webpackJsonp([6],{

/***/ "+2Xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:_vm.inlineClass},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:(_vm.model)},on:{"change":function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+4WN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUTH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTH_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_LOGOUT; });
var AUTH_REQUEST = 'AUTH_REQUEST';
var AUTH_SUCCESS = 'AUTH_SUCCESS';
var AUTH_ERROR = 'AUTH_ERROR';
var AUTH_LOGOUT = 'AUTH_LOGOUT';

/***/ }),

/***/ "+BTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+GID":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__ = __webpack_require__("5fo9");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_567a9450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__ = __webpack_require__("xp4f");
function injectStyle (ssrContext) {
  __webpack_require__("vIES")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Stats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_567a9450_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Stats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);



var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+VxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__ = __webpack_require__("18Zw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0365d158_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__ = __webpack_require__("9TgA");
function injectStyle (ssrContext) {
  __webpack_require__("4JrB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0365d158_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+WI1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[(_vm.values.length === 0)?_c('div',{staticClass:"progress-bar",class:("progress-bar-" + _vm.type),style:(("width: " + _vm.value + "%;")),attrs:{"role":"progressbar","aria-valuenow":_vm.value,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"sr-only"},[_vm._t("default")],2)]):_vm._l((_vm.values),function(progress){return _c('div',{staticClass:"progress-bar",class:("progress-bar-" + (progress.type)),style:(("width: " + (progress.value) + "%;"))},[_c('span',{staticClass:"sr-only"})])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+dbZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+enL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Indicator_Widget__ = __webpack_require__("3yc9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_History_chart__ = __webpack_require__("kM/L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Charts_Area_radar_chart__ = __webpack_require__("IMIu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);














var API = "https://api.semeq.com.br/";

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        IndicatorWidget: __WEBPACK_IMPORTED_MODULE_5__Components_Indicator_Widget__["a" /* default */],
        HistoryChart: __WEBPACK_IMPORTED_MODULE_6__Components_History_chart__["a" /* default */],
        Help: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_components_Help__["a" /* default */],
        AreaRadarChart: __WEBPACK_IMPORTED_MODULE_7__Charts_Area_radar_chart__["a" /* default */]
    },
    data: function data() {
        return {
            title: this.$t("289"),
            title2: this.$t("290"),
            total_falhas_all: 0,
            total_resolvidos_all: 0,
            total_media_all: 0,
            total_falhas_y: 0,
            total_resolvidos_y: 0,
            total_media_y: 0,
            total_falhas_6m: 0,
            total_resolvidos_6m: 0,
            total_media_6m: 0,
            total_falhas_cor: 'red',
            total_resolvidos_cor: 'green',
            total_media_cor: 'blue',
            chart_failure_data: [],
            chart_resolved_data: [],
            chart_tmsa_data: [],
            radar_data: [],
            last_region: '',
            last_plant: -1,
            last_area: '',
            last_sector: '',
            last_machine: '',
            last_component: '',
            last_technique: ''
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4__utils_mixin__["a" /* default */]],
    methods: {
        getReportsOnline: function getReportsOnline() {
            var _param;

            var self = this;
            var param = (_param = { "plant_id": this.filters.plant, "technique_id": this.filters.technique, "corp": 1, "region": this.filters.region, "area": this.filters.area, "sector": this.filters.sector }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_param, 'sector', this.filters.sector), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_param, "machine", this.filters.machine), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_param, "component", this.filters.component), _param);


            __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + 'v1/mysemeq-ambev/history-reports', params: param, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {
                self.total_falhas_all = 0;
                self.total_media_all = 0;
                self.total_falhas_y = 0;
                self.total_media_y = 0;
                self.total_falhas_6m = 0;
                self.total_media_6m = 0;
                var data = response.data;
                var data_len = data.length;
                var last_12_month = data_len - 13;
                var last_6_month = data_len - 7;
                self.chart_failure_data = [];
                self.chart_tmsa_data = [];
                var i = 0;

                __WEBPACK_IMPORTED_MODULE_9_jquery___default.a.each(data, function (key, val) {
                    self.total_falhas_all += val.total;
                    self.total_media_all += val.average;
                    self.chart_failure_data.push([val.ref_date, val.total]);
                    self.chart_tmsa_data.push([val.ref_date, val.average]);

                    if (i >= last_12_month) {
                        self.total_falhas_y += val.total;
                        self.total_media_y += val.average;
                    }

                    if (i >= last_6_month) {
                        self.total_falhas_6m += val.total;
                        self.total_media_6m += val.average;
                    }
                    i++;
                });

                self.total_media_all = parseFloat((self.total_media_all / i).toFixed(1));
                self.total_media_y = parseFloat((self.total_media_y / 12).toFixed(1));
                self.total_media_6m = parseFloat((self.total_media_6m / 6).toFixed(1));
            }).catch(function (response) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        getReportsRci: function getReportsRci() {
            var _param2;

            var self = this;
            var param = (_param2 = { "plant_id": this.filters.plant, "technique_id": this.filters.technique, "corp": 1, "region": this.filters.region, "area": this.filters.area, "sector": this.filters.sector }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_param2, 'sector', this.filters.sector), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_param2, "machine", this.filters.machine), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_param2, "component", this.filters.component), _param2);

            __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + 'v1/mysemeq-ambev/history-reports-rci', params: param, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {
                self.total_resolvidos_all = 0;
                self.total_resolvidos_y = 0;
                self.total_resolvidos_6m = 0;
                var data = response.data;
                var data_len = data.length;
                var last_12_month = data_len - 13;
                var last_6_month = data_len - 7;
                self.chart_resolved_data = [];
                var i = 0;

                __WEBPACK_IMPORTED_MODULE_9_jquery___default.a.each(data, function (key, val) {
                    self.total_resolvidos_all += val.total;
                    self.chart_resolved_data.push([val.ref_date, val.total]);

                    if (i >= last_12_month) {
                        self.total_resolvidos_y += val.total;
                    }

                    if (i >= last_6_month) {
                        self.total_resolvidos_6m += val.total;
                    }

                    i++;
                });
            }).catch(function (response) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        getAreaReports: function getAreaReports() {
            var _param3;

            var self = this;

            var param = (_param3 = { "plant_id": this.filters.plant, "technique_id": this.filters.technique, "corp": 1, "region": this.filters.region, "year": this.filters.year, "period": this.filters.period, "area": this.filters.area, "sector": this.filters.sector }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_param3, 'sector', this.filters.sector), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_param3, "machine", this.filters.machine), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_param3, "component", this.filters.component), _param3);

            __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + 'v1/mysemeq-ambev/areas-reports', params: param, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {

                var data = response.data;
                var new_data = {};
                var area = '';

                var count = 0;
                __WEBPACK_IMPORTED_MODULE_9_jquery___default.a.each(data, function (key, val) {
                    if (val.total >= 1) {
                        if (area != val.area) {
                            new_data[val.area] = { data: [], categories: [] };
                            area = val.area;
                            count = 0;
                        }

                        if (count < 10) {
                            new_data[val.area].data.push(val.total);
                            new_data[val.area].categories.push(val.sector);
                        }

                        count += 1;
                    }
                });

                self.radar_data = new_data;
            }).catch(function (response) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['filters'])),
    watch: {
        filters: function filters(newValue) {
            this.getAreaReports();

            if (this.last_region != newValue.region || this.last_plant != newValue.plant || this.last_area != newValue.area || this.last_sector != newValue.sector || this.last_machine != newValue.machine || this.last_component != newValue.component || this.last_technique != newValue.technique) {
                this.getReportsOnline();
                this.getReportsRci();
            }

            this.last_region = newValue.region;
            this.last_plant = newValue.plant;
            this.last_area = newValue.area;
            this.last_sector = newValue.sector;
            this.last_machine = newValue.machine;
            this.last_component = newValue.component;
            this.last_technique = newValue.technique;
        }
    }
});

/***/ }),

/***/ "+lQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control border-input",domProps:{"value":_vm.value},on:{"input":function($event){_vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+m/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['requiredText', 'email', 'number', 'url', 'idSource', 'idDestination'])),
  data: function data() {
    return {
      model: {
        requiredText: '',
        email: '',
        number: '',
        url: '',
        idSource: '',
        idDestination: ''
      },
      modelValidations: {
        requiredText: {
          required: true
        },
        email: {
          required: true,
          email: true
        },
        number: {
          required: true,
          decimal: true
        },
        url: {
          required: true,
          url: true
        },
        idSource: {
          required: true
        },
        idDestination: {
          required: true,
          confirmed: 'idSource'
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.$emit('on-submit', _this.registerForm, isValid);
      });
    }
  }
});

/***/ }),

/***/ "+mNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Paper Dashboard Headings")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Created using "),_c('a',{attrs:{"href":"https://www.google.com/fonts/specimen/Muli"}},[_vm._v("Muli")]),_vm._v(" Font Family\n          ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"typo-line"},[_c('h1',[_c('p',{staticClass:"category"},[_vm._v("Header 1")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h2',[_c('p',{staticClass:"category"},[_vm._v("Header 2")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h3',[_c('p',{staticClass:"category"},[_vm._v("Header 3")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h4',[_c('p',{staticClass:"category"},[_vm._v("Header 4")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h5',[_c('p',{staticClass:"category"},[_vm._v("Header 5")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h6',[_c('p',{staticClass:"category"},[_vm._v("Header 6")]),_vm._v("Paper Dashboard Heading ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',[_c('span',{staticClass:"category"},[_vm._v("Paragraph")]),_vm._v("Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Quote")]),_vm._v(" "),_c('blockquote',[_c('p',[_vm._v("\n                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam.\n              ")]),_vm._v(" "),_c('small',[_vm._v("\n                Steve Jobs, CEO Apple\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Muted Text")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("\n              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Coloured Text")]),_vm._v(" "),_c('p',{staticClass:"text-primary"},[_vm._v("\n              Text Primary - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-info"},[_vm._v("\n              Text Info - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-success"},[_vm._v("\n              Text Success - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-warning"},[_vm._v("\n              Text Warning - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")]),_vm._v(" "),_c('p',{staticClass:"text-danger"},[_vm._v("\n              Text Danger - Light Bootstrap Table Heading and complex bootstrap dashboard you've ever seen on the internet.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('h2',[_c('p',{staticClass:"category"},[_vm._v("Small Tag")]),_vm._v("Header with small subtitle "),_c('br'),_vm._v(" "),_c('small',[_vm._v("\".small\" is a tag for the headers")])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Lists")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Unordered List")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',{staticClass:"list-unstyled"},[_c('ul',[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")])])]),_vm._v(" "),_c('li',[_vm._v("List Item")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Ordered List")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Unstyled List")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled"},[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h5',[_vm._v("Inline List")]),_vm._v(" "),_c('ul',{staticClass:"list-inline"},[_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")]),_vm._v(" "),_c('li',[_vm._v("List Item")])])])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Blockquotes")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Default Blockquote")]),_vm._v(" "),_c('blockquote',[_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Blockquote with Citation")]),_vm._v(" "),_c('blockquote',[_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")]),_vm._v(" "),_c('small',[_vm._v("Someone famous in\n                    "),_c('cite',{attrs:{"title":"Source Title"}},[_vm._v("Source Title")])])])])])]),_vm._v(" "),_c('div',{staticClass:"typo-line"},[_c('p',{staticClass:"category"},[_vm._v("Code")]),_vm._v(" "),_c('p',[_vm._v("This is "),_c('code',[_vm._v(".css-class-as-code")]),_vm._v(", an example of an inline code element. Wrap inline code within a "),_c('code',[_vm._v("\n              <code>...</code>")]),_vm._v("tag.")]),_vm._v(" "),_c('pre',[_vm._v("1. #This is an example of preformatted text. 2. #Here is another line of code")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/0wm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showModal)?_c('div',{attrs:{"id":"modal-container","tabindex":"1"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }_vm.showModal = false}}},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-dialog d-flex flex-column align-content-center",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"z-index":"10"}},[_c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"col-01"},[_c('button',{staticClass:"bt-help",on:{"click":function($event){_vm.btHelp()}}},[_c('i',{staticClass:"icon-help ti-help-alt"})]),_vm._v(" "),_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"col-02"},[_c('button',{staticClass:"csv-bt",attrs:{"type":"button","aria-label":"CSV"},on:{"click":function($event){_vm.btCSV()}}},[_c('span',{staticClass:"ti-file"},[_vm._v(" CSV")])])]),_vm._v(" "),_c('div',{staticClass:"col-03"},[_c('button',{ref:"closer",staticClass:"close",attrs:{"type":"button","id":"close-button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.showModal = false}}},[_c('span',{staticClass:"ti-close"})])])]),_vm._v(" "),_c('div',{staticClass:"modal-body overflow-auto",staticStyle:{"width":"100%"}},[(_vm.data.length != 0)?_c('table',{staticClass:"table"},[_c('thead',[_c('tr',_vm._l((_vm.columns),function(value,key){return _c('th',{key:key},[(key != 'link' && key != 'link_rci')?_c('div',[_c('p',{staticClass:"table-header",on:{"click":function($event){_vm.sortBy(key)}}},[_vm._v("\n                                                        "+_vm._s(_vm._f("capitalize")(value))+"\n                                                        "),(_vm.sortKey == key)?_c('span',{staticClass:"arrow",class:_vm.sortKey == key ? _vm.order: ''}):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),(key != 'rows')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortFilters["f_" + key]),expression:"sortFilters[\"f_\" + key]"}],staticClass:"table-input",attrs:{"disabled":(key == 'approved_datetime'),"type":"text"},domProps:{"value":(_vm.sortFilters["f_" + key])},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.filterGrid()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sortFilters, "f_" + key, $event.target.value)}}}):_vm._e()]):_vm._e()])}))]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredData),function(entry){return _c('tr',_vm._l((_vm.columns),function(value,key){return _c('td',{key:key},[((key == 'report_number' && entry[key]) && (entry['report_id'] || entry['id']))?_c('div',[_c('div',{staticClass:"href",on:{"click":function($event){_vm.changeModal({'link_rdp': entry['link'], 'link_rci': entry['link_rci'], 'id_rdp': entry['report_id'] || entry['id'] , 'component_id': entry['component_id'], 'technique_id': entry['technique_id'], 'technique': entry['technique'], 'ref_date': entry['ref_date'] , 'report_number': entry['report_number'] , 'plant': entry['plant'] , 'area': entry['area'] })}}},[_vm._v(_vm._s(_vm._f("handleNull")(entry[key])))])]):(key != 'link' && key != 'link_rci' && key != 'report_number')?_c('div',[_vm._v("\n                                            "+_vm._s(_vm._f("handleNull")(entry[key]))+"\n                                        ")]):(key == 'report_number' && !entry['report_id'])?_c('div',[_vm._v("\n                                            -\n                                        ")]):_vm._e()])}))}))]):_vm._e(),_vm._v(" "),(_vm.data.length == 0)?_c('div',{staticClass:"d-flex justify-content-center align-content-middle",attrs:{"id":"spinner-loading"}},[_c('div',{staticClass:"loader"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticStyle:{"text-align":"left","float":"left","width":"40%"}},[_vm._v("\n                                "+_vm._s(_vm.total_pg)+" / "+_vm._s(_vm.totalDados)+" - Page: "+_vm._s(_vm.pg  +1)+" of "+_vm._s(Math.round(_vm.totalDados / 30))+"\n\n                                ")]),_vm._v(" "),_c('div',{staticStyle:{"float":"left","width":"60%"}},[_c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"page-item"},[_c('button',{staticClass:" btn page-link",attrs:{"disabled":_vm.pg==0 || _vm.data.length==0},on:{"click":function($event){_vm.pg--}}},[_vm._v(" "+_vm._s(_vm.$t("158")))])]),_vm._v(" "),_c('li',{staticClass:"page-item"},[_c('button',{staticClass:"btn page-link",attrs:{"disabled":_vm.data.length < 30},on:{"click":function($event){_vm.pg++}}},[_vm._v(_vm._s(_vm.$t("159")))])])])])])])])])])])],1):_vm._e(),_vm._v(" "),(_vm.showModalFile)?_c('div',{attrs:{"id":"modal-container","tabindex":"1"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }_vm.showModalFile = false}}},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-alert modal-dialog d-flex flex-column align-content-center",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"z-index":"10"}},[_c('div',{staticClass:"modal-header"},[_vm._v("\n                                                                 \n                            ")]),_vm._v(" "),_c('div',{staticClass:"modal-body overflow-auto",staticStyle:{"color":"#eee","font-weight":"bold","height":"47px","padding":"5px 0px"}},[_c('div',{staticClass:"loader loader-div"}),_vm._v(" "),_c('div',{staticClass:"txt-loader"},[_vm._v(_vm._s(_vm.$t("160")))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._v("\n                                 \n                            ")])])])])])])],1):_vm._e(),_vm._v(" "),(_vm.showModalHelp)?_c('div',{attrs:{"id":"modal-container","tabindex":"1"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }_vm.showModalHelp = false}}},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-alert modal-dialog d-flex flex-column align-content-center",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"z-index":"10"}},[_c('div',{staticClass:"modal-header header-help"},[_c('div',{staticClass:"col-01"},[_c('i',{staticClass:"icon-help ti-help-alt"}),_vm._v(" "),_c('span',{staticClass:"modal-title-help"},[_vm._v(_vm._s(_vm.titleHelp))])]),_vm._v(" "),_c('div',{staticClass:"col-02"},[_vm._v("\n                                     \n                                ")]),_vm._v(" "),_c('div',{staticClass:"col-03"},[_c('button',{ref:"closer",staticClass:"close-help",attrs:{"type":"button","id":"close-button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.showModalHelp = false}}},[_c('span',{staticClass:"ti-close"})])])]),_vm._v(" "),_c('div',{staticClass:"modal-body overflow-auto body-help"},[_vm._v("\n                                "+_vm._s(_vm.txtHelp)+"\n                            ")])])])])])])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/5fl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_highcharts_vue__ = __webpack_require__("jhCd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_highcharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_highcharts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Maps_MapChartOnline__ = __webpack_require__("YsTl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_ChartsOnline_ChartsStatus__ = __webpack_require__("HkQq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_ChartsOnline_ChartsPointStatus__ = __webpack_require__("tCLc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_ChartsOnline_ChartsAlarme__ = __webpack_require__("302u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_ChartsOnline_ChartsSensorStatus__ = __webpack_require__("C3ME");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_ChartsOnline_ChartsNodesStatus__ = __webpack_require__("Bk+p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_ChartsOnline_ChartsSensorBattery__ = __webpack_require__("xyBX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_ChartsOnline_HeatMap__ = __webpack_require__("g9Xd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_ChartsOnline_HeatMapSensor__ = __webpack_require__("idUJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_ChartsOnline_HeatMapSensorAppointments__ = __webpack_require__("pUs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_ChartsOnline_PrioritiesChart__ = __webpack_require__("TvnU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_ChartsOnline_ChartsDefects__ = __webpack_require__("fIgR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Components_Bookmark__ = __webpack_require__("pk8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_ChartsOnline_ExecutionIndicators__ = __webpack_require__("bkE3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Charts_Donut__ = __webpack_require__("Bmqj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Components_ReincidenciaIndicator__ = __webpack_require__("7j/V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Charts_ReincidenciaChart__ = __webpack_require__("JukQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Charts_ExecutionChart__ = __webpack_require__("M76F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Charts_DonutExecution__ = __webpack_require__("oLj+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Charts_ExecutionChartTotal__ = __webpack_require__("m8hd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_ChartsOnline_chartsReport__ = __webpack_require__("e/5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_ChartsOnline_ChartFailureOnline__ = __webpack_require__("OD4A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Charts_ChartBacklog__ = __webpack_require__("r15C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Charts_ChartReincidenciaPareto__ = __webpack_require__("wXZb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Charts_ChartFailurePareto__ = __webpack_require__("NspE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_mixin__ = __webpack_require__("vsZy");




































__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_30_vue_js_popover___default.a);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  options: null,
  components: {
    highcharts: __WEBPACK_IMPORTED_MODULE_2_highcharts_vue__["Chart"],
    mapChartOnline: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Maps_MapChartOnline__["a" /* default */],
    chartsStatus: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_ChartsOnline_ChartsStatus__["a" /* default */],
    ChartsPointStatus: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_ChartsOnline_ChartsPointStatus__["a" /* default */],
    ChartsAlarme: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_ChartsOnline_ChartsAlarme__["a" /* default */],
    ChartsSensorStatus: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_ChartsOnline_ChartsSensorStatus__["a" /* default */],
    ChartsNodesStatus: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_ChartsOnline_ChartsNodesStatus__["a" /* default */],
    ChartsSensorBattery: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_ChartsOnline_ChartsSensorBattery__["a" /* default */],
    HeatMap: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_ChartsOnline_HeatMap__["a" /* default */],
    HeatMapSensor: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_ChartsOnline_HeatMapSensor__["a" /* default */],
    HeatMapSensorAppointments: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_ChartsOnline_HeatMapSensorAppointments__["a" /* default */],
    PrioritiesChart: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_ChartsOnline_PrioritiesChart__["a" /* default */],
    ChartsDefects: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_ChartsOnline_ChartsDefects__["a" /* default */],
    bookmark: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Components_Bookmark__["a" /* default */],
    ExecutionIndicators: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_ChartsOnline_ExecutionIndicators__["a" /* default */],
    Donut: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Charts_Donut__["a" /* default */],
    ReincidenciaIndicator: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Components_ReincidenciaIndicator__["a" /* default */],
    ReincidenciaChart: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Charts_ReincidenciaChart__["a" /* default */],
    Help: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_components_Help__["a" /* default */],
    popover: __WEBPACK_IMPORTED_MODULE_30_vue_js_popover___default.a,
    ExecutionChart: __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Charts_ExecutionChart__["a" /* default */],
    DonutExecution: __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Charts_DonutExecution__["a" /* default */],
    ExecutionChartTotal: __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Charts_ExecutionChartTotal__["a" /* default */],
    chartsReport: __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_ChartsOnline_chartsReport__["a" /* default */],
    ChartFailure: __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_ChartsOnline_ChartFailureOnline__["a" /* default */],
    ChartBacklog: __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Charts_ChartBacklog__["a" /* default */],
    ChartReincidenciaPareto: __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Charts_ChartReincidenciaPareto__["a" /* default */],
    ChartFailurePareto: __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Charts_ChartFailurePareto__["a" /* default */]
  },
  data: function data() {
    return {
      stepIds: ['collectOn', 'result', 'defectsOn', '', 'planning', 'execution', 'mapa'],
      menutop: false,
      planned_rdps_data: [],
      repetition_data: {},
      repetition_chart_data: [],
      reports_execution_deadline: {
        total: {},
        details: [],
        total_atrasado: 0,
        total_concluido: 0,
        details_total: []
      }
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_32__utils_mixin__["a" /* default */]],
  mounted: function mounted() {
    this.changeTab('online');
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    filterGrid: function filterGrid() {
      var res = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        'plant': this.filtersOn.planta,
        'area': this.filtersOn.area_f,
        'sector': this.filtersOn.sector_f,
        'component': this.filtersOn.subset,
        'plant_name': this.filtersOn.planta_name
      }, this.filtersOn);

      return res;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31_vuex__["a" /* mapGetters */])(['menu', 'filtersOn'])),
  watch: {
    menu: function menu(newValue) {
      if (this.menu.book > 30) {
        this.menutop = true;
      }
      if (this.menu.book < 29) {
        this.menutop = false;
      }
    },
    filtersOn: function filtersOn() {
      this.get_planned_reports();
      this.get_repetition();
      this.get_executed_reports();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    get_planned_reports: function get_planned_reports() {
      var API = "https://api.semeq.com.br/";

      var ENDPOINT = 'v1/mysemeq-ambev/get-planned-reports?online=1';
      var self = this;

      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        plant: this.filtersOn.planta,
        area: this.filtersOn.area_f,
        sector: this.filtersOn.sector_f,
        machine: this.filtersOn.machine,
        component: this.filtersOn.subset
      }, this.filtersOn);

      self.planned_rdps_data = [];
      __WEBPACK_IMPORTED_MODULE_29_axios___default()({ method: 'GET', url: API + ENDPOINT, params: param, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        self.planned_rdps_data = resp.data;
      }).catch(function (err) {
        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    },
    get_repetition: function get_repetition() {
      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/mysemeq-ambev/get-repetition?online=1';
      var self = this;

      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        plant: this.filtersOn.planta,
        area: this.filtersOn.area_f,
        sector: this.filtersOn.sector_f,
        machine: this.filtersOn.machine,
        component: this.filtersOn.subset
      }, this.filtersOn);

      this.repetition_data = [];
      this.repetition_chart_data = [];
      __WEBPACK_IMPORTED_MODULE_29_axios___default()({ method: 'GET', url: API + ENDPOINT, params: param, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (res) {
        var repetition = res.data.total;

        var repetition_chart_data = [];
        for (var i in res.data.detail) {
          var dados = res.data.detail[i];

          repetition_chart_data.push({
            id: i,
            title: dados.plant,
            plant: dados.plant_id,
            data: [[dados['R1'], dados['R2'], dados['R3'], dados['R3+']], [dados['R1_perc'], dados['R2_perc'], dados['R3_perc'], dados['R3+_perc']]]
          });
        }

        self.repetition_chart_data = repetition_chart_data;

        self.repetition_data = {
          'R0': [repetition['R0'], repetition['R0_perc']],
          'R1': [repetition['R1'], repetition['R1_perc']],
          'R2': [repetition['R2'], repetition['R2_perc']],
          'R3': [repetition['R3'], repetition['R3_perc']],
          'R3+': [repetition['R3+'], repetition['R3+_perc']]
        };
      }).catch(function (err) {
        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    },
    get_executed_reports: function get_executed_reports() {

      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/mysemeq-ambev/get-executed-reports-deadline?online=1';

      var param = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        plant: this.filtersOn.planta,
        area: this.filtersOn.area_f,
        sector: this.filtersOn.sector_f,
        machine: this.filtersOn.machine,
        component: this.filtersOn.subset
      }, this.filtersOn);

      this.reports_execution_deadline = { total: {}, details: [], details_total: [] };

      var self = this;
      __WEBPACK_IMPORTED_MODULE_29_axios___default()({ method: 'GET', url: API + ENDPOINT, params: param, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (res) {
        self.reports_execution_deadline = res.data;

        self.reports_execution_deadline.total_atrasado = res.data.total[1] + res.data.total[2] + res.data.total[3];
        self.reports_execution_deadline.total_concluido = res.data.total[0];
      }).catch(function (err) {
        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31_vuex__["b" /* mapMutations */])(['changeTab']))
});

/***/ }),

/***/ "/QQO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"indicator-widget"},[_c('div',{staticClass:"content-1",staticStyle:{"height":"80px"}},[_c('div',{class:'widget-circle circle-'+_vm.color},[_c('div',{class:'circle-'+_vm.color+'-img'})]),_vm._v(" "),_c('div',{staticClass:"widget-right"},[_c('p',{staticClass:"number"},[_vm._v(_vm._s(_vm.valall)+" - "+_vm._s(_vm.val1y)+" - "+_vm._s(_vm.val6m))]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.legend))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/YGB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ValidationForms_RegisterForm_vue__ = __webpack_require__("37ho");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValidationForms_LoginForm_vue__ = __webpack_require__("Pfw2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidationForms_TypeValidationForm_vue__ = __webpack_require__("DfKf");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    RegisterForm: __WEBPACK_IMPORTED_MODULE_0__ValidationForms_RegisterForm_vue__["a" /* default */],
    LoginForm: __WEBPACK_IMPORTED_MODULE_1__ValidationForms_LoginForm_vue__["a" /* default */],
    TypeValidationForm: __WEBPACK_IMPORTED_MODULE_2__ValidationForms_TypeValidationForm_vue__["a" /* default */]
  },
  data: function data() {
    return {
      registerModel: {},
      loginModel: {},
      typeValidationModel: {}
    };
  },

  methods: {
    onRegisterSubmit: function onRegisterSubmit(model, isValid) {
      this.registerModel = model;
    },
    onLoginSubmit: function onLoginSubmit(model, isValid) {
      this.loginModel = model;
    },
    onTypeValidationSubmit: function onTypeValidationSubmit(model, isValid) {
      this.typeValidationModel = model;
    }
  }
});

/***/ }),

/***/ "/ZBZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    showSwal: function showSwal(type) {
      if (type === 'basic') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Here\'s a message!',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill'
        });
      } else if (type === 'title-and-text') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Here\'s a message!',
          text: 'It\'s pretty, isn\'t it?',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-info btn-fill'
        });
      } else if (type === 'success-message') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Good job!',
          text: 'You clicked the button!',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        });
      } else if (type === 'warning-message-and-confirmation') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Are you sure?',
          text: 'You won\'t be able to revert this!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Yes, delete it!',
          buttonsStyling: false
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          });
        });
      } else if (type === 'warning-message-and-cancel') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Are you sure?',
          text: 'You will not be able to recover this imaginary file!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, keep it',
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
            title: 'Deleted!',
            text: 'Your imaginary file has been deleted.',
            type: 'success',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false
          });
        }, function (dismiss) {
          if (dismiss === 'cancel') {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
              title: 'Cancelled',
              text: 'Your imaginary file is safe :)',
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            });
          }
        });
      } else if (type === 'custom-html') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'HTML example',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          html: 'You can use <b>bold text</b>, ' + '<a href="http://github.com">links</a> ' + 'and other HTML tags'
        });
      } else if (type === 'auto-close') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Auto close alert!',
          text: 'I will close in 2 seconds.',
          timer: 2000,
          showConfirmButton: false
        });
      } else if (type === 'input-field') {
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
          title: 'Input something',
          html: '<div class="form-group">' + '<input id="input-field" type="text" class="form-control" />' + '</div>',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        }).then(function (result) {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
            type: 'success',
            html: 'You entered',
            confirmButtonClass: 'btn btn-success btn-fill',
            buttonsStyling: false

          });
        }).catch(__WEBPACK_IMPORTED_MODULE_0_sweetalert2___default.a.noop);
      }
    }
  }
});

/***/ }),

/***/ "/ZJH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
    grid: {
        url: '',
        title: '',
        columns: {},
        show: false,
        titleHelp: '',
        txtHelp: '',
        totalDados: ''
    }
};

var getters = {
    grid: function grid(state) {
        return state.grid;
    }
};

var mutations = {
    changeGrid: function changeGrid(state, payload) {
        state.grid = payload;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations
});

/***/ }),

/***/ "/wqj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 box-release"},[_c('HeatMap')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 box-release"},[_c('HeatMapSensor')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 box-release"},[_c('HeatMapSensorAppointments')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Bz4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0FOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);




/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    setLang: function setLang(lang) {
      this.$store.dispatch('setLang', lang);
    },

    loadLocaleMessage: function loadLocaleMessage(locale, cb) {
      console.log('locale', locale);
      return fetch('./src/lang/' + locale + '.json', {
        method: 'get',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }).then(function (res) {
        console.log('success');
        return res.json();
      }).then(function (json) {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(json).length === 0) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error('locale empty !!'));
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(json);
        }
      }).then(function (message) {
        cb(null, message);
      }).catch(function (error) {
        cb(error);
      });
    }
  }
});

/***/ }),

/***/ "0N4a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0XqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stats-card'
});

/***/ }),

/***/ "0efX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Release_vue__ = __webpack_require__("G8LV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b08484a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Release_vue__ = __webpack_require__("NwLt");
function injectStyle (ssrContext) {
  __webpack_require__("5NI/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Release_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b08484a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Release_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0fCT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0zsf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('highcharts',{attrs:{"options":_vm.mapOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "12dW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-alert modal-dialog d-flex flex-column align-content-center",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"z-index":"10"}},[_c('div',{staticClass:"modal-header"},[_vm._v("\n                                                                 \n                            ")]),_vm._v(" "),_c('div',{staticClass:"modal-body overflow-auto",staticStyle:{"color":"#eee","font-weight":"bold","height":"47px","padding":"5px 0px"}},[_c('div',{staticClass:"loader loader-div"}),_vm._v(" "),_c('div',{staticClass:"txt-loader"},[_vm._v(" "+_vm._s(_vm.$t("160")))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._v("\n                                 \n                            ")])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "18Zw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false
      }
    };
  },

  methods: {
    notifyVue: function notifyVue(verticalAlign, horizontalAlign) {
      var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        component: {
          template: '<span>Welcome to <b>Paper Dashboard</b> - a beautiful freebie for every web developer.</span>'
        },
        icon: 'ti-gift',
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: this.type[color]
      });
    }
  }
});

/***/ }),

/***/ "18tI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Kqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-radio',
  model: {
    prop: 'value'
  },
  props: {
    label: [String, Number],
    disabled: [Boolean, String],
    value: [String, Boolean],
    inline: Boolean,
    type: {
      type: String,
      default: 'neutral'
    }
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'radio-inline';
      }
      return '';
    },
    radioClasses: function radioClasses() {
      return 'radio-' + this.type + ' ' + this.inlineClass;
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "1V4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Layout_LoadingMainPanel_vue__ = __webpack_require__("JhHP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])({ profile: function profile(state) {
      return state.user.profile;
    } }),
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      statsCards: [{
        type: 'warning',
        icon: 'ti-server',
        title: 'Capacity',
        value: '105GB',
        footerText: 'Updated now',
        footerIcon: 'ti-reload'
      }, {
        type: 'success',
        icon: 'ti-wallet',
        title: 'Revenue',
        value: '$1,345',
        footerText: 'Last day',
        footerIcon: 'ti-calendar'
      }, {
        type: 'danger',
        icon: 'ti-pulse',
        title: 'Errors',
        value: '23',
        footerText: 'In the last hour',
        footerIcon: 'ti-timer'
      }, {
        type: 'info',
        icon: 'ti-twitter-alt',
        title: 'Followers',
        value: '+45',
        footerText: 'Updated now',
        footerIcon: 'ti-reload'
      }],
      earningsChart: {
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'April', 'May', 'June'],
          series: [[230, 340, 400, 300, 570, 500, 800]]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: false,
            showLabel: true
          },
          axisY: {
            offset: 40,
            showGrid: false
          },
          low: 0,
          high: 'auto',
          classNames: {
            line: 'ct-line ct-green'
          }
        }
      }

    };
  }
});

/***/ }),

/***/ "1Wac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");









__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default.a);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'charts',
  components: {
    Help: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__["a" /* default */]
  },
  data: function data() {
    return {
      titleChart: this.$t("262"),
      tableData: [],
      chartOptions: {
        chart: {
          type: 'heatmap',
          backgroundColor: 'rgba(0,0,0,0)',
          marginTop: 40,

          plotBorderWidth: 1,
          height: 520
        },

        title: {
          text: ''
        },

        xAxis: {
          categories: [],
          title: {
            text: this.$t("305"),
            style: {
              color: '#fff'
            }
          }
        },

        yAxis: {
          categories: [],
          title: null,
          reversed: true
        },

        tooltip: {
          formatter: function formatter() {
            var value = this.point.value;

            if (value || value == 0) {
              if (this.point.x == 5) {
                return '<b>' + this.point.series.yAxis.categories[this.point.options.y] + '</b><br><b>' + value + ' sensors</b>';
              }
              return '<b>' + this.point.series.yAxis.categories[this.point.options.y] + '</b><br><b>' + value + ' %</b>';
            }
            return '<b>' + this.point.series.yAxis.categories[this.point.options.y] + '</b><br><b>No data!</b>';
          },
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },

        series: [{
          borderWidth: 1,
          data: [],
          showInLegend: false,
          dataLabels: {
            enabled: true,
            color: '#000000'
          }
        }],
        plotOptions: {
          series: {
            dataLabels: {
              formatter: function formatter() {
                if (this.point.x == 5) {
                  return '<span style="color: #fff; font-size:14px"> #' + this.point.value + '</span>';
                }
                return '<span style="font-size:14px;" >' + this.point.value + '</span>';
              }
            },
            events: {
              click: this.loadGrid
            },
            cursor: 'pointer'
          },
          heatmap: {
            borderColor: '#000'
          }
        },

        loading: {
          labelStyle: {
            color: 'black',
            textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
          },
          style: {
            backgroundColor: 'none',
            opacity: 1
          }
        },

        exporting: { enabled: false },
        credits: {
          enabled: false
        }
      } };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__utils_mixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['changeGridOnline']), {
    loadGrid: function loadGrid(event) {

      var area_title = this.chartOptions.yAxis.categories[event.point.y].split(' ').filter(function (item) {
        return item != '-';
      }).join('_');
      var area = event.point.y != 0 ? this.chartOptions.yAxis.categories[event.point.y] : '';
      var status = event.point.x != 5 ? event.point.x : '';

      var point_name = area_title;
      var NAME_CHART = this.$t("370") + ' - ' + point_name.toUpperCase();

      var ENDPOINT = 'v1/mysemeq-ambev/get-sensors-out-service-grid?corp=' + this.filtersOn.corp + '&region=' + this.filtersOn.region + '&planta=' + this.filtersOn.planta + '&area=' + area + '&status=' + status + '&area_f=' + this.filtersOn.area_f + '&sector_f=' + this.filtersOn.sector_f + '&machine=' + this.filtersOn.machine + '&subset=' + this.filtersOn.subset;

      var gridOnline = {
        title: this.$t("370") + ' - ' + this.chartOptions.yAxis.categories[event.point.y],
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
          "area": [this.$t("311"), 'area_f'],
          "setor": [this.$t("312")],
          "conj": [this.$t("316"), 'conjunto'],
          "conj_tag": [this.$t("317")],
          "equip": [this.$t("313")],
          "equip_tag": [this.$t("314")],
          "serie": [this.$t("339")],
          "versao": [this.$t("336")],
          "data": [this.$t("334")],
          "bateria": [this.$t("335")],
          "sinal_nivel": [this.$t("337")],
          "node": [this.$t("338"), 'nodo'],
          "status": ['Status'],
          "id_planta": ['id_planta']
        },
        show: true,
        titleHelp: 'Grid - ' + this.$t("370"),
        txtHelp: this.$t("371")
      };

      if (!this.filtersOn.planta) {
        gridOnline.columns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ "rows": [''], 'planta': [this.$t("310"), 'planta_f'] }, gridOnline.columns);
      } else {
        gridOnline.columns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ "rows": [''] }, gridOnline.columns);
      }

      if (event.point.value) {
        this.changeGridOnline(gridOnline);
      }
    },
    getData: function getData() {

      var API = "https://api.semeq.com.br/";

      var param = {
        'corp': this.filtersOn.corp,
        'region': this.filtersOn.region,
        'planta': this.filtersOn.planta,
        'area_f': this.filtersOn.area_f,
        'sector_f': this.filtersOn.sector_f,
        'machine': this.filtersOn.machine,
        'subset': this.filtersOn.subset
      };

      this.$refs.chart.chart.showLoading();

      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + 'v1/mysemeq-ambev/get-sensors-out-service', params: param, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (_ref) {
        var data = _ref.data;

        if (data) {
          var colors = ['#90ed7d', '#e4d354', '#ffc300', '#f0893a', '#f45b5b', 'transparent'];

          if (data[0].length == 0) {
            self.$refs.chart.chart.showLoading('No data');
            return false;
          }

          var points = data[0].map(function (elem) {
            elem['color'] = colors[elem.x];
            return elem;
          });

          self.chartOptions.series[0].data = points;
          self.chartOptions.xAxis.categories = data[1];

          data[2][0] = (self.filtersOn.planta_name == 'All' ? '' : self.filtersOn.planta_name) || self.filtersOn.region || 'ABInBev';

          self.chartOptions.yAxis.categories = data[2];

          if (data[2].length > 11) {
            self.chartOptions.chart.height = 1300;
          } else {
            self.chartOptions.chart.height = 520;
          }
        }
      }).catch(function (error) {
        self.$refs.chart.chart.showLoading('Error');

        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filtersOn'])),
  watch: {
    filtersOn: function filtersOn(newValue) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "1XZe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1g3y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1pLE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2+hT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "21WK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h4',[_c('small',[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "26rS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2BWB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2SCm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('time-line',[_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badgeType":"danger","badgeIcon":"ti-gallery"}},[_c('span',{staticClass:"label label-danger",attrs:{"slot":"header"},slot:"header"},[_vm._v("Some title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n        Wifey made the best Father's Day meal ever. So thankful so happy so blessed. Thank you for making my family We just had fun with the “future” theme !!!   It was a fun night all together ... The always rude Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in downtown.")]),_vm._v(" "),_c('h6',{attrs:{"slot":"footer"},slot:"footer"},[_c('i',{staticClass:"ti-time"}),_vm._v("\n        11 hours ago via Twitter\n      ")])]),_vm._v(" "),_c('time-line-item',{attrs:{"badgeType":"success","badgeIcon":"ti-check-box"}},[_c('span',{staticClass:"label label-success",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n        Thank God for the support of my wife and real friends. I also wanted to point out that it’s the first album to go number 1 off of streaming!!! I love you Ellen and also my number one design rule of anything I do from shoes to music to homes is that Kim has to like it....")])]),_vm._v(" "),_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badgeType":"info","badgeIcon":"ti-credit-card"}},[_c('span',{staticClass:"label label-success",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("\n          Called I Miss the Old Kanye That’s all it was Kanye And I love you like Kanye loves Kanye Famous viewing @ Figueroa and 12th in downtown LA 11:10PM")]),_vm._v(" "),_c('p',[_vm._v("\n          What if Kanye made a song about Kanye Royère doesn't make a Polar bear bed but the Polar bear couch is my favorite piece of furniture we own It wasn’t any Kanyes Set on his goals Kanye")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('drop-down',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-info dropdown-toggle",attrs:{"slot":"title","href":"#","type":"button","data-toggle":"dropdown"},slot:"title"},[_c('i',{staticClass:"ti-settings"}),_vm._v(" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#action"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#action"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#here"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#link"}},[_vm._v("Separated link")])])])],1)]),_vm._v(" "),_c('time-line-item',{attrs:{"badgeType":"warning","badgeIcon":"ti-gallery"}},[_c('span',{staticClass:"label label-warning",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n        Tune into Big Boy's 92.3 I'm about to play the first single from Cruel Winter Tune into Big Boy's 92.3 I'm about to play the first single from Cruel Winter also to Kim’s hair and makeup Lorraine jewelry and the whole style squad at Balmain and the Yeezy team. Thank you Anna for the invite thank you to the whole Vogue team")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2VUe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");










__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default.a);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'charts',
    components: {
        Help: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__["a" /* default */]
    },
    data: function data() {
        return {
            titleChart: this.$t("135"),
            tableData: [],
            chartOptions: {
                colors: ['#90ed7d', '#ff7f23', '#f45b5b', '#f45b5b', '#104E8B'],
                chart: {
                    type: 'line',
                    backgroundColor: 'rgba(0,0,0,0)',
                    style: {
                        fontFamily: '\'Unica One\', sans-serif'
                    },
                    plotBorderColor: '#606063'
                },
                title: {
                    text: '',
                    style: {
                        color: '#fff',
                        textTransform: 'uppercase',
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }
                },
                subtitle: {
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase'
                    }
                },
                xAxis: {
                    categories: [],
                    crosshair: true,
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#fff'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    title: {
                        text: '',
                        style: {
                            color: '#A0A0A3'
                        }
                    }
                },
                yAxis: [{
                    min: 0,
                    tickInterval: 50,
                    title: {
                        text: this.$t("136"),
                        style: {
                            color: '#A0A0A3',
                            fontSize: '12px'
                        }
                    },
                    stackLabels: {
                        enabled: true,
                        style: {
                            fontWeight: 'bold',
                            color: 'white'
                        }
                    },
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    tickWidth: 1
                }, {
                    min: 2,
                    tickInterval: 2,
                    title: {
                        text: this.$t("140_1"),
                        style: {
                            color: '#A0A0A3',
                            fontSize: '12px'
                        }
                    },
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    tickWidth: 1,
                    opposite: true
                }],
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    },
                    headerFormat: '<span style="font-size:10px;">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b> {point.y} </b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: false
                        }
                    },
                    spline: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true,
                            format: '<span style="position: absolute; top: 20px">{point.y} %</span>',
                            color: '#fff',
                            backgroundColor: 'rgba(0, 0, 0, 0.85)',
                            allowOverlap: true,
                            x: 0,
                            y: -10
                        }
                    }
                },
                legend: {
                    title: {
                        style: {
                            color: '#C0C0C0',
                            fontSize: '12px'
                        }
                    },
                    itemStyle: {
                        color: '#E0E0E3'
                    },
                    itemHoverStyle: {
                        color: '#FFF'
                    },
                    itemHiddenStyle: {
                        color: '#b0adad'
                    },
                    layout: 'horizontal',
                    align: 'left',
                    x: 50,
                    verticalAlign: 'top',
                    y: 0,
                    floating: false,
                    color: 'white',
                    backgroundColor: 'rgba(255,255,255,0.25)'
                },
                labels: {
                    style: {
                        color: '#fff'
                    }
                },
                drilldown: {
                    activeAxisLabelStyle: {
                        color: '#F0F0F3'
                    },
                    activeDataLabelStyle: {
                        color: '#F0F0F3'
                    }
                },
                navigation: {
                    buttonOptions: {
                        symbolStroke: '#DDDDDD',
                        theme: {
                            fill: '#505053'
                        }
                    }
                },
                rangeSelector: {
                    buttonTheme: {
                        fill: '#505053',
                        stroke: '#000000',
                        style: {
                            color: '#CCC'
                        },
                        states: {
                            hover: {
                                fill: '#707073',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            },
                            select: {
                                fill: '#000003',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    },
                    inputBoxBorderColor: '#505053',
                    inputStyle: {
                        backgroundColor: '#333',
                        color: 'silver'
                    },
                    labelStyle: {
                        color: 'silver'
                    }
                },
                navigator: {
                    handles: {
                        backgroundColor: '#666',
                        borderColor: '#AAA'
                    },
                    outlineColor: '#CCC',
                    maskFill: 'rgba(255,255,255,0.1)',
                    series: {
                        color: '#7798BF',
                        lineColor: '#A6C7ED'
                    },
                    xAxis: {
                        gridLineColor: '#505053'
                    }
                },
                scrollbar: {
                    barBackgroundColor: '#808083',
                    barBorderColor: '#808083',
                    buttonArrowColor: '#CCC',
                    buttonBackgroundColor: '#606063',
                    buttonBorderColor: '#606063',
                    rifleColor: '#FFF',
                    trackBackgroundColor: '#404043',
                    trackBorderColor: '#404043'
                },
                series: [{
                    type: 'column',
                    name: this.$t("136"),

                    data: [],
                    yAxis: 0

                }, {
                    type: 'column',
                    name: this.$t("137"),

                    data: [],
                    yAxis: 0
                }, {
                    type: 'column',
                    name: this.$t("138"),

                    data: [],
                    yAxis: 0
                }, {
                    type: 'spline',
                    name: this.$t("139"),

                    data: [],
                    yAxis: 1,
                    marker: {
                        lineWidth: 3,
                        lineColor: '#f45b5b',
                        fillColor: '#f45b5b'
                    },
                    tooltip: {
                        valueSuffix: ' %'
                    }
                }, {
                    type: 'spline',
                    name: this.$t("140"),

                    data: [],
                    color: '#104E8B',
                    yAxis: 1,
                    marker: {
                        lineWidth: 3,
                        lineColor: ' #104E8B',
                        fillColor: '#104E8B'
                    },
                    tooltip: {
                        valueSuffix: ' %'
                    },
                    dataLabels: {
                        enabled: true,
                        y: -15
                    }
                }],
                exporting: { enabled: false },
                credits: {
                    enabled: false
                },
                loading: {
                    labelStyle: {
                        color: 'black',
                        textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
                    },
                    style: {
                        backgroundColor: 'none',
                        opacity: 1
                    }
                }
            }
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4__utils_mixin__["a" /* default */]],
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['changeGrid']), {
        loadGrid: function loadGrid(event) {},
        getData: function getData() {

            var API = "https://api.semeq.com.br/";
            var ENDPOINT = 'v1/mysemeq-ambev/get-failure-rate';
            var self = this;

            this.$refs.chart.chart.showLoading();

            __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ENDPOINT, params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filters, { 'online': 0 }), headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
                self.tableData = resp.data;
                self.$refs.chart.chart.hideLoading();
            }).catch(function (err) {
                self.ApiErrorHandler(self, error.response.data.status_code);
                self.$refs.chart.chart.showLoading('Error');
            });
        },
        setChartData: function setChartData() {

            var self = this;
            var res = self.tableData;

            self.chartOptions.xAxis.categories = [];
            self.chartOptions.series[0].data = [];
            self.chartOptions.series[1].data = [];
            self.chartOptions.series[2].data = [];
            self.chartOptions.series[3].data = [];
            self.chartOptions.series[4].data = [];
            if (res) {
                res.forEach(function (it) {
                    self.chartOptions.xAxis.categories.push(it.ref_date);
                    self.chartOptions.series[0].data.push(it.no_repetition);
                    self.chartOptions.series[1].data.push(it.repetition_yellow);
                    self.chartOptions.series[2].data.push(it.repetition_red);
                    self.chartOptions.series[3].data.push(it.percentage);
                    self.chartOptions.series[4].data.push(it.monthy_accumulated);
                });
            }
        }
    }),
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filters'])),
    watch: {
        filters: function filters(newValue) {
            this.getData();
        },
        tableData: function tableData() {
            this.setChartData();
        }
    }

});

/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97f7102c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("xfMn");
function injectStyle (ssrContext) {
  __webpack_require__("18tI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97f7102c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2ieh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',[(_vm.showModalFile)?_c('div',{attrs:{"id":"modal-container","tabindex":"1"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }_vm.showModalFile = false}}},[_c('Csv')],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpdefects","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("144")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-sm bt-change-chart",attrs:{"id":"buttons-csv","role":"group","aria-label":"Group Buttons"}},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.getCsvAll()}}},[_c('small',[_vm._v(_vm._s(_vm.$t("145")))])])]),_vm._v(" "),_c('div',{staticClass:"title-charts-fail"},[_vm._v(_vm._s(_vm.$t("146"))+"\n        "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpdefects.right",arg:"helpdefects",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"btn-group btn-group-sm bt-change-chart",attrs:{"id":"buttons","role":"group","aria-label":"Group Buttons"}},[_c('button',{staticClass:"btn btn-secondary",class:{ activeDGroup: _vm.activeDGroup },attrs:{"type":"button"},on:{"click":function($event){_vm.getPoints('defect_group')}}},[_c('small',[_vm._v(_vm._s(_vm.$t("147")))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",class:{ activeDefect: _vm.activeDefect },attrs:{"type":"button"},on:{"click":function($event){_vm.getPoints('defect')}}},[_c('small',[_vm._v(_vm._s(_vm.$t("148")))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",class:{ activeMpf: _vm.activeMpf },attrs:{"type":"button"},on:{"click":function($event){_vm.getPoints('mpf')}}},[_c('small',[_vm._v(_vm._s(_vm.$t("149")))])])])]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions,"id":_vm.id}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2rGO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "302u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartsAlarme_vue__ = __webpack_require__("SFlA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6beb9924_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartsAlarme_vue__ = __webpack_require__("tNnJ");
function injectStyle (ssrContext) {
  __webpack_require__("r9NN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6beb9924"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartsAlarme_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6beb9924_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartsAlarme_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "37ho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__ = __webpack_require__("tlmh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a9bfe07_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__ = __webpack_require__("alEA");
function injectStyle (ssrContext) {
  __webpack_require__("8vMF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a9bfe07_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3KWc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"card card-wizard",attrs:{"id":"wizardCard"}},[_c('form-wizard',{attrs:{"shape":"tab","error-color":"#EB5E28","color":"#66615B"},on:{"on-complete":_vm.wizardComplete}},[_c('tab-content',{attrs:{"title":"Personal details","before-change":_vm.validateFirstStep,"icon":"ti-user"}},[_c('first-step',{ref:"firstStep"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Additional Info","before-change":_vm.validateSecondStep,"icon":"ti-settings"}},[_c('second-step',{ref:"secondStep"})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Last step","icon":"ti-check"}},[_c('h2',{staticClass:"text-center text-space"},[_vm._v("Yuhuuu!\n              "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Click on \""),_c('b',[_vm._v("Finish")]),_vm._v("\" to join our community")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-wd btn-back",attrs:{"slot":"prev"},slot:"prev"},[_vm._v("Back")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd btn-next",attrs:{"slot":"next"},slot:"next"},[_vm._v("Next")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"slot":"finish"},slot:"finish"},[_vm._v("Finish")])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3MeN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__ = __webpack_require__("2rGO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__ = __webpack_require__("nu7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);








__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_loading___default.a.directive);
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "3TKg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-12 card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-6"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"pull-right"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"Search records","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"fixed":"right","label":"Actions"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-xs btn-info btn-icon like",on:{"click":function($event){_vm.handleLike(props.$index, props.row)}}},[_c('i',{staticClass:"ti-heart"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-xs btn-warning btn-icon edit",on:{"click":function($event){_vm.handleEdit(props.$index, props.row)}}},[_c('i',{staticClass:"ti-pencil-alt"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-xs btn-danger btn-icon remove",on:{"click":function($event){_vm.handleDelete(props.$index, props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('p',{staticClass:"category"},[_vm._v("Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"title"},[_vm._v("Custom table with pagination")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n      We combine "),_c('a',{attrs:{"href":"http://element.eleme.io/#/en-US/component/quickstart","target":"_blank"}},[_vm._v("Element-UI")]),_vm._v("\n      table functionalities together with a custom pagination component\n      which should provide a very good starting point to integrate tables in your application.\n      Check out more functionalities at "),_c('a',{attrs:{"href":"http://element.eleme.io/#/en-US/component/table","target":"_blank"}},[_vm._v("Element-UI table documentation")]),_vm._v(".\n     ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"category"},[_vm._v("Extended tables")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3lJU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3yc9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Indicator_Widget_vue__ = __webpack_require__("mKjx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_763a2d22_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Indicator_Widget_vue__ = __webpack_require__("/QQO");
function injectStyle (ssrContext) {
  __webpack_require__("O4qw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-763a2d22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Indicator_Widget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_763a2d22_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Indicator_Widget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4/Fw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'charts',
    data: function data() {
        return {
            title: 'Photo Sensor',
            link_photo: '',
            sensor_photo: '',
            active: 'dr',
            showModal: false
        };
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        toggleLink: function toggleLink(link) {
            this.link = link;
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['modal_photo'])),
    computed: {
        photoModal: function photoModal() {
            return this.modal_photo();
        }
    },
    watch: {
        show: function show(newValue) {
            this.showModal = newValue;
        },
        photoModal: function photoModal(newValue) {
            this.link_photo = newValue.link_photo;
            this.sensor_photo = newValue.sensor_photo;
            this.showModal = true;
            this.active = 'dr';

            this.$nextTick(function () {
                this.$refs.closer.focus();
            });
        }
    },
    mounted: function mounted() {
        this.link = this.link_photo;
        this.sensor_photo = this.sensor_photo;
    }
});

/***/ }),

/***/ "4JrB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Lu4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('register-form',{on:{"on-submit":_vm.onRegisterSubmit}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('login-form',{on:{"on-submit":_vm.onLoginSubmit}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('type-validation-form',{on:{"on-submit":_vm.onTypeValidationSubmit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4PsR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mixin__ = __webpack_require__("vsZy");








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'execution-chart',
    props: {
        title: {
            type: String
        },
        id: {
            type: String
        },
        data: {
            type: Array
        },
        filters: {
            type: Object
        },
        online: {
            type: Number,
            default: 0
        }
    },
    data: function data() {
        return {
            tableData: [],
            type: 'line',
            chartOptions: {
                colors: ['#90ed7d', '#f0893a', '#f45b5b', '#f45b5b'],
                chart: {
                    type: 'line',
                    backgroundColor: 'rgba(0,0,0,0)',
                    style: {
                        fontFamily: '\'Unica One\', sans-serif'
                    },
                    plotBorderColor: '#606063'
                },
                title: {
                    text: '',
                    style: {
                        color: '#fff',
                        textTransform: 'uppercase',
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }
                },
                subtitle: {
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase'
                    }
                },
                xAxis: {
                    categories: ['0', '1~15', '15~30', '+30'],
                    crosshair: true,
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#fff'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    title: {
                        text: this.$t("305"),
                        style: {
                            color: '#A0A0A3'
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: this.$t("131"),
                        style: {
                            color: '#A0A0A3',
                            fontSize: '12px'
                        }
                    },
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    tickWidth: 1
                },
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    },
                    headerFormat: '<span style="font-size:10px">{point.key} days</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b> {point.y} </b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true,
                            color: '#F0F0F3',
                            style: {
                                fontSize: '13px'
                            }
                        },
                        marker: {
                            lineColor: '#333'
                        },
                        events: {
                            click: this.loadGrid
                        },
                        cursor: 'pointer'
                    },
                    boxplot: {
                        fillColor: '#505053'
                    },
                    candlestick: {
                        lineColor: 'white'
                    },
                    errorbar: {
                        color: 'white'
                    },
                    column: {
                        pointPadding: 0.1,
                        borderWidth: 0
                    }
                },
                legend: {
                    enabled: false
                },
                labels: {
                    style: {
                        color: '#fff'
                    }
                },
                drilldown: {
                    activeAxisLabelStyle: {
                        color: '#F0F0F3'
                    },
                    activeDataLabelStyle: {
                        color: '#F0F0F3'
                    }
                },
                navigation: {
                    buttonOptions: {
                        symbolStroke: '#DDDDDD',
                        theme: {
                            fill: '#505053'
                        }
                    }
                },
                rangeSelector: {
                    buttonTheme: {
                        fill: '#505053',
                        stroke: '#000000',
                        style: {
                            color: '#CCC'
                        },
                        states: {
                            hover: {
                                fill: '#707073',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            },
                            select: {
                                fill: '#000003',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    },
                    inputBoxBorderColor: '#505053',
                    inputStyle: {
                        backgroundColor: '#333',
                        color: 'silver'
                    },
                    labelStyle: {
                        color: 'silver'
                    }
                },
                navigator: {
                    handles: {
                        backgroundColor: '#666',
                        borderColor: '#AAA'
                    },
                    outlineColor: '#CCC',
                    maskFill: 'rgba(255,255,255,0.1)',
                    series: {
                        color: '#7798BF',
                        lineColor: '#A6C7ED'
                    },
                    xAxis: {
                        gridLineColor: '#505053'
                    }
                },
                scrollbar: {
                    barBackgroundColor: '#808083',
                    barBorderColor: '#808083',
                    buttonArrowColor: '#CCC',
                    buttonBackgroundColor: '#606063',
                    buttonBorderColor: '#606063',
                    rifleColor: '#FFF',
                    trackBackgroundColor: '#404043',
                    trackBorderColor: '#404043'
                },
                series: [{
                    name: this.$t("300"),
                    type: 'column',
                    data: this.data,
                    colorByPoint: true
                }],
                exporting: { enabled: false },
                credits: {
                    enabled: false
                },
                loading: {
                    labelStyle: {
                        color: 'black',
                        textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
                    },
                    style: {
                        backgroundColor: 'none',
                        opacity: 1
                    }
                }
            }
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4__utils_mixin__["a" /* default */]],
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['changeGrid']), {
        loadGrid: function loadGrid(event) {

            if (event.point.y != 0) {
                var area_id = '';
                var planta = '';
                var region = '';

                if (this.filters.plant) {
                    planta = this.filters.plant;
                    area_id = this.id;
                } else if (this.filters.region) {
                    planta = this.id;
                } else {
                    region = this.id;
                }

                var NAME_CHART = this.$t("358");

                var delay = event.point.x;

                var ENDPOINT = 'v1/mysemeq-ambev/get-reports-repetition?year=' + this.filters.year + '&period=' + this.filters.period + '&plant=' + planta + '&region=' + region + '&technique=' + (this.online ? '' : this.filters.technique) + '&area=' + this.filters.area + '&sector=' + this.filters.sector + '&machine=' + this.filters.machine + '&component=' + this.filters.component + '&feedback_status=CLOSED&area_id=' + area_id + '&online=' + this.online + '&delay=' + delay;

                var grid = {
                    totalDados: event.point.y,
                    title: this.$t("358") + ' - ' + this.title,
                    url: ENDPOINT,
                    name_chart: NAME_CHART,
                    columns: {
                        "rows": '',
                        "plant": this.$t("310"),
                        "area": this.$t("311"),
                        "sector": this.$t("312"),
                        "component": this.$t("313"),
                        "component_tag": this.$t("314"),
                        "component_type_en": this.$t("315"),
                        "machine": this.$t("316"),
                        "machine_tag": this.$t("317"),
                        "technique_en": this.$t("321"),
                        "report_number": this.$t("319"),
                        "approved_datetime": this.$t("320"),
                        "link": this.$t("323"),
                        "link_rci": this.$t("324"),
                        "pending_days": this.$t("325"),
                        "delay": this.$t("326"),
                        "prescription_created_datePtime": this.$t("327"),
                        "week": this.$t("328")
                    },
                    show: true,
                    titleHelp: 'Grid - ' + this.$t("358"),
                    txtHelp: this.$t("357")
                };

                this.changeGrid(grid);
            }
        }
    }),
    watch: {
        data: function data(value) {
            this.$refs.chart.chart.redraw();
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "4d5k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLinePage_vue__ = __webpack_require__("NmlF");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96a99592_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLinePage_vue__ = __webpack_require__("2SCm");
function injectStyle (ssrContext) {
  __webpack_require__("G5bo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLinePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96a99592_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLinePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "4emV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mixin__ = __webpack_require__("vsZy");








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'execution-chart',
    props: {
        title: {
            type: String
        },
        id: {
            type: String
        },
        data: {
            type: Array
        },
        filters: {
            type: Object
        },
        online: {
            type: Number,
            default: 0
        }
    },
    data: function data() {
        return {
            tableData: [],
            type: 'line',
            chartOptions: {
                colors: ['#90ed7d', '#f45b5b'],
                chart: {
                    type: 'line',
                    backgroundColor: 'rgba(0,0,0,0)',
                    style: {
                        fontFamily: '\'Unica One\', sans-serif'
                    },
                    plotBorderColor: '#606063'
                },
                title: {
                    text: '',
                    style: {
                        color: '#fff',
                        textTransform: 'uppercase',
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }
                },
                subtitle: {
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase'
                    }
                },
                xAxis: {
                    categories: [this.$t("303"), this.$t("304")],
                    crosshair: true,
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#fff'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    title: {
                        text: '',
                        style: {
                            color: '#A0A0A3'
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: this.$t("131"),
                        style: {
                            color: '#A0A0A3',
                            fontSize: '12px'
                        }
                    },
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    tickWidth: 1
                },
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    },
                    headerFormat: '<span style="font-size:10px">{point.key} days</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b> {point.y} </b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true,
                            color: '#F0F0F3',
                            style: {
                                fontSize: '13px'
                            }
                        },
                        marker: {
                            lineColor: '#333'
                        },
                        events: {
                            click: this.loadGrid
                        },
                        cursor: 'pointer'
                    },
                    boxplot: {
                        fillColor: '#505053'
                    },
                    candlestick: {
                        lineColor: 'white'
                    },
                    errorbar: {
                        color: 'white'
                    },
                    column: {
                        pointPadding: 0.1,
                        borderWidth: 0
                    }
                },
                legend: {
                    enabled: false
                },
                labels: {
                    style: {
                        color: '#fff'
                    }
                },
                drilldown: {
                    activeAxisLabelStyle: {
                        color: '#F0F0F3'
                    },
                    activeDataLabelStyle: {
                        color: '#F0F0F3'
                    }
                },
                navigation: {
                    buttonOptions: {
                        symbolStroke: '#DDDDDD',
                        theme: {
                            fill: '#505053'
                        }
                    }
                },
                rangeSelector: {
                    buttonTheme: {
                        fill: '#505053',
                        stroke: '#000000',
                        style: {
                            color: '#CCC'
                        },
                        states: {
                            hover: {
                                fill: '#707073',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            },
                            select: {
                                fill: '#000003',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    },
                    inputBoxBorderColor: '#505053',
                    inputStyle: {
                        backgroundColor: '#333',
                        color: 'silver'
                    },
                    labelStyle: {
                        color: 'silver'
                    }
                },
                navigator: {
                    handles: {
                        backgroundColor: '#666',
                        borderColor: '#AAA'
                    },
                    outlineColor: '#CCC',
                    maskFill: 'rgba(255,255,255,0.1)',
                    series: {
                        color: '#7798BF',
                        lineColor: '#A6C7ED'
                    },
                    xAxis: {
                        gridLineColor: '#505053'
                    }
                },
                scrollbar: {
                    barBackgroundColor: '#808083',
                    barBorderColor: '#808083',
                    buttonArrowColor: '#CCC',
                    buttonBackgroundColor: '#606063',
                    buttonBorderColor: '#606063',
                    rifleColor: '#FFF',
                    trackBackgroundColor: '#404043',
                    trackBorderColor: '#404043'
                },
                series: [{
                    name: this.$t("300"),
                    type: 'column',
                    data: this.data,
                    colorByPoint: true
                }],
                exporting: { enabled: false },
                credits: {
                    enabled: false
                },
                loading: {
                    labelStyle: {
                        color: 'black',
                        textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
                    },
                    style: {
                        backgroundColor: 'none',
                        opacity: 1
                    }
                }
            }
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4__utils_mixin__["a" /* default */]],
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['changeGrid']), {
        loadGrid: function loadGrid(event) {

            if (event.point.y != 0) {
                var area_id = '';
                var planta = '';
                var region = '';

                if (this.filters.plant) {
                    planta = this.filters.plant;
                    area_id = this.id;
                } else if (this.filters.region) {
                    planta = this.id;
                } else {
                    region = this.id;
                }

                var NAME_CHART = this.$t("358");

                var delay = event.point.x;

                delay = delay == 1 ? 4 : delay;

                var ENDPOINT = 'v1/mysemeq-ambev/get-reports-repetition?year=' + this.filters.year + '&period=' + this.filters.period + '&plant=' + planta + '&region=' + region + '&technique=' + (this.online ? '' : this.filters.technique) + '&area=' + this.filters.area + '&sector=' + this.filters.sector + '&machine=' + this.filters.machine + '&component=' + this.filters.component + '&feedback_status=CLOSED&area_id=' + area_id + '&online=' + this.online + '&delay=' + delay;

                var grid = {
                    totalDados: event.point.y,
                    title: this.$t("358") + ' - ' + this.title,
                    url: ENDPOINT,
                    name_chart: NAME_CHART,
                    columns: {
                        "rows": '',
                        "plant": this.$t("310"),
                        "area": this.$t("311"),
                        "sector": this.$t("312"),
                        "component": this.$t("313"),
                        "component_tag": this.$t("314"),
                        "component_type_en": this.$t("315"),
                        "machine": this.$t("316"),
                        "machine_tag": this.$t("317"),
                        "technique_en": this.$t("321"),
                        "report_number": this.$t("319"),
                        "approved_datetime": this.$t("320"),
                        "link": this.$t("323"),
                        "link_rci": this.$t("324"),
                        "pending_days": this.$t("325"),
                        "delay": this.$t("326"),
                        "prescription_created_datePtime": this.$t("327"),
                        "week": this.$t("328")
                    },
                    show: true,
                    titleHelp: 'Grid - ' + this.$t("358"),
                    txtHelp: this.$t("357")
                };

                this.changeGrid(grid);
            }
        }
    }),
    watch: {
        data: function data(value) {
            this.$refs.chart.chart.redraw();
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "4qt1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembersCard_vue__ = __webpack_require__("negu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb7cf97_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembersCard_vue__ = __webpack_require__("yKB+");
function injectStyle (ssrContext) {
  __webpack_require__("H0v/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembersCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bb7cf97_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembersCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Bu8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidationForms_vue__ = __webpack_require__("/YGB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee6481b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidationForms_vue__ = __webpack_require__("4Lu4");
function injectStyle (ssrContext) {
  __webpack_require__("yqcR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValidationForms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee6481b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValidationForms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9cef132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("gKTg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9cef132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5NHr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    badgeType: {
      type: String,
      default: 'success'
    },
    badgeIcon: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "5NI/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Yw9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Zzn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpbattery","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n              ...\n            ")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help title-mobile"},[_vm._v(" "+_vm._s(_vm.$t("239"))+"\n      ")]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5fo9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stats_TimeLine_vue__ = __webpack_require__("k8VF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Stats_TimeLineItem_vue__ = __webpack_require__("U6TR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Stats_TaskList__ = __webpack_require__("pa/N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_ChartCard_vue__ = __webpack_require__("ddgI");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TimeLine: __WEBPACK_IMPORTED_MODULE_0__Stats_TimeLine_vue__["a" /* default */],
    TimeLineItem: __WEBPACK_IMPORTED_MODULE_1__Stats_TimeLineItem_vue__["a" /* default */],
    ChartCard: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_ChartCard_vue__["a" /* default */],
    TaskList: __WEBPACK_IMPORTED_MODULE_2__Stats_TaskList__["a" /* default */]
  },
  data: function data() {
    return {
      salesChart: {
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          series: [[542, 543, 520, 680, 653, 753, 326, 434, 568, 610, 756, 895], [230, 293, 380, 480, 503, 553, 600, 664, 698, 710, 736, 795]]
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false
          },
          height: '245px'
        }
      },
      usersChart: {
        data: {
          labels: ['9AM', '12AM', '3PM', '6PM', '9PM', '12PM', '3AM', '6AM'],
          series: [[287, 385, 490, 562, 594, 626, 698, 895, 952], [67, 152, 193, 240, 387, 435, 535, 642, 744], [23, 113, 67, 108, 190, 239, 307, 410, 410]]
        },
        options: {
          low: 0,
          high: 1000,
          showArea: true,
          height: '245px',
          axisX: {
            showGrid: false
          },
          showLine: true,
          showPoint: false
        }
      },
      subscriptionsChart: {
        data: {
          labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
          series: [[60, 50, 30, 50, 70, 60, 90, 100]]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: false,
            showLabel: true
          },
          axisY: {
            offset: 40,
            showGrid: false
          },
          low: 0,
          high: 'auto',
          classNames: {
            line: 'ct-line ct-red'
          }
        }
      },
      downloadsChart: {
        data: {
          labels: ['2009', '2010', '2011', '2012', '2013', '2014'],
          series: [[1200, 1000, 3490, 8345, 3256, 2566]]
        },
        options: {
          showPoint: false,
          lineSmooth: true,
          height: '210px',
          axisX: {
            showGrid: false,
            showLabel: true
          },
          axisY: {
            offset: 40,
            showGrid: false
          },
          low: 0,
          high: 'auto',
          classNames: {
            line: 'ct-line ct-orange'
          }
        }
      }
    };
  }
});

/***/ }),

/***/ "5xQ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtendedForms_vue__ = __webpack_require__("V+Sv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b60d23_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtendedForms_vue__ = __webpack_require__("OWRr");
function injectStyle (ssrContext) {
  __webpack_require__("u9kn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtendedForms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b60d23_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtendedForms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5yP1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_toggle_button__ = __webpack_require__("nkUn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__js_world_continent_json__ = __webpack_require__("ui7A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__js_world_continent_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__js_world_continent_json__);







__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_js_popover___default.a);



__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_js_toggle_button___default.a);

var Highcharts = __webpack_require__("SMri");



Highcharts.theme = {
    colors: ['#2b908f', '#90ee7e', '#f45b5b', '#7798BF', '#aaeeee', '#ff0066', '#eeaaee', '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],
    chart: {
        backgroundColor: 'rgba(0,0,0,0)',

        style: {
            fontFamily: '\'Unica One\', sans-serif'
        },
        plotBorderColor: '#606063',
        marginTop: 50,
        marginBottom: 50
    },
    title: {
        style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '20px'
        }
    },
    subtitle: {
        style: {
            color: '#E0E0E3',
            textTransform: 'uppercase'
        }
    },
    xAxis: {
        gridLineColor: '#707073',
        labels: {
            style: {
                color: '#E0E0E3'
            }
        },
        lineColor: '#707073',
        minorGridLineColor: '#505053',
        tickColor: '#707073',
        title: {
            style: {
                color: '#A0A0A3'
            }
        }
    },
    yAxis: {
        gridLineColor: '#707073',
        labels: {
            style: {
                color: '#E0E0E3'
            }
        },
        lineColor: '#707073',
        minorGridLineColor: '#505053',
        tickColor: '#707073',
        tickWidth: 1,
        title: {
            style: {
                color: '#A0A0A3'
            }
        }
    },
    tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        style: {
            color: '#F0F0F0'
        }
    },
    plotOptions: {
        series: {
            dataLabels: {
                color: '#F0F0F3',
                style: {
                    fontSize: '13px'
                }
            },
            marker: {
                lineColor: '#333'
            }
        },
        boxplot: {
            fillColor: '#505053'
        },
        candlestick: {
            lineColor: 'white'
        },
        errorbar: {
            color: 'white'
        }
    },
    legend: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        itemStyle: {
            color: '#E0E0E3'
        },
        itemHoverStyle: {
            color: '#FFF'
        },
        itemHiddenStyle: {
            color: '#606063'
        },
        title: {
            style: {
                color: '#C0C0C0'
            }
        }
    },
    credits: {
        style: {
            color: '#666'
        }
    },
    labels: {
        style: {
            color: '#707073'
        }
    },
    drilldown: {
        activeAxisLabelStyle: {
            color: '#F0F0F3'
        },
        activeDataLabelStyle: {
            color: '#F0F0F3'
        }
    },
    navigation: {
        buttonOptions: {
            symbolStroke: '#DDDDDD',
            theme: {
                fill: '#505053'
            }
        }
    },

    rangeSelector: {
        buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: {
                color: '#CCC'
            },
            states: {
                hover: {
                    fill: '#707073',
                    stroke: '#000000',
                    style: {
                        color: 'white'
                    }
                },
                select: {
                    fill: '#000003',
                    stroke: '#000000',
                    style: {
                        color: 'white'
                    }
                }
            }
        },
        inputBoxBorderColor: '#505053',
        inputStyle: {
            backgroundColor: '#333',
            color: 'silver'
        },
        labelStyle: {
            color: 'silver'
        }
    },
    navigator: {
        handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
        },
        outlineColor: '#CCC',
        maskFill: 'rgba(255,255,255,0.1)',
        series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
        },
        xAxis: {
            gridLineColor: '#505053'
        }
    },
    scrollbar: {
        barBackgroundColor: '#808083',
        barBorderColor: '#808083',
        buttonArrowColor: '#CCC',
        buttonBackgroundColor: '#606063',
        buttonBorderColor: '#606063',
        rifleColor: '#FFF',
        trackBackgroundColor: '#404043',
        trackBorderColor: '#404043'
    },
    mapNavigation: {
        enabled: true,
        enableButtons: false
    }
};

Highcharts.setOptions(Highcharts.theme);

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        id: String
    },
    components: {
        Help: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_components_Help__["a" /* default */]
    },
    data: function data() {
        return {
            changeStart: false,
            titleChartMap: this.$t("291"),
            showLoading: true,
            showMatriz: false,
            activeMatriz: false,
            btn_title: this.$t("126"),
            name_chart: this.$t("125"),
            boxMatriz: '',
            chart: undefined,
            mapOptions: {
                chart: {
                    map: __WEBPACK_IMPORTED_MODULE_7__js_world_continent_json___default.a,

                    renderTo: this.id
                },

                title: {
                    text: ''
                },

                legend: {
                    title: {
                        text: ""
                    }
                },

                mapNavigation: {
                    enabled: true,
                    buttonOptions: {
                        verticalAlign: 'top'
                    }
                },

                tooltip: {
                    headerFormat: '',

                    pointFormat: '<b>{point.pid}</b><br>' + this.$t("127") + ' {point.value} %'
                },

                colorAxis: {
                    showInLegend: false,
                    min: 0,
                    max: 100,
                    stops: [[0, '#90ed7d'], [0.05, '#90ed7d'], [0.051, '#e4d354'], [0.07, '#e4d354'], [0.071, '#f45b5b'], [1, '#f45b5b']]
                },

                series: [{
                    name: 'Basemap',
                    borderColor: '#A0A0A0',
                    nullColor: 'rgba(217, 217, 217)',
                    showInLegend: false,

                    data: []
                }],
                credits: {
                    enabled: false
                },
                loading: {
                    labelStyle: {
                        color: 'black',
                        textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
                    },
                    style: {
                        backgroundColor: 'none',
                        opacity: 1
                    }
                }
            }
        };
    },

    methods: {
        mouseOver: function mouseOver(elem) {
            var self = this;
            if (self.changeStart == true) {
                clearInterval(self.interval);
            }
        },
        mouseleave: function mouseleave(elem) {
            var self = this;
            if (self.changeStart == true) {
                self.btChangeStart();
            }
        },
        btChangeStart: function btChangeStart() {
            var self = this;
            if (self.changeStart == true) {
                self.interval = setInterval(function () {
                    self.showMatriz = !self.showMatriz;
                    self.activeMatriz = !self.activeMatriz;
                    self.btn_title = self.showMatriz ? this.$t("291") : this.$t("126");

                    self.name_chart = self.showMatriz ? this.$t("126") : this.$t("291");

                    if (self.showMatriz) {
                        self.titleChartMap = this.$t("126");
                    } else {
                        self.titleChartMap = this.$t("291");
                    }
                }, 6000);
            } else {
                clearInterval(self.interval);
            }
        },
        getMatrizChart: function getMatrizChart() {
            this.showMatriz = !this.showMatriz;
            this.activeMatriz = !this.activeMatriz;
            this.btn_title = this.showMatriz ? this.$t("291") : this.$t("126");

            this.name_chart = this.showMatriz ? this.$t("126") : this.$t("291");

            if (this.showMatriz) {
                this.titleChartMap = this.$t("126");
            } else {
                this.titleChartMap = this.$t("291");
            }
        },
        getPoints: function getPoints() {
            var data = [];
            var self = this;

            var API = "https://api.semeq.com.br/";

            this.chart.showLoading();

            __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ('v1/mysemeq-ambev/get-health-indicator?region=GLB&tipo=online&planta=&year=' + this.filtersOn.year + '&period=AC'), headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {
                for (var i in response.data) {
                    data.push({
                        'pid': response.data[i].city,
                        'value': response.data[i].tpm,
                        'lat': response.data[i].lat,
                        'lon': response.data[i].lng,
                        'color': response.data[i].cl
                    });
                }

                self.chart.addSeries({
                    type: 'mappoint',
                    enableMouseTracking: true,
                    colorKey: 'color',
                    name: 'Cities',
                    showInLegend: false,
                    zIndex: 7,
                    data: data
                });


                self.chart.hideLoading();
            }).catch(function (error) {
                console.log(error);
                self.chart.showLoading('Error');
            });
        },
        getWorldMap: function getWorldMap() {
            var data = [];
            var self = this;

            var API = "https://api.semeq.com.br/";

            this.chart.showLoading();

            __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + 'v1/mysemeq-ambev/get-health-indicator-glb?region=GLB&tipo=online', headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {
                for (var i in response.data) {
                    var c = '';
                    if (response.data[i].pid == 'AFR') {
                        c = 'af';
                    } else if (response.data[i].pid == 'APAC') {
                        c = 'as';
                    } else if (response.data[i].pid == 'EUR') {
                        c = 'eu';
                    } else if (response.data[i].pid == 'NAZ') {
                            c = 'na';
                        } else if (response.data[i].pid == 'SAZ') {
                            c = 'sa';
                        }

                    data.push({
                        'hc-key': c,
                        'value': response.data[i].tpm,
                        'pid': response.data[i].pid
                    });
                };

                self.chart.addSeries({
                    name: 'Basemap',
                    borderColor: '#000',
                    nullColor: 'rgba(217, 217, 217)',
                    showInLegend: false,
                    data: data
                });
                self.chart.hideLoading();
            }).catch(function (error) {
                console.log(error);
                self.chart.showLoading('Error');
            });
        },
        getMatriz: function getMatriz() {
            var self = this;

            var API = "https://api.semeq.com.br/";

            __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ('v1/mysemeq-ambev/matrixHtml?corporation_id=1&region=&plant_id=' + this.filtersOn.planta + '&year=' + this.filtersOn.year + '&period=' + this.filtersOn.period + '&online=1'), headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {
                self.boxMatriz = response.data;
                self.showLoading = false;
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filtersOn'])),
    watch: {
        filtersOn: function filtersOn(newValue) {
            this.showLoading = true;
            this.getMatriz();
        }
    },
    mounted: function mounted() {
        this.chart = Highcharts.mapChart(this.mapOptions);
        this.getPoints();
        this.getWorldMap();
    },
    created: function created() {}
});

/***/ }),

/***/ "671N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridSystem_vue__ = __webpack_require__("Q8IL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50d9a2f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridSystem_vue__ = __webpack_require__("M/tb");
function injectStyle (ssrContext) {
  __webpack_require__("7p7i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridSystem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50d9a2f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridSystem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6bl1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6dZJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_components_Csv__ = __webpack_require__("Iv/n");










__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_js_popover___default.a);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'charts',
    props: {
        id: String
    },
    components: {
        Help: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_components_Help__["a" /* default */],
        Csv: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_components_Csv__["a" /* default */]
    },
    data: function data() {
        var _chartOptions;

        return {
            showModalFile: false,
            titleChart: this.$t("146"),
            tableData: '',
            activeDGroup: false,
            activeDefect: false,
            activeMpf: false,
            chart: undefined,
            group: 'defect',
            grid_pg: 0,
            selected_defect: '',
            defects: [],
            chartOptions: (_chartOptions = {
                colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8', '#dd6b7f', '#0984e3', '#ffeaa7', '#e84393', '#55efc4', '#636e72', '#ff7675', '#f1c40f', '#34495e'],
                chart: {
                    type: 'pie',
                    renderTo: this.id,
                    marginTop: 35,
                    backgroundColor: 'rgba(0,0,0,0)',
                    style: {
                        fontFamily: '\'Unica One\', sans-serif'
                    },
                    plotBorderColor: '#606063',
                    options3d: {
                        enabled: true,
                        alpha: 45,
                        beta: 0
                    }
                },
                title: {
                    text: '',
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase',
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }
                },
                subtitle: {
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase'
                    }
                },
                accessibility: {
                    announceNewData: {
                        enabled: true
                    },
                    point: {
                        valueSuffix: '%'
                    }
                },
                xAxis: {
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    title: {
                        style: {
                            color: '#A0A0A3'
                        }
                    }
                },
                yAxis: {
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    tickWidth: 1,
                    title: {
                        style: {
                            color: '#A0A0A3'
                        }
                    }
                },
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    }
                },
                plotOptions: {
                    pie: {
                        borderWidth: 0,
                        size: '80%',
                        depth: 65
                    },
                    series: {
                        cursor: 'pointer',
                        innerSize: '50%',
                        events: {
                            click: this.loadGrid
                        },
                        dataLabels: {
                            enabled: true,
                            format: '<span style="color: #fff">{point.name}: {point.percentage:.1f}%</span>',
                            color: '#F0F0F3',
                            style: {
                                fontSize: '12px'
                            }
                        },
                        marker: {
                            lineColor: '#333'
                        }
                    },
                    boxplot: {
                        fillColor: '#505053'
                    },
                    candlestick: {
                        lineColor: 'white'
                    },
                    errorbar: {
                        color: 'white'
                    }
                }
            }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'tooltip', {
                headerFormat: '',
                pointFormat: '<span style="color:{point.color}">{point.name}</span><br/><b>{point.y}</b>',
                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                style: {
                    color: '#F0F0F0'
                }
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'series', [{
                name: 'defects',
                id: 'defects',
                colorByPoint: true,
                data: []
            }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'legend', {
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                itemStyle: {
                    color: '#E0E0E3'
                },
                itemHoverStyle: {
                    color: '#FFF'
                },
                itemHiddenStyle: {
                    color: '#606063'
                },
                title: {
                    style: {
                        color: '#C0C0C0',
                        fontSize: '12px',
                        fontWeight: 'normal'
                    }
                }
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'credits', {
                style: {
                    color: '#666'
                }
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'labels', {
                style: {
                    color: '#707073'
                }
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'drilldown', {
                activeAxisLabelStyle: {
                    color: '#F0F0F3'
                },
                activeDataLabelStyle: {
                    color: '#F0F0F3'
                }
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'navigation', {
                buttonOptions: {
                    symbolStroke: '#DDDDDD',
                    theme: {
                        fill: '#505053'
                    }
                }
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'rangeSelector', {
                buttonTheme: {
                    fill: '#505053',
                    stroke: '#000000',
                    style: {
                        color: '#CCC'
                    },
                    states: {
                        hover: {
                            fill: '#707073',
                            stroke: '#000000',
                            style: {
                                color: 'white'
                            }
                        },
                        select: {
                            fill: '#000003',
                            stroke: '#000000',
                            style: {
                                color: 'white'
                            }
                        }
                    }
                },
                inputBoxBorderColor: '#505053',
                inputStyle: {
                    backgroundColor: '#333',
                    color: 'silver'
                },
                labelStyle: {
                    color: 'silver'
                }
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'navigator', {
                handles: {
                    backgroundColor: '#666',
                    borderColor: '#AAA'
                },
                outlineColor: '#CCC',
                maskFill: 'rgba(255,255,255,0.1)',
                series: {
                    color: '#7798BF',
                    lineColor: '#A6C7ED'
                },
                xAxis: {
                    gridLineColor: '#505053'
                }
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'scrollbar', {
                barBackgroundColor: '#808083',
                barBorderColor: '#808083',
                buttonArrowColor: '#CCC',
                buttonBackgroundColor: '#606063',
                buttonBorderColor: '#606063',
                rifleColor: '#FFF',
                trackBackgroundColor: '#404043',
                trackBorderColor: '#404043'
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'exporting', { enabled: false }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'credits', {
                enabled: false
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'loading', {
                labelStyle: {
                    color: 'black',
                    textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
                },
                style: {
                    backgroundColor: 'none',
                    opacity: 1,
                    marginTop: '20px'
                }
            }), _chartOptions) };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_5__utils_mixin__["a" /* default */]],
    mounted: function mounted() {
        var self = this;
        self.activeDGroup = false;
        self.activeDefect = true;
        self.activeMpf = false;
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['changeGrid']), {
        getData: function getData() {

            var API = "https://api.semeq.com.br/";
            var ENDPOINT = 'v1/mysemeq-ambev/get-defect-chart?group=' + this.group;
            var self = this;

            this.$refs.chart.chart.showLoading();

            __WEBPACK_IMPORTED_MODULE_4_axios___default()({ method: 'GET', url: API + ENDPOINT, params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filters, { 'online': 0 }), headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
                self.tableData = resp.data;
                self.$refs.chart.chart.hideLoading();
            }).catch(function (err) {
                self.ApiErrorHandler(self, error.response.data.status_code);
                self.$refs.chart.chart.showLoading('Error');
            });
        },
        setChartData: function setChartData() {
            var self = this;
            var res = self.tableData;
            var values = [];

            for (var key in res) {
                values.push({ 'name': res[key].text, 'y': res[key].total });
            }
            self.chartOptions.series[0].data = values;
        },
        getCsvAll: function getCsvAll() {
            var self = this;
            self.showModalFile = true;
            var defect = self.group;
            var file = 'csv';
            var API = "https://api.semeq.com.br/";

            var ENDPOINT = 'v1/mysemeq-ambev/get-defect?group=' + this.group + '&year=' + this.filters.year + '&period=' + this.filters.period + '&plant=' + this.filters.plant + '&region=' + this.filters.region + '&technique=' + this.filters.technique + '&status=&area=' + this.filters.area + '&sector=' + this.filters.sector + '&machine=' + this.filters.machine + '&component=' + this.filters.component + '&online=0&pg=0&sort=&order=asc&file=' + file;

            var name_chart_file = this.$t("348");

            __WEBPACK_IMPORTED_MODULE_4_axios___default()({
                method: 'GET',
                url: API + ENDPOINT,
                responseType: 'blob',
                headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token')
                } }).then(function (_ref) {
                var data = _ref.data;

                var url = window.URL.createObjectURL(new Blob([data]));
                var link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', name_chart_file + '.csv');
                document.body.appendChild(link);
                link.click();
                self.showModalFile = false;
            }).catch(function (error) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        getPoints: function getPoints(group) {
            var self = this;
            self.group = group;

            if (self.group == 'defect_group') {
                self.activeDGroup = true;
                self.activeDefect = false;
                self.activeMpf = false;
            }
            if (self.group == 'defect') {
                self.activeDGroup = false;
                self.activeDefect = true;
                self.activeMpf = false;
            }
            if (self.group == 'mpf') {
                self.activeDGroup = false;
                self.activeDefect = false;
                self.activeMpf = true;
            }

            var data = [];

            var API = "https://api.semeq.com.br/";
            var ENDPOINT = 'v1/mysemeq-ambev/get-defect-chart?group=' + this.group;

            this.$refs.chart.chart.showLoading();

            __WEBPACK_IMPORTED_MODULE_4_axios___default()({ method: 'GET', url: API + ENDPOINT, params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filters, { 'online': 0 }), headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {
                for (var i in response.data) {
                    data.push({
                        'name': response.data[i].text,
                        'y': response.data[i].total
                    });
                }

                self.chartOptions.series[0].data = data;
                self.group = group;

                self.$refs.chart.chart.hideLoading();
            }).catch(function (error) {
                self.ApiErrorHandler(self, error.response.data.status_code);
                self.$refs.chart.chart.showLoading('Error');
            });
        },
        loadGrid: function loadGrid(event) {
            var defect = event.point.name;
            var point_name = event.point.name;
            var NAME_CHART = this.$t("348") + ' - ' + point_name.toUpperCase();

            var ENDPOINT = 'v1/mysemeq-ambev/get-defect?group=' + this.group + '&year=' + this.filters.year + '&period=' + this.filters.period + '&plant=' + this.filters.plant + '&region=' + this.filters.region + '&technique=' + this.filters.technique + '&status=' + defect + '&area=' + this.filters.area + '&sector=' + this.filters.sector + '&machine=' + this.filters.machine + '&component=' + this.filters.component + '&online=0';

            var grid = {
                totalDados: event.point.y,
                title: defect,
                url: ENDPOINT,
                name_chart: NAME_CHART,
                columns: {
                    "rows": '',
                    "plant": this.$t("310"),
                    "area": this.$t("311"),
                    "sector": this.$t("312"),
                    "component": this.$t("313"),
                    "component_tag": this.$t("314"),
                    "component_type_en": this.$t("315"),
                    "machine": this.$t("316"),
                    "machine_tag": this.$t("317"),
                    "status_txt_en": this.$t("318"),
                    "report_number": this.$t("319"),
                    "approved_datetime": this.$t("320"),
                    "technique_en": this.$t("321"),
                    "ref_date": this.$t("322"),
                    "link": this.$t("323"),
                    "link_rci": this.$t("324")

                },
                show: true,
                titleHelp: 'Grid - ' + this.$t("348"),
                txtHelp: this.$t("349")
            };

            if (this.filters.plant) {
                grid.title += ' - ' + this.filters.plant_name;
                delete grid.columns['plant'];
            } else if (this.filters.region) {
                grid.title += ' - ' + this.filters.region;
            }

            this.changeGrid(grid);
        }
    }),
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['filters'])),
    watch: {
        filters: function filters(newValue) {
            this.getData();
        },
        tableData: function tableData() {
            this.setChartData();
        }
    }
});

/***/ }),

/***/ "77+S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users__ = __webpack_require__("J8BY");
















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  computed: {
    pagedData: function pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.tableData.length;
        return this.pagedData;
      }
      var result = this.tableData.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString();
            if (rowValue.includes && rowValue.includes(_this.searchQuery)) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.tableData.length;
      return this.tableData.length;
    }
  },
  data: function data() {
    return {
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['name', 'email', 'age'],
      tableColumns: [{
        prop: 'name',
        label: 'Name',
        minWidth: 200
      }, {
        prop: 'email',
        label: 'Email',
        minWidth: 250
      }, {
        prop: 'age',
        label: 'Age',
        minWidth: 100
      }, {
        prop: 'salary',
        label: 'Salary',
        minWidth: 120
      }],
      tableData: __WEBPACK_IMPORTED_MODULE_12__users__["a" /* default */]
    };
  },

  methods: {
    handleLike: function handleLike(index, row) {
      alert('Your want to like ' + row.name);
    },
    handleEdit: function handleEdit(index, row) {
      alert('Your want to edit ' + row.name);
    },
    handleDelete: function handleDelete(index, row) {
      var indexToDelete = this.tableData.findIndex(function (tableRow) {
        return tableRow.id === row.id;
      });
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    }
  }
});

/***/ }),

/***/ "7XZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Indicator_Widget__ = __webpack_require__("3yc9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_History_chart_online__ = __webpack_require__("z35I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Charts_Area_radar_chart__ = __webpack_require__("IMIu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);













var API = "https://api.semeq.com.br/";

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        IndicatorWidget: __WEBPACK_IMPORTED_MODULE_4__Components_Indicator_Widget__["a" /* default */],
        HistoryChart: __WEBPACK_IMPORTED_MODULE_5__Components_History_chart_online__["a" /* default */],
        Help: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_components_Help__["a" /* default */],
        AreaRadarChart: __WEBPACK_IMPORTED_MODULE_6__Charts_Area_radar_chart__["a" /* default */]
    },
    data: function data() {
        return {
            title: this.$t("257"),
            title2: this.$t("258"),
            total_falhas_all: 0,
            total_resolvidos_all: 0,
            total_media_all: 0,
            total_falhas_y: 0,
            total_resolvidos_y: 0,
            total_media_y: 0,
            total_falhas_6m: 0,
            total_resolvidos_6m: 0,
            total_media_6m: 0,
            total_falhas_cor: 'red',
            total_resolvidos_cor: 'green',
            total_media_cor: 'blue',
            chart_failure_data: [],
            chart_resolved_data: [],
            chart_tmsa_data: [],
            radar_data: [],
            last_region: '',
            last_plant: -1,
            last_area: '',
            last_sector: '',
            last_machine: '',
            last_component: '',
            last_technique: ''
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_3__utils_mixin__["a" /* default */]],
    methods: {
        getReportsOnline: function getReportsOnline() {
            var self = this;

            var param = { "plant_id": this.filtersOn.planta, "technique_id": this.filtersOn.technique, "corp": 1, "region": this.filtersOn.region, "area": this.filtersOn.area_f, "sector": this.filtersOn.sector_f, "machine": this.filtersOn.machine, "component": this.filtersOn.subset, "online": 1 };


            __WEBPACK_IMPORTED_MODULE_2_axios___default()({ method: 'GET', url: API + 'v1/mysemeq-ambev/history-reports', params: param, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {
                self.total_falhas_all = 0;
                self.total_media_all = 0;
                self.total_falhas_y = 0;
                self.total_media_y = 0;
                self.total_falhas_6m = 0;
                self.total_media_6m = 0;
                var data = response.data;
                var data_len = data.length;
                var last_12_month = data_len - 13;
                var last_6_month = data_len - 7;
                self.chart_failure_data = [];
                self.chart_tmsa_data = [];
                var i = 0;

                __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.each(data, function (key, val) {
                    self.total_falhas_all += val.total;
                    self.total_media_all += val.average;
                    self.chart_failure_data.push([val.ref_date, val.total]);
                    self.chart_tmsa_data.push([val.ref_date, val.average]);

                    if (i >= last_12_month) {
                        self.total_falhas_y += val.total;
                        self.total_media_y += val.average;
                    }

                    if (i >= last_6_month) {
                        self.total_falhas_6m += val.total;
                        self.total_media_6m += val.average;
                    }
                    i++;
                });

                self.total_media_all = parseFloat((self.total_media_all / i).toFixed(1));
                self.total_media_y = parseFloat((self.total_media_y / 12).toFixed(1));
                self.total_media_6m = parseFloat((self.total_media_6m / 6).toFixed(1));
            }).catch(function (response) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        getReportsRci: function getReportsRci() {

            var self = this;
            var param = { "plant_id": this.filtersOn.planta, "technique_id": this.filtersOn.technique, "corp": 1, "region": this.filtersOn.region, "area": this.filtersOn.area_f, "sector": this.filtersOn.sector_f, "machine": this.filtersOn.machine, "component": this.filtersOn.subset, "online": 1 };
            __WEBPACK_IMPORTED_MODULE_2_axios___default()({ method: 'GET', url: API + 'v1/mysemeq-ambev/history-reports-rci', params: param, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {
                self.total_resolvidos_all = 0;
                self.total_resolvidos_y = 0;
                self.total_resolvidos_6m = 0;
                var data = response.data;
                var data_len = data.length;
                var last_12_month = data_len - 13;
                var last_6_month = data_len - 7;
                self.chart_resolved_data = [];
                var i = 0;

                __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.each(data, function (key, val) {
                    self.total_resolvidos_all += val.total;
                    self.chart_resolved_data.push([val.ref_date, val.total]);

                    if (i >= last_12_month) {
                        self.total_resolvidos_y += val.total;
                    }

                    if (i >= last_6_month) {
                        self.total_resolvidos_6m += val.total;
                    }

                    i++;
                });
            }).catch(function (response) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        getAreaReports: function getAreaReports() {

            var self = this;

            var param = { "plant_id": this.filtersOn.planta, "technique_id": this.filtersOn.technique, "corp": 1, "region": this.filtersOn.region, "year": this.filtersOn.year, "period": this.filtersOn.period, "area": this.filtersOn.area_f, "sector": this.filtersOn.sector_f, "machine": this.filtersOn.machine, "component": this.filtersOn.subset, "online": 1 };

            self.radar_data = [];
            __WEBPACK_IMPORTED_MODULE_2_axios___default()({ method: 'GET', url: API + 'v1/mysemeq-ambev/areas-reports', params: param, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {

                var data = response.data;
                var new_data = {};
                var area = '';

                var count = 0;
                __WEBPACK_IMPORTED_MODULE_8_jquery___default.a.each(data, function (key, val) {
                    if (val.total >= 1) {
                        if (area != val.area) {
                            new_data[val.area] = { data: [], categories: [] };
                            area = val.area;
                            count = 0;
                        }

                        if (count < 10) {
                            new_data[val.area].data.push(val.total);
                            new_data[val.area].categories.push(val.sector);
                        }

                        count += 1;
                    }
                });

                self.radar_data = new_data;
            }).catch(function (response) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filtersOn'])),
    watch: {
        filtersOn: function filtersOn(newValue) {
            this.getAreaReports();

            if (this.last_region != newValue.region || this.last_plant != newValue.planta || this.last_area != newValue.area_f || this.last_sector != newValue.sector_f || this.last_machine != newValue.machine || this.last_component != newValue.subset) {
                this.getReportsOnline();
                this.getReportsRci();
            }

            this.last_region = newValue.region;
            this.last_plant = newValue.planta;
            this.last_area = newValue.area_f;
            this.last_sector = newValue.sector_f;
            this.last_machine = newValue.machine;
            this.last_component = newValue.subset;
            this.last_technique = newValue.technique;
        }
    }
});

/***/ }),

/***/ "7g4f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_money__ = __webpack_require__("9VIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_v_money__);














__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_v_money___default.a, { precision: 4 });

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'charts',
    components: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_date_picker___default.a),
    data: function data() {
        return {
            price: '',
            decimal: '0',
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            money_virgula: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            title: this.$t("299"),
            link_rdp: '',
            link_rci: '',
            id_rdp: '',
            active: 'dr',
            showModal: false,
            rdp: {},
            form: false,
            error: {
                msg: '',
                status: false,
                msgrci: '',
                statusrci: false
            },
            msg: {
                msg: '',
                status: false,
                msgrci: '',
                statusrci: false
            },
            rci_numero: '',
            rci_planta_area: '',
            rci_nome_resp_intervencao: '',
            rci_psm_wo: '',
            rci_tempo_gasto_inter_hour: '',
            rci_tempo_gasto_inter_minu: '',
            rci_tempo_parada_equip_hour: '',
            rci_tempo_parada_equip_minu: '',
            rci_dt_intervencao: '',
            rci_resp_pergunta_a: '1',
            rci_desc_resp_pergunta_a: '',
            rci_resp_pergunta_b: '1',
            rci_desc_resp_pergunta_b: '',
            rci_resp_pergunta_c: '1',
            rci_desc_resp_pergunta_c: '',
            rci_resp_pergunta_d: '1',
            rci_desc_resp_pergunta_d: '',
            disabled: false,
            questao: 'normal',
            vibracao: '0',
            rci_currency: '',
            rci_currency_value: [],
            rci_downtime: '',
            rci_secondary_damage: '',
            rci_preventive: '',
            number_a: '1',
            number_b: '2',
            number_c: '3',
            number_d: '4',
            number_e: '5',

            link_prescription: '',
            create_presc: false,
            presc_note: '',
            files: [],
            disabled_submit: true,
            arquivo: '',
            list_file: [],
            created_by: '',
            creation_date: '',
            edited_by: '',
            last_updated: '',
            notes_save: '',
            active_pres: false,
            disabled_del_presc: true,
            disabled_add_presc: false,
            status_prescription: ''
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_8__utils_mixin__["a" /* default */]],
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        addPresc: function addPresc() {
            this.create_presc = true;
        },
        DeletePresc: function DeletePresc() {
            var self = this;

            if (this.status_prescription == '1') {
                var API = "https://api.semeq.com.br/";


                var data = new FormData();
                data.append('id_prescription', this.id_prescription);

                __WEBPACK_IMPORTED_MODULE_6_axios___default()({ method: 'POST', url: API + 'v1/mysemeq-ambev/deletePrescription', data: data, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {
                    alert(this.$t("341"));
                    self.getPrescription();
                }).catch(function (error) {
                    self.ApiErrorHandler(self, error.response.data.status_code);
                });
            } else {
                alert(this.$t("342"));
            }
        },
        getPrescriptionList: function getPrescriptionList() {
            var self = this;
            self.list_file = [];

            var API = "https://api.semeq.com.br/";


            var data = new FormData();
            data.append('component_id', self.component_id);
            data.append('ref_date', self.ref_date);
            data.append('report_id', self.id_rdp);

            __WEBPACK_IMPORTED_MODULE_6_axios___default()({ method: 'POST', url: API + 'v1/mysemeq-ambev/getPrescriptiong', data: data, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {

                self.list_file = response.data;
            }).catch(function (error) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        getPrescription: function getPrescription() {
            var API = "https://api.semeq.com.br/";


            var self = this;
            self.files = [];
            self.list_file = [];
            self.active_pres = false;
            self.disabled_del_presc = true;
            self.disabled_add_presc = false;
            this.create_presc = false;
            self.presc_note = '';
            self.disabled_submit = true;
            self.status_prescription = '';

            var data = new FormData();
            data.append('component_id', self.component_id);
            data.append('ref_date', self.ref_date);
            data.append('report_id', self.id_rdp);

            __WEBPACK_IMPORTED_MODULE_6_axios___default()({ method: 'POST', url: API + 'v1/mysemeq-ambev/getPrescriptiong', data: data, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {

                console.log('RESULT: ', response.data);
                self.list_file = response.data;
                self.presc_note = response.data[0].note;

                self.id_prescription = response.data[0].id_prescription;
                if (self.id_prescription) {
                    self.active_pres = true;
                }
                self.created_by = response.data[0].create_by;
                self.creation_date = response.data[0].create_at;
                self.edited_by = response.data[0].updated_by;
                self.last_updated = response.data[0].update_at;
                self.notes_save = response.data[0].note;

                self.link_prescription = 'http://mysemeq13.semeq.com.br/upload/';

                if (!response.data[0].file_name) {
                    self.disabled_submit = true;
                } else {
                    self.disabled_submit = false;
                }

                self.status = response.data[0].status;
                self.feedback_executed = response.data[0].feedback_executed;

                if (self.status == 'A' && self.feedback_executed == 'N') {
                    self.status_prescription = 1;
                    self.disabled_del_presc = false;
                    self.disabled_add_presc = false;
                }
                if (self.status == 'F' && self.feedback_executed == 'S') {
                    self.status_prescription = 2;
                    self.disabled_del_presc = true;
                    self.disabled_add_presc = true;
                }
                if (self.status == 'F' && self.feedback_executed == 'N') {
                    self.status_prescription = 3;
                    self.disabled_del_presc = true;
                    self.disabled_add_presc = true;
                }
            }).catch(function (error) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        addFiles: function addFiles() {
            this.$refs.files.click();
        },
        submitFiles: function submitFiles() {

            var self = this;

            var API = "https://api.semeq.com.br/";


            var data = new FormData();

            for (var i = 0; i < this.files.length; i++) {
                var file = this.files[i];

                data.append('files[' + i + ']', file);
            }

            data.append('id_prescription', '');
            data.append('id_rdp', this.id_rdp);
            data.append('component_id', this.component_id);
            data.append('note', this.presc_note);
            data.append('user_id', this.user_id);
            data.append('ref_date', this.ref_date);

            if (this.files.length > 0) {
                data.append('update_note', 'nao');
            } else {
                    data.append('update_note', 'sim');
                }

            __WEBPACK_IMPORTED_MODULE_6_axios___default()({
                method: 'POST', url: API + 'v1/mysemeq-ambev/createPrescription', data: data,
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('user-token'),
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (_ref) {
                var data = _ref.data;

                if (data.status == true) {
                    alert(this.$t("343"));
                    self.files = '';
                    self.getPrescription();
                }
                if (data.status == false) {
                    alert(this.$t("344"));
                }
            }).catch(function (error) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        handleFilesUpload: function handleFilesUpload() {
            var uploadedFiles = this.$refs.files.files;

            for (var i = 0; i < uploadedFiles.length; i++) {

                var filename = uploadedFiles[i].name;

                var nameFile = filename.split('.').slice(0, -1).join('.');

                var regex = /\W|_/;

                var comCaracterEspecial = regex.test(nameFile);

                if (uploadedFiles[i].type == 'application/pdf' && comCaracterEspecial == false) {
                    this.files.push(uploadedFiles[i]);
                } else {
                    alert(this.$t("345"));
                }
            }
        },
        removeFile: function removeFile(key) {
            this.files.splice(key, 1);
        },
        removeFileSave: function removeFileSave(filename, id_prescription) {

            if (this.status_prescription == '1') {
                var API = "https://api.semeq.com.br/";


                var data = new FormData();
                data.append('filename', filename);
                data.append('id_prescription', id_prescription);

                var self = this;
                __WEBPACK_IMPORTED_MODULE_6_axios___default()({ method: 'POST', url: API + 'v1/mysemeq-ambev/deletePrescriptiongFile', data: data, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {
                    alert(this.$t("346"));
                    console.log('RESULT: ', response.data);
                    self.getPrescriptionList();
                }).catch(function (error) {
                    self.ApiErrorHandler(self, error.response.data.status_code);
                });
            } else {

                alert(this.$t("347"));
            }
        },
        toggleLink: function toggleLink(link) {
            this.link = link;
        },
        save: function save() {

            this.msg.status = false;

            var error = false;

            if (!this.rdp.psm_os && !this.rdp.sap_nw_number) {
                this.error.status = true;
                this.error.msg = 'Please fill in PSM / W.O. or Note Number!';
                error = true;
            }

            if (!this.rdp.motivo) {
                this.msg.status = false;
                this.error.status = true;
                this.error.msg = 'Fill in the reason of schedule!';
                error = true;
            }

            var t = new Date().setHours(0, 0, 0, 0);
            var d = this.rdp.data_prog;
            var end_date = new Date(new Date().setYear(new Date().getFullYear() + 1));

            if (d - t < 0) {
                this.error.status = true;
                error = true;
                this.error.msg = 'Please select a date greater or equal than today!';
            } else if (d - end_date > 0) {
                this.error.status = true;
                error = true;
                this.error.msg = 'The date of the schedule should be less than 1 year!';
            }

            if (error) {
                return false;
            }

            this.error.status = false;

            var data = this.rdp.data_prog;
            var dia = data.getDate().toString();
            var diaF = dia.length == 1 ? '0' + dia : dia;
            var mes = (data.getMonth() + 1).toString();
            var mesF = mes.length == 1 ? '0' + mes : mes;
            var anoF = data.getFullYear();

            data = diaF + '/' + mesF + '/' + anoF;

            var model = {
                'prog_n': this.rdp.psm_os,
                'prog_dt': data,
                'prog_motivo': this.rdp.motivo,
                'prog_nota': this.rdp.sap_nw_number,
                'id': this.id_rdp
            };

            var API = "https://api.semeq.com.br/";

            var self = this;
            __WEBPACK_IMPORTED_MODULE_6_axios___default()({ method: 'POST', url: API + 'v1/save-rci-prog', data: model, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (_ref2) {
                var data = _ref2.data;

                if (data) {
                    self.msg.status = data;
                    self.msg.msg = 'Successfully scheduled!';
                }
            }).catch(function (error) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        reset: function reset() {
            this.form = false;
            this.error.status = false;
            this.msg.status = false;
        },
        get_rci_prog: function get_rci_prog() {
            var API = "https://api.semeq.com.br/";

            var self = this;
            __WEBPACK_IMPORTED_MODULE_6_axios___default()({ method: 'GET', url: API + 'v1/get-rci-prog', params: { rdp: this.id_rdp }, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (_ref3) {
                var data = _ref3.data;

                self.rdp = data;
                if (self.rdp.data_prog) {
                    var parts = self.rdp.data_prog.split("/");
                    self.rdp.data_prog = new Date(parts[2], parts[1] - 1, parts[0]);
                }
            }).catch(function (error) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },

        isNumber: function isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        },
        get_currenty: function get_currenty() {
            var self = this;

            var API = "https://api.semeq.com.br/";

            __WEBPACK_IMPORTED_MODULE_6_axios___default()({ method: 'GET', url: API + 'v1/mysemeq-ambev/catMoeda', params: '', headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (_ref4) {
                var data = _ref4.data;

                var res = data;

                var lista = [];
                for (var key in res) {
                    lista.push({
                        'value': res[key].id,
                        'name': res[key].id == 3 ? 'Euro -  €' : res[key].simbolo,
                        'decimal': res[key].tipo_decimal
                    });
                }

                self.rci_currency_value = lista;
            }).catch(function (error) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        get_rci: function get_rci() {
            var self = this;

            var API = "https://api.semeq.com.br/";
            var idrdp = self.link_rci;

            __WEBPACK_IMPORTED_MODULE_6_axios___default()({ method: 'GET', url: API + 'v1/mysemeq-ambev/RciSemeq', params: { idrdp: idrdp }, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (_ref5) {
                var data = _ref5.data;

                self.rci = data;

                if (!self.rci[0].psm_os) {
                    self.disabled = false;
                } else {
                    self.disabled = true;
                }

                self.questao = 'normal';
                self.vibracao = '0';

                self.number_a = '1';
                self.number_b = '0';
                self.number_c = '0';
                self.number_d = '2';
                self.number_e = '3';

                if (self.technique_id == 3) {
                    self.questao = 'oleo';
                    self.number_e = '4';
                }

                if (self.technique_id == 2) {
                    self.questao = 'normal';
                    self.vibracao = '1';

                    self.number_a = '1';
                    self.number_b = '2';
                    self.number_c = '3';
                    self.number_d = '4';
                    self.number_e = '5';
                }

                self.rci_numero = self.report_number;
                self.rci_planta_area = self.plant + ' / ' + self.area;
                self.rci_nome_resp_intervencao = self.rci[0].nome_resp_intervencao == undefined ? self.name_user : self.rci[0].nome_resp_intervencao;
                self.rci_psm_wo = self.rci[0].psm_os;
                self.rci_tempo_gasto_inter_hour = self.rci[0].tempo_gasto_inter_hour;
                self.rci_tempo_gasto_inter_minu = self.rci[0].tempo_gasto_inter_minu;
                self.rci_tempo_parada_equip_hour = self.rci[0].tempo_parada_equip_hour;
                self.rci_tempo_parada_equip_minu = self.rci[0].tempo_parada_equip_minu;

                if (self.rci[0].dt_intervencao) {
                    var parts = self.rci[0].dt_intervencao.split("GMT");
                    self.rci_dt_intervencao = new Date(parts[0]);
                }

                self.rci_resp_pergunta_a = self.rci[0].resp_pergunta_a;
                self.rci_desc_resp_pergunta_a = self.rci[0].desc_resp_pergunta_a;

                self.rci_resp_pergunta_b = self.rci[0].resp_pergunta_b;
                self.rci_desc_resp_pergunta_b = self.rci[0].desc_resp_pergunta_b;

                self.rci_resp_pergunta_c = self.rci[0].resp_pergunta_c;
                self.rci_desc_resp_pergunta_c = self.rci[0].desc_resp_pergunta_c;

                self.rci_resp_pergunta_d = self.rci[0].resp_pergunta_d;
                self.rci_desc_resp_pergunta_d = self.rci[0].desc_resp_pergunta_d;

                self.rci_downtime = self.rci[0].downtime == null ? '0.00' : self.rci[0].downtime;
                self.rci_secondary_damage = self.rci[0].sec_damage == null ? '0.00' : self.rci[0].sec_damage;
                self.rci_preventive = self.rci[0].work_avoided == null ? '0.00' : self.rci[0].work_avoided;
                self.rci_currency = self.rci[0].moeda;
            }).catch(function (error) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        saveRci: function saveRci() {

            this.msg.statusrci = false;
            this.error.msgrci = '';

            var error = false;

            if (!this.rci_psm_wo) {
                this.error.statusrci = true;
                this.error.msgrci = 'Please fill in PSM / W.O!';
                error = true;
                return false;
            }

            if (!this.rci_dt_intervencao) {
                this.error.statusrci = true;
                this.error.msgrci = 'Please fill Intervention Date!';
                error = true;
                return false;
            }

            if (!this.rci_nome_resp_intervencao) {
                this.error.statusrci = true;
                this.error.msgrci = 'Please fill Person responsible for intervention!';
                error = true;
                return false;
            }

            if (this.isNumber(this.rci_tempo_gasto_inter_hour) == false) {
                this.msg.statusrci = false;
                this.error.statusrci = true;
                this.error.msgrci = ' Please fill only number in Hours and Minutes';
                error = true;
                return false;
            }

            if (this.isNumber(this.rci_tempo_gasto_inter_minu) == false) {
                this.msg.statusrci = false;
                this.error.statusrci = true;
                this.error.msgrci = 'Please fill only number in Hours and Minutes';
                error = true;
                return false;
            }

            if (this.isNumber(this.rci_tempo_parada_equip_hour) == false) {
                this.msg.statusrci = false;
                this.error.statusrci = true;
                this.error.msgrci = 'Please fill only number in Hours and Minutes';
                error = true;
                return false;
            }

            if (this.isNumber(this.rci_tempo_parada_equip_minu) == false) {
                this.msg.statusrci = false;
                this.error.statusrci = true;
                this.error.msgrci = 'Please fill only number in Hours and Minutes';
                error = true;
                return false;
            }

            if (!this.rci_currency) {
                this.error.statusrci = true;
                this.error.msgrci = 'Please select a currency!';
                error = true;
                return false;
            }

            if (!this.rci_downtime) {
                this.error.statusrci = true;
                this.error.msgrci = 'Please fill Downtime!';
                error = true;
                return false;
            }

            if (!this.rci_secondary_damage) {
                this.error.statusrci = true;
                this.error.msgrci = 'Please fill Secondary damage!';
                error = true;
                return false;
            }

            if (!this.rci_preventive) {
                this.error.statusrci = true;
                this.error.msgrci = 'Please fill Preventive work avoided!';
                error = true;
                return false;
            }

            if (this.technique_id != 3 && this.technique_id != 2) {
                if (!this.rci_resp_pergunta_a || !this.rci_resp_pergunta_d) {
                    this.msg.statusrci = false;
                    this.error.statusrci = true;
                    this.error.msgrci = 'Please answer all questions!';
                    error = true;
                    return false;
                } else {
                    this.saveRciOk();
                }
            }

            if (this.technique_id == 2) {
                if (!this.rci_resp_pergunta_a || !this.rci_resp_pergunta_b || !this.rci_resp_pergunta_c || !this.rci_resp_pergunta_d) {
                    this.msg.statusrci = false;
                    this.error.statusrci = true;
                    this.error.msgrci = 'Please answer all questions!';
                    error = true;
                    return false;
                } else {
                    this.saveRciOk();
                }
            }

            if (this.technique_id == 3) {
                if (!this.rci_resp_pergunta_a || !this.rci_resp_pergunta_b || !this.rci_resp_pergunta_c) {
                    this.msg.statusrci = false;
                    this.error.statusrci = true;
                    this.error.msgrci = 'Please answer all questions!';
                    error = true;
                    return false;
                } else {
                    this.saveRciOk();
                }
            }
        },
        saveRciOk: function saveRciOk() {

            this.msg.msgrci = '';

            var model = {
                'idrdp': this.link_rci,
                'psm_os': this.rci_psm_wo,
                'user_id': '',
                'dt_inter': this.rci_dt_intervencao,
                'tmp_gasto': this.rci_tempo_gasto_inter_hour + 'H' + this.rci_tempo_gasto_inter_minu,
                'tmp_parada': this.rci_tempo_parada_equip_hour + 'H' + this.rci_tempo_parada_equip_minu,
                'nm_resp_inter': this.rci_nome_resp_intervencao,
                'resp_a': this.rci_resp_pergunta_a == undefined ? '' : this.rci_resp_pergunta_a,
                'desc_a': this.rci_desc_resp_pergunta_a == undefined ? '' : this.rci_desc_resp_pergunta_a,
                'resp_b': this.rci_resp_pergunta_b == undefined ? '' : this.rci_resp_pergunta_b,
                'desc_b': this.rci_desc_resp_pergunta_b == undefined ? '' : this.rci_desc_resp_pergunta_b,
                'resp_c': this.rci_resp_pergunta_c == undefined ? '' : this.rci_resp_pergunta_c,
                'desc_c': this.rci_desc_resp_pergunta_c == undefined ? '' : this.rci_desc_resp_pergunta_c,
                'resp_d': this.rci_resp_pergunta_d == undefined ? '' : this.rci_resp_pergunta_d,
                'desc_d': this.rci_desc_resp_pergunta_d == undefined ? '' : this.rci_desc_resp_pergunta_d,
                'resp_e': '',
                'desc_e': '',
                'resp_f': '',
                'desc_f': '',
                'resp_final': '',
                'motivo': '',
                'id_moeda': this.rci_currency,
                'downtime': this.rci_downtime,
                'sec_damage': this.rci_secondary_damage,
                'work_avoided': this.rci_preventive
            };

            var API = "https://api.semeq.com.br/";

            var self = this;
            __WEBPACK_IMPORTED_MODULE_6_axios___default()({ method: 'POST', url: API + 'v1/mysemeq-ambev/bxRciSemeq', data: model, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (_ref6) {
                var data = _ref6.data;

                if (data) {
                    self.msg.statusrci = data;
                    self.msg.msgrci = 'Successfully scheduled!';
                }
            }).catch(function (error) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])(['modal_rdp'])),
    computed: {
        rdpModal: function rdpModal() {
            return this.modal_rdp();
        }
    },
    watch: {
        files: function files() {
            if (this.files.length > 0) {
                this.disabled_submit = false;
            } else {
                this.disabled_submit = true;
            }
        },
        rci_currency: function rci_currency() {

            var res = this.rci_currency_value;

            for (var key in res) {
                if (res[key].value == this.rci_currency) {
                    this.decimal = res[key].decimal;
                }
            }
        },
        form: function form() {
            if (this.form == true) {
                this.$nextTick(function () {
                    this.$refs.psmschedule.focus();
                });
            }
        },
        active: function active() {
            if (this.active == 'feedback') {
                this.$nextTick(function () {
                    this.$refs.psm.focus();
                });
            }
            if (this.active == 'prescription') {
                this.getPrescription();
            }
        },
        show: function show(newValue) {
            this.showModal = newValue;
        },
        rdpModal: function rdpModal(newValue) {
            this.link_rdp = newValue.link_rdp;
            this.link_rci = newValue.link_rci;
            this.technique_id = newValue.technique_id;
            this.technique = newValue.technique;
            this.component_id = newValue.component_id;
            this.id_rdp = newValue.id_rdp;
            this.ref_date = newValue.ref_date;

            console.log('component_id: ', newValue.component_id);
            console.log('id_rdp: ', newValue.id_rdp);
            console.log('ref_date: ', newValue.ref_date);

            this.report_number = newValue.report_number;
            this.plant = newValue.plant;
            this.area = newValue.area;
            var res = JSON.parse(localStorage.getItem('users'));
            this.name_user = res.users.name;
            this.user_id = res.users.id;


            this.showModal = true;
            this.active = 'dr';
            this.get_rci();
            this.get_rci_prog();
            this.reset();
            this.get_currenty();

            this.$nextTick(function () {
                this.$refs.closer.focus();
            });
        }
    },
    mounted: function mounted() {
        this.link = this.link_rdp;
    }
});

/***/ }),

/***/ "7j/V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReincidenciaIndicator_vue__ = __webpack_require__("XAl3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cee425e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReincidenciaIndicator_vue__ = __webpack_require__("uNEM");
function injectStyle (ssrContext) {
  __webpack_require__("CsB2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cee425e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReincidenciaIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cee425e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReincidenciaIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7p7i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8jBr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8mNY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8sR8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Online2_vue__ = __webpack_require__("Qu5a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_140aeae3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Online2_vue__ = __webpack_require__("/wqj");
function injectStyle (ssrContext) {
  __webpack_require__("8jBr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Online2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_140aeae3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Online2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8vMF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9597":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfileForm_vue__ = __webpack_require__("E0D1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad77aee8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfileForm_vue__ = __webpack_require__("v71F");
function injectStyle (ssrContext) {
  __webpack_require__("D/GA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfileForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad77aee8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfileForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9Dxv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "9G8F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9TgA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._m(1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"places-buttons"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('top', 'left')}}},[_vm._v("Top Left")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('top', 'center')}}},[_vm._v("Top Center")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('top', 'right')}}},[_vm._v("Top Right")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('bottom', 'left')}}},[_vm._v("Bottom Left")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('bottom', 'center')}}},[_vm._v("Bottom Center")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){_vm.notifyVue('bottom', 'right')}}},[_vm._v("Bottom Right")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Notifications")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Custom Vue notifications plugin")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Notifications Style")]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('span',[_vm._v("This is a plain notification")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_vm._v("This is a notification with close button.")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info alert-with-icon"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',{staticClass:"ti-bell",attrs:{"data-notify":"icon"}}),_vm._v(" "),_c('span',{attrs:{"data-notify":"message"}},[_vm._v("This is a notification with close button and icon.")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info alert-with-icon"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',{staticClass:"ti-pie-chart",attrs:{"data-notify":"icon"}}),_vm._v(" "),_c('span',{attrs:{"data-notify":"message"}},[_vm._v("This is a notification with close button and icon and have many lines.\n            You can see that the icon and the close button are always vertically aligned.\n            This is a beautiful notification. So you don't have to worry about the style.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h5',[_vm._v("Notification states")]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Info - ")]),_vm._v(" This is a regular notification made with \".alert-info\"")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-success"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Success - ")]),_vm._v(" This is a regular notification made with \".alert-success\"")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-warning"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Warning - ")]),_vm._v(" This is a regular notification made with \".alert-warning\"")])]),_vm._v(" "),_c('div',{staticClass:"alert alert-danger"},[_c('button',{staticClass:"close",attrs:{"type":"button"}},[_vm._v("×")]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" Danger - ")]),_vm._v(" This is a regular notification made with \".alert-danger\"")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('h5',[_vm._v("Notifications Places\n            "),_c('p',{staticClass:"category"},[_vm._v("Click to view notifications")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9gNx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__ = __webpack_require__("rP9/");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88202afc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__ = __webpack_require__("KtLi");
function injectStyle (ssrContext) {
  __webpack_require__("ifSS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88202afc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "9prC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A+TP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-timeline card-plain"},[_c('div',{staticClass:"card-content"},[_c('ul',{staticClass:"timeline",class:{'timeline-simple': _vm.type === 'simple'}},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A988":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination",class:_vm.paginationClass},[_c('li',{staticClass:"page-item prev-page",class:{disabled: _vm.value === 1}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Previous"},on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fa fa-angle-double-left",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_vm._l((_vm.range(_vm.minPage, _vm.maxPage)),function(item){return _c('li',{staticClass:"page-item",class:{active: _vm.value === item}},[_c('a',{staticClass:"page-link",on:{"click":function($event){_vm.changePage(item)}}},[_vm._v(_vm._s(item))])])}),_vm._v(" "),_c('li',{staticClass:"page-pre next-page",class:{disabled: _vm.value === _vm.totalPages}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Next"},on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fa fa-angle-double-right",attrs:{"aria-hidden":"true"}})])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Alxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartFailure_vue__ = __webpack_require__("2VUe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08d5780e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartFailure_vue__ = __webpack_require__("hLkS");
function injectStyle (ssrContext) {
  __webpack_require__("i2fH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08d5780e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartFailure_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08d5780e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartFailure_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AuCi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BNE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__("aCDv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af926cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__("yNZB");
function injectStyle (ssrContext) {
  __webpack_require__("V5Z/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af926cc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BYD1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row buttons-with-margin"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('p-pagination',{attrs:{"page-count":10},model:{value:(_vm.defaultPagination),callback:function ($$v) {_vm.defaultPagination=$$v},expression:"defaultPagination"}}),_vm._v(" "),_c('p-pagination',{attrs:{"type":"info","page-count":10},model:{value:(_vm.infoPagination),callback:function ($$v) {_vm.infoPagination=$$v},expression:"infoPagination"}})],1)])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Colors")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-default btn-fill btn-wd"},[_vm._v("Default")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-fill btn-wd"},[_vm._v("Primary")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-wd"},[_vm._v("Info")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill btn-wd"},[_vm._v("Success")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning btn-fill btn-wd"},[_vm._v("Warning")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-fill btn-wd"},[_vm._v("Danger")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Styles")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-wd"},[_vm._v("Default")]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-wd"},[_vm._v("Fill")]),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-wd"},[_vm._v("Simple")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Buttons with Label and Animation")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-wd btn-success",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-check"})]),_vm._v("\n                Success\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-danger",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-times"})]),_vm._v("\n                Danger\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-info btn-fill btn-rotate",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-settings"})]),_vm._v("\n                Settings\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-warning btn-fill btn-magnify",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-search"})]),_vm._v("\n                Search\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-default btn-fill btn-move-left",attrs:{"type":"button"}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-angle-left"})]),_vm._v("\n                Back\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd btn-default btn-fill btn-move-right",attrs:{"type":"button"}},[_vm._v("\n                Next\n                "),_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"ti-angle-right"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Sizes")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-lg btn-fill"},[_vm._v("Large")]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill"},[_vm._v("Default")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-fill"},[_vm._v("Small")]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs btn-fill"},[_vm._v("X-Small")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Button Group")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Left")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Middle")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Right")])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("1")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("2")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("3")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("4")])]),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("5")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("6")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("7")])]),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("8")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Pagination")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Social buttons")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Default")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-twitter"},[_c('i',{staticClass:"ti-twitter-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-facebook"},[_c('i',{staticClass:"ti-facebook"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-google"},[_c('i',{staticClass:"ti-google"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-linkedin"},[_c('i',{staticClass:"ti-linkedin"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-pinterest"},[_c('i',{staticClass:"ti-pinterest"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-youtube"},[_c('i',{staticClass:"ti-youtube"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-tumblr"},[_c('i',{staticClass:"ti-tumblr"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-github"},[_c('i',{staticClass:"ti-github"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-dribbble"},[_c('i',{staticClass:"ti-dribbble"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-reddit"},[_c('i',{staticClass:"ti-reddit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-instagram"},[_c('i',{staticClass:"ti-instagram"})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Filled")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-twitter"},[_c('i',{staticClass:"ti-twitter-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-facebook"},[_c('i',{staticClass:"ti-facebook"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-google"},[_c('i',{staticClass:"ti-google"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-linkedin"},[_c('i',{staticClass:"ti-linkedin"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-pinterest"},[_c('i',{staticClass:"ti-pinterest"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-youtube"},[_c('i',{staticClass:"ti-youtube"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-tumblr"},[_c('i',{staticClass:"ti-tumblr"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-github"},[_c('i',{staticClass:"ti-github"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-dribbble"},[_c('i',{staticClass:"ti-dribbble"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-reddit"},[_c('i',{staticClass:"ti-reddit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-fill btn-instagram"},[_c('i',{staticClass:"ti-instagram"})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Simple")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-twitter"},[_c('i',{staticClass:"ti-twitter-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-facebook"},[_c('i',{staticClass:"ti-facebook"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-google"},[_c('i',{staticClass:"ti-google"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-linkedin"},[_c('i',{staticClass:"ti-linkedin"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-pinterest"},[_c('i',{staticClass:"ti-pinterest"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-youtube"},[_c('i',{staticClass:"ti-youtube"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-tumblr"},[_c('i',{staticClass:"ti-tumblr"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-github"},[_c('i',{staticClass:"ti-github"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-dribbble"},[_c('i',{staticClass:"ti-dribbble"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-reddit"},[_c('i',{staticClass:"ti-reddit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-instagram"},[_c('i',{staticClass:"ti-instagram"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bk+p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartsNodesStatus_vue__ = __webpack_require__("FXOA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_315c15e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartsNodesStatus_vue__ = __webpack_require__("Qr7H");
function injectStyle (ssrContext) {
  __webpack_require__("CkBE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartsNodesStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_315c15e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartsNodesStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Bmqj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Donut_vue__ = __webpack_require__("aput");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e392162_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Donut_vue__ = __webpack_require__("JdU4");
function injectStyle (ssrContext) {
  __webpack_require__("Z8Ar")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e392162"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Donut_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e392162_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Donut_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BsmD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'bookmark',
    props: {
        ids: Array },
    data: function data() {
        return {
            activeBtn: '',
            steps: true,
            stepsM: false,
            marginM: false,
            stepsMobile: true
        };
    },

    methods: {
        scroll: function scroll(element) {
            this.activeBtn = element;
            if (element) if (element == 'result' || element == 'reports') {
                element = 'collect';
            }

            document.querySelector('#' + element).scrollIntoView({ behavior: 'smooth' });
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['menu', 'getTab'])),
    watch: {
        menu: function menu(newValue) {
            if (this.menu.book > 30) {
                this.steps = false;
                this.stepsM = true;
                this.marginM = true;
            }
            if (this.menu.book < 29) {
                this.activeBtn = 'mapa';
                this.steps = true;
                this.stepsM = false;
                this.marginM = false;
            }

            if (this.getTab == 'offline') {
                if (this.menu.book >= 1441) {
                    this.activeBtn = 'collect';
                }
                if (this.menu.book >= 1914) {
                    this.activeBtn = 'planning';
                }
                if (this.menu.book >= 3195) {
                    this.activeBtn = 'defects';
                }
                if (this.menu.book >= 5809) {
                    this.activeBtn = 'execution';
                }
            }
            if (this.getTab == 'online') {
                if (this.menu.book >= 1326) {
                    this.activeBtn = 'collect';
                }
                if (this.menu.book >= 2939) {
                    this.activeBtn = 'result';
                }
                if (this.menu.book >= 3419) {
                    this.activeBtn = 'defectsOn';
                }
                if (this.menu.book >= 5530) {
                    this.activeBtn = 'planning';
                }
                if (this.menu.book >= 6843) {
                    this.activeBtn = 'execution';
                }
            }
        },
        getTab: function getTab() {}
    }
});

/***/ }),

/***/ "BxWU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C3ME":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartsSensorStatus_vue__ = __webpack_require__("Z0AX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55939b9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartsSensorStatus_vue__ = __webpack_require__("ZwUA");
function injectStyle (ssrContext) {
  __webpack_require__("vaG6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55939b9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartsSensorStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55939b9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartsSensorStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C4Ut":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CRWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_vm._m(0),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.task.title))]),_vm._v(" "),_c('td',{staticClass:"td-actions text-right"},[_c('div',{staticClass:"table-icons"},[_c('button',{staticClass:"btn btn-info btn-simple btn-xs",attrs:{"type":"button","rel":"tooltip","title":"Edit Task"},on:{"click":_vm.handleEditClick}},[_c('i',{staticClass:"ti-pencil-alt"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-simple btn-xs",attrs:{"type":"button","rel":"tooltip","title":"Remove"},on:{"click":_vm.handleDeleteClick}},[_c('i',{staticClass:"ti-close"})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('label',{staticClass:"checkbox"},[_c('input',{attrs:{"type":"checkbox","value":"","data-toggle":"checkbox"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CSNV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"help-tooltip"},[_c('div',{staticClass:"help-title"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"help-txt"},[_vm._v(_vm._s(_vm.titleChart))])]),_vm._v(" "),_c('div',{staticClass:"help-box"},[_vm._t("content")],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"help-icon"},[_c('i',{staticClass:"icon-help ti-help-alt"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CfDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('div',{attrs:{"id":"modal-container","tabindex":"0"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }_vm.showModal = false}}},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-dialog d-flex flex-column align-content-center",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"z-index":"10"}},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.title)+" - "+_vm._s(_vm.sensor_photo))]),_vm._v(" "),_c('button',{ref:"closer",staticClass:"close",attrs:{"type":"button","id":"close-button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.showModal = false}}},[_c('span',{staticClass:"ti-close"})])]),_vm._v(" "),_c('div',{staticClass:"modal-body overflow-auto",staticStyle:{"width":"100%","height":"73vh"}},[_c('div',{staticStyle:{"background-color":"#2a2a2e","padding":"20px","height":"100%"}},[_c('div',{staticClass:"d-flex justify-content-center align-content-middle",attrs:{"id":"spinner-loading"}},[_c('div',{staticClass:"loader"})]),_vm._v(" "),_c('img',{attrs:{"id":"sensor-img","src":_vm.link_photo,"width":"1013"}})])])])])])])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Chta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'donut',
  data: function data() {
    var _chartOptions;

    return {
      tableData: [],
      chartOptions: (_chartOptions = {
        chart: {
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          },
          plotBorderColor: '#606063'
        },
        title: {
          text: '',
          align: 'center',
          verticalAlign: 'middle',
          margin: -10,
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '16px !important',
            fontWeight: 'bold !important'
          }
        },
        subtitle: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase'
          }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        xAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        yAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        tooltip: {
          headerFormat: '',

          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },
        plotOptions: {
          pie: {
            size: '80%',
            depth: 65,
            borderWidth: 0,
            dataLabels: {
              distance: 1
            },

            cursor: 'pointer'
          },
          series: {
            innerSize: '50%',
            dataLabels: {
              enabled: true,
              format: '<span style="color: #fff">{point.name}: {point.percentage:.1f}%</span>',
              color: '#F0F0F3',
              style: {
                fontSize: '13px'
              }
            },
            events: {
              click: this.loadGrid
            }
          },
          boxplot: {
            fillColor: '#505053'
          },
          candlestick: {
            lineColor: 'white'
          },
          errorbar: {
            color: 'white'
          }
        },
        legend: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          itemStyle: {
            color: '#E0E0E3'
          },
          itemHoverStyle: {
            color: '#FFF'
          },
          itemHiddenStyle: {
            color: '#606063'
          },
          title: {
            style: {
              color: '#C0C0C0',
              fontSize: '12px;'
            }
          }
        },
        credits: {
          style: {
            color: '#666'
          }
        },
        labels: {
          style: {
            color: '#000'
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            color: '#F0F0F3'
          },
          activeDataLabelStyle: {
            color: '#F0F0F3'
          }
        },
        navigation: {
          buttonOptions: {
            symbolStroke: '#DDDDDD',
            theme: {
              fill: '#505053'
            }
          }
        },

        rangeSelector: {
          buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: {
              color: '#CCC'
            },
            states: {
              hover: {
                fill: '#707073',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              },
              select: {
                fill: '#000003',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              }
            }
          },
          inputBoxBorderColor: '#505053',
          inputStyle: {
            backgroundColor: '#333',
            color: 'silver'
          },
          labelStyle: {
            color: 'silver'
          }
        },
        navigator: {
          handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
          },
          outlineColor: '#CCC',
          maskFill: 'rgba(255,255,255,0.1)',
          series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
          },
          xAxis: {
            gridLineColor: '#505053'
          }
        },
        scrollbar: {
          barBackgroundColor: '#808083',
          barBorderColor: '#808083',
          buttonArrowColor: '#CCC',
          buttonBackgroundColor: '#606063',
          buttonBorderColor: '#606063',
          rifleColor: '#FFF',
          trackBackgroundColor: '#404043',
          trackBorderColor: '#404043'
        },
        series: [{
          name: this.$t("302"),
          colorByPoint: true,
          data: [{ name: this.$t("303"), y: this.data[0], color: '#90ed7d' }, { name: this.$t("304"), y: this.data[1], color: '#f45b5b' }]
        }],
        exporting: { enabled: false }
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'credits', {
        enabled: false
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'loading', {
        labelStyle: {
          color: 'black',
          textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
        },
        style: {
          backgroundColor: 'none',
          opacity: 1
        }
      }), _chartOptions)
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    loadGrid: function loadGrid(event) {

      var planta = this.filters.plant;
      var region = this.filters.region;

      var feedback = event.point.name;

      var delay = void 0;
      if (event.point.x == 0) {
        delay = 0;
      } else if (event.point.x == 1) {
        delay = 4;
      }

      var NAME_CHART = feedback.toUpperCase() + ' REPORTS';

      var ENDPOINT = 'v1/mysemeq-ambev/get-reports-repetition?year=' + this.filters.year + '&period=' + this.filters.period + '&plant=' + planta + '&region=' + region + '&technique=' + (this.online ? '' : this.filters.technique) + '&area=' + this.filters.area + '&sector=' + this.filters.sector + '&machine=' + this.filters.machine + '&component=' + this.filters.component + '&feedback_status=CLOSED&delay=' + delay + '&online=' + this.online;

      var grid = {
        totalDados: event.point.y,
        title: NAME_CHART,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
          "rows": '',
          "plant": this.$t("310"),
          "area": this.$t("311"),
          "sector": this.$t("312"),
          "component": this.$t("313"),
          "component_tag": this.$t("314"),
          "component_type_en": this.$t("315"),
          "machine": this.$t("316"),
          "machine_tag": this.$t("317"),
          "status_txt_en": this.$t("318"),
          "report_number": this.$t("319"),
          "approved_datetime": this.$t("320"),
          "technique_en": this.$t("321"),
          "ref_date": this.$t("322"),
          "delay": this.$t("326"),
          "feedback_status_en": this.$t("333"),
          "link": this.$t("323"),
          "link_rci": this.$t("324")
        },
        show: true,
        titleHelp: 'Grid - ' + this.$t("356"),
        txtHelp: this.$t("357")
      };

      if (this.filters.plant) {
        delete grid.columns['plant'];
        grid.title += ' - ' + this.filters.plant_name;
      } else if (this.filters.region) {
        grid.title += ' - ' + this.filters.region;
      } else {
        grid.title += ' - GLOBAL';
      }

      this.changeGrid(grid);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['changeGrid'])),
  props: {
    title: {
      type: String
    },
    data: {
      type: Array
    },
    filters: {
      type: Object
    },
    online: {
      type: Number,
      default: 0
    }
  },
  watch: {
    data: function data(value) {
      this.chartOptions.series[0].data[0].y = value[0];
      this.chartOptions.series[0].data[1].y = value[1];
    }
  }
});

/***/ }),

/***/ "CkBE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__ = __webpack_require__("HRUz");



var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize: function toggleMinimize() {
    document.body.classList.toggle('sidebar-mini');

    var simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);

    this.isMinimized = !this.isMinimized;
  }
};

var SidebarPlugin = {
  install: function install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
    Vue.component('sidebar-item', __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "CsB2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_auth__ = __webpack_require__("+4WN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



var _actions, _mutations;





var state = { token: localStorage.getItem('user-token') || '', status: '', hasLoadedOnce: false };

var getters = {
  isAuthenticated: function isAuthenticated(state) {
    return !!state.token;
  },
  authStatus: function authStatus(state) {
    return state.status;
  }
};

var API = "https://api.semeq.com.br/";
var ENDPOINT = 'auth';
var URL = API + ENDPOINT;

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_auth__["b" /* AUTH_REQUEST */], function (_ref, user) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    commit(__WEBPACK_IMPORTED_MODULE_2__actions_auth__["b" /* AUTH_REQUEST */]);

    __WEBPACK_IMPORTED_MODULE_3_axios___default()({ url: URL, data: user, method: 'POST' }).then(function (resp) {
      console.log(resp.data['access_token']);
      localStorage.setItem('user-token', resp.data['access_token']);
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'] = resp.data['access_token'];
      commit(__WEBPACK_IMPORTED_MODULE_2__actions_auth__["c" /* AUTH_SUCCESS */], resp);

      console.log(resp.token);
      resolve(resp);
    }).catch(function (err) {
      console.log('nao logou');
      commit(__WEBPACK_IMPORTED_MODULE_2__actions_auth__["d" /* AUTH_ERROR */], err);
      localStorage.removeItem('user-token');
      reject(err);
    });

    var log = localStorage.getItem('user-token');
    setTimeout(function () {
      if (log == null) {
        console.log('nao logou');
        reject(401);
      }
    }, 5000);
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_auth__["a" /* AUTH_LOGOUT */], function (_ref2) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    commit(__WEBPACK_IMPORTED_MODULE_2__actions_auth__["a" /* AUTH_LOGOUT */]);
    localStorage.removeItem('hash');
    localStorage.removeItem('user-token');
    delete __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'];
    resolve();
  });
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_auth__["b" /* AUTH_REQUEST */], function (state) {
  state.status = 'loading';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_auth__["c" /* AUTH_SUCCESS */], function (state, resp) {
  state.status = 'success';
  state.token = resp.token;
  state.hasLoadedOnce = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_auth__["d" /* AUTH_ERROR */], function (state) {
  state.status = 'error';
  state.hasLoadedOnce = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_auth__["a" /* AUTH_LOGOUT */], function (state) {
  state.token = '';
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "D/GA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DfKf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypeValidationForm_vue__ = __webpack_require__("+m/k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2f39b1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypeValidationForm_vue__ = __webpack_require__("lS3b");
function injectStyle (ssrContext) {
  __webpack_require__("psw9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TypeValidationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2f39b1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TypeValidationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DjVu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dte2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_LANG; });
var SET_LANG = 'SET_LANG';

/***/ }),

/***/ "E0D1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      user: {
        company: 'Paper Dashboard',
        username: 'michael23',
        email: '',
        lastName: 'Faker',
        address: 'Melbourne, Australia',
        city: 'melbourne',
        postalCode: '',
        aboutMe: 'Oh so, your weak rhyme. You doubt I\'ll bother, reading into it.I\'ll probably won\'t, left to my own devicesBut that\'s the difference in our opinions.'
      }
    };
  },

  methods: {
    updateProfile: function updateProfile() {
      alert('Your data: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.user));
    }
  }
});

/***/ }),

/***/ "E72B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
    gridOnline: {
        url: '',
        title: '',
        columns: {},
        show: false,
        export_csv: true,
        titleHelp: '',
        txtHelp: ''
    }
};

var getters = {
    gridOnline: function gridOnline(state) {
        return state.gridOnline;
    }
};

var mutations = {
    changeGridOnline: function changeGridOnline(state, payload) {
        state.gridOnline = payload;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations
});

/***/ }),

/***/ "ED2B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EEKh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportChart_vue__ = __webpack_require__("L+5Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_490789da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportChart_vue__ = __webpack_require__("Ss98");
function injectStyle (ssrContext) {
  __webpack_require__("1g3y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-490789da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_490789da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EKmn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('input',{attrs:{"type":"text","value":"","id":"v-step-0","placeholder":"Search..."}}),_vm._v(" "),_c('div',{staticClass:"v-step-1"},[_vm._v("A DOM element on your page. The second step will pop on this element because its ID is 'v-step-1'.")]),_vm._v(" "),_c('div',{attrs:{"data-v-step":"2"}},[_vm._v("A DOM element on your page. The third and final step will pop on this element because its ID is 'v-step-2'.")]),_vm._v(" "),_c('v-tour',{attrs:{"name":"myTour","steps":_vm.steps},scopedSlots:_vm._u([{key:"default",fn:function(tour){return [_c('transition',{attrs:{"name":"fade"}},_vm._l((tour.steps),function(step,index){return (tour.currentStep === index)?_c('v-step',{key:index,attrs:{"step":step,"previous-step":tour.previousStep,"next-step":tour.nextStep,"stop":tour.stop,"isFirst":tour.isFirst,"isLast":tour.isLast}},[(tour.currentStep === 0)?[_c('div',{attrs:{"slot":"actions"},slot:"actions"},[_c('div',{staticClass:"btn-fechar-help",on:{"click":tour.stop}},[_vm._v("x")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.nextStep}},[_vm._v("Próximo")])])]:_vm._e(),_vm._v(" "),(tour.currentStep === 1)?[_c('div',{attrs:{"slot":"actions"},slot:"actions"},[_c('div',{staticClass:"btn-fechar-help",on:{"click":tour.stop}},[_vm._v("x")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.previousStep}},[_vm._v("Passo Anterior")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.nextStep}},[_vm._v("Próximo")])])]:_vm._e(),_vm._v(" "),(tour.currentStep === 2)?[_c('div',{attrs:{"slot":"actions"},slot:"actions"},[_c('div',{staticClass:"btn-fechar-help",on:{"click":tour.stop}},[_vm._v("x")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.previousStep}},[_vm._v("Passo Anterior")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.nextStep}},[_vm._v("Próximo")])])]:_vm._e()],2):_vm._e()}))]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EYL6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row bookmark-box"},[_c('bookmark',{attrs:{"ids":_vm.stepIds}})],1),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{class:{ menutop: _vm.menutop},attrs:{"id":"mapa"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row box-container height-map"},[_c('div',{staticClass:"col-lg-12 col-sm-12 box-divided"},[_c('mapChart',{attrs:{"id":"'map'"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row box-container "},[_c('div',{staticClass:"col-lg-12 col-sm-12 box-divided"},[_c('ChartFailure')],1)]),_vm._v(" "),_c('div',{class:{ menutop: _vm.menutop},attrs:{"id":"collect"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row box"},[_c('div',{staticClass:"col-lg-4 col-sm-12 "},[_c('data-survey-chart',{attrs:{"title":"Data Survey","gridtxt":"Asset list data samples status.","data":_vm.general_report.coleta_chart,"filters":_vm.filters}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-sm-12 "},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('Popover',{attrs:{"name":"helpfailure","width":240}},[_c('Help',{attrs:{"titleChart":'Failure Alarm (Analysis)'}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("28")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help"},[_vm._v(_vm._s(_vm.$t("29"))+"\n          "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpfailure.right",arg:"helpfailure",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('report-chart',{attrs:{"title":"Failure Alarm (Analysis)","gridtxt":"Asset list analysed status.","data":_vm.general_report.result_chart,"filters":_vm.filters}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-sm-12 "},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('Popover',{attrs:{"name":"helpfailalarme","width":240}},[_c('Help',{attrs:{"titleChart":'Failure Alarm'}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("30")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help"},[_vm._v(_vm._s(_vm.$t("31"))+"\n          "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpfailalarme.bottom",arg:"helpfailalarme",modifiers:{"bottom":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('report-chart',{attrs:{"title":"Failure Alarm","gridtxt":"Asset list condition status.","data":_vm.general_report.laudo_chart,"filters":_vm.filters}})],1)]),_vm._v(" "),_c('div',{class:{ menutop: _vm.menutop},attrs:{"id":"planning"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row box"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('chartsReport'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.planned_rdps_data),function(item,key,index){return _c('div',{key:index,staticClass:"col-lg-2 col-sm-12",staticStyle:{"padding":"10px"}},[_c('Donut',{attrs:{"id":String(item.id),"title":item.name,"pendente":item.pendente,"programado":item.programado,"filters":_vm.filters}})],1)})),_vm._v(" "),_c('div',{staticClass:"row box-container"},[_c('div',{staticClass:"col-lg-12 col-sm-12 box-divided"},[_c('ChartBacklog',{attrs:{"online":false}})],1)])],1)]),_vm._v(" "),_c('div',{class:{ menutop: _vm.menutop},attrs:{"id":"defects"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row box"},[_c('div',{staticClass:"col-lg-12 col-sm-12 height-box"},[_c('chartsDefects')],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row box"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('Popover',{attrs:{"name":"repetition","width":240}},[_c('Help',{attrs:{"titleChart":'Recurrence Rate of Interventions'}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("32")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help"},[_vm._v(_vm._s(_vm.$t("33"))+"\n        "),_c('button',{directives:[{name:"popover",rawName:"v-popover:repetition.right",arg:"repetition",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_vm._l((_vm.repetition_data),function(item,key,index){return _c('div',{key:index,staticClass:"col-lg-5ths col-md-5ths col-sm-12",staticStyle:{"margin-top":"30px !important"}},[_c('ReincidenciaIndicator',{attrs:{"title":key,"content":item[0],"perc":item[1]}})],1)}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-sm-12 box-divided"},[_c('ChartReincidenciaPareto',{attrs:{"online":false}})],1)]),_vm._v(" "),_vm._l((_vm.repetition_chart_data),function(item){return _c('div',{key:item.id,staticClass:"col-lg-4 col-md-4 col-sm-12"},[_c('ReincidenciaChart',{attrs:{"title":item.title,"data":item.data,"plant":item.plant}})],1)})],2)]),_vm._v(" "),_c('div',{class:{ menutop: _vm.menutop},attrs:{"id":"execution"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row box"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('Popover',{attrs:{"name":"execution_deadline","width":240}},[_c('Help',{attrs:{"titleChart":'Execution'}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("34")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.$t("35"))+"\n        "),_c('button',{directives:[{name:"popover",rawName:"v-popover:execution_deadline.right",arg:"execution_deadline",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-6 col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('ReincidenciaIndicator',{attrs:{"delay":0,"title":"On Time","content":_vm.reports_execution_deadline.total[0],"color":"#90ed7d","font":"24px"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('ReincidenciaIndicator',{attrs:{"delay":1,"title":"1 to 15 days late","content":_vm.reports_execution_deadline.total[1],"color":"#f0893a","font":"24px"}})],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('ReincidenciaIndicator',{attrs:{"delay":2,"title":"15 to 30 days late","content":_vm.reports_execution_deadline.total[2],"color":"#f45b5b","font":"24px"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('ReincidenciaIndicator',{attrs:{"delay":3,"title":"> 30 days late","content":_vm.reports_execution_deadline.total[3],"color":"#f45b5b","font":"24px"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 col-sm-12"},[_c('DonutExecution',{attrs:{"title":"","data":[_vm.reports_execution_deadline.total_concluido, _vm.reports_execution_deadline.total_atrasado],"filters":_vm.filters}})],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('transition',{attrs:{"name":"show-from-left"}},[_c('Popover',{attrs:{"name":"execution_deadline_total","width":240}},[_c('Help',{attrs:{"titleChart":'Comparison Charts - On time | late'}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("36")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.$t("37"))+"\n        "),_c('button',{directives:[{name:"popover",rawName:"v-popover:execution_deadline_total.right",arg:"execution_deadline_total",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.reports_execution_deadline.details_total),function(item,index){return _c('div',{key:index,staticClass:"col-lg-4 col-md-4 col-sm-12"},[_c('ExecutionChartTotal',{attrs:{"title":item.name,"data":[item['onTime'], item['late']],"id":String(item.id),"filters":_vm.filters}})],1)})),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.$t("38"))+"\n        "),_c('button',{directives:[{name:"popover",rawName:"v-popover:execution_deadline_details.right",arg:"execution_deadline_details",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})]),_vm._v(" "),_c('transition',{attrs:{"name":"show-from-left"}},[_c('Popover',{attrs:{"name":"execution_deadline_details","width":240}},[_c('Help',{attrs:{"titleChart":'Comparison Charts by Period'}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("39")))])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.reports_execution_deadline.details),function(item,index){return _c('div',{key:index,staticClass:"col-lg-4 col-md-4 col-sm-12"},[_c('ExecutionChart',{attrs:{"title":item.name,"data":[item[0], item[1], item[2], item[3]],"id":String(item.id),"filters":_vm.filters}})],1)}))],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row box"},[_c('div',{staticClass:"col-lg-12 col-sm-12",attrs:{"id":"execution"}},[_c('ExecutionIndicators')],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('DescontinuationWarning')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Eark":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helphealthon","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChartMap}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMatriz),expression:"!showMatriz"}]},[_c('p',[_vm._v(_vm._s(_vm.$t("114")))]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t("115")))])]),_vm._v(" "),_c('div',{staticClass:"form_failure_rate col-lg-12 col-xs-12"},[_c('div',{staticClass:"col-lg-3 col-xs-3",staticStyle:{"padding-top":"5px"}},[_vm._v("\n                fr = \n                ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-9 col-xs-9"},[_c('div',{staticClass:"col-lg-12 col-xs-12",staticStyle:{"border-bottom":"1px solid #fff","text-align":"center"}},[_vm._v("\n                    (ni*1)+(na*0.5)\n                  ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-xs-12",staticStyle:{"text-align":"center"}},[_vm._v("\n                    nt\n                ")])])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("116"))+" "),_c('b',{staticStyle:{"color":"#68B3C8"}},[_vm._v("ni")]),_vm._v(" = "+_vm._s(_vm.$t("117"))+" "),_c('b',{staticStyle:{"color":"#68B3C8"}},[_vm._v("na")]),_vm._v(" = "+_vm._s(_vm.$t("118"))+" "),_c('b',{staticStyle:{"color":"#68B3C8"}},[_vm._v("nt")]),_vm._v(" = "+_vm._s(_vm.$t("119"))+"\n\n              ")]),_c('p',[_c('b',{staticStyle:{"color":"#68B3C8"}},[_vm._v(_vm._s(_vm.$t("120")))]),_vm._v(" "+_vm._s(_vm.$t("121"))+" "),_c('b',{staticStyle:{"color":"#68B3C8"}},[_vm._v(_vm._s(_vm.$t("122")))]),_vm._v(" "+_vm._s(_vm.$t("123")))])])])])],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpmatrix","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChartMap}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMatriz),expression:"showMatriz"}]},[_vm._v("\n              "+_vm._s(_vm.$t("124"))+"\n            ")])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help"},[_vm._v(_vm._s(_vm.name_chart)+"\n    "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMatriz),expression:"!showMatriz"},{name:"popover",rawName:"v-popover:helphealthon.right",arg:"helphealthon",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help"},[_vm._v(_vm._s(_vm.name_chart)+"\n    "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMatriz),expression:"showMatriz"},{name:"popover",rawName:"v-popover:helpmatrix.right",arg:"helpmatrix",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('div',{staticClass:"bt-change-charts"},[_c('toggle-button',{attrs:{"value":true,"width":60,"labels":{checked: 'On', unchecked: 'Off'}},on:{"change":function($event){_vm.btChangeStart()}},model:{value:(_vm.changeStart),callback:function ($$v) {_vm.changeStart=$$v},expression:"changeStart"}})],1),_vm._v(" "),_c('div',{staticClass:"space"},[_vm._v(" ")]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMatriz),expression:"!showMatriz"}],attrs:{"id":_vm.id},on:{"mouseover":_vm.mouseOver,"mouseleave":_vm.mouseleave}})]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMatriz),expression:"showMatriz"}],on:{"mouseover":_vm.mouseOver,"mouseleave":_vm.mouseleave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"actLoading"},[_vm._v("Loading ...")]),_vm._v(" "),_c('div',{staticClass:"matrix-box",domProps:{"innerHTML":_vm._s(_vm.boxMatriz)}})])]),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-sm",attrs:{"id":"buttons","role":"group","aria-label":"Buttons"}},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.getMatrizChart()}}},[_c('small',[_vm._v(_vm._s(_vm.btn_title))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F7nr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h4',[_c('small',[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FKFf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FQVD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-user"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"row"},_vm._l((_vm.details),function(info,index){return _c('div',{class:_vm.getClasses(index)},[_c('h5',[_vm._v(_vm._s(info.title)+"\n          "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(info.subTitle))])])])}))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image"},[_c('img',{attrs:{"src":"static/img/background.jpg","alt":"..."}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"author"},[_c('img',{staticClass:"avatar border-white",attrs:{"src":"static/img/faces/face-2.jpg","alt":"..."}}),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Chet Faker\n        "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('small',[_vm._v("@chetfaker")])])])]),_vm._v(" "),_c('p',{staticClass:"description text-center"},[_vm._v("\n      \"I like the way you work it\n      "),_c('br'),_vm._v(" No diggity\n      "),_c('br'),_vm._v(" I wanna bag it up\"\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FXAL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FXOA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");










__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_js_popover___default.a);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'charts',
  components: {
    Help: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_components_Help__["a" /* default */]
  },
  data: function data() {
    var _chartOptions;

    return {
      titleChart: this.$t("234"),
      tableData: [],
      chartOptions: (_chartOptions = {
        chart: {
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },
        title: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '16px',
            fontWeight: 'bold'
          }
        },
        subtitle: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase'
          }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        xAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        yAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },
        plotOptions: {
          pie: {
            borderWidth: 0,
            size: '80%',
            dataLabels: {
              distance: 1
            },
            depth: 55
          },
          series: {
            innerSize: '50%',
            dataLabels: {
              enabled: true,
              format: '<span style="color:#fff ">{point.name}:<br></span><span style="color:#fff "> {point.y}</span>',
              color: '#F0F0F3',
              style: {
                fontSize: '13px'
              }
            },
            marker: {
              lineColor: '#333'
            },
            events: {
              click: this.loadGrid
            },
            cursor: 'pointer'
          },
          boxplot: {
            fillColor: '#505053'
          },
          candlestick: {
            lineColor: 'white'
          },
          errorbar: {
            color: 'white'
          }
        },
        legend: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          itemStyle: {
            color: '#E0E0E3'
          },
          itemHoverStyle: {
            color: '#FFF'
          },
          itemHiddenStyle: {
            color: '#606063'
          },
          title: {
            style: {
              color: '#C0C0C0',
              fontSize: '12px'
            }
          }
        },
        credits: {
          style: {
            color: '#666'
          }
        },
        labels: {
          style: {
            color: '#707073'
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            color: '#F0F0F3'
          },
          activeDataLabelStyle: {
            color: '#F0F0F3'
          }
        },
        navigation: {
          buttonOptions: {
            symbolStroke: '#DDDDDD',
            theme: {
              fill: '#505053'
            }
          }
        },

        rangeSelector: {
          buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: {
              color: '#CCC'
            },
            states: {
              hover: {
                fill: '#707073',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              },
              select: {
                fill: '#000003',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              }
            }
          },
          inputBoxBorderColor: '#505053',
          inputStyle: {
            backgroundColor: '#333',
            color: 'silver'
          },
          labelStyle: {
            color: 'silver'
          }
        },
        navigator: {
          handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
          },
          outlineColor: '#CCC',
          maskFill: 'rgba(255,255,255,0.1)',
          series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
          },
          xAxis: {
            gridLineColor: '#505053'
          }
        },
        scrollbar: {
          barBackgroundColor: '#808083',
          barBorderColor: '#808083',
          buttonArrowColor: '#CCC',
          buttonBackgroundColor: '#606063',
          buttonBorderColor: '#606063',
          rifleColor: '#FFF',
          trackBackgroundColor: '#404043',
          trackBorderColor: '#404043'
        },
        series: [{
          name: "SAMPLES",
          colorByPoint: true,
          data: []
        }]
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'drilldown', {
        series: []
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'exporting', { enabled: false }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'credits', {
        enabled: false
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'loading', {
        labelStyle: {
          color: 'black',
          textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
        },
        style: {
          backgroundColor: 'none',
          opacity: 1
        }
      }), _chartOptions) };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__utils_mixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['changeGridOnline']), {
    loadGrid: function loadGrid(event) {
      var status = event.point.drilldown;

      var point_name = event.point.name;
      var NAME_CHART = this.$t("362") + ' - ' + point_name.toUpperCase();
      var ENDPOINT = 'v1/mysemeq-ambev/get-nodo-status-grid?corp=' + this.filtersOn.corp + '&region=' + this.filtersOn.region + '&planta=' + this.filtersOn.planta + '&status=' + status + '&area_f=' + this.filtersOn.area_f + '&sector_f=' + this.filtersOn.sector_f + '&machine=' + this.filtersOn.machine + '&subset=' + this.filtersOn.subset;

      var gridOnline = {
        title: event.point.name,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
          "area": [this.$t("311")],
          "setor": [this.$t("312")],
          "conj": [this.$t("316"), 'conjunto'],
          "conj_tag": [this.$t("317")],
          "equip": [this.$t("313")],
          "equip_tag": [this.$t("314")],
          "nodo": [this.$t("338")],
          "data": [this.$t("334")]
        },
        show: true,
        titleHelp: 'Grid - ' + this.$t("362"),
        txtHelp: this.$t("363")
      };

      if (!this.filtersOn.planta) {
        gridOnline.columns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ "rows": [''], 'planta': [this.$t("310"), 'planta_f'] }, gridOnline.columns);
      } else {
        gridOnline.columns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ "rows": [''] }, gridOnline.columns);
      }

      if (this.filtersOn.planta) {
        gridOnline.title += ' - ' + this.filtersOn.planta_name;
        delete gridOnline.columns['planta'];
      }

      this.changeGridOnline(gridOnline);
    },
    getData: function getData() {
      var API = "https://api.semeq.com.br/";

      var ENDPOINT = 'v1/mysemeq-ambev/get-nodo-status';
      var self = this;

      this.$refs.chart.chart.showLoading();

      __WEBPACK_IMPORTED_MODULE_4_axios___default()({ method: 'GET', url: API + ENDPOINT, params: this.filtersOn, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        self.tableData = resp.data.result;
        self.$refs.chart.chart.hideLoading();
      }).catch(function (err) {
        self.$refs.chart.chart.showLoading('Error');

        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    },
    setChartData: function setChartData() {
      var self = this;
      var res = self.tableData;
      var values = [];
      for (var key in res) {
        if (res[key].status == 1) {
          var color = '#90ed7d';
          var name = this.$t("242_2");
        }
        if (res[key].status == 0) {
          var color = '#f45b5b';
          var name = this.$t("242_3");
        }
        if (res[key].status == 2) {
          var color = '#6b91c9';
          var name = this.$t("242_4");
        }

        values.push({ 'name': name, 'y': res[key].total, 'drilldown': res[key].status, 'color': color });
      }
      self.chartOptions.series[0].data = values;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['filtersOn'])),
  watch: {
    filtersOn: function filtersOn(newValue) {
      this.getData();
    },
    tableData: function tableData() {
      this.setChartData();
    }
  }
});

/***/ }),

/***/ "FiZY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([]);

/***/ }),

/***/ "Fzxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpreincidencepareto","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("141")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.$t("141"))+"\n    "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpreincidencepareto.right",arg:"helpreincidencepareto",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G/W4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-login"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('notifications',{attrs:{"group":"alert"}},[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),_c('div',{staticClass:"box-form-login"},[_c('form',{staticClass:"login",on:{"submit":function($event){$event.preventDefault();return _vm.register($event)}}},[_c('div',{staticClass:"card",attrs:{"data-background":"color","data-color":"blue"}},[_c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$t("48")))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t("49")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control input-no-border",attrs:{"required":"","type":"text","disabled":"disabled"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t("50")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password_actual),expression:"password_actual"}],staticClass:"form-control input-no-border",attrs:{"required":"","type":"password"},domProps:{"value":(_vm.password_actual)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password_actual=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t("51")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password_new),expression:"password_new"}],staticClass:"form-control input-no-border",attrs:{"required":"","type":"password"},domProps:{"value":(_vm.password_new)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password_new=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t("52")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password_repeat_new),expression:"password_repeat_new"}],staticClass:"form-control input-no-border",attrs:{"required":"","type":"password"},domProps:{"value":(_vm.password_repeat_new)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password_repeat_new=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"card-fim text-center"},[_c('button',{staticClass:"btn btn-fill btn-wd ",attrs:{"type":"button"},on:{"click":function($event){_vm.register()}}},[_vm._v("OK")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px auto","text-align":"center"},on:{"click":_vm.logout}},[_c('router-link',{staticClass:"btn-magnify",attrs:{"to":"/admin/overview"}},[_c('i',{staticClass:"ti-power-off"}),_vm._v(" "+_vm._s(_vm.$t("logout"))+"\n              ")])],1)])])])],1),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._v("\n    Copyright © "+_vm._s(_vm.year)+" "),_c('a',{attrs:{"href":"http://www.semeq.com","target":"_blank"}},[_vm._v("SEMEQ")]),_c('br'),_vm._v("\n    All rights reserved\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-system"},[_c('img',{attrs:{"src":"static/img/logo-pb.png"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G5bo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G5h9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var Highcharts = __webpack_require__("504h");
__webpack_require__("mS+B")(Highcharts);
__webpack_require__("VVDx")(Highcharts);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'area-radar-chart',
    mounted: function mounted() {

        this.options.chart.polar = this.chartPolar;
        this.options.chart.type = this.chartType;
        this.chart = new Highcharts.chart(this.options);
    },

    watch: {
        data: function data(value) {

            this.options.chart.polar = this.chartPolar;
            this.options.chart.type = this.chartType;
            this.options.yAxis.title.text = this.titleY;
            this.chart = new Highcharts.chart(this.options);
            this.chart.series[0].setData(this.data, true);
            this.chart.xAxis[0].setCategories(this.categories);
        }
    },
    methods: {
        exporting: function exporting() {
            this.chart.exportChart();
        }
    },
    computed: {
        periodText: function periodText() {
            var period = this.filters.period;
            var year = this.filters.year;

            if (year != new Date().getFullYear() || !period) return year;

            if (period == 3 || period == 6) return period + 'm';
            if (period == 12) return '1Y';
            if (period == 'AC') return 'YTD';
        },
        chartPolar: function chartPolar() {
            if (this.data.length <= 3) {
                return false;
            } else {
                return true;
            }
        },
        chartType: function chartType() {
            if (this.data.length <= 3) {
                return 'column';
            } else {
                return 'area';
            }
        },
        titleY: function titleY() {
            if (this.data.length <= 3) {
                return '# Failures';
            } else {
                return '';
            }
        }
    },
    data: function data() {
        return {
            chart: undefined,
            options: {
                chart: {
                    renderTo: this.id,
                    polar: true,
                    type: 'area',
                    height: 450,
                    spacingBottom: 40,
                    spacingTop: 25,
                    spacingLeft: 20,
                    spacingRight: 20,
                    backgroundColor: 'rgba(0,0,0,0)'
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: this.categories,
                    tickmarkPlacement: 'on',
                    lineWidth: 0,
                    labels: {
                        style: {
                            fontSize: '9px',
                            color: '#E0E0E3'
                        },
                        distance: 20,
                        padding: 0,
                        overflow: 'allow'
                    },
                    gridLineColor: '#707073'
                },
                pane: {},
                yAxis: {
                    gridLineInterpolation: 'polygon',
                    lineWidth: 0,
                    min: 0,
                    endOnTick: false,
                    tickInterval: 1,
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: '',
                        style: {
                            color: '#E0E0E3'
                        }
                    }
                },
                navigation: {
                    buttonOptions: {
                        enabled: false
                    }
                },
                tooltip: {
                    shared: true,
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    }
                },
                legend: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                plotOptions: {

                    series: {
                        dataLabels: {
                            enabled: true,
                            color: '#F0F0F3',
                            style: {
                                fontSize: '10px'
                            }
                        },

                        fillColor: "rgba(107, 145, 201, 0.2)",
                        strokeColor: "rgba(151,187,205,1)",
                        pointColor: "rgba(151,187,205,1)",
                        pointStrokeColor: "#fff",
                        pointHighlightFill: "#fff",
                        pointHighlightStroke: "rgba(151,187,205,1)",
                        marker: {
                            fillColor: '#FFFFFF',
                            lineWidth: 2,
                            radius: 3,
                            lineColor: null }
                    }
                },
                series: [{
                    name: 'Total',
                    data: this.data,
                    color: '#6b91c9'
                }],
                labels: {
                    style: {
                        color: '#707073'
                    }
                }
            }
        };
    },

    props: {
        data: {
            type: Array
        },
        categories: {
            type: Array
        },
        id: {
            type: String
        },
        header: {
            type: String
        },
        filters: {
            type: Object
        }
    }
});

/***/ }),

/***/ "G8LV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs__);




__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeName: 'first'
    };
  }
});

/***/ }),

/***/ "GGES":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TIPO_REQUEST; });
/* unused harmony export TIPO_REQUEST_COMBO */
/* unused harmony export TIPO_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TIPO_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TIPO_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TIPO_DELETE; });
var TIPO_REQUEST = 'TIPO_REQUEST';
var TIPO_REQUEST_COMBO = 'TIPO_REQUEST_COMBO';
var TIPO_ERROR = 'TIPO_ERROR';
var TIPO_CREATE = 'TIPO_CREATE';
var TIPO_UPDATE = 'TIPO_UPDATE';
var TIPO_DELETE = 'TIPO_DELETE';

/***/ }),

/***/ "GJqE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"radio","disabled":_vm.disabled},domProps:{"value":_vm.label,"checked":_vm._q(_vm.model,_vm.label)},on:{"change":function($event){_vm.model=_vm.label}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GXEp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GaK2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Language_vue__ = __webpack_require__("n5Ws");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba646f4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Language_vue__ = __webpack_require__("eHlE");
function injectStyle (ssrContext) {
  __webpack_require__("Kjuj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Language_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba646f4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Language_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gm+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");









__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default.a);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'charts',
    components: {
        Help: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__["a" /* default */]
    },
    data: function data() {
        return {
            titleChart: this.$t("236"),
            tableData: [],
            type: 'line',
            chartOptions: {
                colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8', '#dd6b7f', '#0984e3', '#ffeaa7', '#e84393', '#55efc4', '#636e72', '#ff7675', '#f1c40f', '#34495e'],
                chart: {
                    type: 'line',
                    backgroundColor: 'rgba(0,0,0,0)',
                    style: {
                        fontFamily: '\'Unica One\', sans-serif'
                    },
                    plotBorderColor: '#606063'
                },
                title: {
                    text: '',
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase',
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }
                },
                subtitle: {
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase'
                    }
                },
                xAxis: {
                    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    crosshair: true,
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    title: {
                        style: {
                            color: '#A0A0A3'
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: this.$t("131"),
                        style: {
                            color: '#A0A0A3',
                            fontSize: '12px'
                        }
                    },
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    tickWidth: 1
                },
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    },
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y} </b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true,
                            color: '#F0F0F3',
                            style: {
                                fontSize: '13px'
                            }
                        },
                        marker: {
                            lineColor: '#333'
                        },
                        events: {
                            click: this.loadGrid
                        },
                        cursor: 'pointer'
                    },
                    boxplot: {
                        fillColor: '#505053'
                    },
                    candlestick: {
                        lineColor: 'white'
                    },
                    errorbar: {
                        color: 'white'
                    },
                    column: {
                        pointPadding: 0.1,
                        borderWidth: 0
                    }
                },
                legend: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    itemStyle: {
                        color: '#E0E0E3'
                    },
                    itemHoverStyle: {
                        color: '#FFF'
                    },
                    itemHiddenStyle: {
                        color: '#606063'
                    },
                    title: {
                        style: {
                            color: '#C0C0C0',
                            fontSize: '12px'
                        }
                    }
                },
                labels: {
                    style: {
                        color: '#707073'
                    }
                },
                drilldown: {
                    activeAxisLabelStyle: {
                        color: '#F0F0F3'
                    },
                    activeDataLabelStyle: {
                        color: '#F0F0F3'
                    }
                },
                navigation: {
                    buttonOptions: {
                        symbolStroke: '#DDDDDD',
                        theme: {
                            fill: '#505053'
                        }
                    }
                },

                rangeSelector: {
                    buttonTheme: {
                        fill: '#505053',
                        stroke: '#000000',
                        style: {
                            color: '#CCC'
                        },
                        states: {
                            hover: {
                                fill: '#707073',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            },
                            select: {
                                fill: '#000003',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    },
                    inputBoxBorderColor: '#505053',
                    inputStyle: {
                        backgroundColor: '#333',
                        color: 'silver'
                    },
                    labelStyle: {
                        color: 'silver'
                    }
                },
                navigator: {
                    handles: {
                        backgroundColor: '#666',
                        borderColor: '#AAA'
                    },
                    outlineColor: '#CCC',
                    maskFill: 'rgba(255,255,255,0.1)',
                    series: {
                        color: '#7798BF',
                        lineColor: '#A6C7ED'
                    },
                    xAxis: {
                        gridLineColor: '#505053'
                    }
                },
                scrollbar: {
                    barBackgroundColor: '#808083',
                    barBorderColor: '#808083',
                    buttonArrowColor: '#CCC',
                    buttonBackgroundColor: '#606063',
                    buttonBorderColor: '#606063',
                    rifleColor: '#FFF',
                    trackBackgroundColor: '#404043',
                    trackBorderColor: '#404043'
                },
                series: [{
                    name: this.$t("153_1"),
                    color: '#E4D354',
                    data: []

                }, {
                    name: this.$t("153_2"),
                    color: '#90ED7D',
                    data: []

                }, {
                    name: this.$t("153_3"),
                    color: '#F45B5B',
                    data: []

                }],
                exporting: { enabled: false },
                credits: {
                    enabled: false
                },
                loading: {
                    labelStyle: {
                        color: 'black',
                        textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
                    },
                    style: {
                        backgroundColor: 'none',
                        opacity: 1
                    }
                }

            } };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4__utils_mixin__["a" /* default */]],
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['changeGrid']), {
        loadGrid: function loadGrid(event) {

            var evento = event.point.series.name;
            var filtro = '';
            if (evento == 'Planejamento') {
                filtro = 'Planning';
            }
            if (evento == 'Fechado') {
                filtro = 'Closed';
            }
            if (evento == 'Pendente') {
                filtro = 'Pending';
            }
            var filter = !filtro ? event.point.series.name : filtro;

            var status = filter;

            var date = event.point.category;
            var point_name = event.point.series.name;
            var NAME_CHART = this.$t("350") + ' - ' + point_name.toUpperCase();

            var ENDPOINT = 'v1/mysemeq-ambev/get-reports?plant=' + this.filtersOn.planta + '&region=' + this.filtersOn.region + '&status=' + status + '&year=' + date + '&area=' + this.filtersOn.area_f + '&sector=' + this.filtersOn.sector_f + '&machine=' + this.filtersOn.machine + '&component=' + this.filtersOn.subset + '&online=1';

            var grid = {
                totalDados: event.point.y,
                title: status,
                url: ENDPOINT,
                name_chart: NAME_CHART,
                columns: {
                    "rows": '',
                    "plant": this.$t("310"),
                    "area": this.$t("311"),
                    "sector": this.$t("312"),
                    "component": this.$t("313"),
                    "component_tag": this.$t("314"),
                    "component_type_en": this.$t("315"),
                    "machine": this.$t("316"),
                    "machine_tag": this.$t("317"),
                    "technique_en": this.$t("321"),
                    "report_number": this.$t("319"),
                    "approved_datetime": this.$t("320"),
                    "link": this.$t("323"),
                    "link_rci": this.$t("324"),
                    "pending_days": this.$t("325"),
                    "delay": this.$t("326"),
                    "prescription_created_datePtime": this.$t("327"),
                    "week": this.$t("328"),
                    "currency": this.$t("329"),
                    "downtime": this.$t("330"),
                    "sec_damage": this.$t("331"),
                    "work_avoided": this.$t("332")
                },
                show: true,
                titleHelp: 'Grid - ' + this.$t("350"),
                txtHelp: this.$t("351")
            };

            if (this.filtersOn.plant) {
                grid.title += ' - ' + this.filtersOn.plant_name;
                delete grid.columns['plant'];
            } else if (this.filtersOn.region) {
                grid.title += ' - ' + this.filtersOn.region;
            }

            this.changeGrid(grid);
        },
        getData: function getData() {

            if (this.filtersOn.area || this.filtersOn.sector || this.filtersOn.machine || this.filtersOn.component) {
                var API = "https://api.semeq.com.br/";
                var ENDPOINT = 'v1/mysemeq-ambev/get-reports-chart-filter';

                var self = this;

                this.$refs.chart.chart.showLoading();

                var filters = {
                    'plant': this.filtersOn.planta,
                    'year': this.filtersOn.year,
                    'period': this.filtersOn.period,
                    'region': this.filtersOn.region,
                    'area': this.filtersOn.area_f,
                    'sector': this.filtersOn.sector_f,
                    'machine': this.filtersOn.machine,
                    'component': this.filtersOn.subset,
                    'online': 1
                };

                __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ENDPOINT, params: filters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
                    self.tableData = resp.data;
                    self.$refs.chart.chart.hideLoading();
                }).catch(function (err) {
                    self.ApiErrorHandler(self, error.response.data.status_code);
                    self.$refs.chart.chart.showLoading('Error');
                });
            } else {

                var _API = "https://api.semeq.com.br/";
                var _ENDPOINT = 'v1/mysemeq-ambev/get-reports-chart';
                var _self = this;

                this.$refs.chart.chart.showLoading();

                var _filters = {
                    'plant': this.filtersOn.planta,
                    'year': this.filtersOn.year,
                    'period': this.filtersOn.period,
                    'region': this.filtersOn.region,
                    'area': this.filtersOn.area_f,
                    'sector': this.filtersOn.sector_f,
                    'machine': this.filtersOn.machine,
                    'component': this.filtersOn.subset,
                    'online': 1
                };

                __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: _API + _ENDPOINT, params: _filters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
                    _self.tableData = resp.data;
                    _self.$refs.chart.chart.hideLoading();
                }).catch(function (err) {
                    _self.ApiErrorHandler(_self, error.response.data.status_code);
                    _self.$refs.chart.chart.showLoading('Error');
                });
            }
        },
        setChartData: function setChartData() {
            var self = this;
            var res = self.tableData;

            self.chartOptions.xAxis.categories = [];
            self.chartOptions.series[0].data = [];
            self.chartOptions.series[1].data = [];
            self.chartOptions.series[2].data = [];
            if (res) {
                res.forEach(function (it) {
                    self.chartOptions.xAxis.categories.push(it.ref_date);
                    self.chartOptions.series[0].data.push(it.new);
                    self.chartOptions.series[1].data.push(it.feedback);
                    self.chartOptions.series[2].data.push(it.pending);
                });
            }
        },
        changeTypeChartLine: function changeTypeChartLine() {
            var self = this;
            self.chartOptions.chart.type = 'line';
        },
        changeTypeChartColumn: function changeTypeChartColumn() {
            var self = this;
            self.chartOptions.chart.type = 'column';
        }
    }),
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filtersOn'])),
    watch: {
        filtersOn: function filtersOn(newValue) {
            this.getData();
        },
        tableData: function tableData() {
            this.setChartData();
        }
    }
});

/***/ }),

/***/ "H0v/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H2oj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('h4',{staticClass:"card-title"},[_vm._v("Sweet Alert 2")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"places-sweet-alerts"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("Basic example")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showSwal('basic')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("A title with a text under")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showSwal('title-and-text')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("A success message")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showSwal('success-message')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("Custom HTML description")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showSwal('custom-html')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("A warning message, with a function attached to the \"Confirm\" Button...")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showSwal('warning-message-and-confirmation')}}},[_vm._v("\n              Try me!\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("...and by passing a parameter, you can execute something else for \"Cancel\"")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showSwal('warning-message-and-cancel')}}},[_vm._v("Try me!\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("A message with auto close timer set to 2 seconds")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showSwal('auto-close')}}},[_vm._v("Try me!")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('h5',[_vm._v("Modal window with input field")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill",on:{"click":function($event){_vm.showSwal('input-field')}}},[_vm._v("Try me!")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"category"},[_vm._v("A beautiful plugin, that replace the classic alert, Handcrafted by our friend "),_c('a',{attrs:{"target":"_blank","href":"https://twitter.com/t4t5"}},[_vm._v("Tristan Edwards")]),_vm._v(". Please check out the "),_c('a',{attrs:{"href":"http://limonte.github.io/sweetalert2/","target":"_blank"}},[_vm._v("full documentation.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HHnu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    type: {
      type: String,
      default: ''
    }
  }
});

/***/ }),

/***/ "HRUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__("zwtn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_534e4860_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__("vaZU");
function injectStyle (ssrContext) {
  __webpack_require__("OGQL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_534e4860_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HkQq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartsStatus_vue__ = __webpack_require__("kFEL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56e771a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartsStatus_vue__ = __webpack_require__("bTCR");
function injectStyle (ssrContext) {
  __webpack_require__("ifvD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56e771a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartsStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56e771a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartsStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hozw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('ul',{staticClass:" menu-grande",class:{ steps: _vm.steps, stepsM: _vm.stepsM}},[_c('li',{staticClass:"step1",class:{active: _vm.activeBtn === 'collect' ||  _vm.activeBtn === 'collectOn'}},[_c('a',{attrs:{"href":"","title":""},on:{"click":function($event){$event.preventDefault();_vm.scroll(_vm.ids[0])}}},[_c('em',[_vm._v(_vm._s(_vm.$t("107")))]),_c('span')])]),_vm._v(" "),_c('li',{staticClass:"step2",class:{active: _vm.activeBtn === 'reports' ||  _vm.activeBtn === 'result' }},[_c('a',{attrs:{"href":"","title":""},on:{"click":function($event){$event.preventDefault();_vm.scroll(_vm.ids[1])}}},[_c('em',{class:{ marginM: _vm.marginM}},[_vm._v(_vm._s(_vm.$t("108")))]),_c('span')])]),_vm._v(" "),_c('li',{staticClass:"step3",class:{active: _vm.activeBtn === 'defects' ||  _vm.activeBtn === 'defectsOn' }},[_c('a',{attrs:{"href":"","title":""},on:{"click":function($event){$event.preventDefault();_vm.scroll(_vm.ids[2])}}},[_c('em',[_vm._v(_vm._s(_vm.$t("109")))]),_c('span')])]),_vm._v(" "),_c('li',{staticClass:"step4",class:{active: _vm.activeBtn === 'root' }},[_c('a',{attrs:{"href":"","title":""},on:{"click":function($event){$event.preventDefault();_vm.scroll(_vm.ids[3])}}},[_c('em',{class:{ marginM: _vm.marginM}},[_vm._v(_vm._s(_vm.$t("110")))]),_c('span')])]),_vm._v(" "),_c('li',{staticClass:"step5",class:{active: _vm.activeBtn === 'planning' }},[_c('a',{attrs:{"href":"","title":""},on:{"click":function($event){$event.preventDefault();_vm.scroll(_vm.ids[4])}}},[_c('em',[_vm._v(_vm._s(_vm.$t("111")))]),_c('span')])]),_vm._v(" "),_c('li',{staticClass:"step6",class:{active: _vm.activeBtn === 'execution' }},[_c('a',{attrs:{"href":"","title":""},on:{"click":function($event){$event.preventDefault();_vm.scroll(_vm.ids[5])}}},[_c('em',[_vm._v(_vm._s(_vm.$t("112")))]),_c('span')])]),_vm._v(" "),_c('li',{staticClass:"step7",class:{active: _vm.activeBtn === 'mapa'}},[_c('a',{attrs:{"href":"","title":""},on:{"click":function($event){$event.preventDefault();_vm.scroll(_vm.ids[6])}}},[_c('em',[_vm._v(_vm._s(_vm.$t("113")))]),_c('span')])])]),_vm._v(" "),_c('ul',{staticClass:"menu-pequeno",class:{ stepsMobile: _vm.stepsMobile}},[_c('li',{staticClass:"step1",class:{active: _vm.activeBtn === 'collect' ||  _vm.activeBtn === 'collectOn'}},[_c('a',{attrs:{"href":"","title":""},on:{"click":function($event){$event.preventDefault();_vm.scroll(_vm.ids[0])}}},[_c('em',[_vm._v(_vm._s(_vm.$t("107")))]),_c('span')])]),_vm._v(" "),_c('li',{staticClass:"step2",class:{active: _vm.activeBtn === 'reports' ||  _vm.activeBtn === 'result' }},[_c('a',{attrs:{"href":"","title":""},on:{"click":function($event){$event.preventDefault();_vm.scroll(_vm.ids[1])}}},[_c('em',{class:{ marginM: _vm.marginM}},[_vm._v(_vm._s(_vm.$t("108")))]),_c('span')])]),_vm._v(" "),_c('li',{staticClass:"step3",class:{active: _vm.activeBtn === 'defects' ||  _vm.activeBtn === 'defectsOn' }},[_c('a',{attrs:{"href":"","title":""},on:{"click":function($event){$event.preventDefault();_vm.scroll(_vm.ids[2])}}},[_c('em',[_vm._v(_vm._s(_vm.$t("109")))]),_c('span')])]),_vm._v(" "),_c('li',{staticClass:"step4",class:{active: _vm.activeBtn === 'root' }},[_c('a',{attrs:{"href":"","title":""},on:{"click":function($event){$event.preventDefault();_vm.scroll(_vm.ids[3])}}},[_c('em',{class:{ marginM: _vm.marginM}},[_vm._v(_vm._s(_vm.$t("110")))]),_c('span')])]),_vm._v(" "),_c('li',{staticClass:"step5",class:{active: _vm.activeBtn === 'planning' }},[_c('a',{attrs:{"href":"","title":""},on:{"click":function($event){$event.preventDefault();_vm.scroll(_vm.ids[4])}}},[_c('em',[_vm._v(_vm._s(_vm.$t("111")))]),_c('span')])]),_vm._v(" "),_c('li',{staticClass:"step6",class:{active: _vm.activeBtn === 'execution' }},[_c('a',{attrs:{"href":"","title":""},on:{"click":function($event){$event.preventDefault();_vm.scroll(_vm.ids[5])}}},[_c('em',[_vm._v(_vm._s(_vm.$t("112")))]),_c('span')])]),_vm._v(" "),_c('li',{staticClass:"step7",class:{active: _vm.activeBtn === 'mapa'}},[_c('a',{attrs:{"href":"","title":""},on:{"click":function($event){$event.preventDefault();_vm.scroll(_vm.ids[6])}}},[_c('em',[_vm._v(_vm._s(_vm.$t("113")))]),_c('span')])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hyh/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div'),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-collapse',[_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"1"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"2"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"3"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card card-plain"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-collapse',[_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"1"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"2"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Default Collapsible Item 1","name":"3"}},[_c('div',[_vm._v("\n                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.\n              ")])])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('vue-tabs',{staticClass:"row",attrs:{"direction":"vertical","value":"Description"}},[_c('v-tab',{attrs:{"title":"Info"}},[_c('p',[_vm._v("\n              Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.")]),_vm._v(" "),_c('p',[_vm._v("\n                It’s one continuous form where hardware and software function in perfect unison, creating a new generation of phone that’s better by any measure.")])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Description"}},[_c('p',[_vm._v("\n                The first thing you notice when you hold the phone is how great it feels in your hand. The cover glass curves down around the sides to meet the anodized aluminum enclosure in a remarkable, simplified design.")]),_vm._v(" "),_c('p',[_vm._v("\n                There are no distinct edges. No gaps. Just a smooth, seamless bond of metal and glass that feels like one continuous surface.")])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Messages"}},[_c('p',[_vm._v("\n                It’s one continuous form where hardware and software function in perfect unison, creating a new generation of phone that’s better by any measure.")]),_vm._v(" "),_c('p',[_vm._v("\n                Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.")])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Support"}},[_c('p',[_vm._v("\n                From the seamless transition of glass and metal to the streamlined profile, every detail was carefully considered to enhance your experience. So while its display is larger, the phone feels just right.")]),_vm._v("\n              It’s one continuous form where hardware and software function in perfect unison, creating a new generation of phone that’s better by any measure.\n            ")]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Extra"}},[_vm._v("\n              Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.\n              It’s one continuous form where hardware and software function in perfect unison, creating a new generation of phone that’s better by any measure.\n            ")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(3),_vm._v(" "),_c('vue-tabs',{staticClass:"card-content"},[_c('v-tab',{attrs:{"title":"Home"}},[_vm._v("\n            Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.\n          ")]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Profile"}},[_vm._v("Here is your profile.")]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Messages"}},[_vm._v("Here are your messages.")])],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Collapsible Accordion")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Bootstrap default style")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Collapsible Accordion on Plain Card")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Bootstrap default style")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tabs")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Vertical tabs")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tabs")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Plain text tabs")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I4nB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IMIu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Area_radar_chart_vue__ = __webpack_require__("G5h9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01de51e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Area_radar_chart_vue__ = __webpack_require__("MCxG");
function injectStyle (ssrContext) {
  __webpack_require__("jaXH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01de51e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Area_radar_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01de51e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Area_radar_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IWrx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IZSz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tour_vue__ = __webpack_require__("WSd6");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_239d991c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tour_vue__ = __webpack_require__("EKmn");
function injectStyle (ssrContext) {
  __webpack_require__("rReu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tour_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_239d991c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tour_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "IcX6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartsSkipped_vue__ = __webpack_require__("jWLd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dc8af39_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartsSkipped_vue__ = __webpack_require__("u2UF");
function injectStyle (ssrContext) {
  __webpack_require__("3lJU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4dc8af39"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartsSkipped_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dc8af39_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartsSkipped_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_user__ = __webpack_require__("bREw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_auth__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_chartsOnline__ = __webpack_require__("smvr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_filters__ = __webpack_require__("zAUI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_filtersOn__ = __webpack_require__("hqBF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_grid__ = __webpack_require__("/ZJH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_gridOnline__ = __webpack_require__("E72B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_modal_rdp__ = __webpack_require__("bnyp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_modal_photo__ = __webpack_require__("MW3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_menu__ = __webpack_require__("egBL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mutations__ = __webpack_require__("ukYY");













__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_12__mutations__["a" /* state */],
  mutations: __WEBPACK_IMPORTED_MODULE_12__mutations__["b" /* mutations */],
  actions: __WEBPACK_IMPORTED_MODULE_12__mutations__["c" /* actions */],
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__modules_user__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_3__modules_auth__["a" /* default */],
    grid: __WEBPACK_IMPORTED_MODULE_7__modules_grid__["a" /* default */],
    gridOnline: __WEBPACK_IMPORTED_MODULE_8__modules_gridOnline__["a" /* default */],
    filters: __WEBPACK_IMPORTED_MODULE_5__modules_filters__["a" /* default */],
    filtersOn: __WEBPACK_IMPORTED_MODULE_6__modules_filtersOn__["a" /* default */],
    chartsOnline: __WEBPACK_IMPORTED_MODULE_4__modules_chartsOnline__["a" /* default */],
    modal_rdp: __WEBPACK_IMPORTED_MODULE_9__modules_modal_rdp__["a" /* default */],
    modal_photo: __WEBPACK_IMPORTED_MODULE_10__modules_modal_photo__["a" /* default */],
    menu: __WEBPACK_IMPORTED_MODULE_11__modules_menu__["a" /* default */]
  },
  strict: debug
}));

/***/ }),

/***/ "IsOm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iv/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Csv_vue__ = __webpack_require__("9Dxv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c64657f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Csv_vue__ = __webpack_require__("12dW");
function injectStyle (ssrContext) {
  __webpack_require__("0N4a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c64657f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Csv_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c64657f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Csv_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J0Sr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J8BY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  'id': 1,
  'name': 'Noelia O\'Kon',
  'nickname': 'asperiores',
  'email': 'otho.smitham@example.com',
  'salary': '13098.00',
  'age': 39
}, {
  'id': 1,
  'name': 'Noelia O\'Kon',
  'nickname': 'asperiores',
  'email': 'otho.smitham@example.com',
  'salary': '13098.00',
  'age': 39
}, {
  'id': 1,
  'name': 'Noelia O\'Kon',
  'nickname': 'asperiores',
  'email': 'otho.smitham@example.com',
  'salary': '13098.00',
  'age': 39
}, {
  'id': 1,
  'name': 'Noelia O\'Kon',
  'nickname': 'asperiores',
  'email': 'otho.smitham@example.com',
  'salary': '13098.00',
  'age': 39
}, {
  'id': 1,
  'name': 'Noelia O\'Kon',
  'nickname': 'asperiores',
  'email': 'otho.smitham@example.com',
  'salary': '13098.00',
  'age': 39
}, {
  'id': 1,
  'name': 'Noelia O\'Kon',
  'nickname': 'asperiores',
  'email': 'otho.smitham@example.com',
  'salary': '13098.00',
  'age': 39
}, {
  'id': 1,
  'name': 'Noelia O\'Kon',
  'nickname': 'asperiores',
  'email': 'otho.smitham@example.com',
  'salary': '13098.00',
  'age': 39
}, {
  'id': 1,
  'name': 'Noelia O\'Kon',
  'nickname': 'asperiores',
  'email': 'otho.smitham@example.com',
  'salary': '13098.00',
  'age': 39
}, {
  'id': 1,
  'name': 'Noelia O\'Kon',
  'nickname': 'asperiores',
  'email': 'otho.smitham@example.com',
  'salary': '13098.00',
  'age': 39
}, {
  'id': 2,
  'name': 'Mr. Enid Von PhD',
  'nickname': 'alias',
  'email': 'pollich.cecilia@example.com',
  'salary': '35978.00',
  'age': 26
}, {
  'id': 3,
  'name': 'Colton Koch',
  'nickname': 'id',
  'email': 'little.myrna@example.net',
  'salary': '26278.00',
  'age': 48
}, {
  'id': 4,
  'name': 'Gregory Vandervort',
  'nickname': 'vel',
  'email': 'dock47@example.org',
  'salary': '25537.00',
  'age': 27
}, {
  'id': 5,
  'name': 'Miss Rahsaan Heaney IV',
  'nickname': 'qui',
  'email': 'ugrady@example.org',
  'salary': '49003.00',
  'age': 21
}, {
  'id': 6,
  'name': 'Ms. Crystel Zemlak IV',
  'nickname': 'reiciendis',
  'email': 'amari.rau@example.com',
  'salary': '12383.00',
  'age': 48
}, {
  'id': 7,
  'name': 'Nona McDermott',
  'nickname': 'quaerat',
  'email': 'adrien.baumbach@example.org',
  'salary': '18512.00',
  'age': 31
}, {
  'id': 8,
  'name': 'Miss Genoveva Murazik V',
  'nickname': 'rerum',
  'email': 'ohettinger@example.net',
  'salary': '31209.00',
  'age': 28
}, {
  'id': 9,
  'name': 'Beulah Huels',
  'nickname': 'non',
  'email': 'stefan99@example.com',
  'salary': '36920.00',
  'age': 53
}, {
  'id': 10,
  'name': 'Zoe Klein',
  'nickname': 'ex',
  'email': 'ejacobson@example.org',
  'salary': '35616.00',
  'age': 27
}, {
  'id': 11,
  'name': 'Vickie Kiehn',
  'nickname': 'assumenda',
  'email': 'ayost@example.com',
  'salary': '30790.00',
  'age': 29
}, {
  'id': 12,
  'name': 'Elwyn Herzog',
  'nickname': 'praesentium',
  'email': 'ckassulke@example.net',
  'salary': '35785.00',
  'age': 27
}, {
  'id': 13,
  'name': 'Selena Hettinger',
  'nickname': 'et',
  'email': 'bashirian.hyman@example.net',
  'salary': '31836.00',
  'age': 35
}, {
  'id': 14,
  'name': 'Edwin Beier',
  'nickname': 'eos',
  'email': 'janis71@example.org',
  'salary': '11902.00',
  'age': 38
}, {
  'id': 15,
  'name': 'Lexi Braun MD',
  'nickname': 'autem',
  'email': 'dusty74@example.net',
  'salary': '11927.00',
  'age': 45
}, {
  'id': 16,
  'name': 'Jovany Spencer',
  'nickname': 'fugit',
  'email': 'gbogisich@example.org',
  'salary': '44686.00',
  'age': 43
}, {
  'id': 17,
  'name': 'Prof. Maci Anderson DVM',
  'nickname': 'dolorem',
  'email': 'btorp@example.com',
  'salary': '25055.00',
  'age': 29
}, {
  'id': 18,
  'name': 'Joel Kulas MD',
  'nickname': 'sed',
  'email': 'phoebe.sauer@example.org',
  'salary': '11650.00',
  'age': 24
}, {
  'id': 19,
  'name': 'Mr. Dawson Greenholt',
  'nickname': 'nostrum',
  'email': 'asawayn@example.org',
  'salary': '46962.00',
  'age': 53
}, {
  'id': 20,
  'name': 'Prof. Lloyd Green',
  'nickname': 'velit',
  'email': 'laila.hintz@example.org',
  'salary': '12928.00',
  'age': 46
}, {
  'id': 21,
  'name': 'Shayna Morar',
  'nickname': 'rerum',
  'email': 'wfay@example.org',
  'salary': '22638.00',
  'age': 26
}, {
  'id': 22,
  'name': 'Krista Schulist',
  'nickname': 'qui',
  'email': 'gregoria.jakubowski@example.com',
  'salary': '49345.00',
  'age': 42
}, {
  'id': 23,
  'name': 'Leone Lemke',
  'nickname': 'repellat',
  'email': 'ltorphy@example.com',
  'salary': '17560.00',
  'age': 42
}, {
  'id': 24,
  'name': 'Dr. Willie Kemmer II',
  'nickname': 'quasi',
  'email': 'ivy51@example.net',
  'salary': '35370.00',
  'age': 30
}, {
  'id': 25,
  'name': 'Deonte Lebsack',
  'nickname': 'nesciunt',
  'email': 'alisa83@example.net',
  'salary': '32725.00',
  'age': 24
}, {
  'id': 26,
  'name': 'Prof. Shayne Nader',
  'nickname': 'voluptas',
  'email': 'bosco.shaina@example.net',
  'salary': '9844.00',
  'age': 23
}, {
  'id': 27,
  'name': 'Prof. Kennith Kertzmann',
  'nickname': 'alias',
  'email': 'satterfield.jonathan@example.com',
  'salary': '41950.00',
  'age': 25
}, {
  'id': 28,
  'name': 'Miss Meagan O\'Keefe',
  'nickname': 'corporis',
  'email': 'tracy.barrows@example.com',
  'salary': '41803.00',
  'age': 50
}, {
  'id': 29,
  'name': 'Prof. Edward Pagac MD',
  'nickname': 'quia',
  'email': 'gerhard65@example.org',
  'salary': '22896.00',
  'age': 43
}, {
  'id': 30,
  'name': 'Samantha Weissnat',
  'nickname': 'est',
  'email': 'crystel66@example.net',
  'salary': '18805.00',
  'age': 43
}, {
  'id': 31,
  'name': 'Dr. Gilbert Ward',
  'nickname': 'dolorum',
  'email': 'sandrine06@example.net',
  'salary': '16644.00',
  'age': 32
}, {
  'id': 32,
  'name': 'Mike West',
  'nickname': 'laudantium',
  'email': 'jborer@example.net',
  'salary': '35728.00',
  'age': 42
}, {
  'id': 33,
  'name': 'Prof. Isabell Cruickshank I',
  'nickname': 'recusandae',
  'email': 'ondricka.lurline@example.org',
  'salary': '44574.00',
  'age': 35
}, {
  'id': 34,
  'name': 'Prof. Lonny Rath',
  'nickname': 'nihil',
  'email': 'rfeest@example.net',
  'salary': '19949.00',
  'age': 48
}, {
  'id': 35,
  'name': 'Santina Medhurst MD',
  'nickname': 'suscipit',
  'email': 'ila24@example.net',
  'salary': '36323.00',
  'age': 51
}, {
  'id': 36,
  'name': 'Jeff Lehner',
  'nickname': 'quo',
  'email': 'jarred77@example.com',
  'salary': '48462.00',
  'age': 42
}, {
  'id': 37,
  'name': 'Samanta Pfeffer',
  'nickname': 'officia',
  'email': 'fgoyette@example.net',
  'salary': '19601.00',
  'age': 42
}, {
  'id': 38,
  'name': 'Ofelia Torp',
  'nickname': 'a',
  'email': 'ericka44@example.net',
  'salary': '33149.00',
  'age': 35
}, {
  'id': 39,
  'name': 'Mrs. Margarete Raynor',
  'nickname': 'quia',
  'email': 'jlegros@example.net',
  'salary': '21951.00',
  'age': 40
}, {
  'id': 40,
  'name': 'Mr. Brant Howell V',
  'nickname': 'perspiciatis',
  'email': 'franecki.gerald@example.org',
  'salary': '41552.00',
  'age': 53
}, {
  'id': 41,
  'name': 'Reilly Ruecker DVM',
  'nickname': 'ad',
  'email': 'ldeckow@example.net',
  'salary': '22709.00',
  'age': 42
}, {
  'id': 42,
  'name': 'Zachery McDermott',
  'nickname': 'molestiae',
  'email': 'gladyce84@example.com',
  'salary': '32354.00',
  'age': 25
}, {
  'id': 43,
  'name': 'Heloise Kulas',
  'nickname': 'aut',
  'email': 'kessler.helen@example.net',
  'salary': '45086.00',
  'age': 54
}, {
  'id': 44,
  'name': 'Norma Dibbert',
  'nickname': 'amet',
  'email': 'eudora36@example.net',
  'salary': '15661.00',
  'age': 46
}, {
  'id': 45,
  'name': 'Immanuel Auer',
  'nickname': 'quia',
  'email': 'halvorson.theodora@example.org',
  'salary': '15862.00',
  'age': 39
}, {
  'id': 46,
  'name': 'Lamont Borer',
  'nickname': 'expedita',
  'email': 'trantow.neoma@example.com',
  'salary': '12544.00',
  'age': 25
}, {
  'id': 47,
  'name': 'Brooke Purdy',
  'nickname': 'cupiditate',
  'email': 'bhermiston@example.net',
  'salary': '14457.00',
  'age': 50
}, {
  'id': 48,
  'name': 'Dr. Leo Dach',
  'nickname': 'et',
  'email': 'camila.ward@example.com',
  'salary': '40278.00',
  'age': 49
}, {
  'id': 49,
  'name': 'Krystal Langosh',
  'nickname': 'voluptatum',
  'email': 'pacocha.yesenia@example.org',
  'salary': '9305.00',
  'age': 34
}, {
  'id': 50,
  'name': 'Florence Greenfelder',
  'nickname': 'odit',
  'email': 'kenyatta.oconnell@example.com',
  'salary': '36980.00',
  'age': 38
}]);

/***/ }),

/***/ "JBQO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chartsReport_vue__ = __webpack_require__("qE7L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d79b9d0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chartsReport_vue__ = __webpack_require__("S1zQ");
function injectStyle (ssrContext) {
  __webpack_require__("ZJgM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d79b9d0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chartsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d79b9d0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chartsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JdU4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"area-radar-chart"},[_c('div',{staticClass:"content-1",staticStyle:{"height":"250px"}},[_c('div',{staticClass:"chart-content-div-header"},[_c('h4',[_c('small',[_c('i',{staticClass:"glyphicon glyphicon-signal"}),_vm._v("    "+_vm._s(_vm.title))])])]),_vm._v(" "),_c('div',{staticClass:"chart-content-div"},[_c('highcharts',{ref:"chart",staticStyle:{"height":"100%","width":"100%"},attrs:{"options":_vm.chartOptions}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JhHP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingMainPanel_vue__ = __webpack_require__("3MeN");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ce9c824_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingMainPanel_vue__ = __webpack_require__("i/rH");
function injectStyle (ssrContext) {
  __webpack_require__("sk1x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingMainPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ce9c824_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingMainPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "JukQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReincidenciaChart_vue__ = __webpack_require__("tnlj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a6d1641_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReincidenciaChart_vue__ = __webpack_require__("qbTh");
function injectStyle (ssrContext) {
  __webpack_require__("sx8C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a6d1641"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReincidenciaChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a6d1641_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReincidenciaChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KAR0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KLyw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KT1V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"dialog-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.close($event)}}},[_c('div',{staticClass:"dialog-content"},[_c('div',{staticClass:"dialog-body"},[_c('img',{staticClass:"img",attrs:{"src":"https://semeq.com/wp-content/themes/Semeq/assets/images/logo-semeq.svg","alt":"Logo da Semeq"}}),_vm._v(" "),_c('div',{staticClass:"error-icon"},[_vm._v("\n        ⚠ ")]),_vm._v(" "),_c('h1',{staticClass:"h1"},[_vm._v(_vm._s(_vm.$t("383")))]),_vm._v(" "),_c('p',{staticClass:"p"},[_vm._v(" "+_vm._s(_vm.$t("380"))+" ")]),_vm._v(" "),_c('div',{staticClass:"contact-info"},[_c('p',{staticClass:"p"},[_vm._v(" "+_vm._s(_vm.$t("381"))+" ")]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"dialog-footer"},[_c('button',{on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t("382")))])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"p"},[_c('i',{staticClass:"fa fa-envelope"}),_c('a',{attrs:{"href":"mailto:servicedesk@semeq.com"}},[_vm._v("servicedesk@semeq.com")]),_c('br'),_vm._v(" "),_c('i',{staticClass:"fa fa-phone"}),_vm._v("+5519997107611\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KWPQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridOnline_vue__ = __webpack_require__("lw2a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28279610_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridOnline_vue__ = __webpack_require__("rmvi");
function injectStyle (ssrContext) {
  __webpack_require__("x8Lb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28279610"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridOnline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28279610_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridOnline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kakj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaginatedTables_vue__ = __webpack_require__("77+S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_475d5aa7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaginatedTables_vue__ = __webpack_require__("3TKg");
function injectStyle (ssrContext) {
  __webpack_require__("VEgf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaginatedTables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_475d5aa7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaginatedTables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kjuj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KkWw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentType_vue__ = __webpack_require__("lCsA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f526bb7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentType_vue__ = __webpack_require__("z4K6");
function injectStyle (ssrContext) {
  __webpack_require__("uCbh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f526bb7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KtLi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-md-5"},[_c('user-card'),_vm._v(" "),_c('members-card')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-7"},[_c('edit-profile-form')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KyZi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);









__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tableData: [{
        id: 1,
        name: 'Dakota Rice',
        salary: '$36.738',
        country: 'Niger',
        city: 'Oud-Turnhout'
      }, {
        id: 2,
        name: 'Minerva Hooper',
        salary: '$23,789',
        country: 'Curaçao',
        city: 'Sinaai-Waas'
      }, {
        id: 3,
        name: 'Sage Rodriguez',
        salary: '$56,142',
        country: 'Netherlands',
        city: 'Baileux'
      }, {
        id: 4,
        name: 'Philip Chaney',
        salary: '$38,735',
        country: 'Korea, South',
        city: 'Overland Park'
      }, {
        id: 5,
        name: 'Doris Greene',
        salary: '$63,542',
        country: 'Malawi',
        city: 'Feldkirchen in Kärnten'
      }]
    };
  },

  methods: {
    tableRowClassName: function tableRowClassName(row, index) {
      if (index === 0) {
        return 'success';
      } else if (index === 2) {
        return 'info';
      } else if (index === 4) {
        return 'danger';
      } else if (index === 6) {
        return 'warning';
      }
      return '';
    }
  }
});

/***/ }),

/***/ "L+5Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");








__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_js_popover___default.a);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'report-chart',
  components: {
    Help: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_components_Help__["a" /* default */]
  },
  props: {
    title: {
      type: String
    },
    gridtxt: {
      type: String
    },
    data: {
      type: Array
    },
    help: {
      type: String
    },
    filters: {
      type: Object
    }
  },
  data: function data() {
    var _chartOptions;

    return {
      tableData: [],
      chartOptions: (_chartOptions = {
        chart: {
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063'
        },
        title: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '16px',
            fontWeight: 'bold'
          }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        xAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        yAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },
        plotOptions: {
          pie: {
            borderWidth: 0,
            size: '70%',
            dataLabels: {
              distance: 1
            },
            cursor: 'pointer'
          },
          series: {
            innerSize: '50%',
            dataLabels: {
              enabled: true,
              format: '<span style="color: #fff">{point.name}:<br> </span><span style="color: #fff">{point.percentage:.1f}%<span>',
              color: '#F0F0F3',
              style: {
                fontSize: '13px'
              }
            },
            marker: {
              lineColor: '#333'
            },
            events: {
              click: this.loadGrid
            },
            states: {
              hover: {
                enabled: true
              }
            }
          },
          boxplot: {
            fillColor: '#505053'
          },
          candlestick: {
            lineColor: 'white'
          },
          errorbar: {
            color: 'white'
          }
        },
        legend: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          itemStyle: {
            color: '#E0E0E3'
          },
          itemHoverStyle: {
            color: '#FFF'
          },
          itemHiddenStyle: {
            color: '#606063'
          },
          title: {
            style: {
              color: '#C0C0C0',
              fontSize: '12px',
              fontWeight: 'normal'
            }
          }
        },
        credits: {
          style: {
            color: '#666'
          }
        },
        labels: {
          style: {
            color: '#707073'
          }
        },
        series: [{
          name: "",
          colorByPoint: true,
          data: []
        }],
        exporting: {
          enabled: false
        }
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'credits', {
        enabled: false
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'loading', {
        labelStyle: {
          color: 'black',
          textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
        },
        style: {
          backgroundColor: 'none',
          opacity: 1,
          marginTop: '20px'
        }
      }), _chartOptions)
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['changeGrid']), {
    loadGrid: function loadGrid(event) {
      var status = event.point.drilldown;
      var point_name = event.point.name;
      var NAME_CHART = this.title + ' - ' + point_name.toUpperCase();
      var ENDPOINT = 'v1/mysemeq-ambev/get-general-report?year=' + this.filters.year + '&period=' + this.filters.period + '&plant=' + this.filters.plant + '&region=' + this.filters.region + '&status=' + status + '&technique=' + this.filters.technique + '&skipped=&area=' + this.filters.area + '&sector=' + this.filters.sector + '&machine=' + this.filters.machine + '&component=' + this.filters.component;

      var grid = {
        totalDados: event.point.y,
        title: event.point.name,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
          "rows": '',
          "plant": this.$t("310"),
          "area": this.$t("311"),
          "sector": this.$t("312"),
          "component": this.$t("313"),
          "component_tag": this.$t("314"),
          "component_type_en": this.$t("315"),
          "machine": this.$t("316"),
          "machine_tag": this.$t("317"),
          "status_txt_en": this.$t("318"),
          "report_number": this.$t("319"),
          "approved_datetime": this.$t("320"),
          "technique_en": this.$t("321"),
          "ref_date": this.$t("322"),
          "link": this.$t("323"),
          "link_rci": this.$t("324")
        },
        show: true,
        titleHelp: 'Grid -' + this.title,
        txtHelp: this.gridtxt
      };

      if (this.filters.plant) {
        grid.title += ' - ' + this.filters.plant_name;
        delete grid.columns['plant'];
      } else if (this.filters.region) {
        grid.title += ' - ' + this.filters.region;
      }

      this.changeGrid(grid);
    },
    setChartData: function setChartData() {
      var res = this.data;
      var values = [];
      var color = '';
      for (var key in res) {
        color = '';
        if (res[key].status == 4 || res[key].status == 2 || res[key].status == 0) {
          color = '#e4d354';
        } else if (res[key].status == -1 || res[key].status == 1) {
          color = '#f45b5b';
        } else if (res[key].status == 5 || res[key].status == 3 || res[key].status == 6) {
          color = '#90ed7d';
        }

        values.push({ 'name': res[key].status_txt, 'y': res[key].total, 'drilldown': res[key].status, 'color': color });
      }

      this.chartOptions.series[0].data = values;
    }
  }),
  watch: {
    data: function data() {
      this.setChartData();
    }
  }
});

/***/ }),

/***/ "LKFm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    titleChart: String
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "LQk8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LRfs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LdiV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('form',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email address")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('email'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control",attrs:{"type":"password","name":"password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('password'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-info btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Login")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n        Login Form\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LoYo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M/tb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"container-fluid"},[_c('h4',{staticClass:"title"},[_vm._v("XS Grid\n      "),_c('small',[_vm._v("Always Horizontal")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-xs-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-xs-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-xs-4")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("SM Grid\n      "),_c('small',[_vm._v("Collapsed at 768px")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-4")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("MD Grid\n      "),_c('small',[_vm._v("Collapsed at 992px")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("LG Grid\n      "),_c('small',[_vm._v("Collapsed at 1200px")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-lg-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-lg-4")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-lg-4")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Mixed Grid\n      "),_c('small',[_vm._v("Showing different sizes on different screens")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-6 col-lg-3")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-6 col-lg-3")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-6 col-lg-3")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-lg-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-sm-6 col-lg-3")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Offset Grid\n      "),_c('small',[_vm._v("Adding some space when needed")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-3")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-md-offset-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-3 col-md-offset-6")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-1"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4 col-md-offset-1")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-md-offset-2"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-4 col-md-offset-2")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-md-offset-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content text-center"},[_c('code',[_vm._v("col-md-6 col-md-offset-3")])])])])]),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("Paragraphs")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("Some Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What's happened to me?\" he thought.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h3',[_vm._v("Another Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What's happened to me?\" he thought.")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Some Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Another Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Another Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('h3',[_vm._v("Some Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('h3',[_vm._v("Another Title Here")]),_vm._v(" "),_c('p',[_vm._v("\n              One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment. One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections. The bedding was hardly able to cover it and seemed ready to slide off any moment.")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M0iJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M76F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExecutionChart_vue__ = __webpack_require__("4PsR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40a4e0ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutionChart_vue__ = __webpack_require__("F7nr");
function injectStyle (ssrContext) {
  __webpack_require__("KLyw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40a4e0ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExecutionChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40a4e0ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutionChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d67dbd7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("ruaE");
function injectStyle (ssrContext) {
  __webpack_require__("+dbZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d67dbd7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MAOu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MCxG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area-radar-chart"},[_c('div',{staticClass:"content-1",staticStyle:{"height":"500px"}},[_c('div',{staticClass:"chart-content-div-header"},[_c('h4',[_c('small',[_c('i',{staticClass:"glyphicon glyphicon-signal"}),_vm._v("   #  "+_vm._s(_vm.$t("128"))+" ("+_vm._s(_vm.periodText)+") - "+_vm._s(_vm.header))]),_vm._v(" "),_c('small',[_c('i',{staticClass:"glyphicon glyphicon-print my-export",staticStyle:{"float":"right"},on:{"click":_vm.exporting}})])])]),_vm._v(" "),_c('div',{staticClass:"chart-content-div"},[_c('div',{attrs:{"id":_vm.id}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MW3O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  modal_photo: {
    link_photo: '',
    sensor_photo: ''
  }
};

var getters = {
  modal_photo: function modal_photo(state) {
    return state.modal_photo;
  }
};

var mutations = {
  changeModalPhoto: function changeModalPhoto(state, payload) {
    state.modal_photo = payload;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("0FOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e97be45_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("ED2B");
function injectStyle (ssrContext) {
  __webpack_require__("5Yw9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e97be45_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: 'MySemeq'
    },
    type: {
      type: String,
      default: 'sidebar',
      validator: function validator(value) {
        var acceptedValues = ['sidebar', 'navbar'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: function validator(value) {
        var acceptedValues = ['white', 'brown', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: 'static/img/semeq-logo.png'
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    sidebarClasses: function sidebarClasses() {
      if (this.type === 'sidebar') {
        return 'sidebar';
      } else {
        return 'collapse navbar-collapse off-canvas-sidebar';
      }
    },
    navClasses: function navClasses() {
      if (this.type === 'sidebar') {
        return 'nav';
      } else {
        return 'nav navbar-nav';
      }
    }
  },
  methods: {
    initScrollBarAsync: function initScrollBarAsync() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var PerfectScroll;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "ieps"));

              case 2:
                _context.next = 4;
                return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "Fiov"));

              case 4:
                PerfectScroll = _context.sent;

                PerfectScroll.initialize(_this.$refs.sidebarScrollArea);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    this.initScrollBarAsync();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
});

/***/ }),

/***/ "MhKq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Charts_ChartsSkipped__ = __webpack_require__("IcX6");








__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_js_popover___default.a);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'report-chart',
  components: {
    ChartsSkipped: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Charts_ChartsSkipped__["a" /* default */],
    Help: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_components_Help__["a" /* default */]
  },
  props: {
    title: {
      type: String
    },
    gridtxt: {
      type: String
    },
    data: {
      type: Array
    },
    help: {
      type: String
    },
    filters: {
      type: Object
    }
  },
  data: function data() {
    var _chartOptions;

    return {
      showSkipped: false,
      activeBattery: false,
      btn_title: this.$t("155"),
      tableData: [],
      chartOptions: (_chartOptions = {
        chart: {
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063'
        },
        title: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '16px',
            fontWeight: 'bold'
          }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        xAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        yAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },
        plotOptions: {
          pie: {
            borderWidth: 0,
            size: '70%',
            dataLabels: {
              distance: 1
            },
            cursor: 'pointer'
          },
          series: {
            innerSize: '50%',
            dataLabels: {
              enabled: true,
              format: '<span style="color: #fff">{point.name}:<br> </span><span style="color: #fff">{point.percentage:.1f}%<span>',
              color: '#F0F0F3',
              style: {
                fontSize: '13px'
              }
            },
            marker: {
              lineColor: '#333'
            },
            events: {
              click: this.loadGrid
            },
            states: {
              hover: {
                enabled: true
              }
            }
          },
          boxplot: {
            fillColor: '#505053'
          },
          candlestick: {
            lineColor: 'white'
          },
          errorbar: {
            color: 'white'
          }
        },
        legend: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          itemStyle: {
            color: '#E0E0E3'
          },
          itemHoverStyle: {
            color: '#FFF'
          },
          itemHiddenStyle: {
            color: '#606063'
          },
          title: {
            style: {
              color: '#C0C0C0',
              fontSize: '12px',
              fontWeight: 'normal'
            }
          }
        },
        credits: {
          style: {
            color: '#666'
          }
        },
        labels: {
          style: {
            color: '#707073'
          }
        },
        series: [{
          name: "",
          colorByPoint: true,
          data: []
        }],
        exporting: {
          enabled: false
        }
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'credits', {
        enabled: false
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'loading', {
        labelStyle: {
          color: 'black',
          textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
        },
        style: {
          backgroundColor: 'none',
          opacity: 1,
          marginTop: '20px'
        }
      }), _chartOptions)
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['changeGrid']), {
    loadGrid: function loadGrid(event) {
      var status = event.point.drilldown;
      var point_name = event.point.name;
      var NAME_CHART = this.title + ' - ' + point_name.toUpperCase();
      var ENDPOINT = 'v1/mysemeq-ambev/get-general-report?year=' + this.filters.year + '&period=' + this.filters.period + '&plant=' + this.filters.plant + '&region=' + this.filters.region + '&status=' + status + '&technique=' + this.filters.technique + '&skipped=&area=' + this.filters.area + '&sector=' + this.filters.sector + '&machine=' + this.filters.machine + '&component=' + this.filters.component;

      var grid = {
        totalDados: event.point.y,
        title: event.point.name,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
          "rows": '',
          "plant": this.$t("310"),
          "area": this.$t("311"),
          "sector": this.$t("312"),
          "component": this.$t("313"),
          "component_tag": this.$t("314"),
          "component_type_en": this.$t("315"),
          "machine": this.$t("316"),
          "machine_tag": this.$t("317"),
          "status_txt_en": this.$t("318"),
          "report_number": this.$t("319"),
          "approved_datetime": this.$t("320"),
          "technique_en": this.$t("321"),
          "ref_date": this.$t("322"),
          "link": this.$t("323"),
          "link_rci": this.$t("324")
        },
        show: true,
        titleHelp: 'Grid -' + this.title,
        txtHelp: this.gridtxt
      };

      if (this.filters.plant) {
        grid.title += ' - ' + this.filters.plant_name;
        delete grid.columns['plant'];
      } else if (this.filters.region) {
        grid.title += ' - ' + this.filters.region;
      }

      this.changeGrid(grid);
    },
    setChartData: function setChartData() {
      var res = this.data;
      var values = [];
      var color = '';
      for (var key in res) {
        color = '';
        if (res[key].status == 4 || res[key].status == 2 || res[key].status == 0) {
          color = '#e4d354';
        } else if (res[key].status == -1 || res[key].status == 1) {
          color = '#f45b5b';
        } else if (res[key].status == 5 || res[key].status == 3 || res[key].status == 6) {
          color = '#90ed7d';
        }

        values.push({ 'name': res[key].status_txt, 'y': res[key].total, 'drilldown': res[key].status, 'color': color });
      }

      this.chartOptions.series[0].data = values;
    },
    getBatteryChart: function getBatteryChart() {
      this.showSkipped = !this.showSkipped;
      this.activeBattery = !this.activeBattery;
      this.btn_title = this.showSkipped ? this.$t("157") : this.$t("155");
    }
  }),
  watch: {
    data: function data() {
      this.setChartData();
    }
  }
});

/***/ }),

/***/ "Mi7u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MuMl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N10g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N2Qe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N7DR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NBoB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHdb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "app", function() { return app; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pollyfills__ = __webpack_require__("im4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale__ = __webpack_require__("urW8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__gloablComponents__ = __webpack_require__("iXuc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__routes_routes__ = __webpack_require__("T1vP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_sass_paper_dashboard_scss__ = __webpack_require__("MAOu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_sass_paper_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_sass_paper_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_sass_element_variables_scss__ = __webpack_require__("yv97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_sass_element_variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_sass_element_variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_sass_demo_scss__ = __webpack_require__("9G8F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_sass_demo_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_sass_demo_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lang_lang__ = __webpack_require__("pe4m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_tour__ = __webpack_require__("pvO8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_tour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_tour__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__sidebarLinks__ = __webpack_require__("FiZY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_js_proj4__ = __webpack_require__("gdYb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_highcharts__ = __webpack_require__("504h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_highcharts_highcharts_3d__ = __webpack_require__("nF1+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_highcharts_highcharts_3d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_highcharts_highcharts_3d__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__node_modules_highcharts_highmaps_js__ = __webpack_require__("SMri");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__node_modules_highcharts_highmaps_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__node_modules_highcharts_highmaps_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_highcharts__ = __webpack_require__("ajw3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_highcharts_modules_exporting__ = __webpack_require__("VVDx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_highcharts_modules_exporting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_highcharts_modules_exporting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_highcharts_modules_map__ = __webpack_require__("jgbR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_highcharts_modules_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_highcharts_modules_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_highcharts_modules_drilldown__ = __webpack_require__("DQhn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_highcharts_modules_drilldown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_highcharts_modules_drilldown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_search_select_dist_VueSearchSelect_css__ = __webpack_require__("aS2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_search_select_dist_VueSearchSelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vue_search_select_dist_VueSearchSelect_css__);

























if (typeof window !== 'undefined') {
  window.proj4 = window.proj4 || __WEBPACK_IMPORTED_MODULE_20__src_js_proj4__["default"];
}



__WEBPACK_IMPORTED_MODULE_22_highcharts_highcharts_3d___default()(__WEBPACK_IMPORTED_MODULE_21_highcharts___default.a);







__WEBPACK_IMPORTED_MODULE_25_highcharts_modules_exporting___default()(__WEBPACK_IMPORTED_MODULE_21_highcharts___default.a);
__WEBPACK_IMPORTED_MODULE_26_highcharts_modules_map___default()(__WEBPACK_IMPORTED_MODULE_21_highcharts___default.a);
__WEBPACK_IMPORTED_MODULE_27_highcharts_modules_drilldown___default()(__WEBPACK_IMPORTED_MODULE_21_highcharts___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_24_vue_highcharts__["a" /* default */], { Highcharts: __WEBPACK_IMPORTED_MODULE_21_highcharts___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_23__node_modules_highcharts_highmaps_js___default.a);

__webpack_require__("iq7p");

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9__globalDirectives__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8__gloablComponents__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_notifyjs___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10__components_UIComponents_SidebarPlugin__["a" /* default */], { sidebarLinks: __WEBPACK_IMPORTED_MODULE_19__sidebarLinks__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_18_vue_tour___default.a);
__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_11__routes_routes__["a" /* default */],
  linkActiveClass: 'active',
  mode: 'history' });

var token = localStorage.getItem('user-token');
if (token) {
  __WEBPACK_IMPORTED_MODULE_17_axios___default.a.defaults.headers.common['Authorization'] = token;
}

var app = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_15__lang_lang__["a" /* default */],
  router: router,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_7__App_vue__["a" /* default */]);
  },
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_7__App_vue__["a" /* default */] }
});

window['vue'] = app;
window.store = __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */];

/***/ }),

/***/ "NmlF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dashboard_Stats_TimeLine_vue__ = __webpack_require__("k8VF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dashboard_Stats_TimeLineItem_vue__ = __webpack_require__("U6TR");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TimeLine: __WEBPACK_IMPORTED_MODULE_0__Dashboard_Stats_TimeLine_vue__["a" /* default */],
    TimeLineItem: __WEBPACK_IMPORTED_MODULE_1__Dashboard_Stats_TimeLineItem_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "Nrso":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"text-center"},[_vm._v("Please give us more details about your platform.")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Your Website")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.website),expression:"modelValidations.website"},{name:"model",rawName:"v-model",value:(_vm.model.website),expression:"model.website"}],staticClass:"form-control",attrs:{"type":"text","name":"website","url":"true","placeholder":"ex: http://www.creative-tim.com"},domProps:{"value":(_vm.model.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "website", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.website.invalid),expression:"website.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('website'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Framework Type")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.framework),expression:"model.framework"}],staticClass:"form-control",attrs:{"type":"text","name":"framework","placeholder":"ex: http://www.creative-tim.com"},domProps:{"value":(_vm.model.framework)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "framework", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Language\n        ")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.language),expression:"modelValidations.language"},{name:"model",rawName:"v-model",value:(_vm.model.language),expression:"model.language"}],staticClass:"form-control",attrs:{"name":"language"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("- language -")]),_vm._v(" "),_c('option',{attrs:{"value":"ms"}},[_vm._v("Bahasa Melayu")]),_vm._v(" "),_c('option',{attrs:{"value":"ca"}},[_vm._v("Català")]),_vm._v(" "),_c('option',{attrs:{"value":"da"}},[_vm._v("Dansk")]),_vm._v(" "),_c('option',{attrs:{"value":"de"}},[_vm._v("Deutsch")]),_vm._v(" "),_c('option',{attrs:{"value":"en"}},[_vm._v("English")]),_vm._v(" "),_c('option',{attrs:{"value":"es"}},[_vm._v("Español")]),_vm._v(" "),_c('option',{attrs:{"value":"el"}},[_vm._v("Eλληνικά")]),_vm._v(" "),_c('option',{attrs:{"value":"fr"}},[_vm._v("Français")]),_vm._v(" "),_c('option',{attrs:{"value":"it"}},[_vm._v("Italiano")]),_vm._v(" "),_c('option',{attrs:{"value":"hu"}},[_vm._v("Magyar")]),_vm._v(" "),_c('option',{attrs:{"value":"nl"}},[_vm._v("Nederlands")]),_vm._v(" "),_c('option',{attrs:{"value":"no"}},[_vm._v("Norsk")]),_vm._v(" "),_c('option',{attrs:{"value":"pl"}},[_vm._v("Polski")]),_vm._v(" "),_c('option',{attrs:{"value":"pt"}},[_vm._v("Português")]),_vm._v(" "),_c('option',{attrs:{"value":"fi"}},[_vm._v("Suomi")]),_vm._v(" "),_c('option',{attrs:{"value":"sv"}},[_vm._v("Svenska")]),_vm._v(" "),_c('option',{attrs:{"value":"tr"}},[_vm._v("Türkçe")]),_vm._v(" "),_c('option',{attrs:{"value":"is"}},[_vm._v("Íslenska")]),_vm._v(" "),_c('option',{attrs:{"value":"cs"}},[_vm._v("Čeština")]),_vm._v(" "),_c('option',{attrs:{"value":"ru"}},[_vm._v("Русский")]),_vm._v(" "),_c('option',{attrs:{"value":"th"}},[_vm._v("ภาษาไทย")]),_vm._v(" "),_c('option',{attrs:{"value":"zh"}},[_vm._v("中文 (简体)")]),_vm._v(" "),_c('option',{attrs:{"value":"zh-TW"}},[_vm._v("中文 (繁體)")]),_vm._v(" "),_c('option',{attrs:{"value":"ja"}},[_vm._v("日本語")]),_vm._v(" "),_c('option',{attrs:{"value":"ko"}},[_vm._v("한국어")])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.language.invalid),expression:"language.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('language'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Bootstrap Version\n        ")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.bootstrapVersion),expression:"modelValidations.bootstrapVersion"},{name:"model",rawName:"v-model",value:(_vm.model.bootstrapVersion),expression:"model.bootstrapVersion"}],staticClass:"form-control",attrs:{"name":"cities"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "bootstrapVersion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"selected":"","disabled":""}},[_vm._v("- version -")]),_vm._v(" "),_c('option',{attrs:{"value":"1.1"}},[_vm._v("Bootstrap 1.1")]),_vm._v(" "),_c('option',{attrs:{"value":"2.0"}},[_vm._v("Bootstrap 2.0")]),_vm._v(" "),_c('option',{attrs:{"value":"3.0"}},[_vm._v("Bootstrap 3.0")]),_vm._v(" "),_c('option',{attrs:{"value":"4.0"}},[_vm._v("Bootstrap 4.0(alpha)")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Price")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.price),expression:"model.price"}],staticClass:"form-control",attrs:{"type":"text","name":"price","placeholder":"ex: 19.00"},domProps:{"value":(_vm.model.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "price", $event.target.value)}}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NspE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartFailurePareto_vue__ = __webpack_require__("vUIw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_232efd62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartFailurePareto_vue__ = __webpack_require__("Fzxk");
function injectStyle (ssrContext) {
  __webpack_require__("WLON")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-232efd62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartFailurePareto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_232efd62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartFailurePareto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NwLt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 box-release"},[_c('div',{staticClass:"notas-versao-item"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"notas-versao-conteudo"},[_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.$t("60")))])])]),_vm._v(" "),_c('div',{staticClass:"notas-versao-item"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"notas-versao-conteudo"},[_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("61")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("62")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("63")))])])]),_vm._v(" "),_c('div',{staticClass:"notas-versao-item"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"notas-versao-conteudo"},[_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("64")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("65")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("66")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("67")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("68")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("69")))])])]),_vm._v(" "),_c('div',{staticClass:"notas-versao-item"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"notas-versao-conteudo"},[_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("70")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("71")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("72")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("73")))])])]),_vm._v(" "),_c('div',{staticClass:"notas-versao-item"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"notas-versao-conteudo"},[_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("74")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("75")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("76")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("77")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("78")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("79")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("80")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("81")))])])]),_vm._v(" "),_c('div',{staticClass:"notas-versao-item"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"notas-versao-conteudo"},[_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("82")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("83")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("84")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("85")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("86")))])])]),_vm._v(" "),_c('div',{staticClass:"notas-versao-item"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"notas-versao-conteudo"},[_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("87")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("88")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("89")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("90")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("91")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("92")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("93")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("94")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("95")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("96")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("97")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("98")))])])]),_vm._v(" "),_c('div',{staticClass:"notas-versao-item"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"notas-versao-conteudo"},[_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("99")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("100")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("101")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("102")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("103")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("104")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("105")))]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t("106")))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notas-versao-header"},[_c('span',{staticClass:"notas-versao-v"},[_vm._v("v.326")]),_vm._v(" "),_c('span',{staticClass:"notas-versao-data"},[_vm._v("04/07/2021")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notas-versao-header"},[_c('span',{staticClass:"notas-versao-v"},[_vm._v("v.325")]),_vm._v(" "),_c('span',{staticClass:"notas-versao-data"},[_vm._v("03/10/2021")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notas-versao-header"},[_c('span',{staticClass:"notas-versao-v"},[_vm._v("v.323")]),_vm._v(" "),_c('span',{staticClass:"notas-versao-data"},[_vm._v("02/17/2021")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notas-versao-header"},[_c('span',{staticClass:"notas-versao-v"},[_vm._v("v.218")]),_vm._v(" "),_c('span',{staticClass:"notas-versao-data"},[_vm._v("03/17/2020")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notas-versao-header"},[_c('span',{staticClass:"notas-versao-v"},[_vm._v("v.215")]),_vm._v(" "),_c('span',{staticClass:"notas-versao-data"},[_vm._v("03/11/2020")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notas-versao-header"},[_c('span',{staticClass:"notas-versao-v"},[_vm._v("v.197")]),_vm._v(" "),_c('span',{staticClass:"notas-versao-data"},[_vm._v("02/26/2020")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notas-versao-header"},[_c('span',{staticClass:"notas-versao-v"},[_vm._v("v.172")]),_vm._v(" "),_c('span',{staticClass:"notas-versao-data"},[_vm._v("02/03/2020")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notas-versao-header"},[_c('span',{staticClass:"notas-versao-v"},[_vm._v("v.01")]),_vm._v(" "),_c('span',{staticClass:"notas-versao-data"},[_vm._v("01/28/2020")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O4qw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OD4A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartFailureOnline_vue__ = __webpack_require__("yYoM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03078dfd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartFailureOnline_vue__ = __webpack_require__("cqsY");
function injectStyle (ssrContext) {
  __webpack_require__("n0lJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03078dfd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartFailureOnline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03078dfd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartFailureOnline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OGQL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OWRr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"extended-forms"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('h4',{staticClass:"card-title"},[_vm._v("Datetime Picker")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":"Select date and time","picker-options":_vm.pickerOptions1},model:{value:(_vm.dateTimePicker),callback:function ($$v) {_vm.dateTimePicker=$$v},expression:"dateTimePicker"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('h4',{staticClass:"card-title"},[_vm._v("Date Picker")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"Pick a day","picker-options":_vm.pickerOptions1},model:{value:(_vm.datePicker),callback:function ($$v) {_vm.datePicker=$$v},expression:"datePicker"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('h4',{staticClass:"card-title"},[_vm._v("Time Picker")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-time-select',{attrs:{"picker-options":{
                start: '00:00',
                step: '00:15',
                end: '23:59'
              },"placeholder":"Select time"},model:{value:(_vm.timePicker),callback:function ($$v) {_vm.timePicker=$$v},expression:"timePicker"}})],1)])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Switches")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"category"},[_vm._v("Default")]),_vm._v(" "),_c('p-switch',{attrs:{"type":"primary","on-text":"ON","off-text":"OFF"},model:{value:(_vm.switches.defaultOn),callback:function ($$v) {_vm.$set(_vm.switches, "defaultOn", $$v)},expression:"switches.defaultOn"}}),_vm._v(" "),_c('p-switch',{attrs:{"type":"primary","on-text":"ON","off-text":"OFF"},model:{value:(_vm.switches.defaultOff),callback:function ($$v) {_vm.$set(_vm.switches, "defaultOff", $$v)},expression:"switches.defaultOff"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"category"},[_vm._v("Plain")]),_vm._v(" "),_c('p-switch',{model:{value:(_vm.switches.plainOn),callback:function ($$v) {_vm.$set(_vm.switches, "plainOn", $$v)},expression:"switches.plainOn"}}),_vm._v(" "),_c('p-switch',{model:{value:(_vm.switches.plainOff),callback:function ($$v) {_vm.$set(_vm.switches, "plainOff", $$v)},expression:"switches.plainOff"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('p',{staticClass:"category"},[_vm._v("With Icons")]),_vm._v(" "),_c('p-switch',{model:{value:(_vm.switches.withIconsOn),callback:function ($$v) {_vm.$set(_vm.switches, "withIconsOn", $$v)},expression:"switches.withIconsOn"}},[_c('i',{staticClass:"fa fa-check",attrs:{"slot":"on"},slot:"on"}),_vm._v(" "),_c('i',{staticClass:"fa fa-times",attrs:{"slot":"off"},slot:"off"})]),_vm._v(" "),_c('p-switch',{model:{value:(_vm.switches.withIconsOff),callback:function ($$v) {_vm.$set(_vm.switches, "withIconsOff", $$v)},expression:"switches.withIconsOff"}},[_c('i',{staticClass:"fa fa-check",attrs:{"slot":"on"},slot:"on"}),_vm._v(" "),_c('i',{staticClass:"fa fa-times",attrs:{"slot":"off"},slot:"off"})])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('h4',{staticClass:"card-title"},[_vm._v("Checkboxes")]),_vm._v(" "),_c('p-checkbox',{attrs:{"checked":false}},[_vm._v("Unchecked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"checked":true}},[_vm._v("Checked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":"","checked":false}},[_vm._v("Disabled unchecked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":"","checked":true}},[_vm._v("Disabled checked")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('h4',{staticClass:"card-title"},[_vm._v("Radio")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"1"},model:{value:(_vm.enabledRadio),callback:function ($$v) {_vm.enabledRadio=$$v},expression:"enabledRadio"}},[_vm._v("Radio is off")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"2"},model:{value:(_vm.enabledRadio),callback:function ($$v) {_vm.enabledRadio=$$v},expression:"enabledRadio"}},[_vm._v("Radio is on")]),_vm._v(" "),_c('p-radio',{attrs:{"disabled":"","label":"1"},model:{value:(_vm.disabledRadio),callback:function ($$v) {_vm.disabledRadio=$$v},expression:"disabledRadio"}},[_vm._v("Disabled radio is off")]),_vm._v(" "),_c('p-radio',{attrs:{"disabled":"","label":"2"},model:{value:(_vm.disabledRadio),callback:function ($$v) {_vm.disabledRadio=$$v},expression:"disabledRadio"}},[_vm._v("Disabled radio is on")])],1)]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tags")]),_vm._v(" "),_vm._l((_vm.tags.dynamicTags),function(tag){return _c('el-tag',{key:tag,attrs:{"type":"primary","closable":true,"close-transition":false},on:{"close":function($event){_vm.handleClose(tag)}}},[_vm._v("\n            "+_vm._s(tag)+"\n          ")])}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tags.inputValue),expression:"tags.inputValue"}],ref:"saveTagInput",staticClass:"form-control input-new-tag",attrs:{"type":"text","placeholder":"Add new tag","size":"mini"},domProps:{"value":(_vm.tags.inputValue)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleInputConfirm($event)},"blur":_vm.handleInputConfirm,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tags, "inputValue", $event.target.value)}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Progress Bars")]),_vm._v(" "),_c('p-progress',{attrs:{"value":30}}),_vm._v(" "),_c('p-progress',{attrs:{"value":60,"type":"info"}}),_vm._v(" "),_c('p-progress',{attrs:{"values":[{type:'success', value:35},{type:'warning', value:20}, {type:'danger', value: 10}]}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Sliders")]),_vm._v(" "),_c('el-slider',{staticClass:"slider-success",model:{value:(_vm.sliders.simple),callback:function ($$v) {_vm.$set(_vm.sliders, "simple", $$v)},expression:"sliders.simple"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-slider',{staticClass:"slider-info",attrs:{"max":100,"range":""},model:{value:(_vm.sliders.rangeSlider),callback:function ($$v) {_vm.$set(_vm.sliders, "rangeSlider", $$v)},expression:"sliders.rangeSlider"}})],2),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('h4',{staticClass:"card-title"},[_vm._v("Customisable Select")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('el-select',{staticClass:"select-danger",attrs:{"size":"large","placeholder":"Single Select"},model:{value:(_vm.selects.simple),callback:function ($$v) {_vm.$set(_vm.selects, "simple", $$v)},expression:"selects.simple"}},_vm._l((_vm.selects.countries),function(option){return _c('el-option',{key:option.label,staticClass:"select-danger",attrs:{"value":option.value,"label":option.label}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('el-select',{staticClass:"select-primary",attrs:{"multiple":"","size":"large","placeholder":"Multiple Select"},model:{value:(_vm.selects.multiple),callback:function ($$v) {_vm.$set(_vm.selects, "multiple", $$v)},expression:"selects.multiple"}},_vm._l((_vm.selects.countries),function(option){return _c('el-option',{key:option.label,staticClass:"select-primary",attrs:{"value":option.value,"label":option.label}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Dropdown")]),_vm._v(" "),_c('drop-down',[_c('button',{staticClass:"btn btn-block dropdown-toggle",attrs:{"slot":"title","data-toggle":"dropdown"},slot:"title"},[_vm._v("\n                  Regular\n                  "),_c('b',{staticClass:"caret"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Separated link")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("One more separated link")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('br'),_vm._v(" "),_c('h4',{staticClass:"card-title"},[_vm._v("Dropup")]),_vm._v(" "),_c('drop-down',{attrs:{"slide":"up"}},[_c('button',{staticClass:"btn btn-block dropdown-toggle",attrs:{"slot":"title","data-toggle":"dropdown"},slot:"title"},[_vm._v("\n                  Regular\n                  "),_c('b',{staticClass:"caret"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Separated link")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("One more separated link")])])])],1)])])]),_vm._v(" "),_c('br'),_c('br')])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OaMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chart-card',
  props: {
    footerText: {
      type: String,
      default: ''
    },
    headerTitle: {
      type: String,
      default: 'Chart title'
    },
    chartType: {
      type: String,
      default: 'Line' },
    chartOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default: function _default() {
        return {
          labels: [],
          series: []
        };
      }
    }
  },
  data: function data() {
    return {
      chartId: 'no-id',
      $Chartist: null
    };
  },

  methods: {
    initChart: function initChart() {
      var chartIdQuery = '#' + this.chartId;
      this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions);
    },
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var Chartist;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "715g"));

            case 3:
              Chartist = _context.sent;

              _this.$Chartist = Chartist;
              _this.initChart();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d63ebd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("+lQa");
function injectStyle (ssrContext) {
  __webpack_require__("AuCi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d63ebd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PAWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegularForms_vue__ = __webpack_require__("pfXf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da4aaaf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegularForms_vue__ = __webpack_require__("r2+i");
function injectStyle (ssrContext) {
  __webpack_require__("eFVZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegularForms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da4aaaf4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegularForms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PGBT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pfw2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__("bJ0t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_132f20c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__("LdiV");
function injectStyle (ssrContext) {
  __webpack_require__("DjVu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_132f20c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PzXG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");










__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PSwitch: __WEBPACK_IMPORTED_MODULE_6_src_components_UIComponents_Switch_vue__["a" /* default */]
  },
  data: function data() {
    return {
      tableData: [{
        name: 'Andrew Mike',
        job: 'Develop',
        salary: '€ 99,225',
        active: false
      }, {
        name: 'John Doe',
        job: 'Design',
        salary: '€ 89,241',
        active: false
      }, {
        name: 'Alex Mike',
        job: 'Design',
        salary: '€ 92,144',
        active: false
      }, {
        name: 'Mike Monday',
        job: 'Marketing',
        salary: '€ 49,990',
        active: true
      }, {
        name: 'Paul dickens',
        job: 'Communication',
        salary: '€ 69,201',
        active: true
      }],
      productsTable: [{
        image: 'static/img/tables/agenda.png',
        title: 'Notebook',
        subTitle: 'Most beautiful agenda for the office.',
        price: 49,
        quantity: 1
      }, {
        image: 'static/img/tables/stylus.jpg',
        title: 'Stylus',
        subTitle: 'Design is not just what it looks like and feels like. Design is how it works.',
        price: 499,
        quantity: 2
      }, {
        image: 'static/img/tables/evernote.png',
        title: 'Evernote iPad Stander',
        subTitle: 'A groundbreaking Retina display. All-flash architecture. Fourth-generation Intel processors.',
        price: 799,
        quantity: 1
      }]
    };
  },

  methods: {
    handleLike: function handleLike(index, row) {
      alert('Your clicked on Like button');
    },
    handleEdit: function handleEdit(index, row) {
      alert('Your want to edit ' + row.name);
    },
    handleDelete: function handleDelete(index, row) {
      alert('Your want to delete ' + row.name);
    },
    getSummaries: function getSummaries(param) {
      var _this = this;

      var columns = param.columns;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = 'Total';
        } else if (index < columns.length - 1) {
          sums[index] = '';
        } else {
          var sum = 0;
          _this.productsTable.forEach(function (obj) {
            sum += obj.quantity * obj.price;
          });
          sums[index] = '\u20AC ' + sum;
        }
      });
      return sums;
    }
  }
});

/***/ }),

/***/ "Q8IL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "QHKn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qfw/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataSurveyChart_vue__ = __webpack_require__("MhKq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f29bce8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataSurveyChart_vue__ = __webpack_require__("nSaA");
function injectStyle (ssrContext) {
  __webpack_require__("FXAL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f29bce8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataSurveyChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f29bce8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataSurveyChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Qr7H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpgateway","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("233")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help"},[_vm._v(_vm._s(_vm.$t("234"))+"\n      "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpgateway.bottom",arg:"helpgateway",modifiers:{"bottom":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qu5a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts_vue__ = __webpack_require__("jhCd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_highcharts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_ChartsOnline_HeatMap__ = __webpack_require__("g9Xd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_ChartsOnline_HeatMapSensor__ = __webpack_require__("idUJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_ChartsOnline_HeatMapSensorAppointments__ = __webpack_require__("pUs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  options: null,
  components: {
    highcharts: __WEBPACK_IMPORTED_MODULE_1_highcharts_vue__["Chart"],
    HeatMap: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_ChartsOnline_HeatMap__["a" /* default */],
    HeatMapSensor: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_ChartsOnline_HeatMapSensor__["a" /* default */],
    HeatMapSensorAppointments: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_ChartsOnline_HeatMapSensorAppointments__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  mounted: function mounted() {
    this.changeTab('online');
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapMutations */])(['changeTab']))
});

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7610666_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("x2Ti");
function injectStyle (ssrContext) {
  __webpack_require__("KAR0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7610666_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R9G1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-login"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('notifications',{attrs:{"group":"alert"}},[_vm._v(_vm._s(_vm.error))]),_vm._v(" "),_c('div',{staticClass:"box-form-login"},[_c('form',{staticClass:"login",on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('div',{staticClass:"card",attrs:{"data-background":"color","data-color":"blue"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t("49")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],staticClass:"form-control input-no-border",attrs:{"required":"","type":"text","placeholder":"User"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t("58")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control input-no-border",attrs:{"required":"","type":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_vm._m(2)])])])],1),_vm._v(" "),_c('div',{staticClass:"footer"},[_vm._v("\n    Copyright © "+_vm._s(_vm.year)+" "),_c('a',{attrs:{"href":"http://www.semeq.com","target":"_blank"}},[_vm._v("SEMEQ")]),_c('br'),_vm._v("\n    All rights reserved\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-system"},[_c('img',{attrs:{"src":"static/img/logo-pb.png"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h3',{staticClass:"card-title"},[_vm._v("Login")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-fim text-center"},[_c('button',{staticClass:"btn btn-fill btn-wd ",attrs:{"type":"submit"}},[_vm._v("OK")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RM11":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__ = __webpack_require__("S8VE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07338075_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__ = __webpack_require__("swfc");
function injectStyle (ssrContext) {
  __webpack_require__("XaJ4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07338075_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RXFM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  }
});

/***/ }),

/***/ "RalK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



var Highcharts = __webpack_require__("nER5");
__webpack_require__("VVDx")(Highcharts);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'history-chart',
    mounted: function mounted() {
        this.chart = new Highcharts.stockChart(this.options);
    },

    watch: {
        data: function data(value) {
            var _this = this;

            this.chart.series[0].setData(this.data);
            setTimeout(function () {
                _this.setExtremes();
            }, 500);
        },
        period: function period(value) {
            if (this.data) this.setExtremes();
        },
        year: function year(value) {
            if (this.data) this.setExtremes();
        }
    },
    methods: {
        exporting: function exporting() {
            this.chart.exportChart();
        },
        setExtremes: function setExtremes() {
            var _this2 = this;

            var current_date = new Date();
            var min = void 0;
            var max = void 0;
            if (this.year == current_date.getFullYear()) {

                if (this.period == 'AC') {
                    min = new Date(this.year, 0, 1);
                } else {
                    var date_aux = new Date(current_date);
                    min = new Date(date_aux.setMonth(date_aux.getMonth() - this.period));
                }
                max = current_date;
            } else {
                min = new Date(this.year, 0, 1);
                max = new Date(this.year, 11, 1);
            }

            setTimeout(function () {
                _this2.chart.xAxis[0].setExtremes(min.getTime(), max.getTime());
            }, 500);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        period: function period() {
            return this.filters.period;
        },
        year: function year() {
            return this.filters.year;
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filters'])),
    data: function data() {
        return {
            chart: undefined,
            options: {
                chart: {
                    renderTo: this.id,
                    alignTicks: false,
                    height: 130,
                    borderColor: '#C9625F',
                    backgroundColor: 'transparent',
                    spacingTop: 0,
                    spacingBottom: 5,
                    spacingLeft: 0,
                    spacingRight: 0
                },
                rangeSelector: {
                    allButtonsEnabled: true,
                    selected: 4,
                    inputEnabled: false,
                    buttonTheme: {
                        fill: '#505053',
                        stroke: '#000000',
                        style: {
                            color: '#CCC'
                        },
                        states: {
                            hover: {
                                fill: '#707073',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            },
                            select: {
                                fill: '#000003',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    },
                    inputBoxBorderColor: '#505053',
                    inputStyle: {
                        backgroundColor: '#333',
                        color: 'silver'
                    },
                    labelStyle: {
                        color: 'silver'
                    },
                    buttons: [{
                        type: 'month',
                        count: 3,
                        text: '3m'
                    }, {
                        type: 'month',
                        count: 6,
                        text: '6m'
                    }, {
                        type: 'ytd',
                        text: 'YTD'
                    }, {
                        type: 'year',
                        count: 1,
                        text: '1y'
                    }, {
                        type: 'all',
                        text: 'All'
                    }]
                },
                credits: {
                    enabled: false
                },
                navigation: {
                    buttonOptions: {
                        enabled: false
                    }
                },
                scrollbar: {
                    enabled: false
                },
                navigator: {
                    enabled: false
                },

                colors: ['#6b91c9'],
                xAxis: {
                    minRange: 3,
                    lineColor: '#e1e1e1',
                    tickColor: '#EFEFEF',
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    }
                },
                yAxis: {
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    }
                },
                series: [{
                    type: 'line',
                    name: this.typeValue,
                    dataGrouping: {
                        units: [['week', [1]], ['month', [1, 2, 3, 4, 6]]]
                    }
                }],
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    }
                },
                exporting: {
                    chartOptions: {
                        xAxis: {
                            lineColor: '#e1e1e1',
                            tickColor: '#EFEFEF',
                            labels: {
                                style: {
                                    color: '#000'
                                }
                            }
                        },
                        yAxis: {
                            gridLineColor: '#e1e1e1',
                            labels: {
                                style: {
                                    color: '#000'
                                }
                            }
                        }
                    }
                }
            },
            range_selector: 0
        };
    },

    props: {
        data: {
            default: [],
            type: Array
        },
        id: {
            type: String
        },
        typeValue: {
            type: String
        },
        header: {
            type: String
        }
    }
});

/***/ }),

/***/ "RbX5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_components_Csv__ = __webpack_require__("Iv/n");










__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_js_popover___default.a);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'charts',
    props: {
        id: String
    },
    components: {
        Help: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_components_Help__["a" /* default */],
        Csv: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_components_Csv__["a" /* default */]
    },
    data: function data() {
        var _chartOptions;

        return {
            showModalFile: false,
            titleChart: this.$t("229"),
            tableData: '',
            activeDGroup: false,
            activeDefect: false,
            activeMpf: false,
            chart: undefined,
            group: 'defect',
            grid_pg: 0,
            selected_defect: '',
            defects: [],
            chartOptions: (_chartOptions = {
                colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8', '#dd6b7f', '#0984e3', '#ffeaa7', '#e84393', '#55efc4', '#636e72', '#ff7675', '#f1c40f', '#34495e'],
                chart: {
                    type: 'pie',
                    renderTo: this.id,
                    marginTop: 35,
                    backgroundColor: 'rgba(0,0,0,0)',
                    style: {
                        fontFamily: '\'Unica One\', sans-serif'
                    },
                    plotBorderColor: '#606063',
                    options3d: {
                        enabled: true,
                        alpha: 45,
                        beta: 0
                    }
                },
                title: {
                    text: '',
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase',
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }
                },
                subtitle: {
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase'
                    }
                },
                accessibility: {
                    announceNewData: {
                        enabled: true
                    },
                    point: {
                        valueSuffix: '%'
                    }
                },
                xAxis: {
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    title: {
                        style: {
                            color: '#A0A0A3'
                        }
                    }
                },
                yAxis: {
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    tickWidth: 1,
                    title: {
                        style: {
                            color: '#A0A0A3'
                        }
                    }
                },
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    }
                },
                plotOptions: {
                    pie: {
                        borderWidth: 0,
                        size: '80%',
                        depth: 65
                    },
                    series: {
                        cursor: 'pointer',
                        innerSize: '50%',
                        events: {
                            click: this.loadGrid
                        },
                        dataLabels: {
                            enabled: true,
                            format: '<span style="color: #fff">{point.name}: {point.percentage:.1f}%</span>',
                            color: '#F0F0F3',
                            style: {
                                fontSize: '12px'
                            }
                        },
                        marker: {
                            lineColor: '#333'
                        }
                    },
                    boxplot: {
                        fillColor: '#505053'
                    },
                    candlestick: {
                        lineColor: 'white'
                    },
                    errorbar: {
                        color: 'white'
                    }
                }
            }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'tooltip', {
                headerFormat: '',
                pointFormat: '<span style="color:{point.color}">{point.name}</span><br/><b>{point.y}</b>',
                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                style: {
                    color: '#F0F0F0'
                }
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'series', [{
                name: 'defects',
                id: 'defects',
                colorByPoint: true,
                data: []
            }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'legend', {
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                itemStyle: {
                    color: '#E0E0E3'
                },
                itemHoverStyle: {
                    color: '#FFF'
                },
                itemHiddenStyle: {
                    color: '#606063'
                },
                title: {
                    style: {
                        color: '#C0C0C0',
                        fontSize: '12px',
                        fontWeight: 'normal'
                    }
                }
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'credits', {
                style: {
                    color: '#666'
                }
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'labels', {
                style: {
                    color: '#707073'
                }
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'drilldown', {
                activeAxisLabelStyle: {
                    color: '#F0F0F3'
                },
                activeDataLabelStyle: {
                    color: '#F0F0F3'
                }
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'navigation', {
                buttonOptions: {
                    symbolStroke: '#DDDDDD',
                    theme: {
                        fill: '#505053'
                    }
                }
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'rangeSelector', {
                buttonTheme: {
                    fill: '#505053',
                    stroke: '#000000',
                    style: {
                        color: '#CCC'
                    },
                    states: {
                        hover: {
                            fill: '#707073',
                            stroke: '#000000',
                            style: {
                                color: 'white'
                            }
                        },
                        select: {
                            fill: '#000003',
                            stroke: '#000000',
                            style: {
                                color: 'white'
                            }
                        }
                    }
                },
                inputBoxBorderColor: '#505053',
                inputStyle: {
                    backgroundColor: '#333',
                    color: 'silver'
                },
                labelStyle: {
                    color: 'silver'
                }
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'navigator', {
                handles: {
                    backgroundColor: '#666',
                    borderColor: '#AAA'
                },
                outlineColor: '#CCC',
                maskFill: 'rgba(255,255,255,0.1)',
                series: {
                    color: '#7798BF',
                    lineColor: '#A6C7ED'
                },
                xAxis: {
                    gridLineColor: '#505053'
                }
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'scrollbar', {
                barBackgroundColor: '#808083',
                barBorderColor: '#808083',
                buttonArrowColor: '#CCC',
                buttonBackgroundColor: '#606063',
                buttonBorderColor: '#606063',
                rifleColor: '#FFF',
                trackBackgroundColor: '#404043',
                trackBorderColor: '#404043'
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'exporting', { enabled: false }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'credits', {
                enabled: false
            }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'loading', {
                labelStyle: {
                    color: 'black',
                    textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
                },
                style: {
                    backgroundColor: 'none',
                    opacity: 1,
                    marginTop: '20px'
                }
            }), _chartOptions) };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_5__utils_mixin__["a" /* default */]],
    mounted: function mounted() {
        var self = this;
        self.activeDGroup = false;
        self.activeDefect = true;
        self.activeMpf = false;
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['changeGrid']), {
        getData: function getData() {

            var API = "https://api.semeq.com.br/";
            var ENDPOINT = 'v1/mysemeq-ambev/get-defect-chart?group=' + this.group;
            var self = this;

            this.$refs.chart.chart.showLoading();

            __WEBPACK_IMPORTED_MODULE_4_axios___default()({ method: 'GET', url: API + ENDPOINT, params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filtersOn, { 'online': 1, plant: this.filtersOn.planta, area: this.filtersOn.area_f, sector: this.filtersOn.sector_f, component: this.filtersOn.subset }), headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
                self.tableData = resp.data;
                self.$refs.chart.chart.hideLoading();
            }).catch(function (err) {
                self.ApiErrorHandler(self, error.response.data.status_code);
                self.$refs.chart.chart.showLoading('Error');
            });
        },
        setChartData: function setChartData() {
            var self = this;
            var res = self.tableData;
            var values = [];

            for (var key in res) {
                values.push({ 'name': res[key].text, 'y': res[key].total });
            }
            self.chartOptions.series[0].data = values;
        },
        getCsvAll: function getCsvAll() {
            var self = this;
            self.showModalFile = true;
            var defect = self.group;
            var file = 'csv';
            var API = "https://api.semeq.com.br/";

            var ENDPOINT = 'v1/mysemeq-ambev/get-defect?group=' + this.group + '&year=' + this.filtersOn.year + '&period=' + this.filtersOn.period + '&plant=' + this.filtersOn.planta + '&status=&area=' + this.filtersOn.area_f + '&sector=' + this.filtersOn.sector_f + '&machine=' + this.filtersOn.machine + '&component=' + this.filtersOn.subset + '&online=1&pg=0&sort=&order=asc&file=' + file;

            var name_chart_file = this.$t("360");

            __WEBPACK_IMPORTED_MODULE_4_axios___default()({
                method: 'GET',
                url: API + ENDPOINT,
                responseType: 'blob',
                headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token')
                } }).then(function (_ref) {
                var data = _ref.data;

                var url = window.URL.createObjectURL(new Blob([data]));
                var link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', name_chart_file + '.csv');
                document.body.appendChild(link);
                link.click();
                self.showModalFile = false;
            }).catch(function (error) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        getPoints: function getPoints(group) {
            var self = this;
            self.group = group;

            if (self.group == 'defect_group') {
                self.activeDGroup = true;
                self.activeDefect = false;
                self.activeMpf = false;
            }
            if (self.group == 'defect') {
                self.activeDGroup = false;
                self.activeDefect = true;
                self.activeMpf = false;
            }
            if (self.group == 'mpf') {
                self.activeDGroup = false;
                self.activeDefect = false;
                self.activeMpf = true;
            }

            var data = [];

            var API = "https://api.semeq.com.br/";
            var ENDPOINT = 'v1/mysemeq-ambev/get-defect-chart?group=' + this.group;

            this.$refs.chart.chart.showLoading();

            __WEBPACK_IMPORTED_MODULE_4_axios___default()({ method: 'GET', url: API + ENDPOINT, params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filtersOn, { 'online': 1, plant: this.filtersOn.planta, area: this.filtersOn.area_f, sector: this.filtersOn.sector_f }), headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {
                for (var i in response.data) {
                    data.push({
                        'name': response.data[i].text,
                        'y': response.data[i].total
                    });
                }

                self.chartOptions.series[0].data = data;
                self.group = group;

                self.$refs.chart.chart.hideLoading();
            }).catch(function (error) {
                self.ApiErrorHandler(self, error.response.data.status_code);
                self.$refs.chart.chart.showLoading('Error');
            });
        },
        loadGrid: function loadGrid(event) {
            var defect = event.point.name;
            var point_name = event.point.name;
            var NAME_CHART = this.$t("360") + ' - ' + point_name.toUpperCase();

            var region = this.filtersOn.region || 'GLB';

            var ENDPOINT = 'v1/mysemeq-ambev/get-defect?group=' + this.group + '&year=' + this.filtersOn.year + '&period=' + this.filtersOn.period + '&corp=' + this.filtersOn.corp + '&region=' + region + '&plant=' + this.filtersOn.planta + '&status=' + defect + '&area=' + this.filtersOn.area_f + '&sector=' + this.filtersOn.sector_f + '&machine=' + this.filtersOn.machine + '&component=' + this.filtersOn.subset + '&online=1';

            var grid = {
                title: defect,
                url: ENDPOINT,
                name_chart: NAME_CHART,
                columns: {
                    "rows": '',
                    "plant": this.$t("310"),
                    "area": this.$t("311"),
                    "sector": this.$t("312"),
                    "component": this.$t("313"),
                    "component_tag": this.$t("314"),
                    "component_type_en": this.$t("315"),
                    "machine": this.$t("316"),
                    "machine_tag": this.$t("317"),
                    "status_txt_en": this.$t("318"),
                    "report_number": this.$t("319"),
                    "approved_datetime": this.$t("320"),
                    "technique_en": this.$t("321"),
                    "ref_date": this.$t("322"),
                    "link": this.$t("323"),
                    "link_rci": this.$t("324")
                },
                show: true,
                titleHelp: 'Grid - ' + this.$t("360"),
                txtHelp: this.$t("361")
            };

            if (this.filtersOn.plant) {
                grid.title += ' - ' + this.filtersOn.plant_name;
                delete grid.columns['plant'];
            } else if (this.filtersOn.region) {
                grid.title += ' - ' + this.filtersOn.region;
            }

            this.changeGrid(grid);
        }
    }),
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['filtersOn'])),
    watch: {
        filtersOn: function filtersOn(newValue) {
            this.getData();
        },
        tableData: function tableData() {
            this.setChartData();
        }
    }
});

/***/ }),

/***/ "RfKX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fullcalendar__ = __webpack_require__("olwm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_fullcalendar__);









__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default.a);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'charts',

    props: {
        online: {
            type: Boolean
        }
    },
    components: {
        Help: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__["a" /* default */]
    },
    data: function data() {
        return {
            titleChart: this.$t("130"),
            tableData: [],
            chartOptions: {
                chart: {
                    type: 'column',
                    backgroundColor: 'rgba(0,0,0,0)',
                    style: {
                        fontFamily: '\'Unica One\', sans-serif'
                    },
                    plotBorderColor: '#606063'
                },
                title: {
                    text: '',
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase',
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }
                },
                subtitle: {
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase'
                    }
                },
                xAxis: {
                    categories: [],
                    crosshair: true,
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        },
                        overflow: false
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    title: {
                        style: {
                            color: '#A0A0A3'
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: this.$t("131"),
                        style: {
                            color: '#A0A0A3',
                            fontSize: '12px'
                        }
                    },
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    tickWidth: 1
                },
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    },
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y} </b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true,
                            color: '#F0F0F3',
                            style: {
                                fontSize: '13px'
                            }
                        },
                        marker: {
                            lineColor: '#333'
                        },
                        events: {
                            click: this.loadGrid
                        },
                        cursor: 'pointer'
                    },
                    boxplot: {
                        fillColor: '#505053'
                    },
                    candlestick: {
                        lineColor: 'white'
                    },
                    errorbar: {
                        color: 'white'
                    },
                    column: {
                        pointPadding: 0.1,
                        borderWidth: 0
                    }
                },
                legend: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    itemStyle: {
                        color: '#E0E0E3'
                    },
                    itemHoverStyle: {
                        color: '#FFF'
                    },
                    itemHiddenStyle: {
                        color: '#606063'
                    },
                    title: {
                        style: {
                            color: '#C0C0C0',
                            fontSize: '12px'
                        }
                    }
                },
                labels: {
                    style: {
                        color: '#707073'
                    }
                },
                drilldown: {
                    activeAxisLabelStyle: {
                        color: '#F0F0F3'
                    },
                    activeDataLabelStyle: {
                        color: '#F0F0F3'
                    }
                },
                navigation: {
                    buttonOptions: {
                        symbolStroke: '#DDDDDD',
                        theme: {
                            fill: '#505053'
                        }
                    }
                },

                rangeSelector: {
                    buttonTheme: {
                        fill: '#505053',
                        stroke: '#000000',
                        style: {
                            color: '#CCC'
                        },
                        states: {
                            hover: {
                                fill: '#707073',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            },
                            select: {
                                fill: '#000003',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    },
                    inputBoxBorderColor: '#505053',
                    inputStyle: {
                        backgroundColor: '#333',
                        color: 'silver'
                    },
                    labelStyle: {
                        color: 'silver'
                    }
                },
                navigator: {
                    handles: {
                        backgroundColor: '#666',
                        borderColor: '#AAA'
                    },
                    outlineColor: '#CCC',
                    maskFill: 'rgba(255,255,255,0.1)',
                    series: {
                        color: '#7798BF',
                        lineColor: '#A6C7ED'
                    },
                    xAxis: {
                        gridLineColor: '#505053'
                    }
                },
                scrollbar: {
                    barBackgroundColor: '#808083',
                    barBorderColor: '#808083',
                    buttonArrowColor: '#CCC',
                    buttonBackgroundColor: '#606063',
                    buttonBorderColor: '#606063',
                    rifleColor: '#FFF',
                    trackBackgroundColor: '#404043',
                    trackBorderColor: '#404043'
                },
                series: [{
                    name: this.$t("132"),
                    color: '#90ED7D',
                    data: []

                }, {
                    name: this.$t("133"),
                    color: '#F45B5B',
                    data: []

                }],
                exporting: { enabled: false },
                credits: {
                    enabled: false
                },
                loading: {
                    labelStyle: {
                        color: 'black',
                        textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
                    },
                    style: {
                        backgroundColor: 'none',
                        opacity: 1
                    }
                }

            }
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4__utils_mixin__["a" /* default */]],
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['changeGrid']), {
        loadGrid: function loadGrid(event) {
            var online = '';
            if (this.online == false) {
                online = 0;

                var evento = event.point.series.name;

                var filtro = '';
                if (evento == 'Fechado') {
                    filtro = 'CLOSED';
                }
                if (evento == 'Atrasado') {
                    filtro = 'PENDING';
                }
                if (evento == 'Closed') {
                    filtro = 'CLOSED';
                }
                if (evento == 'Late') {
                    filtro = 'PENDING';
                }

                var filter = !filtro ? event.point.series.name : filtro;


                var area_name = '';
                var planta = '';
                var plant_name = '';
                var region = '';

                if (this.filters.plant) {
                    planta = this.filters.plant;
                    if (!this.filters.area) {
                        area_name = event.point.category;
                    }
                    plant_name = '';
                    region = '';
                } else if (this.filters.region) {
                    planta = '';
                    area_name = '';
                    plant_name = event.point.category;
                    region = this.filters.region;
                } else {
                    region = event.point.category;
                }

                var feedback = filter;

                var NAME_CHART = event.point.category + ' - ' + ('' + evento.toUpperCase());

                if (feedback == 'No data') return;

                var ENDPOINT = 'v1/mysemeq-ambev/get-pareto-rdps-grid?year=' + this.filters.year + '&period=' + this.filters.period + '&plant=' + planta + '&plant_name=' + plant_name + '&region=' + region + '&technique=' + (this.online ? '' : this.filters.technique) + '&area=' + this.filters.area + '&sector=' + this.filters.sector + '&machine=' + this.filters.machine + '&component=' + this.filters.component + '&feedback_status=' + feedback + '&area_name=' + area_name + '&online=' + online;

                var grid = {
                    totalDados: event.point.y,
                    title: NAME_CHART,
                    url: ENDPOINT,
                    name_chart: NAME_CHART,
                    columns: {
                        "rows": '',
                        "plant": this.$t("310"),
                        "area": this.$t("311"),
                        "sector": this.$t("312"),
                        "component": this.$t("313"),
                        "component_tag": this.$t("314"),
                        "component_type_en": this.$t("315"),
                        "machine": this.$t("316"),
                        "machine_tag": this.$t("317"),
                        "status_txt_en": this.$t("318"),
                        "report_number": this.$t("319"),
                        "approved_datetime": this.$t("320"),
                        "technique_en": this.$t("321"),
                        "feedback_status_en": this.$t("333"),
                        "link": this.$t("323"),
                        "link_rci": this.$t("324")
                    },
                    show: true,
                    titleHelp: 'Grid - ' + this.$t("354"),
                    txtHelp: this.$t("355")
                };

                if (this.filters.plant) {
                    delete grid.columns['plant'];
                }

                this.changeGrid(grid);
            } else {
                online = 1;

                var _evento = event.point.series.name;

                var _filtro = '';
                if (_evento == 'Fechado') {
                    _filtro = 'CLOSED';
                }
                if (_evento == 'Atrasado') {
                    _filtro = 'PENDING';
                }
                if (_evento == 'Closed') {
                    _filtro = 'CLOSED';
                }
                if (_evento == 'Late') {
                    _filtro = 'PENDING';
                }

                var _filter = !_filtro ? event.point.series.name : _filtro;


                var _area_name = '';
                var _planta = '';
                var _plant_name = '';
                var _region = '';

                if (this.filtersOn.planta) {
                    _planta = this.filtersOn.planta;
                    if (!this.filtersOn.area) {
                        _area_name = event.point.category;
                    }
                    _plant_name = '';
                    _region = '';
                } else if (this.filtersOn.region) {
                    _planta = '';
                    _area_name = '';
                    _plant_name = event.point.category;
                    _region = this.filtersOn.region;
                } else {
                    _region = event.point.category;
                }

                var _feedback = _filter;

                var _NAME_CHART = event.point.category + ' - ' + ('' + _evento.toUpperCase());

                if (_feedback == 'No data') return;

                var _ENDPOINT = 'v1/mysemeq-ambev/get-pareto-rdps-grid?year=' + this.filtersOn.year + '&period=' + this.filtersOn.period + '&plant=' + _planta + '&plant_name=' + _plant_name + '&region=' + _region + '&technique=' + (this.online ? '' : this.filters.technique) + '&area=' + this.filtersOn.area_f + '&sector=' + this.filtersOn.sector_f + '&machine=' + this.filtersOn.machine + '&component=' + this.filtersOn.subset + '&feedback_status=' + _feedback + '&area_name=' + _area_name + '&online=' + online;

                var _grid = {
                    totalDados: event.point.y,
                    title: _NAME_CHART,
                    url: _ENDPOINT,
                    name_chart: _NAME_CHART,
                    columns: {
                        "rows": '',
                        "plant": this.$t("310"),
                        "area": this.$t("311"),
                        "sector": this.$t("312"),
                        "component": this.$t("313"),
                        "component_tag": this.$t("314"),
                        "component_type_en": this.$t("315"),
                        "machine": this.$t("316"),
                        "machine_tag": this.$t("317"),
                        "status_txt_en": this.$t("318"),
                        "report_number": this.$t("319"),
                        "approved_datetime": this.$t("320"),
                        "technique_en": this.$t("321"),
                        "feedback_status_en": this.$t("333"),
                        "link": this.$t("323"),
                        "link_rci": this.$t("324")
                    },
                    show: true,
                    titleHelp: 'Grid - ' + this.$t("354"),
                    txtHelp: this.$t("355")
                };

                if (this.filtersOn.planta) {
                    delete _grid.columns['plant'];
                }

                this.changeGrid(_grid);
            }
        },
        getData: function getData() {
            var API = "https://api.semeq.com.br/";
            var ENDPOINT = 'v1/mysemeq-ambev/get-pareto-rdps';

            var filters = {};
            if (this.online) {
                filters = this.filtersOn;
            } else {
                filters = this.filters;
            }

            filters['online'] = 0;
            if (this.online) {
                filters['online'] = 1;
                filters['plant'] = filters['planta'];
                filters['area'] = filters['area_f'];
                filters['sector'] = filters['sector_f'];
                filters['component'] = filters['subset'];
            }

            this.$refs.chart.chart.showLoading();

            var self = this;
            __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ENDPOINT, params: filters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
                self.tableData = resp.data;
                self.$refs.chart.chart.hideLoading();
            }).catch(function (err) {
                self.ApiErrorHandler(self, error.response.data.status_code);
                self.$refs.chart.chart.showLoading('Error');
            });
        },
        setChartData: function setChartData() {
            var self = this;
            var res = self.tableData;

            self.chartOptions.xAxis.categories = [];
            self.chartOptions.series[0].data = [];
            self.chartOptions.series[1].data = [];
            if (res) {
                res.forEach(function (it) {

                    self.chartOptions.xAxis.categories.push(it[0]);

                    self.chartOptions.series[0].data.push(it[1]['FECHADO'] || 0);

                    self.chartOptions.series[1].data.push(it[1]['PENDENTE'] || 0);
                });
            }
        }
    }),
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filters', 'filtersOn'])),
    watch: {
        filters: function filters(newValue) {
            this.getData();
        },
        filtersOn: function filtersOn(newValue) {
            this.getData();
        },
        tableData: function tableData() {
            this.setChartData();
        }
    }
});

/***/ }),

/***/ "Rh7U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rrpr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['firstName', 'lastName', 'email'])),
  data: function data() {
    return {
      model: {
        firstName: '',
        lastName: '',
        email: ''
      },
      modelValidations: {
        firstName: {
          min: 5
        },
        lastName: {
          min: 5
        },
        email: {
          required: true,
          email: true
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    }
  }
});

/***/ }),

/***/ "S1zQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpplanning","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("150")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.$t("151"))+"\n      "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpplanning.right",arg:"helpplanning",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-sm bt-change-chart",attrs:{"id":"buttons","role":"group","aria-label":"Buttons"}},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.changeTypeChartLine()}}},[_c('small',[_vm._v(_vm._s(_vm.$t("152")))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.changeTypeChartColumn()}}},[_c('small',[_vm._v(_vm._s(_vm.$t("153")))])])]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S3qy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpplanning","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("235"))+"  ")])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.$t("236"))+" \n      "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpplanning.right",arg:"helpplanning",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-sm bt-change-chart",attrs:{"id":"buttons","role":"group","aria-label":"Buttons"}},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.changeTypeChartLine()}}},[_c('small',[_vm._v(_vm._s(_vm.$t("237"))+" ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.changeTypeChartColumn()}}},[_c('small',[_vm._v(_vm._s(_vm.$t("238")))])])]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S5pc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history-chart"},[_c('div',{staticClass:"content-1",staticStyle:{"height":"180px"}},[_c('div',{staticClass:"chart-content-div-header"},[_c('h4',[_c('small',[_c('i',{staticClass:"glyphicon glyphicon-calendar"}),_vm._v("   "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.header)}})]),_vm._v(" "),_c('small',[_c('i',{staticClass:"glyphicon glyphicon-print my-export",staticStyle:{"float":"right"},on:{"click":_vm.exporting}})])])]),_vm._v(" "),_c('div',{staticClass:"chart-content-div"},[_c('div',{attrs:{"id":_vm.id}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S8VE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "SFlA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");










__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_js_popover___default.a);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'charts',
  components: {
    Help: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_components_Help__["a" /* default */]
  },
  data: function data() {
    var _chartOptions;

    return {
      titleChart: this.$t("226"),
      tableData: [],
      chartOptions: (_chartOptions = {
        chart: {
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },
        title: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '16px',
            fontWeight: 'bold'
          }
        },
        subtitle: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase'
          }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        xAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        yAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },
        plotOptions: {
          pie: {
            borderWidth: 0,
            size: '80%',
            dataLabels: {
              distance: 15
            },
            depth: 55
          },
          series: {
            innerSize: '50%',
            dataLabels: {
              enabled: true,
              format: '<span style="color:#fff ">{point.name}:<br></span><b style="color:#fff "> {point.y}</span>',
              color: '#F0F0F3',
              style: {
                fontSize: '13px'
              }
            },
            marker: {
              lineColor: '#333'
            },
            events: {
              click: this.loadGrid
            }
          },
          boxplot: {
            fillColor: '#505053'
          },
          candlestick: {
            lineColor: 'white'
          },
          errorbar: {
            color: 'white'
          }
        },
        legend: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          itemStyle: {
            color: '#E0E0E3'
          },
          itemHoverStyle: {
            color: '#FFF'
          },
          itemHiddenStyle: {
            color: '#606063'
          },
          title: {
            style: {
              color: '#C0C0C0',
              fontSize: '12px'
            }
          }
        },
        credits: {
          style: {
            color: '#666'
          }
        },
        labels: {
          style: {
            color: '#707073'
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            color: '#F0F0F3'
          },
          activeDataLabelStyle: {
            color: '#F0F0F3'
          }
        },
        navigation: {
          buttonOptions: {
            symbolStroke: '#DDDDDD',
            theme: {
              fill: '#505053'
            }
          }
        },

        rangeSelector: {
          buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: {
              color: '#CCC'
            },
            states: {
              hover: {
                fill: '#707073',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              },
              select: {
                fill: '#000003',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              }
            }
          },
          inputBoxBorderColor: '#505053',
          inputStyle: {
            backgroundColor: '#333',
            color: 'silver'
          },
          labelStyle: {
            color: 'silver'
          }
        },
        navigator: {
          handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
          },
          outlineColor: '#CCC',
          maskFill: 'rgba(255,255,255,0.1)',
          series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
          },
          xAxis: {
            gridLineColor: '#505053'
          }
        },
        scrollbar: {
          barBackgroundColor: '#808083',
          barBorderColor: '#808083',
          buttonArrowColor: '#CCC',
          buttonBackgroundColor: '#606063',
          buttonBorderColor: '#606063',
          rifleColor: '#FFF',
          trackBackgroundColor: '#404043',
          trackBorderColor: '#404043'
        },
        series: [{
          name: "SAMPLES",
          colorByPoint: true,
          data: []
        }]
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'drilldown', {
        series: []
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'exporting', { enabled: false }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'credits', {
        enabled: false
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'loading', {
        labelStyle: {
          color: 'black',
          textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
        },
        style: {
          backgroundColor: 'none',
          opacity: 1,
          marginTop: '20px'
        }
      }), _chartOptions) };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__utils_mixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['changeGridOnline']), {
    loadGrid: function loadGrid(event) {
      var status = event.point.drilldown;
      var NAME_CHART = 'POINT_ALARME_' + event.point.name;
      var ENDPOINT = 'v1/mysemeq-ambev/get-sensor-status-alarme-24-grid?planta=' + this.filtersOn.planta + '&status=' + status + '&area_f=' + this.filtersOn.area_f + '&machine=' + this.filtersOn.machine + '&subset=' + this.filtersOn.subset;

      var gridOnline = {
        title: event.point.name,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
          "area": ['Area'],
          "setor": ['Sector'],
          "conj": ['Machine', 'conjunto'],
          "conj_tag": ['Machine TAG'],
          "equip": ['Component'],
          "equip_tag": ['Component TAG'],
          "ponto": ['Point'],
          "serie": ['Serie'],
          "versao": ['Firmware version'],
          "data": ['Sample date'],
          "bateria": ['Battery level'],
          "sinal_nivel": ['BLE signal'],
          "node": ['Node', 'nodo'],
          "total": ['Total'],
          "status": ['Status'],
          "rdps": ['DR']
        },
        show: true
      };

      if (this.filtersOn.planta) {
        gridOnline.title += ' - ' + this.filtersOn.planta_name;
        delete gridOnline.columns['planta'];
      }

      this.changeGridOnline(gridOnline);
    },
    getData: function getData() {
      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/get-sensor-status-alarme-24';
      var self = this;

      this.$refs.chart.chart.showLoading();

      __WEBPACK_IMPORTED_MODULE_4_axios___default()({ method: 'GET', url: API + ENDPOINT, params: this.filtersOn, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        self.tableData = resp.data.result;
        self.$refs.chart.chart.hideLoading();
      }).catch(function (err) {
        self.$refs.chart.chart.showLoading('Error');

        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    },
    setChartData: function setChartData() {
      var self = this;
      var res = self.tableData;
      var values = [];
      for (var key in res) {
        if (res[key].status == 1) {
          var color = '#90ed7d';
          var name = 'Normal';
        }
        if (res[key].status == 2) {
          var color = '#e4d354';
          var name = 'Alert';
        }
        if (res[key].status == 3) {
          var color = '#f45b5b';
          var name = 'Alarm';
        }
        if (res[key].status == 4) {
          var color = '#6b91c9';
          var name = 'N/A';
        }

        values.push({ 'name': name, 'y': res[key].total, 'drilldown': res[key].status, 'color': color });
      }
      self.chartOptions.series[0].data = values;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['filtersOn'])),
  watch: {
    filtersOn: function filtersOn(newValue) {
      this.getData();
    },
    tableData: function tableData() {
      this.setChartData();
    }
  }
});

/***/ }),

/***/ "Ss98":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SxXj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helptop","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("277"))+" ")])])])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showOtherChart),expression:"!showOtherChart"}]},[_c('div',{staticClass:"title-charts title-bt-help"},[_vm._v(_vm._s(_vm.$t("278"))+"\n        "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helptop.bottom",arg:"helptop",modifiers:{"bottom":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('ChartsAlarme',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOtherChart),expression:"showOtherChart"}]})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Dashboard_Overview_vue__ = __webpack_require__("uFAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Dashboard_Stats_vue__ = __webpack_require__("+GID");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Pages_UserProfile_vue__ = __webpack_require__("9gNx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Pages_TimeLinePage_vue__ = __webpack_require__("4d5k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Pages_Login_vue__ = __webpack_require__("WI53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Pages_Register_vue__ = __webpack_require__("sMOY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Pages_Lock_vue__ = __webpack_require__("duHq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Components_Buttons_vue__ = __webpack_require__("fP9K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Components_GridSystem_vue__ = __webpack_require__("671N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Components_Panels_vue__ = __webpack_require__("i0bx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Components_SweetAlert_vue__ = __webpack_require__("ribu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Components_Notifications_vue__ = __webpack_require__("+VxC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Components_Icons_vue__ = __webpack_require__("RM11");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Components_Typography_vue__ = __webpack_require__("f6/7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Forms_RegularForms_vue__ = __webpack_require__("PAWa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Forms_ExtendedForms_vue__ = __webpack_require__("5xQ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Forms_ValidationForms_vue__ = __webpack_require__("5Bu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Forms_Wizard_vue__ = __webpack_require__("eSiI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Tables_RegularTables_vue__ = __webpack_require__("yg6A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Tables_ExtendedTables_vue__ = __webpack_require__("jJHM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Tables_PaginatedTables_vue__ = __webpack_require__("Kakj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Pages_Home_vue__ = __webpack_require__("kMAn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Pages_Online_vue__ = __webpack_require__("epsa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Pages_Online2_vue__ = __webpack_require__("8sR8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Pages_Release_vue__ = __webpack_require__("0efX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Pages_Language_vue__ = __webpack_require__("GaK2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_Dashboard_Views_Pages_Tour_vue__ = __webpack_require__("IZSz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_components_Dashboard_Views_Pages_Testes_vue__ = __webpack_require__("faDc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_Crud_ComponentType_vue__ = __webpack_require__("KkWw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_src_store__ = __webpack_require__("IcnI");












































__WEBPACK_IMPORTED_MODULE_31_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_32_vue_router__["a" /* default */]);

var ifNotAuthenticated = function ifNotAuthenticated(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_33_src_store__["a" /* default */].getters.isAuthenticated) {
    next();
    return;
  }
  next('/');
};

var ifAuthenticated = function ifAuthenticated(to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_33_src_store__["a" /* default */].getters.isAuthenticated) {
    next();
    return;
  }
  next('/login');
};

var componentsMenu = {
  path: '/components',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/components/buttons',
  children: [{
    path: 'buttons',
    name: 'Buttons',
    component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Components_Buttons_vue__["a" /* default */]
  }, {
    path: 'grid-system',
    name: 'Grid System',
    component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Components_GridSystem_vue__["a" /* default */]
  }, {
    path: 'panels',
    name: 'Panels',
    component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Components_Panels_vue__["a" /* default */]
  }, {
    path: 'sweet-alert',
    name: 'Sweet Alert',
    component: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Components_SweetAlert_vue__["a" /* default */]
  }, {
    path: 'notifications',
    name: 'Notifications',
    component: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Components_Notifications_vue__["a" /* default */]
  }, {
    path: 'icons',
    name: 'Icons',
    component: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Components_Icons_vue__["a" /* default */]
  }, {
    path: 'typography',
    name: 'Typography',
    component: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Components_Typography_vue__["a" /* default */]
  }]
};
var formsMenu = {
  path: '/forms',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/forms/regular',
  children: [{
    path: 'regular',
    name: 'Regular Forms',
    component: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Forms_RegularForms_vue__["a" /* default */]
  }, {
    path: 'extended',
    name: 'Extended Forms',
    component: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Forms_ExtendedForms_vue__["a" /* default */]
  }, {
    path: 'validation',
    name: 'Validation Forms',
    component: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Forms_ValidationForms_vue__["a" /* default */]
  }, {
    path: 'wizard',
    name: 'Wizard',
    component: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Forms_Wizard_vue__["a" /* default */]
  }]
};

var tablesMenu = {
  path: '/table-list',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/table-list/regular',
  children: [{
    path: 'regular',
    name: 'Regular Tables',
    component: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Tables_RegularTables_vue__["a" /* default */]
  }, {
    path: 'extended',
    name: 'Extended Tables',
    component: __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Tables_ExtendedTables_vue__["a" /* default */]
  }, {
    path: 'paginated',
    name: 'Paginated Tables',
    component: __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Tables_PaginatedTables_vue__["a" /* default */]
  }]
};

var pagesMenu = {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/home',
  children: [{
    path: 'home',
    name: 'menu.saude.das.plantas',
    component: __WEBPACK_IMPORTED_MODULE_23_src_components_Dashboard_Views_Pages_Home_vue__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: 'online',
    name: 'Online',
    component: __WEBPACK_IMPORTED_MODULE_24_src_components_Dashboard_Views_Pages_Online_vue__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: 'online2',
    name: 'Online2',
    component: __WEBPACK_IMPORTED_MODULE_25_src_components_Dashboard_Views_Pages_Online2_vue__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: 'release',
    name: 'Release Notes',
    component: __WEBPACK_IMPORTED_MODULE_26_src_components_Dashboard_Views_Pages_Release_vue__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: 'language',
    name: 'Language',
    component: __WEBPACK_IMPORTED_MODULE_27_src_components_Dashboard_Views_Pages_Language_vue__["a" /* default */],
    beforeEnter: ifAuthenticated
  }]
};

var CadastroPage = {
  path: '/crud',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/crud/ComponentType',
  children: [{
    path: 'ComponentType',
    name: 'menu.crud.component.type',
    component: __WEBPACK_IMPORTED_MODULE_30_src_components_Dashboard_Views_Crud_ComponentType_vue__["a" /* default */]
  }]
};

var loginPage = {
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Pages_Login_vue__["a" /* default */],
  beforeEnter: ifNotAuthenticated
};

var registerPage = {
  path: '/register',
  name: 'Register',
  component: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Pages_Register_vue__["a" /* default */]
};

var lockPage = {
  path: '/lock',
  name: 'Lock',
  component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Pages_Lock_vue__["a" /* default */]
};

var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: '/home'
}, pagesMenu, loginPage, registerPage, { path: '*', component: __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__["a" /* default */] }];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "T54D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("v2o3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2cefc64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("A988");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2cefc64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TH7T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_cascader_css__ = __webpack_require__("Rh7U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_cascader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_cascader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_cascader__ = __webpack_require__("pkKZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_cascader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_cascader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_SidebarPlugin_UserMenu_vue__ = __webpack_require__("ij53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__ = __webpack_require__("BNE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__("NYxO");
















__WEBPACK_IMPORTED_MODULE_9_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_cascader___default.a);

__WEBPACK_IMPORTED_MODULE_9_vue___default.a.component('modal', {
  template: '#modal-template'
});

__WEBPACK_IMPORTED_MODULE_9_vue___default.a.directive('scroll', {
  inserted: function inserted(el, binding) {
    var f = function f(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f);
      }
    };
    window.addEventListener('scroll', f);
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showModal: false,
      options: [{
        value: 'guide',
        label: 'Guide',
        children: [{
          value: 'disciplines',
          label: 'Disciplines',
          children: [{
            value: 'consistency',
            label: 'Consistency'
          }, {
            value: 'feedback',
            label: 'Feedback'
          }, {
            value: 'efficiency',
            label: 'Efficiency'
          }, {
            value: 'controllability',
            label: 'Controllability'
          }]
        }, {
          value: 'navigation',
          label: 'Navigation',
          children: [{
            value: 'side nav',
            label: 'Side Navigation'
          }, {
            value: 'top nav',
            label: 'Top Navigation'
          }]
        }]
      }, {
        value: 'component',
        label: 'Component',
        children: [{
          value: 'basic',
          label: 'Basic',
          children: [{
            value: 'layout',
            label: 'Layout'
          }, {
            value: 'color',
            label: 'Color'
          }, {
            value: 'typography',
            label: 'Typography'
          }, {
            value: 'icon',
            label: 'Icon'
          }, {
            value: 'button',
            label: 'Button'
          }]
        }, {
          value: 'form',
          label: 'Form',
          children: [{
            value: 'radio',
            label: 'Radio'
          }, {
            value: 'checkbox',
            label: 'Checkbox'
          }, {
            value: 'input',
            label: 'Input'
          }, {
            value: 'input-number',
            label: 'InputNumber'
          }, {
            value: 'select',
            label: 'Select'
          }, {
            value: 'cascader',
            label: 'Cascader'
          }, {
            value: 'switch',
            label: 'Switch'
          }, {
            value: 'slider',
            label: 'Slider'
          }, {
            value: 'time-picker',
            label: 'TimePicker'
          }, {
            value: 'date-picker',
            label: 'DatePicker'
          }, {
            value: 'datetime-picker',
            label: 'DateTimePicker'
          }, {
            value: 'upload',
            label: 'Upload'
          }, {
            value: 'rate',
            label: 'Rate'
          }, {
            value: 'form',
            label: 'Form'
          }]
        }, {
          value: 'data',
          label: 'Data',
          children: [{
            value: 'table',
            label: 'Table'
          }, {
            value: 'tag',
            label: 'Tag'
          }, {
            value: 'progress',
            label: 'Progress'
          }, {
            value: 'tree',
            label: 'Tree'
          }, {
            value: 'pagination',
            label: 'Pagination'
          }, {
            value: 'badge',
            label: 'Badge'
          }]
        }, {
          value: 'notice',
          label: 'Notice',
          children: [{
            value: 'alert',
            label: 'Alert'
          }, {
            value: 'loading',
            label: 'Loading'
          }, {
            value: 'message',
            label: 'Message'
          }, {
            value: 'message-box',
            label: 'MessageBox'
          }, {
            value: 'notification',
            label: 'Notification'
          }]
        }, {
          value: 'navigation',
          label: 'Navigation',
          children: [{
            value: 'menu',
            label: 'NavMenu'
          }, {
            value: 'tabs',
            label: 'Tabs'
          }, {
            value: 'breadcrumb',
            label: 'Breadcrumb'
          }, {
            value: 'dropdown',
            label: 'Dropdown'
          }, {
            value: 'steps',
            label: 'Steps'
          }]
        }, {
          value: 'others',
          label: 'Others',
          children: [{
            value: 'dialog',
            label: 'Dialog'
          }, {
            value: 'tooltip',
            label: 'Tooltip'
          }, {
            value: 'popover',
            label: 'Popover'
          }, {
            value: 'card',
            label: 'Card'
          }, {
            value: 'carousel',
            label: 'Carousel'
          }, {
            value: 'collapse',
            label: 'Collapse'
          }]
        }]
      }, {
        value: 'resource',
        label: 'Resource',
        children: [{
          value: 'axure',
          label: 'Axure Components'
        }, {
          value: 'sketch',
          label: 'Sketch Templates'
        }, {
          value: 'docs',
          label: 'Design Documentation'
        }]
      }],
      selectedOptions3: ['component', 'data', 'tag']
    };
  },

  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_4__TopNavbar_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_5__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_6__Content_vue__["a" /* default */],
    UserMenu: __WEBPACK_IMPORTED_MODULE_7_src_components_UIComponents_SidebarPlugin_UserMenu_vue__["a" /* default */],
    MobileMenu: __WEBPACK_IMPORTED_MODULE_8_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__["a" /* default */]
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.addEventListener('scroll', this.handleScroll);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    handleScroll: function handleScroll() {
      var book = window.scrollY;

      var menu = {
        "book": book
      };
      this.changeMenu(menu);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapMutations */])(['changeMenu'])),
  computed: {
    availableCities: function availableCities() {
      return this.country ? this.country.cities : false;
    }
  }
});

/***/ }),

/***/ "TUjX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpbacklog","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("129"))+" ")])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.$t("130"))+"\n    "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpbacklog.right",arg:"helpbacklog",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TvnU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrioritiesChart_vue__ = __webpack_require__("Yoeo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e65515a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrioritiesChart_vue__ = __webpack_require__("SxXj");
function injectStyle (ssrContext) {
  __webpack_require__("s/Eg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e65515a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrioritiesChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e65515a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrioritiesChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U4B7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__ = __webpack_require__("LKFm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_253d6100_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__ = __webpack_require__("CSNV");
function injectStyle (ssrContext) {
  __webpack_require__("lteb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_253d6100_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U5Qi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U6TR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLineItem_vue__ = __webpack_require__("5NHr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e1b27df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLineItem_vue__ = __webpack_require__("fYtj");
function injectStyle (ssrContext) {
  __webpack_require__("pZL1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLineItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e1b27df_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLineItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U8A7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UJIc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_vm._t("content")],2)])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UMeC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");









__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default.a);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'charts',
    components: {
        Help: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__["a" /* default */]
    },
    data: function data() {
        return {
            titleChart: this.$t("239"),
            tableData: [],
            chartOptions: {
                colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8', '#dd6b7f', '#0984e3', '#ffeaa7', '#e84393', '#55efc4', '#636e72', '#ff7675', '#f1c40f', '#34495e'],
                chart: {
                    type: 'column',
                    backgroundColor: 'rgba(0,0,0,0)',
                    style: {
                        fontFamily: '\'Unica One\', sans-serif'
                    },
                    plotBorderColor: '#606063'
                },
                title: {
                    text: '',
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase',
                        fontSize: '14px'
                    }
                },
                subtitle: {
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase'
                    }
                },
                xAxis: {
                    categories: [],
                    crosshair: true,
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    title: {
                        style: {
                            color: '#A0A0A3'
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: '# Sensors',
                        style: {
                            color: '#A0A0A3'
                        }
                    },
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    tickWidth: 1
                },
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    },
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name} </td>' + '<td style="padding:0"><b>{point.y} </b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true,
                            color: '#F0F0F3',
                            style: {
                                fontSize: '13px'
                            }
                        },
                        marker: {
                            lineColor: '#333'
                        },
                        events: {
                            click: this.loadGrid
                        },
                        cursor: 'pointer'
                    },
                    boxplot: {
                        fillColor: '#505053'
                    },
                    candlestick: {
                        lineColor: 'white'
                    },
                    errorbar: {
                        color: 'white'
                    },
                    column: {
                        pointPadding: 0.1,
                        borderWidth: 0
                    }
                },
                legend: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    itemStyle: {
                        color: '#E0E0E3'
                    },
                    itemHoverStyle: {
                        color: '#FFF'
                    },
                    itemHiddenStyle: {
                        color: '#606063'
                    },
                    title: {
                        style: {
                            color: '#C0C0C0',
                            fontSize: '14px'
                        }
                    },
                    enabled: false
                },
                labels: {
                    style: {
                        color: '#707073'
                    }
                },
                drilldown: {
                    activeAxisLabelStyle: {
                        color: '#F0F0F3'
                    },
                    activeDataLabelStyle: {
                        color: '#F0F0F3'
                    }
                },
                navigation: {
                    buttonOptions: {
                        symbolStroke: '#DDDDDD',
                        theme: {
                            fill: '#505053'
                        }
                    }
                },

                rangeSelector: {
                    buttonTheme: {
                        fill: '#505053',
                        stroke: '#000000',
                        style: {
                            color: '#CCC'
                        },
                        states: {
                            hover: {
                                fill: '#707073',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            },
                            select: {
                                fill: '#000003',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    },
                    inputBoxBorderColor: '#505053',
                    inputStyle: {
                        backgroundColor: '#333',
                        color: 'silver'
                    },
                    labelStyle: {
                        color: 'silver'
                    }
                },
                navigator: {
                    handles: {
                        backgroundColor: '#666',
                        borderColor: '#AAA'
                    },
                    outlineColor: '#CCC',
                    maskFill: 'rgba(255,255,255,0.1)',
                    series: {
                        color: '#7798BF',
                        lineColor: '#A6C7ED'
                    },
                    xAxis: {
                        gridLineColor: '#505053'
                    }
                },
                scrollbar: {
                    barBackgroundColor: '#808083',
                    barBorderColor: '#808083',
                    buttonArrowColor: '#CCC',
                    buttonBackgroundColor: '#606063',
                    buttonBorderColor: '#606063',
                    rifleColor: '#FFF',
                    trackBackgroundColor: '#404043',
                    trackBorderColor: '#404043'
                },
                series: [{
                    name: [],
                    color: [],
                    data: []
                }],
                exporting: { enabled: false },
                credits: {
                    enabled: false
                },
                loading: {
                    labelStyle: {
                        color: 'black',
                        textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
                    },
                    style: {
                        backgroundColor: 'none',
                        opacity: 1
                    }
                }

            } };
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['changeGridOnline']), {
        loadGrid: function loadGrid(event) {
            var status = event.point.status;
            var point_name = event.point.name;
            var NAME_CHART = this.$t("364") + ' - ' + point_name.toUpperCase();
            var ENDPOINT = 'v1/mysemeq-ambev/get-bateria-status-grid?corp=' + this.filtersOn.corp + '&region=' + this.filtersOn.region + '&planta=' + this.filtersOn.planta + '&status=' + status + '&area_f=' + this.filtersOn.area_f + '&sector_f=' + this.filtersOn.sector_f + '&machine=' + this.filtersOn.machine + '&subset=' + this.filtersOn.subset;

            var gridOnline = {
                title: event.point.name,
                url: ENDPOINT,
                name_chart: NAME_CHART,
                columns: {
                    "area": [this.$t("311")],
                    "setor": [this.$t("312")],
                    "conj": [this.$t("316"), 'conjunto'],
                    "conj_tag": [this.$t("317")],
                    "equip": [this.$t("313")],
                    "equip_tag": [this.$t("314")],
                    "ponto": [this.$t("340")],
                    "serie": [this.$t("339")],
                    "versao": [this.$t("336")],
                    "data": [this.$t("334")],
                    "bateria": [this.$t("335")],
                    "sinal_nivel": [this.$t("337")],
                    "node": [this.$t("338"), 'nodo'],
                    "status": ['Status'],
                    "id_planta": ['id_planta']
                },
                show: true,
                titleHelp: 'Grid - ' + this.$t("364"),
                txtHelp: this.$t("365")
            };

            if (!this.filtersOn.planta) {
                gridOnline.columns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ "rows": [''], 'planta': [this.$t("310"), 'planta_f'] }, gridOnline.columns);
            } else {
                gridOnline.columns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ "rows": [''] }, gridOnline.columns);
            }

            if (this.filtersOn.planta) {
                gridOnline.title += ' - ' + this.filtersOn.planta_name;
                delete gridOnline.columns['planta'];
            }

            this.changeGridOnline(gridOnline);
        },
        getData: function getData() {
            var API = "https://api.semeq.com.br/";

            var ENDPOINT = 'v1/mysemeq-ambev/get-bateria-status';
            var self = this;

            this.$refs.chart.chart.showLoading();

            __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ENDPOINT, params: this.filtersOn, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
                self.tableData = resp.data.result;
                self.$refs.chart.chart.hideLoading();
            }).catch(function (err) {
                self.$refs.chart.chart.showLoading('Error');

                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        setChartData: function setChartData() {
            var self = this;
            var res = self.tableData;
            self.chartOptions.xAxis.categories = [];
            self.chartOptions.series[0].data = [];
            self.chartOptions.series[0].color = [];
            res.forEach(function (it) {
                if (it.status == 0) {
                    it.color = '#f45b5b';
                }
                if (it.status == 1) {
                    it.color = '#f5c869';
                }
                if (it.status == 2) {
                    it.color = '#e4d354';
                }
                if (it.status == 3) {
                    it.color = '#3257a8';
                }
                if (it.status == 4) {
                    it.color = '#90ed7d';
                }
                if (it.status == 5) {
                    it.color = '#6b91c9';
                }

                self.chartOptions.xAxis.categories.push(it.name);
                self.chartOptions.series[0].data.push(it);
            });
        }
    }),
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filtersOn'])),
    watch: {
        filtersOn: function filtersOn(newValue) {
            this.getData();
        },
        tableData: function tableData() {
            this.setChartData();
        }
    }
});

/***/ }),

/***/ "UQPL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UtA4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Tradução")]),_vm._v(" "),_c('span',[_c('h2',[_vm._v(_vm._s(_vm.$t("hello123")))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.$t("bye123")))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$tc('car')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$tc('car', 10, { count: 10})))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.statsCards),function(stats){return _c('div',{staticClass:"col-lg-3 col-sm-6"},[_c('stats-card',[_c('div',{staticClass:"icon-big text-center",class:("icon-" + (stats.type)),attrs:{"slot":"header"},slot:"header"},[_c('i',{class:stats.icon})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(stats.title))]),_vm._v("\n          "+_vm._s(stats.value)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_c('i',{class:stats.footerIcon}),_vm._v(" "+_vm._s(stats.footerText)+"\n        ")])])],1)})),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-4 col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.earningsChart.data,"chart-options":_vm.earningsChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("$34,657")]),_vm._v(" "),_c('span',{staticClass:"label label-success",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n            +18%\n          ")]),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("\n            total earnings "),_c('span',{staticClass:"text-muted"},[_vm._v("in last")]),_vm._v(" ten "),_c('span',{staticClass:"text-muted"},[_vm._v("quarters")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer-title"},slot:"footer-title"},[_vm._v("\n            Financial Statistics\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill btn-icon btn-sm",attrs:{"slot":"footer-right"},slot:"footer-right"},[_c('i',{staticClass:"ti-plus"})])])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":70,"title":"Dashboard","description":"Monthly sales target","color":"blue"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":34,"title":"Orders","description":"Completed","color":"green"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":62,"title":"New Visitors","description":"Out of total number","color":"orange"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-sm-6"},[_c('circle-chart-card',{attrs:{"percentage":10,"title":"Subscriptions","description":"Monthly newsletter","color":"brown"}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-8 col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Global Sales by Top Locations")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("All products that were shipped")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_vm._v("\n               teste\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/US.png"}})])]),_vm._v(" "),_c('td',[_vm._v("USA")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        2.920\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        53.23%\n                      ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/DE.png"}})])]),_vm._v(" "),_c('td',[_vm._v("Germany")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        1.300\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        20.43%\n                      ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/AU.png"}})])]),_vm._v(" "),_c('td',[_vm._v("Australia")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        760\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        10.35%\n                      ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/GB.png"}})])]),_vm._v(" "),_c('td',[_vm._v("United Kingdom")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        690\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        7.87%\n                      ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/RO.png"}})])]),_vm._v(" "),_c('td',[_vm._v("Romania")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        600\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        5.94%\n                      ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('div',{staticClass:"flag"},[_c('img',{attrs:{"src":"static/img/flags/BR.png"}})])]),_vm._v(" "),_c('td',[_vm._v("Brasil")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        550\n                      ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                        4.34%\n                      ")])])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V+Sv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_tag_css__ = __webpack_require__("wJKS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_tag_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_tag_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag__ = __webpack_require__("orbS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_slider_css__ = __webpack_require__("BxWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider__ = __webpack_require__("g2bL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_time_select_css__ = __webpack_require__("2BWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_time_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_time_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select__ = __webpack_require__("bFD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Progress_vue__ = __webpack_require__("sbDz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__ = __webpack_require__("me3u");



















var _components;



/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a.name, __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_date_picker___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select___default.a.name, __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_time_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider___default.a.name, __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_slider___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag___default.a.name, __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_tag___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a.name, __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_button___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a.name, __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_select___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PSwitch', __WEBPACK_IMPORTED_MODULE_19_src_components_UIComponents_Switch_vue__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, 'PProgress', __WEBPACK_IMPORTED_MODULE_18_src_components_UIComponents_Progress_vue__["a" /* default */]), _components),
  data: function data() {
    return {
      enabledRadio: '2',
      disabledRadio: '2',
      switches: {
        defaultOn: true,
        defaultOff: false,
        plainOn: true,
        plainOff: false,
        withIconsOn: true,
        withIconsOff: false
      },
      sliders: {
        simple: 30,
        rangeSlider: [20, 50]
      },
      selects: {
        simple: '',
        countries: [{ value: 'Bahasa Indonesia', label: 'Bahasa Indonesia' }, { value: 'Bahasa Melayu', label: 'Bahasa Melayu' }, { value: 'Català', label: 'Català' }, { value: 'Dansk', label: 'Dansk' }, { value: 'Deutsch', label: 'Deutsch' }, { value: 'English', label: 'English' }, { value: 'Español', label: 'Español' }, { value: 'Eλληνικά', label: 'Eλληνικά' }, { value: 'Français', label: 'Français' }, { value: 'Italiano', label: 'Italiano' }, { value: 'Magyar', label: 'Magyar' }, { value: 'Nederlands', label: 'Nederlands' }, { value: 'Norsk', label: 'Norsk' }, { value: 'Polski', label: 'Polski' }, { value: 'Português', label: 'Português' }, { value: 'Suomi', label: 'Suomi' }, { value: 'Svenska', label: 'Svenska' }, { value: 'Türkçe', label: 'Türkçe' }, { value: 'Íslenska', label: 'Íslenska' }, { value: 'Čeština', label: 'Čeština' }, { value: 'Русский', label: 'Русский' }, { value: 'ภาษาไทย', label: 'ภาษาไทย' }, { value: '中文 (简体)', label: '中文 (简体)' }, { value: 'W">中文 (繁體)', label: 'W">中文 (繁體)' }, { value: '日本語', label: '日本語' }, { value: '한국어', label: '한국어' }],
        multiple: 'ARS'
      },
      tags: {
        dynamicTags: ['Tag 1', 'Tag 2', 'Tag 3'],
        inputVisible: false,
        inputValue: ''
      },
      pickerOptions1: {
        shortcuts: [{
          text: 'Today',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: 'Yesterday',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: 'A week ago',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      datePicker: '',
      dateTimePicker: '',
      timePicker: ''
    };
  },

  methods: {
    handleClose: function handleClose(tag) {
      this.tags.dynamicTags.splice(this.tags.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this = this;

      this.tags.inputVisible = true;
      this.$nextTick(function () {
        _this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.tags.inputValue;
      if (inputValue) {
        this.tags.dynamicTags.push(inputValue);
      }
      this.tags.inputVisible = false;
      this.tags.inputValue = '';
    }
  }
});

/***/ }),

/***/ "V14P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-box"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-8 "},[_vm._v(_vm._s(_vm.usuario))]),_vm._v(" "),_c('div',{staticClass:"col-lg-2 "},[_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.toggleMenu}},[_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isClosed),expression:"!isClosed"}],staticClass:"nav menu-config"},[_c('li',[_c('a',{attrs:{"href":"https://www.youtube.com/watch?v=ao2ZWuPzTlg&feature=youtu.be","target":"_blank"}},[_c('span',{staticClass:"sidebar-mini"},[_c('i',{staticClass:"ti-video-clapper"})]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.$t("01")))]),_vm._v(" "),_c('div',{staticClass:"sidebar-normal-txt "},[_c('iframe',{staticStyle:{"float":"left","margin-right":"5%"},attrs:{"width":"80","height":"50","src":"https://www.youtube.com/embed/ao2ZWuPzTlg","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$t("02")))]),_vm._v(" "+_vm._s(_vm.$t("03"))+"\n              ")])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.youtube.com/watch?v=13YuULpgGLM","target":"_blank"}},[_c('span',{staticClass:"sidebar-mini"},[_c('i',{staticClass:"ti-video-clapper"})]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.$t("01")))]),_vm._v(" "),_c('div',{staticClass:"sidebar-normal-txt ",staticStyle:{"height":"50px"}},[_c('iframe',{staticStyle:{"float":"left","margin-right":"5%"},attrs:{"width":"80","height":"50","src":"https://www.youtube.com/embed/13YuULpgGLM","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share","allowfullscreen":""}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$t("377")))])])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.youtube.com/watch?v=miiYks25KcM","target":"_blank"}},[_c('span',{staticClass:"sidebar-mini"},[_c('i',{staticClass:"ti-video-clapper"})]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.$t("01")))]),_vm._v(" "),_c('div',{staticClass:"sidebar-normal-txt ",staticStyle:{"height":"50px"}},[_c('iframe',{staticStyle:{"float":"left","margin-right":"5%"},attrs:{"width":"80","height":"50","src":"https://www.youtube.com/embed/miiYks25KcM","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share","allowfullscreen":""}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$t("378")))])])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://www.youtube.com/watch?v=H5njBd3yWzY","target":"_blank"}},[_c('span',{staticClass:"sidebar-mini"},[_c('i',{staticClass:"ti-video-clapper"})]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.$t("01")))]),_vm._v(" "),_c('div',{staticClass:"sidebar-normal-txt ",staticStyle:{"height":"50px"}},[_c('iframe',{staticStyle:{"float":"left","margin-right":"5%"},attrs:{"width":"80","height":"50","src":"https://www.youtube.com/embed/H5njBd3yWzY","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share","allowfullscreen":""}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$t("379")))])])])]),_vm._v(" "),_c('li',{staticStyle:{"padding":"10px 15px"}},[_c('span',{staticClass:"sidebar-mini"},[_c('i',{staticClass:"ti-book"})]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.$t("04")))]),_vm._v(" "),_c('a',{staticStyle:{"padding":"0px 15px"},attrs:{"href":"http://abinbev.semeq.com.br/FTA_Lubrication_EN.pdf","target":"_blank"}},[_c('div',{staticClass:"sidebar-normal-txt"},[_vm._v("                  \n                "+_vm._s(_vm.$t("05"))+"\n              ")])]),_vm._v(" "),_c('a',{staticStyle:{"padding":"0px 15px"},attrs:{"href":"http://abinbev.semeq.com.br/SEMEQ_PdM_Technologies.pdf","target":"_blank"}},[_c('div',{staticClass:"sidebar-normal-txt"},[_vm._v("                  \n                "+_vm._s(_vm.$t("06"))+"\n              ")])]),_vm._v(" "),_c('a',{staticStyle:{"padding":"0px 15px"},attrs:{"href":"http://abinbev.semeq.com.br/Semeq_AbInBev_App.pdf","target":"_blank"}},[_c('div',{staticClass:"sidebar-normal-txt"},[_vm._v("                  \n                "+_vm._s(_vm.$t("07"))+"\n              ")])]),_vm._v(" "),_c('a',{staticStyle:{"padding":"0px 15px"},attrs:{"href":"http://abinbev.semeq.com.br/instruction_manual_online_monitoring_system.pdf","target":"_blank"}},[_c('div',{staticClass:"sidebar-normal-txt"},[_vm._v("                  \n                "+_vm._s(_vm.$t("08"))+"\n              ")])]),_vm._v(" "),_c('a',{staticStyle:{"padding":"0px 15px"},attrs:{"href":"http://abinbev.semeq.com.br/Global_Predictive_Guidelines.xlsx","target":"_blank"}},[_c('div',{staticClass:"sidebar-normal-txt"},[_vm._v("                  \n                "+_vm._s(_vm.$t("09"))+"\n              ")])])]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/release"}},[_c('span',{staticClass:"sidebar-mini"},[_c('i',{staticClass:"ti-check"})]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.$t("10")))])])],1)])])],1)]),_vm._v(" "),_c('div',{staticClass:"info",staticStyle:{"height":"38px","padding":"10px 0px"}},[_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-lg-8 "},[_vm._v(_vm._s(_vm.$t("11")))]),_vm._v(" "),_c('div',{staticClass:"col-lg-2 "})])]),_vm._v(" "),_c('div',{staticClass:"links"},[_c('router-link',{attrs:{"to":"/home"}},[_c('div',{staticStyle:{"display":"inline"}},[_c('popover',{attrs:{"name":"hint","width":230,"event":"hover","pointer":false}},[_c('p',[_vm._v(_vm._s(_vm.$t("12")))])]),_vm._v(" "),_c('button',{directives:[{name:"popover",rawName:"v-popover:hint.top",arg:"hint",modifiers:{"top":true}}],staticClass:"btn botao-link",class:{ activeOff: _vm.activeOff },attrs:{"type":"button"},on:{"click":function($event){_vm.linkOffline()}}},[_vm._v("\n          "+_vm._s(_vm.$t("13"))+"\n        ")])],1)]),_vm._v(" "),_c('router-link',{attrs:{"to":"/online"}},[_c('button',{staticClass:"btn botao-link",class:{ activeOn: _vm.activeOn },attrs:{"type":"button"},on:{"click":function($event){_vm.linkOnline()}}},[_vm._v("\n        "+_vm._s(_vm.$t("14"))+"\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"finter-online",class:{ activeViewOn: _vm.activeViewOn }},[_c('div',{staticClass:"finter-campo conf-select"},[_c('label',{attrs:{"for":"inputState"}},[_vm._v(_vm._s(_vm.$t("15")))]),_vm._v(" "),_c('model-select',{staticClass:"select2",attrs:{"id":"plant_select_on","options":_vm.optionsRegionOn,"placeholder":"Select a zone"},model:{value:(_vm.selected_region_on),callback:function ($$v) {_vm.selected_region_on=$$v},expression:"selected_region_on"}})],1),_vm._v(" "),_c('div',{staticClass:"finter-campo conf-select"},[_c('label',{attrs:{"for":"inputState"}},[_vm._v(_vm._s(_vm.$t("16")))]),_vm._v(" "),_c('model-select',{staticClass:"select2",attrs:{"id":"plantsOn_select","options":_vm.optionsOn,"placeholder":"Select a plant"},model:{value:(_vm.selected_plants_online),callback:function ($$v) {_vm.selected_plants_online=$$v},expression:"selected_plants_online"}})],1),_vm._v(" "),_c('div',{staticClass:"finter-bt"},[_c('div',[_c('label',{attrs:{"for":"date"}},[_vm._v(_vm._s(_vm.$t("17")))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date_year_online),expression:"date_year_online"}],staticClass:"display_none",attrs:{"type":"text","name":"date"},domProps:{"value":(_vm.date_year_online)},on:{"input":function($event){if($event.target.composing){ return; }_vm.date_year_online=$event.target.value}}}),_vm._v(" "),_vm._l((_vm.years),function(item){return _c('div',{key:item,staticClass:"box-button"},[_c('button',{staticClass:"btn btn-sm",class:{ active: _vm.activeYearOnline == item },attrs:{"type":"button"},on:{"click":function($event){_vm.btDateOnline(item)}}},[_vm._v(_vm._s(item))])])})],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.viewPeriodOnline),expression:"viewPeriodOnline"}],staticClass:"finter-bt"},[_c('div',[_c('label',{attrs:{"for":"date"}},[_vm._v(_vm._s(_vm.$t("18")))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.period_online),expression:"period_online"}],staticClass:"display_none",attrs:{"type":"text","name":"period"},domProps:{"value":(_vm.period_online)},on:{"input":function($event){if($event.target.composing){ return; }_vm.period_online=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"box-button"},[_c('button',{staticClass:"btn btn-sm",class:{ active3mOnline: _vm.active3mOnline },attrs:{"type":"button"},on:{"click":function($event){_vm.period3mOnline()}}},[_vm._v("3m")])]),_vm._v(" "),_c('div',{staticClass:"box-button"},[_c('button',{staticClass:"btn btn-sm",class:{ active6mOnline: _vm.active6mOnline },attrs:{"type":"button"},on:{"click":function($event){_vm.period6mOnline()}}},[_vm._v("6m")])]),_vm._v(" "),_c('div',{staticClass:"box-button"},[_c('button',{staticClass:"btn btn-sm",class:{ activetdOnline: _vm.activetdOnline },attrs:{"type":"button"},on:{"click":function($event){_vm.periodytdOnline()}}},[_vm._v("YTD")])]),_vm._v(" "),_c('div',{staticClass:"box-button"},[_c('button',{staticClass:"btn btn-sm",class:{ active1yOnline: _vm.active1yOnline },attrs:{"type":"button"},on:{"click":function($event){_vm.period1yOnline()}}},[_vm._v("1Y")])])]),_vm._v(" "),_c('div',{staticClass:"more_filters"},[_c('div',{staticClass:"more_filters_title"},[_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.toggleMenuFilters}},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-xs-8"},[_vm._v(_vm._s(_vm.$t("19")))]),_vm._v(" "),_vm._m(6)])]),_vm._v(" "),_c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isClosedFilter),expression:"!isClosedFilter"}],staticClass:"more_filters_box"},[_c('div',{staticClass:"finter-campo conf-select"},[_c('label',{attrs:{"for":"inputState"}},[_vm._v(_vm._s(_vm.$t("20")))]),_vm._v(" "),_c('model-select',{staticClass:"select2",attrs:{"id":"areaOn_select","options":_vm.optionsAreaOnline,"placeholder":"Select a area"},model:{value:(_vm.selected_area_online),callback:function ($$v) {_vm.selected_area_online=$$v},expression:"selected_area_online"}})],1),_vm._v(" "),(_vm.active_sector == true)?_c('div',{staticClass:"finter-campo conf-select"},[_c('label',{attrs:{"for":"inputState"}},[_vm._v(_vm._s(_vm.$t("20-1")))]),_vm._v(" "),_c('model-select',{staticClass:"select2",attrs:{"id":"sectorOn_select","options":_vm.optionsSectorOnline,"placeholder":"Select a sector"},model:{value:(_vm.selected_sector_online),callback:function ($$v) {_vm.selected_sector_online=$$v},expression:"selected_sector_online"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"finter-campo conf-select"},[_c('label',{attrs:{"for":"inputState"}},[_vm._v(_vm._s(_vm.$t("21")))]),_vm._v(" "),_c('model-select',{staticClass:"select2",attrs:{"id":"machineOn_select","options":_vm.optionsMachineOnline,"placeholder":"Select a machine"},model:{value:(_vm.selected_machine_online),callback:function ($$v) {_vm.selected_machine_online=$$v},expression:"selected_machine_online"}})],1),_vm._v(" "),_c('div',{staticClass:"finter-campo conf-select"},[_c('label',{attrs:{"for":"inputState"}},[_vm._v(_vm._s(_vm.$t("22")))]),_vm._v(" "),_c('model-select',{staticClass:"select2",attrs:{"id":"subsetOn_select","options":_vm.optionsComponentOnline,"placeholder":"Select a subset"},model:{value:(_vm.selected_component_online),callback:function ($$v) {_vm.selected_component_online=$$v},expression:"selected_component_online"}})],1)])])],1)]),_vm._v(" "),_c('div',{staticClass:"filters",class:{ activeViewOff: _vm.activeViewOff }},[_c('div',{staticClass:"finter-campo conf-select"},[_c('label',{attrs:{"for":"inputState"}},[_vm._v(_vm._s(_vm.$t("23")))]),_vm._v(" "),_c('model-select',{staticClass:"select2",attrs:{"id":"region_select","options":_vm.optionsRegion,"placeholder":"Select a zone"},model:{value:(_vm.selected_region),callback:function ($$v) {_vm.selected_region=$$v},expression:"selected_region"}})],1),_vm._v(" "),_c('div',{staticClass:"finter-campo conf-select"},[_c('label',{attrs:{"for":"inputState"}},[_vm._v(_vm._s(_vm.$t("24")))]),_vm._v(" "),_c('model-select',{staticClass:"select2",attrs:{"id":"plant_select","options":_vm.optionsOff,"placeholder":"Select a plant"},model:{value:(_vm.selected_plants),callback:function ($$v) {_vm.selected_plants=$$v},expression:"selected_plants"}})],1),_vm._v(" "),_c('div',{staticClass:"finter-bt"},[_c('div',[_c('label',{attrs:{"for":"date"}},[_vm._v(_vm._s(_vm.$t("25")))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date_year),expression:"date_year"}],staticClass:"display_none",attrs:{"type":"text","name":"date"},domProps:{"value":(_vm.date_year)},on:{"input":function($event){if($event.target.composing){ return; }_vm.date_year=$event.target.value}}}),_vm._v(" "),_vm._l((_vm.years),function(item){return _c('div',{key:item,staticClass:"box-button"},[_c('button',{staticClass:"btn btn-sm",class:{ active: _vm.activeYear == item},attrs:{"type":"button"},on:{"click":function($event){_vm.btDate(item)}}},[_vm._v(_vm._s(item))])])})],2),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.viewPeriod),expression:"viewPeriod"}],staticClass:"finter-bt"},[_c('div',[_c('label',{attrs:{"for":"date"}},[_vm._v(_vm._s(_vm.$t("18")))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.period),expression:"period"}],staticClass:"display_none",attrs:{"type":"text","name":"period"},domProps:{"value":(_vm.period)},on:{"input":function($event){if($event.target.composing){ return; }_vm.period=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"box-button"},[_c('button',{staticClass:"btn btn-sm",class:{ active3m: _vm.active3m },attrs:{"type":"button"},on:{"click":function($event){_vm.period3m()}}},[_vm._v("3m")])]),_vm._v(" "),_c('div',{staticClass:"box-button"},[_c('button',{staticClass:"btn btn-sm",class:{ active6m: _vm.active6m },attrs:{"type":"button"},on:{"click":function($event){_vm.period6m()}}},[_vm._v("6m")])]),_vm._v(" "),_c('div',{staticClass:"box-button"},[_c('button',{staticClass:"btn btn-sm",class:{ activetd: _vm.activetd },attrs:{"type":"button"},on:{"click":function($event){_vm.periodytd()}}},[_vm._v("YTD")])]),_vm._v(" "),_c('div',{staticClass:"box-button"},[_c('button',{staticClass:"btn btn-sm",class:{ active1y: _vm.active1y },attrs:{"type":"button"},on:{"click":function($event){_vm.period1y()}}},[_vm._v("1Y")])])]),_vm._v(" "),_c('div',{staticClass:"more_filters"},[_c('div',{staticClass:"more_filters_title"},[_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.toggleMenuFilters}},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-xs-8"},[_vm._v(_vm._s(_vm.$t("19")))]),_vm._v(" "),_vm._m(8)])]),_vm._v(" "),_c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isClosedFilter),expression:"!isClosedFilter"}],staticClass:"more_filters_box"},[_c('div',{staticClass:"finter-campo conf-select"},[_c('label',{attrs:{"for":"inputState"}},[_vm._v(_vm._s(_vm.$t("20")))]),_vm._v(" "),_c('model-select',{staticClass:"select2",attrs:{"id":"area_select","options":_vm.optionsArea,"placeholder":"Select a area"},model:{value:(_vm.selected_area),callback:function ($$v) {_vm.selected_area=$$v},expression:"selected_area"}})],1),_vm._v(" "),(_vm.active_sector == true)?_c('div',{staticClass:"finter-campo conf-select"},[_c('label',{attrs:{"for":"inputState"}},[_vm._v(_vm._s(_vm.$t("20-1")))]),_vm._v(" "),_c('model-select',{staticClass:"select2",attrs:{"id":"area_select","options":_vm.optionsSector,"placeholder":"Select a sector"},model:{value:(_vm.selected_sector),callback:function ($$v) {_vm.selected_sector=$$v},expression:"selected_sector"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"finter-campo conf-select"},[_c('label',{attrs:{"for":"inputState"}},[_vm._v(_vm._s(_vm.$t("21")))]),_vm._v(" "),_c('model-select',{staticClass:"select2",attrs:{"id":"machine_select","options":_vm.optionsMachine,"placeholder":"Select a machine"},model:{value:(_vm.selected_machine),callback:function ($$v) {_vm.selected_machine=$$v},expression:"selected_machine"}})],1),_vm._v(" "),_c('div',{staticClass:"finter-campo conf-select"},[_c('label',{attrs:{"for":"inputState"}},[_vm._v(_vm._s(_vm.$t("22")))]),_vm._v(" "),_c('model-select',{staticClass:"select2",attrs:{"id":"subset_select","options":_vm.optionsComponent,"placeholder":"Select a subset"},model:{value:(_vm.selected_component),callback:function ($$v) {_vm.selected_component=$$v},expression:"selected_component"}})],1),_vm._v(" "),_c('div',{staticClass:"finter-campo"},[_c('label',{attrs:{"for":"inputState"}},[_vm._v(_vm._s(_vm.$t("26")))]),_vm._v(" "),_c('model-select',{staticClass:"select2",attrs:{"id":"technique_select","options":_vm.optionsTech,"placeholder":"Select a technique"},model:{value:(_vm.selected_techniques),callback:function ($$v) {_vm.selected_techniques=$$v},expression:"selected_techniques"}})],1)])])],1)]),_vm._v(" "),_c('div',{staticClass:"finter-campo",class:{ activeViewOff: _vm.activeViewOff },staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"bt-search"},[_c('button',{staticClass:"btn btn-lg btn-block",attrs:{"type":"button"},on:{"click":function($event){_vm.search()}}},[_vm._v(_vm._s(_vm.$t("27")))])])]),_vm._v(" "),_c('div',{staticClass:"finter-campo",class:{ activeViewOn: _vm.activeViewOn },staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"bt-search"},[_c('button',{staticClass:"btn btn-lg btn-block",attrs:{"type":"button"},on:{"click":function($event){_vm.searchOn()}}},[_vm._v(_vm._s(_vm.$t("27")))])])]),_vm._v(" "),(_vm.isAuthenticated)?_c('div',{staticStyle:{"margin":"30px 10px","text-align":"center"},on:{"click":_vm.logout}},[_c('router-link',{staticClass:"btn-magnify",attrs:{"to":"/admin/overview"}},[_c('i',{staticClass:"ti-power-off"}),_vm._v(" "+_vm._s(_vm.$t("logout"))+"\n  ")])],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-photo"},[_c('img',{staticClass:"img-fluid",attrs:{"src":"static/img/logo-pb.png","alt":"Imagem responsiva"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-slogan"},[_c('img',{staticClass:"img-fluid",attrs:{"src":"static/img/slogan.png","alt":"Imagem responsiva"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 "},[_c('i',{staticClass:"ti-user"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 "},[_c('i',{staticClass:"ti-world"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-xs-2"},[_c('i',{staticClass:"ti-plus"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-xs-2"},[_c('span',[_c('b',{staticClass:"caret"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-xs-2"},[_c('i',{staticClass:"ti-plus"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-xs-2"},[_c('span',[_c('b',{staticClass:"caret"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V5Z/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V67u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate",class:_vm.switchClass},[_c('div',{staticClass:"bootstrap-switch-container",on:{"click":function($event){_vm.triggerToggle()}}},[_c('span',{staticClass:"bootstrap-switch-handle-on ",class:("bootstrap-switch-" + _vm.type)},[_vm._t("on",[_vm._v("\n          "+_vm._s(_vm.onText)+"\n      ")])],2),_vm._v(" "),_c('span',{staticClass:"bootstrap-switch-label"}),_vm._v(" "),_c('span',{staticClass:"bootstrap-switch-handle-off bootstrap-switch-default"},[_vm._t("off",[_vm._v("\n          "+_vm._s(_vm.offText)+"\n      ")])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VEgf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "VsUZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);


var mocks = {
  'user/me': { 'GET': { name: 'Jose', title: 'Sr' } }
};

var apiCall = function apiCall(_ref) {
  var url = _ref.url,
      method = _ref.method,
      args = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['url', 'method']);

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    setTimeout(function () {
      try {
        resolve(mocks[url][method || 'GET']);
      } catch (err) {
        reject(new Error(err));
      }
    }, 1000);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (apiCall);

/***/ }),

/***/ "WFzC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChartCard_vue__ = __webpack_require__("x/a9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ca0e66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChartCard_vue__ = __webpack_require__("qAvE");
function injectStyle (ssrContext) {
  __webpack_require__("PGBT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ca0e66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WI53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("hJZU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df34548_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("R9G1");
function injectStyle (ssrContext) {
  __webpack_require__("WhQp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3df34548_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WLON":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WSd6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-tour',
  data: function data() {
    return {
      steps: [{
        target: '#v-step-0',
        content: 'Discover Vue Tour!'
      }, {
        target: '.v-step-1',
        content: 'An awesome plugin made with Vue.js!'
      }, {
        target: '[data-v-step="2"]',
        content: 'Try it, you\'ll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.'
      }]
    };
  },

  methods: {
    nextStep: function nextStep() {
      this.$tours['myTour'].nextStep();
    },
    showLastStep: function showLastStep() {
      this.$tours['myTour'].currentStep = this.steps.length - 1;
    },
    myCustomPreviousStepCallback: function myCustomPreviousStepCallback(currentStep) {
      console.log('[Vue Tour] A custom previousStep callback has been called on step ' + (currentStep + 1));
    },
    myCustomNextStepCallback: function myCustomNextStepCallback(currentStep) {
      console.log('[Vue Tour] A custom nextStep callback has been called on step ' + (currentStep + 1));

      if (currentStep === 1) {
        console.log('[Vue Tour] A custom nextStep callback has been called from step 2 to step 3');
      }
    }
  }
});

/***/ }),

/***/ "WhQp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ws9Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content table-responsive table-full-width"},[_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"Id","property":"id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Name","property":"name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Country","property":"country"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"City","property":"city"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Salary","property":"salary"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card card-plain"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content table-responsive table-full-width"},[_c('el-table',{attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"label":"Id","property":"id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Name","property":"name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Salary","property":"salary"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Country","property":"country"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"City","property":"city"}})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-content table-responsive table-full-width"},[_c('el-table',{attrs:{"row-class-name":_vm.tableRowClassName,"data":_vm.tableData}},[_c('el-table-column',{staticClass:"success",attrs:{"label":"Id","property":"id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Name","property":"name"}}),_vm._v(" "),_c('el-table-column',{staticClass:"danger",attrs:{"label":"Salary","property":"salary"}}),_vm._v(" "),_c('el-table-column',{staticClass:"info",attrs:{"label":"Country","property":"country"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"City","property":"city"}})],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Striped table")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Here is a subtitle for this table")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Table on Plain Background")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Here is a subtitle for this table")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Regular Table with Colors")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Here is a subtitle for this table")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X+ky":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XAl3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mixin__ = __webpack_require__("vsZy");








/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String
    },
    perc: {
      type: Number
    },
    content: {
      type: Number
    },
    color: {
      type: String
    },
    font: {
      type: String
    },
    delay: {
      type: Number
    }
  },
  data: function data() {
    return {
      colors: {
        'R0': '#e4d354',
        'R1': '#f2c946',
        'R2': '#f0893a',
        'R3': '#f45b5b',
        'R3+': '#f45b5b'
      }
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__utils_mixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['changeGrid']), {
    loadGrid: function loadGrid(event) {

      if (this.content != 0) {

        if (this.getTab == 'offline') {

          var region = this.filters.region;


          var plant = this.filters.plant;


          var status = this.title;

          var feedback_status = void 0;
          var delay = void 0;

          if (!this.delay) {
            delay = '';
            feedback_status = '';
          }
          if (this.delay == 0 || this.delay == 1 || this.delay == 2 || this.delay == 3) {
            delay = this.delay;
            feedback_status = 'CLOSED';
          }

          var NAME_CHART = this.$t("376") + ' - ' + this.title.toUpperCase();

          var ENDPOINT = 'v1/mysemeq-ambev/get-reports-repetition?plant=' + plant + '&region=' + region + '&status=' + status + '&technique=' + this.filters.technique + '&year=' + this.filters.year + '&period=' + this.filters.period + '&area=' + this.filters.area + '&sector=' + this.filters.sector + '&machine=' + this.filters.machine + '&component=' + this.filters.component + '&feedback_status=' + feedback_status + '&delay=' + delay + '&online=0';

          var grid = {
            totalDados: this.content,
            title: this.title,
            url: ENDPOINT,
            name_chart: NAME_CHART,
            columns: {
              "rows": '',
              "plant": this.$t("310"),
              "area": this.$t("311"),
              "sector": this.$t("312"),
              "component": this.$t("313"),
              "component_tag": this.$t("314"),
              "component_type_en": this.$t("315"),
              "machine": this.$t("316"),
              "machine_tag": this.$t("317"),
              "technique_en": this.$t("321"),
              "report_number": this.$t("319"),
              "approved_datetime": this.$t("320"),
              "link": this.$t("323"),
              "link_rci": this.$t("324"),
              "pending_days": this.$t("325"),
              "delay": this.$t("326"),
              "prescription_created_datePtime": this.$t("327"),
              "week": this.$t("328")

            },
            show: true,
            titleHelp: 'Grid - ' + this.$t("356"),
            txtHelp: this.$t("357")
          };

          if (this.filters.plant) {
            grid.title += ' - ' + this.filters.plant_name;
            delete grid.columns['plant'];
          } else if (this.filters.region) {
            grid.title += ' - ' + this.filters.region;
          }

          this.changeGrid(grid);
        }

        if (this.getTab == 'online') {

          var _region = this.filtersOn.region;


          var _plant = this.filtersOn.planta;


          var _status = this.title;

          var _feedback_status = void 0;
          var _delay = void 0;

          if (!this.delay) {
            _delay = '';
            _feedback_status = '';
          }
          if (this.delay == 0 || this.delay == 1 || this.delay == 2 || this.delay == 3) {
            _delay = this.delay;
            _feedback_status = 'CLOSED';
          }

          var _NAME_CHART = this.$t("376") + ' - ' + this.title.toUpperCase();

          var _ENDPOINT = 'v1/mysemeq-ambev/get-reports-repetition?plant=' + _plant + '&region=' + _region + '&status=' + _status + '&technique=&year=' + this.filtersOn.year + '&period=' + this.filtersOn.period + '&area=' + this.filtersOn.area_f + '&sector=' + this.filtersOn.sector_f + '&machine=' + this.filtersOn.machine + '&component=' + this.filtersOn.subset + '&feedback_status=' + _feedback_status + '&delay=' + _delay + '&online=1';

          var _grid = {
            totalDados: this.content,
            title: this.title,
            url: _ENDPOINT,
            name_chart: _NAME_CHART,
            columns: {
              "rows": '',
              "plant": this.$t("310"),
              "area": this.$t("311"),
              "sector": this.$t("312"),
              "component": this.$t("313"),
              "component_tag": this.$t("314"),
              "component_type_en": this.$t("315"),
              "machine": this.$t("316"),
              "machine_tag": this.$t("317"),
              "technique_en": this.$t("321"),
              "report_number": this.$t("319"),
              "approved_datetime": this.$t("320"),
              "link": this.$t("323"),
              "link_rci": this.$t("324"),
              "pending_days": this.$t("325"),
              "delay": this.$t("326"),
              "prescription_created_datePtime": this.$t("327"),
              "week": this.$t("328")
            },
            show: true,
            titleHelp: 'Grid - ' + this.$t("356"),
            txtHelp: this.$t("357")
          };

          if (this.filtersOn.planta) {
            _grid.title += ' - ' + this.filtersOn.planta_name;
            delete _grid.columns['plant'];
          } else if (this.filtersOn.region) {
            _grid.title += ' - ' + this.filtersOn.region;
          }

          this.changeGrid(_grid);
        }
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filters', 'filtersOn', 'getTab']))
});

/***/ }),

/***/ "XIFX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._t("title-content",[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-7"},[_c('div',{staticClass:"numbers pull-left"},[_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-5"},[_c('div',{staticClass:"pull-right"},[_vm._t("title-label")],2)])])]),_vm._v(" "),_vm._t("subtitle"),_vm._v(" "),_c('div',{staticClass:"ct-chart",attrs:{"id":_vm.chartId}})],2),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_vm._t("footer",[_c('hr'),_vm._v(" "),_c('div',{staticClass:"footer-title"},[_vm._t("footer-title")],2),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_vm._t("footer-right")],2)])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XPMo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XXU8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_transitions_collapse_transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_actions_auth__ = __webpack_require__("+4WN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_search_select__ = __webpack_require__("A1eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_fullcalendar__ = __webpack_require__("olwm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_fullcalendar__);




var _components;












__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_js_popover___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_transitions_collapse_transition___default.a), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_components, 'ModelSelect', __WEBPACK_IMPORTED_MODULE_9_vue_search_select__["ModelSelect"]), _components),
  data: function data() {
    return {
      isClosed: true,
      isClosedFilter: true,
      usuario: null,
      optionsOff: [],
      optionsOn: [],
      optionsArea: [],
      optionsSector: [],
      optionsMachine: [],
      optionsComponent: [],
      optionsAreaOnline: [],
      optionsSectorOnline: [],
      optionsMachineOnline: [],
      optionsComponentOnline: [],
      optionsTech: [],
      optionsRegion: [{ 'text': 'ABInBev', 'value': 'GLB' }, { 'text': 'NAZ', 'value': 'NAZ' }, { 'text': 'SAZ', 'value': 'SAZ' }, { 'text': 'MAZ', 'value': 'MAZ' }, { 'text': 'AFR', 'value': 'AFR' }, { 'text': 'EUR', 'value': 'EUR' }, { 'text': 'APAC', 'value': 'APAC' }],
      optionsRegionOn: [{ 'text': 'ABInBev', 'value': '' }, { 'text': 'NAZ', 'value': 'NAZ' }, { 'text': 'SAZ', 'value': 'SAZ' }, { 'text': 'MAZ', 'value': 'MAZ' }, { 'text': 'AFR', 'value': 'AFR' }, { 'text': 'EUR', 'value': 'EUR' }, { 'text': 'APAC', 'value': 'APAC' }],
      selected_area_online: { 'text': '', 'value': '' },
      selected_sector_online: { 'text': '', 'value': '' },
      selected_machine_online: { 'text': '', 'value': '' },
      selected_component_online: { 'text': '', 'value': '' },
      selected_area: { 'text': '', 'value': '' },
      selected_sector: { 'text': '', 'value': '' },
      selected_machine: { 'text': '', 'value': '' },
      selected_component: { 'text': '', 'value': '' },
      selected_plants_online: { 'text': '', 'value': '' },
      selected_plants: { 'text': '', 'value': '' },
      selected_region: { 'text': 'ABInBev', 'value': 'GLB' },
      selected_region_on: { 'text': 'ABInBev', 'value': '' },
      selected_techniques: '',
      date_year: null,
      date_year_online: null,
      text: '',
      period: 'AC',
      period_online: '3',
      viewPeriod: false,
      viewPeriodOnline: false,
      activeBtn: '',
      id_filtro: null,
      activeYear: null,
      active3m: false,
      active6m: false,
      activetd: false,
      active1y: false,
      activeYearOnline: null,
      active3mOnline: false,
      active6mOnline: false,
      activetdOnline: false,
      active1yOnline: false,
      activeOff: false,
      activeOn: false,
      activeViewOff: false,
      activeViewOn: false,
      link: '',
      years: [],
      initSearch: true,
      initSearchOn: true,
      active_sector: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_8__utils_mixin__["a" /* default */]],
  mounted: function mounted() {
    var self = this;
    var API = "https://api.semeq.com.br/";
    var ENDPOINT = 'v1/users/oracle/me';
    __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(API + ENDPOINT, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('user-token')
      }
    }).then(function (response) {
      var localData = {
        'users': response.data
      };
      localStorage.setItem('users', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(localData));
      localStorage.setItem('username', response.data.usern);

      var plant_id = response.data.plant_id;

      self.usuario = response.data.name;

      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      today = yyyy + '-' + mm + '-' + dd;
      var created_datetime = response.data.created_datetime;

      var timeDiff = new Date(today) - new Date(created_datetime);
      var days = timeDiff / (1000 * 60 * 60 * 24);


      var plant_maz = [9362, 9363, 9361, 10262, 10202, 10341, 10201, 10203, 13043, 13081, 13041, 13042, 13044, 14124, 14122, 14121, 13082, 12403, 14123];

      for (var key in plant_maz) {
        if (plant_maz[key] == plant_id) {
          if (days >= 90) {
            alert("Your password has expired, please enter a new password!");
            self.$router.push('/register');
          }
        }
      }
    }).catch(function (response) {
      console.log('error ao logar');
    });
    this.activeViewOff = false;
    this.activeViewOn = true;
    this.activeOff = true;
    this.activetd = true;
    this.active3mOnline = true;

    this.siteOnline();

    var year = new Date().getFullYear();
    while (year != 2017) {
      this.years.push(year);
      year--;
    }

    var currentYear = new Date().getFullYear();
    this.btDate(currentYear);
    this.btDateOnline(currentYear);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    siteOnline: function siteOnline() {
      var self = this;
      var hash = localStorage.getItem('hash');
      self.link = 'https://online.semeq.com.br/login-mysemeq?params=' + hash;
    },
    toggleMenu: function toggleMenu() {
      this.isClosed = !this.isClosed;
    },
    toggleMenuFilters: function toggleMenuFilters() {
      this.isClosedFilter = !this.isClosedFilter;
    },

    logout: function logout() {
      var _this = this;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_6__store_actions_auth__["a" /* AUTH_LOGOUT */]).then(function () {
        return _this.$router.push('/login');
      });
    },
    loadingPlants: function loadingPlants() {
      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/mysemeq-ambev/get-plants';
      var self = this;

      var cached_region = this.getCachedFilter('region');
      if (cached_region) {
        this.selected_region = { 'text': cached_region, 'value': cached_region };
        this.initSearch = true;
        return;
      }

      __WEBPACK_IMPORTED_MODULE_7_axios___default()({ method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        var res = resp.data;
        var values = [{ 'text': 'All', 'value': '' }];
        var cached_plant = self.getCachedFilter('plant');
        var option = undefined;
        for (var key in res) {
          option = { 'text': res[key].name, 'value': res[key].id };

          if (option.value == cached_plant) self.selected_plants = option;

          values.push(option);
        }

        self.optionsOff = values;

        if (!self.selected_plants.text) self.selected_plants = values[0];

        setTimeout(function () {
          if (self.initSearch && !self.getCachedFilter('area') && !self.getCachedFilter('sector') && !self.getCachedFilter('sector') && !self.getCachedFilter('machine') && !self.getCachedFilter('component') && !self.getCachedFilter('technique')) self.search();
        }, 500);
      }).catch(function (err) {
        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    },
    loadingTechniques: function loadingTechniques() {
      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/techniques?lang=EN';
      var self = this;
      __WEBPACK_IMPORTED_MODULE_7_axios___default()({ method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        var res = resp.data;
        var values = [{ 'text': 'All', 'value': '' }];
        var option = undefined;
        var cached_technique = self.getCachedFilter('technique');

        for (var key in res) {
          option = { 'text': res[key].name, 'value': res[key].id };

          if (cached_technique == option.value) {
            self.selected_techniques = option.value;
            self.isClosedFilter = false;
          }

          values.push(option);
        }
        self.optionsTech = values;

        if (!self.selected_techniques) self.selected_techniques = values[0].value;

        if (self.initSearch) self.search();
      }).catch(function (err) {
        self.ApiErrorHandler(self, err.response.data.status_code);
      });
    },
    loadingPlantsOn: function loadingPlantsOn() {
      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/mysemeq-ambev/get-plants-online?region=' + this.selected_region_on.value;

      var cached_region = this.getCachedFilter('region_on');
      if (cached_region) {
        this.selected_region_on = { 'text': cached_region, 'value': cached_region };
        this.initSearchOn = true;
        return;
      }

      var self = this;
      __WEBPACK_IMPORTED_MODULE_7_axios___default()({ method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        var res = resp.data;
        var values = [{ 'text': 'All', 'value': '' }];
        var cached_plant = self.getCachedFilter('planta_on');
        var option = undefined;
        for (var key in res) {
          option = { 'text': res[key].name, 'value': res[key].id };

          if (option.value == cached_plant) self.selected_plants_online = option;

          values.push(option);
        }
        self.optionsOn = values;

        if (!self.selected_plants_online.text) self.selected_plants_online = values[0];

        setTimeout(function () {
          if (self.initSearchOn && !self.getCachedFilter('area_f_on') && !self.getCachedFilter('sector_f_on') && !self.getCachedFilter('machine_on') && !self.getCachedFilter('subset_on')) self.searchOn();
        }, 500);
      }).catch(function (err) {
        self.ApiErrorHandler(self, err.response.data.status_code);
      });
    },
    search: function search() {
      var region = this.selected_region.value == 'GLB' ? '' : this.selected_region.value;
      var plant_id = this.selected_plants.value;
      var plant_name = this.selected_plants.text;
      var area = this.selected_area.value;
      var sector = this.selected_sector.text == 'All' ? '' : this.selected_sector.text;
      var machine = this.selected_machine.value;
      var component = this.selected_component.value;
      var technique = this.selected_techniques;
      var group = 'defect';

      if (this.initSearch) {
        var cached_year = localStorage.getItem('year');
        if (cached_year) {
          this.btDate(cached_year);
        }

        var cached_period = localStorage.getItem('period');
        if (cached_period) {
          if (cached_period == '3') this.period3m();else if (cached_period == '6') this.period6m();else if (cached_period == 'AC') this.periodytd();else if (cached_period == '12') this.period1y();
        }
      }

      var year = this.date_year;
      var period = this.period;

      this.initSearch = false;

      var filters = {
        "region": region,
        "plant": plant_id,
        "plant_name": plant_name,
        "year": year,
        "period": period,
        "area": area,
        "sector": sector,
        "machine": machine,
        "component": component,
        "technique": technique
      };

      this.changeFilters(filters);
    },
    searchOn: function searchOn() {

      if (!this.selected_region_on.text) {
        alert('Please select a region or plant!');
        return false;
      }

      var planta = this.selected_plants_online.value || '';
      var region = this.selected_region_on.value;
      var planta_name = this.selected_plants_online.text;
      var area = this.selected_area_online.value;
      var sector = this.selected_sector_online.text == 'All' ? '' : this.selected_sector_online.text;
      var machine = this.selected_machine_online.value;
      var component = this.selected_component_online.value;

      if (this.initSearchOn) {
        var cached_year = localStorage.getItem('year_on');
        if (cached_year) {
          this.btDateOnline(cached_year);
        }

        var cached_period = localStorage.getItem('period_on');
        if (cached_period) {
          if (cached_period == '3') this.period3mOnline();else if (cached_period == '6') this.period6mOnline();else if (cached_period == 'AC') this.periodytdOnline();else if (cached_period == '12') this.period1yOnline();
        }
      }

      var year = this.date_year_online;
      var period = this.period_online;

      this.initSearchOn = false;

      var filtersOn = {
        "planta": planta,
        'region': region,
        'corp': 1,
        "planta_name": planta_name,
        "year": year,
        "period": period,
        "area_f": area,
        "sector_f": sector,
        "machine": machine,
        "subset": component
      };

      this.changeFiltersOn(filtersOn);
    },
    linkOffline: function linkOffline() {
      var self = this;
      self.activeOff = true;
      self.activeOn = false;
      self.activeViewOff = false;
      self.activeViewOn = true;
      self.changeTab('offline');
    },
    linkOnline: function linkOnline() {
      var self = this;
      this.activeOff = false;
      this.activeOn = true;
      this.activeViewOff = true;
      this.activeViewOn = false;
      self.changeTab('online');
    },
    btDate: function btDate(year) {
      this.activeYear = year;
      this.date_year = String(year);

      if (year == new Date().getFullYear()) {
        this.viewPeriod = true;
      } else {
        this.viewPeriod = false;
      }
    },
    period3m: function period3m() {
      this.active3m = true;
      this.active6m = false;
      this.activetd = false;
      this.active1y = false;
      this.period = '3';
    },
    period6m: function period6m() {
      this.active3m = false;
      this.active6m = true;
      this.activetd = false;
      this.active1y = false;
      this.period = '6';
    },
    periodytd: function periodytd() {
      this.active3m = false;
      this.active6m = false;
      this.activetd = true;
      this.active1y = false;
      this.period = 'AC';
    },
    period1y: function period1y() {
      this.active3m = false;
      this.active6m = false;
      this.activetd = false;
      this.active1y = true;
      this.period = '12';
    },
    btDateOnline: function btDateOnline(year) {
      this.activeYearOnline = year;
      this.date_year_online = String(year);

      if (year == new Date().getFullYear()) {
        this.viewPeriodOnline = true;
      } else {
        this.viewPeriodOnline = false;
      }
    },
    period3mOnline: function period3mOnline() {
      this.active3mOnline = true;
      this.active6mOnline = false;
      this.activetdOnline = false;
      this.active1yOnline = false;
      this.period_online = '3';
    },
    period6mOnline: function period6mOnline() {
      this.active3mOnline = false;
      this.active6mOnline = true;
      this.activetdOnline = false;
      this.active1yOnline = false;
      this.period_online = '6';
    },
    periodytdOnline: function periodytdOnline() {
      this.active3mOnline = false;
      this.active6mOnline = false;
      this.activetdOnline = true;
      this.active1yOnline = false;
      this.period_online = 'AC';
    },
    period1yOnline: function period1yOnline() {
      this.active3mOnline = false;
      this.active6mOnline = false;
      this.activetdOnline = false;
      this.active1yOnline = true;
      this.period_online = '12';
    },
    getCachedFilter: function getCachedFilter(key) {
      return localStorage.getItem(key);
    }

  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapMutations */])(['changeFilters', 'changeFiltersOn', 'changeTab'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(['getProfile', 'isAuthenticated', 'isProfileLoaded', 'getTab']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === 'loading';
    },
    name: function name(state) {
      return state.user.profile.title + ' ' + state.user.profile.name;
    }
  })),
  watch: {
    getTab: function getTab() {
      if (this.getTab == 'online') {
        this.activeViewOn = false;
        this.activeViewOff = true;
        this.activeOn = true;
        this.activeOff = false;
        if (this.optionsOn.length == 0) {
          this.loadingPlantsOn();
        }
      } else if (this.getTab == 'offline') {
        this.activeViewOn = true;
        this.activeViewOff = false;
        this.activeOn = false;
        this.activeOff = true;
        if (this.optionsOff.length == 0) {
          this.loadingPlants();
        }
      }
    },
    selected_region: function selected_region() {

      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/mysemeq-ambev/get-region-plants?region=' + this.selected_region.value;
      this.optionsOff = [];
      this.selected_plants = { value: '', text: '' };
      var self = this;
      __WEBPACK_IMPORTED_MODULE_7_axios___default()({ method: 'GET', url: API + ENDPOINT, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        var res = resp.data;
        var values = [{ 'text': 'All', 'value': '' }];
        var cached_plant = self.getCachedFilter('plant');
        var option = undefined;

        for (var key in res) {
          option = { 'text': res[key].name, 'value': res[key].id };

          if (res[key].id == cached_plant) self.selected_plants = option;

          values.push(option);
        }

        self.optionsOff = values;

        if (!self.selected_plants.text) self.selected_plants = values[0];

        if (self.initSearch && !self.getCachedFilter('area') && !self.getCachedFilter('sector') && !self.getCachedFilter('machine') && !self.getCachedFilter('component') && !self.getCachedFilter('technique')) {
          self.search();
        }
      }).catch(function (err) {
        self.ApiErrorHandler(self, err.response.data.status_code);
      });
    },
    selected_plants: function selected_plants() {
      var _this2 = this;

      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/mysemeq-ambev/get-area?id_plant=' + (this.selected_plants.value || '');
      this.optionsArea = [];
      var self = this;
      __WEBPACK_IMPORTED_MODULE_7_axios___default()({ method: 'GET', url: API + ENDPOINT, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        var res = resp.data;

        var cached_area = self.getCachedFilter('area');
        var option = undefined;

        var values = [{ 'text': 'All', 'value': '' }];
        for (var key in res) {
          option = { 'text': res[key].familia_area, 'value': res[key].id_area };

          if (cached_area == option.value) {
            self.selected_area = option;
            _this2.isClosedFilter = false;
          }

          values.push(option);
        }

        self.optionsArea = values;

        if (!self.selected_area.text) self.selected_area = values[0];

        if (self.initSearch && !self.getCachedFilter('sector') && !self.getCachedFilter('machine') && !self.getCachedFilter('component') && !self.getCachedFilter('technique')) {
          self.search();
        }
      }).catch(function (err) {
        self.ApiErrorHandler(self, err.response.data.status_code);
      });

      if (this.selected_plants.value) {

        this.active_sector = true;

        var ENDPOINT_SECTOR = 'v1/mysemeq-ambev/get-sector?id_plant=' + (this.selected_plants.value || '');

        this.optionsSector = [];
        __WEBPACK_IMPORTED_MODULE_7_axios___default()({ method: 'GET', url: API + ENDPOINT_SECTOR, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
          var res = resp.data;

          var cached_sector = self.getCachedFilter('sector');

          var option = undefined;

          var values = [{ 'text': 'All', 'value': '' }];
          for (var key in res) {
            option = { 'text': res[key].descricao_sector, 'value': res[key].descricao_sector };

            if (cached_sector == option.text) {
              self.selected_sector = option;
              _this2.isClosedFilter = false;
            }

            values.push(option);
          }

          self.optionsSector = values;

          if (!self.selected_sector.text) self.selected_sector = values[0];

          if (self.initSearch && !self.getCachedFilter('sector') && !self.getCachedFilter('machine') && !self.getCachedFilter('component') && !self.getCachedFilter('technique')) {
            self.search();
          }
        }).catch(function (err) {
          self.ApiErrorHandler(self, err.response.data.status_code);
        });
      } else {
        this.active_sector = false;
      }
    },
    selected_area: function selected_area() {
      var _this3 = this;

      var self = this;

      this.optionsMachine = [];
      var area_id = this.selected_area.value;

      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/mysemeq-ambev/get-conjunto?id_plant=' + this.selected_plants.value + '&id_area=' + area_id;
      this.optionsMachine = [];

      __WEBPACK_IMPORTED_MODULE_7_axios___default()({ method: 'GET', url: API + ENDPOINT, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        var res = resp.data;

        var cached_machine = self.getCachedFilter('machine');
        var option = undefined;

        var values = [{ 'text': 'All', 'value': '' }];
        for (var key in res) {
          option = { 'text': res[key].familia_conjunto, 'value': res[key].id_conjunto };

          if (cached_machine == option.value) {
            self.selected_machine = option;
            _this3.isClosedFilter = false;
          }

          values.push(option);
        }

        self.optionsMachine = values;

        if (!self.selected_machine.text) self.selected_machine = values[0];

        if (self.initSearch && !self.getCachedFilter('sector') && !self.getCachedFilter('component') && !self.getCachedFilter('technique')) self.search();
      }).catch(function (err) {
        self.ApiErrorHandler(self, err.response.data.status_code);
      });
    },
    selected_machine: function selected_machine() {
      var _this4 = this;

      var self = this;

      this.optionsComponent = [];

      var area_id = this.selected_area.value;
      var conj_id = this.selected_machine.value;

      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/mysemeq-ambev/get-equipamento?id_plant=' + this.selected_plants.value + '&id_area=' + area_id + '&id_conj=' + conj_id;

      this.optionsComponent = [];

      __WEBPACK_IMPORTED_MODULE_7_axios___default()({ method: 'GET', url: API + ENDPOINT, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        var res = resp.data;

        var cached_component = self.getCachedFilter('component');
        var option = undefined;

        var values = [{ 'text': 'All', 'value': '' }];
        for (var key in res) {
          option = { 'text': res[key].familia_equipamento, 'value': res[key].id_equipamento };

          if (cached_component == option.value) {
            self.selected_component = option;
            _this4.isClosedFilter = false;
          }

          values.push(option);
        }

        self.optionsComponent = values;

        if (!self.selected_component.text) self.selected_component = values[0];

        self.loadingTechniques();
        if (self.initSearch && !self.getCachedFilter('sector') && !self.getCachedFilter('technique')) self.search();
      }).catch(function (err) {
        self.ApiErrorHandler(self, err.response.data.status_code);
      });
    },
    selected_region_on: function selected_region_on() {
      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/mysemeq-ambev/get-plants-online?region=' + this.selected_region_on.value;
      this.optionsOn = [];
      var self = this;
      __WEBPACK_IMPORTED_MODULE_7_axios___default()({ method: 'GET', url: API + ENDPOINT, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        var res = resp.data;

        var cached_plant = self.getCachedFilter('planta_on');
        var option = undefined;

        var values = [{ 'text': 'All', 'value': '' }];
        for (var key in res) {
          option = { 'text': res[key].name, 'value': res[key].id };

          if (res[key].id == cached_plant) self.selected_plants_online = option;

          values.push(option);
        }

        self.optionsOn = values;

        if (!self.selected_plants_online.text) self.selected_plants_online = values[0];

        if (self.initSearchOn && !self.getCachedFilter('area_f_on') && !self.getCachedFilter('sector_f_on') && !self.getCachedFilter('machine_on') && !self.getCachedFilter('subset_on')) {
          self.searchOn();
        }
      }).catch(function (err) {
        self.ApiErrorHandler(self, err.response.data.status_code);
      });
    },
    selected_plants_online: function selected_plants_online() {
      var _this5 = this;

      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/mysemeq-ambev/get-area?id_plant=' + (this.selected_plants_online.value || '');
      this.optionsAreaOnline = [];
      var self = this;
      __WEBPACK_IMPORTED_MODULE_7_axios___default()({ method: 'GET', url: API + ENDPOINT, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        var res = resp.data;

        var cached_area = self.getCachedFilter('area_f_on');
        var option = undefined;

        var values = [{ 'text': 'All', 'value': '' }];
        for (var key in res) {
          option = { 'text': res[key].familia_area, 'value': res[key].id_area };

          if (cached_area == option.value) {
            self.selected_area_online = option;
            _this5.isClosedFilter = false;
          }

          values.push(option);
        }

        self.optionsAreaOnline = values;

        if (!self.selected_area_online.text) self.selected_area_online = values[0];

        if (self.initSearchOn && !self.getCachedFilter('sector_f_on') && !self.getCachedFilter('machine_on') && !self.getCachedFilter('subset_on')) self.searchOn();
      }).catch(function (err) {
        self.ApiErrorHandler(self, err.response.data.status_code);
      });

      if (this.selected_plants_online.value) {
        this.active_sector = true;

        var ENDPOINT_SECTOR = 'v1/mysemeq-ambev/get-sector?id_plant=' + (this.selected_plants_online.value || '');

        this.optionsSectorOnline = [];
        __WEBPACK_IMPORTED_MODULE_7_axios___default()({ method: 'GET', url: API + ENDPOINT_SECTOR, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
          var res = resp.data;

          var cached_sector = self.getCachedFilter('sector_f_on');
          var option = undefined;

          var values = [{ 'text': 'All', 'value': '' }];
          for (var key in res) {
            option = { 'text': res[key].descricao_sector, 'value': res[key].descricao_sector };
            if (cached_sector == option.text) {
              self.selected_sector_online = option;
              _this5.isClosedFilter = false;
            }

            values.push(option);
          }

          self.optionsSectorOnline = values;

          if (!self.selected_sector_online.text) self.selected_sector_online = values[0];

          if (self.initSearchOn && !self.getCachedFilter('sector_f_on') && !self.getCachedFilter('machine_on') && !self.getCachedFilter('subset_on')) self.searchOn();
        }).catch(function (err) {
          self.ApiErrorHandler(self, err.response.data.status_code);
        });
      } else {
        this.active_sector = false;
      }
    },
    selected_area_online: function selected_area_online() {
      var _this6 = this;

      var self = this;
      self.selected_machine_online = { 'text': 'All', 'value': '' };
      this.optionsMachineOnline = [];

      var area_id = this.selected_area_online.value;

      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/mysemeq-ambev/get-conjunto?id_plant=' + this.selected_plants_online.value + '&id_area=' + area_id;
      this.optionsMachineOnline = [];

      __WEBPACK_IMPORTED_MODULE_7_axios___default()({ method: 'GET', url: API + ENDPOINT, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        var res = resp.data;

        var cached_machine = self.getCachedFilter('machine_on');
        var option = undefined;

        var values = [{ 'text': 'All', 'value': '' }];
        for (var key in res) {
          option = { 'text': res[key].familia_conjunto, 'value': res[key].id_conjunto };

          if (cached_machine == option.value) {
            self.selected_machine_online = option;
            _this6.isClosedFilter = false;
          }

          values.push(option);
        }

        self.optionsMachineOnline = values;

        if (!self.selected_machine_online.text) self.selected_machine_online = values[0];

        if (self.initSearchOn && !self.getCachedFilter('sector_f_on') && !self.getCachedFilter('subset_on')) self.searchOn();
      }).catch(function (err) {
        self.ApiErrorHandler(self, err.response.data.status_code);
      });
    },
    selected_machine_online: function selected_machine_online() {
      var _this7 = this;

      var self = this;
      self.selected_component_online = { 'text': 'All', 'value': '' };
      this.optionsComponentOnline = [];

      var area_id = this.selected_area_online.value;
      var conj_id = this.selected_machine_online.value;

      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/mysemeq-ambev/get-equipamento?id_plant=' + this.selected_plants_online.value + '&id_area=' + area_id + '&id_conj=' + conj_id;

      this.optionsComponentOnline = [];

      __WEBPACK_IMPORTED_MODULE_7_axios___default()({ method: 'GET', url: API + ENDPOINT, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        var res = resp.data;

        var cached_component = self.getCachedFilter('subset_on');
        var option = undefined;

        var values = [{ 'text': 'All', 'value': '' }];
        for (var key in res) {
          option = { 'text': res[key].familia_equipamento, 'value': res[key].id_equipamento };

          if (cached_component == option.value) {
            self.selected_component_online = option;
            _this7.isClosedFilter = false;
          }

          values.push(option);
        }

        self.optionsComponentOnline = values;

        if (!self.selected_component_online.text) self.selected_component_online = values[0];

        if (self.initSearchOn) setTimeout(function () {
          self.searchOn();
        }, 5000);
      }).catch(function (err) {
        self.ApiErrorHandler(self, err.response.data.status_code);
      });
    }
  }
});

/***/ }),

/***/ "XaJ4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YNHp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YcmF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yoeo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_ChartsOnline_ChartsAlarme__ = __webpack_require__("302u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");











__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_js_popover___default.a);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'charts',
    components: {
        ChartsAlarme: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_ChartsOnline_ChartsAlarme__["a" /* default */],
        Help: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_components_Help__["a" /* default */]
    },
    data: function data() {
        return {
            titleChart: this.$t("279"),
            tableData: [],
            chartOptions: {
                colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8', '#dd6b7f', '#0984e3', '#ffeaa7', '#e84393', '#55efc4', '#636e72', '#ff7675', '#f1c40f', '#34495e'],
                chart: {
                    type: 'column',
                    backgroundColor: 'rgba(0,0,0,0)',
                    style: {
                        fontFamily: '\'Unica One\', sans-serif'
                    },
                    plotBorderColor: '#606063'
                },
                title: {
                    text: '',
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase',
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }
                },
                subtitle: {
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase'
                    }
                },
                xAxis: {
                    categories: [],
                    crosshair: true,
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    title: {
                        style: {
                            color: '#A0A0A3'
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: this.$t("131"),
                        style: {
                            color: '#A0A0A3'
                        }
                    },
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    tickWidth: 1,
                    allowDecimals: false
                },
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    },
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">' + this.$t("136") + ': </td>' + '<td style="padding:0;"><b>{point.y}</b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true,
                            color: '#F0F0F3',
                            style: {
                                fontSize: '13px'
                            }

                        },
                        marker: {
                            lineColor: '#333'
                        },
                        events: {
                            click: this.loadGrid
                        },
                        cursor: 'pointer'
                    },
                    column: {
                        pointPadding: 0.1,
                        borderWidth: 0
                    }
                },
                legend: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    itemStyle: {
                        color: '#E0E0E3'
                    },
                    itemHoverStyle: {
                        color: '#FFF'
                    },
                    itemHiddenStyle: {
                        color: '#606063'
                    },
                    title: {
                        style: {
                            color: '#C0C0C0',
                            fontSize: '12px'
                        }
                    },
                    enabled: false
                },
                labels: {
                    style: {
                        color: '#707073'
                    }
                },
                drilldown: {
                    activeAxisLabelStyle: {
                        color: '#F0F0F3'
                    },
                    activeDataLabelStyle: {
                        color: '#F0F0F3'
                    }
                },
                navigation: {
                    buttonOptions: {
                        symbolStroke: '#DDDDDD',
                        theme: {
                            fill: '#505053'
                        }
                    }
                },

                rangeSelector: {
                    buttonTheme: {
                        fill: '#505053',
                        stroke: '#000000',
                        style: {
                            color: '#CCC'
                        },
                        states: {
                            hover: {
                                fill: '#707073',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            },
                            select: {
                                fill: '#000003',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    },
                    inputBoxBorderColor: '#505053',
                    inputStyle: {
                        backgroundColor: '#333',
                        color: 'silver'
                    },
                    labelStyle: {
                        color: 'silver'
                    }
                },
                navigator: {
                    handles: {
                        backgroundColor: '#666',
                        borderColor: '#AAA'
                    },
                    outlineColor: '#CCC',
                    maskFill: 'rgba(255,255,255,0.1)',
                    series: {
                        color: '#7798BF',
                        lineColor: '#A6C7ED'
                    },
                    xAxis: {
                        gridLineColor: '#505053'
                    }
                },
                scrollbar: {
                    barBackgroundColor: '#808083',
                    barBorderColor: '#808083',
                    buttonArrowColor: '#CCC',
                    buttonBackgroundColor: '#606063',
                    buttonBorderColor: '#606063',
                    rifleColor: '#FFF',
                    trackBackgroundColor: '#404043',
                    trackBorderColor: '#404043'
                },
                series: [{ color: '#F45B5B' }],
                exporting: { enabled: false },
                credits: {
                    enabled: false
                },
                loading: {
                    labelStyle: {
                        color: 'black',
                        textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
                    },
                    style: {
                        backgroundColor: 'none',
                        opacity: 1
                    }
                }

            },
            showOtherChart: false,
            activeOtherChart: false,
            btn_title: 'POINT ALARME'
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4__utils_mixin__["a" /* default */]],
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['changeGridOnline']), {
        loadGrid: function loadGrid(event) {

            var id = event.point.category;

            var point_name = event.point.category;
            var NAME_CHART = this.$t("374") + ' - ' + point_name.toUpperCase();

            var ENDPOINT = 'v1/mysemeq-ambev/get-top-priorities-grid?corp=' + this.filtersOn.corp + '&region=' + this.filtersOn.region + '&planta=' + this.filtersOn.planta + '&id=' + id + '&area_f=' + this.filtersOn.area_f + '&sector_f=' + this.filtersOn.sector_f + '&machine=' + this.filtersOn.machine + '&subset=' + this.filtersOn.subset;

            var grid = {
                title: this.$t("374"),
                url: ENDPOINT,
                name_chart: NAME_CHART,
                columns: {
                    "area": [this.$t("311")],
                    "setor": [this.$t("312")],
                    "conj": [this.$t("316"), 'conjunto'],
                    "conj_tag": [this.$t("317")],
                    "equip": [this.$t("313")],
                    "equip_tag": [this.$t("314")],
                    "status": ['Status'],
                    "rdps": [this.$t("161")],
                    "approved_datetime": [this.$t("320")]
                },
                show: true,
                export_csv: false,
                titleHelp: 'Grid - ' + this.$t("374"),
                txtHelp: this.$t("375")
            };

            if (!this.filtersOn.planta) {
                grid.columns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ "rows": [''], 'planta': [this.$t("310"), 'planta_f'] }, grid.columns);
            } else {
                grid.columns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ "rows": [''] }, grid.columns);
            }

            if (this.filtersOn.plant) {
                grid.title += ' - ' + this.filtersOn.plant_name;
            } else if (this.filtersOn.region) {
                grid.title += ' - ' + this.filtersOn.region;
            }

            this.changeGridOnline(grid);
        },
        getData: function getData() {

            var API = "https://api.semeq.com.br/";
            var ENDPOINT = 'v1/mysemeq-ambev/get-top-priorities?corp=' + this.filtersOn.corp + '&region=' + this.filtersOn.region + '&planta=' + this.filtersOn.planta + '&area_f=' + this.filtersOn.area_f + '&sector_f=' + this.filtersOn.sector_f + '&machine=' + this.filtersOn.machine + '&subset=' + this.filtersOn.subset;
            this.$refs.chart.chart.showLoading();

            var self = this;
            __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ENDPOINT, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (_ref) {
                var data = _ref.data;

                self.chartOptions.xAxis.categories = data.x;
                self.chartOptions.series[0].data = data.y;

                self.$refs.chart.chart.hideLoading();
            }).catch(function (err) {
                self.ApiErrorHandler(self, error.response.data.status_code);
                self.$refs.chart.chart.showLoading('Error');
            });
        },
        getOtherChart: function getOtherChart() {
            this.showOtherChart = !this.showOtherChart;
            this.activeOtherChart = !this.activeOtherChart;
            this.btn_title = this.showOtherChart ? 'Top Priorities' : 'Point Alarm';
        }
    }),
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filtersOn'])),
    watch: {
        filtersOn: function filtersOn(newValue) {
            this.getData();
        }
    }
});

/***/ }),

/***/ "Yqjs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YsTl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapChartOnline_vue__ = __webpack_require__("5yP1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5867224_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapChartOnline_vue__ = __webpack_require__("Eark");
function injectStyle (ssrContext) {
  __webpack_require__("utzq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e5867224"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapChartOnline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5867224_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapChartOnline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z0AX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_ChartsOnline_ChartsSensorBattery__ = __webpack_require__("xyBX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");











__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_vue_js_popover___default.a);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'charts',
  components: {
    ChartsSensorBattery: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_ChartsOnline_ChartsSensorBattery__["a" /* default */],
    Help: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_components_Help__["a" /* default */]
  },
  data: function data() {
    var _chartOptions;

    return {
      titleChart: this.$t("242"),
      tableData: [],
      chartOptions: (_chartOptions = {
        chart: {
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },
        title: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '16px',
            fontWeight: 'bold'
          }
        },
        subtitle: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase'
          }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        xAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        yAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },
        plotOptions: {
          pie: {
            borderWidth: 0,
            size: '80%',
            dataLabels: {
              distance: 1
            },
            depth: 55
          },
          series: {
            innerSize: '50%',
            dataLabels: {
              enabled: true,
              format: '<span style="color:#fff ">{point.name}:<br></span><span style="color:#fff "> {point.y}</span>',
              color: '#F0F0F3',
              style: {
                fontSize: '13px'
              }
            },
            marker: {
              lineColor: '#333'
            },
            events: {
              click: this.loadGrid
            },
            cursor: 'pointer'
          },
          boxplot: {
            fillColor: '#505053'
          },
          candlestick: {
            lineColor: 'white'
          },
          errorbar: {
            color: 'white'
          }
        },
        legend: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          itemStyle: {
            color: '#E0E0E3'
          },
          itemHoverStyle: {
            color: '#FFF'
          },
          itemHiddenStyle: {
            color: '#606063'
          },
          title: {
            style: {
              color: '#C0C0C0',
              fontSize: '12px'
            }
          }
        },
        credits: {
          style: {
            color: '#666'
          }
        },
        labels: {
          style: {
            color: '#707073'
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            color: '#F0F0F3'
          },
          activeDataLabelStyle: {
            color: '#F0F0F3'
          }
        },
        navigation: {
          buttonOptions: {
            symbolStroke: '#DDDDDD',
            theme: {
              fill: '#505053'
            }
          }
        },

        rangeSelector: {
          buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: {
              color: '#CCC'
            },
            states: {
              hover: {
                fill: '#707073',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              },
              select: {
                fill: '#000003',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              }
            }
          },
          inputBoxBorderColor: '#505053',
          inputStyle: {
            backgroundColor: '#333',
            color: 'silver'
          },
          labelStyle: {
            color: 'silver'
          }
        },
        navigator: {
          handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
          },
          outlineColor: '#CCC',
          maskFill: 'rgba(255,255,255,0.1)',
          series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
          },
          xAxis: {
            gridLineColor: '#505053'
          }
        },
        scrollbar: {
          barBackgroundColor: '#808083',
          barBorderColor: '#808083',
          buttonArrowColor: '#CCC',
          buttonBackgroundColor: '#606063',
          buttonBorderColor: '#606063',
          rifleColor: '#FFF',
          trackBackgroundColor: '#404043',
          trackBorderColor: '#404043'
        },
        series: [{
          name: "SAMPLES",
          colorByPoint: true,
          data: []
        }]
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'drilldown', {
        series: []
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'exporting', { enabled: false }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'credits', {
        enabled: false
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'loading', {
        labelStyle: {
          color: 'black',
          textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
        },
        style: {
          backgroundColor: 'none',
          opacity: 1
        }
      }), _chartOptions),
      showBattery: false,
      activeBattery: false,
      btn_title: this.$t("242_1")
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__utils_mixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['changeGridOnline']), {
    loadGrid: function loadGrid(event) {
      var status = event.point.drilldown;
      var point_name = event.point.name;
      var NAME_CHART = this.$t("366") + ' - ' + point_name.toUpperCase();

      var ENDPOINT = 'v1/mysemeq-ambev/get-sensor-status-grid?corp=' + this.filtersOn.corp + '&region=' + this.filtersOn.region + '&planta=' + this.filtersOn.planta + '&status=' + status + '&area_f=' + this.filtersOn.area_f + '&sector_f=' + this.filtersOn.sector_f + '&machine=' + this.filtersOn.machine + '&subset=' + this.filtersOn.subset;

      var gridOnline = {
        title: event.point.name,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
          "area": [this.$t("311")],
          "setor": [this.$t("312")],
          "conj": [this.$t("316"), 'conjunto'],
          "conj_tag": [this.$t("317")],
          "equip": [this.$t("313")],
          "equip_tag": [this.$t("314")],
          "ponto": [this.$t("340")],
          "serie": [this.$t("339")],
          "versao": [this.$t("336")],
          "data": [this.$t("334")],
          "bateria": [this.$t("335")],
          "sinal_nivel": [this.$t("337")],
          "node": [this.$t("338"), 'nodo'],
          "status": ['Status'],
          "id_planta": ['id_planta']
        },
        show: true,
        titleHelp: 'Grid - ' + this.$t("366"),
        txtHelp: this.$t("367")
      };

      if (!this.filtersOn.planta) {
        gridOnline.columns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ "rows": [''], 'planta': [this.$t("310"), 'planta_f'] }, gridOnline.columns);
      } else {
        gridOnline.columns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ "rows": [''] }, gridOnline.columns);
      }

      if (this.filtersOn.planta) {
        gridOnline.title += ' - ' + this.filtersOn.planta_name;
        delete gridOnline.columns['planta'];
      }

      this.changeGridOnline(gridOnline);
    },
    getData: function getData() {
      var API = "https://api.semeq.com.br/";

      var ENDPOINT = 'v1/mysemeq-ambev/get-sensor-status';
      var self = this;

      this.$refs.chart.chart.showLoading();

      __WEBPACK_IMPORTED_MODULE_4_axios___default()({ method: 'GET', url: API + ENDPOINT, params: this.filtersOn, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        self.tableData = resp.data.result;
        self.$refs.chart.chart.hideLoading();
      }).catch(function (err) {
        self.$refs.chart.chart.showLoading('Error');

        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    },
    setChartData: function setChartData() {
      var self = this;
      var res = self.tableData;
      var values = [];
      for (var key in res) {
        if (res[key].status == 1) {
          var color = '#90ed7d';
          var name = this.$t("242_2");
        }
        if (res[key].status == 0) {
          var color = '#f45b5b';
          var name = this.$t("242_3");
        }
        if (res[key].status == 2) {
          var color = '#6b91c9';
          var name = this.$t("242_4");
        }

        values.push({ 'name': name, 'y': res[key].total, 'drilldown': res[key].status, 'color': color });
      }
      self.chartOptions.series[0].data = values;
    },
    getBatteryChart: function getBatteryChart() {
      this.showBattery = !this.showBattery;
      this.activeBattery = !this.activeBattery;
      this.btn_title = this.showBattery ? this.$t("242_5") : this.$t("242_1");
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['filtersOn'])),
  watch: {
    filtersOn: function filtersOn(newValue) {
      this.getData();
    },
    tableData: function tableData() {
      this.setChartData();
    }
  }
});

/***/ }),

/***/ "Z450":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-progress',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    value: {
      type: Number,
      default: 0,
      validator: function validator(value) {
        return value >= 0 && value <= 100;
      }
    },
    values: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
});

/***/ }),

/***/ "Z8Ar":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZJgM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZLYL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0fe1c34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("q+5V");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0fe1c34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZwUA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showBattery),expression:"!showBattery"}]},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpstatus","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("240")))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("241")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help title-mobile"},[_vm._v(_vm._s(_vm.$t("242"))+"\n      "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpstatus.right",arg:"helpstatus",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('ChartsSensorBattery',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBattery),expression:"showBattery"}]})],1),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-sm",attrs:{"id":"buttons","role":"group","aria-label":"Buttons"}},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.getBatteryChart()}}},[_c('small',[_vm._v(_vm._s(_vm.btn_title))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a8eF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  data: function data() {
    return {
      defaultPagination: 3,
      infoPagination: 5
    };
  }
});

/***/ }),

/***/ "aCDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "aNBM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"area-radar-chart"},[_c('div',{staticClass:"content-1",staticStyle:{"height":"300px","padding":"0"}},[_c('div',{staticClass:"chart-content-div"},[_c('highcharts',{ref:"chart",staticStyle:{"height":"100%","width":"100%"},attrs:{"options":_vm.chartOptions}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aS2V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "alEA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('form',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email address")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('email'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.password),expression:"modelValidations.password"},{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control",attrs:{"type":"password","name":"password"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.password.invalid),expression:"password.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('password'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Confirm Password")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.confirmPassword),expression:"modelValidations.confirmPassword"},{name:"model",rawName:"v-model",value:(_vm.model.confirmPassword),expression:"model.confirmPassword"}],staticClass:"form-control",attrs:{"type":"password","name":"confirm"},domProps:{"value":(_vm.model.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "confirmPassword", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.confirm.invalid),expression:"confirm.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('confirm'))+"\n        ")])]),_vm._v(" "),_c('p-checkbox',[_vm._v("Subscribe to newsletter")])],1),_vm._v(" "),_c('div',{staticClass:"card-footer text-right"},[_c('button',{staticClass:"btn btn-fill btn-info btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Register")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n        Register Form\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aput":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'donut',
  data: function data() {
    var _chartOptions;

    return {
      tableData: [],
      chartOptions: (_chartOptions = {
        chart: {
          colors: ['#f45b5b', '#434348'],
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063',

          margin: -5,
          marginTop: 20
        },
        title: {
          text: ((this.pendente / (this.pendente + this.programado) || 0) * 100).toFixed(2) + ' %',
          align: 'center',
          verticalAlign: 'middle',
          margin: -10,
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '16px !important',
            fontWeight: 'bold !important'
          }
        },
        subtitle: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase'
          }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        xAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        yAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        tooltip: {
          headerFormat: '',
          formatter: function formatter() {
            if (this.point.name == 'No data') return false;
            return '<span style="color:' + this.color + '">' + this.point.name + '</span>: <b>' + this.y + '</b>';
          },
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },
        plotOptions: {
          pie: {
            size: '80%',
            borderWidth: 0,
            borderColor: '#f45b5b',
            dataLabels: {
              distance: 5
            },
            startAngle: -180,
            endAngle: 180,
            center: ['50%', '50%'],
            cursor: 'pointer'
          },
          series: {
            innerSize: '50%',
            dataLabels: {
              enabled: true,
              color: '#F0F0F3',
              style: {
                fontSize: '13px'
              }
            },
            events: {
              click: this.loadGrid
            }
          },
          boxplot: {
            fillColor: '#505053'
          },
          candlestick: {
            lineColor: 'white'
          },
          errorbar: {
            color: 'white'
          }
        },
        legend: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          itemStyle: {
            color: '#E0E0E3'
          },
          itemHoverStyle: {
            color: '#FFF'
          },
          itemHiddenStyle: {
            color: '#606063'
          },
          title: {
            style: {
              color: '#C0C0C0',
              fontSize: '12px;'
            }
          }
        },
        credits: {
          style: {
            color: '#666'
          }
        },
        labels: {
          style: {
            color: '#000'
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            color: '#F0F0F3'
          },
          activeDataLabelStyle: {
            color: '#F0F0F3'
          }
        },
        navigation: {
          buttonOptions: {
            symbolStroke: '#DDDDDD',
            theme: {
              fill: '#505053'
            }
          }
        },

        rangeSelector: {
          buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: {
              color: '#CCC'
            },
            states: {
              hover: {
                fill: '#707073',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              },
              select: {
                fill: '#000003',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              }
            }
          },
          inputBoxBorderColor: '#505053',
          inputStyle: {
            backgroundColor: '#333',
            color: 'silver'
          },
          labelStyle: {
            color: 'silver'
          }
        },
        navigator: {
          handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
          },
          outlineColor: '#CCC',
          maskFill: 'rgba(255,255,255,0.1)',
          series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
          },
          xAxis: {
            gridLineColor: '#505053'
          }
        },
        scrollbar: {
          barBackgroundColor: '#808083',
          barBorderColor: '#808083',
          buttonArrowColor: '#CCC',
          buttonBackgroundColor: '#606063',
          buttonBorderColor: '#606063',
          rifleColor: '#FFF',
          trackBackgroundColor: '#404043',
          trackBorderColor: '#404043'
        },
        series: [{
          name: "Reports",
          colorByPoint: true,
          data: [{ name: this.$t("297"), y: this.pendente, color: '#f45b5b' }, { name: this.$t("298"), y: this.programado, color: '#e4d354' }]
        }]
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'drilldown', {
        series: []
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'exporting', { enabled: false }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'credits', {
        enabled: false
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'loading', {
        labelStyle: {
          color: 'black',
          textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
        },
        style: {
          backgroundColor: 'none',
          opacity: 1
        }
      }), _chartOptions)
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    loadGrid: function loadGrid(event) {

      var area_id = '';
      var planta = '';
      var region = '';

      var evento = event.point.name;
      var filtro = '';
      if (evento == 'Pendente') {
        filtro = 'Pending';
      }
      if (evento == 'Programado') {
        filtro = 'Scheduled';
      }

      var filter = !filtro ? event.point.name : filtro;


      var feedback = filter;

      var NAME_CHART = feedback.toUpperCase() + ' REPORTS - ' + this.title;

      if (feedback == 'No data') return;

      if (this.filters.plant) {
        planta = this.filters.plant;
        area_id = this.id;
      } else if (this.filters.region) {
        planta = this.id;
      } else {
        region = this.id;
      }

      var ENDPOINT = 'v1/mysemeq-ambev/get-reports-repetition?year=' + this.filters.year + '&period=' + this.filters.period + '&plant=' + planta + '&region=' + region + '&technique=' + (this.online ? '' : this.filters.technique) + '&area=' + this.filters.area + '&sector=' + this.filters.sector + '&machine=' + this.filters.machine + '&component=' + this.filters.component + '&feedback_status=' + feedback + '&area_id=' + area_id + '&online=' + this.online;

      var grid = {
        totalDados: event.point.y,
        title: NAME_CHART,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
          "rows": '',
          "plant": this.$t("310"),
          "area": this.$t("311"),
          "sector": this.$t("312"),
          "component": this.$t("313"),
          "component_tag": this.$t("314"),
          "component_type_en": this.$t("315"),
          "machine": this.$t("316"),
          "machine_tag": this.$t("317"),
          "status_txt_en": this.$t("318"),
          "report_number": this.$t("319"),
          "approved_datetime": this.$t("320"),
          "technique_en": this.$t("321"),
          "feedback_status_en": this.$t("333"),
          "link": this.$t("323"),
          "link_rci": this.$t("324")
        },
        show: true,
        titleHelp: 'Grid - ' + this.$t("354"),
        txtHelp: this.$t("355")
      };

      if (this.filters.plant) {
        delete grid.columns['plant'];
      }

      this.changeGrid(grid);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['changeGrid'])),
  mounted: function mounted() {
    if (this.pendente == 0 && this.programado == 0) {
      this.chartOptions.series[0].data = [{ name: 'No data', y: 100, color: 'transparent' }];
      this.chartOptions.plotOptions.pie.borderWidth = 1;

      this.chartOptions.plotOptions.pie.cursor = '';
      this.$refs.chart.chart.redraw();
    }
  },
  props: {
    title: {
      type: String
    },
    pendente: {
      type: Number
    },
    programado: {
      type: Number
    },
    id: {
      type: String
    },
    filters: {
      type: Object
    },
    online: {
      type: Number,
      default: 0
    }
  }
});

/***/ }),

/***/ "ax/O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExecutionIndicators_vue__ = __webpack_require__("+enL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6280e597_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutionIndicators_vue__ = __webpack_require__("kN1a");
function injectStyle (ssrContext) {
  __webpack_require__("LoYo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6280e597"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExecutionIndicators_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6280e597_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutionIndicators_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bJ0t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['email', 'password'])),
  data: function data() {
    return {
      model: {
        email: '',
        password: ''
      },
      modelValidations: {
        email: {
          required: true,
          email: true
        },
        password: {
          required: true,
          min: 5
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.$emit('on-submit', _this.registerForm, isValid);
      });
    }
  }
});

/***/ }),

/***/ "bOnU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_user__ = __webpack_require__("yLEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api__ = __webpack_require__("VsUZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_auth__ = __webpack_require__("+4WN");


var _mutations;







var state = { status: '', profile: {}, tab: '' };

var getters = {
  getProfile: function getProfile(state) {
    return state.profile;
  },
  isProfileLoaded: function isProfileLoaded(state) {
    return !!state.profile.name;
  },
  getTab: function getTab(state) {
    return state.tab;
  }
};

var actions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__actions_user__["a" /* USER_REQUEST */], function (_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  commit(__WEBPACK_IMPORTED_MODULE_1__actions_user__["a" /* USER_REQUEST */]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* default */])({ url: 'user/me' }).then(function (resp) {
    commit(__WEBPACK_IMPORTED_MODULE_1__actions_user__["b" /* USER_SUCCESS */], resp);
  }).catch(function (resp) {
    commit(__WEBPACK_IMPORTED_MODULE_1__actions_user__["c" /* USER_ERROR */]);

    dispatch(__WEBPACK_IMPORTED_MODULE_4__actions_auth__["a" /* AUTH_LOGOUT */]);
  });
});

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions_user__["a" /* USER_REQUEST */], function (state) {
  state.status = 'loading';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions_user__["b" /* USER_SUCCESS */], function (state, resp) {
  state.status = 'success';
  __WEBPACK_IMPORTED_MODULE_3_vue___default.a.set(state, 'profile', resp);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__actions_user__["c" /* USER_ERROR */], function (state) {
  state.status = 'error';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_auth__["a" /* AUTH_LOGOUT */], function (state) {
  state.profile = {};
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'changeTab', function changeTab(state, payload) {
  state.tab = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "bSRr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpdata","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("259")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help title-margin-da"},[_vm._v(_vm._s(_vm.$t("260"))+" \n    "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpdata.right",arg:"helpdata",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bTCR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpsubsets","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("243")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help"},[_vm._v(_vm._s(_vm.$t("244"))+" \n    "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpsubsets.right",arg:"helpsubsets",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bTbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bUm6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chartsDefects_vue__ = __webpack_require__("6dZJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b4e3c8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chartsDefects_vue__ = __webpack_require__("2ieh");
function injectStyle (ssrContext) {
  __webpack_require__("1XZe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chartsDefects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b4e3c8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chartsDefects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bkE3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExecutionIndicators_vue__ = __webpack_require__("7XZz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c9af652_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutionIndicators_vue__ = __webpack_require__("gSF5");
function injectStyle (ssrContext) {
  __webpack_require__("qhRV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c9af652"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExecutionIndicators_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c9af652_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutionIndicators_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bnyp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
    modal_rdp: {
        link_rdp: '',
        link_rci: '',
        technique_id: '',
        id_rdp: '',
        report_number: '',
        plant: '',
        area: ''
    }
};

var getters = {
    modal_rdp: function modal_rdp(state) {
        return state.modal_rdp;
    }
};

var mutations = {
    changeModal: function changeModal(state, payload) {
        state.modal_rdp = payload;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations
});

/***/ }),

/***/ "bpJH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TIPO_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_CHART_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_CHART_POINT_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_CHART_ALARME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_CHART_SENSOR_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_CHART_NODE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_CHART_SENSOR_BATTERY; });
var TIPO_ERROR = 'TIPO_ERROR';
var GET_CHART_STATUS = 'GET_CHART_STATUS';
var GET_CHART_POINT_STATUS = 'GET_CHART_POINT_STATUS';
var GET_CHART_ALARME = 'GET_CHART_ALARME';
var GET_CHART_SENSOR_STATUS = 'GET_CHART_SENSOR_STATUS';
var GET_CHART_NODE_STATUS = 'GET_CHART_NODE_STATUS';
var GET_CHART_SENSOR_BATTERY = 'GET_CHART_SENSOR_BATTERY';

/***/ }),

/***/ "buXi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abcd5d4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("u244");
function injectStyle (ssrContext) {
  __webpack_require__("pnG7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abcd5d4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bx0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Task_vue__ = __webpack_require__("fm0D");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Task: __WEBPACK_IMPORTED_MODULE_1__Task_vue__["a" /* default */]
  },
  data: function data() {
    return {
      tasks: [{
        title: 'Sign contract for "What are conference organizers afraid of?"'
      }, {
        title: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
      }, {
        title: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
      }, {
        title: 'Create 4 Invisible User Experiences you Never Knew About'
      }, {
        title: 'Read "Following makes Medium better"'
      }, {
        title: 'Unfollow 5 enemies from twitter'
      }]
    };
  },

  methods: {
    handleTaskEdit: function handleTaskEdit(index) {
      alert('You want to edit task: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tasks[index]));
    },
    handleTaskDelete: function handleTaskDelete(index) {
      alert('You want to delete task: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tasks[index]));
    }
  }
});

/***/ }),

/***/ "cDSy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cqsY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpfailf","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("224")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.$t("225"))+"\n    "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpfailf.right",arg:"helpfailf",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d+MP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpsensor","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("261")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help title-margin"},[_vm._v(_vm._s(_vm.$t("262"))+"\n    "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpsensor.right",arg:"helpsensor",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('highcharts',{ref:"chart",staticClass:"my-chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "d8qD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ddgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__ = __webpack_require__("OaMs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f662b08e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__ = __webpack_require__("XIFX");
function injectStyle (ssrContext) {
  __webpack_require__("YNHp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f662b08e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "duHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lock_vue__ = __webpack_require__("RXFM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ae8996_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lock_vue__ = __webpack_require__("qQLU");
function injectStyle (ssrContext) {
  __webpack_require__("Mi7u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ae8996_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e/5w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chartsReport_vue__ = __webpack_require__("Gm+k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_129c2b3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chartsReport_vue__ = __webpack_require__("S3qy");
function injectStyle (ssrContext) {
  __webpack_require__("N10g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-129c2b3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chartsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_129c2b3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chartsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "eC1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_toggle_button__ = __webpack_require__("nkUn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__js_world_continent_json__ = __webpack_require__("ui7A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__js_world_continent_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__js_world_continent_json__);







__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_js_popover___default.a);



__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_js_toggle_button___default.a);

var Highcharts = __webpack_require__("SMri");



Highcharts.theme = {
    colors: ['#2b908f', '#90ee7e', '#f45b5b', '#7798BF', '#aaeeee', '#ff0066', '#eeaaee', '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'],
    chart: {
        backgroundColor: 'rgba(0,0,0,0)',

        style: {
            fontFamily: '\'Unica One\', sans-serif'
        },
        plotBorderColor: '#606063',
        marginTop: 50,
        marginBottom: 50
    },
    title: {
        style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '20px'
        }
    },
    subtitle: {
        style: {
            color: '#E0E0E3',
            textTransform: 'uppercase'
        }
    },
    xAxis: {
        gridLineColor: '#707073',
        labels: {
            style: {
                color: '#E0E0E3'
            }
        },
        lineColor: '#707073',
        minorGridLineColor: '#505053',
        tickColor: '#707073',
        title: {
            style: {
                color: '#A0A0A3'
            }
        }
    },
    yAxis: {
        gridLineColor: '#707073',
        labels: {
            style: {
                color: '#E0E0E3'
            }
        },
        lineColor: '#707073',
        minorGridLineColor: '#505053',
        tickColor: '#707073',
        tickWidth: 1,
        title: {
            style: {
                color: '#A0A0A3'
            }
        }
    },
    tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        style: {
            color: '#F0F0F0'
        }
    },
    plotOptions: {
        series: {
            dataLabels: {
                color: '#F0F0F3',
                style: {
                    fontSize: '13px'
                }
            },
            marker: {
                lineColor: '#333'
            }
        },
        boxplot: {
            fillColor: '#505053'
        },
        candlestick: {
            lineColor: 'white'
        },
        errorbar: {
            color: 'white'
        }
    },
    legend: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        itemStyle: {
            color: '#E0E0E3'
        },
        itemHoverStyle: {
            color: '#FFF'
        },
        itemHiddenStyle: {
            color: '#606063'
        },
        title: {
            style: {
                color: '#C0C0C0'
            }
        }
    },
    credits: {
        style: {
            color: '#666'
        }
    },
    labels: {
        style: {
            color: '#707073'
        }
    },
    drilldown: {
        activeAxisLabelStyle: {
            color: '#F0F0F3'
        },
        activeDataLabelStyle: {
            color: '#F0F0F3'
        }
    },
    navigation: {
        buttonOptions: {
            symbolStroke: '#DDDDDD',
            theme: {
                fill: '#505053'
            }
        }
    },

    rangeSelector: {
        buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: {
                color: '#CCC'
            },
            states: {
                hover: {
                    fill: '#707073',
                    stroke: '#000000',
                    style: {
                        color: 'white'
                    }
                },
                select: {
                    fill: '#000003',
                    stroke: '#000000',
                    style: {
                        color: 'white'
                    }
                }
            }
        },
        inputBoxBorderColor: '#505053',
        inputStyle: {
            backgroundColor: '#333',
            color: 'silver'
        },
        labelStyle: {
            color: 'silver'
        }
    },
    navigator: {
        handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
        },
        outlineColor: '#CCC',
        maskFill: 'rgba(255,255,255,0.1)',
        series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
        },
        xAxis: {
            gridLineColor: '#505053'
        }
    },
    scrollbar: {
        barBackgroundColor: '#808083',
        barBorderColor: '#808083',
        buttonArrowColor: '#CCC',
        buttonBackgroundColor: '#606063',
        buttonBorderColor: '#606063',
        rifleColor: '#FFF',
        trackBackgroundColor: '#404043',
        trackBorderColor: '#404043'
    },
    mapNavigation: {
        enabled: true,
        enableButtons: false
    }
};

Highcharts.setOptions(Highcharts.theme);

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        id: String
    },
    components: {
        Help: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_components_Help__["a" /* default */]
    },
    data: function data() {
        return {
            changeStart: false,
            titleChartMap: this.$t("125"),
            showLoading: true,
            showMatriz: false,
            activeMatriz: false,
            btn_title: this.$t("126"),
            name_chart: this.$t("125"),
            boxMatriz: '',
            chart: undefined,
            mapOptions: {
                chart: {
                    map: __WEBPACK_IMPORTED_MODULE_7__js_world_continent_json___default.a,

                    renderTo: this.id
                },

                title: {
                    text: ''
                },

                legend: {
                    title: {
                        text: ""
                    }
                },

                mapNavigation: {
                    enabled: true,
                    buttonOptions: {
                        verticalAlign: 'top'
                    }
                },

                tooltip: {
                    headerFormat: '',

                    pointFormat: '<b>{point.pid}</b><br>' + this.$t("127") + ' {point.value} %'
                },

                colorAxis: {
                    showInLegend: false,
                    min: 0,
                    max: 100,
                    stops: [[0, '#90ed7d'], [0.05, '#90ed7d'], [0.051, '#e4d354'], [0.07, '#e4d354'], [0.071, '#f45b5b'], [1, '#f45b5b']]
                },

                series: [{
                    name: 'Basemap',
                    borderColor: '#A0A0A0',
                    nullColor: 'rgba(217, 217, 217)',
                    showInLegend: false,

                    data: []
                }],
                credits: {
                    enabled: false
                },
                loading: {
                    labelStyle: {
                        color: 'black',
                        textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
                    },
                    style: {
                        backgroundColor: 'none',
                        opacity: 1
                    }
                }
            }
        };
    },

    methods: {
        mouseOver: function mouseOver(elem) {
            var self = this;
            if (self.changeStart == true) {
                clearInterval(self.interval);
            }
        },
        mouseleave: function mouseleave(elem) {
            var self = this;
            if (self.changeStart == true) {
                self.btChangeStart();
            }
        },
        btChangeStart: function btChangeStart() {
            var self = this;
            if (self.changeStart == true) {
                self.interval = setInterval(function () {
                    self.showMatriz = !self.showMatriz;
                    self.activeMatriz = !self.activeMatriz;
                    self.btn_title = self.showMatriz ? this.$t("125") : this.$t("126");

                    self.name_chart = self.showMatriz ? this.$t("126") : this.$t("125");

                    if (self.showMatriz) {
                        self.titleChartMap = this.$t("126");
                    } else {
                        self.titleChartMap = this.$t("125");
                    }
                }, 6000);
            } else {
                clearInterval(self.interval);
            }
        },
        getMatrizChart: function getMatrizChart() {
            this.showMatriz = !this.showMatriz;
            this.activeMatriz = !this.activeMatriz;
            this.btn_title = this.showMatriz ? this.$t("125") : this.$t("126");

            this.name_chart = this.showMatriz ? this.$t("126") : this.$t("125");

            if (this.showMatriz) {
                this.titleChartMap = this.$t("126");
            } else {
                this.titleChartMap = this.$t("125");
            }
        },
        getPoints: function getPoints() {
            var data = [];
            var self = this;

            var API = "https://api.semeq.com.br/";

            this.chart.showLoading();

            __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ('v1/mysemeq-ambev/get-health-indicator?region=GLB&tipo=offline&planta=&year=' + this.filters.year + '&period=AC&technique='), headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {
                for (var i in response.data) {
                    data.push({
                        'pid': response.data[i].city,
                        'value': response.data[i].tpm,
                        'lat': response.data[i].lat,
                        'lon': response.data[i].lng,
                        'color': response.data[i].cl
                    });
                }

                self.chart.addSeries({
                    type: 'mappoint',
                    enableMouseTracking: true,
                    colorKey: 'color',
                    name: 'Cities',
                    showInLegend: false,
                    zIndex: 7,
                    data: data
                });


                self.chart.hideLoading();
            }).catch(function (error) {
                console.log(error);
                self.chart.showLoading('Error');
            });
        },
        getWorldMap: function getWorldMap() {
            var data = [];
            var self = this;

            var API = "https://api.semeq.com.br/";

            this.chart.showLoading();

            __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + 'v1/mysemeq-ambev/get-health-indicator-glb?region=GLB&tipo=offline', headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {
                for (var i in response.data) {
                    var c = '';
                    if (response.data[i].pid == 'AFR') {
                        c = 'af';
                    } else if (response.data[i].pid == 'APAC') {
                        c = 'as';
                    } else if (response.data[i].pid == 'EUR') {
                        c = 'eu';
                    } else if (response.data[i].pid == 'NAZ') {
                            c = 'na';
                        } else if (response.data[i].pid == 'SAZ') {
                            c = 'sa';
                        }

                    data.push({
                        'hc-key': c,
                        'value': response.data[i].tpm,
                        'pid': response.data[i].pid
                    });
                };

                self.chart.addSeries({
                    name: 'Basemap',
                    borderColor: '#000',
                    nullColor: 'rgba(217, 217, 217)',
                    showInLegend: false,
                    data: data
                });
                self.chart.hideLoading();
            }).catch(function (error) {
                console.log(error);
                self.chart.showLoading('Error');
            });
        },
        getMatriz: function getMatriz() {
            var self = this;

            var API = "https://api.semeq.com.br/";

            __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ('v1/mysemeq-ambev/matrixHtml?corporation_id=1&region=' + this.filters.region + '&plant_id=' + this.filters.plant + '&year=' + this.filters.year + '&period=' + this.filters.period), headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (response) {
                self.boxMatriz = response.data;
                self.showLoading = false;
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filters'])),
    watch: {
        filters: function filters(newValue) {
            this.showLoading = true;
            this.getMatriz();
        }
    },
    mounted: function mounted() {
        this.chart = Highcharts.mapChart(this.mapOptions);
        this.getPoints();
        this.getWorldMap();
    },
    created: function created() {}
});

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be5660d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("jqwU");
function injectStyle (ssrContext) {
  __webpack_require__("U8A7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be5660d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eFVZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eHlE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 box-release"},[_c('p',[_vm._v(_vm._s(_vm.$t("292")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lang),expression:"lang"}],attrs:{"type":"radio","id":"en","value":"en"},domProps:{"checked":_vm._q(_vm.lang,"en")},on:{"change":function($event){_vm.lang="en"}}}),_vm._v(" "),_c('img',{attrs:{"src":"static/flags/US.png"}}),_vm._v(" "),_c('label',{attrs:{"for":"one"}},[_vm._v(_vm._s(_vm.$t("293")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lang),expression:"lang"}],attrs:{"type":"radio","id":"pt","value":"pt"},domProps:{"checked":_vm._q(_vm.lang,"pt")},on:{"change":function($event){_vm.lang="pt"}}}),_vm._v(" "),_c('img',{attrs:{"src":"static/flags/BR.png"}}),_vm._v(" "),_c('label',{attrs:{"for":"two"}},[_vm._v(_vm._s(_vm.$t("294")))]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-sm botao-save",attrs:{"type":"button"},on:{"click":function($event){_vm.saveLang()}}},[_vm._v(_vm._s(_vm.$t("295")))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eSiI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wizard_vue__ = __webpack_require__("gww+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bf9cce0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wizard_vue__ = __webpack_require__("3KWc");
function injectStyle (ssrContext) {
  __webpack_require__("6bl1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wizard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bf9cce0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wizard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fg-input',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    label: String
  }
});

/***/ }),

/***/ "edUT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      mapOptions: {
        chart: {
          type: 'column'
        },
        title: {
          text: 'Grafico de RDP - Drilldown '
        },
        subtitle: {
          text: 'Click the columns to view versions. Source: <a href="http://statcounter.com" target="_blank">statcounter.com</a>'
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
          title: {
            text: 'Total percent market share'
          }
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: '{point.y:.1f}%'
            }
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>'
        },
        series: [{
          name: 'Browsers',
          colorByPoint: true,
          data: [{
            'name': 'Chrome',
            'y': 62.74,
            'drilldown': 'Chrome'
          }, {
            'name': 'Firefox',
            'y': 10.57,
            'drilldown': 'Firefox'
          }, {
            'name': 'Internet Explorer',
            'y': 7.23,
            'drilldown': 'Internet Explorer'
          }, {
            'name': 'Safari',
            'y': 5.58,
            'drilldown': 'Safari'
          }, {
            'name': 'Edge',
            'y': 4.02,
            'drilldown': 'Edge'
          }, {
            'name': 'Opera',
            'y': 1.92,
            'drilldown': 'Opera'
          }, {
            'name': 'Other',
            'y': 7.62,
            'drilldown': null
          }]
        }],
        'drilldown': {
          'series': [{
            'name': 'Chrome',
            'id': 'Chrome',
            'data': [['v65.0', 0.1], ['v64.0', 1.3], ['v63.0', 53.02], ['v62.0', 1.4], ['v61.0', 0.88], ['v60.0', 0.56], ['v59.0', 0.45], ['v58.0', 0.49], ['v57.0', 0.32], ['v56.0', 0.29], ['v55.0', 0.79], ['v54.0', 0.18], ['v51.0', 0.13], ['v49.0', 2.16], ['v48.0', 0.13], ['v47.0', 0.11], ['v43.0', 0.17], ['v29.0', 0.26]]
          }, {
            'name': 'Firefox',
            'id': 'Firefox',
            'data': [['v58.0', 1.02], ['v57.0', 7.36], ['v56.0', 0.35], ['v55.0', 0.11], ['v54.0', 0.1], ['v52.0', 0.95], ['v51.0', 0.15], ['v50.0', 0.1], ['v48.0', 0.31], ['v47.0', 0.12]]
          }, {
            'name': 'Internet Explorer',
            'id': 'Internet Explorer',
            'data': [['v11.0', 6.2], ['v10.0', 0.29], ['v9.0', 0.27], ['v8.0', 0.47]]
          }, {
            'name': 'Safari',
            'id': 'Safari',
            'data': [['v11.0', 3.39], ['v10.1', 0.96], ['v10.0', 0.36], ['v9.1', 0.54], ['v9.0', 0.13], ['v5.1', 0.2]]
          }, {
            'name': 'Edge',
            'id': 'Edge',
            'data': [['v16', 2.6], ['v15', 0.92], ['v14', 0.4], ['v13', 0.1]]
          }, {
            'name': 'Opera',
            'id': 'Opera',
            'data': [['v50.0', 0.96], ['v49.0', 0.82], ['v12.1', 0.14]]
          }]
        }
      }
    };
  }
});

/***/ }),

/***/ "egBL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  menu: {
    book: ''
  }
};

var getters = {
  menu: function menu(state) {
    return state.menu;
  }
};

var mutations = {
  changeMenu: function changeMenu(state, payload) {
    state.menu = payload;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),

/***/ "epsa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Online_vue__ = __webpack_require__("/5fl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_727e78ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Online_vue__ = __webpack_require__("zIA9");
function injectStyle (ssrContext) {
  __webpack_require__("C4Ut")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-727e78ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Online_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_727e78ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Online_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f4B7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f6/7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Typography_vue__ = __webpack_require__("0Bz4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef322ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Typography_vue__ = __webpack_require__("+mNl");
function injectStyle (ssrContext) {
  __webpack_require__("LRfs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Typography_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef322ba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Typography_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fIgR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartsDefects_vue__ = __webpack_require__("RbX5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51a3ff68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartsDefects_vue__ = __webpack_require__("trg4");
function injectStyle (ssrContext) {
  __webpack_require__("N2Qe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51a3ff68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartsDefects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51a3ff68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartsDefects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fP9K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Buttons_vue__ = __webpack_require__("a8eF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a7e8c0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Buttons_vue__ = __webpack_require__("BYD1");
function injectStyle (ssrContext) {
  __webpack_require__("bTbK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Buttons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a7e8c0c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Buttons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fYtj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_vm._t("badge",[_c('div',{staticClass:"timeline-badge",class:_vm.badgeType},[_c('i',{class:_vm.badgeIcon})])]),_vm._v(" "),_c('div',{staticClass:"timeline-panel"},[_c('div',{staticClass:"timeline-heading"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"timeline-body"},[_vm._t("body")],2),_vm._v(" "),_c('h6',[_vm._t("footer")],2)])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "faDc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Testes_vue__ = __webpack_require__("edUT");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_992a1504_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Testes_vue__ = __webpack_require__("0zsf");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Testes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_992a1504_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Testes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "fm0D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__ = __webpack_require__("iGuY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be1dda7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__ = __webpack_require__("CRWE");
function injectStyle (ssrContext) {
  __webpack_require__("IWrx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Task_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be1dda7e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Task_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fotD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapChart_vue__ = __webpack_require__("eC1E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c263589_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapChart_vue__ = __webpack_require__("xcM3");
function injectStyle (ssrContext) {
  __webpack_require__("NHdb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c263589"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c263589_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g9Xd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeatMap_vue__ = __webpack_require__("y2Yh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46a2ae32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeatMap_vue__ = __webpack_require__("bSRr");
function injectStyle (ssrContext) {
  __webpack_require__("ZLYL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeatMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46a2ae32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeatMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gKTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Site title")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('footer',{staticClass:"footer-demo"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:'/register'}}},[_vm._v("Register")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 Not Found")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Oops! It seems that this page does not exist.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright pull-right"},[_vm._v("\n        © 2017, made with\n        "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Paper admin\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gP6t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gSF5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"execution","width":240}},[_c('Help',{attrs:{"titleChart":_vm.title}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("245")))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("246"))+" ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("247")))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("248"))+" ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("249")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.title)+"\n        "),_c('button',{directives:[{name:"popover",rawName:"v-popover:execution.right",arg:"execution",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('indicator-widget',{attrs:{"legend":_vm.$t('250'),"color":_vm.total_falhas_cor,"valall":_vm.total_falhas_all,"val1y":_vm.total_falhas_y,"val6m":_vm.total_falhas_6m}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('indicator-widget',{attrs:{"legend":_vm.$t('251'),"color":_vm.total_resolvidos_cor,"valall":_vm.total_resolvidos_all,"val1y":_vm.total_resolvidos_y,"val6m":_vm.total_resolvidos_6m}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('indicator-widget',{attrs:{"legend":_vm.$t('252'),"color":_vm.total_media_cor,"valall":_vm.total_media_all,"val1y":_vm.total_media_y,"val6m":_vm.total_media_6m}})],1)])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('history-chart',{attrs:{"id":"chart_failure","typeValue":'DR',"header":_vm.$t('253'),"data":_vm.chart_failure_data}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('history-chart',{attrs:{"id":"chart_resolved","typeValue":'Feedback',"header":_vm.$t('254'),"data":_vm.chart_resolved_data}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('history-chart',{attrs:{"id":"chart_tmsa","typeValue":'Days',"header":_vm.$t('255'),"data":_vm.chart_tmsa_data}})],1)])]),_vm._v(" "),_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"radar","width":240}},[_c('Help',{attrs:{"titleChart":_vm.title}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("256")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.title2)+"\n        "),_c('button',{directives:[{name:"popover",rawName:"v-popover:radar.right",arg:"radar",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},_vm._l((_vm.radar_data),function(item,key,index){return _c('div',{key:index,staticClass:"col-md-4"},[_c('area-radar-chart',{attrs:{"header":key,"data":item.data,"categories":item.categories,"id":'radar_'+index,"filters":_vm.filtersOn}})],1)}))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gdYb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
var require;var require;

!function (a) {
  if ("object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(exports))) module.exports = a();else if ("function" == typeof define && __webpack_require__("nErl")) define(a);else {
    var b;"undefined" != typeof window ? b = window : "undefined" != typeof global ? b = global : "undefined" != typeof self && (b = self), b.proj4 = a();
  }
}(function () {
  return function a(b, c, d) {
    function e(g, h) {
      if (!c[g]) {
        if (!b[g]) {
          var i = "function" == typeof require && require;if (!h && i) return require(g, !0);if (f) return f(g, !0);throw new Error("Cannot find module '" + g + "'");
        }var j = c[g] = { exports: {} };b[g][0].call(j.exports, function (a) {
          var c = b[g][1][a];return e(c ? c : a);
        }, j, j.exports, a, b, c, d);
      }return c[g].exports;
    }for (var f = "function" == typeof require && require, g = 0; g < d.length; g++) {
      e(d[g]);
    }return e;
  }({ 1: [function (a, b, c) {
      function Point(a, b, c) {
        if (!(this instanceof Point)) return new Point(a, b, c);if (Array.isArray(a)) this.x = a[0], this.y = a[1], this.z = a[2] || 0;else if ("object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(a))) this.x = a.x, this.y = a.y, this.z = a.z || 0;else if ("string" == typeof a && "undefined" == typeof b) {
          var d = a.split(",");this.x = parseFloat(d[0], 10), this.y = parseFloat(d[1], 10), this.z = parseFloat(d[2], 10) || 0;
        } else this.x = a, this.y = b, this.z = c || 0;console.warn("proj4.Point will be removed in version 3, use proj4.toPoint");
      }var d = a("mgrs");Point.fromMGRS = function (a) {
        return new Point(d.toPoint(a));
      }, Point.prototype.toMGRS = function (a) {
        return d.forward([this.x, this.y], a);
      }, b.exports = Point;
    }, { mgrs: 67 }], 2: [function (a, b, c) {
      function Projection(a, b) {
        if (!(this instanceof Projection)) return new Projection(a);b = b || function (a) {
          if (a) throw a;
        };var c = d(a);if ("object" != (typeof c === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(c))) return void b(a);var f = g(c),
            h = Projection.projections.get(f.projName);h ? (e(this, f), e(this, h), this.init(), b(null, this)) : b(a);
      }var d = a("./parseCode"),
          e = a("./extend"),
          f = a("./projections"),
          g = a("./deriveConstants");Projection.projections = f, Projection.projections.start(), b.exports = Projection;
    }, { "./deriveConstants": 33, "./extend": 34, "./parseCode": 37, "./projections": 39 }], 3: [function (a, b, c) {
      b.exports = function (a, b, c) {
        var d,
            e,
            f,
            g = c.x,
            h = c.y,
            i = c.z || 0;for (f = 0; 3 > f; f++) {
          if (!b || 2 !== f || void 0 !== c.z) switch (0 === f ? (d = g, e = "x") : 1 === f ? (d = h, e = "y") : (d = i, e = "z"), a.axis[f]) {case "e":
              c[e] = d;break;case "w":
              c[e] = -d;break;case "n":
              c[e] = d;break;case "s":
              c[e] = -d;break;case "u":
              void 0 !== c[e] && (c.z = d);break;case "d":
              void 0 !== c[e] && (c.z = -d);break;default:
              return null;}
        }return c;
      };
    }, {}], 4: [function (a, b, c) {
      var d = Math.PI / 2,
          e = a("./sign");b.exports = function (a) {
        return Math.abs(a) < d ? a : a - e(a) * Math.PI;
      };
    }, { "./sign": 21 }], 5: [function (a, b, c) {
      var d = 2 * Math.PI,
          e = 3.14159265359,
          f = a("./sign");b.exports = function (a) {
        return Math.abs(a) <= e ? a : a - f(a) * d;
      };
    }, { "./sign": 21 }], 6: [function (a, b, c) {
      b.exports = function (a) {
        return Math.abs(a) > 1 && (a = a > 1 ? 1 : -1), Math.asin(a);
      };
    }, {}], 7: [function (a, b, c) {
      b.exports = function (a) {
        return 1 - .25 * a * (1 + a / 16 * (3 + 1.25 * a));
      };
    }, {}], 8: [function (a, b, c) {
      b.exports = function (a) {
        return .375 * a * (1 + .25 * a * (1 + .46875 * a));
      };
    }, {}], 9: [function (a, b, c) {
      b.exports = function (a) {
        return .05859375 * a * a * (1 + .75 * a);
      };
    }, {}], 10: [function (a, b, c) {
      b.exports = function (a) {
        return a * a * a * (35 / 3072);
      };
    }, {}], 11: [function (a, b, c) {
      b.exports = function (a, b, c) {
        var d = b * c;return a / Math.sqrt(1 - d * d);
      };
    }, {}], 12: [function (a, b, c) {
      b.exports = function (a, b, c, d, e) {
        var f, g;f = a / b;for (var h = 0; 15 > h; h++) {
          if (g = (a - (b * f - c * Math.sin(2 * f) + d * Math.sin(4 * f) - e * Math.sin(6 * f))) / (b - 2 * c * Math.cos(2 * f) + 4 * d * Math.cos(4 * f) - 6 * e * Math.cos(6 * f)), f += g, Math.abs(g) <= 1e-10) return f;
        }return 0 / 0;
      };
    }, {}], 13: [function (a, b, c) {
      var d = Math.PI / 2;b.exports = function (a, b) {
        var c = 1 - (1 - a * a) / (2 * a) * Math.log((1 - a) / (1 + a));if (Math.abs(Math.abs(b) - c) < 1e-6) return 0 > b ? -1 * d : d;for (var e, f, g, h, i = Math.asin(.5 * b), j = 0; 30 > j; j++) {
          if (f = Math.sin(i), g = Math.cos(i), h = a * f, e = Math.pow(1 - h * h, 2) / (2 * g) * (b / (1 - a * a) - f / (1 - h * h) + .5 / a * Math.log((1 - h) / (1 + h))), i += e, Math.abs(e) <= 1e-10) return i;
        }return 0 / 0;
      };
    }, {}], 14: [function (a, b, c) {
      b.exports = function (a, b, c, d, e) {
        return a * e - b * Math.sin(2 * e) + c * Math.sin(4 * e) - d * Math.sin(6 * e);
      };
    }, {}], 15: [function (a, b, c) {
      b.exports = function (a, b, c) {
        var d = a * b;return c / Math.sqrt(1 - d * d);
      };
    }, {}], 16: [function (a, b, c) {
      var d = Math.PI / 2;b.exports = function (a, b) {
        for (var c, e, f = .5 * a, g = d - 2 * Math.atan(b), h = 0; 15 >= h; h++) {
          if (c = a * Math.sin(g), e = d - 2 * Math.atan(b * Math.pow((1 - c) / (1 + c), f)) - g, g += e, Math.abs(e) <= 1e-10) return g;
        }return -9999;
      };
    }, {}], 17: [function (a, b, c) {
      var d = 1,
          e = .25,
          f = .046875,
          g = .01953125,
          h = .01068115234375,
          i = .75,
          j = .46875,
          k = .013020833333333334,
          l = .007120768229166667,
          m = .3645833333333333,
          n = .005696614583333333,
          o = .3076171875;b.exports = function (a) {
        var b = [];b[0] = d - a * (e + a * (f + a * (g + a * h))), b[1] = a * (i - a * (f + a * (g + a * h)));var c = a * a;return b[2] = c * (j - a * (k + a * l)), c *= a, b[3] = c * (m - a * n), b[4] = c * a * o, b;
      };
    }, {}], 18: [function (a, b, c) {
      var d = a("./pj_mlfn"),
          e = 1e-10,
          f = 20;b.exports = function (a, b, c) {
        for (var g = 1 / (1 - b), h = a, i = f; i; --i) {
          var j = Math.sin(h),
              k = 1 - b * j * j;if (k = (d(h, j, Math.cos(h), c) - a) * k * Math.sqrt(k) * g, h -= k, Math.abs(k) < e) return h;
        }return h;
      };
    }, { "./pj_mlfn": 19 }], 19: [function (a, b, c) {
      b.exports = function (a, b, c, d) {
        return c *= b, b *= b, d[0] * a - c * (d[1] + b * (d[2] + b * (d[3] + b * d[4])));
      };
    }, {}], 20: [function (a, b, c) {
      b.exports = function (a, b) {
        var c;return a > 1e-7 ? (c = a * b, (1 - a * a) * (b / (1 - c * c) - .5 / a * Math.log((1 - c) / (1 + c)))) : 2 * b;
      };
    }, {}], 21: [function (a, b, c) {
      b.exports = function (a) {
        return 0 > a ? -1 : 1;
      };
    }, {}], 22: [function (a, b, c) {
      b.exports = function (a, b) {
        return Math.pow((1 - a) / (1 + a), b);
      };
    }, {}], 23: [function (a, b, c) {
      b.exports = function (a) {
        var b = { x: a[0], y: a[1] };return a.length > 2 && (b.z = a[2]), a.length > 3 && (b.m = a[3]), b;
      };
    }, {}], 24: [function (a, b, c) {
      var d = Math.PI / 2;b.exports = function (a, b, c) {
        var e = a * c,
            f = .5 * a;return e = Math.pow((1 - e) / (1 + e), f), Math.tan(.5 * (d - b)) / e;
      };
    }, {}], 25: [function (a, b, c) {
      c.wgs84 = { towgs84: "0,0,0", ellipse: "WGS84", datumName: "WGS84" }, c.ch1903 = { towgs84: "674.374,15.056,405.346", ellipse: "bessel", datumName: "swiss" }, c.ggrs87 = { towgs84: "-199.87,74.79,246.62", ellipse: "GRS80", datumName: "Greek_Geodetic_Reference_System_1987" }, c.nad83 = { towgs84: "0,0,0", ellipse: "GRS80", datumName: "North_American_Datum_1983" }, c.nad27 = { nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat", ellipse: "clrk66", datumName: "North_American_Datum_1927" }, c.potsdam = { towgs84: "606.0,23.0,413.0", ellipse: "bessel", datumName: "Potsdam Rauenberg 1950 DHDN" }, c.carthage = { towgs84: "-263.0,6.0,431.0", ellipse: "clark80", datumName: "Carthage 1934 Tunisia" }, c.hermannskogel = { towgs84: "653.0,-212.0,449.0", ellipse: "bessel", datumName: "Hermannskogel" }, c.ire65 = { towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15", ellipse: "mod_airy", datumName: "Ireland 1965" }, c.rassadiran = { towgs84: "-133.63,-157.5,-158.62", ellipse: "intl", datumName: "Rassadiran" }, c.nzgd49 = { towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993", ellipse: "intl", datumName: "New Zealand Geodetic Datum 1949" }, c.osgb36 = { towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894", ellipse: "airy", datumName: "Airy 1830" }, c.s_jtsk = { towgs84: "589,76,480", ellipse: "bessel", datumName: "S-JTSK (Ferro)" }, c.beduaram = { towgs84: "-106,-87,188", ellipse: "clrk80", datumName: "Beduaram" }, c.gunung_segara = { towgs84: "-403,684,41", ellipse: "bessel", datumName: "Gunung Segara Jakarta" }, c.rnb72 = { towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1", ellipse: "intl", datumName: "Reseau National Belge 1972" };
    }, {}], 26: [function (a, b, c) {
      c.MERIT = { a: 6378137, rf: 298.257, ellipseName: "MERIT 1983" }, c.SGS85 = { a: 6378136, rf: 298.257, ellipseName: "Soviet Geodetic System 85" }, c.GRS80 = { a: 6378137, rf: 298.257222101, ellipseName: "GRS 1980(IUGG, 1980)" }, c.IAU76 = { a: 6378140, rf: 298.257, ellipseName: "IAU 1976" }, c.airy = { a: 6377563.396, b: 6356256.91, ellipseName: "Airy 1830" }, c.APL4 = { a: 6378137, rf: 298.25, ellipseName: "Appl. Physics. 1965" }, c.NWL9D = { a: 6378145, rf: 298.25, ellipseName: "Naval Weapons Lab., 1965" }, c.mod_airy = { a: 6377340.189, b: 6356034.446, ellipseName: "Modified Airy" }, c.andrae = { a: 6377104.43, rf: 300, ellipseName: "Andrae 1876 (Den., Iclnd.)" }, c.aust_SA = { a: 6378160, rf: 298.25, ellipseName: "Australian Natl & S. Amer. 1969" }, c.GRS67 = { a: 6378160, rf: 298.247167427, ellipseName: "GRS 67(IUGG 1967)" }, c.bessel = { a: 6377397.155, rf: 299.1528128, ellipseName: "Bessel 1841" }, c.bess_nam = { a: 6377483.865, rf: 299.1528128, ellipseName: "Bessel 1841 (Namibia)" }, c.clrk66 = { a: 6378206.4, b: 6356583.8, ellipseName: "Clarke 1866" }, c.clrk80 = { a: 6378249.145, rf: 293.4663, ellipseName: "Clarke 1880 mod." }, c.clrk58 = { a: 6378293.645208759, rf: 294.2606763692654, ellipseName: "Clarke 1858" }, c.CPM = { a: 6375738.7, rf: 334.29, ellipseName: "Comm. des Poids et Mesures 1799" }, c.delmbr = { a: 6376428, rf: 311.5, ellipseName: "Delambre 1810 (Belgium)" }, c.engelis = { a: 6378136.05, rf: 298.2566, ellipseName: "Engelis 1985" }, c.evrst30 = { a: 6377276.345, rf: 300.8017, ellipseName: "Everest 1830" }, c.evrst48 = { a: 6377304.063, rf: 300.8017, ellipseName: "Everest 1948" }, c.evrst56 = { a: 6377301.243, rf: 300.8017, ellipseName: "Everest 1956" }, c.evrst69 = { a: 6377295.664, rf: 300.8017, ellipseName: "Everest 1969" }, c.evrstSS = { a: 6377298.556, rf: 300.8017, ellipseName: "Everest (Sabah & Sarawak)" }, c.fschr60 = { a: 6378166, rf: 298.3, ellipseName: "Fischer (Mercury Datum) 1960" }, c.fschr60m = { a: 6378155, rf: 298.3, ellipseName: "Fischer 1960" }, c.fschr68 = { a: 6378150, rf: 298.3, ellipseName: "Fischer 1968" }, c.helmert = { a: 6378200, rf: 298.3, ellipseName: "Helmert 1906" }, c.hough = { a: 6378270, rf: 297, ellipseName: "Hough" }, c.intl = { a: 6378388, rf: 297, ellipseName: "International 1909 (Hayford)" }, c.kaula = { a: 6378163, rf: 298.24, ellipseName: "Kaula 1961" }, c.lerch = { a: 6378139, rf: 298.257, ellipseName: "Lerch 1979" }, c.mprts = { a: 6397300, rf: 191, ellipseName: "Maupertius 1738" }, c.new_intl = { a: 6378157.5, b: 6356772.2, ellipseName: "New International 1967" }, c.plessis = { a: 6376523, rf: 6355863, ellipseName: "Plessis 1817 (France)" }, c.krass = { a: 6378245, rf: 298.3, ellipseName: "Krassovsky, 1942" }, c.SEasia = { a: 6378155, b: 6356773.3205, ellipseName: "Southeast Asia" }, c.walbeck = { a: 6376896, b: 6355834.8467, ellipseName: "Walbeck" }, c.WGS60 = { a: 6378165, rf: 298.3, ellipseName: "WGS 60" }, c.WGS66 = { a: 6378145, rf: 298.25, ellipseName: "WGS 66" }, c.WGS7 = { a: 6378135, rf: 298.26, ellipseName: "WGS 72" }, c.WGS84 = { a: 6378137, rf: 298.257223563, ellipseName: "WGS 84" }, c.sphere = { a: 6370997, b: 6370997, ellipseName: "Normal Sphere (r=6370997)" };
    }, {}], 27: [function (a, b, c) {
      c.greenwich = 0, c.lisbon = -9.131906111111, c.paris = 2.337229166667, c.bogota = -74.080916666667, c.madrid = -3.687938888889, c.rome = 12.452333333333, c.bern = 7.439583333333, c.jakarta = 106.807719444444, c.ferro = -17.666666666667, c.brussels = 4.367975, c.stockholm = 18.058277777778, c.athens = 23.7163375, c.oslo = 10.722916666667;
    }, {}], 28: [function (a, b, c) {
      c.ft = { to_meter: .3048 }, c["us-ft"] = { to_meter: 1200 / 3937 };
    }, {}], 29: [function (a, b, c) {
      function d(a, b, c) {
        var d;return Array.isArray(c) ? (d = g(a, b, c), 3 === c.length ? [d.x, d.y, d.z] : [d.x, d.y]) : g(a, b, c);
      }function e(a) {
        return a instanceof f ? a : a.oProj ? a.oProj : f(a);
      }function proj4(a, b, c) {
        a = e(a);var f,
            g = !1;return "undefined" == typeof b ? (b = a, a = h, g = !0) : ("undefined" != typeof b.x || Array.isArray(b)) && (c = b, b = a, a = h, g = !0), b = e(b), c ? d(a, b, c) : (f = { forward: function forward(c) {
            return d(a, b, c);
          }, inverse: function inverse(c) {
            return d(b, a, c);
          } }, g && (f.oProj = b), f);
      }var f = a("./Proj"),
          g = a("./transform"),
          h = f("WGS84");b.exports = proj4;
    }, { "./Proj": 2, "./transform": 65 }], 30: [function (a, b, c) {
      var d = Math.PI / 2,
          e = 1,
          f = 2,
          g = 3,
          h = 4,
          i = 5,
          j = 484813681109536e-20,
          k = 1.0026,
          l = .3826834323650898,
          m = function m(a) {
        if (!(this instanceof m)) return new m(a);if (this.datum_type = h, a) {
          if (a.datumCode && "none" === a.datumCode && (this.datum_type = i), a.datum_params) {
            for (var b = 0; b < a.datum_params.length; b++) {
              a.datum_params[b] = parseFloat(a.datum_params[b]);
            }(0 !== a.datum_params[0] || 0 !== a.datum_params[1] || 0 !== a.datum_params[2]) && (this.datum_type = e), a.datum_params.length > 3 && (0 !== a.datum_params[3] || 0 !== a.datum_params[4] || 0 !== a.datum_params[5] || 0 !== a.datum_params[6]) && (this.datum_type = f, a.datum_params[3] *= j, a.datum_params[4] *= j, a.datum_params[5] *= j, a.datum_params[6] = a.datum_params[6] / 1e6 + 1);
          }this.datum_type = a.grids ? g : this.datum_type, this.a = a.a, this.b = a.b, this.es = a.es, this.ep2 = a.ep2, this.datum_params = a.datum_params, this.datum_type === g && (this.grids = a.grids);
        }
      };m.prototype = { compare_datums: function compare_datums(a) {
          return this.datum_type !== a.datum_type ? !1 : this.a !== a.a || Math.abs(this.es - a.es) > 5e-11 ? !1 : this.datum_type === e ? this.datum_params[0] === a.datum_params[0] && this.datum_params[1] === a.datum_params[1] && this.datum_params[2] === a.datum_params[2] : this.datum_type === f ? this.datum_params[0] === a.datum_params[0] && this.datum_params[1] === a.datum_params[1] && this.datum_params[2] === a.datum_params[2] && this.datum_params[3] === a.datum_params[3] && this.datum_params[4] === a.datum_params[4] && this.datum_params[5] === a.datum_params[5] && this.datum_params[6] === a.datum_params[6] : this.datum_type === g || a.datum_type === g ? this.nadgrids === a.nadgrids : !0;
        }, geodetic_to_geocentric: function geodetic_to_geocentric(a) {
          var b,
              c,
              e,
              f,
              g,
              h,
              i,
              j = a.x,
              k = a.y,
              l = a.z ? a.z : 0,
              m = 0;if (-d > k && k > -1.001 * d) k = -d;else if (k > d && 1.001 * d > k) k = d;else if (-d > k || k > d) return null;return j > Math.PI && (j -= 2 * Math.PI), g = Math.sin(k), i = Math.cos(k), h = g * g, f = this.a / Math.sqrt(1 - this.es * h), b = (f + l) * i * Math.cos(j), c = (f + l) * i * Math.sin(j), e = (f * (1 - this.es) + l) * g, a.x = b, a.y = c, a.z = e, m;
        }, geocentric_to_geodetic: function geocentric_to_geodetic(a) {
          var b,
              c,
              e,
              f,
              g,
              h,
              i,
              j,
              k,
              l,
              m,
              n,
              o,
              p,
              q,
              r,
              s,
              t = 1e-12,
              u = t * t,
              v = 30,
              w = a.x,
              x = a.y,
              y = a.z ? a.z : 0;if (o = !1, b = Math.sqrt(w * w + x * x), c = Math.sqrt(w * w + x * x + y * y), b / this.a < t) {
            if (o = !0, q = 0, c / this.a < t) return r = d, void (s = -this.b);
          } else q = Math.atan2(x, w);e = y / c, f = b / c, g = 1 / Math.sqrt(1 - this.es * (2 - this.es) * f * f), j = f * (1 - this.es) * g, k = e * g, p = 0;do {
            p++, i = this.a / Math.sqrt(1 - this.es * k * k), s = b * j + y * k - i * (1 - this.es * k * k), h = this.es * i / (i + s), g = 1 / Math.sqrt(1 - h * (2 - h) * f * f), l = f * (1 - h) * g, m = e * g, n = m * j - l * k, j = l, k = m;
          } while (n * n > u && v > p);return r = Math.atan(m / Math.abs(l)), a.x = q, a.y = r, a.z = s, a;
        }, geocentric_to_geodetic_noniter: function geocentric_to_geodetic_noniter(a) {
          var b,
              c,
              e,
              f,
              g,
              h,
              i,
              j,
              m,
              n,
              o,
              p,
              q,
              r,
              s,
              t,
              u,
              v = a.x,
              w = a.y,
              x = a.z ? a.z : 0;if (v = parseFloat(v), w = parseFloat(w), x = parseFloat(x), u = !1, 0 !== v) b = Math.atan2(w, v);else if (w > 0) b = d;else if (0 > w) b = -d;else if (u = !0, b = 0, x > 0) c = d;else {
            if (!(0 > x)) return c = d, void (e = -this.b);c = -d;
          }return g = v * v + w * w, f = Math.sqrt(g), h = x * k, j = Math.sqrt(h * h + g), n = h / j, p = f / j, o = n * n * n, i = x + this.b * this.ep2 * o, t = f - this.a * this.es * p * p * p, m = Math.sqrt(i * i + t * t), q = i / m, r = t / m, s = this.a / Math.sqrt(1 - this.es * q * q), e = r >= l ? f / r - s : -l >= r ? f / -r - s : x / q + s * (this.es - 1), u === !1 && (c = Math.atan(q / r)), a.x = b, a.y = c, a.z = e, a;
        }, geocentric_to_wgs84: function geocentric_to_wgs84(a) {
          if (this.datum_type === e) a.x += this.datum_params[0], a.y += this.datum_params[1], a.z += this.datum_params[2];else if (this.datum_type === f) {
            var b = this.datum_params[0],
                c = this.datum_params[1],
                d = this.datum_params[2],
                g = this.datum_params[3],
                h = this.datum_params[4],
                i = this.datum_params[5],
                j = this.datum_params[6],
                k = j * (a.x - i * a.y + h * a.z) + b,
                l = j * (i * a.x + a.y - g * a.z) + c,
                m = j * (-h * a.x + g * a.y + a.z) + d;a.x = k, a.y = l, a.z = m;
          }
        }, geocentric_from_wgs84: function geocentric_from_wgs84(a) {
          if (this.datum_type === e) a.x -= this.datum_params[0], a.y -= this.datum_params[1], a.z -= this.datum_params[2];else if (this.datum_type === f) {
            var b = this.datum_params[0],
                c = this.datum_params[1],
                d = this.datum_params[2],
                g = this.datum_params[3],
                h = this.datum_params[4],
                i = this.datum_params[5],
                j = this.datum_params[6],
                k = (a.x - b) / j,
                l = (a.y - c) / j,
                m = (a.z - d) / j;a.x = k + i * l - h * m, a.y = -i * k + l + g * m, a.z = h * k - g * l + m;
          }
        } }, b.exports = m;
    }, {}], 31: [function (a, b, c) {
      var d = 1,
          e = 2,
          f = 3,
          g = 5,
          h = 6378137,
          i = .006694379990141316;b.exports = function (a, b, c) {
        function j(a) {
          return a === d || a === e;
        }var k, l, m;if (a.compare_datums(b)) return c;if (a.datum_type === g || b.datum_type === g) return c;var n = a.a,
            o = a.es,
            p = b.a,
            q = b.es,
            r = a.datum_type;if (r === f) if (0 === this.apply_gridshift(a, 0, c)) a.a = h, a.es = i;else {
          if (!a.datum_params) return a.a = n, a.es = a.es, c;for (k = 1, l = 0, m = a.datum_params.length; m > l; l++) {
            k *= a.datum_params[l];
          }if (0 === k) return a.a = n, a.es = a.es, c;r = a.datum_params.length > 3 ? e : d;
        }return b.datum_type === f && (b.a = h, b.es = i), (a.es !== b.es || a.a !== b.a || j(r) || j(b.datum_type)) && (a.geodetic_to_geocentric(c), j(a.datum_type) && a.geocentric_to_wgs84(c), j(b.datum_type) && b.geocentric_from_wgs84(c), b.geocentric_to_geodetic(c)), b.datum_type === f && this.apply_gridshift(b, 1, c), a.a = n, a.es = o, b.a = p, b.es = q, c;
      };
    }, {}], 32: [function (a, b, c) {
      function d(a) {
        var b = this;if (2 === arguments.length) {
          var c = arguments[1];d[a] = "string" == typeof c ? "+" === c.charAt(0) ? f(arguments[1]) : g(arguments[1]) : c;
        } else if (1 === arguments.length) {
          if (Array.isArray(a)) return a.map(function (a) {
            Array.isArray(a) ? d.apply(b, a) : d(a);
          });if ("string" == typeof a) {
            if (a in d) return d[a];
          } else "EPSG" in a ? d["EPSG:" + a.EPSG] = a : "ESRI" in a ? d["ESRI:" + a.ESRI] = a : "IAU2000" in a ? d["IAU2000:" + a.IAU2000] = a : console.log(a);return;
        }
      }var e = a("./global"),
          f = a("./projString"),
          g = a("./wkt");e(d), b.exports = d;
    }, { "./global": 35, "./projString": 38, "./wkt": 66 }], 33: [function (a, b, c) {
      var d = a("./constants/Datum"),
          e = a("./constants/Ellipsoid"),
          f = a("./extend"),
          g = a("./datum"),
          h = 1e-10,
          i = .16666666666666666,
          j = .04722222222222222,
          k = .022156084656084655;b.exports = function (a) {
        if (a.datumCode && "none" !== a.datumCode) {
          var b = d[a.datumCode];b && (a.datum_params = b.towgs84 ? b.towgs84.split(",") : null, a.ellps = b.ellipse, a.datumName = b.datumName ? b.datumName : a.datumCode);
        }if (!a.a) {
          var c = e[a.ellps] ? e[a.ellps] : e.WGS84;f(a, c);
        }return a.rf && !a.b && (a.b = (1 - 1 / a.rf) * a.a), (0 === a.rf || Math.abs(a.a - a.b) < h) && (a.sphere = !0, a.b = a.a), a.a2 = a.a * a.a, a.b2 = a.b * a.b, a.es = (a.a2 - a.b2) / a.a2, a.e = Math.sqrt(a.es), a.R_A && (a.a *= 1 - a.es * (i + a.es * (j + a.es * k)), a.a2 = a.a * a.a, a.b2 = a.b * a.b, a.es = 0), a.ep2 = (a.a2 - a.b2) / a.b2, a.k0 || (a.k0 = 1), a.axis || (a.axis = "enu"), a.datum || (a.datum = g(a)), a;
      };
    }, { "./constants/Datum": 25, "./constants/Ellipsoid": 26, "./datum": 30, "./extend": 34 }], 34: [function (a, b, c) {
      b.exports = function (a, b) {
        a = a || {};var c, d;if (!b) return a;for (d in b) {
          c = b[d], void 0 !== c && (a[d] = c);
        }return a;
      };
    }, {}], 35: [function (a, b, c) {
      b.exports = function (a) {
        a("EPSG:4326", "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees"), a("EPSG:4269", "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees"), a("EPSG:3857", "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs"), a.WGS84 = a["EPSG:4326"], a["EPSG:3785"] = a["EPSG:3857"], a.GOOGLE = a["EPSG:3857"], a["EPSG:900913"] = a["EPSG:3857"], a["EPSG:102113"] = a["EPSG:3857"];
      };
    }, {}], 36: [function (a, b, c) {
      var proj4 = a("./core");proj4.defaultDatum = "WGS84", proj4.Proj = a("./Proj"), proj4.WGS84 = new proj4.Proj("WGS84"), proj4.Point = a("./Point"), proj4.toPoint = a("./common/toPoint"), proj4.defs = a("./defs"), proj4.transform = a("./transform"), proj4.mgrs = a("mgrs"), proj4.version = a("../package.json").version, a("./includedProjections")(proj4), b.exports = proj4;
    }, { "../package.json": 68, "./Point": 1, "./Proj": 2, "./common/toPoint": 23, "./core": 29, "./defs": 32, "./includedProjections": "hTEDpn", "./transform": 65, mgrs: 67 }], 37: [function (a, b, c) {
      function d(a) {
        return "string" == typeof a;
      }function e(a) {
        return a in i;
      }function f(a) {
        var b = ["GEOGCS", "GEOCCS", "PROJCS", "LOCAL_CS"];return b.reduce(function (b, c) {
          return b + 1 + a.indexOf(c);
        }, 0);
      }function g(a) {
        return "+" === a[0];
      }function h(a) {
        return d(a) ? e(a) ? i[a] : f(a) ? j(a) : g(a) ? k(a) : void 0 : a;
      }var i = a("./defs"),
          j = a("./wkt"),
          k = a("./projString");b.exports = h;
    }, { "./defs": 32, "./projString": 38, "./wkt": 66 }], 38: [function (a, b, c) {
      var d = .017453292519943295,
          e = a("./constants/PrimeMeridian"),
          f = a("./constants/units");b.exports = function (a) {
        var _b = {},
            c = {};a.split("+").map(function (a) {
          return a.trim();
        }).filter(function (a) {
          return a;
        }).forEach(function (a) {
          var b = a.split("=");b.push(!0), c[b[0].toLowerCase()] = b[1];
        });var g,
            h,
            i,
            j = { proj: "projName", datum: "datumCode", rf: function rf(a) {
            _b.rf = parseFloat(a);
          }, lat_0: function lat_0(a) {
            _b.lat0 = a * d;
          }, lat_1: function lat_1(a) {
            _b.lat1 = a * d;
          }, lat_2: function lat_2(a) {
            _b.lat2 = a * d;
          }, lat_ts: function lat_ts(a) {
            _b.lat_ts = a * d;
          }, lon_0: function lon_0(a) {
            _b.long0 = a * d;
          }, lon_1: function lon_1(a) {
            _b.long1 = a * d;
          }, lon_2: function lon_2(a) {
            _b.long2 = a * d;
          }, alpha: function alpha(a) {
            _b.alpha = parseFloat(a) * d;
          }, lonc: function lonc(a) {
            _b.longc = a * d;
          }, x_0: function x_0(a) {
            _b.x0 = parseFloat(a);
          }, y_0: function y_0(a) {
            _b.y0 = parseFloat(a);
          }, k_0: function k_0(a) {
            _b.k0 = parseFloat(a);
          }, k: function k(a) {
            _b.k0 = parseFloat(a);
          }, a: function a(_a) {
            _b.a = parseFloat(_a);
          }, b: function b(a) {
            _b.b = parseFloat(a);
          }, r_a: function r_a() {
            _b.R_A = !0;
          }, zone: function zone(a) {
            _b.zone = parseInt(a, 10);
          }, south: function south() {
            _b.utmSouth = !0;
          }, towgs84: function towgs84(a) {
            _b.datum_params = a.split(",").map(function (a) {
              return parseFloat(a);
            });
          }, to_meter: function to_meter(a) {
            _b.to_meter = parseFloat(a);
          }, units: function units(a) {
            _b.units = a, f[a] && (_b.to_meter = f[a].to_meter);
          }, from_greenwich: function from_greenwich(a) {
            _b.from_greenwich = a * d;
          }, pm: function pm(a) {
            _b.from_greenwich = (e[a] ? e[a] : parseFloat(a)) * d;
          }, nadgrids: function nadgrids(a) {
            "@null" === a ? _b.datumCode = "none" : _b.nadgrids = a;
          }, axis: function axis(a) {
            var c = "ewnsud";3 === a.length && -1 !== c.indexOf(a.substr(0, 1)) && -1 !== c.indexOf(a.substr(1, 1)) && -1 !== c.indexOf(a.substr(2, 1)) && (_b.axis = a);
          } };for (g in c) {
          h = c[g], g in j ? (i = j[g], "function" == typeof i ? i(h) : _b[i] = h) : _b[g] = h;
        }return "string" == typeof _b.datumCode && "WGS84" !== _b.datumCode && (_b.datumCode = _b.datumCode.toLowerCase()), _b;
      };
    }, { "./constants/PrimeMeridian": 27, "./constants/units": 28 }], 39: [function (a, b, c) {
      function d(a, b) {
        var c = g.length;return a.names ? (g[c] = a, a.names.forEach(function (a) {
          f[a.toLowerCase()] = c;
        }), this) : (console.log(b), !0);
      }var e = [a("./projections/merc"), a("./projections/longlat")],
          f = {},
          g = [];c.add = d, c.get = function (a) {
        if (!a) return !1;var b = a.toLowerCase();return "undefined" != typeof f[b] && g[f[b]] ? g[f[b]] : void 0;
      }, c.start = function () {
        e.forEach(d);
      };
    }, { "./projections/longlat": 51, "./projections/merc": 52 }], 40: [function (a, b, c) {
      var d = 1e-10,
          e = a("../common/msfnz"),
          f = a("../common/qsfnz"),
          g = a("../common/adjust_lon"),
          h = a("../common/asinz");c.init = function () {
        Math.abs(this.lat1 + this.lat2) < d || (this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e3 = Math.sqrt(this.es), this.sin_po = Math.sin(this.lat1), this.cos_po = Math.cos(this.lat1), this.t1 = this.sin_po, this.con = this.sin_po, this.ms1 = e(this.e3, this.sin_po, this.cos_po), this.qs1 = f(this.e3, this.sin_po, this.cos_po), this.sin_po = Math.sin(this.lat2), this.cos_po = Math.cos(this.lat2), this.t2 = this.sin_po, this.ms2 = e(this.e3, this.sin_po, this.cos_po), this.qs2 = f(this.e3, this.sin_po, this.cos_po), this.sin_po = Math.sin(this.lat0), this.cos_po = Math.cos(this.lat0), this.t3 = this.sin_po, this.qs0 = f(this.e3, this.sin_po, this.cos_po), this.ns0 = Math.abs(this.lat1 - this.lat2) > d ? (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1) : this.con, this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1, this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0);
      }, c.forward = function (a) {
        var b = a.x,
            c = a.y;this.sin_phi = Math.sin(c), this.cos_phi = Math.cos(c);var d = f(this.e3, this.sin_phi, this.cos_phi),
            e = this.a * Math.sqrt(this.c - this.ns0 * d) / this.ns0,
            h = this.ns0 * g(b - this.long0),
            i = e * Math.sin(h) + this.x0,
            j = this.rh - e * Math.cos(h) + this.y0;return a.x = i, a.y = j, a;
      }, c.inverse = function (a) {
        var b, c, d, e, f, h;return a.x -= this.x0, a.y = this.rh - a.y + this.y0, this.ns0 >= 0 ? (b = Math.sqrt(a.x * a.x + a.y * a.y), d = 1) : (b = -Math.sqrt(a.x * a.x + a.y * a.y), d = -1), e = 0, 0 !== b && (e = Math.atan2(d * a.x, d * a.y)), d = b * this.ns0 / this.a, this.sphere ? h = Math.asin((this.c - d * d) / (2 * this.ns0)) : (c = (this.c - d * d) / this.ns0, h = this.phi1z(this.e3, c)), f = g(e / this.ns0 + this.long0), a.x = f, a.y = h, a;
      }, c.phi1z = function (a, b) {
        var c,
            e,
            f,
            g,
            i,
            j = h(.5 * b);if (d > a) return j;for (var k = a * a, l = 1; 25 >= l; l++) {
          if (c = Math.sin(j), e = Math.cos(j), f = a * c, g = 1 - f * f, i = .5 * g * g / e * (b / (1 - k) - c / g + .5 / a * Math.log((1 - f) / (1 + f))), j += i, Math.abs(i) <= 1e-7) return j;
        }return null;
      }, c.names = ["Albers_Conic_Equal_Area", "Albers", "aea"];
    }, { "../common/adjust_lon": 5, "../common/asinz": 6, "../common/msfnz": 15, "../common/qsfnz": 20 }], 41: [function (a, b, c) {
      var d = a("../common/adjust_lon"),
          e = Math.PI / 2,
          f = 1e-10,
          g = a("../common/mlfn"),
          h = a("../common/e0fn"),
          i = a("../common/e1fn"),
          j = a("../common/e2fn"),
          k = a("../common/e3fn"),
          l = a("../common/gN"),
          m = a("../common/asinz"),
          n = a("../common/imlfn");c.init = function () {
        this.sin_p12 = Math.sin(this.lat0), this.cos_p12 = Math.cos(this.lat0);
      }, c.forward = function (a) {
        var b,
            c,
            m,
            n,
            o,
            p,
            q,
            r,
            s,
            t,
            u,
            v,
            w,
            x,
            y,
            z,
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H = a.x,
            I = a.y,
            J = Math.sin(a.y),
            K = Math.cos(a.y),
            L = d(H - this.long0);return this.sphere ? Math.abs(this.sin_p12 - 1) <= f ? (a.x = this.x0 + this.a * (e - I) * Math.sin(L), a.y = this.y0 - this.a * (e - I) * Math.cos(L), a) : Math.abs(this.sin_p12 + 1) <= f ? (a.x = this.x0 + this.a * (e + I) * Math.sin(L), a.y = this.y0 + this.a * (e + I) * Math.cos(L), a) : (B = this.sin_p12 * J + this.cos_p12 * K * Math.cos(L), z = Math.acos(B), A = z / Math.sin(z), a.x = this.x0 + this.a * A * K * Math.sin(L), a.y = this.y0 + this.a * A * (this.cos_p12 * J - this.sin_p12 * K * Math.cos(L)), a) : (b = h(this.es), c = i(this.es), m = j(this.es), n = k(this.es), Math.abs(this.sin_p12 - 1) <= f ? (o = this.a * g(b, c, m, n, e), p = this.a * g(b, c, m, n, I), a.x = this.x0 + (o - p) * Math.sin(L), a.y = this.y0 - (o - p) * Math.cos(L), a) : Math.abs(this.sin_p12 + 1) <= f ? (o = this.a * g(b, c, m, n, e), p = this.a * g(b, c, m, n, I), a.x = this.x0 + (o + p) * Math.sin(L), a.y = this.y0 + (o + p) * Math.cos(L), a) : (q = J / K, r = l(this.a, this.e, this.sin_p12), s = l(this.a, this.e, J), t = Math.atan((1 - this.es) * q + this.es * r * this.sin_p12 / (s * K)), u = Math.atan2(Math.sin(L), this.cos_p12 * Math.tan(t) - this.sin_p12 * Math.cos(L)), C = 0 === u ? Math.asin(this.cos_p12 * Math.sin(t) - this.sin_p12 * Math.cos(t)) : Math.abs(Math.abs(u) - Math.PI) <= f ? -Math.asin(this.cos_p12 * Math.sin(t) - this.sin_p12 * Math.cos(t)) : Math.asin(Math.sin(L) * Math.cos(t) / Math.sin(u)), v = this.e * this.sin_p12 / Math.sqrt(1 - this.es), w = this.e * this.cos_p12 * Math.cos(u) / Math.sqrt(1 - this.es), x = v * w, y = w * w, D = C * C, E = D * C, F = E * C, G = F * C, z = r * C * (1 - D * y * (1 - y) / 6 + E / 8 * x * (1 - 2 * y) + F / 120 * (y * (4 - 7 * y) - 3 * v * v * (1 - 7 * y)) - G / 48 * x), a.x = this.x0 + z * Math.sin(u), a.y = this.y0 + z * Math.cos(u), a));
      }, c.inverse = function (a) {
        a.x -= this.x0, a.y -= this.y0;var b, c, o, p, q, r, s, t, u, v, w, x, y, z, A, B, C, D, E, F, G, H, I;if (this.sphere) {
          if (b = Math.sqrt(a.x * a.x + a.y * a.y), b > 2 * e * this.a) return;return c = b / this.a, o = Math.sin(c), p = Math.cos(c), q = this.long0, Math.abs(b) <= f ? r = this.lat0 : (r = m(p * this.sin_p12 + a.y * o * this.cos_p12 / b), s = Math.abs(this.lat0) - e, q = d(Math.abs(s) <= f ? this.lat0 >= 0 ? this.long0 + Math.atan2(a.x, -a.y) : this.long0 - Math.atan2(-a.x, a.y) : this.long0 + Math.atan2(a.x * o, b * this.cos_p12 * p - a.y * this.sin_p12 * o))), a.x = q, a.y = r, a;
        }return t = h(this.es), u = i(this.es), v = j(this.es), w = k(this.es), Math.abs(this.sin_p12 - 1) <= f ? (x = this.a * g(t, u, v, w, e), b = Math.sqrt(a.x * a.x + a.y * a.y), y = x - b, r = n(y / this.a, t, u, v, w), q = d(this.long0 + Math.atan2(a.x, -1 * a.y)), a.x = q, a.y = r, a) : Math.abs(this.sin_p12 + 1) <= f ? (x = this.a * g(t, u, v, w, e), b = Math.sqrt(a.x * a.x + a.y * a.y), y = b - x, r = n(y / this.a, t, u, v, w), q = d(this.long0 + Math.atan2(a.x, a.y)), a.x = q, a.y = r, a) : (b = Math.sqrt(a.x * a.x + a.y * a.y), B = Math.atan2(a.x, a.y), z = l(this.a, this.e, this.sin_p12), C = Math.cos(B), D = this.e * this.cos_p12 * C, E = -D * D / (1 - this.es), F = 3 * this.es * (1 - E) * this.sin_p12 * this.cos_p12 * C / (1 - this.es), G = b / z, H = G - E * (1 + E) * Math.pow(G, 3) / 6 - F * (1 + 3 * E) * Math.pow(G, 4) / 24, I = 1 - E * H * H / 2 - G * H * H * H / 6, A = Math.asin(this.sin_p12 * Math.cos(H) + this.cos_p12 * Math.sin(H) * C), q = d(this.long0 + Math.asin(Math.sin(B) * Math.sin(H) / Math.cos(A))), r = Math.atan((1 - this.es * I * this.sin_p12 / Math.sin(A)) * Math.tan(A) / (1 - this.es)), a.x = q, a.y = r, a);
      }, c.names = ["Azimuthal_Equidistant", "aeqd"];
    }, { "../common/adjust_lon": 5, "../common/asinz": 6, "../common/e0fn": 7, "../common/e1fn": 8, "../common/e2fn": 9, "../common/e3fn": 10, "../common/gN": 11, "../common/imlfn": 12, "../common/mlfn": 14 }], 42: [function (a, b, c) {
      var d = a("../common/mlfn"),
          e = a("../common/e0fn"),
          f = a("../common/e1fn"),
          g = a("../common/e2fn"),
          h = a("../common/e3fn"),
          i = a("../common/gN"),
          j = a("../common/adjust_lon"),
          k = a("../common/adjust_lat"),
          l = a("../common/imlfn"),
          m = Math.PI / 2,
          n = 1e-10;c.init = function () {
        this.sphere || (this.e0 = e(this.es), this.e1 = f(this.es), this.e2 = g(this.es), this.e3 = h(this.es), this.ml0 = this.a * d(this.e0, this.e1, this.e2, this.e3, this.lat0));
      }, c.forward = function (a) {
        var b,
            c,
            e = a.x,
            f = a.y;if (e = j(e - this.long0), this.sphere) b = this.a * Math.asin(Math.cos(f) * Math.sin(e)), c = this.a * (Math.atan2(Math.tan(f), Math.cos(e)) - this.lat0);else {
          var g = Math.sin(f),
              h = Math.cos(f),
              k = i(this.a, this.e, g),
              l = Math.tan(f) * Math.tan(f),
              m = e * Math.cos(f),
              n = m * m,
              o = this.es * h * h / (1 - this.es),
              p = this.a * d(this.e0, this.e1, this.e2, this.e3, f);b = k * m * (1 - n * l * (1 / 6 - (8 - l + 8 * o) * n / 120)), c = p - this.ml0 + k * g / h * n * (.5 + (5 - l + 6 * o) * n / 24);
        }return a.x = b + this.x0, a.y = c + this.y0, a;
      }, c.inverse = function (a) {
        a.x -= this.x0, a.y -= this.y0;var b,
            c,
            d = a.x / this.a,
            e = a.y / this.a;if (this.sphere) {
          var f = e + this.lat0;b = Math.asin(Math.sin(f) * Math.cos(d)), c = Math.atan2(Math.tan(d), Math.cos(f));
        } else {
          var g = this.ml0 / this.a + e,
              h = l(g, this.e0, this.e1, this.e2, this.e3);if (Math.abs(Math.abs(h) - m) <= n) return a.x = this.long0, a.y = m, 0 > e && (a.y *= -1), a;var o = i(this.a, this.e, Math.sin(h)),
              p = o * o * o / this.a / this.a * (1 - this.es),
              q = Math.pow(Math.tan(h), 2),
              r = d * this.a / o,
              s = r * r;b = h - o * Math.tan(h) / p * r * r * (.5 - (1 + 3 * q) * r * r / 24), c = r * (1 - s * (q / 3 + (1 + 3 * q) * q * s / 15)) / Math.cos(h);
        }return a.x = j(c + this.long0), a.y = k(b), a;
      }, c.names = ["Cassini", "Cassini_Soldner", "cass"];
    }, { "../common/adjust_lat": 4, "../common/adjust_lon": 5, "../common/e0fn": 7, "../common/e1fn": 8, "../common/e2fn": 9, "../common/e3fn": 10, "../common/gN": 11, "../common/imlfn": 12, "../common/mlfn": 14 }], 43: [function (a, b, c) {
      var d = a("../common/adjust_lon"),
          e = a("../common/qsfnz"),
          f = a("../common/msfnz"),
          g = a("../common/iqsfnz");c.init = function () {
        this.sphere || (this.k0 = f(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)));
      }, c.forward = function (a) {
        var b,
            c,
            f = a.x,
            g = a.y,
            h = d(f - this.long0);if (this.sphere) b = this.x0 + this.a * h * Math.cos(this.lat_ts), c = this.y0 + this.a * Math.sin(g) / Math.cos(this.lat_ts);else {
          var i = e(this.e, Math.sin(g));b = this.x0 + this.a * this.k0 * h, c = this.y0 + this.a * i * .5 / this.k0;
        }return a.x = b, a.y = c, a;
      }, c.inverse = function (a) {
        a.x -= this.x0, a.y -= this.y0;var b, c;return this.sphere ? (b = d(this.long0 + a.x / this.a / Math.cos(this.lat_ts)), c = Math.asin(a.y / this.a * Math.cos(this.lat_ts))) : (c = g(this.e, 2 * a.y * this.k0 / this.a), b = d(this.long0 + a.x / (this.a * this.k0))), a.x = b, a.y = c, a;
      }, c.names = ["cea"];
    }, { "../common/adjust_lon": 5, "../common/iqsfnz": 13, "../common/msfnz": 15, "../common/qsfnz": 20 }], 44: [function (a, b, c) {
      var d = a("../common/adjust_lon"),
          e = a("../common/adjust_lat");c.init = function () {
        this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, this.lat0 = this.lat0 || 0, this.long0 = this.long0 || 0, this.lat_ts = this.lat_ts || 0, this.title = this.title || "Equidistant Cylindrical (Plate Carre)", this.rc = Math.cos(this.lat_ts);
      }, c.forward = function (a) {
        var b = a.x,
            c = a.y,
            f = d(b - this.long0),
            g = e(c - this.lat0);return a.x = this.x0 + this.a * f * this.rc, a.y = this.y0 + this.a * g, a;
      }, c.inverse = function (a) {
        var b = a.x,
            c = a.y;return a.x = d(this.long0 + (b - this.x0) / (this.a * this.rc)), a.y = e(this.lat0 + (c - this.y0) / this.a), a;
      }, c.names = ["Equirectangular", "Equidistant_Cylindrical", "eqc"];
    }, { "../common/adjust_lat": 4, "../common/adjust_lon": 5 }], 45: [function (a, b, c) {
      var d = a("../common/e0fn"),
          e = a("../common/e1fn"),
          f = a("../common/e2fn"),
          g = a("../common/e3fn"),
          h = a("../common/msfnz"),
          i = a("../common/mlfn"),
          j = a("../common/adjust_lon"),
          k = a("../common/adjust_lat"),
          l = a("../common/imlfn"),
          m = 1e-10;c.init = function () {
        Math.abs(this.lat1 + this.lat2) < m || (this.lat2 = this.lat2 || this.lat1, this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e = Math.sqrt(this.es), this.e0 = d(this.es), this.e1 = e(this.es), this.e2 = f(this.es), this.e3 = g(this.es), this.sinphi = Math.sin(this.lat1), this.cosphi = Math.cos(this.lat1), this.ms1 = h(this.e, this.sinphi, this.cosphi), this.ml1 = i(this.e0, this.e1, this.e2, this.e3, this.lat1), Math.abs(this.lat1 - this.lat2) < m ? this.ns = this.sinphi : (this.sinphi = Math.sin(this.lat2), this.cosphi = Math.cos(this.lat2), this.ms2 = h(this.e, this.sinphi, this.cosphi), this.ml2 = i(this.e0, this.e1, this.e2, this.e3, this.lat2), this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1)), this.g = this.ml1 + this.ms1 / this.ns, this.ml0 = i(this.e0, this.e1, this.e2, this.e3, this.lat0), this.rh = this.a * (this.g - this.ml0));
      }, c.forward = function (a) {
        var b,
            c = a.x,
            d = a.y;if (this.sphere) b = this.a * (this.g - d);else {
          var e = i(this.e0, this.e1, this.e2, this.e3, d);b = this.a * (this.g - e);
        }var f = this.ns * j(c - this.long0),
            g = this.x0 + b * Math.sin(f),
            h = this.y0 + this.rh - b * Math.cos(f);return a.x = g, a.y = h, a;
      }, c.inverse = function (a) {
        a.x -= this.x0, a.y = this.rh - a.y + this.y0;var b, c, d, e;this.ns >= 0 ? (c = Math.sqrt(a.x * a.x + a.y * a.y), b = 1) : (c = -Math.sqrt(a.x * a.x + a.y * a.y), b = -1);var f = 0;if (0 !== c && (f = Math.atan2(b * a.x, b * a.y)), this.sphere) return e = j(this.long0 + f / this.ns), d = k(this.g - c / this.a), a.x = e, a.y = d, a;var g = this.g - c / this.a;return d = l(g, this.e0, this.e1, this.e2, this.e3), e = j(this.long0 + f / this.ns), a.x = e, a.y = d, a;
      }, c.names = ["Equidistant_Conic", "eqdc"];
    }, { "../common/adjust_lat": 4, "../common/adjust_lon": 5, "../common/e0fn": 7, "../common/e1fn": 8, "../common/e2fn": 9, "../common/e3fn": 10, "../common/imlfn": 12, "../common/mlfn": 14, "../common/msfnz": 15 }], 46: [function (a, b, c) {
      var d = Math.PI / 4,
          e = a("../common/srat"),
          f = Math.PI / 2,
          g = 20;c.init = function () {
        var a = Math.sin(this.lat0),
            b = Math.cos(this.lat0);b *= b, this.rc = Math.sqrt(1 - this.es) / (1 - this.es * a * a), this.C = Math.sqrt(1 + this.es * b * b / (1 - this.es)), this.phic0 = Math.asin(a / this.C), this.ratexp = .5 * this.C * this.e, this.K = Math.tan(.5 * this.phic0 + d) / (Math.pow(Math.tan(.5 * this.lat0 + d), this.C) * e(this.e * a, this.ratexp));
      }, c.forward = function (a) {
        var b = a.x,
            c = a.y;return a.y = 2 * Math.atan(this.K * Math.pow(Math.tan(.5 * c + d), this.C) * e(this.e * Math.sin(c), this.ratexp)) - f, a.x = this.C * b, a;
      }, c.inverse = function (a) {
        for (var b = 1e-14, c = a.x / this.C, h = a.y, i = Math.pow(Math.tan(.5 * h + d) / this.K, 1 / this.C), j = g; j > 0 && (h = 2 * Math.atan(i * e(this.e * Math.sin(a.y), -.5 * this.e)) - f, !(Math.abs(h - a.y) < b)); --j) {
          a.y = h;
        }return j ? (a.x = c, a.y = h, a) : null;
      }, c.names = ["gauss"];
    }, { "../common/srat": 22 }], 47: [function (a, b, c) {
      var d = a("../common/adjust_lon"),
          e = 1e-10,
          f = a("../common/asinz");c.init = function () {
        this.sin_p14 = Math.sin(this.lat0), this.cos_p14 = Math.cos(this.lat0), this.infinity_dist = 1e3 * this.a, this.rc = 1;
      }, c.forward = function (a) {
        var b,
            c,
            f,
            g,
            h,
            i,
            j,
            k,
            l = a.x,
            m = a.y;return f = d(l - this.long0), b = Math.sin(m), c = Math.cos(m), g = Math.cos(f), i = this.sin_p14 * b + this.cos_p14 * c * g, h = 1, i > 0 || Math.abs(i) <= e ? (j = this.x0 + this.a * h * c * Math.sin(f) / i, k = this.y0 + this.a * h * (this.cos_p14 * b - this.sin_p14 * c * g) / i) : (j = this.x0 + this.infinity_dist * c * Math.sin(f), k = this.y0 + this.infinity_dist * (this.cos_p14 * b - this.sin_p14 * c * g)), a.x = j, a.y = k, a;
      }, c.inverse = function (a) {
        var b, c, e, g, h, i;return a.x = (a.x - this.x0) / this.a, a.y = (a.y - this.y0) / this.a, a.x /= this.k0, a.y /= this.k0, (b = Math.sqrt(a.x * a.x + a.y * a.y)) ? (g = Math.atan2(b, this.rc), c = Math.sin(g), e = Math.cos(g), i = f(e * this.sin_p14 + a.y * c * this.cos_p14 / b), h = Math.atan2(a.x * c, b * this.cos_p14 * e - a.y * this.sin_p14 * c), h = d(this.long0 + h)) : (i = this.phic0, h = 0), a.x = h, a.y = i, a;
      }, c.names = ["gnom"];
    }, { "../common/adjust_lon": 5, "../common/asinz": 6 }], 48: [function (a, b, c) {
      var d = a("../common/adjust_lon");c.init = function () {
        this.a = 6377397.155, this.es = .006674372230614, this.e = Math.sqrt(this.es), this.lat0 || (this.lat0 = .863937979737193), this.long0 || (this.long0 = .4334234309119251), this.k0 || (this.k0 = .9999), this.s45 = .785398163397448, this.s90 = 2 * this.s45, this.fi0 = this.lat0, this.e2 = this.es, this.e = Math.sqrt(this.e2), this.alfa = Math.sqrt(1 + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1 - this.e2)), this.uq = 1.04216856380474, this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa), this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2), this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g, this.k1 = this.k0, this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2)), this.s0 = 1.37008346281555, this.n = Math.sin(this.s0), this.ro0 = this.k1 * this.n0 / Math.tan(this.s0), this.ad = this.s90 - this.uq;
      }, c.forward = function (a) {
        var b,
            c,
            e,
            f,
            g,
            h,
            i,
            j = a.x,
            k = a.y,
            l = d(j - this.long0);return b = Math.pow((1 + this.e * Math.sin(k)) / (1 - this.e * Math.sin(k)), this.alfa * this.e / 2), c = 2 * (Math.atan(this.k * Math.pow(Math.tan(k / 2 + this.s45), this.alfa) / b) - this.s45), e = -l * this.alfa, f = Math.asin(Math.cos(this.ad) * Math.sin(c) + Math.sin(this.ad) * Math.cos(c) * Math.cos(e)), g = Math.asin(Math.cos(c) * Math.sin(e) / Math.cos(f)), h = this.n * g, i = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(f / 2 + this.s45), this.n), a.y = i * Math.cos(h) / 1, a.x = i * Math.sin(h) / 1, this.czech || (a.y *= -1, a.x *= -1), a;
      }, c.inverse = function (a) {
        var b,
            c,
            d,
            e,
            f,
            g,
            h,
            i,
            j = a.x;a.x = a.y, a.y = j, this.czech || (a.y *= -1, a.x *= -1), g = Math.sqrt(a.x * a.x + a.y * a.y), f = Math.atan2(a.y, a.x), e = f / Math.sin(this.s0), d = 2 * (Math.atan(Math.pow(this.ro0 / g, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45), b = Math.asin(Math.cos(this.ad) * Math.sin(d) - Math.sin(this.ad) * Math.cos(d) * Math.cos(e)), c = Math.asin(Math.cos(d) * Math.sin(e) / Math.cos(b)), a.x = this.long0 - c / this.alfa, h = b, i = 0;var k = 0;do {
          a.y = 2 * (Math.atan(Math.pow(this.k, -1 / this.alfa) * Math.pow(Math.tan(b / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(h)) / (1 - this.e * Math.sin(h)), this.e / 2)) - this.s45), Math.abs(h - a.y) < 1e-10 && (i = 1), h = a.y, k += 1;
        } while (0 === i && 15 > k);return k >= 15 ? null : a;
      }, c.names = ["Krovak", "krovak"];
    }, { "../common/adjust_lon": 5 }], 49: [function (a, b, c) {
      var d = Math.PI / 2,
          e = Math.PI / 4,
          f = 1e-10,
          g = a("../common/qsfnz"),
          h = a("../common/adjust_lon");c.S_POLE = 1, c.N_POLE = 2, c.EQUIT = 3, c.OBLIQ = 4, c.init = function () {
        var a = Math.abs(this.lat0);if (this.mode = Math.abs(a - d) < f ? this.lat0 < 0 ? this.S_POLE : this.N_POLE : Math.abs(a) < f ? this.EQUIT : this.OBLIQ, this.es > 0) {
          var b;switch (this.qp = g(this.e, 1), this.mmf = .5 / (1 - this.es), this.apa = this.authset(this.es), this.mode) {case this.N_POLE:
              this.dd = 1;break;case this.S_POLE:
              this.dd = 1;break;case this.EQUIT:
              this.rq = Math.sqrt(.5 * this.qp), this.dd = 1 / this.rq, this.xmf = 1, this.ymf = .5 * this.qp;break;case this.OBLIQ:
              this.rq = Math.sqrt(.5 * this.qp), b = Math.sin(this.lat0), this.sinb1 = g(this.e, b) / this.qp, this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1), this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * b * b) * this.rq * this.cosb1), this.ymf = (this.xmf = this.rq) / this.dd, this.xmf *= this.dd;}
        } else this.mode === this.OBLIQ && (this.sinph0 = Math.sin(this.lat0), this.cosph0 = Math.cos(this.lat0));
      }, c.forward = function (a) {
        var b,
            c,
            i,
            j,
            k,
            l,
            m,
            n,
            o,
            p,
            q = a.x,
            r = a.y;if (q = h(q - this.long0), this.sphere) {
          if (k = Math.sin(r), p = Math.cos(r), i = Math.cos(q), this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            if (c = this.mode === this.EQUIT ? 1 + p * i : 1 + this.sinph0 * k + this.cosph0 * p * i, f >= c) return null;c = Math.sqrt(2 / c), b = c * p * Math.sin(q), c *= this.mode === this.EQUIT ? k : this.cosph0 * k - this.sinph0 * p * i;
          } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE && (i = -i), Math.abs(r + this.phi0) < f) return null;c = e - .5 * r, c = 2 * (this.mode === this.S_POLE ? Math.cos(c) : Math.sin(c)), b = c * Math.sin(q), c *= i;
          }
        } else {
          switch (m = 0, n = 0, o = 0, i = Math.cos(q), j = Math.sin(q), k = Math.sin(r), l = g(this.e, k), (this.mode === this.OBLIQ || this.mode === this.EQUIT) && (m = l / this.qp, n = Math.sqrt(1 - m * m)), this.mode) {case this.OBLIQ:
              o = 1 + this.sinb1 * m + this.cosb1 * n * i;break;case this.EQUIT:
              o = 1 + n * i;break;case this.N_POLE:
              o = d + r, l = this.qp - l;break;case this.S_POLE:
              o = r - d, l = this.qp + l;}if (Math.abs(o) < f) return null;switch (this.mode) {case this.OBLIQ:case this.EQUIT:
              o = Math.sqrt(2 / o), c = this.mode === this.OBLIQ ? this.ymf * o * (this.cosb1 * m - this.sinb1 * n * i) : (o = Math.sqrt(2 / (1 + n * i))) * m * this.ymf, b = this.xmf * o * n * j;break;case this.N_POLE:case this.S_POLE:
              l >= 0 ? (b = (o = Math.sqrt(l)) * j, c = i * (this.mode === this.S_POLE ? o : -o)) : b = c = 0;}
        }return a.x = this.a * b + this.x0, a.y = this.a * c + this.y0, a;
      }, c.inverse = function (a) {
        a.x -= this.x0, a.y -= this.y0;var b,
            c,
            e,
            g,
            i,
            j,
            k,
            l = a.x / this.a,
            m = a.y / this.a;if (this.sphere) {
          var n,
              o = 0,
              p = 0;if (n = Math.sqrt(l * l + m * m), c = .5 * n, c > 1) return null;switch (c = 2 * Math.asin(c), (this.mode === this.OBLIQ || this.mode === this.EQUIT) && (p = Math.sin(c), o = Math.cos(c)), this.mode) {case this.EQUIT:
              c = Math.abs(n) <= f ? 0 : Math.asin(m * p / n), l *= p, m = o * n;break;case this.OBLIQ:
              c = Math.abs(n) <= f ? this.phi0 : Math.asin(o * this.sinph0 + m * p * this.cosph0 / n), l *= p * this.cosph0, m = (o - Math.sin(c) * this.sinph0) * n;break;case this.N_POLE:
              m = -m, c = d - c;break;case this.S_POLE:
              c -= d;}b = 0 !== m || this.mode !== this.EQUIT && this.mode !== this.OBLIQ ? Math.atan2(l, m) : 0;
        } else {
          if (k = 0, this.mode === this.OBLIQ || this.mode === this.EQUIT) {
            if (l /= this.dd, m *= this.dd, j = Math.sqrt(l * l + m * m), f > j) return a.x = 0, a.y = this.phi0, a;g = 2 * Math.asin(.5 * j / this.rq), e = Math.cos(g), l *= g = Math.sin(g), this.mode === this.OBLIQ ? (k = e * this.sinb1 + m * g * this.cosb1 / j, i = this.qp * k, m = j * this.cosb1 * e - m * this.sinb1 * g) : (k = m * g / j, i = this.qp * k, m = j * e);
          } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
            if (this.mode === this.N_POLE && (m = -m), i = l * l + m * m, !i) return a.x = 0, a.y = this.phi0, a;k = 1 - i / this.qp, this.mode === this.S_POLE && (k = -k);
          }b = Math.atan2(l, m), c = this.authlat(Math.asin(k), this.apa);
        }return a.x = h(this.long0 + b), a.y = c, a;
      }, c.P00 = .3333333333333333, c.P01 = .17222222222222222, c.P02 = .10257936507936508, c.P10 = .06388888888888888, c.P11 = .0664021164021164, c.P20 = .016415012942191543, c.authset = function (a) {
        var b,
            c = [];return c[0] = a * this.P00, b = a * a, c[0] += b * this.P01, c[1] = b * this.P10, b *= a, c[0] += b * this.P02, c[1] += b * this.P11, c[2] = b * this.P20, c;
      }, c.authlat = function (a, b) {
        var c = a + a;return a + b[0] * Math.sin(c) + b[1] * Math.sin(c + c) + b[2] * Math.sin(c + c + c);
      }, c.names = ["Lambert Azimuthal Equal Area", "Lambert_Azimuthal_Equal_Area", "laea"];
    }, { "../common/adjust_lon": 5, "../common/qsfnz": 20 }], 50: [function (a, b, c) {
      var d = 1e-10,
          e = a("../common/msfnz"),
          f = a("../common/tsfnz"),
          g = Math.PI / 2,
          h = a("../common/sign"),
          i = a("../common/adjust_lon"),
          j = a("../common/phi2z");c.init = function () {
        if (this.lat2 || (this.lat2 = this.lat1), this.k0 || (this.k0 = 1), this.x0 = this.x0 || 0, this.y0 = this.y0 || 0, !(Math.abs(this.lat1 + this.lat2) < d)) {
          var a = this.b / this.a;this.e = Math.sqrt(1 - a * a);var b = Math.sin(this.lat1),
              c = Math.cos(this.lat1),
              g = e(this.e, b, c),
              h = f(this.e, this.lat1, b),
              i = Math.sin(this.lat2),
              j = Math.cos(this.lat2),
              k = e(this.e, i, j),
              l = f(this.e, this.lat2, i),
              m = f(this.e, this.lat0, Math.sin(this.lat0));this.ns = Math.abs(this.lat1 - this.lat2) > d ? Math.log(g / k) / Math.log(h / l) : b, isNaN(this.ns) && (this.ns = b), this.f0 = g / (this.ns * Math.pow(h, this.ns)), this.rh = this.a * this.f0 * Math.pow(m, this.ns), this.title || (this.title = "Lambert Conformal Conic");
        }
      }, c.forward = function (a) {
        var b = a.x,
            c = a.y;Math.abs(2 * Math.abs(c) - Math.PI) <= d && (c = h(c) * (g - 2 * d));var e,
            j,
            k = Math.abs(Math.abs(c) - g);if (k > d) e = f(this.e, c, Math.sin(c)), j = this.a * this.f0 * Math.pow(e, this.ns);else {
          if (k = c * this.ns, 0 >= k) return null;j = 0;
        }var l = this.ns * i(b - this.long0);return a.x = this.k0 * j * Math.sin(l) + this.x0, a.y = this.k0 * (this.rh - j * Math.cos(l)) + this.y0, a;
      }, c.inverse = function (a) {
        var b,
            c,
            d,
            e,
            f,
            h = (a.x - this.x0) / this.k0,
            k = this.rh - (a.y - this.y0) / this.k0;this.ns > 0 ? (b = Math.sqrt(h * h + k * k), c = 1) : (b = -Math.sqrt(h * h + k * k), c = -1);var l = 0;if (0 !== b && (l = Math.atan2(c * h, c * k)), 0 !== b || this.ns > 0) {
          if (c = 1 / this.ns, d = Math.pow(b / (this.a * this.f0), c), e = j(this.e, d), -9999 === e) return null;
        } else e = -g;return f = i(l / this.ns + this.long0), a.x = f, a.y = e, a;
      }, c.names = ["Lambert Tangential Conformal Conic Projection", "Lambert_Conformal_Conic", "Lambert_Conformal_Conic_2SP", "lcc"];
    }, { "../common/adjust_lon": 5, "../common/msfnz": 15, "../common/phi2z": 16, "../common/sign": 21, "../common/tsfnz": 24 }], 51: [function (a, b, c) {
      function d(a) {
        return a;
      }c.init = function () {}, c.forward = d, c.inverse = d, c.names = ["longlat", "identity"];
    }, {}], 52: [function (a, b, c) {
      var d = a("../common/msfnz"),
          e = Math.PI / 2,
          f = 1e-10,
          g = 57.29577951308232,
          h = a("../common/adjust_lon"),
          i = Math.PI / 4,
          j = a("../common/tsfnz"),
          k = a("../common/phi2z");c.init = function () {
        var a = this.b / this.a;this.es = 1 - a * a, "x0" in this || (this.x0 = 0), "y0" in this || (this.y0 = 0), this.e = Math.sqrt(this.es), this.lat_ts ? this.k0 = this.sphere ? Math.cos(this.lat_ts) : d(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) : this.k0 || (this.k0 = this.k ? this.k : 1);
      }, c.forward = function (a) {
        var b = a.x,
            c = a.y;if (c * g > 90 && -90 > c * g && b * g > 180 && -180 > b * g) return null;var d, k;if (Math.abs(Math.abs(c) - e) <= f) return null;if (this.sphere) d = this.x0 + this.a * this.k0 * h(b - this.long0), k = this.y0 + this.a * this.k0 * Math.log(Math.tan(i + .5 * c));else {
          var l = Math.sin(c),
              m = j(this.e, c, l);d = this.x0 + this.a * this.k0 * h(b - this.long0), k = this.y0 - this.a * this.k0 * Math.log(m);
        }return a.x = d, a.y = k, a;
      }, c.inverse = function (a) {
        var b,
            c,
            d = a.x - this.x0,
            f = a.y - this.y0;if (this.sphere) c = e - 2 * Math.atan(Math.exp(-f / (this.a * this.k0)));else {
          var g = Math.exp(-f / (this.a * this.k0));if (c = k(this.e, g), -9999 === c) return null;
        }return b = h(this.long0 + d / (this.a * this.k0)), a.x = b, a.y = c, a;
      }, c.names = ["Mercator", "Popular Visualisation Pseudo Mercator", "Mercator_1SP", "Mercator_Auxiliary_Sphere", "merc"];
    }, { "../common/adjust_lon": 5, "../common/msfnz": 15, "../common/phi2z": 16, "../common/tsfnz": 24 }], 53: [function (a, b, c) {
      var d = a("../common/adjust_lon");c.init = function () {}, c.forward = function (a) {
        var b = a.x,
            c = a.y,
            e = d(b - this.long0),
            f = this.x0 + this.a * e,
            g = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + c / 2.5)) * 1.25;return a.x = f, a.y = g, a;
      }, c.inverse = function (a) {
        a.x -= this.x0, a.y -= this.y0;var b = d(this.long0 + a.x / this.a),
            c = 2.5 * (Math.atan(Math.exp(.8 * a.y / this.a)) - Math.PI / 4);return a.x = b, a.y = c, a;
      }, c.names = ["Miller_Cylindrical", "mill"];
    }, { "../common/adjust_lon": 5 }], 54: [function (a, b, c) {
      var d = a("../common/adjust_lon"),
          e = 1e-10;c.init = function () {}, c.forward = function (a) {
        for (var b = a.x, c = a.y, f = d(b - this.long0), g = c, h = Math.PI * Math.sin(c), i = 0; !0; i++) {
          var j = -(g + Math.sin(g) - h) / (1 + Math.cos(g));if (g += j, Math.abs(j) < e) break;
        }g /= 2, Math.PI / 2 - Math.abs(c) < e && (f = 0);var k = .900316316158 * this.a * f * Math.cos(g) + this.x0,
            l = 1.4142135623731 * this.a * Math.sin(g) + this.y0;return a.x = k, a.y = l, a;
      }, c.inverse = function (a) {
        var b, c;a.x -= this.x0, a.y -= this.y0, c = a.y / (1.4142135623731 * this.a), Math.abs(c) > .999999999999 && (c = .999999999999), b = Math.asin(c);var e = d(this.long0 + a.x / (.900316316158 * this.a * Math.cos(b)));e < -Math.PI && (e = -Math.PI), e > Math.PI && (e = Math.PI), c = (2 * b + Math.sin(2 * b)) / Math.PI, Math.abs(c) > 1 && (c = 1);var f = Math.asin(c);return a.x = e, a.y = f, a;
      }, c.names = ["Mollweide", "moll"];
    }, { "../common/adjust_lon": 5 }], 55: [function (a, b, c) {
      var d = 484813681109536e-20;c.iterations = 1, c.init = function () {
        this.A = [], this.A[1] = .6399175073, this.A[2] = -.1358797613, this.A[3] = .063294409, this.A[4] = -.02526853, this.A[5] = .0117879, this.A[6] = -.0055161, this.A[7] = .0026906, this.A[8] = -.001333, this.A[9] = 67e-5, this.A[10] = -34e-5, this.B_re = [], this.B_im = [], this.B_re[1] = .7557853228, this.B_im[1] = 0, this.B_re[2] = .249204646, this.B_im[2] = .003371507, this.B_re[3] = -.001541739, this.B_im[3] = .04105856, this.B_re[4] = -.10162907, this.B_im[4] = .01727609, this.B_re[5] = -.26623489, this.B_im[5] = -.36249218, this.B_re[6] = -.6870983, this.B_im[6] = -1.1651967, this.C_re = [], this.C_im = [], this.C_re[1] = 1.3231270439, this.C_im[1] = 0, this.C_re[2] = -.577245789, this.C_im[2] = -.007809598, this.C_re[3] = .508307513, this.C_im[3] = -.112208952, this.C_re[4] = -.15094762, this.C_im[4] = .18200602, this.C_re[5] = 1.01418179, this.C_im[5] = 1.64497696, this.C_re[6] = 1.9660549, this.C_im[6] = 2.5127645, this.D = [], this.D[1] = 1.5627014243, this.D[2] = .5185406398, this.D[3] = -.03333098, this.D[4] = -.1052906, this.D[5] = -.0368594, this.D[6] = .007317, this.D[7] = .0122, this.D[8] = .00394, this.D[9] = -.0013;
      }, c.forward = function (a) {
        var b,
            c = a.x,
            e = a.y,
            f = e - this.lat0,
            g = c - this.long0,
            h = f / d * 1e-5,
            i = g,
            j = 1,
            k = 0;for (b = 1; 10 >= b; b++) {
          j *= h, k += this.A[b] * j;
        }var l,
            m,
            n = k,
            o = i,
            p = 1,
            q = 0,
            r = 0,
            s = 0;for (b = 1; 6 >= b; b++) {
          l = p * n - q * o, m = q * n + p * o, p = l, q = m, r = r + this.B_re[b] * p - this.B_im[b] * q, s = s + this.B_im[b] * p + this.B_re[b] * q;
        }return a.x = s * this.a + this.x0, a.y = r * this.a + this.y0, a;
      }, c.inverse = function (a) {
        var b,
            c,
            e,
            f = a.x,
            g = a.y,
            h = f - this.x0,
            i = g - this.y0,
            j = i / this.a,
            k = h / this.a,
            l = 1,
            m = 0,
            n = 0,
            o = 0;for (b = 1; 6 >= b; b++) {
          c = l * j - m * k, e = m * j + l * k, l = c, m = e, n = n + this.C_re[b] * l - this.C_im[b] * m, o = o + this.C_im[b] * l + this.C_re[b] * m;
        }for (var p = 0; p < this.iterations; p++) {
          var q,
              r,
              s = n,
              t = o,
              u = j,
              v = k;for (b = 2; 6 >= b; b++) {
            q = s * n - t * o, r = t * n + s * o, s = q, t = r, u += (b - 1) * (this.B_re[b] * s - this.B_im[b] * t), v += (b - 1) * (this.B_im[b] * s + this.B_re[b] * t);
          }s = 1, t = 0;var w = this.B_re[1],
              x = this.B_im[1];for (b = 2; 6 >= b; b++) {
            q = s * n - t * o, r = t * n + s * o, s = q, t = r, w += b * (this.B_re[b] * s - this.B_im[b] * t), x += b * (this.B_im[b] * s + this.B_re[b] * t);
          }var y = w * w + x * x;n = (u * w + v * x) / y, o = (v * w - u * x) / y;
        }var z = n,
            A = o,
            B = 1,
            C = 0;for (b = 1; 9 >= b; b++) {
          B *= z, C += this.D[b] * B;
        }var D = this.lat0 + C * d * 1e5,
            E = this.long0 + A;return a.x = E, a.y = D, a;
      }, c.names = ["New_Zealand_Map_Grid", "nzmg"];
    }, {}], 56: [function (a, b, c) {
      var d = a("../common/tsfnz"),
          e = a("../common/adjust_lon"),
          f = a("../common/phi2z"),
          g = Math.PI / 2,
          h = Math.PI / 4,
          i = 1e-10;c.init = function () {
        this.no_off = this.no_off || !1, this.no_rot = this.no_rot || !1, isNaN(this.k0) && (this.k0 = 1);var a = Math.sin(this.lat0),
            b = Math.cos(this.lat0),
            c = this.e * a;this.bl = Math.sqrt(1 + this.es / (1 - this.es) * Math.pow(b, 4)), this.al = this.a * this.bl * this.k0 * Math.sqrt(1 - this.es) / (1 - c * c);var f = d(this.e, this.lat0, a),
            g = this.bl / b * Math.sqrt((1 - this.es) / (1 - c * c));1 > g * g && (g = 1);var h, i;if (isNaN(this.longc)) {
          var j = d(this.e, this.lat1, Math.sin(this.lat1)),
              k = d(this.e, this.lat2, Math.sin(this.lat2));this.el = this.lat0 >= 0 ? (g + Math.sqrt(g * g - 1)) * Math.pow(f, this.bl) : (g - Math.sqrt(g * g - 1)) * Math.pow(f, this.bl);var l = Math.pow(j, this.bl),
              m = Math.pow(k, this.bl);h = this.el / l, i = .5 * (h - 1 / h);var n = (this.el * this.el - m * l) / (this.el * this.el + m * l),
              o = (m - l) / (m + l),
              p = e(this.long1 - this.long2);this.long0 = .5 * (this.long1 + this.long2) - Math.atan(n * Math.tan(.5 * this.bl * p) / o) / this.bl, this.long0 = e(this.long0);var q = e(this.long1 - this.long0);this.gamma0 = Math.atan(Math.sin(this.bl * q) / i), this.alpha = Math.asin(g * Math.sin(this.gamma0));
        } else h = this.lat0 >= 0 ? g + Math.sqrt(g * g - 1) : g - Math.sqrt(g * g - 1), this.el = h * Math.pow(f, this.bl), i = .5 * (h - 1 / h), this.gamma0 = Math.asin(Math.sin(this.alpha) / g), this.long0 = this.longc - Math.asin(i * Math.tan(this.gamma0)) / this.bl;this.uc = this.no_off ? 0 : this.lat0 >= 0 ? this.al / this.bl * Math.atan2(Math.sqrt(g * g - 1), Math.cos(this.alpha)) : -1 * this.al / this.bl * Math.atan2(Math.sqrt(g * g - 1), Math.cos(this.alpha));
      }, c.forward = function (a) {
        var b,
            c,
            f,
            j = a.x,
            k = a.y,
            l = e(j - this.long0);if (Math.abs(Math.abs(k) - g) <= i) f = k > 0 ? -1 : 1, c = this.al / this.bl * Math.log(Math.tan(h + f * this.gamma0 * .5)), b = -1 * f * g * this.al / this.bl;else {
          var m = d(this.e, k, Math.sin(k)),
              n = this.el / Math.pow(m, this.bl),
              o = .5 * (n - 1 / n),
              p = .5 * (n + 1 / n),
              q = Math.sin(this.bl * l),
              r = (o * Math.sin(this.gamma0) - q * Math.cos(this.gamma0)) / p;c = Math.abs(Math.abs(r) - 1) <= i ? Number.POSITIVE_INFINITY : .5 * this.al * Math.log((1 - r) / (1 + r)) / this.bl, b = Math.abs(Math.cos(this.bl * l)) <= i ? this.al * this.bl * l : this.al * Math.atan2(o * Math.cos(this.gamma0) + q * Math.sin(this.gamma0), Math.cos(this.bl * l)) / this.bl;
        }return this.no_rot ? (a.x = this.x0 + b, a.y = this.y0 + c) : (b -= this.uc, a.x = this.x0 + c * Math.cos(this.alpha) + b * Math.sin(this.alpha), a.y = this.y0 + b * Math.cos(this.alpha) - c * Math.sin(this.alpha)), a;
      }, c.inverse = function (a) {
        var b, c;this.no_rot ? (c = a.y - this.y0, b = a.x - this.x0) : (c = (a.x - this.x0) * Math.cos(this.alpha) - (a.y - this.y0) * Math.sin(this.alpha), b = (a.y - this.y0) * Math.cos(this.alpha) + (a.x - this.x0) * Math.sin(this.alpha), b += this.uc);var d = Math.exp(-1 * this.bl * c / this.al),
            h = .5 * (d - 1 / d),
            j = .5 * (d + 1 / d),
            k = Math.sin(this.bl * b / this.al),
            l = (k * Math.cos(this.gamma0) + h * Math.sin(this.gamma0)) / j,
            m = Math.pow(this.el / Math.sqrt((1 + l) / (1 - l)), 1 / this.bl);return Math.abs(l - 1) < i ? (a.x = this.long0, a.y = g) : Math.abs(l + 1) < i ? (a.x = this.long0, a.y = -1 * g) : (a.y = f(this.e, m), a.x = e(this.long0 - Math.atan2(h * Math.cos(this.gamma0) - k * Math.sin(this.gamma0), Math.cos(this.bl * b / this.al)) / this.bl)), a;
      }, c.names = ["Hotine_Oblique_Mercator", "Hotine Oblique Mercator", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin", "Hotine_Oblique_Mercator_Azimuth_Center", "omerc"];
    }, { "../common/adjust_lon": 5, "../common/phi2z": 16, "../common/tsfnz": 24 }], 57: [function (a, b, c) {
      var d = a("../common/e0fn"),
          e = a("../common/e1fn"),
          f = a("../common/e2fn"),
          g = a("../common/e3fn"),
          h = a("../common/adjust_lon"),
          i = a("../common/adjust_lat"),
          j = a("../common/mlfn"),
          k = 1e-10,
          l = a("../common/gN"),
          m = 20;c.init = function () {
        this.temp = this.b / this.a, this.es = 1 - Math.pow(this.temp, 2), this.e = Math.sqrt(this.es), this.e0 = d(this.es), this.e1 = e(this.es), this.e2 = f(this.es), this.e3 = g(this.es), this.ml0 = this.a * j(this.e0, this.e1, this.e2, this.e3, this.lat0);
      }, c.forward = function (a) {
        var b,
            c,
            d,
            e = a.x,
            f = a.y,
            g = h(e - this.long0);if (d = g * Math.sin(f), this.sphere) Math.abs(f) <= k ? (b = this.a * g, c = -1 * this.a * this.lat0) : (b = this.a * Math.sin(d) / Math.tan(f), c = this.a * (i(f - this.lat0) + (1 - Math.cos(d)) / Math.tan(f)));else if (Math.abs(f) <= k) b = this.a * g, c = -1 * this.ml0;else {
          var m = l(this.a, this.e, Math.sin(f)) / Math.tan(f);b = m * Math.sin(d), c = this.a * j(this.e0, this.e1, this.e2, this.e3, f) - this.ml0 + m * (1 - Math.cos(d));
        }return a.x = b + this.x0, a.y = c + this.y0, a;
      }, c.inverse = function (a) {
        var b, c, d, e, f, g, i, l, n;if (d = a.x - this.x0, e = a.y - this.y0, this.sphere) {
          if (Math.abs(e + this.a * this.lat0) <= k) b = h(d / this.a + this.long0), c = 0;else {
            g = this.lat0 + e / this.a, i = d * d / this.a / this.a + g * g, l = g;var o;for (f = m; f; --f) {
              if (o = Math.tan(l), n = -1 * (g * (l * o + 1) - l - .5 * (l * l + i) * o) / ((l - g) / o - 1), l += n, Math.abs(n) <= k) {
                c = l;break;
              }
            }b = h(this.long0 + Math.asin(d * Math.tan(l) / this.a) / Math.sin(c));
          }
        } else if (Math.abs(e + this.ml0) <= k) c = 0, b = h(this.long0 + d / this.a);else {
          g = (this.ml0 + e) / this.a, i = d * d / this.a / this.a + g * g, l = g;var p, q, r, s, t;for (f = m; f; --f) {
            if (t = this.e * Math.sin(l), p = Math.sqrt(1 - t * t) * Math.tan(l), q = this.a * j(this.e0, this.e1, this.e2, this.e3, l), r = this.e0 - 2 * this.e1 * Math.cos(2 * l) + 4 * this.e2 * Math.cos(4 * l) - 6 * this.e3 * Math.cos(6 * l), s = q / this.a, n = (g * (p * s + 1) - s - .5 * p * (s * s + i)) / (this.es * Math.sin(2 * l) * (s * s + i - 2 * g * s) / (4 * p) + (g - s) * (p * r - 2 / Math.sin(2 * l)) - r), l -= n, Math.abs(n) <= k) {
              c = l;break;
            }
          }p = Math.sqrt(1 - this.es * Math.pow(Math.sin(c), 2)) * Math.tan(c), b = h(this.long0 + Math.asin(d * p / this.a) / Math.sin(c));
        }return a.x = b, a.y = c, a;
      }, c.names = ["Polyconic", "poly"];
    }, { "../common/adjust_lat": 4, "../common/adjust_lon": 5, "../common/e0fn": 7, "../common/e1fn": 8, "../common/e2fn": 9, "../common/e3fn": 10, "../common/gN": 11, "../common/mlfn": 14 }], 58: [function (a, b, c) {
      var d = a("../common/adjust_lon"),
          e = a("../common/adjust_lat"),
          f = a("../common/pj_enfn"),
          g = 20,
          h = a("../common/pj_mlfn"),
          i = a("../common/pj_inv_mlfn"),
          j = Math.PI / 2,
          k = 1e-10,
          l = a("../common/asinz");c.init = function () {
        this.sphere ? (this.n = 1, this.m = 0, this.es = 0, this.C_y = Math.sqrt((this.m + 1) / this.n), this.C_x = this.C_y / (this.m + 1)) : this.en = f(this.es);
      }, c.forward = function (a) {
        var b,
            c,
            e = a.x,
            f = a.y;if (e = d(e - this.long0), this.sphere) {
          if (this.m) for (var i = this.n * Math.sin(f), j = g; j; --j) {
            var l = (this.m * f + Math.sin(f) - i) / (this.m + Math.cos(f));if (f -= l, Math.abs(l) < k) break;
          } else f = 1 !== this.n ? Math.asin(this.n * Math.sin(f)) : f;b = this.a * this.C_x * e * (this.m + Math.cos(f)), c = this.a * this.C_y * f;
        } else {
          var m = Math.sin(f),
              n = Math.cos(f);c = this.a * h(f, m, n, this.en), b = this.a * e * n / Math.sqrt(1 - this.es * m * m);
        }return a.x = b, a.y = c, a;
      }, c.inverse = function (a) {
        var b, c, f, g;return a.x -= this.x0, f = a.x / this.a, a.y -= this.y0, b = a.y / this.a, this.sphere ? (b /= this.C_y, f /= this.C_x * (this.m + Math.cos(b)), this.m ? b = l((this.m * b + Math.sin(b)) / this.n) : 1 !== this.n && (b = l(Math.sin(b) / this.n)), f = d(f + this.long0), b = e(b)) : (b = i(a.y / this.a, this.es, this.en), g = Math.abs(b), j > g ? (g = Math.sin(b), c = this.long0 + a.x * Math.sqrt(1 - this.es * g * g) / (this.a * Math.cos(b)), f = d(c)) : j > g - k && (f = this.long0)), a.x = f, a.y = b, a;
      }, c.names = ["Sinusoidal", "sinu"];
    }, { "../common/adjust_lat": 4, "../common/adjust_lon": 5, "../common/asinz": 6, "../common/pj_enfn": 17, "../common/pj_inv_mlfn": 18, "../common/pj_mlfn": 19 }], 59: [function (a, b, c) {
      c.init = function () {
        var a = this.lat0;this.lambda0 = this.long0;var b = Math.sin(a),
            c = this.a,
            d = this.rf,
            e = 1 / d,
            f = 2 * e - Math.pow(e, 2),
            g = this.e = Math.sqrt(f);this.R = this.k0 * c * Math.sqrt(1 - f) / (1 - f * Math.pow(b, 2)), this.alpha = Math.sqrt(1 + f / (1 - f) * Math.pow(Math.cos(a), 4)), this.b0 = Math.asin(b / this.alpha);var h = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2)),
            i = Math.log(Math.tan(Math.PI / 4 + a / 2)),
            j = Math.log((1 + g * b) / (1 - g * b));this.K = h - this.alpha * i + this.alpha * g / 2 * j;
      }, c.forward = function (a) {
        var b = Math.log(Math.tan(Math.PI / 4 - a.y / 2)),
            c = this.e / 2 * Math.log((1 + this.e * Math.sin(a.y)) / (1 - this.e * Math.sin(a.y))),
            d = -this.alpha * (b + c) + this.K,
            e = 2 * (Math.atan(Math.exp(d)) - Math.PI / 4),
            f = this.alpha * (a.x - this.lambda0),
            g = Math.atan(Math.sin(f) / (Math.sin(this.b0) * Math.tan(e) + Math.cos(this.b0) * Math.cos(f))),
            h = Math.asin(Math.cos(this.b0) * Math.sin(e) - Math.sin(this.b0) * Math.cos(e) * Math.cos(f));return a.y = this.R / 2 * Math.log((1 + Math.sin(h)) / (1 - Math.sin(h))) + this.y0, a.x = this.R * g + this.x0, a;
      }, c.inverse = function (a) {
        for (var b = a.x - this.x0, c = a.y - this.y0, d = b / this.R, e = 2 * (Math.atan(Math.exp(c / this.R)) - Math.PI / 4), f = Math.asin(Math.cos(this.b0) * Math.sin(e) + Math.sin(this.b0) * Math.cos(e) * Math.cos(d)), g = Math.atan(Math.sin(d) / (Math.cos(this.b0) * Math.cos(d) - Math.sin(this.b0) * Math.tan(e))), h = this.lambda0 + g / this.alpha, i = 0, j = f, k = -1e3, l = 0; Math.abs(j - k) > 1e-7;) {
          if (++l > 20) return;i = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + f / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(j)) / 2)), k = j, j = 2 * Math.atan(Math.exp(i)) - Math.PI / 2;
        }return a.x = h, a.y = j, a;
      }, c.names = ["somerc"];
    }, {}], 60: [function (a, b, c) {
      var d = Math.PI / 2,
          e = 1e-10,
          f = a("../common/sign"),
          g = a("../common/msfnz"),
          h = a("../common/tsfnz"),
          i = a("../common/phi2z"),
          j = a("../common/adjust_lon");c.ssfn_ = function (a, b, c) {
        return b *= c, Math.tan(.5 * (d + a)) * Math.pow((1 - b) / (1 + b), .5 * c);
      }, c.init = function () {
        this.coslat0 = Math.cos(this.lat0), this.sinlat0 = Math.sin(this.lat0), this.sphere ? 1 === this.k0 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= e && (this.k0 = .5 * (1 + f(this.lat0) * Math.sin(this.lat_ts))) : (Math.abs(this.coslat0) <= e && (this.con = this.lat0 > 0 ? 1 : -1), this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e)), 1 === this.k0 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= e && (this.k0 = .5 * this.cons * g(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / h(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts))), this.ms1 = g(this.e, this.sinlat0, this.coslat0), this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - d, this.cosX0 = Math.cos(this.X0), this.sinX0 = Math.sin(this.X0));
      }, c.forward = function (a) {
        var b,
            c,
            f,
            g,
            i,
            k,
            l = a.x,
            m = a.y,
            n = Math.sin(m),
            o = Math.cos(m),
            p = j(l - this.long0);return Math.abs(Math.abs(l - this.long0) - Math.PI) <= e && Math.abs(m + this.lat0) <= e ? (a.x = 0 / 0, a.y = 0 / 0, a) : this.sphere ? (b = 2 * this.k0 / (1 + this.sinlat0 * n + this.coslat0 * o * Math.cos(p)), a.x = this.a * b * o * Math.sin(p) + this.x0, a.y = this.a * b * (this.coslat0 * n - this.sinlat0 * o * Math.cos(p)) + this.y0, a) : (c = 2 * Math.atan(this.ssfn_(m, n, this.e)) - d, g = Math.cos(c), f = Math.sin(c), Math.abs(this.coslat0) <= e ? (i = h(this.e, m * this.con, this.con * n), k = 2 * this.a * this.k0 * i / this.cons, a.x = this.x0 + k * Math.sin(l - this.long0), a.y = this.y0 - this.con * k * Math.cos(l - this.long0), a) : (Math.abs(this.sinlat0) < e ? (b = 2 * this.a * this.k0 / (1 + g * Math.cos(p)), a.y = b * f) : (b = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * f + this.cosX0 * g * Math.cos(p))), a.y = b * (this.cosX0 * f - this.sinX0 * g * Math.cos(p)) + this.y0), a.x = b * g * Math.sin(p) + this.x0, a));
      }, c.inverse = function (a) {
        a.x -= this.x0, a.y -= this.y0;var b,
            c,
            f,
            g,
            h,
            k = Math.sqrt(a.x * a.x + a.y * a.y);if (this.sphere) {
          var l = 2 * Math.atan(k / (.5 * this.a * this.k0));return b = this.long0, c = this.lat0, e >= k ? (a.x = b, a.y = c, a) : (c = Math.asin(Math.cos(l) * this.sinlat0 + a.y * Math.sin(l) * this.coslat0 / k), b = j(Math.abs(this.coslat0) < e ? this.lat0 > 0 ? this.long0 + Math.atan2(a.x, -1 * a.y) : this.long0 + Math.atan2(a.x, a.y) : this.long0 + Math.atan2(a.x * Math.sin(l), k * this.coslat0 * Math.cos(l) - a.y * this.sinlat0 * Math.sin(l))), a.x = b, a.y = c, a);
        }if (Math.abs(this.coslat0) <= e) {
          if (e >= k) return c = this.lat0, b = this.long0, a.x = b, a.y = c, a;a.x *= this.con, a.y *= this.con, f = k * this.cons / (2 * this.a * this.k0), c = this.con * i(this.e, f), b = this.con * j(this.con * this.long0 + Math.atan2(a.x, -1 * a.y));
        } else g = 2 * Math.atan(k * this.cosX0 / (2 * this.a * this.k0 * this.ms1)), b = this.long0, e >= k ? h = this.X0 : (h = Math.asin(Math.cos(g) * this.sinX0 + a.y * Math.sin(g) * this.cosX0 / k), b = j(this.long0 + Math.atan2(a.x * Math.sin(g), k * this.cosX0 * Math.cos(g) - a.y * this.sinX0 * Math.sin(g)))), c = -1 * i(this.e, Math.tan(.5 * (d + h)));return a.x = b, a.y = c, a;
      }, c.names = ["stere", "Stereographic_South_Pole", "Polar Stereographic (variant B)"];
    }, { "../common/adjust_lon": 5, "../common/msfnz": 15, "../common/phi2z": 16, "../common/sign": 21, "../common/tsfnz": 24 }], 61: [function (a, b, c) {
      var d = a("./gauss"),
          e = a("../common/adjust_lon");c.init = function () {
        d.init.apply(this), this.rc && (this.sinc0 = Math.sin(this.phic0), this.cosc0 = Math.cos(this.phic0), this.R2 = 2 * this.rc, this.title || (this.title = "Oblique Stereographic Alternative"));
      }, c.forward = function (a) {
        var b, c, f, g;return a.x = e(a.x - this.long0), d.forward.apply(this, [a]), b = Math.sin(a.y), c = Math.cos(a.y), f = Math.cos(a.x), g = this.k0 * this.R2 / (1 + this.sinc0 * b + this.cosc0 * c * f), a.x = g * c * Math.sin(a.x), a.y = g * (this.cosc0 * b - this.sinc0 * c * f), a.x = this.a * a.x + this.x0, a.y = this.a * a.y + this.y0, a;
      }, c.inverse = function (a) {
        var b, c, f, g, h;if (a.x = (a.x - this.x0) / this.a, a.y = (a.y - this.y0) / this.a, a.x /= this.k0, a.y /= this.k0, h = Math.sqrt(a.x * a.x + a.y * a.y)) {
          var i = 2 * Math.atan2(h, this.R2);b = Math.sin(i), c = Math.cos(i), g = Math.asin(c * this.sinc0 + a.y * b * this.cosc0 / h), f = Math.atan2(a.x * b, h * this.cosc0 * c - a.y * this.sinc0 * b);
        } else g = this.phic0, f = 0;return a.x = f, a.y = g, d.inverse.apply(this, [a]), a.x = e(a.x + this.long0), a;
      }, c.names = ["Stereographic_North_Pole", "Oblique_Stereographic", "Polar_Stereographic", "sterea", "Oblique Stereographic Alternative"];
    }, { "../common/adjust_lon": 5, "./gauss": 46 }], 62: [function (a, b, c) {
      var d = a("../common/e0fn"),
          e = a("../common/e1fn"),
          f = a("../common/e2fn"),
          g = a("../common/e3fn"),
          h = a("../common/mlfn"),
          i = a("../common/adjust_lon"),
          j = Math.PI / 2,
          k = 1e-10,
          l = a("../common/sign"),
          m = a("../common/asinz");c.init = function () {
        this.e0 = d(this.es), this.e1 = e(this.es), this.e2 = f(this.es), this.e3 = g(this.es), this.ml0 = this.a * h(this.e0, this.e1, this.e2, this.e3, this.lat0);
      }, c.forward = function (a) {
        var b,
            c,
            d,
            e = a.x,
            f = a.y,
            g = i(e - this.long0),
            j = Math.sin(f),
            k = Math.cos(f);if (this.sphere) {
          var l = k * Math.sin(g);if (Math.abs(Math.abs(l) - 1) < 1e-10) return 93;c = .5 * this.a * this.k0 * Math.log((1 + l) / (1 - l)), b = Math.acos(k * Math.cos(g) / Math.sqrt(1 - l * l)), 0 > f && (b = -b), d = this.a * this.k0 * (b - this.lat0);
        } else {
          var m = k * g,
              n = Math.pow(m, 2),
              o = this.ep2 * Math.pow(k, 2),
              p = Math.tan(f),
              q = Math.pow(p, 2);b = 1 - this.es * Math.pow(j, 2);var r = this.a / Math.sqrt(b),
              s = this.a * h(this.e0, this.e1, this.e2, this.e3, f);c = this.k0 * r * m * (1 + n / 6 * (1 - q + o + n / 20 * (5 - 18 * q + Math.pow(q, 2) + 72 * o - 58 * this.ep2))) + this.x0, d = this.k0 * (s - this.ml0 + r * p * n * (.5 + n / 24 * (5 - q + 9 * o + 4 * Math.pow(o, 2) + n / 30 * (61 - 58 * q + Math.pow(q, 2) + 600 * o - 330 * this.ep2)))) + this.y0;
        }return a.x = c, a.y = d, a;
      }, c.inverse = function (a) {
        var b,
            c,
            d,
            e,
            f,
            g,
            h = 6;if (this.sphere) {
          var n = Math.exp(a.x / (this.a * this.k0)),
              o = .5 * (n - 1 / n),
              p = this.lat0 + a.y / (this.a * this.k0),
              q = Math.cos(p);b = Math.sqrt((1 - q * q) / (1 + o * o)), f = m(b), 0 > p && (f = -f), g = 0 === o && 0 === q ? this.long0 : i(Math.atan2(o, q) + this.long0);
        } else {
          var r = a.x - this.x0,
              s = a.y - this.y0;for (b = (this.ml0 + s / this.k0) / this.a, c = b, e = 0; !0 && (d = (b + this.e1 * Math.sin(2 * c) - this.e2 * Math.sin(4 * c) + this.e3 * Math.sin(6 * c)) / this.e0 - c, c += d, !(Math.abs(d) <= k)); e++) {
            if (e >= h) return 95;
          }if (Math.abs(c) < j) {
            var t = Math.sin(c),
                u = Math.cos(c),
                v = Math.tan(c),
                w = this.ep2 * Math.pow(u, 2),
                x = Math.pow(w, 2),
                y = Math.pow(v, 2),
                z = Math.pow(y, 2);b = 1 - this.es * Math.pow(t, 2);var A = this.a / Math.sqrt(b),
                B = A * (1 - this.es) / b,
                C = r / (A * this.k0),
                D = Math.pow(C, 2);f = c - A * v * D / B * (.5 - D / 24 * (5 + 3 * y + 10 * w - 4 * x - 9 * this.ep2 - D / 30 * (61 + 90 * y + 298 * w + 45 * z - 252 * this.ep2 - 3 * x))), g = i(this.long0 + C * (1 - D / 6 * (1 + 2 * y + w - D / 20 * (5 - 2 * w + 28 * y - 3 * x + 8 * this.ep2 + 24 * z))) / u);
          } else f = j * l(s), g = this.long0;
        }return a.x = g, a.y = f, a;
      }, c.names = ["Transverse_Mercator", "Transverse Mercator", "tmerc"];
    }, { "../common/adjust_lon": 5, "../common/asinz": 6, "../common/e0fn": 7, "../common/e1fn": 8, "../common/e2fn": 9, "../common/e3fn": 10, "../common/mlfn": 14, "../common/sign": 21 }], 63: [function (a, b, c) {
      var d = .017453292519943295,
          e = a("./tmerc");c.dependsOn = "tmerc", c.init = function () {
        this.zone && (this.lat0 = 0, this.long0 = (6 * Math.abs(this.zone) - 183) * d, this.x0 = 5e5, this.y0 = this.utmSouth ? 1e7 : 0, this.k0 = .9996, e.init.apply(this), this.forward = e.forward, this.inverse = e.inverse);
      }, c.names = ["Universal Transverse Mercator System", "utm"];
    }, { "./tmerc": 62 }], 64: [function (a, b, c) {
      var d = a("../common/adjust_lon"),
          e = Math.PI / 2,
          f = 1e-10,
          g = a("../common/asinz");c.init = function () {
        this.R = this.a;
      }, c.forward = function (a) {
        var b,
            c,
            h = a.x,
            i = a.y,
            j = d(h - this.long0);Math.abs(i) <= f && (b = this.x0 + this.R * j, c = this.y0);var k = g(2 * Math.abs(i / Math.PI));(Math.abs(j) <= f || Math.abs(Math.abs(i) - e) <= f) && (b = this.x0, c = i >= 0 ? this.y0 + Math.PI * this.R * Math.tan(.5 * k) : this.y0 + Math.PI * this.R * -Math.tan(.5 * k));var l = .5 * Math.abs(Math.PI / j - j / Math.PI),
            m = l * l,
            n = Math.sin(k),
            o = Math.cos(k),
            p = o / (n + o - 1),
            q = p * p,
            r = p * (2 / n - 1),
            s = r * r,
            t = Math.PI * this.R * (l * (p - s) + Math.sqrt(m * (p - s) * (p - s) - (s + m) * (q - s))) / (s + m);0 > j && (t = -t), b = this.x0 + t;var u = m + p;return t = Math.PI * this.R * (r * u - l * Math.sqrt((s + m) * (m + 1) - u * u)) / (s + m), c = i >= 0 ? this.y0 + t : this.y0 - t, a.x = b, a.y = c, a;
      }, c.inverse = function (a) {
        var b, c, e, g, h, i, j, k, l, m, n, o, p;return a.x -= this.x0, a.y -= this.y0, n = Math.PI * this.R, e = a.x / n, g = a.y / n, h = e * e + g * g, i = -Math.abs(g) * (1 + h), j = i - 2 * g * g + e * e, k = -2 * i + 1 + 2 * g * g + h * h, p = g * g / k + (2 * j * j * j / k / k / k - 9 * i * j / k / k) / 27, l = (i - j * j / 3 / k) / k, m = 2 * Math.sqrt(-l / 3), n = 3 * p / l / m, Math.abs(n) > 1 && (n = n >= 0 ? 1 : -1), o = Math.acos(n) / 3, c = a.y >= 0 ? (-m * Math.cos(o + Math.PI / 3) - j / 3 / k) * Math.PI : -(-m * Math.cos(o + Math.PI / 3) - j / 3 / k) * Math.PI, b = Math.abs(e) < f ? this.long0 : d(this.long0 + Math.PI * (h - 1 + Math.sqrt(1 + 2 * (e * e - g * g) + h * h)) / 2 / e), a.x = b, a.y = c, a;
      }, c.names = ["Van_der_Grinten_I", "VanDerGrinten", "vandg"];
    }, { "../common/adjust_lon": 5, "../common/asinz": 6 }], 65: [function (a, b, c) {
      var d = .017453292519943295,
          e = 57.29577951308232,
          f = 1,
          g = 2,
          h = a("./datum_transform"),
          i = a("./adjust_axis"),
          j = a("./Proj"),
          k = a("./common/toPoint");b.exports = function l(a, b, c) {
        function m(a, b) {
          return (a.datum.datum_type === f || a.datum.datum_type === g) && "WGS84" !== b.datumCode;
        }var n;return Array.isArray(c) && (c = k(c)), a.datum && b.datum && (m(a, b) || m(b, a)) && (n = new j("WGS84"), l(a, n, c), a = n), "enu" !== a.axis && i(a, !1, c), "longlat" === a.projName ? (c.x *= d, c.y *= d) : (a.to_meter && (c.x *= a.to_meter, c.y *= a.to_meter), a.inverse(c)), a.from_greenwich && (c.x += a.from_greenwich), c = h(a.datum, b.datum, c), b.from_greenwich && (c.x -= b.from_greenwich), "longlat" === b.projName ? (c.x *= e, c.y *= e) : (b.forward(c), b.to_meter && (c.x /= b.to_meter, c.y /= b.to_meter)), "enu" !== b.axis && i(b, !0, c), c;
      };
    }, { "./Proj": 2, "./adjust_axis": 3, "./common/toPoint": 23, "./datum_transform": 31 }], 66: [function (a, b, c) {
      function d(a, b, c) {
        a[b] = c.map(function (a) {
          var b = {};return e(a, b), b;
        }).reduce(function (a, b) {
          return j(a, b);
        }, {});
      }function e(a, b) {
        var c;return Array.isArray(a) ? (c = a.shift(), "PARAMETER" === c && (c = a.shift()), 1 === a.length ? Array.isArray(a[0]) ? (b[c] = {}, e(a[0], b[c])) : b[c] = a[0] : a.length ? "TOWGS84" === c ? b[c] = a : (b[c] = {}, ["UNIT", "PRIMEM", "VERT_DATUM"].indexOf(c) > -1 ? (b[c] = { name: a[0].toLowerCase(), convert: a[1] }, 3 === a.length && (b[c].auth = a[2])) : "SPHEROID" === c ? (b[c] = { name: a[0], a: a[1], rf: a[2] }, 4 === a.length && (b[c].auth = a[3])) : ["GEOGCS", "GEOCCS", "DATUM", "VERT_CS", "COMPD_CS", "LOCAL_CS", "FITTED_CS", "LOCAL_DATUM"].indexOf(c) > -1 ? (a[0] = ["name", a[0]], d(b, c, a)) : a.every(function (a) {
          return Array.isArray(a);
        }) ? d(b, c, a) : e(a, b[c])) : b[c] = !0, void 0) : void (b[a] = !0);
      }function f(a, b) {
        var c = b[0],
            d = b[1];!(c in a) && d in a && (a[c] = a[d], 3 === b.length && (a[c] = b[2](a[c])));
      }function g(a) {
        return a * i;
      }function h(a) {
        function b(b) {
          var c = a.to_meter || 1;return parseFloat(b, 10) * c;
        }"GEOGCS" === a.type ? a.projName = "longlat" : "LOCAL_CS" === a.type ? (a.projName = "identity", a.local = !0) : a.projName = "object" == __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(a.PROJECTION) ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(a.PROJECTION)[0] : a.PROJECTION, a.UNIT && (a.units = a.UNIT.name.toLowerCase(), "metre" === a.units && (a.units = "meter"), a.UNIT.convert && (a.to_meter = parseFloat(a.UNIT.convert, 10))), a.GEOGCS && (a.datumCode = a.GEOGCS.DATUM ? a.GEOGCS.DATUM.name.toLowerCase() : a.GEOGCS.name.toLowerCase(), "d_" === a.datumCode.slice(0, 2) && (a.datumCode = a.datumCode.slice(2)), ("new_zealand_geodetic_datum_1949" === a.datumCode || "new_zealand_1949" === a.datumCode) && (a.datumCode = "nzgd49"), "wgs_1984" === a.datumCode && ("Mercator_Auxiliary_Sphere" === a.PROJECTION && (a.sphere = !0), a.datumCode = "wgs84"), "_ferro" === a.datumCode.slice(-6) && (a.datumCode = a.datumCode.slice(0, -6)), "_jakarta" === a.datumCode.slice(-8) && (a.datumCode = a.datumCode.slice(0, -8)), ~a.datumCode.indexOf("belge") && (a.datumCode = "rnb72"), a.GEOGCS.DATUM && a.GEOGCS.DATUM.SPHEROID && (a.ellps = a.GEOGCS.DATUM.SPHEROID.name.replace("_19", "").replace(/[Cc]larke\_18/, "clrk"), "international" === a.ellps.toLowerCase().slice(0, 13) && (a.ellps = "intl"), a.a = a.GEOGCS.DATUM.SPHEROID.a, a.rf = parseFloat(a.GEOGCS.DATUM.SPHEROID.rf, 10)), ~a.datumCode.indexOf("osgb_1936") && (a.datumCode = "osgb36")), a.b && !isFinite(a.b) && (a.b = a.a);var c = function c(b) {
          return f(a, b);
        },
            d = [["standard_parallel_1", "Standard_Parallel_1"], ["standard_parallel_2", "Standard_Parallel_2"], ["false_easting", "False_Easting"], ["false_northing", "False_Northing"], ["central_meridian", "Central_Meridian"], ["latitude_of_origin", "Latitude_Of_Origin"], ["latitude_of_origin", "Central_Parallel"], ["scale_factor", "Scale_Factor"], ["k0", "scale_factor"], ["latitude_of_center", "Latitude_of_center"], ["lat0", "latitude_of_center", g], ["longitude_of_center", "Longitude_Of_Center"], ["longc", "longitude_of_center", g], ["x0", "false_easting", b], ["y0", "false_northing", b], ["long0", "central_meridian", g], ["lat0", "latitude_of_origin", g], ["lat0", "standard_parallel_1", g], ["lat1", "standard_parallel_1", g], ["lat2", "standard_parallel_2", g], ["alpha", "azimuth", g], ["srsCode", "name"]];d.forEach(c), a.long0 || !a.longc || "Albers_Conic_Equal_Area" !== a.projName && "Lambert_Azimuthal_Equal_Area" !== a.projName || (a.long0 = a.longc), a.lat_ts || !a.lat1 || "Stereographic_South_Pole" !== a.projName && "Polar Stereographic (variant B)" !== a.projName || (a.lat0 = g(a.lat1 > 0 ? 90 : -90), a.lat_ts = a.lat1);
      }var i = .017453292519943295,
          j = a("./extend");b.exports = function (a, b) {
        var c = JSON.parse(("," + a).replace(/\s*\,\s*([A-Z_0-9]+?)(\[)/g, ',["$1",').slice(1).replace(/\s*\,\s*([A-Z_0-9]+?)\]/g, ',"$1"]').replace(/,\["VERTCS".+/, "")),
            d = c.shift(),
            f = c.shift();c.unshift(["name", f]), c.unshift(["type", d]), c.unshift("output");var g = {};return e(c, g), h(g.output), j(b, g.output);
      };
    }, { "./extend": 34 }], 67: [function (a, b, c) {
      function d(a) {
        return a * (Math.PI / 180);
      }function e(a) {
        return 180 * (a / Math.PI);
      }function f(a) {
        var b,
            c,
            e,
            f,
            g,
            i,
            j,
            k,
            l,
            m = a.lat,
            n = a.lon,
            o = 6378137,
            p = .00669438,
            q = .9996,
            r = d(m),
            s = d(n);l = Math.floor((n + 180) / 6) + 1, 180 === n && (l = 60), m >= 56 && 64 > m && n >= 3 && 12 > n && (l = 32), m >= 72 && 84 > m && (n >= 0 && 9 > n ? l = 31 : n >= 9 && 21 > n ? l = 33 : n >= 21 && 33 > n ? l = 35 : n >= 33 && 42 > n && (l = 37)), b = 6 * (l - 1) - 180 + 3, k = d(b), c = p / (1 - p), e = o / Math.sqrt(1 - p * Math.sin(r) * Math.sin(r)), f = Math.tan(r) * Math.tan(r), g = c * Math.cos(r) * Math.cos(r), i = Math.cos(r) * (s - k), j = o * ((1 - p / 4 - 3 * p * p / 64 - 5 * p * p * p / 256) * r - (3 * p / 8 + 3 * p * p / 32 + 45 * p * p * p / 1024) * Math.sin(2 * r) + (15 * p * p / 256 + 45 * p * p * p / 1024) * Math.sin(4 * r) - 35 * p * p * p / 3072 * Math.sin(6 * r));var t = q * e * (i + (1 - f + g) * i * i * i / 6 + (5 - 18 * f + f * f + 72 * g - 58 * c) * i * i * i * i * i / 120) + 5e5,
            u = q * (j + e * Math.tan(r) * (i * i / 2 + (5 - f + 9 * g + 4 * g * g) * i * i * i * i / 24 + (61 - 58 * f + f * f + 600 * g - 330 * c) * i * i * i * i * i * i / 720));return 0 > m && (u += 1e7), { northing: Math.round(u), easting: Math.round(t), zoneNumber: l, zoneLetter: h(m) };
      }function g(a) {
        var b = a.northing,
            c = a.easting,
            d = a.zoneLetter,
            f = a.zoneNumber;if (0 > f || f > 60) return null;var h,
            i,
            j,
            k,
            l,
            m,
            n,
            o,
            p,
            q,
            r = .9996,
            s = 6378137,
            t = .00669438,
            u = (1 - Math.sqrt(1 - t)) / (1 + Math.sqrt(1 - t)),
            v = c - 5e5,
            w = b;"N" > d && (w -= 1e7), o = 6 * (f - 1) - 180 + 3, h = t / (1 - t), n = w / r, p = n / (s * (1 - t / 4 - 3 * t * t / 64 - 5 * t * t * t / 256)), q = p + (3 * u / 2 - 27 * u * u * u / 32) * Math.sin(2 * p) + (21 * u * u / 16 - 55 * u * u * u * u / 32) * Math.sin(4 * p) + 151 * u * u * u / 96 * Math.sin(6 * p), i = s / Math.sqrt(1 - t * Math.sin(q) * Math.sin(q)), j = Math.tan(q) * Math.tan(q), k = h * Math.cos(q) * Math.cos(q), l = s * (1 - t) / Math.pow(1 - t * Math.sin(q) * Math.sin(q), 1.5), m = v / (i * r);var x = q - i * Math.tan(q) / l * (m * m / 2 - (5 + 3 * j + 10 * k - 4 * k * k - 9 * h) * m * m * m * m / 24 + (61 + 90 * j + 298 * k + 45 * j * j - 252 * h - 3 * k * k) * m * m * m * m * m * m / 720);x = e(x);var y = (m - (1 + 2 * j + k) * m * m * m / 6 + (5 - 2 * k + 28 * j - 3 * k * k + 8 * h + 24 * j * j) * m * m * m * m * m / 120) / Math.cos(q);y = o + e(y);var z;if (a.accuracy) {
          var A = g({ northing: a.northing + a.accuracy, easting: a.easting + a.accuracy, zoneLetter: a.zoneLetter, zoneNumber: a.zoneNumber });z = { top: A.lat, right: A.lon, bottom: x, left: y };
        } else z = { lat: x, lon: y };return z;
      }function h(a) {
        var b = "Z";return 84 >= a && a >= 72 ? b = "X" : 72 > a && a >= 64 ? b = "W" : 64 > a && a >= 56 ? b = "V" : 56 > a && a >= 48 ? b = "U" : 48 > a && a >= 40 ? b = "T" : 40 > a && a >= 32 ? b = "S" : 32 > a && a >= 24 ? b = "R" : 24 > a && a >= 16 ? b = "Q" : 16 > a && a >= 8 ? b = "P" : 8 > a && a >= 0 ? b = "N" : 0 > a && a >= -8 ? b = "M" : -8 > a && a >= -16 ? b = "L" : -16 > a && a >= -24 ? b = "K" : -24 > a && a >= -32 ? b = "J" : -32 > a && a >= -40 ? b = "H" : -40 > a && a >= -48 ? b = "G" : -48 > a && a >= -56 ? b = "F" : -56 > a && a >= -64 ? b = "E" : -64 > a && a >= -72 ? b = "D" : -72 > a && a >= -80 && (b = "C"), b;
      }function i(a, b) {
        var c = "" + a.easting,
            d = "" + a.northing;return a.zoneNumber + a.zoneLetter + j(a.easting, a.northing, a.zoneNumber) + c.substr(c.length - 5, b) + d.substr(d.length - 5, b);
      }function j(a, b, c) {
        var d = k(c),
            e = Math.floor(a / 1e5),
            f = Math.floor(b / 1e5) % 20;return l(e, f, d);
      }function k(a) {
        var b = a % q;return 0 === b && (b = q), b;
      }function l(a, b, c) {
        var d = c - 1,
            e = r.charCodeAt(d),
            f = s.charCodeAt(d),
            g = e + a - 1,
            h = f + b,
            i = !1;g > x && (g = g - x + t - 1, i = !0), (g === u || u > e && g > u || (g > u || u > e) && i) && g++, (g === v || v > e && g > v || (g > v || v > e) && i) && (g++, g === u && g++), g > x && (g = g - x + t - 1), h > w ? (h = h - w + t - 1, i = !0) : i = !1, (h === u || u > f && h > u || (h > u || u > f) && i) && h++, (h === v || v > f && h > v || (h > v || v > f) && i) && (h++, h === u && h++), h > w && (h = h - w + t - 1);var j = String.fromCharCode(g) + String.fromCharCode(h);return j;
      }function m(a) {
        if (a && 0 === a.length) throw "MGRSPoint coverting from nothing";for (var b, c = a.length, d = null, e = "", f = 0; !/[A-Z]/.test(b = a.charAt(f));) {
          if (f >= 2) throw "MGRSPoint bad conversion from: " + a;e += b, f++;
        }var g = parseInt(e, 10);if (0 === f || f + 3 > c) throw "MGRSPoint bad conversion from: " + a;var h = a.charAt(f++);if ("A" >= h || "B" === h || "Y" === h || h >= "Z" || "I" === h || "O" === h) throw "MGRSPoint zone letter " + h + " not handled: " + a;d = a.substring(f, f += 2);for (var i = k(g), j = n(d.charAt(0), i), l = o(d.charAt(1), i); l < p(h);) {
          l += 2e6;
        }var m = c - f;if (m % 2 !== 0) throw "MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + a;var q,
            r,
            s,
            t,
            u,
            v = m / 2,
            w = 0,
            x = 0;return v > 0 && (q = 1e5 / Math.pow(10, v), r = a.substring(f, f + v), w = parseFloat(r) * q, s = a.substring(f + v), x = parseFloat(s) * q), t = w + j, u = x + l, { easting: t, northing: u, zoneLetter: h, zoneNumber: g, accuracy: q };
      }function n(a, b) {
        for (var c = r.charCodeAt(b - 1), d = 1e5, e = !1; c !== a.charCodeAt(0);) {
          if (c++, c === u && c++, c === v && c++, c > x) {
            if (e) throw "Bad character: " + a;c = t, e = !0;
          }d += 1e5;
        }return d;
      }function o(a, b) {
        if (a > "V") throw "MGRSPoint given invalid Northing " + a;for (var c = s.charCodeAt(b - 1), d = 0, e = !1; c !== a.charCodeAt(0);) {
          if (c++, c === u && c++, c === v && c++, c > w) {
            if (e) throw "Bad character: " + a;c = t, e = !0;
          }d += 1e5;
        }return d;
      }function p(a) {
        var b;switch (a) {case "C":
            b = 11e5;break;case "D":
            b = 2e6;break;case "E":
            b = 28e5;break;case "F":
            b = 37e5;break;case "G":
            b = 46e5;break;case "H":
            b = 55e5;break;case "J":
            b = 64e5;break;case "K":
            b = 73e5;break;case "L":
            b = 82e5;break;case "M":
            b = 91e5;break;case "N":
            b = 0;break;case "P":
            b = 8e5;break;case "Q":
            b = 17e5;break;case "R":
            b = 26e5;break;case "S":
            b = 35e5;break;case "T":
            b = 44e5;break;case "U":
            b = 53e5;break;case "V":
            b = 62e5;break;case "W":
            b = 7e6;break;case "X":
            b = 79e5;break;default:
            b = -1;}if (b >= 0) return b;throw "Invalid zone letter: " + a;
      }var q = 6,
          r = "AJSAJS",
          s = "AFAFAF",
          t = 65,
          u = 73,
          v = 79,
          w = 86,
          x = 90;c.forward = function (a, b) {
        return b = b || 5, i(f({ lat: a[1], lon: a[0] }), b);
      }, c.inverse = function (a) {
        var b = g(m(a.toUpperCase()));return [b.left, b.bottom, b.right, b.top];
      }, c.toPoint = function (a) {
        var b = c.inverse(a);return [(b[2] + b[0]) / 2, (b[3] + b[1]) / 2];
      };
    }, {}], 68: [function (a, b, c) {
      b.exports = { name: "proj4", version: "2.3.6", description: "Proj4js is a JavaScript library to transform point coordinates from one coordinate system to another, including datum transformations.", main: "lib/index.js", directories: { test: "test", doc: "docs" }, scripts: { test: "./node_modules/istanbul/lib/cli.js test ./node_modules/mocha/bin/_mocha test/test.js" }, repository: { type: "git", url: "git://github.com/proj4js/proj4js.git" }, author: "", license: "MIT", jam: { main: "dist/proj4.js", include: ["dist/proj4.js", "README.md", "AUTHORS", "LICENSE.md"] }, devDependencies: { "grunt-cli": "~0.1.13", grunt: "~0.4.2", "grunt-contrib-connect": "~0.6.0", "grunt-contrib-jshint": "~0.8.0", chai: "~1.8.1", mocha: "~1.17.1", "grunt-mocha-phantomjs": "~0.4.0", browserify: "~3.24.5", "grunt-browserify": "~1.3.0", "grunt-contrib-uglify": "~0.3.2", curl: "git://github.com/cujojs/curl.git", istanbul: "~0.2.4", tin: "~0.4.0" }, dependencies: { mgrs: "0.0.0" } };
    }, {}], "./includedProjections": [function (a, b, c) {
      b.exports = a("hTEDpn");
    }, {}], hTEDpn: [function (a, b, c) {
      var d = [a("./lib/projections/tmerc"), a("./lib/projections/utm"), a("./lib/projections/sterea"), a("./lib/projections/stere"), a("./lib/projections/somerc"), a("./lib/projections/omerc"), a("./lib/projections/lcc"), a("./lib/projections/krovak"), a("./lib/projections/cass"), a("./lib/projections/laea"), a("./lib/projections/aea"), a("./lib/projections/gnom"), a("./lib/projections/cea"), a("./lib/projections/eqc"), a("./lib/projections/poly"), a("./lib/projections/nzmg"), a("./lib/projections/mill"), a("./lib/projections/sinu"), a("./lib/projections/moll"), a("./lib/projections/eqdc"), a("./lib/projections/vandg"), a("./lib/projections/aeqd")];b.exports = function (proj4) {
        d.forEach(function (a) {
          proj4.Proj.projections.add(a);
        });
      };
    }, { "./lib/projections/aea": 40, "./lib/projections/aeqd": 41, "./lib/projections/cass": 42, "./lib/projections/cea": 43, "./lib/projections/eqc": 44, "./lib/projections/eqdc": 45, "./lib/projections/gnom": 47, "./lib/projections/krovak": 48, "./lib/projections/laea": 49, "./lib/projections/lcc": 50, "./lib/projections/mill": 53, "./lib/projections/moll": 54, "./lib/projections/nzmg": 55, "./lib/projections/omerc": 56, "./lib/projections/poly": 57, "./lib/projections/sinu": 58, "./lib/projections/somerc": 59, "./lib/projections/stere": 60, "./lib/projections/sterea": 61, "./lib/projections/tmerc": 62, "./lib/projections/utm": 63, "./lib/projections/vandg": 64 }] }, {}, [36])(36);
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("f1Eh")(module), __webpack_require__("DuR2")))

/***/ }),

/***/ "gww+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__ = __webpack_require__("3kHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("2+hT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Wizard_FirstStep_vue__ = __webpack_require__("jPKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Wizard_SecondStep_vue__ = __webpack_require__("oE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      wizardModel: {}
    };
  },

  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["TabContent"],
    FirstStep: __WEBPACK_IMPORTED_MODULE_3__Wizard_FirstStep_vue__["a" /* default */],
    SecondStep: __WEBPACK_IMPORTED_MODULE_4__Wizard_SecondStep_vue__["a" /* default */]
  },
  methods: {
    validateFirstStep: function validateFirstStep() {
      return this.$refs.firstStep.validate();
    },
    validateSecondStep: function validateSecondStep() {
      return this.$refs.secondStep.validate();
    },
    wizardComplete: function wizardComplete() {
      this.wizardModel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$refs.firstStep.model, this.$refs.secondStep.model);
      __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default()('Good job!', 'You clicked the finish button!', 'success');
    }
  }
});

/***/ }),

/***/ "hASK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-switch',
  props: {
    label: String,
    value: [Array, Boolean],
    disabled: [Boolean, String],
    onText: String,
    offText: String,
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    switchClass: function switchClass() {
      var base = 'bootstrap-switch-';
      var state = this.model ? 'on' : 'off';
      return base + state;
    },

    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    triggerToggle: function triggerToggle() {
      this.model = !this.model;
    }
  }
});

/***/ }),

/***/ "hJZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions_auth__ = __webpack_require__("+4WN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      username: null,
      password: null,
      error: null,
      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false
      },
      year: new Date().getFullYear()
    };
  },

  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },

    login: function login() {
      var _this = this;

      var username = this.username,
          password = this.password;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_actions_auth__["b" /* AUTH_REQUEST */], { username: username, password: password }).then(function () {
        _this.siteOnline();
      }, function (res) {
        _this.$notify({
          component: {
            template: '<span><b>' + _this.$t("59") + '</b></span>'
          },
          type: 'danger',
          group: 'alert',
          horizontalAlign: 'center',
          verticalAlign: 'top'
        });
      });
    },
    siteOnline: function siteOnline() {
      var self = this;
      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/mysemeq-ambev/login-mysemeq-abi';

      __WEBPACK_IMPORTED_MODULE_2_axios___default()({ method: 'GET', url: API + ENDPOINT, params: { 'user': self.username, 'pass': self.password }, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        var res = resp.data;


        localStorage.setItem('hash', res);
        var hash = localStorage.getItem('hash');
        self.$router.go('/');
      }).catch(function (err) {
        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  },
  mounted: function mounted() {
    console.log("https://api.semeq.com.br/");
  }
});

/***/ }),

/***/ "hLkS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpfailg","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("134")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.$t("135"))+"\n    "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpfailg.right",arg:"helpfailg",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hbjD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: 'Título do Diálogo'
    }
  },
  methods: {
    close: function close() {
      this.showDialog = false;
      this.$emit('update:visible', false);
      localStorage.setItem("DescontinuationWarning", "0");
    }
  },
  data: function data() {
    return {
      showDialog: '' + localStorage.getItem("DescontinuationWarning") === "0" ? false : true
    };
  }
});

/***/ }),

/***/ "hjrP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grid_vue__ = __webpack_require__("n8bH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f54671fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Grid_vue__ = __webpack_require__("/0wm");
function injectStyle (ssrContext) {
  __webpack_require__("U5Qi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f54671fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f54671fa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Grid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hqBF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  filtersOn: {
    planta: '',
    region: '',
    corp: 1,
    planta_name: '',
    year: '',
    period: '',
    area_f: '',
    sector_f: '',
    machine: '',
    subset: ''
  }
};

var getters = {
  filtersOn: function filtersOn(state) {
    return state.filtersOn;
  }
};

var mutations = {
  changeFiltersOn: function changeFiltersOn(state, payload) {
    var key = null;
    for (key in payload) {
      localStorage.setItem(key + '_on', payload[key]);
    }
    state.filtersOn = payload;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),

/***/ "hwHr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hzu0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-12"},[_c('el-table',{attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"job","label":"Job Position"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salary","label":"Salary"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-info btn-xs btn-icon like",on:{"click":function($event){_vm.handleLike(props.$index, props.row)}}},[_c('i',{staticClass:"ti-heart"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-warning btn-xs btn-icon edit",on:{"click":function($event){_vm.handleEdit(props.$index, props.row)}}},[_c('i',{staticClass:"ti-pencil-alt"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-danger btn-xs btn-icon remove",on:{"click":function($event){_vm.handleDelete(props.$index, props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}])})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content row table-full-width"},[_c('div',{staticClass:"col-sm-12"},[_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.tableData}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"job","label":"Job Position"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salary","label":"Salary"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Active"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p-switch',{model:{value:(props.row.active),callback:function ($$v) {_vm.$set(props.row, "active", $$v)},expression:"props.row.active"}})]}}])})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('el-table',{staticClass:"table-shopping",staticStyle:{"width":"100%"},attrs:{"summary-method":_vm.getSummaries,"show-summary":"","data":_vm.productsTable}},[_c('el-table-column',{attrs:{"min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":props.row.image,"alt":"Agenda"}})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('strong',[_vm._v(_vm._s(props.row.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(props.row.subTitle))])]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-price",attrs:{"min-width":"80","label":"Price"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('small',[_vm._v("€")]),_vm._v(" "+_vm._s(props.row.price)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{staticClass:"td-number td-quantity",attrs:{"min-width":"150","label":"Quantity"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.quantity)+"\n                "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",on:{"click":function($event){props.row.quantity > 0 ? props.row.quantity-- : 0}}},[_c('i',{staticClass:"ti-minus"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",on:{"click":function($event){props.row.quantity++}}},[_c('i',{staticClass:"ti-plus"})])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Total","min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('strong',[_c('small',[_vm._v("€")]),_vm._v(" "+_vm._s(props.row.quantity * props.row.price)+" ")])]}}])})],1)],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Table with Links")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Here is a subtitle for this table")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Table with Switches")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("With some subtitle")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Table Big Boy")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("A table for content management")]),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i/rH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"row",attrs:{"id":"loading"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i0bx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Panels_vue__ = __webpack_require__("sTXs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb51baa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Panels_vue__ = __webpack_require__("Hyh/");
function injectStyle (ssrContext) {
  __webpack_require__("M0iJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Panels_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb51baa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Panels_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i2fH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iGuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    task: {
      type: Object,
      default: function _default() {
        return {
          title: ''
        };
      }
    },
    index: Number
  },
  methods: {
    handleEditClick: function handleEditClick() {
      this.$emit('on-edit', this.index);
    },
    handleDeleteClick: function handleDeleteClick() {
      this.$emit('on-delete', this.index);
    }
  }
});

/***/ }),

/***/ "iXuc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__ = __webpack_require__("wH4b");






var GlobalComponents = {
  install: function install(Vue) {
    Vue.component(__WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "idUJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeatMapSensor_vue__ = __webpack_require__("1Wac");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff622dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeatMapSensor_vue__ = __webpack_require__("d+MP");
function injectStyle (ssrContext) {
  __webpack_require__("Yqjs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeatMapSensor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff622dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeatMapSensor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ifSS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ifvD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ij53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__ = __webpack_require__("XXU8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e5141ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__ = __webpack_require__("V14P");
function injectStyle (ssrContext) {
  __webpack_require__("FKFf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e5141ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "im4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);


/* unused harmony default export */ var _unused_webpack_default_export = ((function initPollyFills() {
  if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
      position = position || 0;
      return this.indexOf(searchString, position) === position;
    };
  }
  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function value(predicate) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        var len = o.length >>> 0;

        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        var thisArg = arguments[1];

        var k = 0;

        while (k < len) {
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }

          k++;
        }

        return undefined;
      }
    });
  }
})());

/***/ }),

/***/ "iq7p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iqgc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpfail","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("263")))]),_vm._v(" "),_c('p',[_c('ul',[_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t("264"))+":")]),_vm._v(" "+_vm._s(_vm.$t("265")))]),_vm._v(" "),_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t("266"))+":")]),_vm._v(" "+_vm._s(_vm.$t("267")))]),_vm._v(" "),_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t("268"))+":")]),_vm._v(" "+_vm._s(_vm.$t("269")))]),_vm._v(" "),_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t("270"))+":")]),_vm._v(" "+_vm._s(_vm.$t("271")))]),_vm._v(" "),_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t("272"))+":")]),_vm._v(" "+_vm._s(_vm.$t("273")))]),_vm._v(" "),_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t("274"))+":")]),_vm._v(" "+_vm._s(_vm.$t("275")))])])])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help title-margin"},[_vm._v(_vm._s(_vm.$t("276"))+"\n    "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpfail.bottom",arg:"helpfail",modifiers:{"bottom":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "isE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "isgN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jJHM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtendedTables_vue__ = __webpack_require__("PzXG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d99d2a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtendedTables_vue__ = __webpack_require__("hzu0");
function injectStyle (ssrContext) {
  __webpack_require__("LQk8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtendedTables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d99d2a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtendedTables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jPKE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstStep_vue__ = __webpack_require__("Rrpr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea89db28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstStep_vue__ = __webpack_require__("uOOa");
function injectStyle (ssrContext) {
  __webpack_require__("UQPL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea89db28_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jWLd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_components_Csv__ = __webpack_require__("Iv/n");










__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_js_popover___default.a);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'charts',
  components: {
    Help: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_components_Help__["a" /* default */],
    Csv: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_components_Csv__["a" /* default */]
  },
  data: function data() {
    var _chartOptions;

    return {
      showModalFile: false,
      titleChart: this.$t("155"),
      tableData: [],
      chartOptions: (_chartOptions = {
        colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8', '#dd6b7f', '#0984e3', '#ffeaa7', '#e84393', '#55efc4', '#636e72', '#ff7675', '#f1c40f', '#34495e'],
        chart: {
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063'
        },
        title: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '16px',
            fontWeight: 'bold'
          }
        },
        subtitle: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase'
          }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        xAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        yAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },
        plotOptions: {
          pie: {
            borderWidth: 0,
            size: '70%',
            dataLabels: {
              distance: 1
            }
          },
          series: {
            innerSize: '50%',
            dataLabels: {
              enabled: true,
              format: '<span style="color:#fff ">{point.name}:<br></span><span style="color:#fff "> {point.percentage:.1f}%</span>',
              color: '#F0F0F3',
              style: {
                fontSize: '13px'
              }
            },
            marker: {
              lineColor: '#333'
            },
            events: {
              click: this.loadGrid
            }
          },
          boxplot: {
            fillColor: '#505053'
          },
          candlestick: {
            lineColor: 'white'
          },
          errorbar: {
            color: 'white'
          }
        },
        legend: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          itemStyle: {
            color: '#E0E0E3'
          },
          itemHoverStyle: {
            color: '#FFF'
          },
          itemHiddenStyle: {
            color: '#606063'
          },
          title: {
            style: {
              color: '#C0C0C0',
              fontSize: '12px'
            }
          }
        },
        credits: {
          style: {
            color: '#666'
          }
        },
        labels: {
          style: {
            color: '#707073'
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            color: '#F0F0F3'
          },
          activeDataLabelStyle: {
            color: '#F0F0F3'
          }
        },
        navigation: {
          buttonOptions: {
            symbolStroke: '#DDDDDD',
            theme: {
              fill: '#505053'
            }
          }
        },
        rangeSelector: {
          buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: {
              color: '#CCC'
            },
            states: {
              hover: {
                fill: '#707073',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              },
              select: {
                fill: '#000003',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              }
            }
          },
          inputBoxBorderColor: '#505053',
          inputStyle: {
            backgroundColor: '#333',
            color: 'silver'
          },
          labelStyle: {
            color: 'silver'
          }
        },
        navigator: {
          handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
          },
          outlineColor: '#CCC',
          maskFill: 'rgba(255,255,255,0.1)',
          series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
          },
          xAxis: {
            gridLineColor: '#505053'
          }
        },
        scrollbar: {
          barBackgroundColor: '#808083',
          barBorderColor: '#808083',
          buttonArrowColor: '#CCC',
          buttonBackgroundColor: '#606063',
          buttonBorderColor: '#606063',
          rifleColor: '#FFF',
          trackBackgroundColor: '#404043',
          trackBorderColor: '#404043'
        },
        series: [{
          name: "RGP",
          colorByPoint: true,
          data: []
        }]
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'drilldown', {
        series: []
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'exporting', { enabled: false }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'credits', {
        enabled: false
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'loading', {
        labelStyle: {
          color: 'black',
          textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
        },
        style: {
          backgroundColor: 'none',
          opacity: 1,
          marginTop: '20px'
        }
      }), _chartOptions) };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__utils_mixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['changeGrid']), {
    loadGrid: function loadGrid(event) {
      var skipped = event.point.name;
      var point_name = event.point.name;
      var NAME_CHART = this.$t("352") + ' - ' + point_name.toUpperCase();

      var ENDPOINT = 'v1/mysemeq-ambev/get-general-report?year=' + this.filters.year + '&period=' + this.filters.period + '&plant=' + this.filters.plant + '&region=' + this.filters.region + '&status=4&technique=' + this.filters.technique + '&skipped=' + skipped + '&area=' + this.filters.area + '&sector=' + this.filters.sector + '&machine=' + this.filters.machine + '&component=' + this.filters.component;

      var grid = {
        totalDados: event.point.y,
        title: skipped,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
          "rows": '',
          "plant": this.$t("310"),
          "area": this.$t("311"),
          "sector": this.$t("312"),
          "component": this.$t("313"),
          "component_tag": this.$t("314"),
          "component_type_en": this.$t("315"),
          "machine": this.$t("316"),
          "machine_tag": this.$t("317"),
          "technique_en": this.$t("321")
        },
        show: true,
        titleHelp: 'Grid - ' + this.$t("352"),
        txtHelp: this.$t("353")
      };

      if (this.filters.plant) {
        grid.title += ' - ' + this.filters.plant_name;
        delete grid.columns['plant'];
      } else if (this.filters.region) {
        grid.title += ' - ' + this.filters.region;
      }

      this.changeGrid(grid);
    },
    getData: function getData() {

      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/mysemeq-ambev/get-skipped-chart';
      var self = this;

      this.$refs.chart.chart.showLoading();

      __WEBPACK_IMPORTED_MODULE_4_axios___default()({ method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        self.tableData = resp.data;
        self.$refs.chart.chart.hideLoading();
      }).catch(function (err) {
        self.ApiErrorHandler(self, error.response.data.status_code);
        self.$refs.chart.chart.showLoading('Error');
      });
    },
    setChartData: function setChartData() {
      var self = this;
      var res = self.tableData;
      var values = [];
      for (var key in res) {
        values.push({ 'name': res[key].status_txt, 'y': res[key].total, 'drilldown': res[key].status });
      }
      self.chartOptions.series[0].data = values;
    },
    getCsvAll: function getCsvAll() {
      var self = this;
      self.showModalFile = true;
      var file = 'csv';
      var API = "https://api.semeq.com.br/";

      var ENDPOINT = 'v1/mysemeq-ambev/get-general-report?year=' + this.filters.year + '&period=' + this.filters.period + '&plant=' + this.filters.plant + '&region=' + this.filters.region + '&status=4&technique=' + this.filters.technique + '&skipped=&area=' + this.filters.area + '&sector=' + this.filters.sector + '&machine=' + this.filters.machine + '&component=' + this.filters.component + '&pg=0&sort=&order=asc&file=' + file;

      var name_chart_file = this.$t("352");

      __WEBPACK_IMPORTED_MODULE_4_axios___default()({
        method: 'GET',
        url: API + ENDPOINT,
        responseType: 'blob',
        headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token')
        } }).then(function (_ref) {
        var data = _ref.data;

        var url = window.URL.createObjectURL(new Blob([data]));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name_chart_file + '.csv');
        document.body.appendChild(link);
        link.click();
        self.showModalFile = false;
      }).catch(function (error) {
        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['filters'])),
  watch: {
    filters: function filters(newValue) {
      this.getData();
    },
    tableData: function tableData() {
      this.setChartData();
    }
  }
});

/***/ }),

/***/ "jaXH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jcvC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      details: [{
        title: '12',
        subTitle: 'Files'
      }, {
        title: '2GB',
        subTitle: 'Used'
      }, {
        title: '24,6$',
        subTitle: 'Spent'
      }]
    };
  },

  methods: {
    getClasses: function getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return 'col-md-3 col-md-offset-1';
      } else if (remainder === 2) {
        return 'col-md-4';
      } else {
        return 'col-md-3';
      }
    }
  }
});

/***/ }),

/***/ "jqwU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('side-bar',{attrs:{"type":"sidebar","sidebar-links":_vm.$sidebar.sidebarLinks}},[_c('user-menu')],1),_vm._v(" "),_c('script',{attrs:{"type":"text/x-template","id":"modal-template"}},[_vm._v("\n    <transition name=\"modal\">\n      <div class=\"modal-mask\">\n        <div class=\"modal-wrapper\">\n          <div class=\"modal-container\">\n\n            <div class=\"modal-header\">\n              <slot name=\"header\">\n                \n              </slot>\n            </div>\n\n            <div class=\"modal-body\">\n              <slot name=\"body\"> \n                        \n              </slot>\n            </div>\n\n            <div class=\"modal-footer\">\n              <slot name=\"footer\">\n                <button class=\"modal-default-button\" @click=\"$emit('close')\">\n                  "+_vm._s(_vm.$t('modal.pesquisar'))+"\n                </button>                 \n              </slot>\n            </div>\n          </div>\n        </div>\n      </div>\n    </transition>\n  ")]),_vm._v(" "),_c('div',{staticClass:"fixed-plugin",attrs:{"id":"modal"}},[(_vm.showModal)?_c('modal',{on:{"close":function($event){_vm.showModal = false}}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('modal.filtro.pesquisa')))]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('el-cascader',{attrs:{"options":_vm.options},model:{value:(_vm.selectedOptions3),callback:function ($$v) {_vm.selectedOptions3=$$v},expression:"selectedOptions3"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"modal-default-button",on:{"click":function($event){_vm.showModal = false}}},[_vm._v("\n          "+_vm._s(_vm.$t('modal.pesquisar'))+"\n        ")])])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"main-panel",on:{"scroll":_vm.handleScroll}},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar($event)}}}),_vm._v(" "),_c('content-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jrkx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_mixin__ = __webpack_require__("vsZy");









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'charts',
  data: function data() {
    var _chartOptions;

    return {
      tableData: [],
      chartOptions: (_chartOptions = {
        chart: {
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },
        title: {
          text: 'POINT STATUS',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '20px'
          }
        },
        subtitle: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase'
          }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        xAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        yAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },
        plotOptions: {
          pie: {
            borderWidth: 0,
            size: '70%',
            dataLabels: {
              distance: 15
            },
            depth: 55
          },
          series: {
            innerSize: '50%',
            dataLabels: {
              enabled: true,
              format: '<b style="color:#fff ">{point.name}:<br></b><b style="color:#fff "> {point.y}</b>',
              color: '#F0F0F3',
              style: {
                fontSize: '13px'
              }
            },
            marker: {
              lineColor: '#333'
            },
            events: {
              click: this.loadGrid
            }
          },
          boxplot: {
            fillColor: '#505053'
          },
          candlestick: {
            lineColor: 'white'
          },
          errorbar: {
            color: 'white'
          }
        },
        legend: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          itemStyle: {
            color: '#E0E0E3'
          },
          itemHoverStyle: {
            color: '#FFF'
          },
          itemHiddenStyle: {
            color: '#606063'
          },
          title: {
            style: {
              color: '#C0C0C0'
            }
          }
        },
        credits: {
          style: {
            color: '#666'
          }
        },
        labels: {
          style: {
            color: '#707073'
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            color: '#F0F0F3'
          },
          activeDataLabelStyle: {
            color: '#F0F0F3'
          }
        },
        navigation: {
          buttonOptions: {
            symbolStroke: '#DDDDDD',
            theme: {
              fill: '#505053'
            }
          }
        },

        rangeSelector: {
          buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: {
              color: '#CCC'
            },
            states: {
              hover: {
                fill: '#707073',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              },
              select: {
                fill: '#000003',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              }
            }
          },
          inputBoxBorderColor: '#505053',
          inputStyle: {
            backgroundColor: '#333',
            color: 'silver'
          },
          labelStyle: {
            color: 'silver'
          }
        },
        navigator: {
          handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
          },
          outlineColor: '#CCC',
          maskFill: 'rgba(255,255,255,0.1)',
          series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
          },
          xAxis: {
            gridLineColor: '#505053'
          }
        },
        scrollbar: {
          barBackgroundColor: '#808083',
          barBorderColor: '#808083',
          buttonArrowColor: '#CCC',
          buttonBackgroundColor: '#606063',
          buttonBorderColor: '#606063',
          rifleColor: '#FFF',
          trackBackgroundColor: '#404043',
          trackBorderColor: '#404043'
        },
        series: [{
          name: "SAMPLES",
          colorByPoint: true,
          data: []
        }]
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'drilldown', {
        series: []
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'exporting', { enabled: false }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'credits', {
        enabled: false
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'loading', {
        labelStyle: {
          color: 'black',
          textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
        },
        style: {
          backgroundColor: 'none',
          opacity: 1,
          marginTop: '20px'
        }
      }), _chartOptions) };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__utils_mixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['changeGridOnline']), {
    loadGrid: function loadGrid(event) {
      var status = event.point.drilldown;
      console.log('status', status);

      var ENDPOINT = 'v1/get-sensor-status-alarme-grid?planta=' + this.filtersOn.planta + '&status=' + status + '&skipped=';

      var gridOnline = {
        title: event.point.name,
        url: ENDPOINT,
        columns: {
          "area": ['Area'],
          "setor": ['Sector'],
          "conj": ['Machine', 'conjunto'],
          "conj_tag": ['Machine TAG'],
          "equip": ['Component'],
          "equip_tag": ['Component TAG'],
          "ponto": ['Point'],
          "serie": ['Serie'],
          "versao": ['Firmware version'],
          "data": ['Sample date'],
          "bateria": ['Battery level'],
          "sinal_nivel": ['BLE signal'],
          "status": ['Status'],
          "rdps": ['DR']
        },
        show: true
      };

      if (this.filtersOn.planta) {
        gridOnline.title += ' - ' + this.filtersOn.planta_name;
        delete gridOnline.columns['planta'];
      }

      this.changeGridOnline(gridOnline);
    },
    getData: function getData() {
      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/get-sensor-status-alarme';
      var self = this;

      this.$refs.chart.chart.showLoading();

      __WEBPACK_IMPORTED_MODULE_4_axios___default()({ method: 'GET', url: API + ENDPOINT, params: this.filtersOn, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        self.tableData = resp.data.result;
        self.$refs.chart.chart.hideLoading();
      }).catch(function (err) {
        self.$refs.chart.chart.showLoading('Error');

        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    },
    setChartData: function setChartData() {
      var self = this;
      var res = self.tableData;
      var values = [];

      for (var key in res) {
        if (res[key].status == 1) {
          var color = '#90ed7d';
          var name = 'Normal';
        }
        if (res[key].status == 2) {
          var color = '#e4d354';
          var name = 'Alert';
        }
        if (res[key].status == 3) {
          var color = '#f45b5b';
          var name = 'Alarm';
        }
        if (res[key].status == 4) {
          var color = '#6b91c9';
          var name = 'N/A';
        }

        values.push({ 'name': name, 'y': res[key].total, 'drilldown': res[key].status, 'color': color });
      }
      self.chartOptions.series[0].data = values;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['filtersOn'])),
  watch: {
    filtersOn: function filtersOn(newValue) {
      this.getData();
    },
    tableData: function tableData() {
      this.setChartData();
    }
  }
});

/***/ }),

/***/ "k8VF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLine_vue__ = __webpack_require__("HHnu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_869ed9da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLine_vue__ = __webpack_require__("A+TP");
function injectStyle (ssrContext) {
  __webpack_require__("qAgR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeLine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_869ed9da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeLine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kFEL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");










__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_js_popover___default.a);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'charts',
  components: {
    Help: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_components_Help__["a" /* default */]
  },
  data: function data() {
    var _chartOptions;

    return {
      titleChart: this.$t("244"),
      tableData: [],
      chartOptions: (_chartOptions = {
        chart: {
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063',
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0
          }
        },
        title: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '16px',
            fontWeight: 'bold'
          }
        },
        subtitle: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase'
          }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        xAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        yAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        tooltip: {
          headerFormat: '',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },
        plotOptions: {
          pie: {
            borderWidth: 0,
            size: '80%',
            dataLabels: {
              distance: 15
            },
            depth: 55
          },
          series: {
            innerSize: '50%',
            dataLabels: {
              enabled: true,
              format: '<span style="color:#fff ">{point.name}:<br></span><span style="color:#fff "> {point.y}</span>',
              color: '#F0F0F3',
              style: {
                fontSize: '12px'
              }
            },
            marker: {
              lineColor: '#333'
            },
            events: {
              click: this.loadGrid
            }
          },
          boxplot: {
            fillColor: '#505053'
          },
          candlestick: {
            lineColor: 'white'
          },
          errorbar: {
            color: 'white'
          }
        },
        legend: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          itemStyle: {
            color: '#E0E0E3'
          },
          itemHoverStyle: {
            color: '#FFF'
          },
          itemHiddenStyle: {
            color: '#606063'
          },
          title: {
            style: {
              color: '#C0C0C0',
              fontSize: '12px'

            }
          }
        },
        credits: {
          style: {
            color: '#666'
          }
        },
        labels: {
          style: {
            color: '#707073'
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            color: '#F0F0F3'
          },
          activeDataLabelStyle: {
            color: '#F0F0F3'
          }
        },
        navigation: {
          buttonOptions: {
            symbolStroke: '#DDDDDD',
            theme: {
              fill: '#505053'
            }
          }
        },

        rangeSelector: {
          buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: {
              color: '#CCC'
            },
            states: {
              hover: {
                fill: '#707073',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              },
              select: {
                fill: '#000003',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              }
            }
          },
          inputBoxBorderColor: '#505053',
          inputStyle: {
            backgroundColor: '#333',
            color: 'silver'
          },
          labelStyle: {
            color: 'silver'
          }
        },
        navigator: {
          handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
          },
          outlineColor: '#CCC',
          maskFill: 'rgba(255,255,255,0.1)',
          series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
          },
          xAxis: {
            gridLineColor: '#505053'
          }
        },
        scrollbar: {
          barBackgroundColor: '#808083',
          barBorderColor: '#808083',
          buttonArrowColor: '#CCC',
          buttonBackgroundColor: '#606063',
          buttonBorderColor: '#606063',
          rifleColor: '#FFF',
          trackBackgroundColor: '#404043',
          trackBorderColor: '#404043'
        },
        series: [{
          name: "SAMPLES",
          colorByPoint: true,
          data: []
        }]
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'drilldown', {
        series: []
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'exporting', { enabled: false }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'credits', {
        enabled: false
      }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_chartOptions, 'loading', {
        labelStyle: {
          color: 'black',
          textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
        },
        style: {
          backgroundColor: 'none',
          opacity: 1,
          marginTop: '20px'
        }
      }), _chartOptions) };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__utils_mixin__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['changeGridOnline']), {
    loadGrid: function loadGrid(event) {
      var status = event.point.drilldown;
      var point_name = event.point.name;
      var NAME_CHART = this.$t("368") + ' - ' + point_name.toUpperCase();
      var ENDPOINT = 'v1/mysemeq-ambev/get-equip-status-grid?corp=' + this.filtersOn.corp + '&region=' + this.filtersOn.region + '&planta=' + this.filtersOn.planta + '&status=' + status + '&skipped=&area_f=' + this.filtersOn.area_f + '&sector_f=' + this.filtersOn.sector_f + '&machine=' + this.filtersOn.machine + '&subset=' + this.filtersOn.subset;

      var gridOnline = {
        title: event.point.name,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
          "area": [this.$t("311")],
          "setor": [this.$t("312")],
          "conj": [this.$t("316"), 'conjunto'],
          "conj_tag": [this.$t("317")],
          "equip": [this.$t("313")],
          "equip_tag": [this.$t("314")],
          "data": [this.$t("334")],
          "status": ['Status'],
          "rdps": [this.$t("161")],
          "approved_datetime": [this.$t("320")]
        },
        show: true,
        titleHelp: 'Grid - ' + this.$t("368"),
        txtHelp: this.$t("369")
      };

      if (!this.filtersOn.planta) {
        gridOnline.columns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ "rows": [''], 'planta': [this.$t("310"), 'planta_f'] }, gridOnline.columns);
      } else {
        gridOnline.columns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ "rows": [''] }, gridOnline.columns);
      }

      if (this.filtersOn.planta) {
        gridOnline.title += ' - ' + this.filtersOn.planta_name;
        delete gridOnline.columns['planta'];
      }

      this.changeGridOnline(gridOnline);
    },
    getData: function getData() {
      var API = "https://api.semeq.com.br/";

      var ENDPOINT = 'v1/mysemeq-ambev/get-equip-status';
      var self = this;

      this.$refs.chart.chart.showLoading();

      __WEBPACK_IMPORTED_MODULE_4_axios___default()({ method: 'GET', url: API + ENDPOINT, params: this.filtersOn, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        self.tableData = resp.data.result;
        self.$refs.chart.chart.hideLoading();
      }).catch(function (err) {
        self.$refs.chart.chart.showLoading('Error');

        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    },
    setChartData: function setChartData() {
      var self = this;
      var res = self.tableData;
      var values = [];

      for (var key in res) {
        if (res[key].status == 1) {
          var color = '#90ed7d';
          var name = this.$t("306");
        }
        if (res[key].status == 2) {
          var color = '#e4d354';
          var name = this.$t("307");
        }
        if (res[key].status == 3) {
          var color = '#f45b5b';
          var name = this.$t("308");
        }
        if (res[key].status == 4) {
          var color = '#6b91c9';
          var name = this.$t("309");
        }

        values.push({ 'name': name, 'y': res[key].total, 'drilldown': res[key].status, 'color': color });
      }
      self.chartOptions.series[0].data = values;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['filtersOn'])),
  watch: {
    filtersOn: function filtersOn(newValue) {
      this.getData();
    },
    tableData: function tableData() {
      this.setChartData();
    }
  }
});

/***/ }),

/***/ "kKi2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");








__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_js_popover___default.a);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'charts',
  components: {
    Help: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_components_Help__["a" /* default */]
  },
  data: function data() {
    return {
      titleChart: this.$t("276"),
      tableData: [],
      chartOptions: {
        chart: {
          type: 'heatmap',
          backgroundColor: 'rgba(0,0,0,0)',
          marginTop: 40,

          plotBorderWidth: 1,
          height: 520
        },

        title: {
          text: ''
        },

        xAxis: {
          categories: [],
          title: {
            text: 'days',
            style: {
              color: '#fff'
            }
          }
        },

        yAxis: {
          categories: [],
          title: null,
          reversed: true
        },

        tooltip: {
          formatter: function formatter() {
            var value = this.point.value;
            if (value || value == 0) {
              return '<b>' + this.point.value + '</b> sensors - <b>' + this.series.yAxis.categories[this.point.y] + '</b>';
            }
            return '<b>' + this.point.series.yAxis.categories[this.point.options.y] + '</b><br><b>No data!</b>';
          },
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },

        series: [{
          borderWidth: 1,
          data: [],
          showInLegend: false,
          dataLabels: {
            enabled: true,
            color: '#000000'
          }
        }],

        plotOptions: {
          heatmap: {
            nullColor: '#000',
            borderColor: '#000'
          },
          series: {
            dataLabels: {
              formatter: function formatter() {
                return '<span style="font-size:14px" >' + this.point.value + '</span>';
              }
            },
            events: {
              click: this.loadGrid
            },
            cursor: 'pointer'
          }
        },

        loading: {
          labelStyle: {
            color: 'black',
            textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
          },
          style: {
            backgroundColor: 'none',
            opacity: 1
          }
        },

        exporting: { enabled: false },
        credits: {
          enabled: false
        }

      } };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['changeGridOnline']), {
    getData: function getData() {
      var API = "https://api.semeq.com.br/";

      var param = {
        'corp': this.filtersOn.corp,
        'region': this.filtersOn.region,
        'planta': this.filtersOn.planta,
        'area_f': this.filtersOn.area_f,
        'sector_f': this.filtersOn.sector_f,
        'machine': this.filtersOn.machine,
        'subset': this.filtersOn.subset
      };

      this.$refs.chart.chart.showLoading();

      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + 'v1/mysemeq-ambev/get-sensors-failure-mode', params: param, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (_ref) {
        var data = _ref.data;

        if (data) {

          var colors = ['#e4d354', '#ffc300', '#f0893a', '#f45b5b'];

          if (data[0].length == 0) {
            self.$refs.chart.chart.showLoading('No data');
            return false;
          }

          var points = data[0].map(function (elem) {
            elem['color'] = colors[elem.x];
            return elem;
          });

          self.chartOptions.series[0].data = points;
          self.chartOptions.xAxis.categories = data[1];

          data[2][0] = (self.filtersOn.planta_name == 'All' ? '' : self.filtersOn.planta_name) || self.filtersOn.region || 'ABInBev';
          self.chartOptions.yAxis.categories = data[2];
        }
      }).catch(function (error) {
        self.$refs.chart.chart.showLoading('Error');

        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    },
    loadGrid: function loadGrid(event) {

      var area_title = this.chartOptions.yAxis.categories[event.point.y].split(' ').filter(function (item) {
        return item != '-';
      }).join('_');
      var motivo = event.point.y != 0 ? this.chartOptions.yAxis.categories[event.point.y] : '';
      var status = event.point.x;
      var point_name = area_title;
      var NAME_CHART = this.$t("372") + ' - ' + point_name.toUpperCase();
      var ENDPOINT = 'v1/mysemeq-ambev/get-sensors-failure-mode-grid?corp=' + this.filtersOn.corp + '&region=' + this.filtersOn.region + '&planta=' + this.filtersOn.planta + '&motivo=' + motivo + '&status=' + status + '&area_f=' + this.filtersOn.area_f + '&sector_f=' + this.filtersOn.sector_f + '&machine=' + this.filtersOn.machine + '&subset=' + this.filtersOn.subset;

      var gridOnline = {
        title: this.$t("372") + ' - ' + this.chartOptions.yAxis.categories[event.point.y],
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
          "area": [this.$t("311")],
          "setor": [this.$t("312")],
          "conj": [this.$t("316"), 'conjunto'],
          "conj_tag": [this.$t("317")],
          "equip": [this.$t("313")],
          "equip_tag": [this.$t("314")],
          "serie": [this.$t("339")],
          "versao": [this.$t("336")],
          "data": [this.$t("334")],
          "bateria": [this.$t("335")],
          "sinal_nivel": [this.$t("337")],
          "node": [this.$t("338"), 'nodo'],
          "status": ['Status'],
          "id_planta": ['id_planta']
        },
        show: true,
        titleHelp: 'Grid - ' + this.$t("372"),
        txtHelp: this.$t("373")
      };

      if (!this.filtersOn.planta) {
        gridOnline.columns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ "rows": [''], 'planta': [this.$t("310"), 'planta_f'] }, gridOnline.columns);
      } else {
        gridOnline.columns = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ "rows": [''] }, gridOnline.columns);
      }

      if (event.point.value) {
        this.changeGridOnline(gridOnline);
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filtersOn'])),
  watch: {
    filtersOn: function filtersOn(newValue) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "kM/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_chart_vue__ = __webpack_require__("RalK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dac7ad6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_chart_vue__ = __webpack_require__("zTKL");
function injectStyle (ssrContext) {
  __webpack_require__("yFFQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6dac7ad6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dac7ad6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kMAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("skQX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26eabd1b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("EYL6");
function injectStyle (ssrContext) {
  __webpack_require__("TH7T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26eabd1b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26eabd1b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kN1a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"execution","width":240}},[_c('Help',{attrs:{"titleChart":_vm.title}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("280")))]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.$t("281")))]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.$t("282")))]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.$t("283")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("284")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.title)+"\n        "),_c('button',{directives:[{name:"popover",rawName:"v-popover:execution.right",arg:"execution",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('indicator-widget',{attrs:{"legend":_vm.$t('285'),"color":_vm.total_falhas_cor,"valall":_vm.total_falhas_all,"val1y":_vm.total_falhas_y,"val6m":_vm.total_falhas_6m}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('indicator-widget',{attrs:{"legend":_vm.$t('286'),"color":_vm.total_resolvidos_cor,"valall":_vm.total_resolvidos_all,"val1y":_vm.total_resolvidos_y,"val6m":_vm.total_resolvidos_6m}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('indicator-widget',{attrs:{"legend":_vm.$t('287'),"color":_vm.total_media_cor,"valall":_vm.total_media_all,"val1y":_vm.total_media_y,"val6m":_vm.total_media_6m}})],1)])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('history-chart',{attrs:{"id":"chart_failure","typeValue":'DR',"header":_vm.$t('253'),"data":_vm.chart_failure_data}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('history-chart',{attrs:{"id":"chart_resolved","typeValue":'Feedback',"header":_vm.$t('254'),"data":_vm.chart_resolved_data}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('history-chart',{attrs:{"id":"chart_tmsa","typeValue":'Days',"header":_vm.$t('255'),"data":_vm.chart_tmsa_data}})],1)])]),_vm._v(" "),_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"radar","width":240}},[_c('Help',{attrs:{"titleChart":_vm.title2}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("288")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.title2)+"\n        "),_c('button',{directives:[{name:"popover",rawName:"v-popover:radar.right",arg:"radar",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},_vm._l((_vm.radar_data),function(item,key,index){return _c('div',{key:index,staticClass:"col-md-4"},[_c('area-radar-chart',{attrs:{"header":key,"data":item.data,"categories":item.categories,"id":'radar_'+index,"filters":_vm.filters}})],1)}))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kVx9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("uEKC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071d300e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("+2Xc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071d300e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kiqb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



var Highcharts = __webpack_require__("nER5");
__webpack_require__("VVDx")(Highcharts);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'history-chart',
    mounted: function mounted() {
        this.chart = new Highcharts.stockChart(this.options);
    },

    watch: {
        data: function data(value) {
            var _this = this;

            this.chart.series[0].setData(this.data);
            setTimeout(function () {
                _this.setExtremes();
            }, 500);
        },
        period: function period(value) {
            if (this.data) this.setExtremes();
        },
        year: function year(value) {
            if (this.data) this.setExtremes();
        }
    },
    methods: {
        exporting: function exporting() {
            this.chart.exportChart();
        },
        setExtremes: function setExtremes() {
            var _this2 = this;

            var current_date = new Date();
            var min = void 0;
            var max = void 0;
            if (this.year == current_date.getFullYear()) {

                if (this.period == 'AC') {
                    min = new Date(this.year, 0, 1);
                } else {
                    var date_aux = new Date(current_date);
                    min = new Date(date_aux.setMonth(date_aux.getMonth() - this.period));
                }
                max = current_date;
            } else {
                min = new Date(this.year, 0, 1);
                max = new Date(this.year, 11, 1);
            }

            setTimeout(function () {
                _this2.chart.xAxis[0].setExtremes(min.getTime(), max.getTime());
            }, 500);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        period: function period() {
            return this.filtersOn.period;
        },
        year: function year() {
            return this.filtersOn.year;
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filtersOn'])),
    data: function data() {
        return {
            chart: undefined,
            options: {
                chart: {
                    renderTo: this.id,
                    alignTicks: false,
                    height: 130,
                    borderColor: '#C9625F',
                    backgroundColor: 'transparent',
                    spacingTop: 0,
                    spacingBottom: 5,
                    spacingLeft: 0,
                    spacingRight: 0
                },
                rangeSelector: {
                    allButtonsEnabled: true,
                    selected: 4,
                    inputEnabled: false,
                    buttonTheme: {
                        fill: '#505053',
                        stroke: '#000000',
                        style: {
                            color: '#CCC'
                        },
                        states: {
                            hover: {
                                fill: '#707073',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            },
                            select: {
                                fill: '#000003',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    },
                    inputBoxBorderColor: '#505053',
                    inputStyle: {
                        backgroundColor: '#333',
                        color: 'silver'
                    },
                    labelStyle: {
                        color: 'silver'
                    },
                    buttons: [{
                        type: 'month',
                        count: 3,
                        text: '3m'
                    }, {
                        type: 'month',
                        count: 6,
                        text: '6m'
                    }, {
                        type: 'ytd',
                        text: 'YTD'
                    }, {
                        type: 'year',
                        count: 1,
                        text: '1y'
                    }, {
                        type: 'all',
                        text: 'All'
                    }]
                },
                credits: {
                    enabled: false
                },
                navigation: {
                    buttonOptions: {
                        enabled: false
                    }
                },
                scrollbar: {
                    enabled: false
                },
                navigator: {
                    enabled: false
                },

                colors: ['#6b91c9'],
                xAxis: {
                    minRange: 3,
                    lineColor: '#e1e1e1',
                    tickColor: '#EFEFEF',
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    }
                },
                yAxis: {
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    }
                },
                series: [{
                    type: 'line',
                    name: this.typeValue,
                    dataGrouping: {
                        units: [['week', [1]], ['month', [1, 2, 3, 4, 6]]]
                    }
                }],
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    }
                },
                exporting: {
                    chartOptions: {
                        xAxis: {
                            lineColor: '#e1e1e1',
                            tickColor: '#EFEFEF',
                            labels: {
                                style: {
                                    color: '#000'
                                }
                            }
                        },
                        yAxis: {
                            gridLineColor: '#e1e1e1',
                            labels: {
                                style: {
                                    color: '#000'
                                }
                            }
                        }
                    }
                }
            },
            range_selector: 0
        };
    },

    props: {
        data: {
            default: [],
            type: Array
        },
        id: {
            type: String
        },
        typeValue: {
            type: String
        },
        header: {
            type: String
        }
    }
});

/***/ }),

/***/ "lCsA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_actions_componentType__ = __webpack_require__("GGES");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_async_computed__ = __webpack_require__("PlbA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_async_computed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_async_computed__);























var focus = {
  inserted: function inserted(el) {
    el.focus();
  }
};

__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_17_vue_async_computed___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  directives: { focus: focus },
  name: 'my-tour',
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_13_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  asyncComputed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_vuex__["a" /* mapGetters */])({
    tableData: 'tableData'
  }), {
    pagedData: function pagedData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', _this.tableData);

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    queriedData: function queriedData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.searchQuery) {
                  _context2.next = 4;
                  break;
                }

                if (!(_this2.tableData && _this2.tableData[0].total > 1)) {
                  _context2.next = 4;
                  break;
                }

                _this2.pagination.total = _this2.tableData[0].total;
                return _context2.abrupt('return', _this2.pagedData);

              case 4:
                if (!_this2.searchQuery) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return', _this2.tableData);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    to: function to() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var highBound;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                highBound = _this3.from + _this3.pagination.perPage;

                if (_this3.total < highBound) {
                  highBound = _this3.total;
                }
                return _context3.abrupt('return', highBound);

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    from: function from() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', _this4.pagination.perPage * (_this4.pagination.currentPage - 1));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    total: function total() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this5.tableData && _this5.tableData[0].total > 0)) {
                  _context5.next = 3;
                  break;
                }

                _this5.pagination.total = _this5.tableData[0].total;
                return _context5.abrupt('return', _this5.tableData[0].total);

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  }),
  watch: {
    searchQuery: function searchQuery(value) {
      var page = 1;
      var limit = this.pagination.perPage;
      var order = this.satusOrder;
      if (this.searchQuery) {
        var search = this.searchQuery;
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_16__store_actions_componentType__["a" /* TIPO_REQUEST */], { page: page, limit: limit, search: search, order: order });
      }
      if (this.searchQuery === '') {
        var _search = '';
        this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_16__store_actions_componentType__["a" /* TIPO_REQUEST */], { page: page, limit: limit, search: _search, order: order });
      }
    }
  },
  data: function data() {
    return {
      steps: [{
        target: '#v-step-0',
        content: 'Help:'
      }, {
        target: '.v-step-1',
        content: 'Help:'
      }, {
        target: '.v-step-2',
        content: 'Help:'
      }, {
        target: '.v-step-3',
        content: 'Help:'
      }, {
        target: '.v-step-4',
        content: 'Help:'
      }, {
        target: '.v-step-5',
        content: 'Help:'
      }, {
        target: '.v-step-6',
        content: 'Help:'
      }, {
        target: '.v-step-7',
        content: 'Help:'
      }, {
        target: '.v-step-8',
        content: 'Help:'
      }, {
        target: '.v-step-9',
        content: 'Help:'
      }, {
        target: '.v-step-10',
        content: 'Help:'
      }],
      max: 40,
      text: '',
      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false
      },
      selected: '',
      selectedId: '',
      satusOrder: '',
      show: false,
      showNovo: false,
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['id', 'descricao'],
      tableColumns: [{
        prop: 'descricao',
        sortable: 'custom',
        label: 'cadastro.tipo.equipamento.tabela.descricao',
        minWidth: 250
      }]
    };
  },
  mounted: function mounted() {
    var page = 1;
    var limit = this.pagination.perPage;
    var search = '';
    var order = 'ascending';
    this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_16__store_actions_componentType__["a" /* TIPO_REQUEST */], { page: page, limit: limit, search: search, order: order });
  },

  methods: {
    clearButton: function clearButton() {
      this.selected = '';
    },
    nextStep: function nextStep() {
      this.$tours['myTour'].nextStep();
    },
    showLastStep: function showLastStep() {
      this.$tours['myTour'].currentStep = this.steps.length - 1;
    },
    myCustomPreviousStepCallback: function myCustomPreviousStepCallback(currentStep) {
      console.log('[Vue Tour] A custom previousStep callback has been called on step ' + (currentStep + 1));
    },
    myCustomNextStepCallback: function myCustomNextStepCallback(currentStep) {
      console.log('[Vue Tour] A custom nextStep callback has been called on step ' + (currentStep + 1));

      if (currentStep === 1) {
        console.log('[Vue Tour] A custom nextStep callback has been called from step 2 to step 3');
      }
    },
    upper: function upper(e) {
      e.target.value = e.target.value.toUpperCase();
    },
    ordem: function ordem(a) {
      this.satusOrder = a.order;
      console.log(a);
      var page = 1;
      var limit = this.pagination.perPage;
      var search = '';
      var order = a.order;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_16__store_actions_componentType__["a" /* TIPO_REQUEST */], { page: page, limit: limit, search: search, order: order });
    },
    showSwal: function showSwal(type) {
      var _this6 = this;

      var selected = this.selected;
      var selectedId = this.selectedId;

      if (type === 'editar-tipo-equipamento') {
        if (selectedId === '' || selected === '') {
          this.show = true;
          setTimeout(function () {
            _this6.show = false;
          }, 5000);
          return false;
        }

        var sucessoAlterar = this.$t('cadastro.sweet.text.alterar.sucesso');
        var msgSucessoAlterar = this.$t('cadastro.sweet.text.alterar.sucesso.msg');
        var errorAlterar = this.$t('cadastro.sweet.text.erro.alterar');
        var msgErrorAlterar = this.$t('cadastro.sweet.text.erro.alterar.msg');
        __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
          text: this.$t('cadastro.sweet.text.alterar'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Ok',
          buttonsStyling: false
        }).then(function (data) {
          var descricao = selected.toUpperCase();
          _this6.$store.dispatch(__WEBPACK_IMPORTED_MODULE_16__store_actions_componentType__["b" /* TIPO_UPDATE */], { descricao: descricao, selectedId: selectedId }).then(function (res) {
            if (res.status === 400) {
              __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                title: errorAlterar,
                text: msgErrorAlterar,
                type: 'warning',
                confirmButtonClass: 'btn btn-danger btn-fill',
                buttonsStyling: false
              });
            } else if (res.status === 200) {
              __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                title: sucessoAlterar,
                text: msgSucessoAlterar,
                type: 'success',
                confirmButtonClass: 'btn btn-success btn-fill',
                buttonsStyling: false
              });
              _this6.selected = '';
              _this6.selectedId = '';
              var page = _this6.pagination.currentPage;
              var limit = _this6.pagination.perPage;
              var search = '';
              var order = _this6.satusOrder;
              _this6.$store.dispatch(__WEBPACK_IMPORTED_MODULE_16__store_actions_componentType__["a" /* TIPO_REQUEST */], { page: page, limit: limit, search: search, order: order });
            }
          }).catch(function (error) {
            console.log(error);
            __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
              title: errorAlterar,
              text: msgErrorAlterar,
              type: 'warning',
              confirmButtonClass: 'btn btn-danger btn-fill',
              buttonsStyling: false
            });
          });
        });
      } else if (type === 'novo-tipo-equipamento') {
        if (selected === '') {
          this.showNovo = true;
          setTimeout(function () {
            _this6.showNovo = false;
          }, 5000);
          return false;
        }

        var errorNovo = this.$t('cadastro.sweet.text.criar.erro');
        var msgErrorNovo = this.$t('cadastro.sweet.text.criar.erro.msg');
        var sucessoNovo = this.$t('cadastro.sweet.text.criar.salvo');
        var msgSucessoNovo = this.$t('cadastro.sweet.text.criar.salvo.msg.geral');
        __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
          text: this.$t('cadastro.sweet.text.criar'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Ok',
          buttonsStyling: false
        }).then(function (data) {
          var descricao = selected.toUpperCase();
          _this6.$store.dispatch(__WEBPACK_IMPORTED_MODULE_16__store_actions_componentType__["c" /* TIPO_CREATE */], { descricao: descricao }).then(function (res) {
            if (res.status === 400) {
              __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                title: errorNovo,
                text: msgErrorNovo,
                type: 'warning',
                confirmButtonClass: 'btn btn-danger btn-fill',
                buttonsStyling: false
              });
            } else if (res.status === 200) {
              __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
                title: sucessoNovo,
                text: msgSucessoNovo,
                type: 'success',
                confirmButtonClass: 'btn btn-success btn-fill',
                buttonsStyling: false
              });
              _this6.selected = '';
              var page = 1;
              var limit = _this6.pagination.perPage;
              var search = '';
              var order = _this6.satusOrder;
              _this6.$store.dispatch(__WEBPACK_IMPORTED_MODULE_16__store_actions_componentType__["a" /* TIPO_REQUEST */], { page: page, limit: limit, search: search, order: order });
            }
          }).catch(function (error) {
            console.log(error);
            __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
              title: errorNovo,
              text: msgErrorNovo,
              type: 'warning',
              confirmButtonClass: 'btn btn-danger btn-fill',
              buttonsStyling: false
            });
          });
        });
      }
    },
    handleEdit: function handleEdit(index, row) {
      this.selected = row.descricao;
      this.selectedId = row.id;
      this.$refs.selected.focus();
    },
    handleDelete: function handleDelete(index, row) {
      var _this7 = this;

      var selectedId = row.id;
      var descricao = row.descricao;
      var errorExcluir = this.$t('cadastro.sweet.text.excluir.erro');
      var msgErrorExcluir = this.$t('cadastro.sweet.text.excluir.erro.msg');
      var sucessoExcluir = this.$t('cadastro.sweet.text.excluir.sucesso');
      var msgSucessoExcluir = this.$t('cadastro.sweet.text.excluir.sucesso.msg');
      __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
        text: this.$t('cadastro.sweet.text.excluir'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Ok',
        buttonsStyling: false
      }).then(function (data) {
        _this7.$store.dispatch(__WEBPACK_IMPORTED_MODULE_16__store_actions_componentType__["d" /* TIPO_DELETE */], { descricao: descricao, selectedId: selectedId }).then(function (res) {
          if (res.status === 400) {
            __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
              title: errorExcluir,
              text: msgErrorExcluir,
              type: 'warning',
              confirmButtonClass: 'btn btn-danger btn-fill',
              buttonsStyling: false
            });
          } else if (res.status === 200) {
            __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
              title: sucessoExcluir,
              text: msgSucessoExcluir,
              type: 'success',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            });
            _this7.selected = '';
            var page = 1;
            var limit = _this7.pagination.perPage;
            var search = '';
            var order = _this7.satusOrder;
            _this7.$store.dispatch(__WEBPACK_IMPORTED_MODULE_16__store_actions_componentType__["a" /* TIPO_REQUEST */], { page: page, limit: limit, search: search, order: order });
          }
        }).catch(function (error) {
          console.log(error);
          __WEBPACK_IMPORTED_MODULE_14_sweetalert2___default()({
            title: errorExcluir,
            text: msgErrorExcluir,
            type: 'warning',
            confirmButtonClass: 'btn btn-danger btn-fill',
            buttonsStyling: false
          });
        });
      });
    }
  }
});

/***/ }),

/***/ "lS3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('form',{staticClass:"form-horizontal"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Required text")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.requiredText),expression:"modelValidations.requiredText"},{name:"model",rawName:"v-model",value:(_vm.model.requiredText),expression:"model.requiredText"}],staticClass:"form-control",attrs:{"type":"text","name":"requiredText"},domProps:{"value":(_vm.model.requiredText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "requiredText", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.requiredText.invalid),expression:"requiredText.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('requiredText'))+"\n            ")])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('email'))+"\n            ")])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Number")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.number),expression:"modelValidations.number"},{name:"model",rawName:"v-model",value:(_vm.model.number),expression:"model.number"}],staticClass:"form-control",attrs:{"type":"number","name":"number"},domProps:{"value":(_vm.model.number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "number", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.number.invalid),expression:"number.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('number'))+"\n            ")])]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Url")]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.url),expression:"modelValidations.url"},{name:"model",rawName:"v-model",value:(_vm.model.url),expression:"model.url"}],staticClass:"form-control",attrs:{"type":"url","name":"url"},domProps:{"value":(_vm.model.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "url", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.url.invalid),expression:"url.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('url'))+"\n            ")])]),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group column-sizing"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("\n            Equal to\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.idSource),expression:"modelValidations.idSource"},{name:"model",rawName:"v-model",value:(_vm.model.idSource),expression:"model.idSource"}],staticClass:"form-control",attrs:{"name":"idSource","placeholder":"#idSource","type":"text"},domProps:{"value":(_vm.model.idSource)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "idSource", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.idSource.invalid),expression:"idSource.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('idSource'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.idDestination),expression:"modelValidations.idDestination"},{name:"model",rawName:"v-model",value:(_vm.model.idDestination),expression:"model.idDestination"}],staticClass:"form-control",attrs:{"name":"idDestination","placeholder":"#idDestination","type":"text"},domProps:{"value":(_vm.model.idDestination)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "idDestination", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.idDestination.invalid),expression:"idDestination.invalid"}],staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.getError('idDestination'))+"\n            ")])]),_vm._v(" "),_vm._m(5)])])]),_vm._v(" "),_c('div',{staticClass:"card-footer text-center"},[_c('button',{staticClass:"btn btn-fill btn-info btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.validate($event)}}},[_vm._v("Validate inputs")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n        Register Form\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("required:true")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("email:true")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("decimal:true")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("url:true")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4"},[_c('code',[_vm._v("confirmed : 'idSource'")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lteb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lw2a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_mixin__ = __webpack_require__("vsZy");







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            data: [],
            pg: 0,
            showModal: false,
            showModalFile: false,
            showModalHelp: false,
            title: '',
            columns: {},
            url: '',
            sortFilters: {},
            sortOrders: {},
            order: 'asc',
            sortKey: '',
            export_csv: true,
            titleHelp: '',
            txtHelp: ''
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_3__utils_mixin__["a" /* default */]],
    computed: {
        filteredData: function filteredData() {
            return this.data;
        },
        gridInfo: function gridInfo() {
            return this.gridOnline();
        },
        planta: function planta() {
            return this.filtersOn().planta;
        }
    },
    filters: {
        capitalize: function capitalize(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        handleNull: function handleNull(str) {
            str = str == 0 ? str.toString() : str;
            return str || '-';
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        getData: function getData(pg) {
            var API = "https://api.semeq.com.br/";

            this.data = [];

            var self = this;
            __WEBPACK_IMPORTED_MODULE_1_axios___default()({ method: 'GET', url: API + this.url + '&sort=' + this.sortKey + '&order=' + this.order, params: this.sortFilters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (_ref) {
                var data = _ref.data;

                if (data.result.length > 0) {
                    self.data = data.result;
                } else {
                    self.data = [{ '-': '-' }];
                }
                self.pg = pg;
            }).catch(function (error) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        filterGrid: function filterGrid() {
            this.getData(0);
        },
        sortBy: function sortBy(key) {
            if (this.sortKey != key) {
                this.order = 'asc';
            } else {
                this.order = this.order == 'desc' ? 'asc' : 'desc';
            }

            this.sortKey = key;
            this.getData(0);
        },
        btHelp: function btHelp() {
            this.showModalHelp = true;
        },
        btCSV: function btCSV() {
            var self = this;
            self.showModalFile = true;
            var API = "https://api.semeq.com.br/";
            var name_chart_file = this.name_chart;
            var file = 'csv';
            __WEBPACK_IMPORTED_MODULE_1_axios___default()({
                method: 'GET',
                url: API + this.url + '&file=' + file + '&sort=' + this.sortKey + '&order=' + this.order,
                params: this.sortFilters,
                responseType: 'blob',
                headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token')
                } }).then(function (_ref2) {
                var data = _ref2.data;

                var url = window.URL.createObjectURL(new Blob([data]));
                var link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', name_chart_file + '.csv');
                document.body.appendChild(link);
                link.click();
                self.showModalFile = false;
            }).catch(function (error) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        http_to_https: function http_to_https(url) {
            return 'https://' + url.split('://')[1];
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['gridOnline', 'filtersOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['changeModal', 'changeModalPhoto'])),
    watch: {
        show: function show(newValue) {
            this.showModal = newValue;
        },
        url: function url(newValue) {
            this.url = newValue;
            this.sortFilters = {};
            this.sortKey = '';
            this.order = 'asc';
            this.getData(0);
        },
        pg: function pg(newValue) {
            if (newValue >= 0) {
                this.getData(newValue);
            }
        },
        gridInfo: function gridInfo(newValue) {
            this.title = newValue.title.toUpperCase();
            this.url = newValue.url;
            this.name_chart = newValue.name_chart;
            this.columns = newValue.columns;
            this.showModal = newValue.show;
            this.export_csv = newValue.export_csv;
            this.titleHelp = newValue.titleHelp;
            this.txtHelp = newValue.txtHelp;

            this.$nextTick(function () {
                this.$refs.closer.focus();
            });
        }
    }
});

/***/ }),

/***/ "m8hd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExecutionChartTotal_vue__ = __webpack_require__("4emV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ebec138_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutionChartTotal_vue__ = __webpack_require__("21WK");
function injectStyle (ssrContext) {
  __webpack_require__("NBoB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ebec138"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExecutionChartTotal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ebec138_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExecutionChartTotal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mKjx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'indicator-widget',
    props: {
        legend: {
            required: true
        },
        color: {
            type: String,
            required: true
        },
        valall: {
            type: Number,
            default: 0
        },
        val1y: {
            type: Number,
            default: 0
        },
        val6m: {
            type: Number,
            default: 0
        }
    }
});

/***/ }),

/***/ "me3u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__("hASK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aef443c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__("V67u");
function injectStyle (ssrContext) {
  __webpack_require__("J0Sr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aef443c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n0lJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n5Ws":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs__);




__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_nav_tabs___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      lang: 'en'
    };
  },
  mounted: function mounted() {
    var lang = localStorage.getItem('lang');
    this.lang = !lang ? 'en' : lang;
  },

  methods: {
    saveLang: function saveLang() {
      var lang = this.lang;
      this.$store.dispatch('setLang', lang);
    }
  }
});

/***/ }),

/***/ "n8bH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_mixin__ = __webpack_require__("vsZy");







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            apareceClass: false,
            total_pg: '',
            data: [],
            pg: 0,
            showModal: false,
            showModalFile: false,
            showModalHelp: false,
            title: '',
            button: '',
            columns: {},
            url: '',
            sortFilters: {},
            sortOrders: {},
            order: 'asc',
            sortKey: '',
            titleHelp: '',
            txtHelp: '',
            totalDados: ''
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_3__utils_mixin__["a" /* default */]],
    computed: {
        filteredData: function filteredData() {
            return this.data;
        },
        gridInfo: function gridInfo() {
            return this.grid();
        }
    },
    filters: {
        capitalize: function capitalize(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        handleNull: function handleNull(str) {
            return str || '-';
        }
    },
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        getData: function getData(pg) {
            var self = this;

            var API = "https://api.semeq.com.br/";

            self.data = [];
            self.total_pg = 0;

            __WEBPACK_IMPORTED_MODULE_1_axios___default()({ method: 'GET', url: API + this.url + '&pg=' + pg + '&sort=' + this.sortKey + '&order=' + this.order, params: this.sortFilters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (_ref) {
                var data = _ref.data;

                if (data.length > 0) {
                    self.data = data;
                } else {
                    self.data = [{ '-': '-' }];
                }
                self.pg = pg;

                if (data.length < 30) {
                    self.apareceClass = true;
                } else {
                    self.apareceClass = false;
                }

                for (var i in data) {
                    self.total_pg = data[i].rows;
                }
            }).catch(function (error) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        filterGrid: function filterGrid() {
            this.getData(0);
        },
        sortBy: function sortBy(key) {
            if (this.sortKey != key) {
                this.order = 'asc';
            } else {
                this.order = this.order == 'desc' ? 'asc' : 'desc';
            }

            this.sortKey = key;
            this.getData(0);
        },
        btHelp: function btHelp() {
            this.showModalHelp = true;
        },
        btCSV: function btCSV() {
            var self = this;
            self.showModalFile = true;
            var API = "https://api.semeq.com.br/";
            var name_chart_file = this.name_chart;
            var file = 'csv';
            __WEBPACK_IMPORTED_MODULE_1_axios___default()({
                method: 'GET',
                url: API + this.url + '&file=' + file + '&sort=' + this.sortKey + '&order=' + this.order, params: this.sortFilters,
                responseType: 'blob',
                headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token')
                } }).then(function (_ref2) {
                var data = _ref2.data;

                var url = window.URL.createObjectURL(new Blob([data]));
                var link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', name_chart_file + '.csv');
                document.body.appendChild(link);
                link.click();
                self.showModalFile = false;
            }).catch(function (error) {
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['grid']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['changeModal'])),
    watch: {
        show: function show(newValue) {
            this.showModal = newValue;
        },
        url: function url(newValue) {
            this.url = newValue;
            this.sortFilters = {};
            this.sortKey = '';
            this.order = 'asc';
            this.getData(0);
        },
        pg: function pg(newValue) {
            if (newValue >= 0) {
                this.getData(newValue);
            }
        },
        gridInfo: function gridInfo(newValue) {
            this.totalDados = newValue.totalDados;
            this.title = newValue.title.toUpperCase();
            this.url = newValue.url;
            this.name_chart = newValue.name_chart;
            this.columns = newValue.columns;
            this.showModal = newValue.show;
            this.titleHelp = newValue.titleHelp;
            this.txtHelp = newValue.txtHelp;

            this.$nextTick(function () {
                this.$refs.closer.focus();
            });
        }
    }
});

/***/ }),

/***/ "nSaA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showSkipped),expression:"!showSkipped"}],staticClass:"data-survey"},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('Popover',{attrs:{"name":"helpdata","width":240}},[_c('Help',{attrs:{"titleChart":'Data Survey'}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("156")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help"},[_vm._v(_vm._s(_vm.$t("157"))+"\n      "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpdata.right",arg:"helpdata",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('chartsSkipped',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSkipped),expression:"showSkipped"}]})],1),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-sm",attrs:{"id":"buttons-change","role":"group","aria-label":"Buttons"}},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.getBatteryChart()}}},[_c('small',[_vm._v(_vm._s(_vm.btn_title))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "negu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Team members',
      members: [{
        image: 'static/img/faces/face-0.jpg',
        name: 'Dj Khaled',
        status: 'Offline'
      }, {
        image: 'static/img/faces/face-1.jpg',
        name: 'Creative Tim',
        status: 'Available'
      }, {
        image: 'static/img/faces/face-3.jpg',
        name: 'Flume',
        status: 'Busy'
      }]
    };
  },

  methods: {
    getStatusClass: function getStatusClass(status) {
      switch (status) {
        case 'Offline':
          return 'text-muted';
        case 'Available':
          return 'text-success';
        case 'Busy':
          return 'text-danger';
        default:
          return 'text-success';
      }
    }
  }
});

/***/ }),

/***/ "o/9F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_photo_modal_vue__ = __webpack_require__("4/Fw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f64d54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_photo_modal_vue__ = __webpack_require__("CfDv");
function injectStyle (ssrContext) {
  __webpack_require__("hwHr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55f64d54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_photo_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f64d54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_photo_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oDd1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oE/Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondStep_vue__ = __webpack_require__("qeuK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc7402e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondStep_vue__ = __webpack_require__("Nrso");
function injectStyle (ssrContext) {
  __webpack_require__("f4B7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc7402e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oHle":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oLj+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonutExecution_vue__ = __webpack_require__("Chta");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fd1afae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonutExecution_vue__ = __webpack_require__("aNBM");
function injectStyle (ssrContext) {
  __webpack_require__("sPYd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9fd1afae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DonutExecution_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fd1afae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DonutExecution_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "opmZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('div',{attrs:{"id":"modal-container","tabindex":"0"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }_vm.showModal = false}}},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-dialog d-flex flex-column align-content-center",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"z-index":"10"}},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('button',{ref:"closer",staticClass:"close",attrs:{"type":"button","id":"close-button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.showModal = false}}},[_c('span',{staticClass:"ti-close"})]),_vm._v(" "),_c('div',{attrs:{"id":"buttons"}},[_c('button',{staticClass:"btn page-link",on:{"click":function($event){_vm.active='dr'}}},[_vm._v(" "+_vm._s(_vm.$t("161")))]),_vm._v(" "),_c('button',{staticClass:"btn page-link",on:{"click":function($event){_vm.active='feedback'}}},[_vm._v(_vm._s(_vm.$t("162")))]),_vm._v(" "),_c('button',{staticClass:"btn page-link",on:{"click":function($event){_vm.active='prescription'}}},[_vm._v(_vm._s(_vm.$t("163")))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body overflow-auto",staticStyle:{"width":"100%","height":"73vh"}},[_c('div',{staticStyle:{"background-color":"#fff","padding":"20px"}},[_c('div',{staticClass:"d-flex justify-content-center align-content-middle",attrs:{"id":"spinner-loading"}},[_c('div',{staticClass:"loader"})]),_vm._v(" "),(_vm.active == 'feedback' && _vm.rdp.status=='A' && _vm.form==false)?_c('button',{staticClass:"btn page-link btn-form-rci",on:{"click":function($event){_vm.form=!_vm.form}}},[_vm._v("\n                                        "+_vm._s(_vm.$t("164"))+"\n                                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"schedule-form"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.form && _vm.active == 'feedback')?_c('div',{staticClass:"form-wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-5"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("165"))+" \n                                                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rdp.psm_os),expression:"rdp.psm_os"}],ref:"psmschedule",staticClass:"form-control",attrs:{"type":"text","name":"PSM","placeholder":"0000"},domProps:{"value":(_vm.rdp.psm_os)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rdp, "psm_os", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-5"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("166"))+"  \n                                                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rdp.sap_nw_number),expression:"rdp.sap_nw_number"}],staticClass:"form-control",attrs:{"type":"text","name":"note_number","placeholder":"0000"},domProps:{"value":(_vm.rdp.sap_nw_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rdp, "sap_nw_number", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-5"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("167"))+"\n                                                        ")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"date","placeholder":"","format":"dd/MM/yyyy","prefix-icon":"ti-calendar"},model:{value:(_vm.rdp.data_prog),callback:function ($$v) {_vm.$set(_vm.rdp, "data_prog", $$v)},expression:"rdp.data_prog"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-5"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("168"))+" \n                                                        ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.rdp.motivo),expression:"rdp.motivo"}],staticClass:"form-control",attrs:{"type":"text","name":"reason","placeholder":""},domProps:{"value":(_vm.rdp.motivo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rdp, "motivo", $event.target.value)}}})])]),_vm._v(" "),(_vm.error.status)?_c('span',{staticStyle:{"color":"red","font-size":"15px"}},[_vm._v(_vm._s(_vm.error.msg)),_c('br'),_c('br')]):_vm._e(),_vm._v(" "),(_vm.msg.status)?_c('span',{staticStyle:{"font-size":"15px"}},[_vm._v(_vm._s(_vm.msg.msg)),_c('br'),_c('br')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row btns-prog"},[_c('button',{staticClass:"btn page-link btn-prog-rci",on:{"click":function($event){_vm.reset()}}},[_vm._v(_vm._s(_vm.$t("169"))+" ")]),_vm._v(" "),_c('button',{staticClass:"btn page-link btn-prog-rci",on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t("170"))+" ")])])]):_vm._e()])],1),_vm._v(" "),_c('iframe',{directives:[{name:"show",rawName:"v-show",value:(_vm.active=="dr"),expression:"active==\"dr\""}],attrs:{"src":_vm.link_rdp,"name":"frame","id":"iframe_dr","frameborder":"0"}}),_vm._v(" "),_c('hr',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"schedule-form"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.active=='feedback')?_c('div',{staticClass:"form-wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("171"))+" \n                                                        ")]),_vm._v("\n                                                        "+_vm._s(_vm.rci_numero)+"\n                                                    ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("172"))+"\n                                                        ")]),_vm._v("\n                                                        "+_vm._s(_vm.rci_planta_area)+"\n                                                    ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("165"))+"\n                                                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_psm_wo),expression:"rci_psm_wo"}],ref:"psm",staticClass:"form-control",attrs:{"autofocus":"","disabled":_vm.disabled,"maxlength":"16","type":"text","name":"PSM","placeholder":"0000"},domProps:{"value":(_vm.rci_psm_wo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rci_psm_wo=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("173"))+" \n                                                        ")]),_vm._v(" "),_c('el-date-picker',{staticClass:"calendario",attrs:{"type":"date","placeholder":"","format":"dd/MM/yyyy","prefix-icon":"ti-calendar","disabled":_vm.disabled},model:{value:(_vm.rci_dt_intervencao),callback:function ($$v) {_vm.rci_dt_intervencao=$$v},expression:"rci_dt_intervencao"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("174"))+"\n                                                        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("175"))+" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_tempo_gasto_inter_hour),expression:"rci_tempo_gasto_inter_hour"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled,"maxlength":"2","type":"text","name":"Hours","placeholder":"00"},domProps:{"value":(_vm.rci_tempo_gasto_inter_hour)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rci_tempo_gasto_inter_hour=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("176"))+" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_tempo_gasto_inter_minu),expression:"rci_tempo_gasto_inter_minu"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled,"maxlength":"2","type":"text","name":"Minutes","placeholder":"00"},domProps:{"value":(_vm.rci_tempo_gasto_inter_minu)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rci_tempo_gasto_inter_minu=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("177"))+"\n                                                        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("175"))+" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_tempo_parada_equip_hour),expression:"rci_tempo_parada_equip_hour"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled,"maxlength":"2","type":"text","name":"Hours","placeholder":"00"},domProps:{"value":(_vm.rci_tempo_parada_equip_hour)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rci_tempo_parada_equip_hour=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("176"))+" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_tempo_parada_equip_minu),expression:"rci_tempo_parada_equip_minu"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled,"maxlength":"2","type":"text","name":"Minutes","placeholder":"00"},domProps:{"value":(_vm.rci_tempo_parada_equip_minu)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rci_tempo_parada_equip_minu=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("178"))+" \n                                                        ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_nome_resp_intervencao),expression:"rci_nome_resp_intervencao"}],staticClass:"form-control",attrs:{"disabled":_vm.disabled,"maxlength":"40","type":"text","name":"Person responsible for intervention:","placeholder":"ex: Jose"},domProps:{"value":(_vm.rci_nome_resp_intervencao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rci_nome_resp_intervencao=$event.target.value}}})])]),_vm._v(" "),_c('hr',{staticClass:"line"}),_vm._v(" "),(_vm.questao=='normal')?_c('div',{staticClass:"row",staticStyle:{"margin":"10px 0px"}},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.number_a)+" - "+_vm._s(_vm.$t("179"))+"\n                                                        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_resp_pergunta_a),expression:"rci_resp_pergunta_a"}],attrs:{"disabled":_vm.disabled,"type":"radio","id":"1","value":"1"},domProps:{"checked":_vm._q(_vm.rci_resp_pergunta_a,"1")},on:{"change":function($event){_vm.rci_resp_pergunta_a="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"1"}},[_vm._v(_vm._s(_vm.$t("180"))+" ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_resp_pergunta_a),expression:"rci_resp_pergunta_a"}],attrs:{"disabled":_vm.disabled,"type":"radio","id":"2","value":"2"},domProps:{"checked":_vm._q(_vm.rci_resp_pergunta_a,"2")},on:{"change":function($event){_vm.rci_resp_pergunta_a="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"2"}},[_vm._v(_vm._s(_vm.$t("181")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_resp_pergunta_a),expression:"rci_resp_pergunta_a"}],attrs:{"disabled":_vm.disabled,"type":"radio","id":"3","value":"3"},domProps:{"checked":_vm._q(_vm.rci_resp_pergunta_a,"3")},on:{"change":function($event){_vm.rci_resp_pergunta_a="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"3"}},[_vm._v(_vm._s(_vm.$t("182")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_desc_resp_pergunta_a),expression:"rci_desc_resp_pergunta_a"}],staticClass:"col-md-12",attrs:{"disabled":_vm.disabled,"maxlength":"200"},domProps:{"value":(_vm.rci_desc_resp_pergunta_a)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rci_desc_resp_pergunta_a=$event.target.value}}})])])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.questao=='oleo')?_c('div',{staticClass:"row",staticStyle:{"margin":"10px 0px"}},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("183"))+"\n                                                        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_resp_pergunta_a),expression:"rci_resp_pergunta_a"}],attrs:{"disabled":_vm.disabled,"type":"radio","id":"1","value":"1"},domProps:{"checked":_vm._q(_vm.rci_resp_pergunta_a,"1")},on:{"change":function($event){_vm.rci_resp_pergunta_a="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"1"}},[_vm._v(_vm._s(_vm.$t("180")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_resp_pergunta_a),expression:"rci_resp_pergunta_a"}],attrs:{"disabled":_vm.disabled,"type":"radio","id":"2","value":"2"},domProps:{"checked":_vm._q(_vm.rci_resp_pergunta_a,"2")},on:{"change":function($event){_vm.rci_resp_pergunta_a="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"2"}},[_vm._v(_vm._s(_vm.$t("184")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_resp_pergunta_a),expression:"rci_resp_pergunta_a"}],attrs:{"disabled":_vm.disabled,"type":"radio","id":"3","value":"3"},domProps:{"checked":_vm._q(_vm.rci_resp_pergunta_a,"3")},on:{"change":function($event){_vm.rci_resp_pergunta_a="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"3"}},[_vm._v(_vm._s(_vm.$t("185")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_desc_resp_pergunta_a),expression:"rci_desc_resp_pergunta_a"}],staticClass:"col-md-12",attrs:{"disabled":_vm.disabled,"maxlength":"200"},domProps:{"value":(_vm.rci_desc_resp_pergunta_a)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rci_desc_resp_pergunta_a=$event.target.value}}})])])])]):_vm._e(),_vm._v(" "),(_vm.questao=='normal' && _vm.vibracao=='1' )?_c('div',{staticClass:"row",staticStyle:{"margin":"10px 0px"}},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.number_b)+" - "+_vm._s(_vm.$t("186"))+"\n                                                        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_resp_pergunta_b),expression:"rci_resp_pergunta_b"}],attrs:{"disabled":_vm.disabled,"type":"radio","id":"1","value":"1"},domProps:{"checked":_vm._q(_vm.rci_resp_pergunta_b,"1")},on:{"change":function($event){_vm.rci_resp_pergunta_b="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"1"}},[_vm._v(_vm._s(_vm.$t("180")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_resp_pergunta_b),expression:"rci_resp_pergunta_b"}],attrs:{"disabled":_vm.disabled,"type":"radio","id":"2","value":"2"},domProps:{"checked":_vm._q(_vm.rci_resp_pergunta_b,"2")},on:{"change":function($event){_vm.rci_resp_pergunta_b="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"2"}},[_vm._v(_vm._s(_vm.$t("187")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_desc_resp_pergunta_b),expression:"rci_desc_resp_pergunta_b"}],staticClass:"col-md-12",attrs:{"disabled":_vm.disabled,"maxlength":"200"},domProps:{"value":(_vm.rci_desc_resp_pergunta_b)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rci_desc_resp_pergunta_b=$event.target.value}}})])])])]):_vm._e(),_vm._v(" "),(_vm.questao=='oleo')?_c('div',{staticClass:"row",staticStyle:{"margin":"10px 0px"}},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("188"))+"\n                                                        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_resp_pergunta_b),expression:"rci_resp_pergunta_b"}],attrs:{"disabled":_vm.disabled,"type":"radio","id":"1","value":"1"},domProps:{"checked":_vm._q(_vm.rci_resp_pergunta_b,"1")},on:{"change":function($event){_vm.rci_resp_pergunta_b="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"1"}},[_vm._v(_vm._s(_vm.$t("180")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_resp_pergunta_b),expression:"rci_resp_pergunta_b"}],attrs:{"disabled":_vm.disabled,"type":"radio","id":"2","value":"2"},domProps:{"checked":_vm._q(_vm.rci_resp_pergunta_b,"2")},on:{"change":function($event){_vm.rci_resp_pergunta_b="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"2"}},[_vm._v(_vm._s(_vm.$t("189")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_desc_resp_pergunta_b),expression:"rci_desc_resp_pergunta_b"}],staticClass:"col-md-12",attrs:{"disabled":_vm.disabled,"maxlength":"200"},domProps:{"value":(_vm.rci_desc_resp_pergunta_b)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rci_desc_resp_pergunta_b=$event.target.value}}})])])])]):_vm._e(),_vm._v(" "),(_vm.questao=='normal' && _vm.vibracao=='1')?_c('div',{staticClass:"row",staticStyle:{"margin":"10px 0px"}},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.number_c)+" - "+_vm._s(_vm.$t("190"))+"\n                                                        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_resp_pergunta_c),expression:"rci_resp_pergunta_c"}],attrs:{"disabled":_vm.disabled,"type":"radio","id":"1","value":"1"},domProps:{"checked":_vm._q(_vm.rci_resp_pergunta_c,"1")},on:{"change":function($event){_vm.rci_resp_pergunta_c="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"1"}},[_vm._v(_vm._s(_vm.$t("180")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_resp_pergunta_c),expression:"rci_resp_pergunta_c"}],attrs:{"disabled":_vm.disabled,"type":"radio","id":"2","value":"2"},domProps:{"checked":_vm._q(_vm.rci_resp_pergunta_c,"2")},on:{"change":function($event){_vm.rci_resp_pergunta_c="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"2"}},[_vm._v(_vm._s(_vm.$t("191")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_desc_resp_pergunta_c),expression:"rci_desc_resp_pergunta_c"}],staticClass:"col-md-12",attrs:{"disabled":_vm.disabled,"maxlength":"200"},domProps:{"value":(_vm.rci_desc_resp_pergunta_c)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rci_desc_resp_pergunta_c=$event.target.value}}})])])])]):_vm._e(),_vm._v(" "),(_vm.questao=='oleo')?_c('div',{staticClass:"row",staticStyle:{"margin":"10px 0px"}},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.$t("192"))+"\n                                                        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_resp_pergunta_c),expression:"rci_resp_pergunta_c"}],attrs:{"disabled":_vm.disabled,"type":"radio","id":"1","value":"1"},domProps:{"checked":_vm._q(_vm.rci_resp_pergunta_c,"1")},on:{"change":function($event){_vm.rci_resp_pergunta_c="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"1"}},[_vm._v(_vm._s(_vm.$t("193")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_resp_pergunta_c),expression:"rci_resp_pergunta_c"}],attrs:{"disabled":_vm.disabled,"type":"radio","id":"2","value":"2"},domProps:{"checked":_vm._q(_vm.rci_resp_pergunta_c,"2")},on:{"change":function($event){_vm.rci_resp_pergunta_c="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"2"}},[_vm._v(_vm._s(_vm.$t("194")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_desc_resp_pergunta_c),expression:"rci_desc_resp_pergunta_c"}],staticClass:"col-md-12",attrs:{"disabled":_vm.disabled,"maxlength":"40"},domProps:{"value":(_vm.rci_desc_resp_pergunta_c)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rci_desc_resp_pergunta_c=$event.target.value}}})])])])]):_vm._e(),_vm._v(" "),(_vm.questao=='normal')?_c('div',{staticClass:"row",staticStyle:{"margin":"10px 0px"}},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                            "+_vm._s(_vm.number_d)+" - "+_vm._s(_vm.$t("195"))+"\n                                                        ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_resp_pergunta_d),expression:"rci_resp_pergunta_d"}],attrs:{"disabled":_vm.disabled,"type":"radio","id":"1","value":"1"},domProps:{"checked":_vm._q(_vm.rci_resp_pergunta_d,"1")},on:{"change":function($event){_vm.rci_resp_pergunta_d="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"peg_04_resp_01"}},[_vm._v(_vm._s(_vm.$t("196")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_resp_pergunta_d),expression:"rci_resp_pergunta_d"}],attrs:{"disabled":_vm.disabled,"type":"radio","id":"2","value":"2"},domProps:{"checked":_vm._q(_vm.rci_resp_pergunta_d,"2")},on:{"change":function($event){_vm.rci_resp_pergunta_d="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":"peg_04_resp_02"}},[_vm._v(_vm._s(_vm.$t("197")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_desc_resp_pergunta_d),expression:"rci_desc_resp_pergunta_d"}],staticClass:"col-md-12",attrs:{"disabled":_vm.disabled,"maxlength":"200"},domProps:{"value":(_vm.rci_desc_resp_pergunta_d)},on:{"input":function($event){if($event.target.composing){ return; }_vm.rci_desc_resp_pergunta_d=$event.target.value}}})])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"10px 0px"}},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v(_vm._s(_vm.number_e)+" -  "+_vm._s(_vm.$t("198")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('label',[_vm._v(_vm._s(_vm.$t("199"))+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.rci_currency),expression:"rci_currency"}],staticClass:"form-control",staticStyle:{"width":"230px!important"},attrs:{"disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.rci_currency=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.rci_currency_value),function(item){return _c('option',{domProps:{"value":item.value}},[_vm._v(_vm._s(item.name))])}))])]),_vm._v(" "),_c('br'),_vm._v(" "),(this.decimal == 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.$t("200")))]),_vm._v(" "),_c('money',_vm._b({staticClass:"form-control",attrs:{"disabled":_vm.disabled,"maxlength":"20"},model:{value:(_vm.rci_downtime),callback:function ($$v) {_vm.rci_downtime=$$v},expression:"rci_downtime"}},'money',_vm.money,false))],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.$t("201")))]),_vm._v(" "),_c('money',_vm._b({staticClass:"form-control",attrs:{"disabled":_vm.disabled,"maxlength":"20"},model:{value:(_vm.rci_secondary_damage),callback:function ($$v) {_vm.rci_secondary_damage=$$v},expression:"rci_secondary_damage"}},'money',_vm.money,false))],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.$t("202")))]),_vm._v(" "),_c('money',_vm._b({staticClass:"form-control",attrs:{"disabled":_vm.disabled,"maxlength":"20"},model:{value:(_vm.rci_preventive),callback:function ($$v) {_vm.rci_preventive=$$v},expression:"rci_preventive"}},'money',_vm.money,false))],1)]):_vm._e(),_vm._v(" "),(this.decimal == 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.$t("200")))]),_vm._v(" "),_c('money',_vm._b({staticClass:"form-control",attrs:{"disabled":_vm.disabled,"maxlength":"20"},model:{value:(_vm.rci_downtime),callback:function ($$v) {_vm.rci_downtime=$$v},expression:"rci_downtime"}},'money',_vm.money_virgula,false))],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.$t("201")))]),_vm._v(" "),_c('money',_vm._b({staticClass:"form-control",attrs:{"disabled":_vm.disabled,"maxlength":"20"},model:{value:(_vm.rci_secondary_damage),callback:function ($$v) {_vm.rci_secondary_damage=$$v},expression:"rci_secondary_damage"}},'money',_vm.money_virgula,false))],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.$t("202")))]),_vm._v(" "),_c('money',_vm._b({staticClass:"form-control",attrs:{"disabled":_vm.disabled,"maxlength":"20"},model:{value:(_vm.rci_preventive),callback:function ($$v) {_vm.rci_preventive=$$v},expression:"rci_preventive"}},'money',_vm.money_virgula,false))],1)]):_vm._e()])]),_vm._v(" "),(_vm.error.statusrci)?_c('span',{staticStyle:{"color":"red","font-size":"15px"}},[_vm._v(_vm._s(_vm.error.msgrci)),_c('br'),_c('br')]):_vm._e(),_vm._v(" "),(_vm.msg.statusrci)?_c('span',{staticStyle:{"font-size":"15px"}},[_vm._v(_vm._s(_vm.msg.msgrci)),_c('br'),_c('br')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row btns-prog"},[_c('button',{staticClass:"btn page-link btn-prog-rci",attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.saveRci()}}},[_vm._v(" "+_vm._s(_vm.$t("203")))])])]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"schedule-form",staticStyle:{"min-height":"350px","background":"#fff"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.active=='prescription')?_c('div',{staticClass:"form-wrapper"},[(_vm.active_pres == true)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                                "+_vm._s(_vm.$t("204"))+" \n                                                            ")]),_vm._v("\n                                                            "+_vm._s(_vm.created_by)+"\n                                                        ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                                "+_vm._s(_vm.$t("205"))+"\n                                                            ")]),_vm._v("\n                                                            "+_vm._s(_vm.creation_date)+"\n                                                        ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                                "+_vm._s(_vm.$t("206"))+"\n                                                            ")]),_vm._v("\n                                                            "+_vm._s(_vm.edited_by)+"\n                                                        ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                                "+_vm._s(_vm.$t("207"))+"\n                                                            ")]),_vm._v("\n                                                            "+_vm._s(_vm.last_updated)+"\n                                                        ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                                "+_vm._s(_vm.$t("208"))+":\n                                                            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[(_vm.status_prescription == 1)?_c('div',{staticStyle:{"color":"#ae242b","font-weight":"bold"}},[_vm._v("\n                                                                "+_vm._s(_vm.$t("209"))+"\n                                                            ")]):_vm._e(),_vm._v(" "),(_vm.status_prescription == 2)?_c('div',{staticStyle:{"color":"#24ae40","font-weight":"bold"}},[_vm._v("\n                                                                "+_vm._s(_vm.$t("210"))+"\n                                                            ")]):_vm._e(),_vm._v(" "),(_vm.status_prescription == 3)?_c('div',{staticStyle:{"color":"#d4bd2a","font-weight":"bold"}},[_vm._v("\n                                                                "+_vm._s(_vm.$t("211"))+"\n                                                            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                                "+_vm._s(_vm.$t("212"))+":\n                                                            ")]),_vm._v("\n                                                            "+_vm._s(_vm.notes_save)+"\n                                                        ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.list_file),function(file,key){return _c('div',{staticClass:"file-listing"},[(file.file_name)?_c('div',[_c('iframe',{attrs:{"src":_vm.link_prescription +file.id_prescription +'/'+ file.file_name,"name":"frame","id":"iframe_dr","frameborder":"0"}})]):_vm._e()])})],2):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"col-md-12 btn page-link-presc-del btn-prog-rci",attrs:{"disabled":_vm.disabled_del_presc},on:{"click":function($event){_vm.DeletePresc()}}},[_vm._v(_vm._s(_vm.$t("213")))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"col-md-12 btn page-link-presc btn-prog-rci",attrs:{"disabled":_vm.disabled_add_presc},on:{"click":function($event){_vm.addPresc()}}},[_vm._v(_vm._s(_vm.$t("214")))])])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.create_presc == true)?_c('div',{staticStyle:{"background":"#eee","padding":"10px 10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                                "+_vm._s(_vm.$t("215"))+"\n                                                            ")]),_vm._v("\n                                                            "+_vm._s(_vm.report_number)+"\n                                                        ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                                "+_vm._s(_vm.$t("216"))+"\n                                                            ")]),_vm._v("\n                                                            "+_vm._s(_vm.plant + ' / ' + _vm.area)+"\n                                                        ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                                "+_vm._s(_vm.$t("217"))+"\n                                                            ")]),_vm._v("\n                                                            "+_vm._s(_vm.technique)+"\n                                                        ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                                "+_vm._s(_vm.$t("218"))+":\n                                                            ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.presc_note),expression:"presc_note"}],staticClass:"col-md-12",attrs:{"maxlength":"200"},domProps:{"value":(_vm.presc_note)},on:{"input":function($event){if($event.target.composing){ return; }_vm.presc_note=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                                                                "+_vm._s(_vm.$t("219"))+" \n                                                            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"col-md-3 btn page-link btn-prog-rci",on:{"click":function($event){_vm.addFiles()}}},[_vm._v(_vm._s(_vm.$t("220")))])]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"30px"}},[_c('input',{ref:"files",attrs:{"type":"file","name":"files","id":"files","multiple":""},on:{"change":function($event){_vm.handleFilesUpload()}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},_vm._l((_vm.files),function(file,key){return _c('div',{staticClass:"file-listing"},[_vm._v("\n                                                            "+_vm._s(file.name)+" "),_c('span',{staticClass:"remove-file",on:{"click":function($event){_vm.removeFile( key )}}},[_vm._v(_vm._s(_vm.$t("221")))])])})),_vm._v(" "),_c('div',{staticClass:"col-md-12"},_vm._l((_vm.list_file),function(file,key){return (file.file_name)?_c('div',{staticClass:"file-listing"},[_vm._v("\n                                                                \n                                                            "+_vm._s(file.file_name)+" "),_c('span',{staticClass:"remove-file",on:{"click":function($event){_vm.removeFileSave( file.file_name, file.id_prescription )}}},[_vm._v(_vm._s(_vm.$t("221")))])]):_vm._e()})),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"30px"}},[_c('button',{staticClass:"col-md-12 btn page-link-presc btn-prog-rci",attrs:{"disabled":_vm.disabled_submit},on:{"click":function($event){_vm.submitFiles()}}},[_vm._v(_vm._s(_vm.$t("222")))])])])]):_vm._e()]):_vm._e()])],1)])])])])])])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oylM":
/***/ (function(module, exports) {

module.exports = {"10":"Notas de lançamento","11":"Monitoramento online","12":"Dados preditivos offline e online.","13":"OffLine","14":"Online","15":"Zona","16":"Plantas (BOPs, VOPs)","17":"Data","18":"Período","19":"Mais filtros","20":"Área","21":"Conjunto","22":"Equipamento","23":"Zona","24":"Plantas (BOPs, VOPs)","25":"Data","26":"Técnicas preditivas","27":"Pesquisar","28":"Apresenta o estado dos dados analisados.","29":"Alarme de falha (análise)","30":"Apresenta o estado dos dados analisados.","31":"Alarme de falha","32":"Apresenta a taxa de recorrência das intervenções agrupadas por período.","33":"Taxa de recorrência de intervenções","34":"Quantidade de relatórios executados no prazo | atrasado. O sistema mostra os relatórios atrasados pareto usando três períodos distintos.","35":"Execução","36":"Gráficos de comparação de Pareto.","37":"Gráficos de comparação - pontual | atrasado","38":"Gráficos de comparação por período - No horário | atrasado","39":"Gráficos de comparação de Pareto por período.","40":"Apresenta a taxa de recorrência das intervenções agrupadas por período.","41":"Taxa de recorrência de intervenções","42":"Quantidade de relatórios executados no prazo | atrasado. O sistema mostra os relatórios atrasados pareto usando três períodos distintos.","43":"Execução","44":"Gráficos de comparação de Pareto.","45":"Gráficos de comparação - pontual | atrasado","46":"Gráficos de comparação por período - No horário | atrasado","47":"Gráficos de comparação de Pareto por período.","48":"Alterar senha","49":"Usuário","50":"Senha real","51":"Nova senha","52":"Repita a nova senha","53":"Por favor, insira todos os campos!","54":"Por favor, a nova senha deve conter no mínimo 8 caracteres e no máximo 15 caracteres.","55":"A senha inserida não é igual à nova senha!","56":"Senha alterada com sucesso!","57":"Erro ao alterar a senha!","58":"Senha","59":"Atenção - Nome de usuário e senha incorretos!","60":"Adicionada coluna Data e Hora de Aprovação nas grades que mostram informações de relatórios;","61":"Ajustes nos gráficos, deixando apenas as iniciais das unidades;","62":"Ajustes no layout do gráfico de 'Disponibilidade de Dados';","63":"Escrever filtros para o usuário;","64":"Baixa de RCI;","65":"Correção da numeração das linhas de grade;","66":"Ajustes no layout do gráfico 'Disponibilidade do Sensor';","67":"Ajuda nos ajustes dos gráficos 'Modo de falha do sensor' e 'Status do sensor';","68":"Upload de prescrição;","69":"Novas colunas de feedback na grade do gráfico de planejamento;","70":"Bookmark no menu do processo ligando a etapa do processo com um 'grupo' de gráficos para acessar os gráficos mais rapidamente;","71":"Alterado o layout de apresentação dos gráficos para melhor visualização e distribuição das informações;","72":"Incluído no menu de PDFs para Semeq Pred + App;","73":"Adicionado botão de ajuda em cada gráfico;","74":"Filtros adicionados por Área / Máquina / Subconjunto na guia Off-line e On-line;","75":"Adicionado ao menu de vídeo e guia;","76":"Incluído o gráfico de prioridades principais na guia Online;","77":"Alterado o tamanho da fonte dos gráficos;","78":"Valores padrão alterados dos filtros da guia Online para a Data 2020 e o período de 3 meses;","79":"Texto de região alterado por zona;","80":"Título alterado dos gráficos online (ao vivo e 24 horas);","81":"Endereço do site alterado de abi.semeq.com.br para abinbev.semeq.com.br;","82":"Adicionado o ícone 'Estamos aqui pela cerveja';","83":"Adicionada Disponibilidade de Dados Gráficos (%) em Online;","84":"Adicionado gráfico% de disponibilidade de sensores on-line;","85":"Adicionado gráfico # Modo de falha de sensores em online;","86":"Mapa adicionado na guia Online;","87":"Filtro de grade;","88":"Filtro de zona;","89":"Adicionado botão para exibição de gráfico de bateria online;","90":"Log de login;","91":"Apresentação do processo Semeq;","92":"Matriz de criticidade;","93":"Gráficos de barras alterados para linhas;","94":"Rótulos de componentes alterados para subconjuntos;","95":"Rótulo de plantas alteradas para sites (BOPs, VOPs);","96":"Gráfico de status do ponto online removido;","97":"Exportar informações da grade para o arquivo .CSV;","98":"Menu com vídeo, guia e nota de lançamento;","99":"Criando um novo layout de sistema MySemeq;","100":"Informações de dados offline e online;","101":"Gráficos e mapas para apresentação da saúde da empresa;","102":"Filtros para melhor análise da saúde da empresa (Sites / Data / Período / Técnicas Preditivas);","103":"Informações de grades;","104":"Visualização de DR (offline e online);","105":"Ver e adicionar comentários (offline);","106":"Visualização da imagem do sensor (online);","107":"Pesquisa de Dados","108":"Alarme de falha","109":"Diagnóstico","110":"Análise da causa raiz","111":"Planejamento","112":"Execução","113":"Feedback","114":"O desempenho da taxa de falha dos sites (BOPs, VOPs). Este mapa é baseado na World Class Maintenance. Os valores entre 0 e 4,9% são bons para o WCM, entre 5 e 9,9 é típico e 10+ precisa de melhorias.","115":"Fórmula da taxa de falha:","116":"onde","117":"número de intervenções,","118":"número de alertas e","119":"ativos totais incluídos no Plano PdM.","120":"Rótulo anual","121":"mostra a média do ano e","122":"etiqueta acumulada","123":"mostra a média do período desde a data inicial do PdM.","124":"Esta tabela mapeia cada local / planta de acordo com o número de relatório de diagnóstico recorrente e a quantidade total de dias pendentes (relatórios abertos). Certifique-se de que os filtros na barra lateral esquerda estão ajustados de acordo com suas necessidades.","125":"Mapa de saúde","126":"Matriz de criticidade","127":"Taxa de falha:","128":"FALHAS:","129":"Pareto do valor total do laudo de diagnóstico executado e tardio.","130":"Backlog","131":"# RDP","132":"Fechado","133":"Atrasado","134":"A Taxa de Falha apresenta a média móvel dos últimos doze meses.","135":"Taxa de falha","136":"RDP's","137":"R1 - R2","138":"R3 +","139":"Mensal","140":"Média acumulada","141":"Taxa de falha de Pareto","142":"Pareto da taxa de recorrência das intervenções.","143":"Recorrência","144":"Apresenta os detalhes do defeito encontrado. Algum relatório de diagnóstico pode ter mais de um defeito / falha e é considerado na fórmula da taxa de falha.","145":"Exportar tudo","146":"Modos de falha previstos","147":"Grupo","148":"Falha","149":"Modos de falhas","150":"Apresenta o valor total do relatório de diagnóstico na linha do tempo agrupado por planejado, executado e pendente.","151":"Planejamento","152":"Gráfico em linha","153":"Gráfico na coluna","154":"Apresenta o pareto sobre os dados não lidos. Quando o usuário não consegue obter os dados, o sistema requer que digite o motivo para tal.","155":"Ignorado","156":"Apresenta o estado da amostragem de dados de acordo com os filtros selecionados na barra esquerda","157":"Levan. Dados","158":"Anterior","159":"Próximo","160":"Gerando arquivo .csv!","161":"RDP","162":"Feedback","163":"Prescrição","164":"Agenda","165":"PSM / W.O .:","166":"Número da nota","167":"Data da programação (dd / mm / aaaa):","168":"Motivo da programação:","169":"Cancelar","170":"Salvar","171":"#RDP:","172":"Planta / Área:","173":"Data de intervenção (dd / mm / aaaa):","174":"Tempo gasto na intervenção:","175":"Horas","176":"Minutos","177":"Tempo de inatividade do equipamento:","178":"Pessoa responsável pela intervenção:","179":"O defeito encontrado era igual ao defeito diagnosticado?","180":"Sim","181":"Não, não havia defeito","182":"Não, o defeito não corresponde ao diagnóstico. Descreva o defeito encontrado.","183":"1 - O lubrificante foi trocado conforme solicitado?","184":"Filtragem aplicada","185":"Não, motivo?","186":"A especificação do componente com defeito está totalmente correta? (No caso de rolamentos, é 2R, Z, ZZ, K,.) '","187":"Não. Qual é o correto?","188":"2 - A limpeza do sistema foi executada?","189":"Não. Por quê?","190":"A posição indicada do componente com defeito estava correta?","191":"Não. Qual é o correto?","192":"3 - Foi realizada alguma outra intervenção além da recomendada?","193":"Não","194":"Sim. O quê?","195":"Foi realizada alguma outra intervenção, além da recomendada?","196":"Não","197":"Sim. O quê?","198":"Qual é a estimativa de custo potencial evitado gerado por esta tarefa proativa?","199":"Selecione a moeda:","200":"Tempo de inatividade:","201":"Danos secundários:","202":"Trabalho preventivo evitado:","203":"Salvar","204":"Criado por:","205":"Data de criação:","206":"Editado por:","207":"Última atualização:","208":"Status","209":"PENDENTE","210":"EXECUTADO","211":"NÃO EXECUTADO","212":"Notas","213":"Excluir Prescrição","214":"Adicionar Prescrição","215":"RDP:","216":"Planta / Área:","217":"Técnica:","218":"Nota:","219":"Adicionar arquivos (inclua apenas arquivos PDF e sem caracteres especiais):","220":"Adicionar arquivos","221":"Remover Arquivo","222":"Salvar Prescrição","223":"Planejamento / Execução","224":"A Taxa de Falha apresenta a média móvel dos últimos doze meses.","225":"Taxa de falha","226":"ALARME DE PONTO (últimas 24 horas)","227":"Apresenta os detalhes sobre o defeito encontrado. Algum relatório de diagnóstico pode ter mais de um defeito / falha e é considerado na fórmula da taxa de falha.","228":"Exportar tudo","229":"Modos de falha previstos","230":"Grupo","231":"Falha","232":"Modos de falhas","233":"Apresenta o grupo de status atual dos gateways executando e offline.","234":"Status do gateway (ativo)","235":"Apresenta o valor total do relatório de diagnóstico na linha do tempo agrupado em planejado, executado e pendente.","236":"Planejamento","237":"Gráfico em linha","238":"Gráfico na coluna","239":"Status da bateria (ao vivo)","240":"Apresenta o status atual dos sensores agrupados por rodando e offline.","241":"A parte azul do gráfico (N / A) significa que os sensores foram instalados e ainda não leram nenhuma amostra.","242":"Status do sensor (ao vivo)","243":"Apresenta o estado dos dados analisados.","244":"Alarme de falha (ao vivo)","245":"Compreendendo os indicadores. Da esquerda para a direita:","246":"Quantidade de falhas detectadas de DRs gerados na planta no período selecionado.","247":"Pedidos resolvidos são a quantidade de feedbacks no período selecionado.","248":"MTFS é o tempo médio em dias para resolver uma anomalia.","249":"6m: 6 meses, YTD: Ano atual, 1a: 12 meses, Todos: desde o início.","250":"FALHAS DETEC. (Todos, 1a, 6m)","251":"PEDIDOS RESOL. (Todos, 1a, 6m)","252":"MTFS (DIAS) (Todos, 1a, 6m)","253":"FALHAS DETECTADAS","254":"PEDIDOS RESOLVIDOS","255":"MTFS","256":"Cada radar apresenta os principais modos de potencial de falha e a quantidade de ocorrências em cada entidade de acordo com a seleção do filtro.","257":"Dados históricos","258":"Gráficos de comparação","259":"Apresenta a disponibilidade de dados em porcentagem considerando o status do gateway e dos sensores.","260":"Disponibilidade de dados (%)","261":"Apresenta a disponibilidade de dados dos sensores calculando o número total de horas por mês.","262":"% Disponibilidade de Sensores","263":"Apresenta o gráfico de pareto considerando os motivos de cada sensor parar de funcionar.","264":"Bateria","265":"menos de 10%.","266":"Sem Sinal","267":"Bateria com mais de 10% e 3 dias sem comunicação","268":"Gateway","269":"Deve ser indicado pelo usuário.","270":"Fora da máquina","271":"Deve ser indicado pelo usuário ou sem amostras disponíveis até o momento.","272":"N / A","273":"Não há vínculo com o ponto (não instalado).","274":"Não instalado","275":"Não há vínculo com o ponto e não há data de entrega atualizada.","276":"# Modo de falha de sensores","277":"Apresenta as principais falhas de prioridade de cada maquinário. Esta lista deve ser verificada e alguma ação deve ser realizada.","278":"Prioridades principais","279":"Prioridades principais (últimas 24 horas)","280":"Compreendendo indicadores. Da esquerda para a direita:","281":"Quantidade de falhas detectadas de DRs gerados na planta no período selecionado.","282":"Pedidos resolvidos são a quantidade de feedbacks no período selecionado.","283":"MTFS é o tempo médio em dias para resolver uma anomalia.","284":"6m: 6 meses, YTD: Ano atual, 1a: 12 meses, Todos: desde o início.","285":"FALHAS DETEC. (Todos, 1a, 6m)","286":"PEDIDOS RESOL. (Todos, 1a, 6m)","287":"MTFS (DIAS) (Todos, 1a, 6m)","288":"Cada radar apresenta os principais modos de potencial de falha e a quantidade de ocorrências em cada entidade de acordo com a seleção do filtro.","289":"Dados históricos","290":"Gráficos de comparação","291":"Mapa de saúde online","292":"Selecione o idioma:","293":"Inglês","294":"Português","295":"Salvar","296":"Idioma salvo com sucesso!","297":"Pendente","298":"Programado","299":"RDP","300":"# Relatórios","301":"% Relatórios","302":"Relatórios","303":"No horário","304":"Atrasado","305":"Dias","306":"Normal","307":"Alerta","308":"Alarme","309":"N/A","310":"Planta","311":"Área","312":"Setor","313":"Equipamento","314":"Equipamento TAG","315":"Equipamento Tipo","316":"Conjunto","317":"Conjunto TAG","318":"Status","319":"Número RDP","320":"Aprovação Data/Hora","321":"Técnica","322":"Data","323":"RDP","324":"RCI","325":"Dias Pendentes","326":"Atraso","327":"Data de Prescrição","328":"Semana","329":"Moeda","330":"Tempo de inatividade","331":"Dano secundário","332":"Trabalho preventivo evitado","333":"Status Feedback","334":"Data da amostra","335":"Nível da bateria","336":"Versão Firmware","337":"BLE sinal","338":"Node","339":"Série","340":"Ponto","341":"Arquivo de prescrição excluído com sucesso!","342":"A prescrição com status EXECUTADO OU NÃO EXECUTADO não pode ser excluída!","343":"Prescrição salva com sucesso!","344":"Erro ao salvar prescrição!","345":"Inclua apenas arquivos PDF e nenhum caractere especial!","346":"Arquivo de prescrição excluído com sucesso!","347":"A prescrição com o status EXECUTADA OU NÃO EXECUTADA não pode ser excluída!","348":"MODOS DE FALHA PREDITOS","349":"Lista de modos de falha.","350":"EXECUÇÃO DE PLANEJAMENTO","351":"Lista de relatórios agrupada por status planejado, executado ou pendente.","352":"PULADO","353":"Razões para dados não medidos.","354":"PLANEJAMENTO","355":"Lista de relatórios agrupada por status planejado ou pendente.","356":"EXECUÇÃO","357":"Lista de relatórios.","358":"PRAZO DE EXECUÇÃO DO RELATÓRIO","359":"TAXA DE RECORRÊNCIA DE INTERVENÇÕES","360":"MODOS DE FALHA PREDITADOS (ONLINE)","361":"Lista de modos de falha.","362":"STATUS DO GATEWAY","363":"Lista de status do gateway.","364":"STATUS DA BATERIA","365":"Lista de status da bateria.","366":"STATUS DO SENSOR","367":"Lista de status do sensor (ao vivo).","368":"ALARME DE FALHA","369":"Lista de alarmes de falha.","370":"DISPONIBILIDADE DO SENSOR","371":"Lista de disponibilidade de sensores","372":"MODO DE FALHA DO SENSOR","373":"Lista de modos de falha de sensores","374":"PRINCIPAIS PRIORIDADES","375":"Lista de prioridades principais.","376":"TAXA DE INTERVENÇÕES DE RECORRÊNCIA","377":"Como adicionar um sensor","378":"Como preencher uma RDP","379":"Como trocar um sensor","380":"A migração dos sensores para a nova plataforma de monitoramento está em andamento. As zonas AFR, APAC, SAZ e NAZ já estão em estágio avançado — aguardando apenas a liberação das novas regras de firewall pela ABI. As zonas EUR e MAZ serão finalizadas em breve. Recomendamos que, a partir deste mês, entre em contato com seu gestor de contas para solicitar acesso ao novo dashboard.","381":"Importante: A plataforma atual será desativada até o final de julho de 2025. A API da versão legada também será descontinuada no mesmo período. Se você utiliza integrações com a API antiga, será necessário atualizar os endpoints e migrar para a nova API.","382":"Fechar","383":"Atenção: Migração para nova plataforma em andamento.","logout":"Sair","01":"Vídeo","02":"ABinBev Preditiva Online:","03":"Para embarcar na jornada rumo a 100% de confiabilidade, tecnologia para alcançar alto desempenho!","04":"Guia","05":"Análise da árvore de falhas - Lubrificação","06":"SEMEQ PdM Technologies","07":"Aplicativo Semeq AbInBev","08":"Manual de Instruções - Sistema de Monitoramento Online","09":"Linha Guia Global Pdm","10_1":"Idioma","20-1":"Setor","140_1":"Percentagem","153_1":"Planejamento","153_2":"Fechado","153_3":"Pendente","242_1":"Status da Bateria","242_2":"Enviando","242_3":"Parado","242_4":"Parado N / A","242_5":"Status do Sensor","modal.pesquisar":"OK","modal.filtro.pesquisa":"Filtro de pesquisa","notificationofdescontinuation":"Esta aplicação será descontinuada após o segundo semestre de 2025, para mais informações entre em contato com nosso suporte"}

/***/ }),

/***/ "pUs0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeatMapSensorAppointments_vue__ = __webpack_require__("kKi2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b756da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeatMapSensorAppointments_vue__ = __webpack_require__("iqgc");
function injectStyle (ssrContext) {
  __webpack_require__("y0zJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeatMapSensorAppointments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b756da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeatMapSensorAppointments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pZL1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pa/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskList_vue__ = __webpack_require__("bx0x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_094478c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskList_vue__ = __webpack_require__("whIq");
function injectStyle (ssrContext) {
  __webpack_require__("YcmF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_094478c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pe4m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pt_json__ = __webpack_require__("oylM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pt_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pt_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__en_json__ = __webpack_require__("yZm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__es_json__ = __webpack_require__("vnEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__es_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__es_json__);







__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var lang = localStorage.getItem('lang');
var locale = !lang ? 'en' : lang;

var messages = {
  pt: __WEBPACK_IMPORTED_MODULE_2__pt_json___default.a,
  en: __WEBPACK_IMPORTED_MODULE_3__en_json___default.a,
  es: __WEBPACK_IMPORTED_MODULE_4__es_json___default.a
};

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: locale,
  messages: messages
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),

/***/ "pfXf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      radios: {
        radio1: '1',
        radio2: '2',
        radio3: '2'
      },
      checkboxes: {
        first: false,
        second: false,
        a: false,
        b: false,
        c: false,
        unchecked: false,
        checked: true,
        disabledUnchecked: false,
        disabledChecked: true
      }
    };
  }
});

/***/ }),

/***/ "pk8m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bookmark_vue__ = __webpack_require__("BsmD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b35605e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bookmark_vue__ = __webpack_require__("Hozw");
function injectStyle (ssrContext) {
  __webpack_require__("MuMl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b35605e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bookmark_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b35605e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bookmark_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pnG7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "psw9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q+5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"div",class:[_vm.getSlideClass, {open:_vm.isOpen}],on:{"click":_vm.toggleDropDown}},[_vm._t("title",[_c('a',{staticClass:"dropdown-toggle",attrs:{"data-toggle":"dropdown","href":"javascript:void(0)"}},[_c('i',{class:_vm.icon}),_vm._v(" "),_c('p',{staticClass:"notification"},[_vm._v(_vm._s(_vm.title)+"\n        "),_c('b',{staticClass:"caret"})])])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_vm._t("default")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qAgR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qAvE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-circle-chart",attrs:{"data-background-color":_vm.color}},[_c('div',{staticClass:"card-header text-center"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{ref:"chart",staticClass:"chart-circle",attrs:{"data-percent":_vm.percentage}},[_vm._v(_vm._s(_vm.percentage)+"%")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qBcI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fullcalendar__ = __webpack_require__("olwm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_fullcalendar__);









__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default.a);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'charts',
    props: {
        online: {
            type: Boolean
        }
    },
    components: {
        Help: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__["a" /* default */]
    },
    data: function data() {
        return {
            titleChart: this.$t("143"),
            tableData: [],
            chartOptions: {
                chart: {
                    type: 'column',
                    backgroundColor: 'rgba(0,0,0,0)',
                    style: {
                        fontFamily: '\'Unica One\', sans-serif'
                    },
                    plotBorderColor: '#606063'
                },
                title: {
                    text: '',
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase',
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }
                },
                subtitle: {
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase'
                    }
                },
                xAxis: {
                    categories: [],
                    crosshair: true,
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        },
                        overflow: false
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    title: {
                        style: {
                            color: '#A0A0A3'
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: this.$t("131"),
                        style: {
                            color: '#A0A0A3',
                            fontSize: '12px'
                        }
                    },
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    tickWidth: 1
                },
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    },
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y} </b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true,
                            color: '#F0F0F3',
                            style: {
                                fontSize: '13px'
                            }
                        },
                        marker: {
                            lineColor: '#333'
                        }
                    },
                    boxplot: {
                        fillColor: '#505053'
                    },
                    candlestick: {
                        lineColor: 'white'
                    },
                    errorbar: {
                        color: 'white'
                    },
                    column: {
                        pointPadding: 0.1,
                        borderWidth: 0
                    }
                },
                legend: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    itemStyle: {
                        color: '#E0E0E3'
                    },
                    itemHoverStyle: {
                        color: '#FFF'
                    },
                    itemHiddenStyle: {
                        color: '#606063'
                    },
                    title: {
                        style: {
                            color: '#C0C0C0',
                            fontSize: '12px'
                        }
                    }
                },
                labels: {
                    style: {
                        color: '#707073'
                    }
                },
                drilldown: {
                    activeAxisLabelStyle: {
                        color: '#F0F0F3'
                    },
                    activeDataLabelStyle: {
                        color: '#F0F0F3'
                    }
                },
                navigation: {
                    buttonOptions: {
                        symbolStroke: '#DDDDDD',
                        theme: {
                            fill: '#505053'
                        }
                    }
                },

                rangeSelector: {
                    buttonTheme: {
                        fill: '#505053',
                        stroke: '#000000',
                        style: {
                            color: '#CCC'
                        },
                        states: {
                            hover: {
                                fill: '#707073',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            },
                            select: {
                                fill: '#000003',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    },
                    inputBoxBorderColor: '#505053',
                    inputStyle: {
                        backgroundColor: '#333',
                        color: 'silver'
                    },
                    labelStyle: {
                        color: 'silver'
                    }
                },
                navigator: {
                    handles: {
                        backgroundColor: '#666',
                        borderColor: '#AAA'
                    },
                    outlineColor: '#CCC',
                    maskFill: 'rgba(255,255,255,0.1)',
                    series: {
                        color: '#7798BF',
                        lineColor: '#A6C7ED'
                    },
                    xAxis: {
                        gridLineColor: '#505053'
                    }
                },
                scrollbar: {
                    barBackgroundColor: '#808083',
                    barBorderColor: '#808083',
                    buttonArrowColor: '#CCC',
                    buttonBackgroundColor: '#606063',
                    buttonBorderColor: '#606063',
                    rifleColor: '#FFF',
                    trackBackgroundColor: '#404043',
                    trackBorderColor: '#404043'
                },
                series: [{
                    name: this.$t("143"),
                    color: '#F45B5B',
                    data: []
                }],
                exporting: { enabled: false },
                credits: {
                    enabled: false
                },
                loading: {
                    labelStyle: {
                        color: 'black',
                        textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
                    },
                    style: {
                        backgroundColor: 'none',
                        opacity: 1
                    }
                }

            }
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4__utils_mixin__["a" /* default */]],
    methods: {
        getData: function getData() {
            var API = "https://api.semeq.com.br/";
            var ENDPOINT = 'v1/mysemeq-ambev/get-pareto-reincidencia';

            var filters = {};
            if (this.online) {
                filters = this.filtersOn;
            } else {
                filters = this.filters;
            }

            filters['online'] = 0;
            if (this.online) {
                filters['online'] = 1;
                filters['plant'] = filters['planta'];
            }

            this.$refs.chart.chart.showLoading();

            var self = this;
            __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ENDPOINT, params: filters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
                self.tableData = resp.data;
                self.$refs.chart.chart.hideLoading();
            }).catch(function (err) {
                self.ApiErrorHandler(self, error.response.data.status_code);
                self.$refs.chart.chart.showLoading('Error');
            });
        },
        setChartData: function setChartData() {
            var self = this;
            var res = self.tableData;

            self.chartOptions.xAxis.categories = [];
            self.chartOptions.series[0].data = [];
            if (res) {
                res.forEach(function (it) {
                    self.chartOptions.xAxis.categories.push(it[0]);
                    self.chartOptions.series[0].data.push(it[1]);
                });
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filters', 'filtersOn'])),
    watch: {
        filters: function filters(newValue) {
            this.getData();
        },
        filtersOn: function filtersOn(newValue) {
            this.getData();
        },
        tableData: function tableData() {
            this.setChartData();
        }
    }
});

/***/ }),

/***/ "qE7L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");









__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default.a);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'charts',
    components: {
        Help: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__["a" /* default */]
    },
    data: function data() {
        return {
            titleChart: this.$t("151"),
            tableData: [],
            type: 'line',
            chartOptions: {
                colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8', '#dd6b7f', '#0984e3', '#ffeaa7', '#e84393', '#55efc4', '#636e72', '#ff7675', '#f1c40f', '#34495e'],
                chart: {
                    type: 'line',
                    backgroundColor: 'rgba(0,0,0,0)',
                    style: {
                        fontFamily: '\'Unica One\', sans-serif'
                    },
                    plotBorderColor: '#606063'
                },
                title: {
                    text: '',
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase',
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }
                },
                subtitle: {
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase'
                    }
                },
                xAxis: {
                    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    crosshair: true,
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    title: {
                        style: {
                            color: '#A0A0A3'
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: this.$t("131"),
                        style: {
                            color: '#A0A0A3',
                            fontSize: '12px'
                        }
                    },
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    tickWidth: 1
                },
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    },
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y} </b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true,
                            color: '#F0F0F3',
                            style: {
                                fontSize: '13px'
                            }
                        },
                        marker: {
                            lineColor: '#333'
                        },
                        events: {
                            click: this.loadGrid
                        },
                        cursor: 'pointer'
                    },
                    boxplot: {
                        fillColor: '#505053'
                    },
                    candlestick: {
                        lineColor: 'white'
                    },
                    errorbar: {
                        color: 'white'
                    },
                    column: {
                        pointPadding: 0.1,
                        borderWidth: 0
                    }
                },
                legend: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    itemStyle: {
                        color: '#E0E0E3'
                    },
                    itemHoverStyle: {
                        color: '#FFF'
                    },
                    itemHiddenStyle: {
                        color: '#606063'
                    },
                    title: {
                        style: {
                            color: '#C0C0C0',
                            fontSize: '12px'
                        }
                    }
                },
                labels: {
                    style: {
                        color: '#707073'
                    }
                },
                drilldown: {
                    activeAxisLabelStyle: {
                        color: '#F0F0F3'
                    },
                    activeDataLabelStyle: {
                        color: '#F0F0F3'
                    }
                },
                navigation: {
                    buttonOptions: {
                        symbolStroke: '#DDDDDD',
                        theme: {
                            fill: '#505053'
                        }
                    }
                },

                rangeSelector: {
                    buttonTheme: {
                        fill: '#505053',
                        stroke: '#000000',
                        style: {
                            color: '#CCC'
                        },
                        states: {
                            hover: {
                                fill: '#707073',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            },
                            select: {
                                fill: '#000003',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    },
                    inputBoxBorderColor: '#505053',
                    inputStyle: {
                        backgroundColor: '#333',
                        color: 'silver'
                    },
                    labelStyle: {
                        color: 'silver'
                    }
                },
                navigator: {
                    handles: {
                        backgroundColor: '#666',
                        borderColor: '#AAA'
                    },
                    outlineColor: '#CCC',
                    maskFill: 'rgba(255,255,255,0.1)',
                    series: {
                        color: '#7798BF',
                        lineColor: '#A6C7ED'
                    },
                    xAxis: {
                        gridLineColor: '#505053'
                    }
                },
                scrollbar: {
                    barBackgroundColor: '#808083',
                    barBorderColor: '#808083',
                    buttonArrowColor: '#CCC',
                    buttonBackgroundColor: '#606063',
                    buttonBorderColor: '#606063',
                    rifleColor: '#FFF',
                    trackBackgroundColor: '#404043',
                    trackBorderColor: '#404043'
                },
                series: [{
                    name: this.$t("153_1"),
                    color: '#E4D354',
                    data: []

                }, {
                    name: this.$t("153_2"),
                    color: '#90ED7D',
                    data: []

                }, {
                    name: this.$t("153_3"),
                    color: '#F45B5B',
                    data: []

                }],
                exporting: { enabled: false },
                credits: {
                    enabled: false
                },
                loading: {
                    labelStyle: {
                        color: 'black',
                        textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
                    },
                    style: {
                        backgroundColor: 'none',
                        opacity: 1
                    }
                }

            } };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4__utils_mixin__["a" /* default */]],
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['changeGrid']), {
        loadGrid: function loadGrid(event) {

            var evento = event.point.series.name;
            var filtro = '';
            if (evento == 'Planejamento') {
                filtro = 'Planning';
            }
            if (evento == 'Fechado') {
                filtro = 'Closed';
            }
            if (evento == 'Pendente') {
                filtro = 'Pending';
            }
            var filter = !filtro ? event.point.series.name : filtro;

            var status = filter;

            var date = event.point.category;
            var point_name = event.point.series.name;
            var NAME_CHART = this.$t("350") + ' - ' + point_name.toUpperCase();

            var ENDPOINT = 'v1/mysemeq-ambev/get-reports?plant=' + this.filters.plant + '&region=' + this.filters.region + '&status=' + status + '&technique=' + this.filters.technique + '&year=' + date + '&area=' + this.filters.area + '&machine=' + this.filters.machine + '&component=' + this.filters.component + '&sector=' + this.filters.sector;

            var grid = {
                totalDados: event.point.y,
                title: status,
                url: ENDPOINT,
                name_chart: NAME_CHART,
                columns: {
                    "rows": '',
                    "plant": this.$t("310"),
                    "area": this.$t("311"),
                    "sector": this.$t("312"),
                    "component": this.$t("313"),
                    "component_tag": this.$t("314"),
                    "component_type_en": this.$t("315"),
                    "machine": this.$t("316"),
                    "machine_tag": this.$t("317"),
                    "technique_en": this.$t("321"),
                    "report_number": this.$t("319"),
                    "approved_datetime": this.$t("320"),
                    "link": this.$t("323"),
                    "link_rci": this.$t("324"),
                    "pending_days": this.$t("325"),
                    "delay": this.$t("326"),
                    "prescription_created_datePtime": this.$t("327"),
                    "week": this.$t("328"),
                    "currency": this.$t("329"),
                    "downtime": this.$t("330"),
                    "sec_damage": this.$t("331"),
                    "work_avoided": this.$t("332")
                },
                show: true,
                titleHelp: 'Grid - ' + this.$t("350"),
                txtHelp: this.$t("351")
            };

            if (this.filters.plant) {
                grid.title += ' - ' + this.filters.plant_name;
                delete grid.columns['plant'];
            } else if (this.filters.region) {
                grid.title += ' - ' + this.filters.region;
            }

            this.changeGrid(grid);
        },
        getData: function getData() {

            if (this.filters.area || this.filters.machine || this.filters.component || this.filters.sector) {
                var API = "https://api.semeq.com.br/";
                var ENDPOINT = 'v1/mysemeq-ambev/get-reports-chart-filter';

                var self = this;

                this.$refs.chart.chart.showLoading();

                __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
                    self.tableData = resp.data;
                    self.$refs.chart.chart.hideLoading();
                }).catch(function (err) {
                    self.ApiErrorHandler(self, error.response.data.status_code);
                    self.$refs.chart.chart.showLoading('Error');
                });
            } else {

                var _API = "https://api.semeq.com.br/";
                var _ENDPOINT = 'v1/mysemeq-ambev/get-reports-chart';
                var _self = this;

                this.$refs.chart.chart.showLoading();

                __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: _API + _ENDPOINT, params: this.filters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
                    _self.tableData = resp.data;
                    _self.$refs.chart.chart.hideLoading();
                }).catch(function (err) {
                    _self.ApiErrorHandler(_self, error.response.data.status_code);
                    _self.$refs.chart.chart.showLoading('Error');
                });
            }
        },
        setChartData: function setChartData() {
            var self = this;
            var res = self.tableData;

            self.chartOptions.xAxis.categories = [];
            self.chartOptions.series[0].data = [];
            self.chartOptions.series[1].data = [];
            self.chartOptions.series[2].data = [];
            if (res) {
                res.forEach(function (it) {
                    self.chartOptions.xAxis.categories.push(it.ref_date);
                    self.chartOptions.series[0].data.push(it.new);
                    self.chartOptions.series[1].data.push(it.feedback);
                    self.chartOptions.series[2].data.push(it.pending);
                });
            }
        },
        changeTypeChartLine: function changeTypeChartLine() {
            var self = this;
            self.chartOptions.chart.type = 'line';
        },
        changeTypeChartColumn: function changeTypeChartColumn() {
            var self = this;
            self.chartOptions.chart.type = 'column';
        }
    }),
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filters'])),
    watch: {
        filters: function filters(newValue) {
            this.getData();
        },
        tableData: function tableData() {
            this.setChartData();
        }
    }
});

/***/ }),

/***/ "qQLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"},on:{"click":_vm.toggleNavbar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/admin"}},[_vm._v("Paper Dashboard PRO")])],1),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/admin"}},[_vm._v("\n          Dashboard\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"full-page lock-page",staticStyle:{"background-image":"url('static/img/background/background-5.png')"},attrs:{"data-color":"green","data-image":"static/img/background/background-5.png"}},[_c('div',{staticClass:"content"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card card-lock"},[_c('div',{staticClass:"author"},[_c('img',{staticClass:"avatar",attrs:{"src":"static/img/faces/face-2.jpg","alt":"..."}})]),_vm._v(" "),_c('h4',[_vm._v("Chet Faker")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Enter Password"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-wd",attrs:{"type":"button"}},[_vm._v("Unlock")])])])]),_vm._v(" "),_c('footer',{staticClass:"footer footer-transparent"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_vm._v("\n            © Coded with\n            "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by\n            "),_c('a',{attrs:{"href":"https://github.com/cristijora","target":"_blank"}},[_vm._v("Cristi Jora")]),_vm._v(".\n            Designed by "),_c('a',{attrs:{"href":"https://www.creative-tim.com/?ref=pdf-vuejs","target":"_blank"}},[_vm._v("Creative Tim")]),_vm._v(".\n          ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qbTh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h4',[_c('small',[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_vm._v(" "+_vm._s(_vm.plant)+" ")]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qeuK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['website', 'language', 'bootstrapVersion'])),
  data: function data() {
    return {
      model: {
        website: '',
        frameworkType: '',
        language: '',
        bootstrapVersion: '',
        price: ''
      },
      modelValidations: {
        website: {
          url: true,
          required: true
        },
        language: {
          required: true
        },
        bootstrapVersion: {
          required: true
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    }
  }
});

/***/ }),

/***/ "qhRV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r15C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartBacklog_vue__ = __webpack_require__("RfKX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77fbbbf7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartBacklog_vue__ = __webpack_require__("TUjX");
function injectStyle (ssrContext) {
  __webpack_require__("N7DR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77fbbbf7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartBacklog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77fbbbf7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartBacklog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r2+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('form',{attrs:{"method":"#","action":"#"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p-checkbox',[_vm._v("Subscribe to newsletter")]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"}},[_vm._v("Submit")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('form',{staticClass:"form-horizontal"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3"}),_vm._v(" "),_c('p-checkbox',{staticClass:"col-md-9"},[_vm._v("Remember me")])],1)]),_vm._v(" "),_vm._m(6)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',{staticClass:"form-horizontal",attrs:{"method":"get","action":"/"}},[_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Checkboxes and radios")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('p-checkbox',{model:{value:(_vm.checkboxes.first),callback:function ($$v) {_vm.$set(_vm.checkboxes, "first", $$v)},expression:"checkboxes.first"}},[_vm._v("First checkbox")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.checkboxes.second),callback:function ($$v) {_vm.$set(_vm.checkboxes, "second", $$v)},expression:"checkboxes.second"}},[_vm._v("Second checkbox")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"1"},model:{value:(_vm.radios.radio1),callback:function ($$v) {_vm.$set(_vm.radios, "radio1", $$v)},expression:"radios.radio1"}},[_vm._v("First Radio")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"2"},model:{value:(_vm.radios.radio1),callback:function ($$v) {_vm.$set(_vm.radios, "radio1", $$v)},expression:"radios.radio1"}},[_vm._v("Second Radio")])],1)])]),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Inline checkboxes")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('p-checkbox',{attrs:{"inline":true},model:{value:(_vm.checkboxes.a),callback:function ($$v) {_vm.$set(_vm.checkboxes, "a", $$v)},expression:"checkboxes.a"}},[_vm._v("a")]),_vm._v(" "),_c('p-checkbox',{attrs:{"inline":true},model:{value:(_vm.checkboxes.b),callback:function ($$v) {_vm.$set(_vm.checkboxes, "b", $$v)},expression:"checkboxes.b"}},[_vm._v("b")]),_vm._v(" "),_c('p-checkbox',{attrs:{"inline":true},model:{value:(_vm.checkboxes.c),callback:function ($$v) {_vm.$set(_vm.checkboxes, "c", $$v)},expression:"checkboxes.c"}},[_vm._v("c")])],1)])]),_vm._v(" "),_c('fieldset',[_c('legend',[_vm._v("Input Variants")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Custom Checkboxes & radios")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-sm-offset-1"},[_c('p-checkbox',{model:{value:(_vm.checkboxes.unchecked),callback:function ($$v) {_vm.$set(_vm.checkboxes, "unchecked", $$v)},expression:"checkboxes.unchecked"}},[_vm._v("Unchecked")]),_vm._v(" "),_c('p-checkbox',{model:{value:(_vm.checkboxes.checked),callback:function ($$v) {_vm.$set(_vm.checkboxes, "checked", $$v)},expression:"checkboxes.checked"}},[_vm._v("Unchecked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":true},model:{value:(_vm.checkboxes.disabledUnchecked),callback:function ($$v) {_vm.$set(_vm.checkboxes, "disabledUnchecked", $$v)},expression:"checkboxes.disabledUnchecked"}},[_vm._v("Disabled unchecked")]),_vm._v(" "),_c('p-checkbox',{attrs:{"disabled":true},model:{value:(_vm.checkboxes.disabledChecked),callback:function ($$v) {_vm.$set(_vm.checkboxes, "disabledChecked", $$v)},expression:"checkboxes.disabledChecked"}},[_vm._v("Disabled checked")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('p-radio',{attrs:{"label":"1"},model:{value:(_vm.radios.radio2),callback:function ($$v) {_vm.$set(_vm.radios, "radio2", $$v)},expression:"radios.radio2"}},[_vm._v("Radio is off")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"2"},model:{value:(_vm.radios.radio2),callback:function ($$v) {_vm.$set(_vm.radios, "radio2", $$v)},expression:"radios.radio2"}},[_vm._v("Radio is on")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"1","disabled":true},model:{value:(_vm.radios.radio2),callback:function ($$v) {_vm.$set(_vm.radios, "radio2", $$v)},expression:"radios.radio2"}},[_vm._v("Disabled radio is off")]),_vm._v(" "),_c('p-radio',{attrs:{"label":"2","disabled":true},model:{value:(_vm.radios.radio2),callback:function ($$v) {_vm.$set(_vm.radios, "radio2", $$v)},expression:"radios.radio2"}},[_vm._v("Disabled radio is on")])],1)])]),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n            Stacked Form\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email address")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Enter email"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n            Horizontal Form\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3 control-label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"Email"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3 control-label"},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('button',{staticClass:"btn btn-fill btn-info",attrs:{"type":"submit"}},[_vm._v("\n                Sign in\n              ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Form Elements")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("With help")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text"}}),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("A block of help text that breaks onto a new line.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"password","name":"password"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Placeholder")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"placeholder"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Disabled")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Disabled input here...","disabled":""}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Static control")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('p',{staticClass:"form-control-static"},[_vm._v("hello@creative-tim.com")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group has-success"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Input with success")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","value":"Success"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group has-error"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Input with error")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","value":"Error"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group column-sizing"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Column sizing")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":".col-md-3"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":".col-md-4"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":".col-md-5"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Input groups")]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v("@")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","placeholder":"Username"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text"}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(".00")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v("$")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text"}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(".00")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label"},[_vm._v("Textarea")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('textarea',{staticClass:"form-control",attrs:{"placeholder":"Here can be your nice text","rows":"3"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r9NN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rP9/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserProfile_EditProfileForm_vue__ = __webpack_require__("9597");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserProfile_UserCard_vue__ = __webpack_require__("v98p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserProfile_MembersCard_vue__ = __webpack_require__("4qt1");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    EditProfileForm: __WEBPACK_IMPORTED_MODULE_0__UserProfile_EditProfileForm_vue__["a" /* default */],
    UserCard: __WEBPACK_IMPORTED_MODULE_1__UserProfile_UserCard_vue__["a" /* default */],
    MembersCard: __WEBPACK_IMPORTED_MODULE_2__UserProfile_MembersCard_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "rReu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ribu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SweetAlert_vue__ = __webpack_require__("/ZBZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76315f86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SweetAlert_vue__ = __webpack_require__("H2oj");
function injectStyle (ssrContext) {
  __webpack_require__("d8qD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SweetAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76315f86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SweetAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rmvi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showModal)?_c('div',{attrs:{"id":"modal-container","tabindex":"0"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }_vm.showModal = false}}},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-dialog d-flex flex-column align-content-center",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"z-index":"10"}},[_c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"col-01"},[_c('button',{staticClass:"bt-help",on:{"click":function($event){_vm.btHelp()}}},[_c('i',{staticClass:"icon-help ti-help-alt"})]),_vm._v(" "),_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),(_vm.export_csv != false)?_c('div',{staticClass:"col-02"},[_c('button',{staticClass:"csv-bt",attrs:{"type":"button","aria-label":"CSV"},on:{"click":function($event){_vm.btCSV()}}},[_c('span',{staticClass:"ti-file"},[_vm._v(" CSV")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('button',{ref:"closer",staticClass:"close",attrs:{"type":"button","id":"close-button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.showModal = false}}},[_c('span',{staticClass:"ti-close"})])])]),_vm._v(" "),_c('div',{staticClass:"modal-body overflow-auto",staticStyle:{"width":"100%"}},[(_vm.data.length != 0)?_c('table',{staticClass:"table"},[_c('thead',[_c('tr',_vm._l((_vm.columns),function(value,key){return _c('th',{key:key},[(key != 'link' && key != 'link_rci' && key != 'id_planta')?_c('div',[_c('p',{staticClass:"table-header",class:key != 'rdps' ? 'cursor-pointer': '',on:{"click":function($event){key != 'rdps' && key != 'approved_datetime' ? _vm.sortBy(value[1] || key) : null}}},[_vm._v("\n                                                        "+_vm._s(_vm._f("capitalize")(value[0]))+"\n                                                        "),((_vm.sortKey == key || _vm.sortKey == value[1]) && key != 'rdps')?_c('span',{staticClass:"arrow",class:(_vm.sortKey == key || _vm.sortKey == value[1]) ? _vm.order: ''}):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),(key != 'rows')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sortFilters[value[1] || key]),expression:"sortFilters[value[1] || key]"}],staticClass:"table-input",attrs:{"disabled":(key == 'rdps' || key == 'status' || key == 'approved_datetime'),"type":"text"},domProps:{"value":(_vm.sortFilters[value[1] || key])},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.filterGrid()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sortFilters, value[1] || key, $event.target.value)}}}):_vm._e()]):_vm._e()])}))]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredData),function(entry){return _c('tr',_vm._l((_vm.columns),function(value,key){return _c('td',{key:key},[(key == 'report_number' && entry[key])?_c('div',[_c('div',{staticClass:"href",on:{"click":function($event){_vm.changeModal({'link_rdp': entry['link'], 'link_rci': entry['link_rci']})}}},[_vm._v(_vm._s(_vm._f("handleNull")(entry[key])))])]):(key == 'status' && entry[key])?_c('div',[_c('div',{class:'icon-status-'+entry[key]})]):(key == 'serie' && entry[key])?_c('div',[(entry['id_planta'] == null)?_c('div',[_c('div',{staticClass:"href",on:{"click":function($event){_vm.changeModalPhoto({'link_photo': 'https://s3-sa-east-1.amazonaws.com/semeq-repo/img/'+_vm.planta+'/sensor/'+entry[key]+'.jpg', 'sensor_photo': entry[key] })}}},[_vm._v(_vm._s(_vm._f("handleNull")(entry[key])))]),_c('br')]):_vm._e(),_vm._v(" "),(entry['id_planta'] != null)?_c('div',[_c('div',{staticClass:"href",on:{"click":function($event){_vm.changeModalPhoto({'link_photo': 'https://s3-sa-east-1.amazonaws.com/semeq-repo/img/'+entry['id_planta']+'/sensor/'+entry[key]+'.jpg', 'sensor_photo': entry[key] })}}},[_vm._v(_vm._s(_vm._f("handleNull")(entry[key])))]),_c('br')]):_vm._e()]):(key == 'rdps' && entry[key])?_c('div',_vm._l((entry[key]),function(v,k){return _c('div',{key:k},[_c('div',{staticClass:"href",on:{"click":function($event){_vm.changeModal({'link_rdp': _vm.http_to_https(entry[key][k].link)+'&lang=EN', 'link_rci': entry[key][k].rdp, 'id_rdp': entry[key][k].rdp, 'technique_id': '2' , 'report_number': entry[key][k].number , 'plant': entry['planta'] , 'area': entry['area'] })}}},[_vm._v(_vm._s(_vm._f("handleNull")(entry[key][k].number))+" ")]),_c('br')])})):(key == 'approved_datetime' && entry['rdps'])?_c('div',_vm._l((entry['rdps']),function(v,k){return _c('div',{key:"approved_datetime" + k},[_vm._v("\n                                                "+_vm._s(_vm._f("handleNull")(entry['rdps'][k].approved_datetime))+"\n                                            ")])})):(((key != 'link') && (key != 'link_rci') && (key != 'id_planta')))?_c('div',[_vm._v("\n                                            "+_vm._s(_vm._f("handleNull")(entry[key]))+"\n                                        ")]):_vm._e()])}))}))]):_vm._e(),_vm._v(" "),(_vm.data.length == 0)?_c('div',{staticClass:"d-flex justify-content-center align-content-middle",attrs:{"id":"spinner-loading"}},[_c('div',{staticClass:"loader"})]):_vm._e()])])])])])])],1):_vm._e(),_vm._v(" "),(_vm.showModalFile)?_c('div',{attrs:{"id":"modal-container","tabindex":"1"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }_vm.showModalFile = false}}},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-alert modal-dialog d-flex flex-column align-content-center",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"z-index":"10"}},[_c('div',{staticClass:"modal-header"},[_vm._v("\n                                                                 \n                            ")]),_vm._v(" "),_c('div',{staticClass:"modal-body overflow-auto",staticStyle:{"color":"#eee","font-weight":"bold","height":"47px","padding":"5px 0px"}},[_c('div',{staticClass:"loader loader-div"}),_vm._v(" "),_c('div',{staticClass:"txt-loader"},[_vm._v(" "+_vm._s(_vm.$t("160")))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._v("\n                                 \n                            ")])])])])])])],1):_vm._e(),_vm._v(" "),(_vm.showModalHelp)?_c('div',{attrs:{"id":"modal-container","tabindex":"1"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }_vm.showModalHelp = false}}},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-alert modal-dialog d-flex flex-column align-content-center",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"z-index":"10"}},[_c('div',{staticClass:"modal-header header-help"},[_c('div',{staticClass:"col-01"},[_c('i',{staticClass:"icon-help ti-help-alt"}),_vm._v(" "),_c('span',{staticClass:"modal-title-help"},[_vm._v(_vm._s(_vm.titleHelp))])]),_vm._v(" "),_c('div',{staticClass:"col-02"},[_vm._v("\n                                     \n                                ")]),_vm._v(" "),_c('div',{staticClass:"col-03"},[_c('button',{ref:"closer",staticClass:"close-help",attrs:{"type":"button","id":"close-button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.showModalHelp = false}}},[_c('span',{staticClass:"ti-close"})])])]),_vm._v(" "),_c('div',{staticClass:"modal-body overflow-auto body-help"},[_vm._v("\n                                "+_vm._s(_vm.txtHelp)+"\n                            ")])])])])])])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ruaE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'nav-open': _vm.$sidebar.showSidebar}},[_c('grid'),_vm._v(" "),_c('gridOnline'),_vm._v(" "),_c('RDPModal'),_vm._v(" "),_c('PhotoModal'),_vm._v(" "),_c('notifications',{attrs:{"transition-name":"notification-list","transition-mode":"out-in"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('keep-alive',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s/Eg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sMOY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__("wfBj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6f46be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__("G/W4");
function injectStyle (ssrContext) {
  __webpack_require__("bOnU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6f46be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sPYd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-down',
  props: {
    title: String,
    icon: String,
    slide: {
      type: String,
      default: 'down'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    getSlideClass: function getSlideClass() {
      return this.slide === 'down' ? 'dropdown' : 'dropup';
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    }
  }
});

/***/ }),

/***/ "sTXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_collapse_item_css__ = __webpack_require__("XPMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_collapse_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_collapse_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item__ = __webpack_require__("uEG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_css__ = __webpack_require__("8mNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_collapse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse__ = __webpack_require__("YnkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs__);











__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_collapse___default.a);
__WEBPACK_IMPORTED_MODULE_5_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_collapse_item___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeName: 'first'
    };
  }
});

/***/ }),

/***/ "sbDz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Progress_vue__ = __webpack_require__("Z450");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a5b77cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Progress_vue__ = __webpack_require__("+WI1");
function injectStyle (ssrContext) {
  __webpack_require__("gP6t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Progress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a5b77cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Progress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sk1x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "skQX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts_vue__ = __webpack_require__("jhCd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_highcharts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Maps_MapChart__ = __webpack_require__("fotD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Charts_ReportChart__ = __webpack_require__("EEKh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Charts_DataSurveyChart__ = __webpack_require__("Qfw/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Charts_ChartsSkipped__ = __webpack_require__("IcX6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Charts_chartsReport__ = __webpack_require__("JBQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Charts_chartsDefects__ = __webpack_require__("bUm6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Components_Bookmark__ = __webpack_require__("pk8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Components_ExecutionIndicators__ = __webpack_require__("ax/O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Charts_Donut__ = __webpack_require__("Bmqj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Components_ReincidenciaIndicator__ = __webpack_require__("7j/V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Charts_ReincidenciaChart__ = __webpack_require__("JukQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Charts_ExecutionChart__ = __webpack_require__("M76F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Charts_DonutExecution__ = __webpack_require__("oLj+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Charts_ExecutionChartTotal__ = __webpack_require__("m8hd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Charts_ChartFailure__ = __webpack_require__("Alxq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Charts_ChartBacklog__ = __webpack_require__("r15C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Charts_ChartReincidenciaPareto__ = __webpack_require__("wXZb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Charts_ChartFailurePareto__ = __webpack_require__("NspE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Components_DescontinuationWarning_vue__ = __webpack_require__("ssV8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_mixin__ = __webpack_require__("vsZy");



























__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_23_vue_js_popover___default.a);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  options: null,
  components: {
    highcharts: __WEBPACK_IMPORTED_MODULE_1_highcharts_vue__["Chart"],
    mapChart: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Maps_MapChart__["a" /* default */],
    ReportChart: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Charts_ReportChart__["a" /* default */],
    chartsSkipped: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Charts_ChartsSkipped__["a" /* default */],
    chartsReport: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_Charts_chartsReport__["a" /* default */],
    chartsDefects: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_Charts_chartsDefects__["a" /* default */],
    bookmark: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_Components_Bookmark__["a" /* default */],
    ExecutionIndicators: __WEBPACK_IMPORTED_MODULE_9__Components_ExecutionIndicators__["a" /* default */],
    Donut: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Charts_Donut__["a" /* default */],
    ReincidenciaIndicator: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Components_ReincidenciaIndicator__["a" /* default */],
    ReincidenciaChart: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Charts_ReincidenciaChart__["a" /* default */],
    popover: __WEBPACK_IMPORTED_MODULE_23_vue_js_popover___default.a,
    Help: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_components_Help__["a" /* default */],
    ExecutionChart: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Charts_ExecutionChart__["a" /* default */],
    DonutExecution: __WEBPACK_IMPORTED_MODULE_16_src_components_Dashboard_Views_Charts_DonutExecution__["a" /* default */],
    ExecutionChartTotal: __WEBPACK_IMPORTED_MODULE_17_src_components_Dashboard_Views_Charts_ExecutionChartTotal__["a" /* default */],
    ChartFailure: __WEBPACK_IMPORTED_MODULE_18_src_components_Dashboard_Views_Charts_ChartFailure__["a" /* default */],
    DataSurveyChart: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Charts_DataSurveyChart__["a" /* default */],
    ChartBacklog: __WEBPACK_IMPORTED_MODULE_19_src_components_Dashboard_Views_Charts_ChartBacklog__["a" /* default */],
    ChartReincidenciaPareto: __WEBPACK_IMPORTED_MODULE_20_src_components_Dashboard_Views_Charts_ChartReincidenciaPareto__["a" /* default */],
    ChartFailurePareto: __WEBPACK_IMPORTED_MODULE_21_src_components_Dashboard_Views_Charts_ChartFailurePareto__["a" /* default */],
    DescontinuationWarning: __WEBPACK_IMPORTED_MODULE_22_src_components_Dashboard_Views_Components_DescontinuationWarning_vue__["a" /* default */]
  },
  data: function data() {
    return {
      stepIds: ['collect', 'reports', 'defects', '', 'planning', 'execution', 'mapa'],
      menutop: false,
      planned_rdps_data: [],
      repetition_data: {},
      repetition_chart_data: [],
      general_report: {
        coleta_chart: [],
        laudo_chart: [],
        result_chart: []
      },
      reports_execution_deadline: {
        total: {},
        details: [],
        total_atrasado: 0,
        total_concluido: 0,
        details_total: []
      }
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_26__utils_mixin__["a" /* default */]],
  mounted: function mounted() {
    this.changeTab('offline');
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    get_planned_reports: function get_planned_reports() {
      var API = "https://api.semeq.com.br/";

      var ENDPOINT = 'v1/mysemeq-ambev/get-planned-reports';
      var self = this;

      self.planned_rdps_data = [];
      __WEBPACK_IMPORTED_MODULE_25_axios___default()({ method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
        self.planned_rdps_data = resp.data;
      }).catch(function (err) {
        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    },
    get_repetition: function get_repetition() {
      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/mysemeq-ambev/get-repetition';
      var self = this;

      this.repetition_data = [];
      this.repetition_chart_data = [];
      __WEBPACK_IMPORTED_MODULE_25_axios___default()({ method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (res) {
        var repetition = res.data.total;

        var repetition_chart_data = [];
        for (var i in res.data.detail) {
          var dados = res.data.detail[i];

          repetition_chart_data.push({
            id: i,
            title: dados.plant,
            plant: dados.plant_id,
            data: [[dados['R1'], dados['R2'], dados['R3'], dados['R3+']], [dados['R1_perc'], dados['R2_perc'], dados['R3_perc'], dados['R3+_perc']]]
          });
        }

        self.repetition_chart_data = repetition_chart_data;

        self.repetition_data = {
          'R0': [repetition['R0'] - 1, repetition['R0_perc']],
          'R1': [repetition['R1'], repetition['R1_perc']],
          'R2': [repetition['R2'], repetition['R2_perc']],
          'R3': [repetition['R3'], repetition['R3_perc']],
          'R3+': [repetition['R3+'], repetition['R3+_perc']]
        };
      }).catch(function (error) {
        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    },
    get_general_report: function get_general_report() {

      var API = "https://api.semeq.com.br/";

      if (this.filters.area || this.filters.sector || this.filters.machine || this.filters.component) {
        var ENDPOINT = 'v1/mysemeq-ambev/get-general-report-chart-filter';

        var self = this;
        __WEBPACK_IMPORTED_MODULE_25_axios___default()({ method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
          self.general_report = resp.data;
        }).catch(function (err) {
          self.ApiErrorHandler(self, error.response.data.status_code);
        });
      } else {
        var _ENDPOINT = 'v1/mysemeq-ambev/get-general-report-chart';

        var _self = this;
        __WEBPACK_IMPORTED_MODULE_25_axios___default()({ method: 'GET', url: API + _ENDPOINT, params: this.filters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
          _self.general_report = resp.data;
        }).catch(function (err) {
          _self.ApiErrorHandler(_self, error.response.data.status_code);
        });
      }
    },
    get_executed_reports: function get_executed_reports() {

      var API = "https://api.semeq.com.br/";
      var ENDPOINT = 'v1/mysemeq-ambev/get-executed-reports-deadline';

      this.reports_execution_deadline = { total: {}, details: [], details_total: [] };
      this.reports_execution_deadline.total_atrasado = 0;
      this.reports_execution_deadline.total_concluido = 0;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_25_axios___default()({ method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (res) {
        self.reports_execution_deadline = res.data;

        self.reports_execution_deadline.total_atrasado = res.data.total[1] + res.data.total[2] + res.data.total[3];
        self.reports_execution_deadline.total_concluido = res.data.total[0];
      }).catch(function (err) {
        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    },
    showNotification: function showNotification() {
      this.$notify({
        message: this.$i18n.t("48"),
        type: "warning",
        top: true,
        showClose: true,
        fullWidth: true,
        closeDelay: 9999999999999
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_vuex__["b" /* mapMutations */])(['changeTab'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_vuex__["a" /* mapGetters */])(['filters', 'menu'])),
  watch: {
    menu: function menu(newValue) {
      if (this.menu.book > 30) {
        this.menutop = true;
      }
      if (this.menu.book < 29) {
        this.menutop = false;
      }
    },
    filters: function filters() {
      this.get_planned_reports();
      this.get_repetition();
      this.get_general_report();
      this.get_executed_reports();
    }
  }
});

/***/ }),

/***/ "smvr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__ = __webpack_require__("bpJH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



var _actions, _mutations;




var state = {
  onlineStatus: [],
  onlinePointStatus: [],
  onlineAlarme: [],
  onlineSensorStatus: [],
  onlineNodeStatus: [],
  onlineSensorBattery: []

};

var getters = {
  onlineStatus: function onlineStatus(state) {
    return state.onlineStatus;
  },
  onlinePointStatus: function onlinePointStatus(state) {
    return state.onlinePointStatus;
  },
  onlineAlarme: function onlineAlarme(state) {
    return state.onlineAlarme;
  },
  onlineSensorStatus: function onlineSensorStatus(state) {
    return state.onlineSensorStatus;
  },
  onlineNodeStatus: function onlineNodeStatus(state) {
    return state.onlineNodeStatus;
  },
  onlineSensorBattery: function onlineSensorBattery(state) {
    return state.onlineSensorBattery;
  }

};

var API = "https://api.semeq.com.br/";
var ENDPOINT = 'v1/get-equip-status';
var ENDPOINT_STATUS_ALARME = 'v1/get-sensor-status-alarme';
var ENDPOINT_ALARME = 'v1/get-sensor-status-alarme-24';
var ENDPOINT_SENSOR_STATUS = 'v1/get-sensor-status';
var ENDPOINT_NODE_STATUS = 'v1/get-nodo-status';
var ENDPOINT_SENSOR_BATTERY = 'v1/get-bateria-status';

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["a" /* GET_CHART_STATUS */], function (_ref, user) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  console.log('user: ', user);
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    console.log('TOKEN', localStorage.getItem('user-token'));
    commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["a" /* GET_CHART_STATUS */]);
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ENDPOINT, params: user, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
      console.log('API GET_CHART_STATUS :', resp.data.result);
      var res = resp.data.result;
      commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["a" /* GET_CHART_STATUS */], res);
      resolve(res);
    }).catch(function (err) {
      commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["b" /* TIPO_ERROR */], err);
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["c" /* GET_CHART_POINT_STATUS */], function (_ref2, user) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  console.log('user: ', user);
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    console.log('TOKEN', localStorage.getItem('user-token'));
    commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["c" /* GET_CHART_POINT_STATUS */]);
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ENDPOINT_STATUS_ALARME, params: user, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
      console.log('API GET_CHART_POINT_STATUS :', resp.data.result);
      var res = resp.data.result;
      commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["c" /* GET_CHART_POINT_STATUS */], res);
      resolve(res);
    }).catch(function (err) {
      commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["b" /* TIPO_ERROR */], err);
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["d" /* GET_CHART_ALARME */], function (_ref3, user) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch;

  console.log('user: ', user);
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    console.log('TOKEN', localStorage.getItem('user-token'));
    commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["d" /* GET_CHART_ALARME */]);
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ENDPOINT_ALARME, params: user, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
      console.log('API GET_CHART_ALARME :', resp.data.result);
      var res = resp.data.result;
      commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["d" /* GET_CHART_ALARME */], res);
      resolve(res);
    }).catch(function (err) {
      commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["b" /* TIPO_ERROR */], err);
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["e" /* GET_CHART_SENSOR_STATUS */], function (_ref4, user) {
  var commit = _ref4.commit,
      dispatch = _ref4.dispatch;

  console.log('user: ', user);
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    console.log('TOKEN', localStorage.getItem('user-token'));
    commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["e" /* GET_CHART_SENSOR_STATUS */]);
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ENDPOINT_SENSOR_STATUS, params: user, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
      console.log('API GET_CHART_SENSOR_STATUS :', resp.data.result);
      var res = resp.data.result;
      commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["e" /* GET_CHART_SENSOR_STATUS */], res);
      resolve(res);
    }).catch(function (err) {
      commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["b" /* TIPO_ERROR */], err);
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["f" /* GET_CHART_NODE_STATUS */], function (_ref5, user) {
  var commit = _ref5.commit,
      dispatch = _ref5.dispatch;

  console.log('user: ', user);
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    console.log('TOKEN', localStorage.getItem('user-token'));
    commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["f" /* GET_CHART_NODE_STATUS */]);
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ENDPOINT_NODE_STATUS, params: user, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
      console.log('API GET_CHART_NODE_STATUS :', resp.data.result);
      var res = resp.data.result;
      commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["f" /* GET_CHART_NODE_STATUS */], res);
      resolve(res);
    }).catch(function (err) {
      commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["b" /* TIPO_ERROR */], err);
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["g" /* GET_CHART_SENSOR_BATTERY */], function (_ref6, user) {
  var commit = _ref6.commit,
      dispatch = _ref6.dispatch;

  console.log('user: ', user);
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    console.log('TOKEN', localStorage.getItem('user-token'));
    commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["g" /* GET_CHART_SENSOR_BATTERY */]);
    __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ENDPOINT_SENSOR_BATTERY, params: user, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
      console.log('API GET_CHART_SENSOR_BATTERY :', resp.data.result);
      var res = resp.data.result;
      commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["g" /* GET_CHART_SENSOR_BATTERY */], res);
      resolve(res);
    }).catch(function (err) {
      commit(__WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["b" /* TIPO_ERROR */], err);
      reject(err);
    });
  });
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["a" /* GET_CHART_STATUS */], function (state, res) {
  state.onlineStatus = res;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["c" /* GET_CHART_POINT_STATUS */], function (state, res) {
  state.onlinePointStatus = res;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["d" /* GET_CHART_ALARME */], function (state, res) {
  state.onlineAlarme = res;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["e" /* GET_CHART_SENSOR_STATUS */], function (state, res) {
  state.onlineSensorStatus = res;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["f" /* GET_CHART_NODE_STATUS */], function (state, res) {
  state.onlineNodeStatus = res;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_chartsOnline__["g" /* GET_CHART_SENSOR_BATTERY */], function (state, res) {
  state.onlineSensorBattery = res;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "ssV8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DescontinuationWarning_vue__ = __webpack_require__("hbjD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cca66d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DescontinuationWarning_vue__ = __webpack_require__("KT1V");
function injectStyle (ssrContext) {
  __webpack_require__("QHKn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cca66d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DescontinuationWarning_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cca66d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DescontinuationWarning_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "swfc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("320+ Themify Icons")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Handcrafted by our friends from\n          "),_c('a',{attrs:{"target":"_blank","href":"https://themify.me/"}},[_vm._v("Themify")]),_vm._v(".")])]),_vm._v(" "),_c('div',{staticClass:"card-content all-icons"},[_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Arrows & Direction Icons ")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrows-vertical"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrows-vertical")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrows-horizontal"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrows-horizontal")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-double-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-double-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-double-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-double-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-double-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-double-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-angle-double-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-angle-double-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-move"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-move")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-fullscreen"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-fullscreen")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-top-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-top-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-top-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-top-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-circle-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-circle-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-circle-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-circle-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-circle-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-circle-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrow-circle-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrow-circle-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-arrows-corner"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-arrows-corner")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-split-v"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-split-v")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-split-v-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-split-v-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-split-h"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-split-h")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-point-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-point-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-point-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-point-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-point-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-point-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-point-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-point-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-back-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-back-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-back-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-back-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-exchange-vertical"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-exchange-vertical")])])]),_vm._v(" "),_c('h3',[_vm._v("Web App Icons")]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-wand"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-wand")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-save"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-save")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-save-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-save-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-direction"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-direction")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-direction-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-direction-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-user"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-user")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-link"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-link")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-unlink"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-unlink")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-trash"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-trash")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-target"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-target")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-tag"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-tag")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-desktop"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-desktop")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-tablet"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-tablet")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-mobile"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-mobile")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-email"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-email")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-star"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-star")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-spray"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-spray")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-signal"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-signal")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shopping-cart"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shopping-cart")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shopping-cart-full"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shopping-cart-full")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-settings"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-settings")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-search"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-search")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-zoom-in"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-zoom-in")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-zoom-out"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-zoom-out")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cut"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cut")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ruler"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ruler")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ruler-alt-2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ruler-alt-2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ruler-pencil"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ruler-pencil")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ruler-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ruler-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bookmark"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bookmark")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bookmark-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bookmark-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-reload"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-reload")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-plus"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-plus")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-minus"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-minus")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-close"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-close")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pin"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pin")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pencil"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pencil")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pencil-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pencil-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-paint-roller"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-paint-roller")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-paint-bucket"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-paint-bucket")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-na"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-na")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-medall"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-medall")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-medall-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-medall-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-marker"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-marker")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-marker-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-marker-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-lock"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-lock")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-unlock"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-unlock")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-location-arrow"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-location-arrow")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layers"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layers")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layers-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layers-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-key"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-key")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-image"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-image")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-heart"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-heart")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-heart-broken"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-heart-broken")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-stop"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-stop")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-open"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-open")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hand-drag"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hand-drag")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flag"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flag")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flag-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flag-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flag-alt-2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flag-alt-2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-eye"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-eye")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-import"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-import")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-export"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-export")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cup"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cup")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-crown"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-crown")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-comments"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-comments")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-comment"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-comment")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-comment-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-comment-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-thought"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-thought")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-clip"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-clip")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-check"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-check")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-check-box"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-check-box")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-camera"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-camera")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-announcement"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-announcement")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-brush"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-brush")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-brush-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-brush-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-palette"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-palette")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-briefcase"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-briefcase")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bolt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bolt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bolt-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bolt-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-blackboard"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-blackboard")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bag"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bag")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-world"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-world")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-wheelchair"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-wheelchair")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-car"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-car")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-truck"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-truck")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-timer"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-timer")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ticket"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ticket")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-thumb-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-thumb-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-thumb-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-thumb-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-stats-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-stats-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-stats-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-stats-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shine"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shine")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shift-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shift-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shift-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shift-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shift-right-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shift-right-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shift-left-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shift-left-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shield"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shield")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-notepad"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-notepad")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-server"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-server")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pulse"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pulse")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-printer"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-printer")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-power-off"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-power-off")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-plug"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-plug")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pie-chart"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pie-chart")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-panel"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-panel")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-package"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-package")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-music"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-music")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-music-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-music-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-mouse"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-mouse")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-mouse-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-mouse-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-money"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-money")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-microphone"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-microphone")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-menu"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-menu")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-menu-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-menu-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-map"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-map")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-map-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-map-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-location-pin"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-location-pin")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-light-bulb"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-light-bulb")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-info"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-info")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-infinite"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-infinite")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-id-badge"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-id-badge")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-hummer"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-hummer")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-home"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-home")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-help"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-help")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-headphone"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-headphone")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-harddrives"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-harddrives")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-harddrive"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-harddrive")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-gift"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-gift")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-game"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-game")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-filter"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-filter")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-files"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-files")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-file"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-file")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-zip"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-zip")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-folder"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-folder")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-envelope"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-envelope")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-dashboard"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-dashboard")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cloud"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cloud")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cloud-up"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cloud-up")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-cloud-down"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-cloud-down")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-clipboard"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-clipboard")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-calendar"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-calendar")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-book"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-book")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bell"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bell")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-basketball"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-basketball")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bar-chart"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bar-chart")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-bar-chart-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-bar-chart-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-archive"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-archive")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-anchor"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-anchor")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-alert"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-alert")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-alarm-clock"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-alarm-clock")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-agenda"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-agenda")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-write"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-write")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-wallet"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-wallet")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-video-clapper"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-video-clapper")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-video-camera"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-video-camera")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-vector"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-vector")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-support"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-support")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-stamp"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-stamp")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-slice"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-slice")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-shortcode"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-shortcode")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-receipt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-receipt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pin2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pin2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pin-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pin-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pencil-alt2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pencil-alt2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-eraser"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-eraser")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-more"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-more")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-more-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-more-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-microphone-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-microphone-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-magnet"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-magnet")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-line-double"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-line-double")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-line-dotted"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-line-dotted")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-line-dashed"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-line-dashed")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-ink-pen"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-ink-pen")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-info-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-info-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-help-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-help-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-headphone-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-headphone-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-gallery"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-gallery")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-face-smile"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-face-smile")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-face-sad"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-face-sad")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-credit-card"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-credit-card")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-comments-smiley"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-comments-smiley")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-time"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-time")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-share"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-share")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-share-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-share-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-rocket"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-rocket")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-new-window"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-new-window")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-rss"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-rss")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-rss-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-rss-alt")])])]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Control Icons")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-stop"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-stop")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-shuffle"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-shuffle")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-play"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-play")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-pause"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-pause")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-forward"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-forward")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-backward"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-backward")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-volume"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-volume")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-skip-forward"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-skip-forward")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-skip-backward"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-skip-backward")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-record"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-record")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-control-eject"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-control-eject")])])]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Text Editor")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-paragraph"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-paragraph")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-uppercase"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-uppercase")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-underline"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-underline")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-text"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-text")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-Italic"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-Italic")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-smallcap"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-smallcap")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-list"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-list")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-list-ol"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-list-ol")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-align-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-align-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-align-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-align-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-align-justify"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-align-justify")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-align-center"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-align-center")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-quote-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-quote-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-quote-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-quote-left")])])]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Layout Icons")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-width-full"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-width-full")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-width-default"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-width-default")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-width-default-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-width-default-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-tab"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-tab")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-tab-window"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-tab-window")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-tab-v"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-tab-v")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-tab-min"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-tab-min")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-slider"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-slider")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-slider-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-slider-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-sidebar-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-sidebar-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-sidebar-none"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-sidebar-none")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-sidebar-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-sidebar-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-placeholder"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-placeholder")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-menu"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-menu")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-menu-v"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-menu-v")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-menu-separated"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-menu-separated")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-menu-full"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-menu-full")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-right-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-right-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-overlay"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-overlay")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-overlay-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-overlay-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-overlay-alt-2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-overlay-alt-2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-left-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-left-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-center"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-center")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-media-center-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-media-center-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-list-thumb"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-list-thumb")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-list-thumb-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-list-thumb-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-list-post"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-list-post")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-list-large-image"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-list-large-image")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-line-solid"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-line-solid")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid4"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid4")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid3"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid3")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid2-thumb"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid2-thumb")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-center"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-center")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-btn-right"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-btn-right")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-cta-btn-left"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-cta-btn-left")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column4"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column4")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column3"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column3")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-accordion-separated"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-accordion-separated")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-accordion-merged"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-accordion-merged")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-accordion-list"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-accordion-list")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-widgetized"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-widgetized")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-widget"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-widget")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-widget-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-widget-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-view-list"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-view-list")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-view-list-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-view-list-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-view-grid"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-view-grid")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-upload"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-upload")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-download"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-download")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-loop"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-loop")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-sidebar-2"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-sidebar-2")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid4-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid4-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid3-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid3-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-grid2-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-grid2-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column4-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column4-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column3-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column3-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-layout-column2-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-layout-column2-alt")])])]),_vm._v(" "),_c('div',{staticClass:"icon-section"},[_c('h3',[_vm._v("Brand Icons")]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flickr"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flickr")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-flickr-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-flickr-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-instagram"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-instagram")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-google"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-google")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-github"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-github")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-facebook"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-facebook")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-dropbox"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-dropbox")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-dropbox-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-dropbox-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-dribbble"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-dribbble")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-apple"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-apple")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-android"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-android")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-yahoo"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-yahoo")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-trello"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-trello")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-stack-overflow"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-stack-overflow")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-soundcloud"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-soundcloud")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-sharethis"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-sharethis")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-sharethis-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-sharethis-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-reddit"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-reddit")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-microsoft"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-microsoft")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-microsoft-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-microsoft-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-linux"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-linux")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-jsfiddle"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-jsfiddle")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-joomla"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-joomla")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-html5"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-html5")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-css3"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-css3")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-drupal"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-drupal")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-wordpress"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-wordpress")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-tumblr"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-tumblr")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-tumblr-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-tumblr-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-skype"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-skype")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-youtube"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-youtube")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-vimeo"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-vimeo")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-vimeo-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-vimeo-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-twitter"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-twitter")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-twitter-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-twitter-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-linkedin"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-linkedin")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pinterest"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pinterest")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-pinterest-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-pinterest-alt")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-themify-logo"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-themify-logo")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-themify-favicon"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-themify-favicon")])]),_vm._v(" "),_c('div',{staticClass:"icon-container"},[_c('span',{staticClass:"ti-themify-favicon-alt"}),_vm._v(" "),_c('span',{staticClass:"icon-name"},[_vm._v(" ti-themify-favicon-alt")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sx8C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tCLc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartsPointStatus_vue__ = __webpack_require__("jrkx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7def9e4d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartsPointStatus_vue__ = __webpack_require__("1pLE");
function injectStyle (ssrContext) {
  __webpack_require__("0fCT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartsPointStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7def9e4d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartsPointStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tNnJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helppoint","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v("\n            ...\n          ")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help"},[_vm._v(" "+_vm._s(_vm.$t("226"))+"\n    ")]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tlmh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__("sUu7");





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["b" /* mapFields */])(['email', 'password', 'confirm'])),
  data: function data() {
    return {
      model: {
        email: '',
        password: '',
        confirmPassword: ''
      },
      modelValidations: {
        email: {
          required: true,
          email: true
        },
        password: {
          required: true,
          min: 5
        },
        confirmPassword: {
          required: true,
          confirmed: 'password'
        }
      }
    };
  },

  methods: {
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      var _this = this;

      this.$validator.validateAll().then(function (isValid) {
        _this.$emit('on-submit', _this.registerForm, isValid);
      });
    }
  }
});

/***/ }),

/***/ "tnlj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_mixin__ = __webpack_require__("vsZy");









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'charts',
    props: {
        title: {
            type: String
        },
        plant: {
            type: Number
        },
        data: {
            type: Array }
    },
    data: function data() {
        var _ref;

        return {
            titleChart: this.$t("223"),
            tableData: [],
            type: 'line',
            chartOptions: {
                colors: ['#e4d354', '#f0893a', '#f45b5b', '#f45b5b'],
                chart: {
                    type: 'line',
                    backgroundColor: 'rgba(0,0,0,0)',
                    style: {
                        fontFamily: '\'Unica One\', sans-serif'
                    },
                    plotBorderColor: '#606063'
                },
                title: {
                    text: '',
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase',
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }
                },
                subtitle: {
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase'
                    }
                },
                xAxis: {
                    categories: ['R1', 'R2', 'R3', 'R3+'],
                    crosshair: true,
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    title: {
                        style: {
                            color: '#A0A0A3'
                        }
                    }
                },
                yAxis: [(_ref = {
                    labels: {
                        format: '{value}%'
                    },
                    title: {
                        text: this.$t("299"),
                        style: {
                            color: '#A0A0A3',
                            fontSize: '12px'
                        }
                    },
                    gridLineColor: '#707073'
                }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'labels', {
                    style: {
                        color: '#E0E0E3'
                    }
                }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'lineColor', '#707073'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'minorGridLineColor', '#505053'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tickColor', '#707073'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tickWidth', 1), _ref), {
                    title: {
                        text: this.$t("299"),
                        style: {
                            color: '#A0A0A3',
                            fontSize: '12px'
                        }
                    },
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    tickWidth: 1,
                    opposite: true
                }],
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    },
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y} </b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true,
                            color: '#F0F0F3',
                            style: {
                                fontSize: '13px'
                            }
                        },
                        cursor: 'pointer',
                        marker: {
                            lineColor: '#333'
                        },
                        events: {
                            click: this.loadGrid
                        }
                    },
                    boxplot: {
                        fillColor: '#505053'
                    },
                    candlestick: {
                        lineColor: 'white'
                    },
                    errorbar: {
                        color: 'white'
                    },
                    column: {
                        pointPadding: 0.1,
                        borderWidth: 0
                    }
                },
                legend: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    itemStyle: {
                        color: '#E0E0E3'
                    },
                    itemHoverStyle: {
                        color: '#FFF'
                    },
                    itemHiddenStyle: {
                        color: '#606063'
                    },
                    title: {
                        style: {
                            color: '#C0C0C0',
                            fontSize: '12px'
                        }
                    }
                },
                labels: {
                    style: {
                        color: '#707073'
                    }
                },
                drilldown: {
                    activeAxisLabelStyle: {
                        color: '#F0F0F3'
                    },
                    activeDataLabelStyle: {
                        color: '#F0F0F3'
                    }
                },
                navigation: {
                    buttonOptions: {
                        symbolStroke: '#DDDDDD',
                        theme: {
                            fill: '#505053'
                        }
                    }
                },

                rangeSelector: {
                    buttonTheme: {
                        fill: '#505053',
                        stroke: '#000000',
                        style: {
                            color: '#CCC'
                        },
                        states: {
                            hover: {
                                fill: '#707073',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            },
                            select: {
                                fill: '#000003',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    },
                    inputBoxBorderColor: '#505053',
                    inputStyle: {
                        backgroundColor: '#333',
                        color: 'silver'
                    },
                    labelStyle: {
                        color: 'silver'
                    }
                },
                navigator: {
                    handles: {
                        backgroundColor: '#666',
                        borderColor: '#AAA'
                    },
                    outlineColor: '#CCC',
                    maskFill: 'rgba(255,255,255,0.1)',
                    series: {
                        color: '#7798BF',
                        lineColor: '#A6C7ED'
                    },
                    xAxis: {
                        gridLineColor: '#505053'
                    }
                },
                scrollbar: {
                    barBackgroundColor: '#808083',
                    barBorderColor: '#808083',
                    buttonArrowColor: '#CCC',
                    buttonBackgroundColor: '#606063',
                    buttonBorderColor: '#606063',
                    rifleColor: '#FFF',
                    trackBackgroundColor: '#404043',
                    trackBorderColor: '#404043'
                },
                series: [{
                    name: this.$t("300"),
                    type: 'column',
                    yAxis: 1,
                    data: this.data[0],
                    colorByPoint: true
                }, {
                    name: this.$t("301"),
                    type: 'spline',
                    data: this.data[1],
                    tooltip: {
                        valueSuffix: '%'
                    },
                    color: '#fff'
                }],
                exporting: { enabled: false },
                credits: {
                    enabled: false
                },
                loading: {
                    labelStyle: {
                        color: 'black',
                        textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
                    },
                    style: {
                        backgroundColor: 'none',
                        opacity: 1
                    }
                }
            }
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_5__utils_mixin__["a" /* default */]],
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapMutations */])(['changeGrid']), {
        loadGrid: function loadGrid(event) {
            var total = event.point.y;

            if (total != 0) {

                if (this.getTab == 'offline') {

                    var region = this.filters.region ? '' : this.title;


                    var plant = this.filters.region ? this.plant : '';


                    var status = event.point.category;
                    var date = event.point.category;
                    var point_name = event.point.series.name;
                    var NAME_CHART = this.$t("359") + ' - ' + point_name.toUpperCase();

                    var ENDPOINT = 'v1/mysemeq-ambev/get-reports-repetition?plant=' + plant + '&region=' + region + '&status=' + status + '&technique=' + this.filters.technique + '&year=' + this.filters.year + '&period=' + this.filters.period + '&area=' + this.filters.area + '&sector=' + this.filters.sector + '&machine=' + this.filters.machine + '&component=' + this.filters.component + '&online=0';

                    var grid = {
                        totalDados: event.point.y,
                        title: this.title + ' ' + event.point.series.name,
                        url: ENDPOINT,
                        name_chart: NAME_CHART,
                        columns: {
                            "rows": '',
                            "plant": this.$t("310"),
                            "area": this.$t("311"),
                            "sector": this.$t("312"),
                            "component": this.$t("313"),
                            "component_tag": this.$t("314"),
                            "component_type_en": this.$t("315"),
                            "machine": this.$t("316"),
                            "machine_tag": this.$t("317"),
                            "technique_en": this.$t("321"),
                            "report_number": this.$t("319"),
                            "approved_datetime": this.$t("320"),
                            "link": this.$t("323"),
                            "link_rci": this.$t("324"),
                            "pending_days": this.$t("325"),
                            "delay": this.$t("326"),
                            "prescription_created_datePtime": this.$t("327"),
                            "week": this.$t("328")

                        },
                        show: true,
                        titleHelp: 'Grid - ' + this.$t("359"),
                        txtHelp: this.$t("357")
                    };

                    if (this.filters.plant) {
                        grid.title += ' - ' + this.filters.plant_name;
                        delete grid.columns['plant'];
                    } else if (this.filters.region) {
                        grid.title += ' - ' + this.filters.region;
                    }

                    this.changeGrid(grid);
                }
                if (this.getTab == 'online') {

                    var _region = this.filtersOn.region ? '' : this.title;


                    var _plant = this.filtersOn.region ? this.plant : '';


                    var _status = event.point.category;
                    var _date = event.point.category;
                    var _point_name = event.point.series.name;
                    var _NAME_CHART = this.$t("359") + ' - ' + _point_name.toUpperCase();

                    var _ENDPOINT = 'v1/mysemeq-ambev/get-reports-repetition?plant=' + _plant + '&region=' + _region + '&status=' + _status + '&technique=&year=' + this.filtersOn.year + '&period=' + this.filtersOn.period + '&area=' + this.filtersOn.area_f + '&sector=' + this.filtersOn.sector_f + '&machine=' + this.filtersOn.machine + '&component=' + this.filtersOn.subset + '&online=1';

                    var _grid = {
                        totalDados: event.point.y,
                        title: this.title + ' ' + event.point.series.name,
                        url: _ENDPOINT,
                        name_chart: _NAME_CHART,
                        columns: {
                            "rows": '',
                            "plant": this.$t("310"),
                            "area": this.$t("311"),
                            "sector": this.$t("312"),
                            "component": this.$t("313"),
                            "component_tag": this.$t("314"),
                            "component_type_en": this.$t("315"),
                            "machine": this.$t("316"),
                            "machine_tag": this.$t("317"),
                            "technique_en": this.$t("321"),
                            "report_number": this.$t("319"),
                            "approved_datetime": this.$t("320"),
                            "link": this.$t("323"),
                            "link_rci": this.$t("324"),
                            "pending_days": this.$t("325"),
                            "delay": this.$t("326"),
                            "prescription_created_datePtime": this.$t("327"),
                            "week": this.$t("328")
                        },
                        show: true,
                        titleHelp: 'Grid - ' + this.$t("359"),
                        txtHelp: this.$t("357")
                    };

                    if (this.filters.plant) {
                        _grid.title += ' - ' + this.filters.plant_name;
                        delete _grid.columns['plant'];
                    } else if (this.filters.region) {
                        _grid.title += ' - ' + this.filters.region;
                    }

                    this.changeGrid(_grid);
                }
            }
        }
    }),
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        soma: function soma() {
            var soma = this.chartOptions.series[0].data;

            soma = soma.reduce(function (total, num) {
                return total + num;
            }, 0);
            return soma;
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['filters', 'filtersOn', 'getTab'])),
    mounted: function mounted() {
        if (this.soma <= 0) this.$refs.chart.chart.showLoading('No data!');
    }
});

/***/ }),

/***/ "trg4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showModalFile)?_c('div',{attrs:{"id":"modal-container","tabindex":"1"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }_vm.showModalFile = false}}},[_c('Csv')],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpdefects","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("227")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-sm bt-change-chart",attrs:{"id":"buttons-csv","role":"group","aria-label":"Group Buttons"}},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.getCsvAll()}}},[_c('small',[_vm._v(_vm._s(_vm.$t("228")))])])]),_vm._v(" "),_c('div',{staticClass:"title-charts-fail"},[_vm._v(_vm._s(_vm.$t("229"))+"\n    "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpdefects.right",arg:"helpdefects",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-sm bt-change-chart",attrs:{"id":"buttons","role":"group","aria-label":"Group Buttons"}},[_c('button',{staticClass:"btn btn-secondary",class:{ activeDGroup: _vm.activeDGroup },attrs:{"type":"button"},on:{"click":function($event){_vm.getPoints('defect_group')}}},[_c('small',[_vm._v(_vm._s(_vm.$t("230")))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",class:{ activeDefect: _vm.activeDefect },attrs:{"type":"button"},on:{"click":function($event){_vm.getPoints('defect')}}},[_c('small',[_vm._v(_vm._s(_vm.$t("231")))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",class:{ activeMpf: _vm.activeMpf },attrs:{"type":"button"},on:{"click":function($event){_vm.getPoints('mpf')}}},[_c('small',[_vm._v(_vm._s(_vm.$t("232")))])])]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions,"id":_vm.id}}),_vm._v(" "),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u244":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('keep-alive',[_c('router-view')],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u2UF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showModalFile)?_c('div',{attrs:{"id":"modal-container","tabindex":"1"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,"Escape")){ return null; }_vm.showModalFile = false}}},[_c('Csv')],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpskipped","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("154")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-sm bt-change-chart",attrs:{"id":"buttons-csv","role":"group","aria-label":"Group Buttons"}},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.getCsvAll()}}},[_c('small',[_vm._v(_vm._s(_vm.$t("145")))])])]),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.$t("155"))+"\n    "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpskipped.right",arg:"helpskipped",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u9kn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uCbh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uEKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: [Array, Boolean],
    disabled: [Boolean, String],
    inline: Boolean
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.checked;
      },
      set: function set(check) {
        this.$emit('input', check);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'checkbox-inline';
      }
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "uFAt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__("1V4J");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27db7d6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__("UtA4");
function injectStyle (ssrContext) {
  __webpack_require__("9prC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27db7d6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "uNEM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container cursor-pointer",style:(("background: " + (_vm.color || _vm.colors[_vm.title.toUpperCase()]))),on:{"click":function($event){_vm.loadGrid()}}},[_c('div',{staticStyle:{"display":"none"}},[_vm._v(" "+_vm._s(_vm.delay)+" ")]),_vm._v(" "),_c('div',{staticClass:"header"},[_c('h4',{style:(("font-size: " + (_vm.font || "")))},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('h4',{staticStyle:{"font-size":"22px"}},[_vm._v(" "+_vm._s(_vm.perc)+" "),(_vm.perc || _vm.perc == 0)?_c('span',[_vm._v("%")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))]),_vm._v(" "),_c('div',{staticClass:"footer-text"},[_vm._v(" "+_vm._s(_vm.$t("161")))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uOOa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"text-center"},[_vm._v("Please tell us more about yourself.")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          First Name\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.firstName),expression:"modelValidations.firstName"},{name:"model",rawName:"v-model",value:(_vm.model.firstName),expression:"model.firstName"}],staticClass:"form-control",attrs:{"type":"text","name":"firstName","placeholder":"ex: Mike"},domProps:{"value":(_vm.model.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "firstName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.firstName.invalid),expression:"firstName.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('firstName'))+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Last Name\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.lastName),expression:"modelValidations.lastName"},{name:"model",rawName:"v-model",value:(_vm.model.lastName),expression:"model.lastName"}],staticClass:"form-control",attrs:{"type":"text","name":"lastName","placeholder":"ex: Andrew"},domProps:{"value":(_vm.model.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "lastName", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastName.invalid),expression:"lastName.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('lastName'))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n          Email\n        ")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.modelValidations.email),expression:"modelValidations.email"},{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"form-control",attrs:{"type":"email","name":"email"},domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.email.invalid),expression:"email.invalid"}],staticClass:"text-danger"},[_vm._v("\n          "+_vm._s(_vm.getError('email'))+"\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ui7A":
/***/ (function(module, exports) {

module.exports = {"title":"World continents","version":"1.1.3","type":"FeatureCollection","copyright":"Copyright (c) 2020 Highsoft AS, Based on data from Natural Earth","copyrightShort":"Natural Earth","copyrightUrl":"http://www.naturalearthdata.com","crs":{"type":"name","properties":{"name":"urn:ogc:def:crs:EPSG:54003"}},"hc-transform":{"default":{"crs":"+proj=mill +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R_A +datum=WGS84 +units=m +no_defs","scale":0.0000170655279715,"jsonres":15.5,"jsonmarginX":-999,"jsonmarginY":9851,"xoffset":-19863092.8548,"yoffset":12635908.1982}},"features":[{"type":"Feature","id":"EU","properties":{"hc-group":"admin0","hc-middle-x":0.65,"hc-middle-y":0.63,"hc-key":"eu","hc-a2":"EU","abbrev-a3":"EUR","iso-a2":"EU","name":"Europe"},"geometry":{"type":"MultiPolygon","coordinates":[[[[4565,8339],[4573,8321],[4568,8300],[4540,8327],[4565,8339]]],[[[4626,8335],[4615,8302],[4593,8291],[4579,8298],[4605,8305],[4586,8315],[4577,8336],[4598,8344],[4602,8334],[4615,8353],[4626,8349],[4626,8335]]],[[[4544,7853],[4534,7844],[4536,7819],[4526,7793],[4514,7799],[4507,7823],[4511,7835],[4528,7839],[4530,7850],[4544,7853]]],[[[4887,9499],[4905,9499],[4910,9478],[4875,9474],[4849,9493],[4887,9499]]],[[[4709,8944],[4720,8947],[4729,8933],[4742,8945],[4738,8917],[4718,8917],[4637,8897],[4689,8920],[4678,8930],[4709,8944]]],[[[4893,9475],[4931,9478],[4950,9453],[4974,9450],[4938,9415],[4915,9415],[4925,9433],[4870,9426],[4869,9434],[4892,9456],[4869,9467],[4893,9475]]],[[[4820,8447],[4824,8430],[4808,8420],[4812,8406],[4793,8387],[4788,8411],[4798,8423],[4820,8431],[4820,8447]]],[[[5728,8944],[5724,8950],[5700,8929],[5673,8942],[5676,8961],[5704,8973],[5734,8956],[5728,8944]]],[[[5936,9600],[5894,9599],[5902,9615],[5940,9619],[5930,9625],[5974,9624],[5979,9591],[6020,9602],[6001,9587],[5968,9588],[5973,9603],[5936,9600]]],[[[5855,9618],[5837,9624],[5828,9604],[5790,9611],[5810,9620],[5830,9613],[5840,9634],[5855,9618]]],[[[5922,9644],[5897,9635],[5843,9649],[5876,9654],[5862,9669],[5903,9664],[5952,9648],[5922,9644]]],[[[6158,9675],[6180,9655],[6150,9643],[6112,9639],[6094,9650],[6139,9660],[6158,9675]]],[[[5669,9637],[5660,9644],[5611,9622],[5581,9636],[5675,9649],[5688,9634],[5669,9637]]],[[[4919,8461],[4904,8473],[4920,8478],[4942,8458],[4932,8447],[4908,8438],[4899,8453],[4919,8461]]],[[[4368,7747],[4350,7723],[4324,7732],[4341,7742],[4368,7747]]],[[[4702,7703],[4699,7681],[4711,7687],[4700,7653],[4706,7643],[4698,7631],[4681,7636],[4643,7659],[4627,7662],[4618,7674],[4640,7683],[4642,7700],[4649,7680],[4661,7676],[4694,7683],[4702,7703]]],[[[4533,7787],[4544,7763],[4536,7715],[4521,7717],[4515,7706],[4497,7716],[4506,7741],[4499,7783],[4506,7774],[4527,7789],[4533,7787]]],[[[5022,7660],[5045,7670],[5037,7655],[5050,7643],[5055,7630],[5067,7617],[5086,7623],[5072,7605],[5036,7655],[5022,7660]]],[[[4969,7661],[4972,7666],[4979,7637],[4999,7636],[4995,7646],[5014,7646],[5029,7626],[5004,7638],[4988,7629],[4979,7635],[4969,7661]]],[[[4975,7710],[4966,7690],[4989,7673],[4997,7661],[4987,7655],[4981,7674],[4938,7705],[4963,7700],[4975,7710]]],[[[5025,7695],[5020,7682],[5007,7695],[5022,7696],[5025,7711],[5016,7719],[5030,7724],[5037,7711],[5025,7695]]],[[[4941,7603],[4969,7588],[5013,7587],[5027,7577],[4983,7573],[4973,7582],[4962,7571],[4947,7585],[4941,7603]]],[[[4096,7606],[4096,7606],[4096,7606],[4096,7606],[4096,7606]]],[[[4129,7581],[4129,7581],[4129,7581],[4129,7581],[4129,7581]]],[[[5226,7564],[5223,7564],[5219,7564],[5221,7566],[5226,7564]]],[[[5252,7574],[5251,7574],[5249,7575],[5249,7575],[5249,7575],[5249,7575],[5248,7575],[5249,7575],[5248,7575],[5246,7575],[5248,7576],[5247,7576],[5248,7576],[5248,7576],[5248,7576],[5249,7577],[5252,7574]]],[[[5039,7756],[5024,7747],[5026,7756],[5044,7766],[5022,7766],[5008,7759],[5001,7738],[4990,7727],[4991,7745],[4999,7744],[5006,7775],[4992,7780],[4984,7766],[4978,7778],[4952,7769],[4959,7758],[4942,7752],[4926,7762],[4919,7747],[4942,7717],[4925,7703],[4960,7686],[4962,7665],[4949,7678],[4945,7639],[4925,7636],[4917,7625],[4907,7643],[4893,7634],[4889,7662],[4865,7671],[4877,7687],[4860,7700],[4877,7710],[4848,7717],[4849,7732],[4828,7752],[4823,7767],[4829,7776],[4826,7794],[4831,7808],[4819,7813],[4804,7831],[4779,7843],[4753,7842],[4746,7855],[4729,7851],[4738,7861],[4700,7882],[4704,7898],[4675,7927],[4666,7915],[4655,7926],[4654,7951],[4614,7933],[4619,7895],[4656,7869],[4669,7836],[4700,7812],[4727,7813],[4726,7795],[4785,7768],[4800,7749],[4795,7738],[4780,7755],[4757,7763],[4743,7748],[4741,7734],[4760,7724],[4758,7707],[4742,7701],[4742,7691],[4728,7675],[4716,7675],[4721,7699],[4731,7702],[4726,7726],[4714,7748],[4694,7753],[4689,7768],[4677,7765],[4650,7773],[4654,7787],[4639,7788],[4571,7843],[4552,7887],[4512,7901],[4495,7884],[4476,7878],[4436,7850],[4371,7869],[4347,7854],[4345,7834],[4353,7826],[4341,7805],[4316,7789],[4284,7781],[4246,7728],[4249,7713],[4262,7701],[4240,7688],[4234,7663],[4206,7655],[4193,7634],[4125,7633],[4103,7623],[4090,7609],[4074,7619],[4064,7641],[4037,7649],[4022,7641],[4001,7647],[3990,7643],[3996,7659],[3996,7689],[3976,7701],[3988,7734],[4001,7779],[3993,7818],[4001,7825],[3982,7847],[3986,7857],[4010,7865],[4023,7877],[4042,7870],[4096,7870],[4126,7864],[4151,7869],[4193,7860],[4212,7871],[4220,7910],[4223,7943],[4215,7958],[4222,7968],[4186,7985],[4192,8007],[4139,8028],[4104,8050],[4164,8065],[4176,8052],[4215,8057],[4202,8085],[4189,8077],[4190,8097],[4214,8097],[4220,8087],[4249,8081],[4267,8087],[4262,8098],[4290,8107],[4300,8119],[4302,8142],[4359,8163],[4388,8199],[4399,8234],[4407,8241],[4487,8257],[4507,8247],[4507,8260],[4520,8261],[4499,8302],[4511,8312],[4493,8329],[4502,8343],[4494,8370],[4509,8394],[4532,8396],[4548,8414],[4567,8421],[4557,8385],[4560,8371],[4578,8366],[4534,8326],[4537,8301],[4550,8288],[4572,8278],[4588,8282],[4571,8267],[4590,8265],[4623,8285],[4634,8280],[4649,8292],[4673,8263],[4730,8277],[4742,8288],[4794,8300],[4802,8283],[4832,8284],[4844,8304],[4880,8304],[4879,8328],[4872,8358],[4875,8383],[4893,8413],[4940,8422],[4939,8394],[4952,8388],[4972,8399],[4970,8426],[4977,8447],[4960,8445],[4947,8455],[4945,8484],[4964,8488],[4976,8501],[4972,8521],[4944,8516],[4927,8523],[4917,8512],[4911,8534],[4886,8542],[4875,8539],[4857,8518],[4836,8521],[4841,8535],[4856,8529],[4884,8547],[4889,8592],[4880,8607],[4883,8624],[4875,8639],[4883,8663],[4913,8668],[4920,8686],[4943,8695],[4984,8741],[4998,8739],[5001,8771],[4977,8786],[4924,8782],[4913,8768],[4898,8773],[4874,8739],[4887,8721],[4866,8694],[4834,8673],[4822,8675],[4803,8660],[4776,8628],[4768,8632],[4767,8595],[4760,8562],[4774,8541],[4784,8541],[4809,8523],[4814,8509],[4807,8483],[4753,8458],[4749,8437],[4738,8427],[4757,8399],[4738,8357],[4743,8391],[4721,8351],[4687,8354],[4673,8340],[4678,8328],[4701,8312],[4698,8306],[4672,8322],[4636,8324],[4639,8334],[4623,8359],[4634,8375],[4619,8386],[4610,8409],[4594,8430],[4585,8466],[4563,8497],[4563,8485],[4540,8473],[4505,8443],[4478,8432],[4447,8437],[4416,8464],[4419,8480],[4407,8483],[4408,8497],[4421,8512],[4408,8511],[4409,8528],[4392,8565],[4415,8564],[4401,8581],[4413,8587],[4396,8600],[4415,8610],[4420,8624],[4447,8632],[4458,8650],[4493,8659],[4500,8684],[4515,8687],[4525,8677],[4540,8683],[4552,8668],[4592,8691],[4581,8692],[4547,8677],[4536,8689],[4554,8709],[4575,8722],[4573,8741],[4585,8739],[4626,8754],[4610,8758],[4631,8794],[4619,8790],[4632,8817],[4642,8816],[4655,8842],[4668,8845],[4679,8866],[4714,8882],[4690,8886],[4721,8894],[4705,8897],[4771,8917],[4741,8917],[4744,8928],[4769,8954],[4750,8949],[4780,8977],[4787,8965],[4837,8988],[4835,9012],[4860,8993],[4861,9011],[4915,9014],[4913,9036],[4941,9040],[4929,9022],[4951,9023],[4931,9009],[4933,9000],[4959,9025],[4960,9053],[4970,9039],[4984,9053],[4995,9048],[5010,9060],[5025,9052],[4993,9025],[4994,9003],[5031,9045],[5040,9049],[5035,9018],[5065,9043],[5066,9057],[5095,9051],[5074,9024],[5086,9020],[5102,9045],[5137,9036],[5169,9013],[5142,9002],[5097,9005],[5152,8989],[5191,8982],[5198,8997],[5229,8981],[5201,8980],[5241,8968],[5234,8958],[5261,8967],[5275,8959],[5313,8955],[5363,8931],[5386,8913],[5432,8896],[5462,8880],[5472,8846],[5445,8816],[5412,8802],[5371,8800],[5340,8810],[5296,8816],[5279,8826],[5240,8832],[5204,8851],[5224,8822],[5270,8801],[5282,8781],[5268,8765],[5283,8741],[5278,8726],[5297,8714],[5312,8720],[5310,8748],[5327,8744],[5344,8756],[5374,8740],[5419,8726],[5443,8744],[5423,8767],[5427,8777],[5455,8795],[5471,8799],[5508,8834],[5507,8815],[5527,8817],[5554,8790],[5553,8811],[5564,8829],[5558,8849],[5544,8854],[5556,8908],[5529,8926],[5588,8923],[5606,8918],[5629,8887],[5589,8881],[5577,8861],[5596,8853],[5604,8839],[5625,8836],[5659,8845],[5662,8873],[5690,8881],[5760,8921],[5791,8925],[5827,8942],[5854,8944],[5835,8929],[5843,8913],[5869,8904],[5871,8915],[5901,8928],[5941,8924],[5960,8939],[5987,8946],[5992,8959],[6003,8934],[5994,8916],[6010,8912],[6013,8929],[6047,8943],[6024,8976],[6034,8984],[6007,8983],[6003,8993],[5978,9003],[5976,9016],[6001,9017],[6034,8994],[6034,8984],[6043,8991],[6097,8985],[6141,8975],[6188,8950],[6236,8936],[6249,8921],[6223,8855],[6201,8819],[6146,8748],[6145,8693],[6137,8621],[6125,8567],[6103,8501],[6076,8442],[6054,8381],[6041,8382],[6031,8337],[6003,8319],[6000,8294],[6028,8269],[6033,8252],[6017,8240],[6015,8217],[6023,8180],[6059,8158],[6050,8141],[6005,8140],[5959,8152],[5918,8149],[5885,8155],[5846,8157],[5821,8152],[5785,8120],[5772,8100],[5769,8073],[5759,8055],[5746,8015],[5745,7994],[5664,7945],[5656,7948],[5643,7921],[5629,7902],[5655,7882],[5651,7851],[5684,7809],[5663,7787],[5645,7790],[5625,7807],[5597,7823],[5599,7833],[5575,7842],[5547,7834],[5543,7841],[5503,7858],[5477,7858],[5451,7869],[5431,7864],[5431,7864],[5402,7891],[5378,7901],[5369,7911],[5331,7929],[5365,7933],[5361,7946],[5372,7960],[5389,7963],[5372,7972],[5365,7983],[5410,7996],[5410,8005],[5360,7999],[5353,7991],[5311,7982],[5279,7965],[5294,7935],[5331,7938],[5327,7924],[5303,7926],[5269,7912],[5254,7900],[5243,7908],[5242,7925],[5223,7935],[5222,7945],[5249,7956],[5233,7967],[5211,7961],[5185,7968],[5212,7980],[5167,7981],[5132,7944],[5126,7917],[5111,7914],[5098,7898],[5096,7869],[5083,7865],[5068,7831],[5081,7802],[5111,7788],[5108,7780],[5086,7783],[5065,7779],[5054,7767],[5043,7759],[5039,7756]]],[[[4772,9585],[4806,9562],[4812,9536],[4868,9529],[4857,9522],[4888,9516],[4884,9504],[4864,9506],[4814,9491],[4816,9467],[4802,9465],[4790,9429],[4777,9427],[4750,9371],[4706,9399],[4678,9411],[4664,9432],[4700,9442],[4751,9449],[4749,9453],[4659,9446],[4655,9465],[4697,9469],[4720,9483],[4753,9484],[4709,9491],[4691,9508],[4678,9493],[4686,9486],[4663,9475],[4638,9474],[4609,9501],[4601,9490],[4613,9475],[4582,9489],[4565,9512],[4584,9508],[4587,9532],[4570,9563],[4576,9569],[4603,9582],[4618,9570],[4661,9584],[4651,9565],[4663,9562],[4683,9580],[4704,9567],[4711,9547],[4736,9520],[4725,9546],[4717,9584],[4734,9597],[4750,9584],[4772,9585]]],[[[5015,9555],[4969,9546],[4963,9538],[4929,9540],[4929,9553],[4867,9551],[4849,9557],[4835,9548],[4833,9566],[4898,9573],[4899,9580],[4808,9574],[4790,9585],[4809,9594],[4785,9601],[4794,9617],[4824,9598],[4815,9616],[4832,9608],[4855,9621],[4859,9637],[4869,9606],[4898,9611],[4913,9593],[4924,9626],[4939,9623],[4932,9604],[4971,9612],[5044,9604],[5054,9582],[5015,9567],[5015,9555]]],[[[5897,9674],[5887,9683],[5918,9678],[5932,9698],[5973,9694],[5970,9702],[5960,9718],[5997,9721],[5978,9689],[6015,9681],[6012,9672],[5955,9687],[5963,9668],[5980,9664],[5973,9643],[5926,9662],[5933,9678],[5897,9674]]],[[[6022,9661],[6069,9668],[6074,9700],[6085,9710],[6128,9709],[6122,9702],[6084,9700],[6081,9634],[6051,9620],[5998,9628],[6005,9647],[6051,9650],[6022,9661]]],[[[6269,9396],[6283,9372],[6230,9343],[6060,9297],[6044,9286],[6028,9262],[5999,9256],[5995,9245],[5967,9253],[5982,9233],[5968,9230],[5954,9203],[5895,9150],[5884,9123],[5887,9101],[5905,9066],[5950,9037],[5936,9025],[5903,9029],[5885,9038],[5878,9028],[5858,9040],[5823,9045],[5837,9060],[5821,9068],[5814,9050],[5792,9067],[5806,9074],[5771,9082],[5767,9099],[5781,9115],[5797,9111],[5808,9142],[5803,9154],[5823,9155],[5819,9170],[5859,9197],[5833,9205],[5867,9218],[5884,9245],[5910,9247],[5888,9257],[5914,9261],[5899,9268],[5922,9274],[5915,9281],[5933,9301],[5953,9297],[5948,9308],[5967,9312],[5982,9331],[6012,9333],[6028,9344],[6052,9342],[6052,9354],[6090,9349],[6139,9356],[6185,9372],[6224,9395],[6269,9396]]],[[[5627,9613],[5658,9617],[5679,9631],[5700,9627],[5715,9636],[5696,9645],[5737,9662],[5776,9638],[5754,9629],[5718,9626],[5723,9608],[5742,9591],[5755,9599],[5768,9587],[5727,9590],[5711,9617],[5640,9604],[5627,9613]]],[[[3785,8707],[3755,8691],[3733,8686],[3704,8672],[3661,8679],[3632,8694],[3587,8692],[3616,8710],[3598,8726],[3599,8736],[3547,8742],[3614,8750],[3592,8756],[3611,8768],[3573,8775],[3552,8767],[3533,8772],[3557,8785],[3565,8806],[3593,8795],[3575,8817],[3591,8819],[3628,8795],[3623,8775],[3634,8760],[3647,8781],[3659,8783],[3654,8800],[3664,8802],[3677,8784],[3701,8806],[3713,8797],[3725,8822],[3737,8794],[3749,8805],[3770,8805],[3769,8821],[3784,8822],[3803,8803],[3819,8815],[3812,8798],[3823,8799],[3818,8783],[3855,8772],[3854,8747],[3830,8732],[3827,8719],[3785,8707]]],[[[3972,8209],[3982,8231],[3956,8248],[3974,8257],[3961,8275],[3966,8279],[4006,8277],[4016,8292],[4000,8291],[4012,8313],[4038,8322],[4056,8314],[4070,8318],[4092,8292],[4081,8269],[4068,8266],[4079,8224],[4068,8193],[4036,8191],[3999,8169],[3966,8164],[3950,8181],[3964,8191],[3947,8190],[3972,8209]]],[[[4048,8442],[4071,8454],[4067,8441],[4076,8405],[4089,8412],[4084,8425],[4108,8459],[4118,8455],[4155,8460],[4162,8481],[4181,8479],[4160,8445],[4135,8429],[4144,8424],[4130,8410],[4152,8419],[4198,8418],[4203,8409],[4181,8372],[4179,8359],[4162,8350],[4192,8344],[4207,8330],[4223,8291],[4239,8285],[4253,8270],[4265,8229],[4255,8221],[4293,8223],[4307,8205],[4302,8189],[4284,8179],[4281,8169],[4297,8162],[4295,8152],[4263,8137],[4250,8140],[4216,8131],[4216,8139],[4183,8131],[4171,8137],[4152,8130],[4148,8117],[4115,8121],[4102,8107],[4095,8116],[4133,8155],[4166,8154],[4176,8170],[4151,8163],[4126,8177],[4110,8170],[4100,8183],[4132,8197],[4134,8222],[4121,8241],[4133,8235],[4161,8241],[4173,8271],[4160,8270],[4148,8286],[4155,8302],[4139,8297],[4126,8303],[4127,8282],[4104,8300],[4119,8327],[4098,8343],[4105,8324],[4085,8319],[4090,8338],[4085,8348],[4092,8365],[4069,8359],[4073,8379],[4083,8379],[4088,8397],[4063,8392],[4067,8411],[4063,8428],[4044,8417],[4048,8442]]]]}},{"type":"Feature","id":"OC","properties":{"hc-group":"admin0","hc-middle-x":0.34,"hc-middle-y":0.46,"hc-key":"oc","hc-a2":"OC","abbrev-a3":"OCA","iso-a2":"OC","name":"Oceania"},"geometry":{"type":"MultiPolygon","coordinates":[[[[8861,6273],[8858,6285],[8876,6279],[8880,6265],[8890,6274],[8910,6251],[8861,6273]]],[[[8303,5422],[8316,5416],[8298,5405],[8276,5406],[8272,5416],[8303,5422]]],[[[9069,5923],[9115,5893],[9127,5878],[9149,5866],[9183,5837],[9179,5835],[9138,5856],[9107,5875],[9090,5893],[9069,5923]]],[[[8092,6165],[8080,6162],[8090,6179],[8100,6175],[8115,6180],[8124,6172],[8108,6158],[8092,6165]]],[[[8803,6349],[8800,6358],[8841,6318],[8847,6306],[8831,6294],[8835,6307],[8825,6311],[8821,6322],[8807,6335],[8803,6349]]],[[[8680,6431],[8674,6439],[8709,6424],[8720,6416],[8725,6426],[8732,6408],[8745,6420],[8740,6402],[8759,6384],[8752,6367],[8746,6387],[8734,6404],[8699,6426],[8680,6431]]],[[[9170,6069],[9180,6034],[9192,6023],[9182,6019],[9171,6035],[9172,6051],[9161,6047],[9156,6056],[9156,6078],[9162,6062],[9170,6069]]],[[[9019,6225],[9012,6209],[9028,6191],[9014,6194],[9000,6209],[9012,6209],[9018,6224],[9007,6222],[8987,6240],[8979,6265],[8980,6277],[9002,6230],[9019,6225]]],[[[8937,6241],[8963,6246],[8984,6224],[8980,6217],[8956,6222],[8950,6236],[8937,6241]]],[[[8402,6242],[8402,6307],[8402,6433],[8434,6419],[8475,6409],[8493,6415],[8485,6403],[8506,6397],[8521,6382],[8544,6366],[8541,6350],[8563,6345],[8580,6335],[8592,6334],[8603,6323],[8604,6313],[8578,6311],[8584,6290],[8612,6273],[8625,6244],[8642,6246],[8644,6231],[8667,6226],[8673,6239],[8689,6233],[8695,6212],[8677,6230],[8659,6221],[8665,6214],[8685,6209],[8677,6205],[8691,6199],[8673,6195],[8660,6205],[8608,6211],[8580,6231],[8552,6272],[8543,6277],[8505,6280],[8483,6287],[8489,6275],[8480,6273],[8475,6259],[8461,6265],[8473,6246],[8451,6235],[8402,6242]]],[[[8910,6289],[8897,6292],[8897,6292],[8908,6291],[8910,6289],[8910,6289]]],[[[8910,6289],[8924,6286],[8957,6265],[8927,6275],[8910,6289],[8910,6289]]],[[[9523,5984],[9518,5985],[9518,5985],[9521,5987],[9523,5984],[9523,5984],[9523,5984]]],[[[9523,5984],[9532,5984],[9530,5973],[9523,5984],[9523,5984],[9523,5984]]],[[[9518,5985],[9499,5973],[9496,5966],[9496,5966],[9496,5969],[9480,5961],[9469,5978],[9474,5985],[9465,5998],[9476,5992],[9486,5996],[9512,5986],[9518,5985],[9518,5985]]],[[[9496,5963],[9495,5964],[9496,5966],[9496,5966],[9496,5963],[9496,5963]]],[[[9496,5963],[9505,5946],[9496,5947],[9496,5963],[9496,5963]]],[[[9535,6016],[9534,6016],[9534,6016],[9534,6016],[9534,6016],[9535,6016],[9535,6016]]],[[[9535,6016],[9546,6023],[9544,6006],[9541,6016],[9535,6016],[9535,6016]]],[[[9202,6049],[9201,6053],[9201,6053],[9201,6053],[9201,6053],[9202,6049],[9202,6049]]],[[[9202,6049],[9206,6028],[9194,6029],[9203,6037],[9202,6049],[9202,6049]]],[[[8549,5972],[8566,5956],[8563,5945],[8591,5936],[8599,5922],[8637,5915],[8641,5902],[8627,5899],[8644,5883],[8659,5842],[8668,5835],[8663,5851],[8676,5866],[8691,5834],[8691,5812],[8702,5808],[8710,5793],[8719,5793],[8746,5755],[8757,5752],[8766,5762],[8757,5738],[8761,5698],[8771,5687],[8768,5666],[8773,5641],[8755,5581],[8753,5557],[8741,5535],[8742,5526],[8721,5512],[8694,5464],[8689,5436],[8672,5412],[8664,5377],[8667,5358],[8652,5348],[8617,5347],[8596,5338],[8575,5319],[8563,5314],[8562,5302],[8544,5319],[8518,5323],[8519,5344],[8477,5312],[8443,5328],[8422,5327],[8383,5345],[8365,5369],[8369,5387],[8351,5418],[8343,5423],[8320,5419],[8330,5450],[8316,5470],[8304,5436],[8280,5433],[8244,5446],[8231,5478],[8220,5496],[8205,5502],[8205,5518],[8186,5537],[8185,5530],[8161,5541],[8144,5539],[8113,5557],[8049,5550],[7999,5531],[7967,5532],[7906,5503],[7901,5489],[7888,5477],[7830,5481],[7785,5477],[7763,5457],[7751,5460],[7737,5445],[7717,5440],[7686,5440],[7666,5447],[7656,5460],[7641,5463],[7637,5490],[7646,5486],[7657,5498],[7658,5551],[7643,5578],[7637,5598],[7637,5621],[7624,5652],[7613,5665],[7600,5655],[7612,5678],[7609,5690],[7588,5719],[7576,5743],[7583,5769],[7592,5777],[7591,5792],[7601,5809],[7598,5837],[7609,5860],[7613,5839],[7627,5860],[7655,5875],[7649,5895],[7665,5884],[7691,5900],[7707,5894],[7730,5905],[7750,5908],[7761,5918],[7772,5914],[7813,5927],[7829,5945],[7838,5963],[7853,5972],[7849,5999],[7872,6020],[7889,5991],[7888,6017],[7894,6029],[7914,6027],[7916,6059],[7930,6057],[7932,6068],[7944,6066],[7935,6083],[7962,6082],[7989,6105],[8001,6100],[8025,6076],[8022,6063],[8036,6074],[8073,6071],[8060,6085],[8070,6096],[8076,6114],[8086,6118],[8083,6128],[8108,6151],[8139,6147],[8158,6152],[8158,6167],[8131,6177],[8155,6185],[8172,6165],[8191,6165],[8209,6155],[8219,6158],[8228,6149],[8252,6157],[8269,6170],[8269,6158],[8283,6146],[8260,6119],[8261,6107],[8282,6103],[8268,6091],[8268,6103],[8253,6098],[8240,6069],[8274,6046],[8307,6030],[8319,6016],[8345,6010],[8373,5986],[8397,5993],[8415,6035],[8422,6067],[8418,6082],[8420,6141],[8429,6153],[8436,6176],[8438,6209],[8450,6193],[8457,6161],[8467,6157],[8463,6147],[8474,6138],[8477,6104],[8489,6082],[8505,6092],[8510,6080],[8530,6069],[8528,6051],[8532,6024],[8554,5988],[8549,5972]]],[[[8508,5238],[8511,5255],[8523,5244],[8562,5232],[8603,5241],[8612,5253],[8601,5276],[8617,5274],[8622,5257],[8616,5255],[8618,5191],[8608,5191],[8607,5159],[8595,5168],[8575,5144],[8550,5147],[8528,5181],[8526,5204],[8518,5213],[8508,5238]]],[[[8702,6364],[8717,6368],[8712,6387],[8739,6387],[8734,6364],[8726,6363],[8729,6349],[8712,6343],[8681,6325],[8656,6324],[8647,6331],[8620,6340],[8613,6349],[8637,6349],[8642,6365],[8654,6372],[8668,6361],[8671,6347],[8697,6351],[8702,6364]]],[[[9245,5037],[9213,5030],[9204,5039],[9196,5033],[9204,5019],[9179,5013],[9191,5026],[9188,5052],[9160,5051],[9152,5058],[9166,5090],[9208,5129],[9247,5147],[9288,5182],[9299,5208],[9316,5223],[9317,5241],[9333,5255],[9344,5245],[9347,5227],[9366,5240],[9367,5227],[9378,5238],[9375,5219],[9382,5212],[9360,5185],[9352,5169],[9336,5152],[9346,5137],[9325,5136],[9295,5121],[9291,5099],[9274,5069],[9276,5062],[9245,5037]]],[[[9412,5216],[9391,5227],[9401,5239],[9409,5262],[9401,5275],[9367,5293],[9366,5300],[9390,5312],[9398,5349],[9384,5387],[9384,5401],[9374,5399],[9346,5434],[9349,5440],[9334,5459],[9345,5462],[9348,5447],[9370,5442],[9390,5422],[9388,5409],[9405,5401],[9418,5402],[9427,5387],[9432,5353],[9474,5342],[9490,5356],[9507,5350],[9499,5322],[9487,5303],[9473,5304],[9458,5291],[9456,5266],[9431,5229],[9412,5216]]],[[[8896,6292],[8876,6294],[8857,6312],[8874,6307],[8894,6292],[8896,6292],[8896,6292]]],[[[9534,6016],[9528,6016],[9511,6007],[9508,6019],[9531,6027],[9545,6029],[9534,6016],[9534,6016],[9534,6016]]],[[[9201,6053],[9192,6053],[9200,6055],[9201,6053],[9201,6053],[9201,6053]]]]}},{"type":"Feature","id":"AF","properties":{"hc-group":"admin0","hc-middle-x":0.66,"hc-middle-y":0.54,"hc-key":"af","hc-a2":"AF","abbrev-a3":"AFR","iso-a2":"AF","name":"Africa"},"geometry":{"type":"MultiPolygon","coordinates":[[[[3731,7363],[3734,7372],[3752,7352],[3758,7360],[3781,7367],[3802,7353],[3797,7341],[3790,7349],[3772,7354],[3749,7350],[3731,7363]]],[[[4096,7606],[4096,7606],[4096,7606],[4115,7584],[4129,7581],[4129,7581],[4129,7581],[4168,7587],[4180,7579],[4203,7580],[4220,7594],[4286,7625],[4333,7629],[4341,7636],[4396,7639],[4409,7631],[4437,7639],[4458,7639],[4472,7645],[4488,7637],[4514,7642],[4545,7654],[4562,7633],[4580,7645],[4583,7638],[4564,7620],[4567,7604],[4580,7596],[4583,7584],[4567,7561],[4553,7553],[4559,7533],[4580,7536],[4584,7517],[4618,7504],[4648,7507],[4702,7490],[4711,7466],[4727,7454],[4766,7448],[4790,7438],[4813,7422],[4824,7422],[4844,7439],[4848,7452],[4841,7468],[4845,7483],[4860,7495],[4891,7507],[4907,7508],[4934,7498],[4934,7488],[4964,7477],[4990,7476],[4996,7462],[5015,7465],[5059,7457],[5109,7439],[5123,7443],[5148,7461],[5194,7462],[5199,7447],[5206,7454],[5230,7446],[5261,7455],[5261,7455],[5261,7455],[5269,7434],[5279,7404],[5281,7396],[5250,7321],[5256,7305],[5300,7223],[5305,7191],[5340,7164],[5340,7151],[5352,7126],[5349,7112],[5353,7075],[5363,7063],[5389,7044],[5400,7022],[5409,6983],[5423,6958],[5435,6980],[5432,6957],[5440,6948],[5466,6939],[5481,6919],[5499,6908],[5513,6886],[5530,6875],[5531,6861],[5513,6852],[5534,6842],[5544,6825],[5557,6815],[5578,6814],[5602,6828],[5621,6822],[5648,6836],[5695,6839],[5734,6849],[5749,6861],[5764,6856],[5758,6837],[5760,6818],[5753,6811],[5750,6786],[5734,6757],[5721,6742],[5697,6688],[5665,6639],[5609,6580],[5565,6554],[5534,6527],[5493,6483],[5480,6463],[5438,6421],[5406,6359],[5396,6332],[5403,6319],[5411,6341],[5419,6321],[5410,6312],[5418,6300],[5411,6280],[5428,6282],[5410,6265],[5421,6239],[5423,6217],[5445,6205],[5450,6191],[5444,6167],[5449,6128],[5447,6108],[5456,6083],[5449,6053],[5429,6025],[5406,6011],[5370,5996],[5346,5981],[5328,5960],[5277,5920],[5275,5903],[5284,5894],[5289,5872],[5298,5862],[5300,5843],[5296,5798],[5299,5790],[5288,5775],[5247,5759],[5222,5746],[5223,5705],[5207,5651],[5189,5638],[5172,5619],[5149,5577],[5104,5531],[5076,5506],[5035,5483],[5010,5481],[5011,5474],[4989,5475],[4986,5468],[4950,5475],[4944,5471],[4919,5475],[4893,5462],[4870,5463],[4842,5448],[4810,5470],[4794,5469],[4799,5479],[4780,5514],[4793,5519],[4790,5551],[4763,5593],[4749,5634],[4716,5670],[4705,5690],[4692,5739],[4690,5769],[4681,5789],[4683,5829],[4678,5847],[4665,5862],[4649,5891],[4642,5912],[4616,5956],[4604,5973],[4600,5991],[4603,6023],[4601,6043],[4608,6049],[4616,6074],[4623,6113],[4656,6149],[4662,6183],[4660,6196],[4643,6224],[4637,6242],[4649,6252],[4648,6265],[4633,6296],[4632,6307],[4616,6330],[4612,6357],[4603,6374],[4546,6430],[4528,6454],[4530,6469],[4521,6471],[4516,6485],[4528,6497],[4530,6543],[4543,6564],[4548,6599],[4538,6624],[4519,6615],[4518,6642],[4430,6635],[4420,6644],[4412,6665],[4399,6684],[4385,6695],[4369,6697],[4311,6692],[4290,6687],[4284,6679],[4265,6678],[4232,6661],[4194,6647],[4186,6652],[4138,6662],[4083,6656],[4036,6636],[4012,6643],[3982,6659],[3949,6689],[3921,6705],[3907,6718],[3874,6730],[3885,6731],[3874,6750],[3868,6748],[3863,6782],[3855,6795],[3830,6808],[3820,6830],[3802,6837],[3800,6846],[3783,6836],[3780,6846],[3792,6845],[3803,6860],[3780,6855],[3763,6871],[3760,6901],[3768,6908],[3750,6940],[3769,6974],[3771,6999],[3784,7039],[3778,7070],[3769,7083],[3779,7107],[3758,7136],[3756,7155],[3769,7172],[3791,7219],[3817,7245],[3820,7269],[3831,7294],[3854,7308],[3874,7346],[3917,7359],[3944,7380],[3971,7417],[3964,7435],[3965,7458],[3980,7478],[3983,7496],[4004,7519],[4035,7531],[4054,7544],[4070,7572],[4081,7602],[4096,7606]]],[[[5707,5964],[5699,5945],[5673,5861],[5665,5845],[5654,5798],[5641,5765],[5615,5756],[5593,5745],[5583,5744],[5550,5763],[5541,5781],[5542,5810],[5530,5830],[5526,5848],[5535,5876],[5546,5889],[5563,5919],[5563,5931],[5551,5964],[5548,5993],[5562,6016],[5563,6032],[5574,6030],[5587,6039],[5615,6046],[5637,6061],[5668,6094],[5663,6103],[5673,6115],[5689,6114],[5693,6140],[5704,6158],[5713,6138],[5724,6126],[5730,6103],[5733,6075],[5740,6054],[5733,6038],[5723,6054],[5715,6051],[5721,6021],[5709,5999],[5707,5964]]]]}},{"type":"Feature","id":"AS","properties":{"hc-group":"admin0","hc-middle-x":0.44,"hc-middle-y":0.46,"hc-key":"as","hc-a2":"AS","abbrev-a3":"ASA","iso-a2":"AS","name":"Asia"},"geometry":{"type":"MultiPolygon","coordinates":[[[[9585,9083],[9623,9065],[9609,9055],[9567,9047],[9548,9051],[9548,9051],[9515,9041],[9517,9065],[9548,9080],[9548,9080],[9548,9080],[9548,9080],[9548,9080],[9585,9083]]],[[[9558,8755],[9549,8750],[9549,8750],[9534,8739],[9497,8731],[9470,8740],[9443,8741],[9453,8727],[9476,8736],[9475,8720],[9491,8710],[9499,8717],[9510,8698],[9508,8673],[9529,8663],[9538,8640],[9518,8624],[9470,8634],[9411,8613],[9387,8599],[9373,8599],[9314,8556],[9279,8541],[9267,8517],[9254,8521],[9233,8543],[9199,8543],[9168,8533],[9141,8511],[9149,8539],[9112,8522],[9103,8509],[9093,8523],[9068,8520],[9054,8497],[9057,8478],[9072,8469],[9095,8485],[9097,8469],[9084,8467],[9064,8451],[9052,8475],[9032,8460],[9020,8435],[9035,8421],[9041,8430],[9059,8419],[9044,8405],[9043,8379],[9056,8378],[9060,8355],[9051,8348],[9037,8359],[9024,8353],[9013,8331],[9024,8300],[9012,8286],[8983,8287],[8963,8273],[8956,8247],[8963,8230],[8950,8236],[8921,8222],[8911,8185],[8865,8143],[8856,8195],[8847,8223],[8830,8318],[8833,8344],[8845,8379],[8863,8391],[8873,8407],[8867,8422],[8887,8423],[8932,8449],[8957,8481],[9017,8527],[9018,8537],[9064,8563],[9080,8578],[9083,8620],[9095,8628],[9115,8626],[9096,8638],[9057,8631],[9051,8586],[9032,8593],[9020,8579],[8966,8544],[8974,8564],[8956,8560],[8955,8573],[8970,8587],[8971,8605],[8947,8593],[8942,8603],[8887,8598],[8863,8586],[8863,8572],[8813,8534],[8791,8512],[8787,8497],[8813,8496],[8830,8489],[8786,8477],[8766,8485],[8753,8471],[8736,8477],[8707,8468],[8688,8481],[8680,8501],[8655,8508],[8632,8498],[8642,8483],[8606,8492],[8595,8485],[8559,8492],[8488,8493],[8439,8480],[8419,8458],[8399,8448],[8387,8425],[8334,8388],[8312,8362],[8278,8333],[8232,8302],[8248,8289],[8281,8290],[8275,8258],[8288,8258],[8286,8272],[8307,8263],[8295,8247],[8312,8249],[8331,8266],[8336,8278],[8367,8278],[8380,8261],[8415,8232],[8406,8225],[8415,8184],[8400,8171],[8386,8129],[8392,8111],[8378,8049],[8355,8029],[8330,7995],[8317,7967],[8252,7900],[8230,7868],[8194,7846],[8172,7839],[8146,7846],[8147,7862],[8120,7847],[8099,7825],[8091,7826],[8068,7799],[8070,7774],[8056,7769],[8039,7752],[8006,7736],[8004,7716],[8031,7698],[8059,7652],[8066,7612],[8055,7581],[8037,7567],[8022,7577],[8001,7568],[8005,7558],[7981,7553],[7986,7520],[7966,7519],[7980,7547],[7964,7552],[7958,7566],[7985,7605],[7970,7628],[7976,7644],[7988,7640],[7976,7660],[7960,7673],[7938,7666],[7935,7678],[7922,7680],[7941,7701],[7945,7721],[7919,7739],[7884,7738],[7855,7725],[7861,7719],[7819,7701],[7837,7723],[7823,7724],[7830,7740],[7852,7762],[7839,7774],[7819,7777],[7797,7752],[7771,7741],[7756,7717],[7741,7708],[7727,7718],[7712,7698],[7728,7681],[7751,7682],[7754,7652],[7768,7647],[7807,7673],[7831,7657],[7847,7662],[7864,7656],[7853,7637],[7845,7642],[7807,7624],[7805,7614],[7774,7595],[7761,7577],[7774,7561],[7792,7553],[7811,7510],[7810,7499],[7838,7476],[7843,7462],[7835,7454],[7843,7442],[7813,7430],[7806,7420],[7825,7423],[7834,7413],[7849,7416],[7856,7435],[7855,7408],[7844,7413],[7842,7383],[7831,7390],[7833,7360],[7813,7349],[7795,7316],[7771,7309],[7772,7276],[7764,7261],[7739,7237],[7719,7226],[7714,7216],[7694,7213],[7682,7191],[7662,7185],[7631,7187],[7623,7176],[7605,7168],[7601,7185],[7594,7166],[7581,7168],[7573,7149],[7562,7157],[7549,7150],[7511,7142],[7498,7131],[7506,7115],[7488,7108],[7481,7129],[7483,7146],[7445,7158],[7432,7144],[7413,7140],[7421,7135],[7388,7117],[7390,7108],[7374,7101],[7362,7070],[7376,7049],[7386,7044],[7392,7024],[7429,6988],[7438,6987],[7454,6962],[7470,6917],[7468,6902],[7475,6880],[7467,6880],[7468,6853],[7462,6842],[7410,6813],[7399,6813],[7387,6788],[7359,6776],[7346,6761],[7337,6767],[7340,6797],[7321,6819],[7294,6820],[7277,6862],[7264,6867],[7250,6881],[7221,6882],[7225,6905],[7198,6903],[7197,6867],[7192,6860],[7172,6806],[7174,6779],[7192,6781],[7195,6762],[7204,6752],[7202,6729],[7226,6709],[7242,6709],[7288,6666],[7298,6649],[7295,6618],[7297,6595],[7307,6585],[7320,6588],[7313,6577],[7323,6551],[7300,6546],[7295,6554],[7234,6592],[7235,6604],[7218,6622],[7213,6651],[7207,6657],[7207,6684],[7200,6697],[7185,6701],[7189,6717],[7164,6744],[7153,6746],[7147,6736],[7145,6777],[7154,6801],[7143,6804],[7145,6826],[7154,6823],[7160,6839],[7149,6851],[7127,6857],[7154,6855],[7158,6868],[7141,6869],[7146,6893],[7155,6896],[7145,6912],[7132,6947],[7129,6977],[7105,7021],[7097,6996],[7075,6987],[7062,6972],[7026,6981],[7038,7027],[7024,7065],[7011,7067],[7005,7080],[7018,7083],[7002,7104],[6991,7096],[6957,7146],[6961,7156],[6945,7186],[6935,7177],[6921,7186],[6927,7167],[6918,7158],[6905,7162],[6880,7151],[6851,7148],[6843,7157],[6820,7148],[6809,7137],[6814,7121],[6796,7100],[6768,7091],[6751,7077],[6728,7048],[6703,7028],[6676,7011],[6676,6998],[6645,6990],[6637,6973],[6616,6970],[6610,6951],[6618,6901],[6613,6875],[6604,6862],[6604,6810],[6590,6811],[6576,6786],[6580,6782],[6556,6771],[6551,6754],[6535,6745],[6520,6754],[6507,6769],[6498,6801],[6477,6852],[6467,6862],[6456,6886],[6449,6917],[6439,6941],[6415,6982],[6402,7043],[6392,7096],[6399,7116],[6388,7153],[6389,7167],[6377,7161],[6382,7151],[6376,7138],[6343,7123],[6316,7136],[6283,7171],[6319,7179],[6326,7191],[6306,7185],[6273,7199],[6265,7211],[6236,7226],[6230,7244],[6216,7249],[6209,7273],[6187,7266],[6153,7263],[6125,7266],[6123,7261],[6093,7263],[6070,7256],[5985,7272],[5966,7272],[5941,7279],[5932,7313],[5926,7322],[5913,7312],[5893,7317],[5859,7294],[5852,7308],[5842,7301],[5826,7317],[5802,7330],[5797,7338],[5766,7349],[5750,7385],[5735,7388],[5745,7395],[5728,7419],[5714,7414],[5695,7425],[5694,7415],[5673,7413],[5678,7395],[5666,7399],[5672,7381],[5706,7324],[5724,7313],[5732,7291],[5744,7292],[5742,7279],[5763,7291],[5772,7282],[5772,7253],[5763,7233],[5777,7233],[5779,7224],[5801,7228],[5839,7226],[5875,7255],[5903,7282],[5913,7298],[5913,7254],[5920,7239],[5936,7222],[5984,7209],[6014,7168],[6000,7145],[5981,7126],[5989,7117],[5980,7112],[5964,7118],[5952,7093],[5956,7071],[5929,7065],[5919,7045],[5908,7039],[5904,7025],[5892,7037],[5879,7026],[5874,7010],[5844,7010],[5802,6994],[5789,6980],[5791,6969],[5766,6957],[5742,6952],[5699,6935],[5687,6922],[5667,6922],[5649,6910],[5629,6903],[5598,6901],[5575,6883],[5548,6879],[5527,6897],[5523,6923],[5511,6921],[5521,6936],[5511,6972],[5515,6982],[5506,7006],[5490,7000],[5486,7007],[5500,7015],[5499,7024],[5482,7038],[5467,7061],[5459,7086],[5447,7100],[5421,7115],[5405,7141],[5401,7160],[5405,7179],[5386,7217],[5359,7232],[5348,7250],[5344,7267],[5329,7274],[5334,7287],[5301,7332],[5291,7351],[5274,7352],[5284,7398],[5281,7396],[5279,7404],[5261,7455],[5261,7455],[5276,7476],[5283,7504],[5313,7560],[5313,7610],[5308,7620],[5320,7629],[5315,7640],[5295,7627],[5271,7635],[5246,7614],[5220,7610],[5197,7627],[5158,7639],[5149,7617],[5128,7613],[5112,7621],[5106,7634],[5087,7638],[5088,7644],[5057,7641],[5067,7652],[5055,7655],[5056,7676],[5027,7686],[5047,7691],[5041,7701],[5050,7708],[5038,7720],[5046,7731],[5022,7727],[5013,7748],[5024,7743],[5039,7756],[5041,7759],[5043,7759],[5113,7760],[5119,7771],[5115,7788],[5174,7783],[5204,7805],[5235,7815],[5276,7813],[5283,7818],[5300,7802],[5313,7805],[5327,7788],[5332,7793],[5360,7781],[5383,7777],[5415,7784],[5435,7777],[5473,7793],[5484,7808],[5476,7837],[5457,7852],[5431,7864],[5431,7864],[5431,7864],[5433,7869],[5451,7869],[5477,7858],[5503,7858],[5543,7841],[5547,7834],[5575,7842],[5599,7833],[5597,7823],[5625,7807],[5645,7790],[5663,7787],[5684,7809],[5714,7767],[5736,7761],[5709,7748],[5702,7711],[5692,7706],[5695,7674],[5700,7664],[5730,7656],[5758,7634],[5782,7628],[5828,7639],[5844,7637],[5838,7668],[5843,7707],[5831,7722],[5831,7743],[5806,7747],[5812,7779],[5835,7767],[5853,7770],[5864,7784],[5846,7796],[5840,7818],[5819,7818],[5801,7798],[5796,7818],[5806,7841],[5783,7844],[5765,7866],[5751,7893],[5733,7900],[5727,7924],[5745,7920],[5767,7934],[5803,7937],[5817,7959],[5820,7985],[5798,7995],[5792,7988],[5761,8000],[5745,7994],[5746,8015],[5759,8055],[5769,8073],[5772,8100],[5785,8120],[5821,8152],[5846,8157],[5885,8155],[5918,8149],[5959,8152],[6005,8140],[6050,8141],[6059,8158],[6023,8180],[6015,8217],[6017,8240],[6033,8252],[6028,8269],[6000,8294],[6003,8319],[6031,8337],[6041,8382],[6054,8381],[6076,8442],[6103,8501],[6125,8567],[6137,8621],[6145,8693],[6146,8748],[6201,8819],[6223,8855],[6249,8921],[6264,8905],[6287,8943],[6270,8945],[6256,8972],[6229,8982],[6219,8978],[6235,9037],[6210,9035],[6224,9068],[6254,9080],[6269,9097],[6284,9145],[6302,9155],[6360,9157],[6397,9146],[6398,9121],[6379,9085],[6368,9081],[6393,9058],[6396,9021],[6386,9012],[6390,8943],[6421,8921],[6405,8906],[6407,8882],[6391,8876],[6380,8853],[6359,8839],[6360,8828],[6334,8821],[6309,8836],[6284,8836],[6296,8821],[6298,8835],[6317,8830],[6311,8816],[6373,8807],[6387,8826],[6417,8836],[6429,8860],[6453,8879],[6452,8904],[6441,8915],[6445,8930],[6502,8946],[6529,8922],[6523,8883],[6551,8872],[6578,8875],[6534,8883],[6536,8902],[6554,8909],[6540,8940],[6513,8953],[6476,8960],[6464,8952],[6424,8956],[6429,8968],[6417,8985],[6424,9008],[6441,9026],[6419,9066],[6403,9076],[6418,9096],[6459,9112],[6462,9142],[6434,9163],[6457,9167],[6482,9136],[6482,9120],[6469,9104],[6477,9081],[6468,9074],[6491,9065],[6543,9059],[6563,9046],[6558,9066],[6500,9082],[6490,9101],[6518,9109],[6537,9097],[6553,9100],[6543,9123],[6517,9122],[6538,9141],[6561,9133],[6567,9154],[6583,9167],[6595,9158],[6590,9128],[6659,9090],[6692,9094],[6706,9089],[6698,9074],[6676,9067],[6679,9040],[6693,9052],[6710,9038],[6702,9019],[6719,9024],[6701,9065],[6715,9085],[6707,9097],[6672,9111],[6672,9122],[6644,9126],[6629,9136],[6633,9157],[6616,9179],[6633,9194],[6666,9199],[6711,9199],[6702,9228],[6736,9220],[6737,9202],[6773,9209],[6821,9211],[6792,9243],[6760,9250],[6759,9263],[6777,9256],[6815,9277],[6817,9269],[6877,9304],[6901,9311],[7007,9328],[6991,9341],[7011,9345],[7016,9373],[7031,9372],[7032,9350],[7073,9355],[7075,9375],[7045,9376],[7057,9398],[7094,9411],[7069,9395],[7067,9378],[7092,9380],[7087,9356],[7109,9351],[7076,9346],[7079,9337],[7159,9349],[7189,9340],[7163,9369],[7221,9370],[7233,9384],[7223,9397],[7260,9423],[7292,9440],[7336,9442],[7369,9434],[7385,9419],[7381,9402],[7416,9392],[7386,9368],[7427,9370],[7430,9382],[7492,9379],[7524,9383],[7534,9374],[7565,9374],[7567,9350],[7591,9359],[7595,9329],[7605,9328],[7597,9294],[7489,9238],[7434,9198],[7407,9197],[7392,9179],[7380,9180],[7358,9149],[7379,9161],[7383,9173],[7424,9171],[7517,9201],[7477,9206],[7491,9220],[7560,9202],[7582,9213],[7593,9191],[7650,9202],[7739,9195],[7739,9174],[7778,9163],[7872,9156],[7889,9174],[7880,9184],[7890,9203],[7902,9197],[7920,9214],[7947,9187],[7968,9193],[8021,9189],[8019,9182],[8062,9163],[8053,9133],[8065,9120],[8047,9110],[8016,9130],[8072,9060],[8105,9040],[8124,9046],[8153,9100],[8186,9075],[8211,9072],[8255,9086],[8316,9064],[8311,9074],[8285,9081],[8336,9087],[8349,9074],[8374,9077],[8360,9103],[8369,9116],[8349,9115],[8359,9134],[8406,9139],[8390,9156],[8419,9149],[8532,9137],[8573,9124],[8518,9130],[8522,9121],[8577,9123],[8549,9098],[8526,9098],[8530,9088],[8554,9096],[8585,9124],[8620,9123],[8656,9114],[8669,9102],[8648,9101],[8638,9090],[8666,9088],[8663,9077],[8686,9080],[8715,9068],[8732,9045],[8775,9044],[8842,9057],[8890,9056],[8918,9050],[8952,9034],[8964,9012],[8952,8993],[8993,8969],[9017,8980],[9080,8987],[9103,8976],[9165,8972],[9191,8987],[9205,8959],[9235,8951],[9244,8935],[9282,8946],[9272,8977],[9273,9005],[9374,8992],[9418,8991],[9501,8972],[9549,8946],[9549,8946],[9582,8934],[9586,8923],[9616,8913],[9651,8890],[9687,8879],[9690,8862],[9712,8822],[9724,8819],[9724,8844],[9708,8849],[9792,8843],[9802,8829],[9838,8803],[9851,8803],[9827,8790],[9826,8778],[9778,8773],[9781,8750],[9770,8740],[9777,8720],[9736,8716],[9703,8739],[9683,8737],[9670,8748],[9668,8767],[9637,8777],[9624,8769],[9591,8773],[9578,8799],[9555,8801],[9556,8786],[9569,8778],[9558,8755]]],[[[7654,6255],[7645,6250],[7621,6272],[7644,6273],[7659,6263],[7654,6255]]],[[[8334,6269],[8340,6262],[8303,6262],[8315,6286],[8338,6293],[8346,6287],[8334,6269]]],[[[8124,6310],[8135,6301],[8113,6270],[8104,6289],[8119,6291],[8124,6310]]],[[[7618,6302],[7595,6297],[7571,6299],[7574,6306],[7608,6307],[7618,6302]]],[[[7859,6350],[7843,6349],[7838,6355],[7855,6361],[7855,6370],[7870,6378],[7878,6375],[7871,6357],[7892,6352],[7859,6350]]],[[[7997,6397],[7983,6396],[7966,6403],[7961,6414],[7982,6419],[7998,6410],[7997,6397]]],[[[7417,6425],[7422,6434],[7440,6428],[7438,6417],[7421,6414],[7417,6425]]],[[[7944,6456],[7971,6455],[7957,6448],[7927,6453],[7913,6450],[7914,6460],[7944,6456]]],[[[7403,6424],[7394,6418],[7372,6426],[7367,6445],[7348,6452],[7361,6464],[7374,6462],[7383,6437],[7397,6434],[7391,6423],[7403,6424]]],[[[7184,6450],[7212,6416],[7197,6426],[7183,6446],[7164,6460],[7155,6474],[7165,6481],[7174,6457],[7184,6450]]],[[[7998,6495],[8009,6496],[8017,6486],[8009,6470],[8024,6463],[8006,6458],[7999,6468],[8007,6474],[7998,6495]]],[[[7098,6569],[7070,6590],[7076,6594],[7098,6570],[7118,6572],[7122,6552],[7136,6537],[7129,6525],[7110,6550],[7119,6553],[7118,6568],[7098,6569]]],[[[8210,6325],[8218,6319],[8202,6306],[8198,6310],[8202,6340],[8211,6349],[8219,6343],[8217,6324],[8210,6325]]],[[[7684,6248],[7667,6248],[7668,6261],[7678,6268],[7692,6259],[7709,6260],[7711,6269],[7729,6271],[7755,6265],[7761,6256],[7739,6249],[7697,6242],[7684,6248]]],[[[8015,6420],[8025,6425],[8053,6422],[8062,6427],[8096,6417],[8114,6392],[8065,6412],[8064,6407],[8040,6408],[8025,6419],[8018,6411],[8005,6412],[8015,6420]]],[[[8829,8140],[8840,8135],[8855,8142],[8840,8118],[8810,8094],[8809,8084],[8786,8061],[8803,8085],[8796,8100],[8821,8111],[8820,8120],[8835,8125],[8829,8140]]],[[[8285,8303],[8302,8315],[8314,8298],[8306,8281],[8299,8301],[8285,8303]]],[[[7832,6701],[7845,6706],[7842,6685],[7818,6678],[7801,6695],[7826,6684],[7837,6686],[7832,6701]]],[[[9238,8986],[9222,8976],[9189,8990],[9204,9000],[9238,8992],[9238,8986]]],[[[7895,6835],[7904,6828],[7901,6811],[7892,6803],[7882,6782],[7892,6775],[7874,6773],[7855,6797],[7869,6805],[7873,6829],[7890,6826],[7885,6803],[7900,6830],[7895,6835]]],[[[6348,9182],[6363,9175],[6310,9164],[6313,9184],[6342,9191],[6348,9182]]],[[[7793,6911],[7820,6904],[7830,6880],[7821,6867],[7793,6911]]],[[[7590,9239],[7572,9224],[7534,9239],[7550,9250],[7588,9247],[7590,9239]]],[[[7841,6870],[7853,6876],[7842,6859],[7861,6847],[7878,6845],[7877,6837],[7861,6822],[7842,6815],[7847,6851],[7839,6854],[7841,6870]]],[[[7772,7210],[7785,7207],[7816,7256],[7832,7263],[7844,7255],[7838,7249],[7826,7197],[7813,7178],[7809,7159],[7792,7181],[7788,7204],[7772,7210]]],[[[6936,9561],[6926,9563],[6935,9595],[6955,9596],[7012,9587],[6979,9570],[6964,9579],[6934,9582],[6936,9561]]],[[[8389,9214],[8379,9232],[8399,9235],[8406,9212],[8433,9214],[8473,9193],[8478,9175],[8466,9172],[8396,9185],[8372,9180],[8370,9189],[8393,9196],[8389,9214]]],[[[8581,9277],[8551,9291],[8561,9312],[8573,9299],[8620,9302],[8626,9290],[8641,9293],[8692,9285],[8685,9271],[8644,9263],[8613,9266],[8581,9277]]],[[[6605,6792],[6612,6796],[6630,6783],[6648,6757],[6663,6723],[6658,6698],[6626,6682],[6614,6685],[6604,6708],[6600,6743],[6610,6784],[6605,6792]]],[[[8216,7552],[8219,7537],[8202,7518],[8194,7526],[8175,7521],[8166,7504],[8154,7502],[8149,7525],[8165,7547],[8182,7541],[8188,7555],[8216,7552]]],[[[6990,6910],[6989,6893],[6994,6866],[6979,6842],[6978,6853],[6990,6910]]],[[[7510,7082],[7504,7064],[7478,7045],[7452,7056],[7450,7079],[7482,7101],[7518,7101],[7520,7091],[7510,7082]]],[[[7785,6234],[7809,6213],[7798,6206],[7784,6216],[7754,6228],[7760,6234],[7785,6234]]],[[[8402,6433],[8402,6307],[8402,6242],[8371,6271],[8339,6270],[8346,6287],[8331,6305],[8316,6350],[8254,6376],[8233,6378],[8206,6396],[8206,6391],[8184,6404],[8175,6390],[8166,6388],[8154,6418],[8137,6423],[8144,6430],[8159,6426],[8168,6436],[8191,6431],[8196,6438],[8176,6444],[8158,6441],[8140,6447],[8132,6464],[8107,6466],[8092,6483],[8078,6474],[8092,6455],[8086,6449],[8070,6454],[8079,6457],[8071,6474],[8092,6485],[8092,6493],[8075,6494],[8087,6506],[8103,6508],[8117,6504],[8115,6497],[8098,6493],[8103,6483],[8115,6485],[8158,6498],[8179,6487],[8196,6487],[8205,6469],[8199,6459],[8214,6441],[8217,6422],[8225,6411],[8240,6410],[8263,6434],[8263,6453],[8229,6464],[8252,6460],[8251,6488],[8261,6477],[8261,6460],[8289,6456],[8308,6465],[8369,6439],[8378,6441],[8402,6433]]],[[[5246,7575],[5244,7570],[5226,7564],[5221,7566],[5219,7564],[5205,7579],[5222,7581],[5223,7589],[5238,7587],[5272,7597],[5253,7585],[5252,7578],[5252,7578],[5252,7578],[5252,7578],[5252,7578],[5248,7577],[5246,7577],[5246,7577],[5246,7576],[5246,7575]]],[[[5249,7575],[5249,7575],[5249,7575],[5249,7575]]],[[[5252,7574],[5249,7577],[5252,7578],[5252,7578],[5252,7578],[5252,7574]]],[[[7328,6515],[7326,6517],[7325,6523],[7325,6523],[7328,6515],[7328,6515],[7328,6515]]],[[[5248,7576],[5247,7576],[5248,7576],[5248,7576],[5248,7576],[5248,7576],[5248,7576]]],[[[5252,7578],[5252,7578],[5252,7578],[5252,7578],[5252,7578]]],[[[5248,7575],[5249,7575],[5249,7575],[5249,7575],[5249,7575],[5249,7575],[5248,7575]]],[[[7749,6532],[7720,6532],[7710,6512],[7709,6493],[7697,6473],[7678,6457],[7685,6444],[7670,6421],[7680,6409],[7671,6391],[7666,6403],[7627,6387],[7623,6407],[7597,6408],[7580,6423],[7568,6409],[7558,6412],[7544,6405],[7542,6426],[7510,6419],[7498,6421],[7488,6476],[7469,6473],[7483,6481],[7469,6484],[7462,6501],[7470,6509],[7459,6519],[7457,6533],[7464,6554],[7480,6569],[7488,6558],[7520,6554],[7529,6590],[7579,6601],[7607,6634],[7608,6643],[7624,6646],[7655,6673],[7663,6671],[7670,6688],[7682,6699],[7693,6720],[7705,6703],[7718,6696],[7719,6681],[7726,6686],[7754,6666],[7761,6668],[7768,6652],[7790,6665],[7769,6645],[7760,6658],[7730,6651],[7748,6639],[7707,6630],[7721,6613],[7707,6602],[7715,6599],[7729,6575],[7722,6564],[7755,6537],[7749,6532]]],[[[7270,6542],[7297,6535],[7295,6524],[7307,6516],[7295,6488],[7309,6478],[7325,6478],[7330,6454],[7340,6442],[7362,6438],[7375,6413],[7371,6397],[7366,6338],[7353,6349],[7350,6340],[7335,6335],[7323,6344],[7305,6364],[7264,6392],[7262,6402],[7245,6414],[7229,6433],[7208,6472],[7205,6485],[7189,6508],[7171,6517],[7170,6527],[7153,6565],[7128,6579],[7126,6592],[7101,6618],[7091,6620],[7062,6650],[7051,6674],[7057,6680],[7082,6663],[7123,6662],[7146,6638],[7147,6628],[7189,6602],[7213,6572],[7227,6576],[7245,6571],[7243,6557],[7270,6552],[7270,6542]]],[[[7834,6264],[7852,6256],[7866,6264],[7896,6269],[7903,6262],[7910,6269],[7934,6270],[7935,6264],[7907,6259],[7896,6265],[7889,6258],[7878,6262],[7837,6248],[7782,6249],[7766,6253],[7791,6266],[7813,6264],[7829,6257],[7834,6264]]],[[[7374,6337],[7402,6331],[7404,6336],[7434,6324],[7442,6326],[7449,6311],[7504,6305],[7518,6321],[7551,6307],[7567,6307],[7572,6288],[7588,6281],[7609,6286],[7622,6279],[7619,6262],[7626,6252],[7590,6261],[7585,6266],[7569,6261],[7543,6267],[7540,6264],[7505,6271],[7472,6283],[7441,6280],[7414,6289],[7388,6292],[7389,6304],[7357,6309],[7368,6320],[7374,6337]]],[[[7833,6505],[7850,6486],[7886,6486],[7879,6475],[7887,6459],[7869,6462],[7867,6482],[7854,6465],[7834,6453],[7823,6457],[7853,6423],[7849,6405],[7870,6386],[7875,6404],[7880,6389],[7866,6378],[7847,6376],[7843,6367],[7828,6372],[7833,6389],[7811,6405],[7816,6428],[7807,6432],[7791,6422],[7796,6415],[7798,6373],[7794,6347],[7772,6343],[7766,6352],[7774,6382],[7764,6408],[7753,6404],[7749,6425],[7765,6451],[7765,6473],[7777,6490],[7778,6516],[7786,6530],[7801,6531],[7811,6548],[7828,6541],[7897,6533],[7920,6544],[7918,6548],[7942,6569],[7929,6537],[7912,6520],[7880,6518],[7875,6524],[7838,6521],[7796,6523],[7785,6502],[7787,6489],[7805,6468],[7816,6467],[7833,6485],[7833,6505]]],[[[8004,6507],[8000,6519],[8008,6560],[8024,6579],[8040,6580],[8028,6568],[8024,6577],[8016,6562],[8021,6554],[8009,6538],[8014,6532],[8033,6554],[8041,6554],[8041,6540],[8029,6535],[8045,6516],[8019,6523],[8017,6508],[8031,6478],[8004,6507]]],[[[7913,6851],[7921,6840],[7927,6847],[7929,6854],[7910,6877],[7937,6878],[7946,6868],[7948,6839],[7932,6840],[7939,6805],[7920,6806],[7911,6790],[7898,6791],[7908,6806],[7924,6813],[7921,6831],[7915,6823],[7913,6851]]],[[[7904,6697],[7903,6717],[7910,6725],[7894,6737],[7867,6722],[7867,6735],[7859,6734],[7847,6710],[7842,6713],[7852,6743],[7871,6747],[7875,6758],[7895,6761],[7899,6747],[7909,6749],[7914,6761],[7924,6758],[7925,6775],[7935,6767],[7947,6773],[7943,6792],[7952,6824],[7953,6798],[7965,6797],[7959,6787],[7975,6750],[7979,6722],[7969,6707],[7967,6693],[7955,6724],[7947,6714],[7951,6683],[7942,6666],[7937,6678],[7910,6690],[7904,6697]]],[[[7770,6844],[7778,6846],[7783,6869],[7795,6861],[7772,6839],[7777,6817],[7749,6794],[7737,6778],[7706,6756],[7716,6774],[7726,6779],[7750,6807],[7763,6817],[7762,6830],[7770,6844]]],[[[7903,6910],[7906,6922],[7915,6917],[7898,6895],[7896,6866],[7907,6863],[7904,6853],[7885,6867],[7878,6859],[7882,6891],[7878,6904],[7859,6919],[7861,6896],[7853,6908],[7843,6897],[7847,6913],[7835,6919],[7817,6907],[7802,6926],[7813,6935],[7801,6945],[7802,6935],[7787,6944],[7778,6978],[7779,6991],[7793,6981],[7794,7027],[7803,7057],[7822,7067],[7824,7082],[7840,7087],[7839,7066],[7817,7060],[7843,7049],[7850,7056],[7848,7029],[7859,7013],[7850,6990],[7831,6978],[7825,6959],[7835,6942],[7839,6952],[7855,6942],[7857,6931],[7875,6920],[7894,6918],[7903,6910]]],[[[8471,8214],[8466,8181],[8477,8156],[8484,8120],[8499,8080],[8469,8085],[8448,8033],[8448,8024],[8462,8005],[8473,7978],[8445,7982],[8434,7955],[8426,7981],[8433,7997],[8431,8018],[8436,8045],[8428,8062],[8436,8096],[8433,8129],[8440,8150],[8423,8176],[8422,8201],[8430,8226],[8425,8240],[8441,8240],[8455,8254],[8442,8277],[8453,8283],[8461,8271],[8458,8258],[8470,8232],[8471,8214]]],[[[8531,9308],[8500,9280],[8458,9286],[8446,9299],[8461,9319],[8442,9320],[8434,9308],[8450,9283],[8482,9274],[8442,9267],[8427,9277],[8375,9267],[8358,9274],[8344,9257],[8311,9268],[8281,9299],[8296,9298],[8289,9316],[8306,9324],[8297,9334],[8340,9350],[8367,9331],[8402,9314],[8403,9340],[8413,9348],[8448,9329],[8489,9327],[8531,9308]]],[[[7264,9554],[7283,9544],[7281,9529],[7308,9536],[7329,9517],[7349,9513],[7354,9494],[7337,9483],[7306,9478],[7232,9473],[7197,9459],[7175,9464],[7228,9535],[7264,9554]]],[[[6968,9551],[7025,9577],[7049,9599],[7126,9604],[7149,9584],[7154,9596],[7173,9596],[7199,9571],[7184,9544],[7169,9544],[7195,9524],[7179,9514],[7131,9513],[7102,9525],[7050,9528],[7031,9541],[7016,9566],[6984,9551],[6980,9532],[6968,9551]]],[[[7107,9654],[7136,9640],[7114,9636],[7114,9608],[7035,9601],[7027,9595],[7011,9592],[6947,9612],[6959,9624],[6983,9627],[6998,9647],[6976,9645],[6992,9660],[7046,9671],[7072,9681],[7107,9654]]],[[[7958,6260],[7977,6260],[7997,6271],[8011,6270],[7991,6254],[7950,6239],[7934,6231],[7915,6211],[7887,6205],[7885,6195],[7868,6188],[7884,6203],[7893,6227],[7929,6246],[7950,6270],[7958,6260]]],[[[8434,7729],[8427,7711],[8416,7699],[8418,7686],[8405,7689],[8400,7673],[8404,7655],[8389,7618],[8399,7600],[8387,7594],[8384,7582],[8371,7573],[8366,7597],[8354,7569],[8339,7562],[8338,7580],[8320,7566],[8282,7560],[8282,7552],[8262,7545],[8254,7529],[8239,7528],[8228,7539],[8233,7564],[8208,7567],[8173,7552],[8154,7549],[8145,7535],[8130,7544],[8116,7540],[8104,7546],[8107,7556],[8120,7557],[8170,7596],[8179,7591],[8212,7598],[8250,7593],[8254,7608],[8278,7638],[8277,7655],[8293,7661],[8284,7638],[8321,7649],[8337,7664],[8328,7673],[8329,7687],[8339,7671],[8356,7682],[8374,7728],[8366,7740],[8374,7757],[8369,7765],[8382,7775],[8383,7789],[8393,7776],[8406,7775],[8407,7789],[8397,7784],[8400,7799],[8410,7792],[8415,7768],[8424,7758],[8434,7729]]],[[[8089,7465],[8073,7472],[8084,7503],[8062,7521],[8069,7534],[8054,7546],[8072,7537],[8079,7524],[8093,7538],[8108,7541],[8110,7531],[8130,7529],[8123,7519],[8135,7518],[8138,7507],[8128,7495],[8118,7457],[8106,7448],[8107,7425],[8092,7420],[8102,7456],[8085,7453],[8089,7465]]],[[[8626,7940],[8632,7934],[8599,7922],[8578,7901],[8575,7881],[8535,7856],[8512,7847],[8496,7849],[8480,7838],[8468,7812],[8424,7837],[8402,7827],[8394,7835],[8381,7824],[8408,7807],[8394,7809],[8379,7794],[8354,7797],[8356,7817],[8367,7823],[8369,7838],[8388,7851],[8387,7863],[8407,7855],[8415,7863],[8412,7876],[8421,7884],[8424,7920],[8410,7926],[8431,7941],[8461,7907],[8473,7897],[8515,7884],[8530,7898],[8522,7877],[8532,7880],[8531,7861],[8538,7861],[8567,7879],[8575,7904],[8605,7930],[8626,7940]]],[[[7325,6523],[7320,6532],[7309,6538],[7331,6544],[7339,6537],[7322,6534],[7325,6523],[7325,6523]]],[[[7328,6515],[7344,6500],[7329,6500],[7331,6509],[7328,6515],[7328,6515],[7328,6515]]]]}},{"type":"Feature","id":"NA","properties":{"hc-group":"admin0","hc-middle-x":0.43,"hc-middle-y":0.51,"hc-key":"na","hc-a2":"NA","abbrev-a3":"NAM","iso-a2":"NA","name":"North America"},"geometry":{"type":"MultiPolygon","coordinates":[[[[3469,9081],[3498,9077],[3503,9062],[3469,9049],[3499,9056],[3511,9033],[3486,9027],[3430,9021],[3456,9043],[3441,9038],[3434,9045],[3425,9018],[3469,9024],[3434,9003],[3453,8998],[3465,9012],[3481,9009],[3511,9020],[3562,9004],[3597,9005],[3572,8980],[3546,8974],[3531,8961],[3482,8931],[3455,8923],[3431,8924],[3391,8905],[3343,8897],[3323,8900],[3302,8926],[3314,8898],[3278,8872],[3272,8853],[3236,8814],[3211,8805],[3162,8773],[3138,8781],[3143,8798],[3160,8813],[3137,8808],[3138,8793],[3122,8780],[3075,8770],[3094,8763],[3071,8748],[3059,8754],[3057,8711],[3063,8687],[3042,8672],[3046,8664],[3008,8634],[3015,8598],[3003,8596],[3003,8571],[2985,8572],[3001,8557],[2995,8545],[2978,8540],[2986,8519],[2963,8509],[2954,8522],[2932,8520],[2920,8527],[2923,8539],[2896,8551],[2852,8550],[2836,8556],[2837,8571],[2817,8574],[2803,8597],[2805,8614],[2775,8630],[2780,8651],[2755,8661],[2739,8685],[2742,8704],[2723,8706],[2720,8738],[2725,8747],[2700,8779],[2677,8802],[2677,8820],[2690,8832],[2717,8841],[2677,8841],[2668,8849],[2721,8863],[2670,8857],[2676,8886],[2692,8890],[2692,8905],[2728,8897],[2742,8906],[2713,8904],[2708,8913],[2686,8909],[2695,8928],[2721,8931],[2727,8922],[2751,8924],[2753,8953],[2779,8948],[2771,8962],[2758,8955],[2760,8979],[2745,8985],[2757,8997],[2716,9001],[2689,9017],[2672,9019],[2650,9036],[2667,9043],[2678,9069],[2683,9038],[2712,9036],[2739,9021],[2731,9055],[2697,9060],[2691,9070],[2705,9080],[2732,9084],[2706,9089],[2693,9081],[2664,9091],[2668,9075],[2629,9072],[2611,9089],[2625,9096],[2618,9142],[2601,9146],[2642,9160],[2617,9162],[2631,9176],[2607,9198],[2604,9235],[2587,9239],[2576,9273],[2544,9281],[2530,9300],[2542,9303],[2536,9321],[2465,9347],[2388,9360],[2372,9345],[2308,9354],[2302,9342],[2275,9347],[2300,9334],[2242,9342],[2207,9360],[2193,9386],[2157,9398],[2170,9410],[2170,9428],[2210,9441],[2176,9443],[2194,9452],[2158,9446],[2111,9471],[2120,9495],[2215,9513],[2225,9524],[2254,9531],[2315,9533],[2347,9559],[2342,9594],[2301,9600],[2283,9596],[2271,9615],[2291,9624],[2305,9648],[2312,9637],[2340,9645],[2349,9660],[2403,9676],[2445,9665],[2463,9673],[2452,9686],[2467,9696],[2448,9713],[2488,9727],[2535,9722],[2506,9731],[2531,9739],[2654,9758],[2680,9739],[2673,9699],[2698,9721],[2686,9750],[2789,9722],[2800,9727],[2767,9742],[2752,9768],[2814,9764],[2822,9757],[2902,9734],[2927,9716],[2954,9720],[2933,9734],[2939,9738],[2876,9757],[2852,9778],[2857,9788],[2922,9772],[2949,9759],[2929,9747],[2939,9738],[2969,9760],[2910,9787],[3018,9786],[3028,9766],[3032,9785],[3072,9772],[3080,9781],[3050,9787],[2913,9795],[2877,9802],[2901,9811],[2928,9803],[2942,9817],[3016,9822],[3058,9806],[3037,9817],[3079,9816],[3064,9831],[3119,9812],[3117,9835],[3175,9844],[3218,9844],[3299,9851],[3354,9849],[3501,9826],[3488,9819],[3351,9814],[3227,9797],[3319,9803],[3370,9813],[3450,9808],[3513,9816],[3535,9796],[3589,9789],[3627,9776],[3595,9755],[3553,9751],[3377,9741],[3291,9720],[3310,9708],[3323,9719],[3439,9735],[3531,9730],[3528,9715],[3481,9704],[3479,9690],[3556,9713],[3573,9733],[3626,9737],[3637,9715],[3630,9697],[3575,9655],[3609,9662],[3707,9718],[3706,9696],[3731,9689],[3732,9713],[3749,9694],[3791,9719],[3846,9718],[3901,9705],[3920,9693],[3862,9662],[3827,9660],[3835,9646],[3802,9636],[3753,9637],[3708,9631],[3724,9626],[3758,9632],[3791,9620],[3771,9607],[3706,9606],[3677,9594],[3682,9610],[3656,9585],[3668,9571],[3690,9573],[3680,9551],[3698,9543],[3691,9512],[3639,9512],[3641,9501],[3609,9441],[3627,9440],[3626,9455],[3644,9459],[3686,9455],[3687,9483],[3714,9502],[3699,9482],[3699,9464],[3686,9431],[3666,9442],[3643,9439],[3653,9422],[3694,9410],[3709,9416],[3728,9452],[3736,9447],[3716,9411],[3718,9393],[3704,9368],[3709,9334],[3693,9366],[3694,9388],[3652,9395],[3616,9377],[3600,9389],[3586,9380],[3618,9369],[3617,9352],[3669,9353],[3659,9336],[3686,9321],[3684,9291],[3647,9295],[3618,9312],[3628,9299],[3674,9270],[3661,9258],[3699,9258],[3701,9295],[3723,9302],[3720,9291],[3745,9279],[3712,9276],[3708,9261],[3685,9234],[3661,9235],[3656,9245],[3615,9244],[3601,9225],[3647,9212],[3651,9187],[3629,9188],[3599,9176],[3550,9196],[3511,9189],[3486,9175],[3518,9167],[3533,9130],[3593,9101],[3577,9090],[3611,9092],[3595,9083],[3598,9066],[3613,9066],[3623,9027],[3568,9022],[3551,9031],[3541,9056],[3494,9083],[3469,9081]],[[3469,9081],[3467,9082],[3467,9082],[3467,9082],[3467,9082],[3435,9105],[3418,9103],[3451,9091],[3442,9085],[3467,9082],[3467,9082],[3467,9082],[3467,9082],[3467,9081],[3469,9081]]],[[[3572,9166],[3611,9157],[3610,9144],[3589,9145],[3574,9155],[3534,9156],[3533,9161],[3572,9166]]],[[[3639,9244],[3662,9229],[3630,9224],[3613,9239],[3639,9244]]],[[[3746,9591],[3730,9575],[3711,9571],[3686,9583],[3733,9598],[3746,9591]]],[[[2640,9018],[2688,9009],[2704,8995],[2726,8988],[2721,8971],[2679,8958],[2661,8970],[2684,8969],[2638,8983],[2644,9000],[2640,9018]]],[[[3552,9132],[3535,9152],[3574,9153],[3609,9128],[3601,9113],[3552,9132]]],[[[3571,9174],[3521,9180],[3579,9168],[3535,9164],[3499,9172],[3513,9185],[3536,9186],[3571,9174]]],[[[2345,7052],[2335,7049],[2347,7031],[2326,7047],[2319,7041],[2281,7039],[2277,7051],[2284,7056],[2345,7052]]],[[[-927,8186],[-920,8180],[-949,8170],[-955,8176],[-983,8173],[-999,8176],[-999,8179],[-979,8183],[-943,8178],[-927,8186]]],[[[383,8319],[382,8341],[396,8345],[403,8335],[396,8303],[384,8307],[383,8319]]],[[[322,8373],[306,8340],[306,8387],[314,8392],[340,8389],[357,8372],[324,8367],[322,8373]]],[[[-630,8536],[-618,8531],[-614,8515],[-645,8512],[-670,8527],[-630,8536]]],[[[-631,8270],[-635,8253],[-670,8239],[-682,8241],[-717,8220],[-697,8244],[-662,8245],[-657,8264],[-631,8270]]],[[[-235,8455],[-211,8439],[-235,8435],[-225,8428],[-223,8405],[-249,8403],[-273,8379],[-269,8396],[-281,8385],[-296,8407],[-250,8436],[-235,8455]]],[[[252,8443],[287,8433],[290,8410],[262,8421],[268,8408],[287,8403],[296,8378],[294,8355],[274,8382],[280,8391],[268,8399],[260,8389],[256,8415],[238,8432],[252,8443]]],[[[325,8344],[316,8342],[325,8362],[338,8361],[370,8318],[374,8298],[361,8307],[348,8294],[336,8315],[327,8298],[336,8330],[325,8344]]],[[[2369,8107],[2391,8102],[2435,8084],[2440,8074],[2424,8073],[2385,8085],[2360,8101],[2369,8107]]],[[[1860,8235],[1869,8234],[1881,8214],[1841,8227],[1860,8235]]],[[[409,8281],[451,8240],[434,8245],[433,8232],[416,8248],[419,8253],[409,8281]]],[[[1919,8625],[1922,8607],[1909,8589],[1897,8597],[1896,8614],[1907,8626],[1919,8625]]],[[[1840,8652],[1845,8641],[1810,8616],[1794,8614],[1787,8630],[1805,8650],[1840,8652]]],[[[1976,8666],[1963,8657],[1945,8672],[1970,8674],[1979,8686],[1999,8680],[1976,8666]]],[[[2032,8911],[2045,8907],[2047,8873],[2023,8858],[1991,8857],[1981,8880],[1999,8908],[2032,8911]]],[[[1936,8972],[1955,8962],[1936,8942],[1937,8910],[1919,8943],[1939,8963],[1936,8972]]],[[[1179,9180],[1158,9154],[1122,9185],[1107,9189],[1120,9202],[1162,9205],[1181,9194],[1179,9180]]],[[[1185,9357],[1177,9374],[1195,9378],[1234,9356],[1245,9338],[1205,9330],[1201,9299],[1208,9288],[1189,9278],[1170,9284],[1192,9303],[1197,9334],[1185,9357]]],[[[794,9345],[786,9321],[766,9307],[743,9313],[766,9332],[794,9345]]],[[[1599,9438],[1616,9427],[1605,9411],[1573,9424],[1574,9437],[1599,9438]]],[[[1166,9424],[1184,9417],[1174,9405],[1151,9417],[1135,9445],[1152,9443],[1166,9424]]],[[[1449,9447],[1514,9444],[1505,9427],[1432,9428],[1425,9442],[1449,9447]]],[[[1330,9600],[1352,9590],[1349,9570],[1308,9594],[1330,9600]]],[[[1908,8413],[1908,8387],[1930,8366],[1939,8376],[1941,8355],[1927,8357],[1918,8342],[1900,8360],[1913,8363],[1907,8382],[1908,8413]]],[[[457,8230],[472,8232],[475,8203],[461,8204],[457,8230]]],[[[2499,7960],[2479,7945],[2451,7943],[2445,7960],[2473,7997],[2480,7981],[2463,7953],[2482,7971],[2499,7960]]],[[[2432,7975],[2406,7963],[2384,7967],[2360,7984],[2370,7987],[2382,7975],[2432,7975]]],[[[1897,9175],[1879,9178],[1878,9203],[1918,9198],[1957,9200],[1984,9191],[2013,9167],[2010,9152],[1956,9156],[1926,9148],[1904,9153],[1897,9175]]],[[[1466,9325],[1475,9337],[1479,9313],[1505,9293],[1502,9257],[1469,9256],[1452,9266],[1451,9248],[1435,9253],[1434,9267],[1413,9277],[1425,9304],[1400,9307],[1423,9316],[1438,9307],[1464,9316],[1466,9325]]],[[[978,9479],[956,9485],[926,9479],[925,9487],[1007,9510],[1034,9499],[1037,9481],[986,9486],[978,9479]]],[[[1406,9470],[1378,9476],[1361,9493],[1368,9514],[1427,9501],[1466,9484],[1450,9477],[1459,9459],[1410,9453],[1379,9464],[1406,9470]]],[[[2427,7001],[2436,7010],[2438,7031],[2441,7012],[2455,6988],[2453,6959],[2466,6934],[2462,6923],[2438,6991],[2427,7001]]],[[[1978,7054],[1993,7053],[2014,7038],[1995,7040],[1984,7032],[1969,7036],[1950,7048],[1964,7056],[1978,7054]]],[[[1964,7279],[1961,7255],[1969,7245],[1973,7215],[1957,7239],[1948,7243],[1962,7259],[1964,7279]]],[[[1965,7304],[1940,7304],[1946,7309],[1975,7313],[1989,7303],[1973,7294],[1965,7304]]],[[[-777,8681],[-754,8686],[-748,8676],[-707,8668],[-738,8652],[-770,8675],[-787,8668],[-800,8678],[-796,8690],[-777,8681]]],[[[1979,6762],[1985,6741],[1964,6720],[1948,6744],[1958,6757],[1927,6750],[1943,6762],[1929,6772],[1911,6768],[1909,6760],[1888,6749],[1902,6728],[1877,6720],[1874,6730],[1849,6720],[1857,6734],[1853,6745],[1837,6753],[1815,6749],[1788,6764],[1795,6773],[1764,6791],[1763,6801],[1752,6789],[1736,6799],[1729,6812],[1734,6834],[1711,6854],[1702,6867],[1677,6887],[1687,6890],[1675,6901],[1669,6895],[1644,6898],[1614,6906],[1587,6918],[1569,6919],[1542,6937],[1524,6956],[1493,6983],[1470,6986],[1465,6993],[1448,6979],[1415,6970],[1379,6979],[1347,6996],[1321,7002],[1283,7018],[1261,7037],[1211,7050],[1197,7067],[1166,7082],[1146,7113],[1160,7120],[1153,7127],[1161,7146],[1148,7161],[1143,7182],[1107,7223],[1079,7244],[1070,7258],[1036,7279],[1042,7296],[1034,7310],[1002,7327],[1002,7343],[983,7351],[955,7381],[928,7439],[930,7450],[904,7464],[882,7468],[876,7450],[883,7419],[913,7389],[926,7390],[928,7365],[935,7370],[938,7345],[960,7317],[974,7308],[993,7259],[1004,7251],[998,7241],[1023,7230],[1035,7210],[1033,7196],[1023,7189],[1011,7209],[975,7235],[969,7233],[957,7251],[959,7274],[955,7286],[923,7309],[888,7325],[887,7330],[872,7344],[872,7344],[887,7342],[897,7347],[901,7363],[873,7393],[852,7405],[841,7439],[823,7463],[825,7473],[807,7490],[804,7513],[782,7534],[774,7523],[774,7504],[767,7511],[773,7537],[749,7548],[722,7539],[729,7556],[707,7562],[707,7580],[688,7598],[667,7628],[673,7636],[655,7649],[652,7669],[666,7658],[652,7680],[651,7670],[616,7708],[612,7739],[596,7760],[606,7795],[592,7845],[603,7882],[611,7942],[604,7991],[595,8023],[586,8039],[591,8047],[606,8039],[645,8035],[654,8054],[633,8078],[588,8099],[590,8117],[577,8127],[531,8129],[527,8138],[496,8156],[494,8189],[518,8198],[511,8204],[494,8195],[488,8166],[480,8192],[484,8204],[474,8231],[451,8241],[418,8278],[418,8295],[404,8298],[400,8314],[405,8336],[396,8346],[380,8343],[374,8327],[374,8354],[364,8344],[352,8352],[364,8374],[337,8397],[312,8435],[308,8436],[317,8423],[316,8402],[308,8397],[296,8390],[300,8406],[290,8436],[307,8437],[296,8442],[274,8486],[283,8447],[265,8446],[252,8469],[238,8468],[254,8448],[235,8441],[206,8459],[188,8478],[142,8498],[148,8513],[128,8505],[55,8523],[10,8518],[-3,8532],[-37,8538],[-57,8529],[-47,8547],[-63,8555],[-56,8569],[-83,8546],[-78,8557],[-102,8554],[-89,8518],[-146,8513],[-177,8488],[-199,8480],[-215,8488],[-200,8495],[-212,8509],[-195,8542],[-199,8550],[-159,8570],[-173,8579],[-212,8552],[-217,8534],[-234,8528],[-237,8514],[-254,8502],[-257,8489],[-279,8491],[-280,8476],[-254,8468],[-277,8453],[-292,8433],[-305,8432],[-326,8413],[-334,8414],[-349,8389],[-368,8380],[-357,8356],[-385,8376],[-407,8362],[-412,8346],[-446,8341],[-475,8311],[-471,8325],[-489,8321],[-499,8331],[-502,8309],[-545,8299],[-528,8284],[-550,8297],[-581,8283],[-597,8289],[-585,8302],[-556,8309],[-548,8302],[-545,8323],[-529,8321],[-505,8342],[-468,8347],[-462,8359],[-420,8383],[-401,8402],[-383,8413],[-378,8451],[-365,8470],[-397,8458],[-419,8465],[-423,8450],[-439,8471],[-459,8459],[-461,8478],[-483,8455],[-501,8464],[-511,8486],[-501,8496],[-519,8523],[-557,8509],[-611,8543],[-588,8555],[-602,8559],[-633,8589],[-630,8600],[-602,8631],[-586,8659],[-573,8666],[-550,8655],[-527,8666],[-529,8682],[-486,8677],[-474,8688],[-480,8712],[-493,8720],[-475,8730],[-486,8745],[-543,8720],[-555,8727],[-599,8721],[-633,8728],[-656,8755],[-632,8761],[-669,8767],[-688,8746],[-689,8776],[-637,8805],[-590,8823],[-561,8825],[-559,8800],[-515,8799],[-480,8808],[-506,8819],[-529,8840],[-519,8843],[-498,8818],[-474,8814],[-457,8822],[-477,8829],[-495,8822],[-506,8830],[-505,8848],[-523,8845],[-559,8850],[-573,8876],[-644,8913],[-634,8940],[-579,8943],[-543,8966],[-539,8991],[-507,9015],[-476,9017],[-441,9041],[-393,9043],[-357,9068],[-322,9062],[-335,9050],[-321,9043],[-310,9058],[-278,9041],[-254,9048],[-222,9042],[-234,9028],[-215,9022],[-134,9028],[-109,9015],[-72,9007],[-36,9008],[2,8998],[40,9005],[61,8999],[96,8980],[140,8979],[162,8973],[193,8954],[235,8940],[253,8940],[260,8962],[290,8972],[304,8984],[320,8972],[306,8959],[337,8967],[347,8981],[396,8989],[412,9006],[443,8998],[401,8980],[373,8974],[332,8938],[351,8935],[347,8949],[376,8961],[383,8971],[403,8960],[421,8983],[457,8991],[461,8982],[487,9008],[483,9033],[516,9012],[528,8986],[551,8968],[564,8973],[582,8995],[576,9007],[596,9007],[594,8984],[606,8984],[595,8965],[632,8972],[639,8990],[684,8986],[717,8967],[765,8958],[783,8948],[844,8936],[845,8946],[903,8926],[902,8908],[874,8909],[857,8892],[890,8882],[922,8881],[935,8904],[930,8879],[996,8886],[1030,8907],[1057,8875],[1079,8859],[1074,8872],[1082,8900],[1115,8900],[1124,8913],[1145,8917],[1148,8928],[1122,8922],[1089,8904],[1055,8909],[1070,8927],[1129,8941],[1153,8932],[1151,8916],[1182,8921],[1182,8897],[1210,8899],[1246,8881],[1269,8879],[1293,8887],[1362,8886],[1341,8898],[1356,8900],[1386,8875],[1399,8884],[1382,8896],[1371,8891],[1352,8914],[1394,8919],[1400,8909],[1435,8910],[1418,8869],[1439,8864],[1452,8840],[1456,8859],[1440,8881],[1448,8899],[1465,8897],[1498,8926],[1472,8934],[1486,8950],[1481,8970],[1425,8991],[1415,9015],[1426,9032],[1413,9042],[1418,9068],[1447,9078],[1433,9082],[1454,9103],[1472,9106],[1457,9104],[1455,9135],[1440,9153],[1440,9198],[1454,9205],[1454,9219],[1500,9229],[1541,9218],[1562,9221],[1602,9213],[1553,9153],[1538,9146],[1486,9149],[1506,9132],[1486,9108],[1474,9106],[1520,9071],[1521,9042],[1537,9034],[1550,9012],[1553,8990],[1565,8990],[1575,8973],[1603,8967],[1585,8952],[1595,8940],[1590,8918],[1600,8907],[1616,8928],[1618,8949],[1639,8958],[1666,8936],[1673,8912],[1655,8909],[1659,8884],[1685,8857],[1711,8864],[1712,8875],[1697,8899],[1705,8911],[1715,8892],[1728,8898],[1735,8932],[1769,8947],[1745,8957],[1739,8980],[1746,8990],[1789,8990],[1825,8980],[1839,8962],[1858,8967],[1865,8951],[1849,8942],[1866,8935],[1833,8904],[1866,8868],[1857,8845],[1845,8844],[1810,8811],[1797,8813],[1793,8792],[1803,8777],[1780,8784],[1773,8805],[1747,8810],[1743,8824],[1702,8817],[1730,8804],[1712,8783],[1685,8763],[1669,8763],[1638,8781],[1636,8763],[1695,8759],[1698,8754],[1667,8709],[1636,8698],[1614,8712],[1600,8682],[1579,8680],[1589,8657],[1577,8639],[1528,8629],[1523,8605],[1491,8583],[1495,8577],[1480,8556],[1466,8516],[1467,8475],[1484,8466],[1515,8464],[1537,8404],[1528,8387],[1578,8400],[1613,8388],[1641,8383],[1667,8366],[1679,8349],[1735,8331],[1766,8316],[1787,8320],[1836,8311],[1831,8275],[1840,8258],[1834,8224],[1856,8204],[1862,8190],[1885,8175],[1889,8161],[1910,8152],[1921,8173],[1908,8230],[1900,8239],[1909,8247],[1905,8262],[1920,8274],[1909,8292],[1912,8300],[1932,8300],[1967,8318],[2000,8351],[2005,8380],[1988,8430],[1940,8465],[1966,8487],[1967,8504],[1983,8518],[1968,8537],[1972,8552],[1954,8555],[1974,8584],[1958,8603],[1958,8634],[1991,8632],[2056,8615],[2066,8619],[2068,8637],[2078,8638],[2106,8616],[2119,8613],[2148,8592],[2156,8569],[2193,8565],[2198,8555],[2210,8566],[2214,8554],[2201,8541],[2208,8528],[2205,8499],[2224,8475],[2271,8444],[2311,8465],[2332,8487],[2327,8506],[2341,8517],[2355,8549],[2363,8521],[2407,8460],[2412,8439],[2442,8423],[2431,8400],[2450,8394],[2446,8380],[2455,8366],[2433,8356],[2458,8355],[2459,8341],[2481,8338],[2484,8324],[2471,8307],[2497,8320],[2496,8311],[2519,8313],[2522,8300],[2570,8289],[2565,8274],[2575,8255],[2615,8245],[2617,8190],[2580,8164],[2558,8166],[2521,8147],[2509,8129],[2486,8117],[2466,8118],[2440,8112],[2436,8117],[2397,8120],[2377,8116],[2336,8121],[2302,8119],[2281,8102],[2273,8083],[2253,8081],[2224,8061],[2229,8048],[2296,8075],[2327,8080],[2356,8074],[2368,8061],[2362,8048],[2331,8033],[2317,8041],[2299,8037],[2325,8020],[2358,8028],[2332,7999],[2346,7991],[2358,7967],[2370,7960],[2418,7944],[2434,7954],[2461,7934],[2386,7903],[2364,7906],[2348,7880],[2322,7868],[2310,7877],[2305,7896],[2314,7907],[2362,7934],[2362,7926],[2385,7936],[2346,7938],[2359,7949],[2317,7930],[2288,7924],[2275,7908],[2259,7905],[2236,7887],[2227,7898],[2218,7883],[2198,7880],[2179,7860],[2176,7838],[2166,7826],[2191,7803],[2155,7796],[2149,7785],[2138,7792],[2111,7788],[2089,7780],[2101,7777],[2127,7785],[2134,7780],[2104,7767],[2070,7762],[2079,7756],[2075,7736],[2053,7709],[2034,7727],[2047,7704],[2044,7679],[2023,7655],[2031,7675],[2012,7673],[2011,7643],[2020,7640],[2033,7605],[2018,7588],[2021,7580],[2003,7565],[1986,7565],[1971,7555],[1962,7538],[1938,7535],[1921,7510],[1876,7479],[1857,7440],[1866,7404],[1884,7368],[1883,7357],[1900,7317],[1896,7269],[1892,7262],[1870,7259],[1863,7279],[1852,7282],[1823,7332],[1832,7342],[1819,7343],[1825,7377],[1794,7410],[1784,7416],[1756,7400],[1720,7429],[1677,7421],[1666,7436],[1664,7420],[1649,7425],[1628,7422],[1629,7405],[1617,7403],[1633,7382],[1613,7391],[1601,7383],[1581,7382],[1558,7405],[1541,7398],[1514,7405],[1489,7402],[1443,7373],[1414,7367],[1421,7362],[1401,7345],[1389,7326],[1397,7277],[1383,7240],[1376,7180],[1383,7151],[1398,7121],[1418,7097],[1423,7080],[1437,7063],[1455,7062],[1477,7045],[1529,7059],[1554,7061],[1580,7075],[1594,7099],[1598,7132],[1614,7140],[1663,7150],[1704,7138],[1704,7118],[1696,7109],[1689,7116],[1674,7089],[1683,7085],[1675,7061],[1685,7052],[1664,7044],[1669,7023],[1660,7025],[1660,7009],[1651,6988],[1639,6980],[1662,6971],[1681,6974],[1716,6993],[1729,6993],[1728,6980],[1755,6980],[1776,6974],[1782,6961],[1803,6957],[1810,6950],[1808,6932],[1797,6899],[1799,6873],[1788,6842],[1800,6816],[1821,6792],[1841,6781],[1840,6770],[1857,6775],[1857,6767],[1878,6769],[1916,6791],[1960,6779],[1979,6762]]],[[[868,7348],[872,7344],[872,7344],[868,7345],[868,7348],[868,7348],[868,7348]]],[[[363,8233],[352,8236],[339,8262],[341,8275],[369,8266],[382,8272],[375,8239],[368,8234],[379,8236],[394,8191],[363,8224],[356,8231],[363,8233]]],[[[1857,7160],[1855,7164],[1855,7164],[1855,7164],[1857,7163],[1857,7160],[1857,7160]]],[[[2049,7197],[2047,7198],[2047,7201],[2047,7201],[2049,7197],[2049,7197],[2049,7197]]],[[[2049,7197],[2070,7185],[2094,7180],[2068,7179],[2054,7188],[2049,7197],[2049,7197],[2049,7197]]],[[[2462,6826],[2460,6822],[2461,6806],[2434,6803],[2447,6811],[2441,6823],[2462,6826],[2462,6826],[2462,6826]]],[[[1858,7151],[1858,7152],[1858,7152],[1858,7152],[1858,7151],[1858,7151],[1858,7151]]],[[[1858,7151],[1812,7146],[1812,7157],[1824,7161],[1844,7151],[1858,7151],[1858,7151]]],[[[1858,7152],[1857,7160],[1857,7160],[1860,7152],[1858,7152],[1858,7152],[1858,7152]]],[[[543,8081],[473,8139],[494,8143],[514,8132],[556,8124],[568,8126],[573,8106],[592,8085],[617,8076],[631,8064],[621,8044],[588,8054],[543,8081]]],[[[2236,9006],[2211,8989],[2249,9005],[2253,9016],[2278,8996],[2269,8978],[2294,8956],[2264,8955],[2225,8965],[2263,8948],[2258,8931],[2244,8926],[2288,8917],[2315,8897],[2352,8894],[2340,8887],[2362,8884],[2385,8862],[2403,8856],[2422,8831],[2424,8847],[2452,8829],[2447,8814],[2416,8807],[2433,8797],[2419,8795],[2428,8780],[2396,8778],[2383,8770],[2393,8758],[2387,8743],[2378,8755],[2356,8752],[2321,8784],[2315,8801],[2289,8822],[2273,8823],[2281,8811],[2259,8818],[2283,8795],[2257,8791],[2240,8806],[2259,8779],[2272,8782],[2294,8750],[2337,8730],[2347,8712],[2338,8701],[2354,8699],[2371,8678],[2357,8665],[2340,8679],[2354,8649],[2335,8653],[2336,8643],[2291,8658],[2260,8684],[2263,8671],[2234,8690],[2230,8682],[2269,8656],[2316,8617],[2331,8592],[2354,8590],[2348,8578],[2315,8603],[2306,8601],[2275,8614],[2239,8619],[2208,8638],[2182,8643],[2174,8633],[2163,8653],[2146,8662],[2159,8680],[2137,8685],[2130,8698],[2114,8685],[2111,8708],[2077,8734],[2059,8718],[2026,8729],[2014,8714],[1986,8714],[1962,8698],[1965,8718],[1955,8731],[1957,8745],[1981,8757],[1977,8770],[2027,8758],[2037,8734],[2038,8748],[2021,8763],[2043,8760],[2077,8773],[2094,8770],[2089,8782],[2065,8803],[2127,8851],[2119,8885],[2108,8907],[2080,8916],[2070,8899],[2096,8894],[2096,8884],[2067,8884],[2056,8898],[2073,8908],[2072,8921],[2055,8924],[2055,8912],[2037,8922],[2058,8940],[2035,8947],[2001,8930],[2001,8947],[2031,8951],[2029,8961],[2001,8975],[1993,8953],[1979,8960],[1994,8988],[1970,8989],[1970,9008],[1949,9010],[1929,9027],[1915,9019],[1932,9016],[1941,8999],[1911,8990],[1922,8983],[1904,8978],[1899,8965],[1887,8981],[1855,8997],[1819,8987],[1812,8999],[1794,8996],[1731,9004],[1709,9011],[1712,8999],[1694,8998],[1696,9013],[1646,9023],[1621,9057],[1657,9050],[1688,9052],[1665,9063],[1613,9070],[1614,9093],[1605,9102],[1620,9115],[1609,9120],[1620,9150],[1629,9148],[1636,9176],[1674,9203],[1705,9210],[1752,9208],[1756,9200],[1725,9179],[1705,9152],[1718,9128],[1712,9117],[1722,9095],[1759,9067],[1726,9061],[1759,9060],[1769,9077],[1747,9088],[1726,9108],[1754,9120],[1734,9141],[1739,9161],[1765,9184],[1819,9204],[1857,9203],[1869,9176],[1883,9171],[1895,9147],[1888,9116],[1907,9134],[1933,9121],[1925,9105],[1940,9102],[1935,9119],[1948,9139],[1973,9148],[2043,9134],[2047,9113],[2072,9110],[2060,9087],[2090,9093],[2078,9078],[2106,9066],[2108,9074],[2098,9081],[2123,9087],[2150,9080],[2163,9066],[2157,9046],[2173,9058],[2181,9048],[2167,9032],[2199,9045],[2244,9029],[2241,9018],[2206,9006],[2236,9006]]],[[[2680,8015],[2688,8033],[2699,8036],[2689,8019],[2702,8025],[2707,8015],[2698,7988],[2680,7981],[2679,8001],[2661,7991],[2670,8010],[2666,8025],[2662,8009],[2642,8011],[2630,7992],[2609,7992],[2610,8012],[2603,8019],[2583,8015],[2548,8021],[2516,8016],[2508,8028],[2537,8051],[2529,8055],[2537,8075],[2547,8070],[2544,8087],[2571,8141],[2587,8159],[2613,8171],[2626,8184],[2616,8150],[2586,8109],[2583,8091],[2604,8114],[2617,8116],[2618,8094],[2643,8081],[2651,8095],[2683,8079],[2670,8070],[2670,8054],[2686,8047],[2671,8022],[2680,8015]]],[[[1286,8971],[1270,8993],[1265,8980],[1238,8985],[1230,8966],[1250,8965],[1265,8951],[1259,8924],[1240,8939],[1212,8935],[1169,8949],[1125,8956],[1120,8972],[1098,8948],[1063,8944],[1051,8933],[1013,8927],[975,8911],[975,8923],[939,8919],[912,8936],[911,8956],[890,8961],[844,8962],[825,8970],[801,8998],[815,9005],[897,9015],[932,9014],[935,9027],[917,9035],[848,9029],[821,9024],[797,9031],[773,9053],[840,9072],[848,9081],[798,9072],[775,9077],[782,9088],[753,9086],[753,9103],[781,9119],[767,9130],[803,9157],[885,9184],[903,9169],[901,9151],[884,9140],[910,9140],[931,9163],[984,9146],[965,9127],[971,9122],[998,9138],[1026,9134],[999,9162],[1017,9162],[1060,9138],[1059,9126],[1087,9086],[1100,9101],[1085,9114],[1074,9179],[1079,9193],[1103,9173],[1112,9180],[1156,9150],[1166,9112],[1188,9071],[1177,9058],[1197,9038],[1230,9026],[1269,9004],[1289,9016],[1286,8971]]],[[[1795,8689],[1772,8679],[1767,8668],[1747,8659],[1736,8665],[1732,8687],[1691,8681],[1699,8697],[1720,8705],[1713,8728],[1721,8745],[1727,8784],[1752,8798],[1767,8771],[1782,8758],[1802,8754],[1808,8745],[1850,8724],[1854,8706],[1887,8699],[1896,8691],[1872,8674],[1829,8685],[1828,8699],[1812,8698],[1813,8709],[1794,8701],[1795,8689]]],[[[1295,8946],[1326,8947],[1361,8963],[1355,8969],[1375,8993],[1388,8994],[1405,8972],[1441,8978],[1429,8958],[1436,8941],[1455,8939],[1416,8918],[1388,8922],[1314,8944],[1312,8914],[1295,8946]]],[[[1336,9071],[1318,9098],[1278,9125],[1260,9124],[1237,9143],[1241,9164],[1254,9166],[1276,9146],[1301,9147],[1312,9160],[1266,9190],[1287,9196],[1288,9209],[1313,9205],[1308,9214],[1330,9214],[1381,9226],[1382,9245],[1394,9254],[1375,9213],[1394,9211],[1398,9184],[1362,9164],[1395,9160],[1408,9173],[1423,9130],[1415,9097],[1371,9081],[1352,9066],[1336,9071]]],[[[751,9231],[782,9235],[818,9224],[863,9189],[830,9177],[750,9141],[745,9125],[718,9120],[710,9081],[634,9056],[606,9090],[571,9104],[552,9104],[570,9133],[576,9155],[615,9205],[604,9210],[586,9239],[679,9251],[721,9235],[751,9231]]],[[[1313,9304],[1319,9316],[1271,9313],[1236,9307],[1224,9331],[1249,9336],[1274,9324],[1252,9350],[1274,9371],[1295,9383],[1324,9376],[1339,9365],[1346,9375],[1382,9367],[1391,9318],[1368,9297],[1385,9286],[1372,9279],[1304,9278],[1291,9298],[1313,9304]]],[[[1008,9355],[1035,9381],[1056,9390],[1057,9376],[1076,9354],[1064,9339],[1107,9330],[1119,9341],[1144,9336],[1155,9316],[1137,9281],[1066,9272],[1054,9281],[1032,9269],[971,9248],[931,9242],[911,9245],[889,9259],[937,9276],[974,9278],[992,9292],[951,9284],[903,9282],[901,9299],[889,9281],[874,9275],[866,9287],[852,9275],[799,9289],[817,9324],[876,9329],[822,9331],[822,9340],[850,9351],[858,9365],[889,9367],[890,9381],[889,9391],[918,9384],[921,9353],[948,9347],[977,9327],[983,9308],[1005,9311],[1052,9306],[1046,9322],[1018,9331],[1040,9343],[1008,9355]]],[[[1920,9270],[1895,9263],[1897,9255],[1849,9245],[1816,9251],[1810,9267],[1799,9252],[1777,9248],[1708,9246],[1652,9248],[1651,9271],[1641,9257],[1609,9250],[1549,9264],[1546,9285],[1535,9290],[1549,9313],[1544,9331],[1516,9359],[1488,9353],[1437,9361],[1408,9397],[1438,9403],[1499,9393],[1517,9375],[1566,9379],[1591,9371],[1595,9362],[1629,9355],[1626,9348],[1571,9347],[1602,9341],[1632,9325],[1640,9303],[1650,9316],[1661,9305],[1674,9312],[1714,9303],[1754,9316],[1767,9314],[1792,9326],[1811,9321],[1834,9327],[1869,9324],[1912,9305],[1913,9288],[1889,9280],[1914,9278],[1920,9270]]],[[[861,9417],[832,9406],[850,9396],[846,9380],[812,9369],[803,9353],[784,9361],[792,9385],[770,9381],[775,9372],[756,9367],[768,9358],[730,9328],[700,9333],[671,9340],[654,9333],[642,9351],[656,9362],[680,9364],[694,9378],[760,9421],[789,9423],[807,9416],[809,9427],[831,9433],[861,9417]]],[[[1013,9430],[958,9419],[926,9431],[914,9449],[897,9442],[869,9459],[892,9466],[910,9455],[999,9468],[1029,9467],[1029,9459],[995,9453],[1016,9447],[1013,9430]]],[[[1204,9550],[1229,9541],[1243,9527],[1265,9531],[1327,9500],[1318,9489],[1342,9466],[1343,9454],[1316,9447],[1296,9452],[1261,9441],[1242,9444],[1239,9477],[1232,9475],[1233,9485],[1182,9479],[1165,9494],[1177,9499],[1211,9494],[1211,9512],[1190,9512],[1194,9525],[1166,9514],[1176,9526],[1150,9527],[1155,9548],[1204,9550]]],[[[1636,9605],[1662,9599],[1646,9612],[1653,9622],[1676,9620],[1697,9586],[1691,9564],[1707,9569],[1738,9564],[1757,9545],[1711,9530],[1680,9504],[1660,9523],[1661,9489],[1636,9473],[1608,9501],[1624,9472],[1604,9482],[1598,9470],[1549,9475],[1482,9524],[1513,9537],[1553,9536],[1531,9555],[1492,9543],[1439,9552],[1443,9563],[1482,9576],[1436,9569],[1413,9584],[1411,9602],[1465,9595],[1488,9604],[1449,9601],[1415,9611],[1433,9619],[1431,9632],[1459,9639],[1447,9654],[1465,9665],[1515,9667],[1513,9675],[1479,9679],[1512,9687],[1554,9672],[1586,9631],[1628,9629],[1636,9605]]],[[[1879,9419],[1931,9405],[1920,9394],[1963,9396],[1968,9377],[1931,9363],[1927,9336],[1910,9329],[1915,9356],[1882,9347],[1862,9348],[1874,9366],[1820,9361],[1787,9366],[1757,9363],[1772,9356],[1684,9365],[1655,9361],[1651,9387],[1640,9362],[1624,9372],[1606,9367],[1591,9381],[1658,9407],[1678,9404],[1699,9415],[1676,9420],[1661,9448],[1691,9455],[1719,9448],[1732,9430],[1800,9420],[1801,9430],[1828,9459],[1820,9462],[1801,9436],[1787,9429],[1739,9432],[1750,9449],[1736,9458],[1753,9465],[1762,9483],[1741,9469],[1719,9465],[1682,9469],[1682,9490],[1708,9513],[1748,9520],[1792,9515],[1850,9517],[1859,9529],[1828,9518],[1776,9523],[1775,9538],[1754,9567],[1711,9577],[1713,9614],[1791,9609],[1838,9583],[1853,9565],[1884,9566],[1858,9573],[1853,9586],[1808,9614],[1960,9633],[1903,9634],[1945,9645],[2002,9654],[1936,9651],[1935,9661],[1972,9683],[1955,9682],[1921,9661],[1913,9649],[1866,9635],[1816,9629],[1805,9640],[1773,9627],[1704,9633],[1732,9657],[1722,9660],[1688,9635],[1626,9652],[1655,9660],[1705,9661],[1763,9680],[1710,9669],[1613,9661],[1598,9673],[1626,9678],[1610,9684],[1655,9702],[1593,9686],[1583,9693],[1620,9705],[1588,9708],[1566,9699],[1551,9705],[1578,9720],[1615,9725],[1626,9718],[1647,9735],[1667,9739],[1733,9730],[1762,9730],[1704,9741],[1701,9747],[1745,9752],[1733,9765],[1794,9756],[1826,9738],[1815,9752],[1901,9729],[1822,9758],[1841,9780],[1884,9771],[1856,9788],[1905,9786],[1897,9799],[1986,9794],[2023,9774],[2000,9795],[1979,9803],[2016,9808],[2073,9804],[2084,9794],[2109,9809],[2205,9812],[2207,9803],[2250,9804],[2303,9796],[2237,9777],[2271,9779],[2352,9797],[2407,9768],[2444,9766],[2452,9745],[2362,9711],[2249,9700],[2295,9696],[2194,9672],[2322,9695],[2357,9699],[2352,9688],[2314,9676],[2247,9644],[2197,9610],[2132,9596],[2177,9602],[2153,9575],[2131,9570],[2097,9577],[2103,9561],[2078,9555],[2047,9558],[2048,9550],[2014,9558],[2022,9549],[1979,9556],[1981,9543],[2065,9541],[2060,9512],[2055,9499],[2005,9496],[2046,9485],[2032,9468],[1994,9455],[1956,9459],[1969,9436],[1952,9422],[1928,9416],[1879,9419]]],[[[1855,7164],[1840,7175],[1847,7183],[1820,7183],[1798,7161],[1787,7167],[1769,7155],[1771,7168],[1782,7182],[1807,7193],[1837,7199],[1882,7199],[1900,7195],[1917,7185],[1924,7174],[1938,7174],[1959,7165],[1951,7179],[1975,7158],[2001,7141],[2032,7132],[2032,7125],[2056,7120],[2072,7110],[2071,7103],[2031,7098],[2012,7101],[1969,7096],[1988,7115],[1981,7122],[1947,7123],[1943,7146],[1905,7153],[1889,7164],[1853,7169],[1855,7164],[1855,7164],[1855,7164]]],[[[2155,7028],[2135,7047],[2111,7045],[2089,7048],[2082,7041],[2064,7053],[2074,7060],[2115,7053],[2117,7084],[2096,7090],[2109,7103],[2137,7092],[2166,7099],[2199,7090],[2208,7073],[2233,7069],[2259,7042],[2238,7052],[2200,7055],[2180,7046],[2175,7053],[2155,7028]]],[[[2047,7201],[2046,7203],[2033,7206],[2046,7218],[2027,7244],[2014,7244],[2005,7231],[1997,7241],[2013,7249],[2015,7259],[2031,7244],[2046,7219],[2047,7201],[2047,7201]]],[[[868,7348],[855,7359],[868,7357],[868,7348],[868,7348],[868,7348]]],[[[2462,6826],[2467,6836],[2464,6826],[2462,6826],[2462,6826],[2462,6826]]]]}},{"type":"Feature","id":"SA","properties":{"hc-group":"admin0","hc-middle-x":0.59,"hc-middle-y":0.35,"hc-key":"sa","hc-a2":"SA","abbrev-a3":"SAM","iso-a2":"SA","name":"South America"},"geometry":{"type":"MultiPolygon","coordinates":[[[[2042,4982],[2057,4981],[2063,4959],[2047,4958],[2041,4944],[2030,4948],[2032,4981],[2042,4982]]],[[[2057,5107],[2069,5101],[2088,5112],[2083,5080],[2057,5107]]],[[[2093,4769],[2083,4773],[2111,4775],[2133,4760],[2113,4746],[2093,4769]]],[[[2105,5194],[2090,5187],[2097,5168],[2086,5153],[2067,5158],[2075,5180],[2077,5208],[2091,5210],[2105,5194]]],[[[2784,6507],[2766,6511],[2795,6520],[2789,6506],[2800,6511],[2808,6504],[2832,6500],[2819,6466],[2790,6456],[2767,6457],[2761,6477],[2752,6484],[2765,6501],[2784,6507]]],[[[1592,6518],[1592,6500],[1601,6494],[1593,6470],[1592,6489],[1581,6480],[1567,6479],[1576,6492],[1561,6509],[1569,6513],[1580,6496],[1592,6518]]],[[[3135,4751],[3177,4747],[3203,4721],[3193,4715],[3183,4730],[3149,4750],[3135,4751]]],[[[2459,4867],[2482,4856],[2512,4855],[2494,4833],[2473,4822],[2460,4829],[2485,4845],[2459,4867]]],[[[2499,4832],[2520,4845],[2521,4859],[2539,4851],[2552,4856],[2557,4843],[2537,4835],[2537,4827],[2514,4831],[2498,4817],[2499,4832]]],[[[2282,4710],[2287,4697],[2272,4699],[2266,4690],[2277,4679],[2266,4673],[2265,4700],[2253,4701],[2245,4714],[2282,4710]]],[[[1964,6720],[1985,6741],[1979,6762],[1995,6747],[1992,6759],[2012,6772],[2028,6793],[2034,6819],[2054,6835],[2068,6825],[2073,6841],[2099,6840],[2130,6858],[2132,6868],[2146,6875],[2163,6864],[2156,6854],[2139,6849],[2150,6823],[2134,6797],[2152,6774],[2165,6783],[2166,6795],[2150,6826],[2198,6847],[2187,6857],[2200,6874],[2207,6845],[2230,6845],[2244,6835],[2248,6819],[2257,6816],[2306,6821],[2319,6809],[2341,6803],[2368,6816],[2375,6823],[2410,6824],[2433,6821],[2405,6818],[2436,6796],[2442,6799],[2467,6782],[2470,6761],[2490,6759],[2515,6745],[2536,6723],[2536,6711],[2547,6708],[2574,6687],[2610,6678],[2613,6683],[2644,6684],[2666,6679],[2696,6668],[2726,6645],[2736,6631],[2748,6630],[2750,6615],[2764,6572],[2787,6557],[2788,6543],[2761,6514],[2748,6505],[2747,6478],[2732,6466],[2720,6469],[2705,6462],[2728,6463],[2756,6476],[2765,6456],[2807,6452],[2833,6470],[2842,6489],[2878,6488],[2888,6479],[2897,6482],[2922,6458],[2932,6472],[2946,6455],[2950,6434],[2959,6427],[2970,6442],[3013,6426],[3013,6430],[3039,6423],[3079,6425],[3118,6401],[3161,6365],[3180,6359],[3211,6358],[3218,6348],[3232,6299],[3231,6277],[3217,6239],[3184,6201],[3170,6193],[3148,6155],[3128,6129],[3111,6115],[3106,6077],[3112,6042],[3102,6002],[3104,5987],[3087,5961],[3087,5934],[3068,5901],[3057,5891],[3047,5870],[3050,5857],[3021,5839],[3018,5826],[2940,5821],[2919,5804],[2906,5801],[2874,5784],[2848,5765],[2826,5735],[2823,5709],[2832,5685],[2819,5649],[2790,5622],[2775,5590],[2751,5557],[2751,5570],[2763,5579],[2764,5593],[2748,5599],[2742,5570],[2728,5563],[2720,5549],[2718,5531],[2707,5504],[2685,5483],[2674,5462],[2639,5443],[2614,5449],[2599,5445],[2575,5459],[2553,5459],[2538,5477],[2538,5505],[2532,5465],[2545,5450],[2563,5441],[2574,5425],[2571,5403],[2587,5395],[2588,5380],[2564,5345],[2561,5336],[2518,5317],[2465,5308],[2431,5309],[2423,5279],[2422,5242],[2399,5232],[2379,5232],[2346,5248],[2338,5237],[2341,5203],[2358,5194],[2378,5200],[2384,5176],[2370,5171],[2360,5185],[2343,5175],[2360,5168],[2333,5143],[2337,5118],[2323,5106],[2326,5094],[2308,5095],[2288,5087],[2275,5073],[2266,5053],[2272,5038],[2291,5022],[2314,5019],[2322,5003],[2315,4983],[2268,4946],[2260,4911],[2229,4896],[2221,4871],[2227,4845],[2244,4819],[2213,4821],[2175,4802],[2166,4759],[2148,4759],[2129,4768],[2129,4782],[2156,4787],[2162,4799],[2124,4784],[2127,4770],[2102,4782],[2116,4797],[2150,4809],[2128,4810],[2094,4786],[2082,4791],[2090,4802],[2075,4803],[2080,4819],[2091,4818],[2066,4837],[2081,4845],[2083,4860],[2066,4862],[2040,4846],[2050,4866],[2046,4881],[2069,4876],[2055,4890],[2071,4892],[2058,4901],[2068,4905],[2065,4927],[2066,4915],[2036,4879],[2037,4902],[2045,4914],[2031,4923],[2040,4937],[2051,4937],[2047,4953],[2063,4957],[2065,4928],[2067,4962],[2051,4993],[2075,5022],[2047,5035],[2033,5024],[2028,5035],[2051,5055],[2048,5064],[2071,5087],[2070,5073],[2093,5078],[2099,5098],[2094,5108],[2104,5126],[2071,5125],[2074,5137],[2106,5134],[2105,5151],[2115,5167],[2110,5177],[2120,5201],[2109,5221],[2105,5211],[2086,5211],[2080,5238],[2087,5273],[2101,5290],[2092,5326],[2080,5330],[2094,5338],[2088,5362],[2102,5369],[2118,5423],[2131,5438],[2137,5469],[2148,5490],[2155,5528],[2147,5568],[2148,5597],[2158,5607],[2151,5638],[2169,5680],[2183,5752],[2179,5771],[2182,5800],[2179,5821],[2187,5827],[2194,5873],[2190,5891],[2193,5914],[2186,5954],[2187,5963],[2155,5986],[2152,5999],[2127,6014],[2087,6030],[2044,6056],[2022,6078],[2007,6101],[2013,6116],[1985,6154],[1985,6164],[1971,6177],[1932,6268],[1918,6283],[1903,6310],[1879,6324],[1868,6337],[1877,6343],[1867,6356],[1865,6385],[1879,6400],[1903,6415],[1910,6434],[1899,6421],[1896,6429],[1875,6441],[1880,6447],[1875,6477],[1886,6483],[1887,6497],[1900,6510],[1901,6533],[1932,6541],[1931,6556],[1944,6561],[1940,6573],[1951,6586],[1967,6584],[1969,6596],[1985,6618],[1974,6632],[1981,6642],[1978,6668],[1983,6678],[1976,6690],[1980,6700],[1964,6720]]],[[[2202,4715],[2184,4717],[2169,4708],[2155,4725],[2138,4721],[2137,4733],[2168,4733],[2144,4749],[2142,4738],[2130,4754],[2141,4756],[2160,4745],[2172,4747],[2170,4758],[2182,4769],[2190,4742],[2226,4734],[2195,4748],[2191,4759],[2215,4771],[2215,4777],[2189,4773],[2184,4791],[2204,4801],[2213,4813],[2221,4804],[2232,4810],[2247,4794],[2242,4780],[2276,4749],[2318,4725],[2339,4726],[2353,4715],[2314,4712],[2297,4699],[2298,4709],[2284,4715],[2246,4719],[2229,4714],[2242,4713],[2237,4705],[2248,4689],[2227,4693],[2231,4703],[2202,4694],[2199,4709],[2202,4715]]]]}}]}

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__("Du/2");




var state = {
  lang: 'en'
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SET_LANG */], function (state, payload) {

  localStorage.setItem('lang', payload);
  var lang = localStorage.getItem('lang');

  __WEBPACK_IMPORTED_MODULE_1__main__["app"].$i18n.locale = lang;


  if (lang == 'pt') {
    alert('Idioma salvo com sucesso!');
  } else {
    alert('Language saved successfully!');
  }

  __WEBPACK_IMPORTED_MODULE_1__main__["app"].$router.push('/');

  location.reload();
});

var actions = {
  setLang: function setLang(_ref, payload) {
    var commit = _ref.commit;


    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* SET_LANG */], payload);
  }
};

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "utzq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uyGn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v2o3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actions_componentType__ = __webpack_require__("GGES");






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-pagination',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    searchQuery: {
      type: String,
      default: 'default'
    },
    order: {
      type: String,
      default: 'default'
    },
    pageCount: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 1
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    tableData: 'tableData'
  }), {
    paginationClass: function paginationClass() {
      return 'pagination-' + this.type;
    },
    totalPages: function totalPages() {
      if (this.pageCount > 0) return this.pageCount;
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage);
      }
      return 1;
    },
    pagesToDisplay: function pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages;
      }
      return this.defaultPagesToDisplay;
    },
    minPage: function minPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage > this.totalPages) {
          return this.totalPages - this.pagesToDisplay + 1;
        }
        return this.value - pagesToAdd;
      } else {
        return 1;
      }
    },
    maxPage: function maxPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage < this.totalPages) {
          return newMaxPage;
        } else {
          return this.totalPages;
        }
      } else {
        return this.pagesToDisplay;
      }
    }
  }),
  data: function data() {
    return {
      defaultPagesToDisplay: 5
    };
  },

  methods: {
    range: function range(min, max) {
      var arr = [];
      for (var i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },
    changePage: function changePage(item, searchQuery) {
      this.$emit('input', item);
      var page = item;
      var limit = this.perPage;
      var search = this.searchQuery;
      var order = this.order;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_actions_componentType__["a" /* TIPO_REQUEST */], { page: page, limit: limit, search: search, order: order });
    },
    nextPage: function nextPage() {
      if (this.value < this.totalPages) {
        this.$emit('input', this.value + 1);
      }
      var page = this.value + 1;
      var limit = this.perPage;
      var search = '';
      var order = this.order;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_actions_componentType__["a" /* TIPO_REQUEST */], { page: page, limit: limit, search: search, order: order });
    },
    prevPage: function prevPage() {
      if (this.value > 1) {
        this.$emit('input', this.value - 1);
      }
      var page = this.value - 1;
      var limit = this.perPage;
      var search = '';
      var order = this.order;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_actions_componentType__["a" /* TIPO_REQUEST */], { page: page, limit: limit, search: search, order: order });
    }
  },
  watch: {
    perPage: function perPage(value) {
      var page = 1;
      var limit = this.perPage;
      var search = '';
      var order = this.order;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_actions_componentType__["a" /* TIPO_REQUEST */], { page: page, limit: limit, search: search, order: order });
      this.$emit('input', 1);
    },
    total: function total(value) {
      this.$emit('input', 1);
    }
  }
});

/***/ }),

/***/ "v71F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('fg-input',{attrs:{"type":"text","label":"Company","disabled":true,"placeholder":"Paper dashboard"},model:{value:(_vm.user.company),callback:function ($$v) {_vm.$set(_vm.user, "company", $$v)},expression:"user.company"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('fg-input',{attrs:{"type":"text","label":"Username","placeholder":"Username"},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"email","label":"Username","placeholder":"Email"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"First Name","placeholder":"First Name"},model:{value:(_vm.user.firstName),callback:function ($$v) {_vm.$set(_vm.user, "firstName", $$v)},expression:"user.firstName"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('fg-input',{attrs:{"type":"text","label":"Last Name","placeholder":"Last Name"},model:{value:(_vm.user.lastName),callback:function ($$v) {_vm.$set(_vm.user, "lastName", $$v)},expression:"user.lastName"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('fg-input',{attrs:{"type":"text","label":"Address","placeholder":"Home Address"},model:{value:(_vm.user.address),callback:function ($$v) {_vm.$set(_vm.user, "address", $$v)},expression:"user.address"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"text","label":"City","placeholder":"City"},model:{value:(_vm.user.city),callback:function ($$v) {_vm.$set(_vm.user, "city", $$v)},expression:"user.city"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"text","label":"Country","placeholder":"Country"},model:{value:(_vm.user.country),callback:function ($$v) {_vm.$set(_vm.user, "country", $$v)},expression:"user.country"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('fg-input',{attrs:{"type":"number","label":"Postal Code","placeholder":"ZIP Code"},model:{value:(_vm.user.postalCode),callback:function ($$v) {_vm.$set(_vm.user, "postalCode", $$v)},expression:"user.postalCode"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("About Me")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.aboutMe),expression:"user.aboutMe"}],staticClass:"form-control border-input",attrs:{"rows":"5","placeholder":"Here can be your description"},domProps:{"value":(_vm.user.aboutMe)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "aboutMe", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-info btn-fill btn-wd",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.updateProfile($event)}}},[_vm._v("\n          Update Profile\n        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v("Edit Profile")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v98p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__ = __webpack_require__("jcvC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3657aad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__ = __webpack_require__("FQVD");
function injectStyle (ssrContext) {
  __webpack_require__("oHle")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3657aad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vIES":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vNb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__ = __webpack_require__("0XqQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a2eabee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__ = __webpack_require__("UJIc");
function injectStyle (ssrContext) {
  __webpack_require__("uyGn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a2eabee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a2eabee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vUIw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fullcalendar__ = __webpack_require__("olwm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_fullcalendar__);









__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default.a);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'charts',
    props: {
        online: {
            type: Boolean
        }
    },
    components: {
        Help: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__["a" /* default */]
    },
    data: function data() {
        return {
            titleChart: this.$t("141"),
            tableData: [],
            chartOptions: {
                chart: {
                    type: 'column',
                    backgroundColor: 'rgba(0,0,0,0)',
                    style: {
                        fontFamily: '\'Unica One\', sans-serif'
                    },
                    plotBorderColor: '#606063'
                },
                title: {
                    text: '',
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase',
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }
                },
                subtitle: {
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase'
                    }
                },
                xAxis: {
                    categories: [],
                    crosshair: true,
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        },
                        overflow: false
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    title: {
                        style: {
                            color: '#A0A0A3'
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: this.$t("131"),
                        style: {
                            color: '#A0A0A3',
                            fontSize: '12px'
                        }
                    },
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    tickWidth: 1
                },
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    },
                    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y} </b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    series: {
                        dataLabels: {
                            enabled: true,
                            color: '#F0F0F3',
                            style: {
                                fontSize: '13px'
                            },
                            format: '{point.y:.1f}%'
                        },
                        marker: {
                            lineColor: '#333'
                        }
                    },
                    boxplot: {
                        fillColor: '#505053'
                    },
                    candlestick: {
                        lineColor: 'white'
                    },
                    errorbar: {
                        color: 'white'
                    },
                    column: {
                        pointPadding: 0.1,
                        borderWidth: 0
                    }
                },
                legend: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    itemStyle: {
                        color: '#E0E0E3'
                    },
                    itemHoverStyle: {
                        color: '#FFF'
                    },
                    itemHiddenStyle: {
                        color: '#606063'
                    },
                    title: {
                        style: {
                            color: '#C0C0C0',
                            fontSize: '12px'
                        }
                    }
                },
                labels: {
                    style: {
                        color: '#707073'
                    }
                },
                drilldown: {
                    activeAxisLabelStyle: {
                        color: '#F0F0F3'
                    },
                    activeDataLabelStyle: {
                        color: '#F0F0F3'
                    }
                },
                navigation: {
                    buttonOptions: {
                        symbolStroke: '#DDDDDD',
                        theme: {
                            fill: '#505053'
                        }
                    }
                },

                rangeSelector: {
                    buttonTheme: {
                        fill: '#505053',
                        stroke: '#000000',
                        style: {
                            color: '#CCC'
                        },
                        states: {
                            hover: {
                                fill: '#707073',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            },
                            select: {
                                fill: '#000003',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    },
                    inputBoxBorderColor: '#505053',
                    inputStyle: {
                        backgroundColor: '#333',
                        color: 'silver'
                    },
                    labelStyle: {
                        color: 'silver'
                    }
                },
                navigator: {
                    handles: {
                        backgroundColor: '#666',
                        borderColor: '#AAA'
                    },
                    outlineColor: '#CCC',
                    maskFill: 'rgba(255,255,255,0.1)',
                    series: {
                        color: '#7798BF',
                        lineColor: '#A6C7ED'
                    },
                    xAxis: {
                        gridLineColor: '#505053'
                    }
                },
                scrollbar: {
                    barBackgroundColor: '#808083',
                    barBorderColor: '#808083',
                    buttonArrowColor: '#CCC',
                    buttonBackgroundColor: '#606063',
                    buttonBorderColor: '#606063',
                    rifleColor: '#FFF',
                    trackBackgroundColor: '#404043',
                    trackBorderColor: '#404043'
                },
                series: [{
                    name: this.$t("135"),
                    color: '#F45B5B',
                    data: [],
                    tooltip: {
                        valueSuffix: ' %'
                    }
                }],
                exporting: { enabled: false },
                credits: {
                    enabled: false
                },
                loading: {
                    labelStyle: {
                        color: 'black',
                        textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
                    },
                    style: {
                        backgroundColor: 'none',
                        opacity: 1
                    }
                }

            }
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4__utils_mixin__["a" /* default */]],
    methods: {
        getData: function getData() {
            var API = "https://api.semeq.com.br/";
            var ENDPOINT = 'v1/mysemeq-ambev/get-history-failure';

            var filters = {};
            if (this.online) {
                filters = this.filtersOn;
            } else {
                filters = this.filters;
            }

            filters['online'] = 0;
            if (this.online) {
                filters['online'] = 1;
                filters['plant'] = filters['planta'];
                filters['area'] = filters['area_f'];
                filters['component'] = filters['subset'];
            }

            this.$refs.chart.chart.showLoading();


            var self = this;
            __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ENDPOINT, params: filters, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
                self.tableData = resp.data;
                self.$refs.chart.chart.hideLoading();
            }).catch(function (err) {
                self.ApiErrorHandler(self, error.response.data.status_code);
                self.$refs.chart.chart.showLoading('Error');
            });
        },
        setChartData: function setChartData() {
            var self = this;
            var res = self.tableData;

            self.chartOptions.xAxis.categories = [];
            self.chartOptions.series[0].data = [];
            if (res) {
                res.forEach(function (it) {
                    self.chartOptions.xAxis.categories.push(it[0]);
                    self.chartOptions.series[0].data.push(it[1]);
                });
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filters', 'filtersOn'])),
    watch: {
        filters: function filters(newValue) {
            this.getData();
        },
        filtersOn: function filtersOn(newValue) {
            this.getData();
        },
        tableData: function tableData() {
            this.setChartData();
        }
    }
});

/***/ }),

/***/ "vaG6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vaZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.baseComponent,{tag:"component",class:{active: _vm.isActive},attrs:{"to":_vm.link.path ? _vm.link.path : '/',"tag":"li"}},[(_vm.isMenu)?_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.collapseMenu}},[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t(_vm.link.name))+"\n      "),_c('b',{staticClass:"caret"})])]):_vm._e(),_vm._v(" "),(_vm.$slots.default || this.isMenu)?_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsed),expression:"!collapsed"}],staticClass:"nav"},[_vm._t("default")],2)])],1):_vm._e(),_vm._v(" "),(_vm.children.length === 0 && !_vm.$slots.default && _vm.link.path)?_vm._t("title",[_c(_vm.elementType(_vm.link, false),{tag:"component",class:{active: _vm.link.active},attrs:{"to":_vm.link.path,"target":_vm.link.target,"href":_vm.link.path}},[(_vm.addLink)?[_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.$t(_vm.link.name)))])]:[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t(_vm.link.name)))])]],2)]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vnEV":
/***/ (function(module, exports) {

module.exports = {"380":"La migración de los sensores a la nueva plataforma de monitoreo está en curso. Las zonas AFR, APAC, SAZ y NAZ ya están en una etapa avanzada, esperando únicamente la liberación de las nuevas reglas de firewall por parte de ABI. Las zonas EUR y MAZ se completarán pronto. Recomendamos que, a partir de este mes, se comunique con su gestor de cuentas para solicitar acceso al nuevo panel.","381":"Importante: La plataforma actual será desactivada a finales de julio de 2025. La API de la versión antigua también será descontinuada en el mismo período. Si utiliza integraciones con la API anterior, deberá actualizar los endpoints y migrar a la nueva API.","382":"Cerrar","383":"Atención: Migración a la nueva plataforma en curso.","hello123":"hola","bye123":"adiós","car":"caro","logout":"Dejar","usuario_logado":"Usuario registrado","home":"Home","menu.home":"Home","menu.crud":"CRUD","menu.saude.das.plantas":"Plantas de la Salud","menu.crud.component.type":"Tipo de equipo","menu.crud.items.repair":"Artículos para Reparar","menu.adm":"ADM","menu.usuario":"Usuario","menu.tour":"Tour","menu.autorizacao":"Autorización","menu.perfil":"Perfil","menu.idioma":"Idioma","menu.configuracao.planta":"Configuración de Planta","menu.cronograma":"Contrato","menu.cronograma.contrato":"Contrato de Planificación","menu.relatorio":"Informe","menu.geral.planta":"General de la Planta","menu.baixa.rdp.rci":"Cierre del RDP (RCI)","menu.aprovacao.rdp":"Aprobación RDP","menu.amostras.justificadas":"Muestras justificadas","menu.impressao.relatorio":"Imprimir informe","menu.indicadores":"Indicadores","menu.situacao.coleta":"Situación de la Colección","menu.quantidade.rdps":"Cantidad de RDPs","menu.indice.falha":"Índice de Fallo","menu.taxa.falha":"Índice de Intervención","menu.indice.intervercao":"Índice de Eje. de Intervención","menu.intranet":"Intranet","menu.situacao.amostras":"Situación de Muestras","menu.indice.prescricao":"Índice de Prescripción","menu.medicao.viscosidade":"Medida de la viscosidad","menu.log.coletor":"Registro de Coletor","titulo.notas.versao":"Notas de versión","titulo.notas.versao.novo":"Novedades","notas.versao.v.705.1":"Añadido a la opción de período igual a 5 años en la configuración de los indicadores de dimensión tiempo, en el dashboard.","notas.versao.v.677.1":"Añadido fecha de creación y fecha de aprobación para aprobación de RDP.","notas.versao.v.677.2":"Añadido filtro de fecha para muestras justificadas sucessivamente.","notas.versao.v.672.1":"Una nueva curva fue añadida en el Índice de ejecución de intervención en la dimensión tiempo. Esta nueva curva gris se refiere al índice de ejecución de intervención acumulado en el periodo seleccionado.","notas.versao.v.657.1":"Añadido a la visualización de prescripción. La prescripción cuando esta disponible puede visualizarse junto a RDP y a RCI.","notas.versao.v.561.1":"Añadido la posibilidad de filtrar por Fecha de referencia y Situación de RDP en el filtro permanente deaprobación.","notas.versao.v.561.2":"Añadido la posibilidad de filtrar por Fecha de referencia en el filtro permanente de índice de cantidad de Rdp's.","notas.versao.v.561.3":"Añadido grupo de defecto, defecto y modo potencial de fallo en el filtro permanente en Índice de Fallo.","notas.versao.v.561.4":"Añadido grupo de defecto, defecto y modo potencial de fallo en el filtro de Dashbord de Índice de Grupo de Fallo. Disponible la selección de niveles (grupo de defecto, defecto y modo potencial de fallo) en la visualización de Índice de Grupo de Fallo.","notas.versao.v.554.1":"Optimización de el tiempo de abertura dos informes (RDP).","notas.versao.v.468.1":"Foi Añadido uma nova columna contendo o Modo potencial de fallo, na exportación do informe de Conclusão de Intervención (RCI).","notas.versao.v.423.1":"O filtro rápido é desabilitado quando um filtro permanente é seleccionado, evitando uma posible confusão sobre qual filtro esta sendo utilizado.","notas.versao.v.411.1":"Añadido um novo informe que indica as muestras justificadas sucessivamente.","notas.versao.v.385.1":"Añadido um novo indicator no dashboard para mostrar o índice anual de ejecución de intervención.","notas.versao.v.381.1":"Añadido novo indicator para mostrar a situación das muestras.","notas.versao.v.371.1":"Nova página para alterar a contraseña.","notas.versao.v.365.1":"Criado um novo objeto no menu Indicadores para visualización de índice de eficiência de ejecución de intervención (Índice de ejecución de intervención).","notas.versao.v.361.1":"Foi implementado mudanças que permobjeto o funcionamento total no Internet Explorer versão 9 ou superior.","notas.versao.v.352.1":"Foi Añadido uma nova ferramenta para aprobación e desaprobación de RDP. A mesma está Disponible no menu informe/aprobación de RDP.","notas.versao.v.342.1":"Añadido click na columna para listar todas as RDP's na dimensão tiempo no índice de intervención.","notas.versao.v.335.1":"Melhora na notificación por e-mail.","notas.versao.v.331.1":"Problemas ao digitar nos campos de texto no indicador de defecto resolvido.","notas.versao.v.331.2":"Algunas traduções foram alteradas.","notas.versao.v.331.3":"Añadido tooltip para os icones help e release.","notas.versao.v.328.1":"Criado um novo objeto no menu informe para visualización de RDP (Baixa RDP (RCI)). A nova página oferece uma nova Tabla onde Es posible visualizar e exportar as RDP's por mês ou todas as RDP's.","notas.versao.v.328.2":"Añadido help para Baixa RDP (RCI)","notas.versao.v.328.3":"Criado uma nova página que contém as notas de versão como novas herramientas e problemas corrigidos. A tela é acessível pelo ícone ao lado do help.","notas.versao.v.322.1":"Corrigido a exportación do CSV onde a columna Status era sempre exportada em inglês.","notas.versao.v.322.2":"Añadido mais detalhes no Help do dashboard.","notas.versao.v.322.3":"Alterado o nombre da técnica análisis de motor elétrico para análisis de Circuito de Motores.","notas.versao.v.320.1":"Añadido pareto na dimensão tiempo no indicador de falha.","notas.versao.v.320.2":"Corrigido o mau funcionamento do pareto pela tecla CTRL após abrir o help.","notas.versao.v.311.1":"Añadido novo help com imagens ilustrativas e mejores explicações em relación as herramientas e opciones de cada tela.","notas.versao.v.305.1":"Añadido nova ferramenta para ordenar os gráficos na dimensão planta.","notas.versao.v.301.1":"Foram feitas alterações para melhorar o funcionamento do software no navegador Google Chrome.","notas.versao.v.301.2":"Otras correcciones menores.","notas.versao.v.298.1":"Añadido cores fixas para os gráficos de indicador de defecto no dashboard.","notas.versao.v.298.2":"Otras correcciones menores.","notas.versao.versao.anterior":"Versión anterior","notas.versao.novo.mysemeq":"Nuevo MySemeq","notas.versao.rastreamento.processo":"Proceso de Seguimiento","notas.versao.cronograma.servico":"Horas de Servicios - Estático","notas.versao.cronograma.servico.tempo.real":"Horas de Servicios - tiempo Reales","notas.versao.em.breve":"Pronto","notas.versao.rel.tec.tecnica":"Informe Técnico por Técnica","notas.versao.rel.saude.maquinas":"Informe técnico para Salud de Máquinas","notas.versao.historico.obs":"Histórico - Observación de reincidencia de Defectos","notas.versao.filtro.tabelas":"Filtros y tablas personalizadas","notas.versao.historico.ensaio":"Historia de los Ensayos(equipo) Eliminado del plan","notas.versao.inte.negocios":"Inteligencia de Negocios (B.I.)","notas.versao.com.planta":"Comparación de las Plantas","notas.versao.com.tecnica":"Comparación de las Técnicas","notas.versao.ana.defeito.tempo":"Análisis de Grupo/ Tipos de defectos en el Tiempo","notas.versao.ana.defeito.planta":"Análisis de Grupo de Defecto de Plantas","notas.versao.exportacao.excel":"Exportar Archivo - Excel","notas.versao.exportacao.jpge":"Exportación de los Indicadores - JPEG","notas.versao.impressao.grafico":"Impresión de los Gráficos","notas.versao.indicadores.processo":"Indicadores de Proceso","notas.versao.indice.coleta":"Índice de colección/Justificaciones","notas.versao.quantidade.laudo":"Número de Informes","notas.versao.indice.falha":"Índice de Fallo","notas.versao.indicadores.result":"Indicadores de Resultado","notas.versao.taxa.falha":"Índice de Intervención","notas.versao.indice.exe.intervencao":"Índice de Ejecución de Intervención","notas.versao.relatorio.ganho":"Informe de ganancias (Downtime)","notas.versao.defeito.tipo.efeito":"Defectos Causa y Efecto","notas.versao.mtbf.setor":"MTBF Corporación/Planta y Sector","notas.versao.indicadores.qualidade":"Indicadores de Calidad","notas.versao.indice.monitoramento":"Índice de Confiabilidad de Monitoreo","notas.versao.automacao.integracao":"Automatización y Integración","notas.versao.notificacao.email":"Notificación de informes por email","notas.versao.integracao.erp":"Integración con ERP - Apertura de notas de servicio","notas.versao.relatorio.intervencao":"Informe de Terminación de la intervención","notas.versao.tempo.atualizacao.dados":"Tiempo de actualización de datos","notas.versao.interface.usuario":"Interfaz de usuario","notas.versao.apresentacao.corporacao":"Presentación de la Salud de Corporación","notas.versao.dashboard.personalizado":"Dashboard Personalizado","notas.versao.impressao.dashboard":"Imprimir Dashboard","notas.versao.pagina.help.passo":"Páginas de ayuda paso a paso y muy detallada","notas.versao.notas.versao":"Notas de versión","notas.versao.novo.layout.laudos":"Nueva disposición de informes","notas.versao.multilinguas":"Plurilingüe","notas.versao.portugues":"Portugués","notas.versao.ingles":"Inglés","notas.versao.espanhol":"Español","notas.versao.alemao":"Alemán","notas.versao.frances":"Frances","notas.versao.polones":"Polaco","notas.versao.navegadores.suportado":"Navegadores compatibles","notas.versao.suporte.novas.tecnologias":"El apoyo a las nuevas tecnologías y navegadores. *","notas.versao.versao.exploreie":"* Internet Explorer disponible sólo en la versión 9 o superior.","card.capacity":"Capacidad","grafico.traducao":"espanhol","modal.pesquisar":"OK","modal.filtro.pesquisa":"Filtro de búsqueda","guia.traducao":"Guia ES","filtro.grafico.crie.um.filtro":"Crie um filtro","filtro.grafico.subtitutlo":"Seleccione debajo de los filtros para su gráfico.","filtro.grafico.adicionar.filtro":"Añadir Filtro","filtro.grafico.reiniciar.filtro":"Reanudar Filtro","filtro.grafico.selecione":"seleccionar","filtro.grafico.corporacao":"Corporação","filtro.grafico.planta":"Planta","filtro.grafico.area":"Área","filtro.grafico.setor":"Sector","filtro.grafico.conjunto":"Conjunto","filtro.grafico.tag.conj":"Tag. Conj.","filtro.grafico.equipamento":"Equipamiento","filtro.grafico.tag.eq":"Tag. Eq.","filtro.grafico.tipo.equipamento":"Tipo de Equipamiento","filtro.grafico.tecnica":"Técnica","filtro.grafico.igual":"Igual","filtro.grafico.fora.de":"Fuera de","filtro.grafico.diferente":"Diferente","filtro.grafico.menor":"Menor","filtro.grafico.maior":"Mayor","filtro.grafico.contem":"Contiene","filtro.grafico.nao.contem":"No Contiene","filtro.grafico.entre":"Entre","filtro.grafico.nome.indicador":"Nombre del indicador","filtro.grafico.periodo":"Período","filtro.grafico.mes.anterior":"Mês anterior","filtro.grafico.mes.corrente":"Mês corrente","filtro.grafico.ultimo.tres.meses":"Últimos 3 meses","filtro.grafico.tipo":"Tipo","filtro.grafico.pizza":"Pizza","filtro.grafico.barra":"Barra","filtro.grafico.coluna":"Coluna","filtro.grafico.btn.fechar":"Cerrar","filtro.grafico.btn.salvar":"Guardar","help-grafico-text-1":"El constructor de filtros esta dividido en dos fases, en la primera es posible crear y alterar las condiciones del filtro, Añadir un nombre al gráfico. En la segunda estan las opciones de gráfico, es posible alterar el periodo y el tipo de gráfico.","help-grafico-titulo.add.limpando":"Añadiendo / Limpiando","help-grafico-text-2":"El botón 'Añadir Filtro' permite Añadir una nueva linea de condición. No hay limites para Añadir nuevas condiciones. el botón 'Reiniciar Filtro' limpará todas las condiciones existentes, para eliminar una condición clique en ícono con un 'X' que antecede a condición deseada.","help-grafico-titulo.condicao":"Condición","help-grafico-text-3":"Aqui es posible seleccionar las siguientes condiciones:","help-grafico-text-4":"Igual:","help-grafico-text-4-1":"Seleccione esta opción para buscar exactamente el valor que fue insertado.","help-grafico-text-5":"Fora de:","help-grafico-text-5-1":"Seleccione esta opción para buscar valores diferentes al valor que fue insertado.","help-grafico-text-6":"Diferente:","help-grafico-text-6-1":"Seleccione esta opción para buscar cualquier valor que sea diferente al insertado.","help-grafico-text-7":"Menor:","help-grafico-text-7-1":"Seleccione esta opción para buscar todos los valores menores al que fue insertado","help-grafico-text-8":"Maior:","help-grafico-text-8-1":"Seleccione esta opción para buscar todos los valores mayores al que fue insertado","help-grafico-text-9":"Contém:","help-grafico-text-9-1":"Seleccione esta opción para buscar todos los registros que contienen el valor insertado. Esta opcion devolverá todos los valores que contengan el valor insertado, por ejemplo si el valor insertado fue 'Mot' devolverá el registro 'Motor', si existen.","help-grafico-text-10":"Não contém:","help-grafico-text-10-1":"Seleccione esta opción para buscar todos os registros que no contienen el valor insertado. Esta opcion devolverá todos los valores que no contengan el valor insertado, por ejemplo si el valor insertado fue 'Mot' no retornará los registros que contengan 'Motor', si existen.","help-grafico-text-11":"Entre:","help-grafico-text-11-1":"Seleccione esta opción para buscar valores entre dos limites predefinidos","help-grafico-titulo.valores":"Valores","help-grafico-text-12":"Inserte el valor deseado seguido de los patrones listados abajo.","help-grafico-text-13":"Igual:","help-grafico-text-13-1":"i la condición es Igual, Inserte los valores deseados separados por comas sin espacios, por ejemplo, si desear buscar 'Moto' y 'Bomba', Inserte 'Motor,Bomba' sin comillas, o solo 'Motor' sin comillas para filtrar solo 'Motor'.","help-grafico-text-14":"Fora de:","help-grafico-text-14-1":"Si la condición es Fora de, Inserte los valores deseados separados por comas sin espacios, por ejemplo, se desear buscar por registros que no contien 'Motor' ni 'Bomba', Inserte 'Motor,Bomba' sin comillas, o solo 'Motor' sin comillas para filtrar apenas 'Motor'.","help-grafico-text-15":"Entre:","help-grafico-text-15-1":"Si la condición es Entre es preciso Insertar los dos valores que limitaran la busqueda, por ejemplo, para buscar una fecha entre 01/01/2012 y 01/06/2012, Inserte los dos valores separados por comas como '01/01/2013,01/06/2013' sin comillas.","help-grafico-text-16":"Diferente, menor, maior, contiene y no contien:","help-grafico-text-16-1":"Para estas condiciones Inserte un valor único. No es posible Insertar dos valores, para eso Añada una nueva linea e Inserte el próximo valor.","help-grafico-titulo.inserir.nome":"Insertar nombre","help-grafico-text-17":"Inserte aquí un nombre para identificar el gráfico de acuerdo con el filtro creado para organizar mejor se dashboard.","help-grafico-titulo.periodo":"Periodo","help-grafico-text-18":"Seleccione el periodo deseado para el gráfico seleccionado. Las opciones son fijas y varian según el gráfico.","help-grafico-titulo.tipo.grafico":"Tipo de gráfico","help-grafico-text-19":"Seleccione el tipo de gráfico para visualizar de maneras diferentes la información. Las opciones son fijas y son diferentes para cada gráfica.","cadastro.tipo.equipamento.tabela.descricao":"Descripción","cadastro.tipo.equipamento.tabela.acao":"Conduct","quantidade-linhas-tabela":"Tablas extendidas:","tabela.search":"Buscar","paginacao-showing":"Demostración","paginacao-to":"de","paginacao-of":"total","paginacao-entries":"líneas","cadastro.editar":"Editar","cadastro.titulo.descricao":"Descripción","cadastro.btn.editar":"Guardar","cadastro.btn.novo":"Nuevo","cadastro.btn.pesquisar":"Investigación","id.tabela.tipo.equipamento":"ID","cadastro.aviso.atencao":"Atención","cadastro.aviso.aviso":"Advertencia","cadastro.aviso.atencao.a":"Por favor seleccione una descripción abajo para editar!","cadastro.aviso.atencao.b":"¡Please enter la descripción!","cadastro.aviso.atencao.c":"¡Please enter la tipo de equipo!","cadastro.titulo.tipo.equipamento":"Tipo de equipo","cadastro.sweet.text.alterar":"Cambiar la descripción del tipo de equipo?","cadastro.sweet.text.erro.alterar":"Error al cambiar!","cadastro.sweet.text.erro.alterar.msg":"¡Por favor, inténtelo de nuevo más tarde!","cadastro.sweet.text.alterar.sucesso":"Cambiado!","cadastro.sweet.text.alterar.sucesso.msg":"Tipo de equipo cambiado con éxito!","cadastro.sweet.text.criar":"Crear nuevo tipo de equipo?","cadastro.sweet.text.criar.erro":"Error al insertar!","cadastro.sweet.text.criar.erro.msg":"Por favor, inténtelo de nuevo más tarde!","cadastro.sweet.text.criar.salvo":"Guardar","cadastro.sweet.text.criar.salvo.msg":"Tipo de equipo creado con éxito!","cadastro.sweet.text.excluir":"Excluir Tipo de equipo?","cadastro.sweet.text.excluir.erro":"Error al eliminar!","cadastro.sweet.text.excluir.erro.msg":"Por favor, inténtelo de nuevo más tarde!","cadastro.sweet.text.excluir.sucesso":"Excluidos!","cadastro.sweet.text.excluir.sucesso.msg":"Tipo de equipo excluido con éxito!","cadastro.numero.caracteres":"Número de caracteres restantes","helper.msg.cadastro.01":"Introduzca una descripción para un tipo de equipo, teniendo en cuenta que hasta un máximo de 40 caracteres y admite los siguientes caracteres especiales:   - . / % <> , * () + ","helper.msg.cadastro.02":"Después de ingresar una descripción para el nuevo tipo de equipo, haga clic en el botón (Nuevo), esto guardará un nuevo tipo de equipo.","helper.msg.cadastro.03":"EDITAR: En la tabla de abajo para editar una descripción, haga clic en el icono ","helper.msg.cadastro.04":"ubicado en la columna (Acciones), por lo que la descripción se cargará en la ventana anterior para cambiarla.","helper.msg.cadastro.05":"Después de cargar la descripción y la edición seleccionadas, haga clic en este botón, luego aparece una ventana de confirmación y, si se confirma, se guardarán los cambios. ","helper.msg.cadastro.06":"ELIMINAR: en la tabla siguiente para eliminar un tipo de equipo, haga clic en el icono ","helper.msg.cadastro.07":"que está en la columna (Acciones), luego muestra una pantalla de confirmación y, si se confirma, se eliminará del tipo de equipo seleccionado.","helper.msg.cadastro.08":"Seleccione el número de líneas que desee","helper.msg.cadastro.09":"para mostrar en la tabla de abajo.","helper.msg.cadastro.10":"Ingrese la descripción del tipo de equipo que desea ver y se filtrará en la tabla.","helper.msg.cadastro.11":"ASCENDING: para los datos de la tabla mostrados ASCENDING, haga clic en el icono","helper.msg.cadastro.12":"junto a Descripción.","helper.msg.cadastro.13":"ORDEN DE DISMINUCIÓN: Para que los datos de la tabla se muestren DESCENDIENDO, haga clic en el icono ","helper.msg.cadastro.14":"junto a Descripción.","helper.msg.cadastro.15":"PAGINACIÓN: para navegar por la tabla, haga clic en la numeración de las páginas o avance haciendo clic en el icono","helper.msg.cadastro.16":" o devolver las páginas anteriores haciendo clic en el icono ","helper.msg.cadastro.17":"Terminado","helper.msg.cadastro.18":"Limpia el campo de descripción.","crud.title.items.repair":"Artículos para Reparar","crud.items.repair.component.type":"Tipo del equipo","crud.items.repair.tipo":"Tipo","crud.items.repair.descricao":"Descripción","cadastro.sweet.text.item.repair.criar":"Crear nuevo elemento a reparar?","cadastro.sweet.text.item.repair.criar.salvo.msg":"¡Elemento a reparar creado con éxito!","item.repair.sweet.text.excluir.sucesso.msg":"¡Elemento a reparar eliminado con éxito!","item.repair.sweet.text.excluir":"Eliminar Elemento a reparar?","item.repair.sweet.text.alterar.sucesso.msg":"Elemento a reparar cambiado con éxito!","item.repair.sweet.text.alterar":"¿Cambiar la descripción del Elemento a reparar?","item.repair.search.type":"Procurar por:","item.repair.search.type.desc":"DESCRIPCIÓN","item.repair.search.type.type":"TIPO","helper.msg.item.repair.01":"Introduzca aquí una descripción para un artículo a reparar, recordando que hasta un máximo de 40 caracteres y acepta los siguientes caracteres especiales:   - . / % <> , * () + ","helper.msg.item.repair.02":"Después de informar una descripción al nuevo ítem a reparar informe un tipo de equipo, vea que al escribir él informa en un combo opcões relacionadas, así que haga clic sobre el tipo de equipo deseado.","helper.msg.item.repair.03":"Después de insertar una descripción para el nuevo elemento a reparar y seleccionar un tipo de equipo, haga clic en el botón (Nuevo), así se guardará un nuevo elemento a reparar.","helper.msg.item.repair.04":"EDITAR: En la siguiente tabla para editar una descripción, haga clic en el icono ","helper.msg.item.repair.05":"que queda en la columna (Acciones), así la descripción y el tipo de equipo será cargado en las respectivas ventanas arriba para ser alteradas.","helper.msg.item.repair.06":"Después de editar la información deseada, haga clic en este botón, a continuación, aparecerá una ventana de confirmación y si se confirma, se guardarán los cambios. ","helper.msg.item.repair.07":"EXCLUIR: En la tabla siguiente para eliminar un elemento a reparar, haga clic en el icono","helper.msg.item.repair.08":"que se encuentra en la columna (Acciones), a continuación se mostrará una pantalla de confirmación y si se confirma, se eliminará el elemento a reparar seleccionado.","helper.msg.item.repair.09":"Seleccione la cantidad de líneas","helper.msg.item.repair.10":"que desea mostrar en la siguiente tabla. ","helper.msg.item.repair.11":"Indicar por qué columna desea buscar (DESCRIPCIÓN O TIPO), por defecto viene seleccionada la opción Descripción.","helper.msg.item.repair.12":"Después de seleccionar por qué columna desea buscar, escriba en este campo la búsqueda y así será filtrado en la tabla abajo.","helper.msg.item.repair.13":"ORDEN CRECIENTE: para que los datos de la tabla se muestren de forma CRECIENTE, haga clic en el icono ","helper.msg.item.repair.14":". Así la tabla será ordenada de forma CRECIENTE conforme a la columna que pertenece (por ejemplo, TIPO O DESCRIPCIÓN).","helper.msg.item.repair.15":"ORDEN DECRESCENTE: para que los datos de la tabla se muestren de forma DECRESCENTE, haga clic en el icono","helper.msg.item.repair.16":". Assim a tabela será ordenada de forma DECRESCENTE conforme a coluna que pertence (ex: TIPO OU DESCRIÇÃO).","helper.msg.item.repair.17":"Limpia el campo de descripción.","helper.msg.item.repair.18":"PAGINACIÓN: para navegar en la tabla, haga clic en la numeración de las páginas o avance haciendo clic en el icono ","helper.msg.item.repair.19":" o volver a las páginas anteriores haciendo clic en el icono ","menu.crud.fail.mode":"Modo de falla (M.P.D.F)","crud.title.fail.mode":"Modo de falla (M.P.D.F)","crud.fail.mode.itens.repair":"Artículos para Reparar","crud.fail.mode.falha":"Culpa","crud.fail.mode.causa.efeito":"Causa o efecto","crud.fail.mode.tipo":"Tipo de Componente","crud.fail.mode.descricao":"Descripción","crud.fail.mode.codigo":"Código","crud.fail.mode.causa.efeito.tb":"Causa/Efecto","menu.crud.fail":"Fallar","cadastro.titulo.fail":"Registro de fallos","cadastro.titulo.fail.color":"Establecer color","cadastro.fail.tabela.descricao":"Descripción","cadastro.fail.tabela.color":"Color","cadastro.aviso.atencao.color":"Por favor, establece un color!","cadastro.sweet.text.criar.fail":"Crear nuevo fallo?","cadastro.sweet.text.alterar.fail":"Cambiar el fallo?","cadastro.sweet.text.excluir.fail":"Eliminar fallo?","cadastro.sweet.text.excluir.sucesso.msg.fail":"¡Falla excluida con éxito!","cadastro.sweet.text.criar.salvo.msg.fail":"¡Falla guardada con éxito!","helper.msg.fail.01":"Introduzca una descripción para un Falla, teniendo en cuenta que hasta un máximo de 40 caracteres y admite los siguientes caracteres especiales:   - . / % <> , * () + ","helper.msg.fail.02":"Después de ingresar una descripción para el nuevo Falla, haga clic en el botón (Nuevo), esto guardará un nuevo Falla.","helper.msg.fail.03":"EDITAR: En la tabla de abajo para editar una descripción, haga clic en el icono ","helper.msg.fail.04":"ubicado en la columna (Acciones), por lo que la descripción se cargará en la ventana anterior para cambiarla.","helper.msg.fail.05":"Después de cargar la descripción y la edición seleccionadas, haga clic en este botón, luego aparece una ventana de confirmación y, si se confirma, se guardarán los cambios. ","helper.msg.fail.06":"ELIMINAR: en la tabla siguiente para eliminar un Falla, haga clic en el icono ","helper.msg.fail.07":"que está en la columna (Acciones), luego muestra una pantalla de confirmación y, si se confirma, se eliminará del Falla seleccionado.","helper.msg.fail.08":"Seleccione el número de líneas que desee","helper.msg.fail.09":"para mostrar en la tabla de abajo.","helper.msg.fail.10":"Ingrese la descripción del Falla que desea ver y se filtrará en la tabla.","helper.msg.fail.11":"ASCENDING: para los datos de la tabla mostrados ASCENDING, haga clic en el icono","helper.msg.fail.12":"junto a Descripción.","helper.msg.fail.13":"ORDEN DE DISMINUCIÓN: Para que los datos de la tabla se muestren DESCENDIENDO, haga clic en el icono ","helper.msg.fail.14":"junto a Descripción.","helper.msg.fail.15":"PAGINACIÓN: para navegar por la tabla, haga clic en la numeración de las páginas o avance haciendo clic en el icono","helper.msg.fail.16":" o devolver las páginas anteriores haciendo clic en el icono ","helper.msg.fail.17":"Terminado","helper.msg.fail.18":"Limpia el campo de descripción.","menu.crud.fail.group":"Grupo Falla","cadastro.titulo.fail.group":"Registro Grupo Falla","cadastro.sweet.text.criar.fail.group":"¿Crear nuevo grupo de fallos?","cadastro.sweet.text.criar.salvo.msg.geral":"¡Guardada con éxito!","00000000000":""}

/***/ }),

/***/ "vsZy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        ApiErrorHandler: function ApiErrorHandler(context, status_code) {
            switch (status_code) {
                case 401:
                    console.log('Session Expired!');

                    break;

                default:
                    break;
            }
        }

    }
});

/***/ }),

/***/ "wH4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__ = __webpack_require__("1Kqs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da06f95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__ = __webpack_require__("GJqE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da06f95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wJKS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wXZb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartReincidenciaPareto_vue__ = __webpack_require__("qBcI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dc621f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartReincidenciaPareto_vue__ = __webpack_require__("x34T");
function injectStyle (ssrContext) {
  __webpack_require__("xNyn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dc621f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartReincidenciaPareto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dc621f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartReincidenciaPareto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wfBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions_auth__ = __webpack_require__("+4WN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'register',
  data: function data() {
    return {
      username: null,
      password_actual: null,
      password_new: null,
      password_repeat_new: null,
      error: null,
      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false
      },
      year: new Date().getFullYear()
    };
  },

  methods: {
    logout: function logout() {
      var _this = this;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_actions_auth__["a" /* AUTH_LOGOUT */]).then(function () {
        return _this.$router.push('/login');
      });
    },
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },

    register: function register() {
      var _this2 = this;

      var self = this;

      if (!self.password_actual || !self.password_new || !self.password_repeat_new) {

        this.$notify({
          component: {
            template: '<span><b>' + this.$t("53") + '</b></span>'
          },
          type: 'danger',
          group: 'alert',
          horizontalAlign: 'center',
          verticalAlign: 'top'
        });
      }

      var password_new = self.password_new.length;
      console.log('total: ', password_new);
      if (password_new < 8 || password_new > 15) {
        this.$notify({
          component: {
            template: '<span><b>' + this.$t("54") + '</b></span>'
          },
          type: 'info',
          group: 'alert',
          horizontalAlign: 'center',
          verticalAlign: 'top'
        });
      } else {
        if (self.password_actual && self.password_new && self.password_repeat_new) {

          if (self.password_new != self.password_repeat_new) {

            this.$notify({
              component: {
                template: '<span><b>' + this.$t("55") + '</b></span>'
              },
              type: 'danger',
              group: 'alert',
              horizontalAlign: 'center',
              verticalAlign: 'top'
            });
          } else {
            var API = "https://api.semeq.com.br/";
            var ENDPOINT = 'v1/users/change-password';

            __WEBPACK_IMPORTED_MODULE_2_axios___default()({ method: 'GET', url: API + ENDPOINT,
              params: {
                'user': self.username,
                'password_actual': self.password_actual,
                'password_new': self.password_new
              },
              headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
              var res = resp.data;
              var hash_new = res.hash_new[0];
              var status = res.status;

              if (status == 200) {
                _this2.$notify({
                  component: {
                    template: '<span><b>' + _this2.$t("56") + '</b></span>'
                  },
                  type: 'success',
                  group: 'alert',
                  horizontalAlign: 'center',
                  verticalAlign: 'top'
                });

                localStorage.setItem('hash', hash_new);

                self.$router.push('/');
              } else {
                _this2.$notify({
                  component: {
                    template: '<span><b>' + _this2.$t("57") + '</b></span>'
                  },
                  type: 'danger',
                  group: 'alert',
                  horizontalAlign: 'center',
                  verticalAlign: 'top'
                });
              }
            }).catch(function (err) {
              _this2.$notify({
                component: {
                  template: '<span><b>' + _this2.$t("57") + '</b></span>'
                },
                type: 'danger',
                group: 'alert',
                horizontalAlign: 'center',
                verticalAlign: 'top'
              });

              self.logout();
            });
          }
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.closeMenu();
  },
  mounted: function mounted() {
    var self = this;

    var user = localStorage.getItem('username');
    self.username = user;
  }
});

/***/ }),

/***/ "whIq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"table-full-width table-tasks"},[_c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.tasks),function(task,index){return _c('task',{key:task.title,attrs:{"task":task,"index":index},on:{"on-edit":_vm.handleTaskEdit,"on-delete":_vm.handleTaskDelete}})}))])])]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Tasks")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Backend development")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"fa fa-history"}),_vm._v(" Updated 3 minutes ago\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x/a9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'circle-chart-card',
  props: {
    color: {
      type: String,
      default: 'blue'
    },
    percentage: {
      type: Number,
      default: 0
    },
    title: String,
    description: String
  },
  data: function data() {
    return {
      chartId: 'no-id',
      chart: null
    };
  },

  methods: {
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = 'div_' + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    renderChart: function renderChart(EasyPieChart) {
      this.chart = new EasyPieChart(this.$refs.chart, {
        lineWidth: 6,
        size: 160,
        scaleColor: false,
        trackColor: 'rgba(255,255,255,.25)',
        barColor: '#FFFFFF',
        animate: { duration: 2000, enabled: true }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var EasyPieChart;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "PeU/"));

            case 3:
              EasyPieChart = _context.sent;

              _this.renderChart(EasyPieChart);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    percentage: function percentage(newVal) {
      if (this.chart) {
        this.chart.update(newVal);
      }
    }
  }
});

/***/ }),

/***/ "x2Ti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sidebarClasses,attrs:{"data-background-color":_vm.backgroundColor,"data-active-color":_vm.activeColor}},[_c('div',{ref:"sidebarScrollArea",staticClass:"sidebar-wrapper"},[_vm._t("default"),_vm._v(" "),_c('ul',{class:_vm.navClasses},[_vm._t("links",_vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-item',{key:link.name + index,attrs:{"link":link}},_vm._l((link.children),function(subLink,index){return _c('sidebar-item',{key:subLink.name + index,attrs:{"link":subLink}})}))}))],2)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x34T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpreincidencepareto","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChart}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("142"))+" ")])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.$t("143"))+"\n    "),_c('button',{directives:[{name:"popover",rawName:"v-popover:helpreincidencepareto.right",arg:"helpreincidencepareto",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x8Lb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xDit":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rdp_modal_vue__ = __webpack_require__("7g4f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08296a70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rdp_modal_vue__ = __webpack_require__("opmZ");
function injectStyle (ssrContext) {
  __webpack_require__("26rS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08296a70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rdp_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08296a70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rdp_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actions_auth__ = __webpack_require__("+4WN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Charts_Grid__ = __webpack_require__("hjrP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Views_ChartsOnline_GridOnline__ = __webpack_require__("KWPQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Charts_rdp_modal__ = __webpack_require__("xDit");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_ChartsOnline_photo_modal__ = __webpack_require__("o/9F");





__webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "x36W"));
__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "p4sG"));






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  created: function created() {
    var self = this;

    var isAlreadyFetchingAccessToken = false;
    var subscribers = [];

    function onAccessTokenFetched(access_token) {
      subscribers = subscribers.filter(function (callback) {
        return callback(access_token);
      });
    }

    function addSubscriber(callback) {
      subscribers.push(callback);
    }

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      var config = error.config,
          status = error.response.status;

      var originalRequest = config;

      if (status === 401) {
        if (!isAlreadyFetchingAccessToken) {
          var hash = localStorage.getItem('hash');

          if (hash) {
            isAlreadyFetchingAccessToken = true;

            var API = "https://api.semeq.com.br/";
            var ENDPOINT = 'v1/login-mysemeq?params=';
            __WEBPACK_IMPORTED_MODULE_1_axios___default()({ method: 'GET', url: API + ENDPOINT + hash }).then(function (resp) {
              var token = resp.data;
              localStorage.setItem('user-token', resp.data['access_token']);
              __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.common['Authorization'] = resp.data['access_token'];
              var access_token = resp.data['access_token'];


              isAlreadyFetchingAccessToken = false;
              onAccessTokenFetched(access_token);
            }).catch(function (err) {
              self.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_actions_auth__["a" /* AUTH_LOGOUT */]).then(function () {
                return self.$router.push('/login');
              });
            });
          } else {
            self.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_actions_auth__["a" /* AUTH_LOGOUT */]).then(function () {
              return self.$router.push('/login');
            });
          }
        }

        var retryOriginalRequest = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
          addSubscriber(function (access_token) {
            originalRequest.headers.Authorization = 'Bearer ' + access_token;

            resolve(__WEBPACK_IMPORTED_MODULE_1_axios___default()(originalRequest));
          });
        });

        return retryOriginalRequest;
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  components: {
    grid: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard_Views_Charts_Grid__["a" /* default */],
    gridOnline: __WEBPACK_IMPORTED_MODULE_4__components_Dashboard_Views_ChartsOnline_GridOnline__["a" /* default */],
    RDPModal: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Charts_rdp_modal__["a" /* default */],
    PhotoModal: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_ChartsOnline_photo_modal__["a" /* default */]
  }
});

/***/ }),

/***/ "xNyn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xcM3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helphealth","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChartMap}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMatriz),expression:"!showMatriz"}]},[_c('p',[_vm._v(_vm._s(_vm.$t("114")))]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t("115")))])]),_vm._v(" "),_c('div',{staticClass:"form_failure_rate col-lg-12 col-xs-12"},[_c('div',{staticClass:"col-lg-3 col-xs-3",staticStyle:{"padding-top":"5px"}},[_vm._v("\n                fr = \n                ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-9 col-xs-9"},[_c('div',{staticClass:"col-lg-12 col-xs-12",staticStyle:{"border-bottom":"1px solid #fff","text-align":"center"}},[_vm._v("\n                    (ni*1)+(na*0.5)\n                  ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-xs-12",staticStyle:{"text-align":"center"}},[_vm._v("\n                    nt\n                ")])])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t("116"))+" "),_c('b',{staticStyle:{"color":"#68B3C8"}},[_vm._v("ni")]),_vm._v(" = "+_vm._s(_vm.$t("117"))+" "),_c('b',{staticStyle:{"color":"#68B3C8"}},[_vm._v("na")]),_vm._v(" = "+_vm._s(_vm.$t("118"))+" "),_c('b',{staticStyle:{"color":"#68B3C8"}},[_vm._v("nt")]),_vm._v(" = "+_vm._s(_vm.$t("119"))+"\n\n              ")]),_c('p',[_c('b',{staticStyle:{"color":"#68B3C8"}},[_vm._v(_vm._s(_vm.$t("120")))]),_vm._v(" "+_vm._s(_vm.$t("121"))+" "),_c('b',{staticStyle:{"color":"#68B3C8"}},[_vm._v(_vm._s(_vm.$t("122")))]),_vm._v(" "+_vm._s(_vm.$t("123")))])])])])],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"show-from-left"}},[_c('popover',{attrs:{"name":"helpmatrix","width":240}},[_c('Help',{attrs:{"titleChart":_vm.titleChartMap}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMatriz),expression:"showMatriz"}]},[_vm._v("\n              "+_vm._s(_vm.$t("124"))+"\n            ")])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help"},[_vm._v(_vm._s(_vm.name_chart)+"\n    "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMatriz),expression:"!showMatriz"},{name:"popover",rawName:"v-popover:helphealth.right",arg:"helphealth",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help"},[_vm._v(_vm._s(_vm.name_chart)+"\n    "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMatriz),expression:"showMatriz"},{name:"popover",rawName:"v-popover:helpmatrix.right",arg:"helpmatrix",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('div',{staticClass:"bt-change-charts"},[_c('toggle-button',{attrs:{"value":true,"width":60,"labels":{checked: 'On', unchecked: 'Off'}},on:{"change":function($event){_vm.btChangeStart()}},model:{value:(_vm.changeStart),callback:function ($$v) {_vm.changeStart=$$v},expression:"changeStart"}})],1),_vm._v(" "),_c('div',{staticClass:"space"},[_vm._v(" ")]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMatriz),expression:"!showMatriz"}],attrs:{"id":_vm.id},on:{"mouseover":_vm.mouseOver,"mouseleave":_vm.mouseleave}})]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMatriz),expression:"showMatriz"}],on:{"mouseover":_vm.mouseOver,"mouseleave":_vm.mouseleave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"actLoading"},[_vm._v("Loading ...")]),_vm._v(" "),_c('div',{staticClass:"matrix-box",domProps:{"innerHTML":_vm._s(_vm.boxMatriz)}})])]),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-sm",attrs:{"id":"buttons","role":"group","aria-label":"Buttons"}},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.getMatrizChart()}}},[_c('small',[_vm._v(_vm._s(_vm.btn_title))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xfMn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-default"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"navbar-minimize"},[_c('button',{staticClass:"btn btn-fill btn-icon",on:{"click":_vm.minimizeSidebar}},[_c('i',{class:_vm.$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'})])]),_vm._v(" "),_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",class:{toggled: _vm.$sidebar.showSidebar},attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar bar1"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar2"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar3"})]),_vm._v(" "),_c('a',{staticClass:"navbar-brand"},[_vm._v("MySemeq")])]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse navbar-collapse"},[_c('ul',{staticClass:"nav navbar-nav navbar-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xp4f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('chart-card',{attrs:{"chart-data":_vm.salesChart.data,"chart-options":_vm.salesChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("2015 Sales")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("All products including Taxes")])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer-title"},slot:"footer-title"},[_c('i',{staticClass:"ti-check"}),_vm._v(" Data information certified\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Tesla Model S\n          "),_c('i',{staticClass:"fa fa-circle text-warning"}),_vm._v(" BMW 5 Series\n        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"ti-check"}),_vm._v(" Data information certified\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('chart-card',{attrs:{"chart-data":_vm.usersChart.data,"chart-options":_vm.usersChart.options}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Users Behavior")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("24 hours performance")])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer-title"},slot:"footer-title"},[_c('i',{staticClass:"ti-reload"}),_vm._v(" Updated 3 minutes ago\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"chart-legend"},[_c('i',{staticClass:"fa fa-circle text-info"}),_vm._v(" Open\n          "),_c('i',{staticClass:"fa fa-circle text-danger"}),_vm._v(" Click\n          "),_c('i',{staticClass:"fa fa-circle text-warning"}),_vm._v(" Click Second Time\n        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"stats"},[_c('i',{staticClass:"ti-reload"}),_vm._v(" Updated 3 minutes ago\n        ")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.subscriptionsChart.data,"chart-options":_vm.subscriptionsChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("169")]),_vm._v(" "),_c('span',{staticClass:"label label-danger",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n        -14%\n      ")]),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("\n        total subscriptions "),_c('span',{staticClass:"text-muted"},[_vm._v("in last")]),_vm._v(" 7 days\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer-title"},slot:"footer-title"},[_vm._v("\n        View all members\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-fill btn-icon btn-sm",attrs:{"slot":"footer-right"},slot:"footer-right"},[_c('i',{staticClass:"ti-angle-right"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-6"},[_c('chart-card',{attrs:{"chart-data":_vm.downloadsChart.data,"chart-options":_vm.downloadsChart.options}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("8,960")]),_vm._v(" "),_c('span',{staticClass:"label label-warning",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n        ~51%\n      ")]),_vm._v(" "),_c('h6',{attrs:{"slot":"subtitle"},slot:"subtitle"},[_vm._v("\n        total downloads "),_c('span',{staticClass:"text-muted"},[_vm._v("in last")]),_vm._v(" 6 years\n      ")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer-title"},slot:"footer-title"},[_vm._v("\n        View more details\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill btn-icon btn-sm",attrs:{"slot":"footer-right"},slot:"footer-right"},[_c('i',{staticClass:"ti-info"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('task-list'),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('time-line',{attrs:{"type":"simple"}},[_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badge-type":"danger","badgeIcon":"ti-gallery"}},[_c('span',{staticClass:"label label-danger",attrs:{"slot":"header"},slot:"header"},[_vm._v("Some title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n          Wifey made the best Father's Day meal ever. So thankful so happy so blessed. Thank you for making my family We just had fun with the “future” theme !!!   It was a fun night all together ... The always rude Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in downtown.")]),_vm._v(" "),_c('h6',{attrs:{"slot":"footer"},slot:"footer"},[_c('i',{staticClass:"ti-time"}),_vm._v("\n          11 hours ago via Twitter\n        ")])]),_vm._v(" "),_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badge-type":"success","badgeIcon":"ti-credit-card"}},[_c('span',{staticClass:"label label-info",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('p',{attrs:{"slot":"body"},slot:"body"},[_vm._v("\n          Thank God for the support of my wife and real friends. I also wanted to point out that it’s the first album to go number 1 off of streaming!!! I love you Ellen and also my number one design rule of anything I do from shoes to music to homes is that Kim has to like it....")])]),_vm._v(" "),_c('time-line-item',{staticClass:"timeline-inverted",attrs:{"badge-type":"info","badgeIcon":"ti-check-box"}},[_c('span',{staticClass:"label label-success",attrs:{"slot":"header"},slot:"header"},[_vm._v("Another Title")]),_vm._v(" "),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("\n            Called I Miss the Old Kanye That’s all it was Kanye And I love you like Kanye loves Kanye Famous viewing @ Figueroa and 12th in downtown LA 11:10PM")]),_vm._v(" "),_c('p',[_vm._v("\n            What if Kanye made a song about Kanye Royère doesn't make a Polar bear bed but the Polar bear couch is my favorite piece of furniture we own It wasn’t any Kanyes Set on his goals Kanye")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('drop-down',[_c('button',{staticClass:"btn btn-info dropdown-toggle",attrs:{"slot":"title","type":"button","data-toggle":"dropdown"},slot:"title"},[_c('i',{staticClass:"ti-settings"}),_vm._v(" "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#action"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#action"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#here"}},[_vm._v("Something else here")])]),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#link"}},[_vm._v("Separated link")])])])],1)])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-chat"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Chat")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("With Tania Andrew")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('ol',{staticClass:"chat"},[_c('li',{staticClass:"other"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/faces/face-2.jpg","alt":"crash"}})]),_vm._v(" "),_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                Hola!\n                How are you?\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:20")])])])]),_vm._v(" "),_c('li',{staticClass:"self"},[_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                Puff...\n                I'm alright. How are you?\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:22")])])]),_vm._v(" "),_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/default-avatar.png","alt":"crash"}})])]),_vm._v(" "),_c('li',{staticClass:"other"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/faces/face-2.jpg","alt":"crash"}})]),_vm._v(" "),_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                I'm ok too!\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:24")])])])]),_vm._v(" "),_c('li',{staticClass:"self"},[_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                Well, it was nice hearing from you.\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:25")])])]),_vm._v(" "),_c('div',{staticClass:"no-avatar"})]),_vm._v(" "),_c('li',{staticClass:"self"},[_c('div',{staticClass:"msg"},[_c('p',[_vm._v("\n                OK, bye-bye\n                See you!\n              ")]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('i',{staticClass:"ti-check"}),_vm._v(" "),_c('h6',[_vm._v("11:25")])])]),_vm._v(" "),_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/default-avatar.png","alt":"crash"}})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"send-message"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":"static/img/default-avatar.png","alt":"crash"}})]),_vm._v(" "),_c('input',{staticClass:"form-control textarea",attrs:{"type":"text","placeholder":"Type here!"}}),_vm._v(" "),_c('div',{staticClass:"send-button"},[_c('button',{staticClass:"btn btn-primary btn-fill"},[_vm._v("Send")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xyBX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartsSensorBattery_vue__ = __webpack_require__("UMeC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45b37663_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartsSensorBattery_vue__ = __webpack_require__("5Zzn");
function injectStyle (ssrContext) {
  __webpack_require__("buXi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartsSensorBattery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45b37663_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChartsSensorBattery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y0zJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y2Yh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");









__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default.a);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'charts',
  components: {
    Help: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__["a" /* default */]
  },
  data: function data() {
    return {
      titleChart: this.$t("260"),
      tableData: [],
      chartOptions: {
        chart: {
          type: 'heatmap',
          backgroundColor: 'rgba(0,0,0,0)',
          marginTop: 40,

          plotBorderWidth: 1,
          height: 520
        },

        title: {
          text: ''
        },

        xAxis: {
          categories: [],
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },

        yAxis: {
          categories: [],
          title: null,
          reversed: true,
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1
        },

        accessibility: {
          point: {
            descriptionFormatter: function descriptionFormatter(point) {
              var ix = point.index + 1,
                  xName = this.getPointCategoryName(point, 'x'),
                  yName = this.getPointCategoryName(point, 'y'),
                  val = point.value;
              return ix + '. ' + xName + ' sales ' + yName + ', ' + val + '.';
            }
          }
        },

        colorAxis: {
          stops: [[0, '#ffffff'], [0.80, '#ffffff'], [1, '#305496']],
          min: 0
        },

        legend: {
          align: 'right',
          layout: 'vertical',
          margin: 0,
          verticalAlign: 'middle',
          y: 25,
          symbolHeight: 280
        },

        tooltip: {
          formatter: function formatter() {
            var value = this.point.value;

            if (value || value == 0) {
              return '<b>' + this.point.series.yAxis.categories[this.point.options.y] + '</b><br><b>' + value + ' %' + '</b> in <br><b>' + this.point.series.xAxis.categories[this.point.options.x] + '</b>';
            }
            return '<b>' + this.point.series.yAxis.categories[this.point.options.y] + '</b><br><b>No data!</b>';
          },
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },

        series: [{
          name: 'Data Availability',
          borderWidth: 1,

          data: [],
          dataLabels: {
            enabled: true,
            color: '#000000',
            fontSize: '24px'
          }
        }],

        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              formatter: function formatter() {
                return '<span style="font-size:14px;" >' + this.point.value + '</span>';
              }
            }
          },
          heatmap: {
            nullColor: '#000'
          }
        },

        loading: {
          labelStyle: {
            color: 'black',
            textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
          },
          style: {
            backgroundColor: 'none',
            opacity: 1
          }
        },

        exporting: { enabled: false },
        credits: {
          enabled: false
        }
      }
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__utils_mixin__["a" /* default */]],
  methods: {
    getPointCategoryName: function getPointCategoryName(point, dimension) {
      var series = point.series,
          isY = dimension === 'y',
          axis = series[isY ? 'yAxis' : 'xAxis'];
      return axis.categories[point[isY ? 'y' : 'x']];
    },
    getData: function getData() {
      var API = "https://api.semeq.com.br/";

      var param = {
        'corp': this.filtersOn.corp,
        'region': this.filtersOn.region,
        'planta': this.filtersOn.planta,
        'period': this.filtersOn.period,
        'year': this.filtersOn.year,
        'area_f': this.filtersOn.area_f,
        'sector_f': this.filtersOn.sector_f,
        'machine': this.filtersOn.machine,
        'subset': this.filtersOn.subset
      };

      this.$refs.chart.chart.showLoading();

      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + 'v1/mysemeq-ambev/get-data-availability', params: param, headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (_ref) {
        var data = _ref.data;

        if (data) {
          self.$refs.chart.chart.hideLoading();
          self.chartOptions.series[0].data = data[0];
          self.chartOptions.xAxis.categories = data[1];
          var yAxis = data[2];
          yAxis[0] = (self.filtersOn.planta_name == 'All' ? '' : self.filtersOn.planta_name) || self.filtersOn.region || 'ABInBev';

          if (data[2].length > 11) {
            self.chartOptions.chart.height = 1300;
          } else {
            self.chartOptions.chart.height = 520;
          }

          self.chartOptions.yAxis.categories = yAxis;

          if (data[0].length == 0) {
            self.$refs.chart.chart.showLoading('No data');
          }
        }
      }).catch(function (error) {
        self.$refs.chart.chart.showLoading('Error');

        self.ApiErrorHandler(self, error.response.data.status_code);
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filtersOn'])),
  watch: {
    filtersOn: function filtersOn(newValue) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "yFFQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yKB+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('ul',{staticClass:"list-unstyled team-members"},[_c('li',_vm._l((_vm.members),function(member){return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-circle img-no-padding img-responsive",attrs:{"src":member.image,"alt":"Circle Image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_vm._v("\n            "+_vm._s(member.name)+"\n            "),_c('br'),_vm._v(" "),_c('span',{class:_vm.getStatusClass(member.status)},[_c('small',[_vm._v(_vm._s(member.status))])])]),_vm._v(" "),_vm._m(0,true)])}))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-3 text-right"},[_c('button',{staticClass:"btn btn-sm btn-success btn-icon"},[_c('i',{staticClass:"fa fa-envelope"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yLEp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_ERROR; });
var USER_REQUEST = 'USER_REQUEST';
var USER_SUCCESS = 'USER_SUCCESS';
var USER_ERROR = 'USER_ERROR';

/***/ }),

/***/ "yNZB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_vm._m(0),_vm._v(" "),_c('drop-down',{attrs:{"tag":"li","title":"5 Notificaitons","icon":"ti-bell"}},[_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"slot":"title","href":"javascript:void(0)","data-toggle":"dropdown"},slot:"title"},[_c('i',{staticClass:"ti-bell"}),_vm._v(" "),_c('span',{staticClass:"notification"},[_vm._v("5")]),_vm._v(" "),_c('p',{staticClass:"hidden-md hidden-lg"},[_vm._v("\n        Notifications\n        "),_c('b',{staticClass:"caret"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 1")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 2")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 3")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 4")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Another notification")])])]),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"dropdown-toggle btn-magnify",attrs:{"href":"javascript:void(0)","data-toggle":"dropdown"}},[_c('i',{staticClass:"ti-panel"}),_vm._v(" "),_c('p',[_vm._v("Stats")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"btn-rotate",attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"ti-settings"}),_vm._v(" "),_c('p',{staticClass:"hidden-md hidden-lg"},[_vm._v("\n        Settings\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yYoM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mixin__ = __webpack_require__("vsZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover__ = __webpack_require__("JwGB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__ = __webpack_require__("U4B7");










__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vue_js_popover___default.a);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'charts',
    components: {
        Help: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_components_Help__["a" /* default */]
    },
    data: function data() {
        return {
            titleChart: this.$t("225"),
            tableData: [],
            chartOptions: {
                colors: ['#90ed7d', '#ff7f23', '#f45b5b', '#f45b5b', '#104E8B'],
                chart: {
                    type: 'line',
                    backgroundColor: 'rgba(0,0,0,0)',
                    style: {
                        fontFamily: '\'Unica One\', sans-serif'
                    },
                    plotBorderColor: '#606063'
                },
                title: {
                    text: '',
                    style: {
                        color: '#fff',
                        textTransform: 'uppercase',
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }
                },
                subtitle: {
                    style: {
                        color: '#E0E0E3',
                        textTransform: 'uppercase'
                    }
                },
                xAxis: {
                    categories: [],
                    crosshair: true,
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#fff'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    title: {
                        text: '',
                        style: {
                            color: '#A0A0A3'
                        }
                    }
                },
                yAxis: [{
                    min: 0,
                    tickInterval: 50,
                    title: {
                        text: this.$t("136"),
                        style: {
                            color: '#A0A0A3',
                            fontSize: '12px'
                        }
                    },
                    stackLabels: {
                        enabled: true,
                        style: {
                            fontWeight: 'bold',
                            color: 'white'
                        }
                    },
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    tickWidth: 1
                }, {
                    min: 0,
                    tickInterval: 2,
                    title: {
                        text: this.$t("140_1"),
                        style: {
                            color: '#A0A0A3',
                            fontSize: '12px'
                        }
                    },
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                            color: '#E0E0E3'
                        }
                    },
                    lineColor: '#707073',
                    minorGridLineColor: '#505053',
                    tickColor: '#707073',
                    tickWidth: 1,
                    opposite: true
                }],
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    },
                    headerFormat: '<span style="font-size:10px;">{point.key}</span><table>',
                    pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b> {point.y} </b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: false
                        }
                    },
                    spline: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true,
                            format: '<span style="position: absolute; top: 20px">{point.y} %</span>',
                            color: '#fff',
                            backgroundColor: 'rgba(0, 0, 0, 0.85)',
                            allowOverlap: true,
                            x: 0,
                            y: -10
                        }
                    }
                },
                legend: {
                    title: {
                        style: {
                            color: '#C0C0C0',
                            fontSize: '12px'
                        }
                    },
                    itemStyle: {
                        color: '#E0E0E3'
                    },
                    itemHoverStyle: {
                        color: '#FFF'
                    },
                    itemHiddenStyle: {
                        color: '#b0adad'
                    },
                    layout: 'horizontal',
                    align: 'left',
                    x: 50,
                    verticalAlign: 'top',
                    y: 0,
                    floating: false,
                    color: 'white',
                    backgroundColor: 'rgba(255,255,255,0.25)'
                },
                labels: {
                    style: {
                        color: '#fff'
                    }
                },
                drilldown: {
                    activeAxisLabelStyle: {
                        color: '#F0F0F3'
                    },
                    activeDataLabelStyle: {
                        color: '#F0F0F3'
                    }
                },
                navigation: {
                    buttonOptions: {
                        symbolStroke: '#DDDDDD',
                        theme: {
                            fill: '#505053'
                        }
                    }
                },
                rangeSelector: {
                    buttonTheme: {
                        fill: '#505053',
                        stroke: '#000000',
                        style: {
                            color: '#CCC'
                        },
                        states: {
                            hover: {
                                fill: '#707073',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            },
                            select: {
                                fill: '#000003',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    },
                    inputBoxBorderColor: '#505053',
                    inputStyle: {
                        backgroundColor: '#333',
                        color: 'silver'
                    },
                    labelStyle: {
                        color: 'silver'
                    }
                },
                navigator: {
                    handles: {
                        backgroundColor: '#666',
                        borderColor: '#AAA'
                    },
                    outlineColor: '#CCC',
                    maskFill: 'rgba(255,255,255,0.1)',
                    series: {
                        color: '#7798BF',
                        lineColor: '#A6C7ED'
                    },
                    xAxis: {
                        gridLineColor: '#505053'
                    }
                },
                scrollbar: {
                    barBackgroundColor: '#808083',
                    barBorderColor: '#808083',
                    buttonArrowColor: '#CCC',
                    buttonBackgroundColor: '#606063',
                    buttonBorderColor: '#606063',
                    rifleColor: '#FFF',
                    trackBackgroundColor: '#404043',
                    trackBorderColor: '#404043'
                },
                series: [{
                    type: 'column',
                    name: this.$t("136"),

                    data: [],
                    yAxis: 0

                }, {
                    type: 'column',
                    name: 'R1 - R2',

                    data: [],
                    yAxis: 0
                }, {
                    type: 'column',
                    name: 'R3+',

                    data: [],
                    yAxis: 0
                }, {
                    type: 'spline',
                    name: this.$t("139"),

                    data: [],
                    yAxis: 1,
                    marker: {
                        lineWidth: 3,
                        lineColor: '#f45b5b',
                        fillColor: '#f45b5b'
                    },
                    tooltip: {
                        valueSuffix: ' %'
                    }
                }, {
                    type: 'spline',
                    name: this.$t("140"),

                    data: [],
                    color: '#104E8B',
                    yAxis: 1,
                    marker: {
                        lineWidth: 3,
                        lineColor: ' #104E8B',
                        fillColor: '#104E8B'
                    },
                    tooltip: {
                        valueSuffix: ' %'
                    },
                    dataLabels: {
                        enabled: true,
                        y: -15
                    }

                }],
                exporting: { enabled: false },
                credits: {
                    enabled: false
                },
                loading: {
                    labelStyle: {
                        color: 'black',
                        textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff'
                    },
                    style: {
                        backgroundColor: 'none',
                        opacity: 1
                    }
                }
            }
        };
    },

    mixins: [__WEBPACK_IMPORTED_MODULE_4__utils_mixin__["a" /* default */]],
    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['changeGrid']), {
        loadGrid: function loadGrid(event) {},
        getData: function getData() {

            var API = "https://api.semeq.com.br/";
            var ENDPOINT = 'v1/mysemeq-ambev/get-failure-rate';
            var self = this;

            this.$refs.chart.chart.showLoading();

            __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'GET', url: API + ENDPOINT, params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.filtersOn, { 'online': 1, plant: this.filtersOn.planta, area: this.filtersOn.area_f, sector: this.filtersOn.sector_f, component: this.filtersOn.subset }), headers: { Authorization: 'Bearer ' + localStorage.getItem('user-token') } }).then(function (resp) {
                self.tableData = resp.data;
                self.$refs.chart.chart.hideLoading();
            }).catch(function (err) {
                self.ApiErrorHandler(self, error.response.data.status_code);
                self.$refs.chart.chart.showLoading('Error');
            });
        },
        setChartData: function setChartData() {

            var self = this;
            var res = self.tableData;

            self.chartOptions.xAxis.categories = [];
            self.chartOptions.series[0].data = [];
            self.chartOptions.series[1].data = [];
            self.chartOptions.series[2].data = [];
            self.chartOptions.series[3].data = [];
            self.chartOptions.series[4].data = [];
            if (res) {
                res.forEach(function (it) {
                    self.chartOptions.xAxis.categories.push(it.ref_date);
                    self.chartOptions.series[0].data.push(it.no_repetition);
                    self.chartOptions.series[1].data.push(it.repetition_yellow);
                    self.chartOptions.series[2].data.push(it.repetition_red);
                    self.chartOptions.series[3].data.push(it.percentage);
                    self.chartOptions.series[4].data.push(it.monthy_accumulated);
                });
            }
        }
    }),
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['filtersOn'])),
    watch: {
        filtersOn: function filtersOn(newValue) {
            this.getData();
        },
        tableData: function tableData() {
            this.setChartData();
        }
    }

});

/***/ }),

/***/ "yZm8":
/***/ (function(module, exports) {

module.exports = {"10":"Release notes","11":"Online Monitoring","12":"Offline And Online Predictive Data.","13":"OffLine","14":"Online","15":"Zone","16":"Sites (BOPs, VOPs)","17":"Date","18":"Period","19":"More Filters","20":"Area","21":"Machine","22":"Subset","23":"Zone","24":"Sites (BOPs, VOPs)","25":"Date","26":"Predictive Techniques","27":"Search","28":"Presents the status about the analyzed data.","29":"Failure Alarm (Analysis)","30":"Presents the status about the analyzed data.","31":"Failure Alarm","32":"Presents the recurrence rate of the interventions grouped by period.","33":"Recurrence Rate of Interventions","34":"Amount of executed reports on time | late. The system shows the late reports pareto using three distincts periods.","35":"Execution","36":"Pareto´s Comparison charts.","37":"Comparison Charts - On time | late","38":"Comparison Charts by Period - On time | late","39":"Pareto´s Comparison charts by Period.","40":"Presents the recurrence rate of the interventions grouped by period.","41":"Recurrence Rate of Interventions","42":"Amount of executed reports on time | late. The system shows the late reports pareto using three distincts periods.","43":"Execution","44":"Pareto´s Comparison charts.","45":"Comparison Charts - On time | late","46":"Comparison Charts by Period - On time | late","47":"Pareto´s Comparison charts by Period.","48":"Change Password","49":"User","50":"Actual password","51":"New password","52":"Repeat new password","53":"Please enter all fields!","54":"Please, the new password must contain a minimum of 8 characters and a maximum of 15 characters.","55":"The password entered is not the same as the new password!","56":"Password changed successfully!","57":"Error changing password!","58":"Password","59":"Attention - Incorrect username and password!","60":"Added column Approval Datetime in the grids that show reports information;","61":"Adjustments to the graphs, leaving only the initials of the units;","62":"Adjustments to the layout of the 'Data Availability' chart;","63":"Write filters for user;","64":"Write-off of RCI;","65":"Correction of grid line numbering;","66":"Adjustments in the layout of the 'Sensor Availability' graph;","67":"Helps adjustments of the 'Sensor Failure Mode' and 'Sensor Status' graphics;","68":"Prescription Upload;","69":"New feedback columns in the Planning chart grid;","70":"Bookmark in the process menu linking the process step with a 'group' of graphs to access the graphs more quickly;","71":"Changed the presentation layout of the graphics for better visualization and distribution of information;","72":"Included in the pdfs menu for Semeq Pred+ App;","73":"Added help button on each chart;","74":"Added filters by Area / Machine / Subset in the Offline and Online tab;","75":"Added to the video and guide menu;","76":"Included Top Priorities chart in Online tab;","77":"Changed font size of graphics;","78":"Changed default values of Online tab filters for Date 2020 and Period 3 months;","79":"Changed Region text by Zone;","80":"Changed title of online graphics (live e 24hours);","81":"Changed website address from abi.semeq.com.br to abinbev.semeq.com.br;","82":"Added icon 'We`re here for the beer';","83":"Added graphic Data Availability (%) in Online;","84":"Added graphic % Sensors Availability in Online;","85":"Added graphic # Sensors Failure Mode in Online;","86":"Added map in the Online tab;","87":"Grid Filter;","88":"Zone Filter;","89":"Added button for online battery graph display;","90":"Log login;","91":"Presentation of the Semeq process;","92":"Criticality Matrix;","93":"Changed bar charts for lines;","94":"Changed Component labels for Subsets;","95":"Changed Plants label for Sites (BOPs, VOPs);","96":"Removed Online Point Status graph;","97":"Export grid information to .CSV file;","98":"Menu with Video, Guide and Release Note;","99":"Creating a new MySemeq system layout;","100":"Offline and Online data information;","101":"Graphics and map for presenting the company's health;","102":"Filters for better analysis of the company's health (Sites / Date / Period / Predictive Techniques);","103":"Grids Information;","104":"DR view (Offline and Online);","105":"Viewing and Adding Feedback (Offline);","106":"Sensor image view (Online);","107":"Data Survey","108":"Failure Alarm","109":"Diagnosis","110":"Root Cause Analysis","111":"Planning","112":"Execution","113":"Feedback","114":"The failure rate performance of the sites (BOPs, VOPs). This map is based on the World Class Maintenance. The values between 0 and 4.9% is good for the WCM, between 5 and 9.9 is typical and 10+ needs improvement.","115":"Failure Rate formula:","116":"where","117":"numbers of interventions,","118":"numbers of alerts and","119":"total assets included in the PdM Plan.","120":"Annual label","121":"shows the average of the year and","122":"accumulated label","123":"shows the average of the period since the PdM initial date.","124":"This table map each site/plant according with the number of recurrent diagnosis report and the total amount of pending days (open reports). Make sure if the filters on left side bar are set with your needs.","125":"Health Map","126":"Criticality Matrix","127":"Failure Rate:","128":"FAILURES:","129":"Pareto of total amount of the diagnosis report executed and late.","130":"Backlog","131":"# Diagnosis Report","132":"Closed","133":"Late","134":"The Failure Rate presents the last twelve-months moving average.","135":"Failure Rate","136":"DR´s","137":"R1 - R2","138":"R3+","139":"Monthly","140":"Average accumulated","141":"Failure Rate Pareto","142":"Pareto of the recurrence rate of the interventions.","143":"Recurrence","144":"Presents the details about the defect found. Some diagnosis report could have more than one defect/failure and it is considered in the failure rate formula.","145":"Export All","146":"Failure Modes Predicted","147":"Group","148":"Failure","149":"Failures Modes","150":"Presents total amount of the diagnosis report in timeline grouped by planned, executed and pending. ","151":"Planning","152":"Chart in Line","153":"Chart in Column","154":"Presents the pareto about the data not read. When the user can not get data then the system requires to type the reason for that.","155":"Skipped","156":"Presents the status about the data sampling according with the selected filters in the left bar","157":"Data Survey","158":"Previous","159":"Next","160":"Generating .csv file!","161":"DR","162":"Feedback","163":"Prescription","164":"Schedule","165":"PSM / W.O.:","166":"Note number","167":"Date of schedule (dd/mm/yyyy):","168":"Reason of schedule:","169":"Cancel","170":"Save","171":"#DR:","172":"Plant/Area:","173":"Intervention Date (dd/mm/yyyy):","174":"Time spent on intervention:","175":"Hours","176":"Minutes","177":"Equipment downtime:","178":"Person responsible for intervention:","179":"Was the found defect the same as the diagnosed defect?","180":"Yes","181":"No, there was no defect","182":"No, defect did not match the diagnosis. Describe the defect that was found.","183":"1 - The lubricant was changed as requested?","184":"Applied filtering","185":"No, Reason ?","186":"Is the specification of the defective component completely correct? (in case of rolling bearings, is it 2R, Z, ZZ, K, .)'","187":"No. What is the correct one ?","188":"2 - Cleaning the system was run?","189":"No. Why ?","190":"Was the indicated position of the defective component correct?","191":"No. What is the correct one ?","192":"3 - Was any other intervention performed, in addition to the recommended intervention?","193":"No","194":"Yes. What ?","195":"Was any other intervention performed, in addition to the recommended intervention?","196":"No","197":"Yes. What ?","198":"What is the estimated potential cost avoidance generated by this proactive task?","199":"Select currency:","200":"Downtime:","201":"Secondary damage:","202":"Preventive work avoided:","203":"Save","204":"Created by:","205":"Creation date:","206":"Edited by:","207":"Last updated:","208":"Status","209":"PENDING","210":"EXECUTED","211":"NO EXECUTED","212":"Notes","213":"Delete Prescription","214":"Add Prescription","215":"DR:","216":"Plant/Area:","217":"Technique:","218":"Note:","219":"Add Files (Please Include Only Pdf Files, And No Special Characters):","220":"Add Files","221":"Remove File","222":"Save Prescription","223":"Planning / Execution","224":"The Failure Rate presents the last twelve-months moving average.","225":"Failure Rate","226":"POINT ALARME (last 24 hours)","227":"Presents the details about the defect found. Some diagnosis report could have more than one defect/failure and it is considered in the failure rate formula.","228":"Export All","229":"Failure Modes Predicted","230":"Group","231":"Failure","232":"Failures Modes","233":"Presents the gateways current status group by running and offline.","234":"Gateway Status (Live)","235":"Presents total amount of the diagnosis report in timeline grouped by planned, executed and pending.","236":"Planning","237":"Chart in Line","238":"Chart in Column","239":"Battery Status (Live)","240":"Presents the sensors current status grouped by running and offline.","241":"The blue part of the chart (N/A) means that the sensors was installed and not read any samples yet.","242":"Sensor Status (Live)","243":"Presents the status about the analyzed data.","244":"Failure Alarm (Live)","245":"Understanding Indicators. From left to right: ","246":"Detected Failures amount of generated DRs in plant on selected period. ","247":"Resolved orders is the amount of feedbacks on selected period. ","248":"MTFS it's the time average in days to solve an anomaly.","249":"6m: 6 months, YTD: Current Year, 1y: 12 months, All: since the beginning.","250":"DETECTED FAILURES (All, 1y, 6m)","251":"RESOLVED ORDERS (All, 1y, 6m)","252":"MTFS (DAYS) (All, 1y, 6m)","253":"DETECTED FAILURES","254":"RESOLVED ORDERS","255":"MTFS","256":"Each radar presents the main failure potential modes and the amount of occurrences in each entities according the filter selection.","257":"Historical Data","258":"Comparison Charts","259":"Presents the data availability in percentage considering the gateway and sensors status.","260":"Data Availability ( % )","261":"Presents the sensors data availability computing the total number of hours per month.","262":" % Sensors Availability","263":"Presents the pareto chart considering the reasons of each sensors stop to work.","264":"Battery","265":"less than 10%.","266":"No Signal","267":"Battery higher than 10% and 3-days with no communication","268":"Gateway","269":"Must be appointed  by the user.","270":"Out of Machine","271":"Must be appointed by the user or with no samples available until now.","272":"N/A","273":"There is no link with the point (Not installed).","274":"Not Installted","275":"There is no link with the point and there is delivered date updated.","276":"# Sensors Failure Mode","277":"Presents the top priorities failures by each machinery. This list must be verified and some action must be done.","278":"Top Priorities","279":"Top Priorities (Last 24 Hours)","280":"Understanding Indicators. From left to right: ","281":"Detected Failures amount of generated DRs in plant on selected period. ","282":"Resolved orders is the amount of feedbacks on selected period. ","283":"MTFS it's the time average in days to solve an anomaly. ","284":"6m: 6 months, YTD: Current Year, 1y: 12 months, All: since the beginning.","285":"DETECTED FAILURES (All, 1y, 6m)","286":"RESOLVED ORDERS (All, 1y, 6m)","287":"MTFS (DAYS) (All, 1y, 6m)","288":"Each radar presents the main failure potential modes and the amount of occurrences in each entities according the filter selection.","289":"Historical Data","290":"Comparison Charts","291":"Health Map Online","292":"Select the language:","293":"English","294":"Portuguese","295":"Save","296":"Language saved successfully!","297":"Pending","298":"Scheduled","299":"Diagnosis Report","300":"# Reports","301":"% Reports","302":"Reports","303":"On Time","304":"Late","305":"Days","306":"Normal","307":"Alert","308":"Alarm","309":"N/A","310":"Plant","311":"Area","312":"Sector","313":"Component","314":"Component TAG","315":"Component Type","316":"Machine","317":"Machine TAG","318":"Status","319":"Report Number","320":"Approval Datetime","321":"Technique","322":"Date","323":"RDP","324":"RCI","325":"Pending Days","326":"Delay","327":"Prescription Date","328":"Week","329":"Currency","330":"Downtime","331":"Secondary damage","332":"Preventive work avoided","333":"Feedback Status","334":"Sample date","335":"Battery level","336":"Firmware version","337":"BLE signal","338":"Node","339":"Serie","340":"Point","341":"Prescription file successfully deleted!","342":"Prescription with status EXECUTED OR NOT EXECUTED cannot be deleted!","343":"Prescription saved successfully!","344":"Error saving prescription!","345":"Please Include Only Pdf Files, And No Special Characters!","346":"Prescription file successfully deleted!","347":"Prescription with status EXECUTED OR NOT EXECUTED cannot be deleted!","348":"FAILURE MODES PREDICTED","349":"Failure mode list.","350":"PLANNING EXECUTION","351":"Report list grouped by planned, executed or pending status.","352":"SKIPPED","353":"Reasons for non-measures data.","354":"PLANNING","355":"Report list grouped by planned or pending status.","356":"EXECUTION","357":"Report list.","358":"REPORT EXECUTION DEADLINE","359":"RECURRENCE RATE OF INTERVENTIONS","360":"FAILURE MODES PREDICTED(ONLINE)","361":"Failure mode list.","362":"GATEWAY STATUS","363":"Gateway Status list.","364":"BATTERY STATUS","365":"Battery Status list.","366":"SENSOR STATUS","367":"Sensor Status (Live) list.","368":"FAILURE ALARM","369":"Failure Alarm list.","370":"SENSOR AVAILABILITY","371":"Sensors Availability list","372":"SENSOR FAILURE MODE","373":"Sensors Failure Mode list","374":"TOP PRIORITIES","375":"Top Priorities list.","376":"RECURRENCE RATE OF INTERVENTIONS","377":"How to add a sensor","378":"How to fill up DR","379":"How to replace a sensor","380":"The migration of sensors to the new monitoring platform is underway. The AFR, APAC, SAZ, and NAZ zones are already at an advanced stage — pending only the release of new firewall rules by ABI. The EUR and MAZ zones will be completed soon. We recommend that, starting this month, you contact your account manager to request access to the new dashboard.","381":"Important: The current platform will be deactivated by the end of July 2025. The legacy API will also be discontinued during the same period. If you use integrations with the old API, you will need to update the endpoints and migrate to the new API.","382":"Close","383":"Attention: Migration to the new platform is in progress.","logout":"Logout","01":"Video","02":"ABinBev Online Predictive:","03":"To get on board in the journey towards 100% Reliability, Technology to reach high performance!","04":"Guide","05":"Failure Tree Analysis - Lubrication","06":"SEMEQ PdM Technologies","07":"Semeq AbInBev App","08":"Instruction Manual - Online Monitoring System","09":"Global Pdm Guide Line","10_1":"Language","20-1":"Sector","140_1":"Percentage","153_1":"Planning","153_2":"Closed","153_3":"Pending","242_1":"Battery Status","242_2":"Sending","242_3":"Stopped","242_4":"Stopped N/A","242_5":"Sensor Status","modal.pesquisar":"OK","modal.filtro.pesquisa":"Search filter"}

/***/ }),

/***/ "yg6A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegularTables_vue__ = __webpack_require__("KyZi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3287d0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegularTables_vue__ = __webpack_require__("Ws9Q");
function injectStyle (ssrContext) {
  __webpack_require__("IsOm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegularTables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3287d0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegularTables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yqcR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yv97":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z35I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_chart_online_vue__ = __webpack_require__("kiqb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f16cb3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_chart_online_vue__ = __webpack_require__("S5pc");
function injectStyle (ssrContext) {
  __webpack_require__("oDd1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23f16cb3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_chart_online_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23f16cb3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_chart_online_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z4K6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"alert alert-danger"},[_c('button',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){_vm.show = false}}},[_c('i',{staticClass:"fa fa-times-circle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',[_c('b',[_vm._v(_vm._s(_vm.$t('cadastro.aviso.atencao'))+": ")]),_vm._v(" "+_vm._s(_vm.$t('cadastro.aviso.atencao.a')))])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showNovo)?_c('div',{staticClass:"alert alert-danger"},[_c('button',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){_vm.showNovo = false}}},[_c('i',{staticClass:"fa fa-times-circle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',[_c('b',[_vm._v(" "+_vm._s(_vm.$t('cadastro.aviso.atencao'))+": ")]),_vm._v(_vm._s(_vm.$t('cadastro.aviso.atencao.b')))])]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 card"},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"tela-edicao"},[_c('form',{attrs:{"method":"#","action":"#"}},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("\n              "+_vm._s(_vm.$t('cadastro.titulo.tipo.equipamento'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v(_vm._s(_vm.$t('cadastro.titulo.descricao')))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.satusOrder),expression:"satusOrder"}],staticClass:"form-control disable",attrs:{"type":"text"},domProps:{"value":(_vm.satusOrder)},on:{"input":function($event){if($event.target.composing){ return; }_vm.satusOrder=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedId),expression:"selectedId"}],staticClass:"form-control disable",attrs:{"type":"text"},domProps:{"value":(_vm.selectedId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedId=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],ref:"selected",staticClass:"form-control upper col-md-11",attrs:{"type":"text","id":"v-step-0","maxlength":_vm.max},domProps:{"value":(_vm.selected)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.selected=$event.target.value},function($event){_vm.upper($event)}]}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-secondary v-step-9",attrs:{"type":"button"},on:{"click":_vm.clearButton}},[_c('i',{staticClass:"fa fa-eraser",attrs:{"aria-hidden":"true"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"number-characters"},[_vm._v(_vm._s(_vm.$t('cadastro.numero.caracteres'))+":")]),_vm._v(" "),_c('div',{staticClass:"number-characters-view",domProps:{"textContent":_vm._s((_vm.max - _vm.selected.length))}})])])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"form-group col-xs-12 col-sm-12 col-md-12",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6"},[_c('button',{staticClass:"v-step-3 btn btn-wd btn-success btn-fill btn-margin",attrs:{"type":"button"},on:{"click":function($event){_vm.showSwal('editar-tipo-equipamento')}}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-check"})]),_vm._v("\n                  "+_vm._s(_vm.$t('cadastro.btn.editar'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6"},[_c('button',{staticClass:"v-step-1 btn btn-wd btn-info btn-fill btn-margin",attrs:{"type":"button"},on:{"click":function($event){_vm.showSwal('novo-tipo-equipamento')}}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v("\n                  "+_vm._s(_vm.$t('cadastro.btn.novo'))+"\n                ")])])])])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12 card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"category"},[_vm._v(_vm._s(_vm.$t('quantidade-linhas-tabela')))])]),_vm._v(" "),_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6"},[_c('el-select',{staticClass:"select-default select-limit v-step-5",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}))],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6"},[_c('div',{staticClass:"pull-right searchQuery v-step-6"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control input-sm search-input",attrs:{"type":"search","placeholder":_vm.$t('tabela.search'),"aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 v-step-2 v-step-4 v-step-7 v-step-8"},[_c('el-table',{ref:"tabelaGeral",staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""},on:{"sort-change":_vm.ordem}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"sortable":column.sortable,"min-width":column.minWidth,"prop":column.prop,"label":_vm.$t(column.label)}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":70,"fixed":"right","label":_vm.$t('cadastro.tipo.equipamento.tabela.acao')},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-xs btn-warning btn-icon edit",on:{"click":function($event){_vm.handleEdit(props.$index, props.row)}}},[_c('i',{staticClass:"ti-pencil-alt"})]),_vm._v(" "),_c('a',{staticClass:"btn btn-simple btn-xs btn-danger btn-icon remove",on:{"click":function($event){_vm.handleDelete(props.$index, props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.$t('paginacao-showing'))+" "+_vm._s(_vm.from + 1)+" "+_vm._s(_vm.$t('paginacao-to'))+" "+_vm._s(_vm.to)+" "+_vm._s(_vm.$t('paginacao-of'))+" "+_vm._s(_vm.total)+" "+_vm._s(_vm.$t('paginacao-entries')))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 v-step-10"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total,"searchQuery":this.searchQuery,"order":this.satusOrder},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])]),_vm._v(" "),_c('v-tour',{attrs:{"name":"myTour","steps":_vm.steps},scopedSlots:_vm._u([{key:"default",fn:function(tour){return [_c('transition',{attrs:{"name":"fade"}},_vm._l((tour.steps),function(step,index){return (tour.currentStep === index)?_c('v-step',{key:index,attrs:{"step":step,"previous-step":tour.previousStep,"next-step":tour.nextStep,"stop":tour.stop,"isFirst":tour.isFirst,"isLast":tour.isLast}},[(tour.currentStep === 0)?[_c('div',{attrs:{"slot":"actions"},slot:"actions"},[_c('p',{staticClass:"helper-text"},[_vm._v(_vm._s(_vm.$t('helper.msg.cadastro.01'))+" ")]),_vm._v(" "),_c('div',{staticClass:"btn-fechar-help",on:{"click":tour.stop}},[_c('i',{staticClass:"fa fa-times-circle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.nextStep}},[_c('i',{staticClass:"fa fa-arrow-right",attrs:{"aria-hidden":"true"}})])])]:_vm._e(),_vm._v(" "),(tour.currentStep === 1)?[_c('div',{attrs:{"slot":"actions"},slot:"actions"},[_c('p',{staticClass:"helper-text"},[_vm._v(_vm._s(_vm.$t('helper.msg.cadastro.02'))+" ")]),_vm._v(" "),_c('div',{staticClass:"btn-fechar-help",on:{"click":tour.stop}},[_c('i',{staticClass:"fa fa-times-circle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.previousStep}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.nextStep}},[_c('i',{staticClass:"fa fa-arrow-right",attrs:{"aria-hidden":"true"}})])])]:_vm._e(),_vm._v(" "),(tour.currentStep === 2)?[_c('div',{attrs:{"slot":"actions"},slot:"actions"},[_c('p',{staticClass:"helper-text"},[_vm._v(_vm._s(_vm.$t('helper.msg.cadastro.03'))),_c('i',{staticClass:"btn btn-simple btn-xs btn-warning btn-icon edit ti-pencil-alt"}),_vm._v(" "+_vm._s(_vm.$t('helper.msg.cadastro.04')))]),_vm._v(" "),_c('div',{staticClass:"btn-fechar-help",on:{"click":tour.stop}},[_c('i',{staticClass:"fa fa-times-circle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.previousStep}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.nextStep}},[_c('i',{staticClass:"fa fa-arrow-right",attrs:{"aria-hidden":"true"}})])])]:_vm._e(),_vm._v(" "),(tour.currentStep === 3)?[_c('div',{attrs:{"slot":"actions"},slot:"actions"},[_c('p',{staticClass:"helper-text"},[_vm._v(_vm._s(_vm.$t('helper.msg.cadastro.05')))]),_vm._v(" "),_c('div',{staticClass:"btn-fechar-help",on:{"click":tour.stop}},[_c('i',{staticClass:"fa fa-times-circle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.previousStep}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.nextStep}},[_c('i',{staticClass:"fa fa-arrow-right",attrs:{"aria-hidden":"true"}})])])]:_vm._e(),_vm._v(" "),(tour.currentStep === 4)?[_c('div',{attrs:{"slot":"actions"},slot:"actions"},[_c('p',{staticClass:"helper-text"},[_vm._v(_vm._s(_vm.$t('helper.msg.cadastro.06'))),_c('i',{staticClass:"btn btn-simple btn-xs btn-danger btn-icon remove ti-close"}),_vm._v(" "+_vm._s(_vm.$t('helper.msg.cadastro.07')))]),_vm._v(" "),_c('div',{staticClass:"btn-fechar-help",on:{"click":tour.stop}},[_c('i',{staticClass:"fa fa-times-circle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.previousStep}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.nextStep}},[_c('i',{staticClass:"fa fa-arrow-right",attrs:{"aria-hidden":"true"}})])])]:_vm._e(),_vm._v(" "),(tour.currentStep === 5)?[_c('div',{attrs:{"slot":"actions"},slot:"actions"},[_c('p',{staticClass:"helper-text"},[_vm._v(_vm._s(_vm.$t('helper.msg.cadastro.08')))]),_vm._v(" "),_c('p',{staticClass:"helper-text"},[_vm._v(_vm._s(_vm.$t('helper.msg.cadastro.09')))]),_vm._v(" "),_c('div',{staticClass:"btn-fechar-help",on:{"click":tour.stop}},[_c('i',{staticClass:"fa fa-times-circle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.previousStep}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.nextStep}},[_c('i',{staticClass:"fa fa-arrow-right",attrs:{"aria-hidden":"true"}})])])]:_vm._e(),_vm._v(" "),(tour.currentStep === 6)?[_c('div',{attrs:{"slot":"actions"},slot:"actions"},[_c('p',{staticClass:"helper-text"},[_vm._v(_vm._s(_vm.$t('helper.msg.cadastro.10')))]),_vm._v(" "),_c('div',{staticClass:"btn-fechar-help",on:{"click":tour.stop}},[_c('i',{staticClass:"fa fa-times-circle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.previousStep}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.nextStep}},[_c('i',{staticClass:"fa fa-arrow-right",attrs:{"aria-hidden":"true"}})])])]:_vm._e(),_vm._v(" "),(tour.currentStep === 7)?[_c('div',{attrs:{"slot":"actions"},slot:"actions"},[_c('p',{staticClass:"helper-text"},[_vm._v(_vm._s(_vm.$t('helper.msg.cadastro.11'))),_c('i',{staticClass:"fa fa-sort-asc",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('helper.msg.cadastro.12')))]),_vm._v(" "),_c('div',{staticClass:"btn-fechar-help",on:{"click":tour.stop}},[_c('i',{staticClass:"fa fa-times-circle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.previousStep}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.nextStep}},[_c('i',{staticClass:"fa fa-arrow-right",attrs:{"aria-hidden":"true"}})])])]:_vm._e(),_vm._v(" "),(tour.currentStep === 8)?[_c('div',{attrs:{"slot":"actions"},slot:"actions"},[_c('p',{staticClass:"helper-text"},[_vm._v(_vm._s(_vm.$t('helper.msg.cadastro.13'))),_c('i',{staticClass:"fa fa-sort-desc",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('helper.msg.cadastro.14')))]),_vm._v(" "),_c('div',{staticClass:"btn-fechar-help",on:{"click":tour.stop}},[_c('i',{staticClass:"fa fa-times-circle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.previousStep}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.nextStep}},[_c('i',{staticClass:"fa fa-arrow-right",attrs:{"aria-hidden":"true"}})])])]:_vm._e(),_vm._v(" "),(tour.currentStep === 9)?[_c('div',{attrs:{"slot":"actions"},slot:"actions"},[_c('p',{staticClass:"helper-text"},[_vm._v(_vm._s(_vm.$t('helper.msg.cadastro.18')))]),_vm._v(" "),_c('div',{staticClass:"btn-fechar-help",on:{"click":tour.stop}},[_c('i',{staticClass:"fa fa-times-circle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.previousStep}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.nextStep}},[_c('i',{staticClass:"fa fa-arrow-right",attrs:{"aria-hidden":"true"}})])])]:_vm._e(),_vm._v(" "),(tour.currentStep === 10)?[_c('div',{attrs:{"slot":"actions"},slot:"actions"},[_c('p',{staticClass:"helper-text"},[_vm._v(_vm._s(_vm.$t('helper.msg.cadastro.15'))),_c('i',{staticClass:"fa fa-angle-double-right",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.$t('helper.msg.cadastro.16'))),_c('i',{staticClass:"fa fa-angle-double-left",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"btn-fechar-help",on:{"click":tour.stop}},[_c('i',{staticClass:"fa fa-times-circle",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.previousStep}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":tour.stop}},[_vm._v(_vm._s(_vm.$t('helper.msg.cadastro.17')))])])]:_vm._e()],2):_vm._e()}))]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zAUI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  filters: {
    plant: '',
    plant_name: '',
    year: '',
    period: '',
    area: '',
    sector: '',
    machine: '',
    component: '',
    technique: ''
  }
};

var getters = {
  filters: function filters(state) {
    return state.filters;
  }
};

var mutations = {
  changeFilters: function changeFilters(state, payload) {
    var key = null;
    for (key in payload) {
      localStorage.setItem(key, payload[key]);
    }
    state.filters = payload;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),

/***/ "zIA9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row bookmark-box"},[_c('bookmark',{attrs:{"ids":_vm.stepIds}})],1),_vm._v(" "),_c('div',{class:{ menutop: _vm.menutop},attrs:{"id":"mapa"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row box height-map"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('mapChartOnline',{attrs:{"id":"'map'"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row box box-container "},[_c('div',{staticClass:"col-lg-12 col-sm-12 box-divided"},[_c('ChartFailure')],1)]),_vm._v(" "),_c('div',{class:{ menutop: _vm.menutop},attrs:{"id":"collectOn"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row box"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('HeatMap')],1)]),_vm._v(" "),_c('div',{staticClass:"row box"},[_c('div',{staticClass:"col-lg-6 col-md-6"},[_c('HeatMapSensor')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6"},[_c('HeatMapSensorAppointments')],1)]),_vm._v(" "),_c('div',{staticClass:"row box"},[_c('div',{staticClass:"col-lg-6 col-sm-12 height-box"},[_c('ChartsSensorStatus')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-12 height-box"},[_c('ChartsNodesStatus')],1)]),_vm._v(" "),_c('div',{class:{ menutop: _vm.menutop},attrs:{"id":"collect"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row box"},[_c('div',{staticClass:"col-lg-6 col-sm-12 height-box"},[_c('chartsStatus')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-12 height-box"},[_c('PrioritiesChart')],1)]),_vm._v(" "),_c('div',{class:{ menutop: _vm.menutop},attrs:{"id":"defectsOn"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row box"},[_c('div',{staticClass:"col-lg-12 col-sm-12 height-box"},[_c('ChartsDefects')],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row box"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('Popover',{attrs:{"name":"repetitionOn","width":240}},[_c('Help',{attrs:{"titleChart":'Recurrence Rate of Interventions'}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("40")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help title-margin"},[_vm._v(_vm._s(_vm.$t("41"))+"\n        "),_c('button',{directives:[{name:"popover",rawName:"v-popover:repetitionOn.right",arg:"repetitionOn",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_vm._l((_vm.repetition_data),function(item,key,index){return _c('div',{key:index,staticClass:"col-lg-5ths col-md-5ths col-sm-12",staticStyle:{"margin-top":"30px !important"}},[_c('ReincidenciaIndicator',{attrs:{"title":key,"content":item[0],"perc":item[1]}})],1)}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row box-container"},[_c('div',{staticClass:"col-lg-12 col-sm-12 box-divided"},[_c('ChartReincidenciaPareto',{attrs:{"online":true}})],1)]),_vm._v(" "),_vm._l((_vm.repetition_chart_data),function(item){return _c('div',{key:item.id,staticClass:"col-lg-4 col-md-4 col-sm-12"},[_c('ReincidenciaChart',{attrs:{"title":item.title,"data":item.data,"plant":item.plant}})],1)})],2)]),_vm._v(" "),_c('div',{class:{ menutop: _vm.menutop},attrs:{"id":"planning"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row box"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('chartsReport'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"30px !important"}},_vm._l((_vm.planned_rdps_data),function(item,key,index){return _c('div',{key:index,staticClass:"col-lg-2 col-sm-12",staticStyle:{"padding":"10px"}},[_c('Donut',{attrs:{"id":String(item.id),"title":item.name,"pendente":item.pendente,"programado":item.programado,"filters":_vm.filterGrid,"online":1}})],1)})),_vm._v(" "),_c('div',{staticClass:"row box-container"},[_c('div',{staticClass:"col-lg-12 col-sm-12 box-divided"},[_c('ChartBacklog',{attrs:{"online":true}})],1)])],1)]),_vm._v(" "),_c('div',{class:{ menutop: _vm.menutop},attrs:{"id":"execution"}},[_vm._v(" ")]),_vm._v(" "),_c('div',{staticClass:"row box"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('transition',{attrs:{"name":"show-from-left"}},[_c('Popover',{attrs:{"name":"execution_deadline","width":240}},[_c('Help',{attrs:{"titleChart":'Execution'}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("42")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts title-bt-help title-margin"},[_vm._v(_vm._s(_vm.$t("43"))+"\n        "),_c('button',{directives:[{name:"popover",rawName:"v-popover:execution_deadline.right",arg:"execution_deadline",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('ReincidenciaIndicator',{attrs:{"delay":0,"title":"On Time","content":_vm.reports_execution_deadline.total[0],"color":"#90ed7d","font":"24px"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('ReincidenciaIndicator',{attrs:{"delay":1,"title":"1 to 15 days late","content":_vm.reports_execution_deadline.total[1],"color":"#f0893a","font":"24px"}})],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('ReincidenciaIndicator',{attrs:{"delay":2,"title":"15 to 30 days late","content":_vm.reports_execution_deadline.total[2],"color":"#f45b5b","font":"24px"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('ReincidenciaIndicator',{attrs:{"delay":3,"title":"> 30 days late","content":_vm.reports_execution_deadline.total[3],"color":"#f45b5b","font":"24px"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('DonutExecution',{attrs:{"title":"","data":[_vm.reports_execution_deadline.total_concluido, _vm.reports_execution_deadline.total_atrasado],"filters":_vm.filterGrid,"online":1}})],1)])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('transition',{attrs:{"name":"show-from-left"}},[_c('Popover',{attrs:{"name":"execution_deadline_total","width":240}},[_c('Help',{attrs:{"titleChart":'Comparison Charts - On time | late'}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("44")))])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.$t("45"))+"\n        "),_c('button',{directives:[{name:"popover",rawName:"v-popover:execution_deadline_total.right",arg:"execution_deadline_total",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})])]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.reports_execution_deadline.details_total),function(item,index){return _c('div',{key:index,staticClass:"col-lg-4 col-md-4 col-sm-12"},[_c('ExecutionChartTotal',{attrs:{"title":item.name,"data":[item['onTime'], item['late']],"id":String(item.id),"filters":_vm.filterGrid,"online":1}})],1)})),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"title-charts"},[_vm._v(_vm._s(_vm.$t("46"))+"\n        "),_c('button',{directives:[{name:"popover",rawName:"v-popover:execution_deadline_details.right",arg:"execution_deadline_details",modifiers:{"right":true}}],staticClass:"bt-help"},[_c('i',{staticClass:"icon-help ti-help-alt"})]),_vm._v(" "),_c('transition',{attrs:{"name":"show-from-left"}},[_c('Popover',{attrs:{"name":"execution_deadline_details","width":240}},[_c('Help',{attrs:{"titleChart":'Comparison Charts by Period'}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t("47")))])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.reports_execution_deadline.details),function(item,index){return _c('div',{key:index,staticClass:"col-lg-4 col-md-4 col-sm-12"},[_c('ExecutionChart',{attrs:{"title":item.name,"data":[item[0], item[1], item[2], item[3]],"id":String(item.id),"filters":_vm.filterGrid,"online":1}})],1)}))],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row box"},[_c('div',{staticClass:"col-lg-12 col-sm-12"},[_c('ExecutionIndicators')],1)]),_vm._v(" "),_c('br')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zTKL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"history-chart"},[_c('div',{staticClass:"content-1",staticStyle:{"height":"180px"}},[_c('div',{staticClass:"chart-content-div-header"},[_c('h4',[_c('small',[_c('i',{staticClass:"glyphicon glyphicon-calendar"}),_vm._v("   "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.header)}})]),_vm._v(" "),_c('small',[_c('i',{staticClass:"glyphicon glyphicon-print my-export",staticStyle:{"float":"right"},on:{"click":_vm.exporting}})])])]),_vm._v(" "),_c('div',{staticClass:"chart-content-div"},[_c('div',{attrs:{"id":_vm.id}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_actions_auth__ = __webpack_require__("+4WN");






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeNotifications: false
    };
  },

  name: 'navigation',
  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar: function minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },

    logout: function logout() {
      var _this = this;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_2__store_actions_auth__["a" /* AUTH_LOGOUT */]).then(function () {
        return _this.$router.push('/login');
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getProfile', 'isAuthenticated', 'isProfileLoaded']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === 'loading';
    },
    name: function name(state) {
      return state.user.profile.title + ' ' + state.user.profile.name;
    }
  }))
});

/***/ }),

/***/ "zwtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a),
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          path: '',
          children: []
        };
      }
    }
  },
  provide: function provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },

  inject: {
    addLink: { default: null },
    removeLink: { default: null }
  },
  data: function data() {
    return {
      children: [],
      collapsed: true
    };
  },

  computed: {
    baseComponent: function baseComponent() {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link';
    },
    isMenu: function isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive: function isActive() {
      var _this = this;

      if (this.$route) {
        var matchingRoute = this.children.find(function (c) {
          return _this.$route.path.startsWith(c.link.path);
        });
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    addChild: function addChild(item) {
      var index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild: function removeChild(item) {
      var tabs = this.children;
      var index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType: function elementType(link) {
      var isParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (link.isRoute === false) {
        return isParent ? 'li' : 'a';
      } else {
        return 'router-link';
      }
    },
    linkAbbreviation: function linkAbbreviation(name) {
      var matches = name.match(/\b(\w)/g);
      return matches.join('');
    },
    collapseMenu: function collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu: function collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    }
  },
  mounted: function mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed: function destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f13f8e5b2428b2fdc5a2.js